
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cdE69", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4dfec5d38a52a651$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNzOG = parcelRequire("iNzOG");
const $4dfec5d38a52a651$var$IssueViewComments = ({ rootRelayFragment: rootRelayFragment })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNzOG.default), {
        rootRelayFragment: rootRelayFragment
    });
var $4dfec5d38a52a651$export$2e2bcd8739ae039 = $4dfec5d38a52a651$var$IssueViewComments;

});
parcelRegister("iNzOG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6a3e901d01cfe23$export$2e2bcd8739ae039);
/* comments-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cb25w = parcelRequire("cb25w");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $jzjy1 = parcelRequire("jzjy1");

var $2vSU6 = parcelRequire("2vSU6");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $9lnEj = parcelRequire("9lnEj");


var $18jBk = parcelRequire("18jBk");

var $uTOCQ = parcelRequire("uTOCQ");

var $2n3vo = parcelRequire("2n3vo");

var $lY0Md = parcelRequire("lY0Md");

var $9pF5v = parcelRequire("9pF5v");

var $hxqfC = parcelRequire("hxqfC");

var $8dFNe = parcelRequire("8dFNe");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $2QmDq = parcelRequire("2QmDq");

var $lssfC = parcelRequire("lssfC");

var $d4MOh = parcelRequire("d4MOh");

var $fKtck = parcelRequire("fKtck");

var $lPPO3 = parcelRequire("lPPO3");

var $l8ruj = parcelRequire("l8ruj");

var $6s1PB = parcelRequire("6s1PB");

var $6irpc = parcelRequire("6irpc");

var $9AfTz = parcelRequire("9AfTz");

var $2gCtH = parcelRequire("2gCtH");

var $iixvy = parcelRequire("iixvy");

var $9vYHU = parcelRequire("9vYHU");

var $4nRwA = parcelRequire("4nRwA");

var $3EXh5 = parcelRequire("3EXh5");

var $5BQ0h = parcelRequire("5BQ0h");
const $b6a3e901d01cfe23$export$8cf44888942822ef = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxidpf _otyrutpp _18u0idpf",
            __cmplp.isCompact ? "_19pkpxbi" : "_19pk1ejb",
            __cmplp.className
        ])
    });
});
class $b6a3e901d01cfe23$export$434c217d363ea16 extends (0, $5uXOq.Component) {
    static{
        this.displayName = (0, $9pF5v.COMMENTS);
    }
    static{
        this.defaultProps = {
            canAddComments: false
        };
    }
    componentDidMount() {
        // This is only for the exp, this will move to mainIssueAGGQuery in GA
        // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/work_item_create_from_comment_and_pin_comment/setup
        if (this.props.commentIds.length !== 0 && this.props.getPinnedComments) this.props.getPinnedComments();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        // We fetch more comments when there are no comments left visible
        // but there are still comments available to be fetched (i.e. hidden)
        if (nextProps.commentsPageInfo && nextProps.commentIds.length !== this.props.commentIds.length && nextProps.commentIds.length === 0) {
            if (nextProps.commentsPageInfo.hasNextPage) nextProps.fetchMoreOlderComments();
            else if (nextProps.commentsPageInfo.hasPreviousPage) nextProps.fetchMoreNewerComments();
        }
        if (!nextProps.isLoadingMoreComments) this.setState({
            loadMoreButtonTypeClicked: undefined
        });
    }
    componentDidUpdate() {
        if (this.props.unreadCommentsCount && this.props.unreadCommentsCount > 0 && this.props.isRealTimeCommentUpdated === false && (0, $4R6GH.fg)('thor_send_realtime_attribute')) {
            this.props.setRealTimeCommentUpdated?.(true);
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'realtimeUpdated'
            });
            analyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'comments realtimeUpdated');
        }
    }
    renderLoadOlderButton() {
        const { isLoadingMoreComments: isLoadingMoreComments, commentsPageInfo: commentsPageInfo } = this.props;
        const { loadMoreButtonTypeClicked: loadMoreButtonTypeClicked } = this.state;
        const { onLoadOlderButtonClick: onLoadOlderButtonClick } = this;
        const isLoading = loadMoreButtonTypeClicked === (0, $lY0Md.LOAD_OLDER_BUTTON) && isLoadingMoreComments;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2n3vo.default), {
            onClick: onLoadOlderButtonClick,
            numberToLoad: 0,
            isDisabled: isLoadingMoreComments,
            isLoading: isLoading,
            loadButton: commentsPageInfo.hasNextPage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5BQ0h.default).showMoreComments));
    }
    renderLoadNewerButton() {
        const { isLoadingMoreComments: isLoadingMoreComments, commentsPageInfo: commentsPageInfo } = this.props;
        const { loadMoreButtonTypeClicked: loadMoreButtonTypeClicked } = this.state;
        const { onLoadNewerButtonClick: onLoadNewerButtonClick } = this;
        const isLoading = loadMoreButtonTypeClicked === (0, $lY0Md.LOAD_NEWER_BUTTON) && isLoadingMoreComments;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2n3vo.default), {
            onClick: onLoadNewerButtonClick,
            numberToLoad: 0,
            isDisabled: isLoadingMoreComments,
            isLoading: isLoading,
            loadButton: commentsPageInfo.hasPreviousPage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5BQ0h.default).showMoreComments));
    }
    render() {
        const { commentIds: commentIds, canAddComments: canAddComments, fullIssueUrl: fullIssueUrl, loadingStage: loadingStage, selectedSortOrder: selectedSortOrder, projectType: projectType, commentSessionId: commentSessionId, rootRelayFragment: rootRelayFragment, commentsPageInfo: commentsPageInfo, isThreadedCommentsEnabled: isThreadedCommentsEnabled, isRealTimeCommentUpdated: isRealTimeCommentUpdated, isPremium: isPremium, isAiOptInEnabled: isAiOptInEnabled, accountId: accountId, pinnedCommentsIds: pinnedCommentsIds } = this.props;
        if (!commentIds.length && !canAddComments) return null;
        const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $fKtck.getPermalinkStatus)((0, $9pF5v.COMMENTS));
        const sortedList = commentIds.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selectedSortOrder === (0, $c97bf8752afb1bcb$export$eda5fe8da1abb04c) && this.renderLoadNewerButton(), selectedSortOrder === (0, $c97bf8752afb1bcb$export$e86669f498228fff) && this.renderLoadOlderButton(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6a3e901d01cfe23$export$8cf44888942822ef // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.activity.comments-list",
            isCompact: (0, $4R6GH.fg)('jira_custom_comment_component_refactor') || (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false)
        }, (0, $4R6GH.fg)('jira_issue_mobile_section_message') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vYHU.SectionMessage), null), commentIds.map((commentInfo)=>{
            const commentId = commentInfo.id;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $18jBk.default), {
                key: commentId,
                commentId: commentId,
                fullIssueUrl: fullIssueUrl,
                isHighlighted: hasPermalink && commentId === permalinkId,
                commentSessionId: commentSessionId,
                isThreadedCommentsEnabled: isThreadedCommentsEnabled
            }, isThreadedCommentsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6irpc.default), {
                commentId: commentId,
                fullIssueUrl: fullIssueUrl,
                commentSessionId: commentSessionId,
                hasReplies: commentInfo.size > 0,
                ...(0, $4R6GH.fg)('thor_send_realtime_attribute') ? {
                    isRealTimeCommentUpdated: isRealTimeCommentUpdated
                } : {}
            }));
        })), selectedSortOrder === (0, $c97bf8752afb1bcb$export$eda5fe8da1abb04c) && this.renderLoadOlderButton(), selectedSortOrder === (0, $c97bf8752afb1bcb$export$e86669f498228fff) && this.renderLoadNewerButton()) : null;
        const renderSmartRequestSummaryEntryPointContainer = ()=>{
            if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4nRwA.JsmSmartRequestSummaryEntryPointContainer), null);
            if (projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) {
                if ((0, $4R6GH.fg)('improve_issue_view_comment_ai')) {
                    const isSmartRequestSummaryEnabled = isPremium && isAiOptInEnabled;
                    if (!isSmartRequestSummaryEnabled || !accountId) return null;
                    if ((0, $4R6GH.fg)('proactive_comment_summary_targeting_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3EXh5.IssueSmartRequestSummaryEntryPointContainer), null);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3EXh5.IssueSmartRequestSummaryEntryPointContainerOld), null);
                }
                return (0, $4R6GH.fg)('proactive_comment_summary_targeting_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3EXh5.IssueSmartRequestSummaryEntryPointContainer), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3EXh5.IssueSmartRequestSummaryEntryPointContainerOld), null);
            }
            return null;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderSmartRequestSummaryEntryPointContainer(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "commentsActivityFeed"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $uTOCQ.default), {
            loadingStage: loadingStage,
            canAddComments: canAddComments,
            list: sortedList,
            hasPrevComments: commentsPageInfo.hasPreviousPage,
            selectedSortOrder: selectedSortOrder,
            rootRelayFragment: rootRelayFragment,
            pinnedCommentsIds: pinnedCommentsIds || []
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            loadMoreButtonTypeClicked: undefined
        }, this.onLoadOlderButtonClick = (event, analyticsEvent)=>{
            const { fetchMoreOlderComments: fetchMoreOlderComments } = this.props;
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'loadMoreButtonClicked', {
                loadMoreButtonType: (0, $lY0Md.LOAD_OLDER_BUTTON)
            });
            this.setState({
                loadMoreButtonTypeClicked: (0, $lY0Md.LOAD_OLDER_BUTTON)
            });
            fetchMoreOlderComments();
        }, this.onLoadNewerButtonClick = (event, analyticsEvent)=>{
            const { fetchMoreNewerComments: fetchMoreNewerComments } = this.props;
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'loadMoreButtonClicked', {
                loadMoreButtonType: (0, $lY0Md.LOAD_NEWER_BUTTON)
            });
            this.setState({
                loadMoreButtonTypeClicked: (0, $lY0Md.LOAD_NEWER_BUTTON)
            });
            fetchMoreNewerComments();
        };
    }
}
const $b6a3e901d01cfe23$var$CommentWithPermaLinkRemoval = (0, $lPPO3.withRemovePermalinkQuery)((0, $9lnEj.default)($b6a3e901d01cfe23$export$434c217d363ea16));
const $b6a3e901d01cfe23$var$ConnectedComments = (0, $hxqfC.connect)((state)=>({
        commentIds: (0, $d4MOh.sortedVisibleCommentIdsSelector)(state),
        canAddComments: (0, $d4MOh.canAddCommentsSelector)(state),
        isLoadingMoreComments: (0, $d4MOh.isLoadingMoreCommentsSelector)(state),
        projectType: (0, $bcoYn.projectTypeSelector)(state),
        // baseUrl, issueKey & shouldFetchCommentVisibilities are used in with-comment-visibilities.js
        baseUrl: (0, $a1ky2.baseUrlSelector)(state),
        issueKey: (0, $a1ky2.issueKeySelector)(state),
        shouldFetchCommentVisibilities: (0, $d4MOh.isCommentVisibilityRestrictionSupportedSelector)(state),
        // fullIssueUrl for the comments permalink
        fullIssueUrl: (0, $lssfC.fullIssueUrlSelector)(state),
        loadingStage: (0, $d4MOh.loadingStageSelector)(state),
        selectedSortOrder: (0, $2QmDq.getSelectedActivitySortOrder)(state),
        commentSessionId: (0, $d4MOh.commentSessionIdSelector)(state),
        commentsPageInfo: (0, $d4MOh.commentsPageInfoSelector)(state),
        isThreadedCommentsEnabled: (0, $d4MOh.isThreadedCommentsEnabledSelector)(state),
        ...(0, $4R6GH.fg)('thor_send_realtime_attribute') && {
            unreadCommentsCount: (0, $d4MOh.getUnreadCommentCountSelector)(state)
        },
        ...(0, $4R6GH.fg)('improve_issue_view_comment_ai') && {
            accountId: (0, $a1ky2.accountIdloggedInUserSelector)(state)
        },
        ...(0, $4R6GH.fg)('work_item_create_from_comment_and_pin_comment_gate') && {
            pinnedCommentsIds: (0, $d4MOh.pinnedCommentIdsSelector)(state)
        }
    }), (dispatch)=>({
        fetchMoreOlderComments: ()=>{
            dispatch((0, $8dFNe.fetchOlderCommentsRequest)());
        },
        fetchMoreNewerComments: ()=>{
            dispatch((0, $8dFNe.fetchNewerCommentsRequest)());
        },
        ...(0, $4R6GH.fg)('work_item_create_from_comment_and_pin_comment_gate') && {
            getPinnedComments: ()=>{
                dispatch((0, $8dFNe.fetchPinnedCommentsRequest)());
            }
        }
    }))($b6a3e901d01cfe23$var$CommentWithPermaLinkRemoval);
const $b6a3e901d01cfe23$var$ConnectedCommentsWithAnalyticsSubjectBase = (0, $jzjy1.AnalyticsSubject)('comment')(// @ts-expect-error - Argument of type 'ConnectedComponentClass<ComponentType<CommentVisibilitiesComponentProps<OwnProps & StateProps & DispatchProps>>, Omit<...>>' is not assignable to parameter of type 'JSXElementConstructor<WithAnalyticsEventsProps> & ComponentClass<Omit<CommentVisibilitiesComponentProps<OwnProps & StateProps & DispatchProps>, "baseUrl" | ... 12 more ... | "shouldFetchCommentVisibilities">, any> & { ...; }'.
(0, $cb25w.default)()($b6a3e901d01cfe23$var$ConnectedComments));
const $b6a3e901d01cfe23$var$IssueViewCommentWithRealtimeCommentsData = (props)=>{
    const [{ isRealTimeCommentUpdated: isRealTimeCommentUpdated }, { setRealTimeCommentUpdated: setRealTimeCommentUpdated }] = (0, $9AfTz.useRealTimeComments)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6a3e901d01cfe23$var$ConnectedCommentsWithAnalyticsSubjectBase, {
        ...props,
        isRealTimeCommentUpdated: isRealTimeCommentUpdated,
        setRealTimeCommentUpdated: setRealTimeCommentUpdated
    });
};
const $b6a3e901d01cfe23$var$ConnectedCommentsWithAnalyticsSubject = (0, $cSD7y.componentWithFG)('thor_send_realtime_attribute', $b6a3e901d01cfe23$var$IssueViewCommentWithRealtimeCommentsData, $b6a3e901d01cfe23$var$ConnectedCommentsWithAnalyticsSubjectBase); // A temporary wrapper to enable AI opt-in for comments.
const $b6a3e901d01cfe23$var$IssueViewCommentWithSmartRequestSummaryInEnabled = (props)=>{
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6a3e901d01cfe23$var$ConnectedCommentsWithAnalyticsSubject, {
        ...props,
        isAiOptInEnabled: isAiOptInEnabled,
        isPremium: isPremium
    });
};
const $b6a3e901d01cfe23$var$ConnectedCommentsWithSmartRequestSummaryInEnabled = (0, $cSD7y.componentWithFG)('improve_issue_view_comment_ai', $b6a3e901d01cfe23$var$IssueViewCommentWithSmartRequestSummaryInEnabled, $b6a3e901d01cfe23$var$ConnectedCommentsWithAnalyticsSubjectBase);
const $b6a3e901d01cfe23$var$IssueViewComment = ({ rootRelayFragment: rootRelayFragment })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "issue-view-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue.issue-view.activity.comments",
        packageName: "jiraIssueViewActivity",
        teamName: "bento",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6a3e901d01cfe23$var$ConnectedCommentsWithSmartRequestSummaryInEnabled, {
        rootRelayFragment: rootRelayFragment
    })));
var $b6a3e901d01cfe23$export$2e2bcd8739ae039 = $b6a3e901d01cfe23$var$IssueViewComment;

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("9lnEj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a507ec6a392a18a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $76taC = parcelRequire("76taC");

var $4YS3Y = parcelRequire("4YS3Y");
const $7a507ec6a392a18a$var$withCommentVisibilities = (WrappedComponent)=>(props)=>{
        const { baseUrl: baseUrl, issueKey: issueKey, shouldFetchCommentVisibilities: shouldFetchCommentVisibilities, createAnalyticsEvent: createAnalyticsEvent } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $76taC.default), {
            baseUrl: baseUrl,
            issueKey: issueKey,
            createAnalyticsEvent: createAnalyticsEvent,
            scope: issueKey,
            key: issueKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YS3Y.default), null, (_, { fetch: fetch })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                fetchCommentVisibilities: shouldFetchCommentVisibilities ? fetch : undefined
            })));
    };
var $7a507ec6a392a18a$export$2e2bcd8739ae039 = $7a507ec6a392a18a$var$withCommentVisibilities;

});
parcelRegister("76taC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10b7134ed11271c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");

var $4CsHp = parcelRequire("4CsHp");
var $c10b7134ed11271c$export$2e2bcd8739ae039 = (0, $gg7kZ.createContainer)((0, $4CsHp.default), {
    displayName: 'CommentVisibilitiesContainer'
});

});
parcelRegister("4CsHp", function(module, exports) {

$parcel$export(module.exports, "default", () => $082d5b271ded4ee7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $fXYMu = parcelRequire("fXYMu");
const $082d5b271ded4ee7$export$d4c72bab9d6cc13a = {
    data: null,
    loading: false,
    error: null
};
var $082d5b271ded4ee7$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'issue-view-comment-visibilities',
    initialState: $082d5b271ded4ee7$export$d4c72bab9d6cc13a,
    actions: $fXYMu.default
});

});
parcelRegister("fXYMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $581960065823c78f$export$2e2bcd8739ae039);

var $kXoUR = parcelRequire("kXoUR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$581960065823c78f$export$2e2bcd8739ae039 = {
    fetch: $kXoUR.default
};

});
parcelRegister("kXoUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $db67aa46697a11e1$export$2e2bcd8739ae039);


var $6r7fT = parcelRequire("6r7fT");

var $8zOmE = parcelRequire("8zOmE");

var $ibxR7 = parcelRequire("ibxR7");
const $db67aa46697a11e1$var$logError = (error)=>{
    (0, $6r7fT.trackOrLogClientError)('issue.fetch.comment-visibilities', 'An error occurred attempting to fetch comment visibilities from gira', error);
};
const $db67aa46697a11e1$var$sendCommentVisibilityAnalytics = (// @ts-expect-error - TS2304 - Cannot find name 'AnalyticsEvent'.
createAnalyticsEvent, // @ts-expect-error - TS2304 - Cannot find name 'CommentVisibility'.
commentVisibilities)=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'fetched'
    });
    const commentVisibilityStats = {
        totalCount: commentVisibilities.length,
        roleCount: commentVisibilities.filter((commentVisibility)=>commentVisibility.type === (0, $b276debff3ef22b6$export$28a8bb936dce2def)).length,
        groupCount: commentVisibilities.filter((commentVisibility)=>commentVisibility.type === (0, $b276debff3ef22b6$export$537a061b2f9c8800)).length
    };
    (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, 'commentVisibilities fetched', commentVisibilityStats);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db67aa46697a11e1$export$2e2bcd8739ae039 = ()=>async ({ getState: getState, setState: setState }, { issueKey: issueKey, baseUrl: baseUrl, createAnalyticsEvent: createAnalyticsEvent })=>{
        const currentState = getState();
        if (currentState.loading || currentState.error || currentState.data) return;
        setState({
            loading: true,
            error: null,
            data: null
        });
        try {
            const commentVisibilities = await (0, $ibxR7.fetchCommentVisibilities)(baseUrl, issueKey);
            setState({
                loading: false,
                error: null,
                data: {
                    commentVisibilities: commentVisibilities
                }
            });
            $db67aa46697a11e1$var$sendCommentVisibilityAnalytics(createAnalyticsEvent, commentVisibilities);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            $db67aa46697a11e1$var$logError(error);
            setState({
                loading: false,
                error: error,
                data: null
            });
        }
    };

});
const $b276debff3ef22b6$export$537a061b2f9c8800 = 'group';
const $b276debff3ef22b6$export$28a8bb936dce2def = 'role';
const $b276debff3ef22b6$export$a3863626f98a38c2 = 'public';

parcelRegister("ibxR7", function(module, exports) {

$parcel$export(module.exports, "fetchCommentVisibilities", () => $cb10b36427cb27c6$export$f0e1b4b790c7c8ca);

var $iBOrg = parcelRequire("iBOrg");

var $elSB3 = parcelRequire("elSB3");

var $8fD9V = parcelRequire("8fD9V");

const $cb10b36427cb27c6$var$transformData = (jiraCommentVisibilities)=>jiraCommentVisibilities.map((edge)=>(0, $elSB3.transformJiraCommentVisibility)(edge.node));
const $cb10b36427cb27c6$export$f0e1b4b790c7c8ca = async (baseUrl, issueKey)=>{
    const { errors: errors, data: data } = await (0, $iBOrg.getClient)(baseUrl).query({
        query: (0, $8fD9V.commentVisibilitiesQuery),
        variables: {
            issueKey: issueKey
        }
    });
    if (errors) throw new Error((0, $27a9f90bd2062810$export$b2f70af5a5c18e45));
    if (data?.viewIssue?.jiraCommentVisibilities) {
        const transformedData = $cb10b36427cb27c6$var$transformData(data.viewIssue.jiraCommentVisibilities.edges);
        return transformedData;
    }
    throw new Error((0, $27a9f90bd2062810$export$13ec698b470de206));
};

});
parcelRegister("elSB3", function(module, exports) {

$parcel$export(module.exports, "transformComment", () => $1ed994a6a130b7c8$export$f6e85761e2e2b7d7);
$parcel$export(module.exports, "transformJiraCommentVisibility", () => $1ed994a6a130b7c8$export$d6420884ced7f774);
$parcel$export(module.exports, "normalizeComment", () => $1ed994a6a130b7c8$export$3ae47ac75ea0ca01);
$parcel$export(module.exports, "normalizeComments", () => $1ed994a6a130b7c8$export$5b6423f1622a7d75);

var $bMyd4 = parcelRequire("bMyd4");

var $2YZCu = parcelRequire("2YZCu");



var $g2C8o = parcelRequire("g2C8o");

var $4R6GH = parcelRequire("4R6GH");

var $hRvWW = parcelRequire("hRvWW");

var $d4jBl = parcelRequire("d4jBl");
const $1ed994a6a130b7c8$var$LOG_LOCATION = 'issue.transform.comment';
const $1ed994a6a130b7c8$export$1473b79d5dab5134 = ({ type: type, value: value, identifier: identifier })=>{
    switch(type){
        case 0, $b276debff3ef22b6$export$537a061b2f9c8800:
            return {
                value: value,
                type: type,
                groupId: identifier
            };
        case 0, $b276debff3ef22b6$export$28a8bb936dce2def:
            return {
                value: value,
                type: type
            };
        default:
            {
                const message = `transformCommentVisibility: unknown comment visibility type received '${type}'`;
                (0, $2YZCu.default).safeErrorWithoutCustomerData($1ed994a6a130b7c8$var$LOG_LOCATION, message, new Error(message));
                return {
                    value: value,
                    type: (0, $b276debff3ef22b6$export$28a8bb936dce2def)
                };
            }
    }
};
const $1ed994a6a130b7c8$export$f6e85761e2e2b7d7 = (comment)=>({
        id: comment.id,
        author: comment.author ? (0, $d4jBl.transformUser)(comment.author) : null,
        updateAuthor: comment.updateAuthor ? (0, $d4jBl.transformUser)(comment.updateAuthor) : null,
        bodyAdf: comment.body,
        bodyHtml: undefined,
        visibility: comment.visibility ? $1ed994a6a130b7c8$export$1473b79d5dab5134(comment.visibility) : null,
        createdDate: (0, $bMyd4.default)(comment.created),
        updatedDate: comment.updated ? (0, $bMyd4.default)(comment.updated) : null,
        edited: !!comment.updated && comment.updated !== comment.created,
        isInternal: !comment.jsdPublic,
        outsideComment: comment.outsideComment ?? false,
        eventOccurredAt: comment.eventTime,
        jsdIncidentActivityViewHidden: comment.hidden
    });
const $1ed994a6a130b7c8$export$d6420884ced7f774 = (node)=>{
    switch(node.__typename){
        case 0, $11504d78ab25a247$export$5a7c166ea3706e65:
            return {
                type: (0, $b276debff3ef22b6$export$537a061b2f9c8800),
                groupId: node.group.groupId,
                value: node.group.name
            };
        case 0, $11504d78ab25a247$export$5c1bc3a6c47faaf9:
            return {
                type: (0, $b276debff3ef22b6$export$28a8bb936dce2def),
                value: node.name
            };
        default:
            {
                const message = `transformJiraCommentVisibility: unknown comment visibility type received '${node.__typename}'`;
                (0, $2YZCu.default).safeErrorWithoutCustomerData($1ed994a6a130b7c8$var$LOG_LOCATION, message, new Error(message));
                return {
                    type: (0, $b276debff3ef22b6$export$28a8bb936dce2def),
                    value: node.name
                };
            }
    }
};
const $1ed994a6a130b7c8$export$3ae47ac75ea0ca01 = (comment)=>{
    const authorId = comment.author ? comment.author.id : null;
    const updateAuthorId = comment.updateAuthor ? comment.updateAuthor.id : null;
    const commentJsmTimelineProps = {
        eventOccurredAt: comment.eventOccurredAt,
        jsdIncidentActivityViewHidden: comment.jsdIncidentActivityViewHidden
    };
    const getCommentVisibility = ()=>comment.visibility ?? (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC);
    return {
        id: comment.id,
        authorId: authorId,
        updateAuthorId: updateAuthorId,
        bodyAdf: comment.bodyAdf,
        bodyHtml: comment.bodyHtml,
        createdDate: comment.createdDate,
        updatedDate: comment.updatedDate,
        edited: comment.edited,
        visibility: getCommentVisibility(),
        isInternal: comment.isInternal,
        jsdAuthorCanSeeRequest: comment.jsdAuthorCanSeeRequest,
        cursor: comment.cursor,
        ...comment.isDeleted ? {
            isDeleted: comment.isDeleted
        } : {},
        ...comment.childCommentsPageInfo ? {
            childCommentsPageInfo: comment.childCommentsPageInfo
        } : {},
        ...commentJsmTimelineProps,
        ...(0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') && {
            isThirdPartySyncOn: comment.isThirdPartySyncOn,
            thirdPartyLink: comment.thirdPartyLink,
            thirdPartyCommentSource: comment.thirdPartyCommentSource
        }
    };
};
const $1ed994a6a130b7c8$export$cbcdba95478e8fd6 = (comments)=>{
    const gatherUsers = (userComments, usersAccumulator = [])=>{
        (userComments ?? []).forEach(({ author: author, updateAuthor: updateAuthor, childComments: childComments })=>{
            if (author) usersAccumulator.push(author);
            if (updateAuthor) usersAccumulator.push(updateAuthor);
            // Recursively process child comments, if any
            if (childComments && childComments.length > 0) gatherUsers(childComments, usersAccumulator);
        });
        return usersAccumulator;
    };
    const users = gatherUsers(comments);
    const normalizedUsers = (0, $hRvWW.normalizeItemArray)(users, 'id');
    return normalizedUsers;
};
const $1ed994a6a130b7c8$export$77a9e47277cbb42 = (comments)=>{
    const normalizedComments = {};
    if (!comments || (comments ?? []).length === 0) return normalizedComments;
    // this will map the root comments
    const commentsInfoList = comments.map((comment)=>({
            comment: comment,
            parentId: ''
        }));
    while(commentsInfoList.length > 0){
        const commentInfo = commentsInfoList.pop();
        if (commentInfo) {
            const { comment: comment, parentId: parentId } = commentInfo;
            const { id: id, childComments: childComments = [] } = comment;
            const childCommentIds = new Set();
            // Iterate over each child comment once
            for (const childComment of childComments){
                childCommentIds.add(childComment.id);
                // Push each child comment along with its parentId onto the commentsInfoList
                commentsInfoList.push({
                    comment: childComment,
                    parentId: id
                });
            }
            // Store the comment in the normalized structure
            normalizedComments[id] = {
                ...$1ed994a6a130b7c8$export$3ae47ac75ea0ca01(comment),
                childCommentIds: childCommentIds,
                ...parentId ? {
                    parentId: parentId
                } : {}
            };
        }
    }
    return normalizedComments;
};
const $1ed994a6a130b7c8$export$5b6423f1622a7d75 = (comments, commentsPageInfo)=>({
        users: $1ed994a6a130b7c8$export$cbcdba95478e8fd6(comments),
        commentsPageInfo: commentsPageInfo,
        comments: $1ed994a6a130b7c8$export$77a9e47277cbb42(comments)
    });

});
parcelRegister("bMyd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a80361bc9f544ca$export$2e2bcd8739ae039);

var $eZDAP = parcelRequire("eZDAP");

var $el0er = parcelRequire("el0er");
var // IE 11 and Safari can't recognize date format '2013-04-19T18:26:46.396+0000' provided by JIRA
// so we convert it to format '2013-05-03T08:36:14.787Z'
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1a80361bc9f544ca$export$2e2bcd8739ae039 = (dateString)=>{
    if (dateString === null) return dateString;
    const parsedDate = typeof dateString === 'string' ? (0, $eZDAP.default)(dateString) : (0, $el0er.default)(dateString);
    return parsedDate.toISOString();
};

});

const $11504d78ab25a247$export$5a7c166ea3706e65 = 'JiraGroupVisibility';
const $11504d78ab25a247$export$5c1bc3a6c47faaf9 = 'JiraRoleVisibility';

parcelRegister("hRvWW", function(module, exports) {

$parcel$export(module.exports, "normalizeItemArray", () => $d7fd5dd46e4de057$export$5bd0cd6e0fd0812c);
const $d7fd5dd46e4de057$export$511d6032b747bf81 = (fields, typename)=>fields.find((f)=>f.__typename === typename);
const $d7fd5dd46e4de057$export$5bd0cd6e0fd0812c = (items, key)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const normalizedItems = {};
    items.forEach((item)=>{
        normalizedItems[item[key]] = item;
    });
    return normalizedItems;
};

});


parcelRegister("8fD9V", function(module, exports) {

$parcel$export(module.exports, "getCommentsQuery", () => $869d864f6d8b925f$export$f97b33aeea757b6e);
$parcel$export(module.exports, "commentVisibilitiesQuery", () => $869d864f6d8b925f$export$21eb8040ac826961);

var $dvijh = parcelRequire("dvijh");

var $fKtck = parcelRequire("fKtck");

var $4R6GH = parcelRequire("4R6GH");
const $869d864f6d8b925f$var$commentParameter = ()=>{
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $fKtck.getPermalinkStatus)((0, $dvijh.COMMENTS));
    return hasPermalink ? `commentId: ${permalinkId}` : '';
};
const $869d864f6d8b925f$export$6c5bfd6f86c70c22 = ` jiraCommentVisibility {
  __typename
  ...on JiraRoleVisibility {
    name
  }
  ...on JiraGroupVisibility {
    group {
      groupId
      name
    }
  }
}`;
const $869d864f6d8b925f$export$f97b33aeea757b6e = (maxResults, startAt, orderBy)=>{
    if ((0, $4R6GH.fg)('jlovep-3963-ignore-gira-comments-data')) return `
        comments (first: ${startAt}, maxResults: ${maxResults}, orderBy: "${orderBy}",${$869d864f6d8b925f$var$commentParameter()}) {
            totalCount
        }
    `;
    return `
    comments (first: ${startAt}, maxResults: ${maxResults}, orderBy: "${orderBy}",${$869d864f6d8b925f$var$commentParameter()}) {
        nodes {
            id
            author {
                accountId
                displayName
                avatarUrl
            }
            updateAuthor {
                accountId
                displayName
                avatarUrl
            }
            ${$869d864f6d8b925f$export$6c5bfd6f86c70c22}
            created
            updated
            renderedBody
            jsdPublic
            bodyAdf
            jsdAuthorCanSeeRequest
        }
        totalCount
        startIndex
    }
`;
};
const $869d864f6d8b925f$var$jiraCommentVisibilities = `
jiraCommentVisibilities {
    edges {
      node {
        __typename
        ...on JiraRoleVisibility {
          name
        }
        ...on JiraGroupVisibility {
          group {
            groupId
            name
          }
        }
      }
    }
  }
`;
const $869d864f6d8b925f$export$21eb8040ac826961 = `
query CommentVisibilitiesQuery($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        ${$869d864f6d8b925f$var$jiraCommentVisibilities}
    }
}
`;

});

const $27a9f90bd2062810$export$b2f70af5a5c18e45 = 'GraphqlErrorResponse';
const $27a9f90bd2062810$export$13ec698b470de206 = 'GraphqlNullData';






parcelRegister("4YS3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a79b1d8865c12fc3$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $51nlc = parcelRequire("51nlc");

var $4CsHp = parcelRequire("4CsHp");
var $a79b1d8865c12fc3$export$2e2bcd8739ae039 = (0, $51nlc.createSubscriber)((0, $4CsHp.default), {
    displayName: 'CommentVisibilitiesSubscriber'
});

});


// Activity sort order
const $c97bf8752afb1bcb$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $c97bf8752afb1bcb$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("18jBk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59ac1c3a475f1d8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iQv12 = parcelRequire("iQv12");

var $8oe80 = parcelRequire("8oe80");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $97xMx = parcelRequire("97xMx");

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $2vSU6 = parcelRequire("2vSU6");

var $8dFNe = parcelRequire("8dFNe");

var $epg8f = parcelRequire("epg8f");

var $d4MOh = parcelRequire("d4MOh");

var $2QmDq = parcelRequire("2QmDq");

var $cSD7y = parcelRequire("cSD7y");

var $5CbyA = parcelRequire("5CbyA");

var $8BBFj = parcelRequire("8BBFj");

var $hAf12 = parcelRequire("hAf12");

var $7aBQD = parcelRequire("7aBQD");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $gDpUM = parcelRequire("gDpUM");

var $cEbDs = parcelRequire("cEbDs");

var $j7n8D = parcelRequire("j7n8D");


var $13dnH = parcelRequire("13dnH");

var $cgobB = parcelRequire("cgobB");

var $zzDIW = parcelRequire("zzDIW");

var $6R7Gx = parcelRequire("6R7Gx");

var $9AfTz = parcelRequire("9AfTz");

var $hKi22 = parcelRequire("hKi22");
const $f59ac1c3a475f1d8$var$CommentWithMonitoringBase = (props)=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "comment-item",
        packageName: "issue",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97xMx.default), {
        ...props,
        intl: intl
    }));
};
const $f59ac1c3a475f1d8$var$CommentWithRealtimeData = (props)=>{
    const [{ isRealTimeCommentUpdated: isRealTimeCommentUpdated }] = (0, $9AfTz.useRealTimeComments)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f59ac1c3a475f1d8$var$CommentWithMonitoringBase, {
        ...props,
        isRealTimeCommentUpdated: isRealTimeCommentUpdated
    });
};
const $f59ac1c3a475f1d8$export$d62f28fdecfe27b6 = (0, $cSD7y.componentWithFG)('thor_send_realtime_attribute', $f59ac1c3a475f1d8$var$CommentWithRealtimeData, $f59ac1c3a475f1d8$var$CommentWithMonitoringBase);
const $f59ac1c3a475f1d8$var$isNewComment = (commentId)=>commentId.includes((0, $7a0695d910e98a34$export$c4134c813c47beb0)) || commentId.includes((0, $7a0695d910e98a34$export$56251dcfec1ad08d));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f59ac1c3a475f1d8$var$getExtractionStateProps = (state, commentId)=>({
        baseUrl: (0, $a1ky2.baseUrlSelector)(state),
        isReactionsFeatureActive: (0, $cEbDs.shouldShowReactionsSelector)(state),
        issueAri: (0, $bcoYn.issueAriSelector)(state),
        commentAri: (0, $cEbDs.commentAriSelector)(commentId)(state),
        projectType: (0, $bcoYn.projectTypeSelector)(state),
        mentionProvider: (0, $epg8f.mentionProviderSelector)(state),
        mediaContext: (0, $gDpUM.mediaContextSelector)(state),
        contextIdentifier: (0, $7aBQD.memoizedContextIdentifierSelector)(state, commentId),
        sharedAtTimestamp: (0, $zzDIW.getTimestampForSharingAsComment)(state),
        sharedValue: (0, $zzDIW.getValueForSharingAsComment)(state),
        activityProvider: (0, $hAf12.activityProviderSelector)(state)
    });
const $f59ac1c3a475f1d8$var$getExtractionDispatchProps = (dispatch)=>({
        onEditorExpandedFailure: ()=>{
            dispatch((0, $5CbyA.editorExpandedFailure)());
        },
        onEditorSaveFailure: ()=>{
            dispatch((0, $5CbyA.editorSaveFailure)());
        },
        onEditorClearSharedValues: ()=>{
            dispatch((0, $8BBFj.clearSharedAsCommentValues)());
        }
    });
var $f59ac1c3a475f1d8$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $8oe80.default)('issueFields', {
    onEditSave: 'updated',
    onDeleteConfirm: 'deleted',
    onScrolledToPermalink: 'scrolled'
}), (0, $iQv12.default)({
    onCopyClick: 'copyCommentUrl'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ commentId: string; isHighlighted: boolean; issueAri?: string | null | undefined; isReactionsFeatureActive?: boolean | undefined; baseUrl?: string | undefined; projectType?: "software" | ... 4 more ... | undefined; ... 55 more ...; intl?: IntlShape | undefined; }, { ...; }>' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof Props]: K extends "onEditSave" | "onDeleteConfirm" | "onScrolledToPermalink" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>, { ...; }>, ConnectedComponent<...>>'.
(0, $hxqfC.connect)((initialState, { commentId: commentId })=>{
    const asyncComponentsLoadedSelector = (0, $4R6GH.fg)('remove_issue_view_remote_data_loading') ? (0, $6R7Gx.hasFetchedConfluenceWhiteboardsSelector) : (0, $cgobB.isIssueRemoteDataLoadingCompleteSelector);
    return (state, { isHighlighted: isHighlighted })=>({
            jsdAuthorCanSeeRequest: (0, $d4MOh.commentOutsiderCommentSelector)(commentId)(state),
            bodyAdf: (0, $d4MOh.commentEditingOrViewBodyAdfSelector)(commentId)(state),
            bodyHtml: (0, $d4MOh.commentBodyHtmlSelector)(commentId)(state),
            hasDraft: (0, $13dnH.fieldHasDraftSelector)((0, $j7n8D.createCommentDraftKey)(commentId))(state),
            author: (0, $d4MOh.commentAuthorSelector)(commentId)(state),
            updateAuthor: (0, $d4MOh.commentUpdateAuthorSelector)(commentId)(state),
            createdDate: (0, $d4MOh.commentCreatedDateSelector)(commentId)(state),
            updatedDate: (0, $d4MOh.commentUpdatedDateSelector)(commentId)(state),
            edited: (0, $d4MOh.commentEditedSelector)(commentId)(state),
            isOptimistic: (0, $d4MOh.commentIsOptimisticSelector)(commentId)(state),
            hasSaveFailed: (0, $d4MOh.commentSaveFailedSelector)(commentId)(state),
            canEdit: (0, $d4MOh.canEditCommentSelector)(commentId)(state),
            isEditing: (0, $d4MOh.isEditingCommentSelector)(commentId)(state),
            canDelete: (0, $d4MOh.canDeleteCommentSelector)(commentId)(state),
            hasDeleteModal: (0, $d4MOh.commentHasDeleteModalSelector)(commentId)(state),
            visibility: (0, $d4MOh.commentVisibilitySelector)(commentId)(state),
            visibilityEdited: (0, $d4MOh.commentEditingOrViewVisibilitySelector)(commentId)(state),
            isInternal: (0, $d4MOh.isInternalCommentSelector)(commentId)(state),
            isEditingInternal: (0, $d4MOh.isEditingInternalCommentSelector)(commentId)(state),
            eventOccurredAt: (0, $d4MOh.commentEventOccurredAtSelector)(commentId)(state),
            jsdIncidentActivityViewHidden: (0, $d4MOh.commentJsdIncidentActivityViewHiddenSelector)(commentId)(state),
            showReactions: (0, $cEbDs.shouldShowReactionsSelector)(state),
            shouldShowCommentVisibility: (0, $d4MOh.isCommentVisibilityRestrictionSupportedSelector)(state),
            // checks whether certain async components that may affect comment scroll has finished loading.
            shouldScrollAfterAsyncComponentsLoaded: isHighlighted && asyncComponentsLoadedSelector(state),
            // whether permalink scroll has occured. Need to not scroll again if user resizes to single column view or vice versa
            hasScrolledPermalink: (0, $d4MOh.hasScrolledPermalinkCommentSelector)(state),
            isDeleted: (0, $d4MOh.commentIsDeletedSelector)(commentId)(state),
            hasReplies: !!(0, $d4MOh.commentRepliesSelector)(commentId)(state),
            canAdd: (0, $d4MOh.canAddCommentsSelector)(state),
            isReplyingToComment: (0, $d4MOh.isReplyingToCommentSelector)(commentId)(state),
            parentId: (0, $d4MOh.commentParentIdSelector)(commentId)(state),
            ...((0, $bcoYn.projectTypeSelector)(state) === (0, $2vSU6.SOFTWARE_PROJECT) || (0, $bcoYn.projectTypeSelector)(state) === (0, $2vSU6.CORE_PROJECT)) && (0, $4R6GH.fg)('thor_issue_view_realtime_updates_gate') && {
                latestCommentViewInteractedTime: (0, $d4MOh.getPersistedLatestCommentTimeSelector)(state),
                topMostUnreadCommentId: (0, $d4MOh.getTopMostUnreadCommentIdSelector)(state),
                isActivityFeedInViewPort: (0, $2QmDq.getActivityFeedInViewPort)(state),
                commentScrollStatusForRealTimeUpdates: (0, $d4MOh.getCommentScrollStatusForRealTimeUpdates)(state)
            },
            ...(0, $4R6GH.fg)('work_item_create_from_comment_and_pin_comment_gate') && {
                canCreateWorkItemInComment: (0, $hKi22.canCreateChildrenPermissionsSelector)(state)
            },
            ...$f59ac1c3a475f1d8$var$getExtractionStateProps(state, commentId),
            ...(0, $4R6GH.fg)('work_item_create_from_comment_and_pin_comment_gate') && {
                canPin: (0, $d4MOh.canPinCommentsSelector)(state),
                isPinned: (0, $d4MOh.pinnedCommentSelector)(commentId)(state),
                isPinnedCommentsLimitReached: (0, $d4MOh.isPinnedCommentsLimitReachedSelector)(state),
                pinnedCommentBodyAdf: (0, $d4MOh.pinnedCommentBodyAdfSelector)(commentId)(state)
            }
        });
}, (dispatch, { commentId: commentId })=>({
        getOnEditClick: (isInternal, commentSessionId)=>dispatch((0, $8dFNe.editCommentBegin)(commentId, isInternal, commentSessionId)),
        onEditCancel: ()=>dispatch((0, $8dFNe.editCommentCancel)(commentId)),
        onEditUpdate: (editValue)=>dispatch((0, $8dFNe.editCommentUpdate)(commentId, editValue)),
        onEditPaste: (pastedContent)=>dispatch((0, $8dFNe.pastedIntoCommentForm)(commentId, pastedContent)),
        onBlur: ()=>dispatch((0, $8dFNe.editCommentCollapse)(commentId)),
        getOnEditSave: (eventData, analyticsEvent, commentSessionId)=>dispatch((0, $8dFNe.saveCommentRequest)({
                id: commentId,
                ...eventData
            }, analyticsEvent, commentSessionId)),
        onCommentVisibilityChange: (visibility)=>{
            dispatch((0, $8dFNe.editCommentVisibility)(commentId, visibility));
        },
        onSaveRetry: ()=>dispatch((0, $8dFNe.saveCommentRetry)(commentId, new Date().toISOString(), $f59ac1c3a475f1d8$var$isNewComment(commentId))),
        onSaveEdit: ()=>dispatch((0, $8dFNe.saveCommentEdit)(commentId)),
        onSaveCancel: (parentId)=>dispatch((0, $8dFNe.saveCommentCancel)(commentId, $f59ac1c3a475f1d8$var$isNewComment(commentId), parentId)),
        setScrollStatus: (status)=>dispatch((0, $8dFNe.setCommentScrollStatus)(status)),
        onReplyClick: (replyToCommentId, authorId, authorDisplayName, visibility, commentSessionId, extraCommentContent)=>dispatch((0, $8dFNe.replyCommentBegin)(replyToCommentId, authorId, authorDisplayName, visibility, commentSessionId, (0, $4R6GH.fg)('work_item_create_from_comment_and_pin_comment_gate') ? extraCommentContent : undefined)),
        onCommentInteractionUpdateCommentViewInteractionTimeMarker: ()=>// Update interaction time marker with the current time when user interacted with new comments
            dispatch((0, $8dFNe.updateCommentViewInteractionTimeMarker)(new Date().toISOString())),
        ...$f59ac1c3a475f1d8$var$getExtractionDispatchProps(dispatch),
        setScrollStatusForRealTimeUpdate: (status)=>dispatch((0, $8dFNe.setCommentScrollStatusForRealTimeUpdates)(status)),
        ...(0, $4R6GH.fg)('work_item_create_from_comment_and_pin_comment_gate') && {
            onPinClick: ()=>dispatch((0, $8dFNe.pinComment)(commentId)),
            onUnpinClick: ()=>dispatch((0, $8dFNe.unpinComment)(commentId))
        }
    }), // WARNING !!!
//
// DO NOT merge props. The underlying comment has been optimised and removed it from the
// connected component.
//
(stateProps, dispatchProps, ownProps)=>({
        ...stateProps,
        ...dispatchProps,
        ...ownProps
    })))($f59ac1c3a475f1d8$export$d62f28fdecfe27b6);

});
parcelRegister("97xMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1d73f6c81b5566e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i2Rm5 = parcelRequire("i2Rm5");

var $90yGq = parcelRequire("90yGq");

var $l8ruj = parcelRequire("l8ruj");

var $4R6GH = parcelRequire("4R6GH");

var $2xRn9 = parcelRequire("2xRn9");

var $kKasH = parcelRequire("kKasH");

var $jk6du = parcelRequire("jk6du");
const $f1d73f6c81b5566e$export$9bd8b68d6331f364 = (props)=>{
    const { baseUrl: baseUrl, issueAri: issueAri, commentAri: commentAri, isReactionsFeatureActive: isReactionsFeatureActive, mediaContext: mediaContext, mentionProvider: mentionProvider, contextIdentifier: contextIdentifier, getEncodedMention: getEncodedMention, projectType: projectType, activityProvider: activityProvider, sharedAtTimestamp: sharedAtTimestamp, sharedValue: sharedValue, onEditorExpandedFailure: onEditorExpandedFailure, onEditorSaveFailure: onEditorSaveFailure, onEditorClearSharedValues: onEditorClearSharedValues, ...commentProps } = props;
    const [, { setContextState: setContextState, setEditorState: setEditorState, setReactionsState: setReactionsState }] = (0, $kKasH.useCommentActivityActions)();
    const currentUserAaid = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        setContextState({
            issueAri: issueAri,
            commentAri: commentAri,
            projectType: projectType
        });
    }, [
        commentAri,
        issueAri,
        projectType,
        setContextState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setEditorState({
            contextIdentifier: contextIdentifier,
            mentionProvider: mentionProvider,
            getEncodedMention: getEncodedMention,
            activityProvider: activityProvider,
            mediaContext: mediaContext,
            sharedAtTimestamp: sharedAtTimestamp,
            sharedValue: sharedValue,
            onEditorExpandedFailure: onEditorExpandedFailure,
            onEditorSaveFailure: onEditorSaveFailure,
            onEditorClearSharedValues: onEditorClearSharedValues
        });
    }, [
        activityProvider,
        contextIdentifier,
        getEncodedMention,
        mediaContext,
        mentionProvider,
        onEditorClearSharedValues,
        onEditorExpandedFailure,
        onEditorSaveFailure,
        setEditorState,
        sharedAtTimestamp,
        sharedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setReactionsState({
            isActive: isReactionsFeatureActive
        });
    }, [
        isReactionsFeatureActive,
        setReactionsState
    ]);
    // in preview mode there is only ONE render phase, so `useEffect` above is never
    // called. This means we have to control and init sweet-state imperatively
    // so all chilren components can read the information present in the state.
    if (false) {
        setContextState({
            issueAri: issueAri,
            commentAri: commentAri,
            projectType: projectType
        });
        setEditorState({
            contextIdentifier: contextIdentifier,
            mentionProvider: mentionProvider,
            getEncodedMention: getEncodedMention,
            activityProvider: activityProvider,
            mediaContext: mediaContext,
            sharedAtTimestamp: sharedAtTimestamp,
            sharedValue: sharedValue,
            onEditorExpandedFailure: onEditorExpandedFailure,
            onEditorSaveFailure: onEditorSaveFailure,
            onEditorClearSharedValues: onEditorClearSharedValues
        });
        setReactionsState({
            isActive: isReactionsFeatureActive
        });
    }
    const [editorState] = (0, $2xRn9.useEditorState)();
    // If these values are not available in the editor state then we do not
    // want to render the comment, because at the moment a second rendering
    // phase occurs once the values are set. If we don't avoid this, scrolling
    // to a focused comment does not work as expected because the height of
    // the comment content changes after the first render.
    if (!editorState.contextIdentifier || !editorState.mediaContext || !editorState.mentionProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
        id: `issue-comment-${props.commentId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "IssueComment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jk6du.default), {
        ...commentProps,
        projectType: projectType,
        currentUserAaid: currentUserAaid
    })));
};
const $f1d73f6c81b5566e$export$1abff73339628082 = (props)=>{
    const { baseUrl: baseUrl, issueAri: issueAri, commentAri: commentAri, isReactionsFeatureActive: isReactionsFeatureActive, mediaContext: mediaContext, mentionProvider: mentionProvider, contextIdentifier: contextIdentifier, getEncodedMention: getEncodedMention, projectType: projectType, activityProvider: activityProvider, sharedAtTimestamp: sharedAtTimestamp, sharedValue: sharedValue, onEditorExpandedFailure: onEditorExpandedFailure, onEditorSaveFailure: onEditorSaveFailure, onEditorClearSharedValues: onEditorClearSharedValues, ...commentProps } = props;
    const [, { setContextState: setContextState, setEditorState: setEditorState, setReactionsState: setReactionsState }] = (0, $kKasH.useCommentActivityActions)();
    const currentUserAaid = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        setContextState({
            issueAri: issueAri,
            commentAri: commentAri,
            projectType: projectType
        });
    }, [
        commentAri,
        issueAri,
        projectType,
        setContextState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setEditorState({
            contextIdentifier: contextIdentifier,
            mentionProvider: mentionProvider,
            getEncodedMention: getEncodedMention,
            activityProvider: activityProvider,
            mediaContext: mediaContext,
            sharedAtTimestamp: sharedAtTimestamp,
            sharedValue: sharedValue,
            onEditorExpandedFailure: onEditorExpandedFailure,
            onEditorSaveFailure: onEditorSaveFailure,
            onEditorClearSharedValues: onEditorClearSharedValues
        });
    }, [
        activityProvider,
        contextIdentifier,
        getEncodedMention,
        mediaContext,
        mentionProvider,
        onEditorClearSharedValues,
        onEditorExpandedFailure,
        onEditorSaveFailure,
        setEditorState,
        sharedAtTimestamp,
        sharedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('improve_issue_view_comment_reaction_buttons')) setReactionsState({
            isActive: isReactionsFeatureActive
        });
    }, [
        isReactionsFeatureActive,
        setReactionsState
    ]);
    // in preview mode there is only ONE render phase, so `useEffect` above is never
    // called. This means we have to control and init sweet-state imperatively
    // so all chilren components can read the information present in the state.
    if (false) {
        setContextState({
            issueAri: issueAri,
            commentAri: commentAri,
            projectType: projectType
        });
        setEditorState({
            contextIdentifier: contextIdentifier,
            mentionProvider: mentionProvider,
            getEncodedMention: getEncodedMention,
            activityProvider: activityProvider,
            mediaContext: mediaContext,
            sharedAtTimestamp: sharedAtTimestamp,
            sharedValue: sharedValue,
            onEditorExpandedFailure: onEditorExpandedFailure,
            onEditorSaveFailure: onEditorSaveFailure,
            onEditorClearSharedValues: onEditorClearSharedValues
        });
        if (!(0, $4R6GH.fg)('improve_issue_view_comment_reaction_buttons')) setReactionsState({
            isActive: isReactionsFeatureActive
        });
    }
    // If these values are not available in the editor state then we do not
    // want to render the comment, because at the moment a second rendering
    // phase occurs once the values are set. If we don't avoid this, scrolling
    // to a focused comment does not work as expected because the height of
    // the comment content changes after the first render.
    // UPD - changing to props instead of state to improve performance
    if (!contextIdentifier || !mediaContext || !mentionProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
        id: `issue-comment-${props.commentId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "IssueComment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jk6du.default), {
        ...commentProps,
        projectType: projectType,
        currentUserAaid: currentUserAaid,
        contextIdentifier: contextIdentifier,
        mentionProvider: mentionProvider,
        mediaContext: mediaContext
    })));
};
const $f1d73f6c81b5566e$export$8c4b9cee5fccafe7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xRn9.CommentActivityStoreContainer), {
        scope: `comment-${props.commentId}`
    }, (0, $4R6GH.fg)('change_comment_editorstate_props_to_propdrill') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1d73f6c81b5566e$export$1abff73339628082, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1d73f6c81b5566e$export$9bd8b68d6331f364, props));
var $f1d73f6c81b5566e$export$2e2bcd8739ae039 = $f1d73f6c81b5566e$export$8c4b9cee5fccafe7;

});
parcelRegister("2xRn9", function(module, exports) {

$parcel$export(module.exports, "useContextState", () => $41c87d9a8b84d5c5$export$678f7876866dd0b1);
$parcel$export(module.exports, "useContextStateIssueAri", () => $41c87d9a8b84d5c5$export$6e8818cead1a1cd9);
$parcel$export(module.exports, "useEditorState", () => $41c87d9a8b84d5c5$export$e6e340c65601d57b);
$parcel$export(module.exports, "useReactionsStateIsActive", () => $41c87d9a8b84d5c5$export$87a7c0057fa8756d);
$parcel$export(module.exports, "useCommentActivityStoreActions", () => $41c87d9a8b84d5c5$export$ea49c34f8e661fcf);
$parcel$export(module.exports, "CommentActivityStoreContainer", () => $41c87d9a8b84d5c5$export$406af6e6c6ae7c57);

var $8Rkzz = parcelRequire("8Rkzz");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2yQfU = parcelRequire("2yQfU");
const $41c87d9a8b84d5c5$var$emptyMentionEncoder = ()=>'';
const $41c87d9a8b84d5c5$export$d4c72bab9d6cc13a = {
    context: {
        issueAri: null,
        commentAri: null,
        projectType: null
    },
    editor: {
        contextIdentifier: null,
        mentionProvider: null,
        getEncodedMention: $41c87d9a8b84d5c5$var$emptyMentionEncoder,
        activityProvider: null,
        mediaContext: null,
        sharedAtTimestamp: null,
        sharedValue: undefined,
        onEditorExpandedFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditorSaveFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditorClearSharedValues: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    reactions: {
        isActive: false
    }
};
const $41c87d9a8b84d5c5$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-comment',
    initialState: $41c87d9a8b84d5c5$export$d4c72bab9d6cc13a,
    actions: $2yQfU.actions
});
const $41c87d9a8b84d5c5$export$678f7876866dd0b1 = (0, $3sQ5x.createHook)($41c87d9a8b84d5c5$export$6f57813fe9f31bf9, {
    selector: (state)=>state.context
});
const $41c87d9a8b84d5c5$export$6e8818cead1a1cd9 = (0, $3sQ5x.createHook)($41c87d9a8b84d5c5$export$6f57813fe9f31bf9, {
    selector: (state)=>({
            issueAri: state.context.issueAri,
            commentAri: state.context.commentAri
        })
});
const $41c87d9a8b84d5c5$export$e6e340c65601d57b = (0, $3sQ5x.createHook)($41c87d9a8b84d5c5$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editor
});
const $41c87d9a8b84d5c5$export$2c4c0ee735162c7d = (0, $3sQ5x.createHook)($41c87d9a8b84d5c5$export$6f57813fe9f31bf9, {
    selector: (state)=>state.reactions
});
const $41c87d9a8b84d5c5$export$87a7c0057fa8756d = (0, $3sQ5x.createHook)($41c87d9a8b84d5c5$export$6f57813fe9f31bf9, {
    selector: (state)=>({
            isActive: state.reactions.isActive
        })
});
const $41c87d9a8b84d5c5$export$ea49c34f8e661fcf = (0, $3sQ5x.createHook)($41c87d9a8b84d5c5$export$6f57813fe9f31bf9, {
    selector: null
});
const $41c87d9a8b84d5c5$export$406af6e6c6ae7c57 = (0, $gg7kZ.createContainer)($41c87d9a8b84d5c5$export$6f57813fe9f31bf9);

});
parcelRegister("2yQfU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c0f075a82151e56e$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $c0f075a82151e56e$var$setContextState = (contextState)=>({ setState: setState, getState: getState })=>{
        const newState = {
            ...getState(),
            context: contextState
        };
        setState(newState);
    };
const $c0f075a82151e56e$var$setEditorState = (editorState)=>({ setState: setState, getState: getState })=>{
        const newState = {
            ...getState(),
            editor: editorState
        };
        setState(newState);
    };
const $c0f075a82151e56e$var$setReactionsState = (reactionsState)=>({ setState: setState, getState: getState })=>{
        const newState = {
            ...getState(),
            reactions: reactionsState
        };
        setState(newState);
    };
const $c0f075a82151e56e$export$e324594224ef24da = {
    setContextState: $c0f075a82151e56e$var$setContextState,
    setEditorState: $c0f075a82151e56e$var$setEditorState,
    setReactionsState: $c0f075a82151e56e$var$setReactionsState
};

});


parcelRegister("kKasH", function(module, exports) {

$parcel$export(module.exports, "useCommentActivityActions", () => $cc70a6593a4fabe5$export$627672134a655e8e);

var $5uXOq = parcelRequire("5uXOq");

var $2xRn9 = parcelRequire("2xRn9");

const $cc70a6593a4fabe5$export$627672134a655e8e = ()=>{
    const [, actions] = (0, $2xRn9.useCommentActivityStoreActions)();
    const workflowActions = (0, $5uXOq.useMemo)(()=>{
        // @ts-expect-error - TS2304 - Cannot find name 'ContextState'.
        const setContextState = (contextState)=>{
            actions.setContextState(contextState);
        };
        // @ts-expect-error - TS2304 - Cannot find name 'EditorState'.
        const setEditorState = (editorState)=>{
            actions.setEditorState(editorState);
        };
        // @ts-expect-error - TS2304 - Cannot find name 'ReactionsState'.
        const setReactionsState = (reactionsState)=>{
            actions.setReactionsState(reactionsState);
        };
        return {
            setContextState: setContextState,
            setEditorState: setEditorState,
            setReactionsState: setReactionsState
        };
    }, [
        actions
    ]);
    return [
        null,
        workflowActions
    ];
};

});

parcelRegister("jk6du", function(module, exports) {

$parcel$export(module.exports, "default", () => $6328b84ac3e18183$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $1jWct = parcelRequire("1jWct");

var $9P99f = parcelRequire("9P99f");

var $9xeZK = parcelRequire("9xeZK");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $kLoIs = parcelRequire("kLoIs");

var $k4owb = parcelRequire("k4owb");

var $6oCZK = parcelRequire("6oCZK");

var $7XYc4 = parcelRequire("7XYc4");

var $bsdOm = parcelRequire("bsdOm");

var $eNNkf = parcelRequire("eNNkf");


var $pa9q9 = parcelRequire("pa9q9");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $g2C8o = parcelRequire("g2C8o");

var $eUE6n = parcelRequire("eUE6n");

var $bEaSU = parcelRequire("bEaSU");

var $8RfOY = parcelRequire("8RfOY");

var $jEjVx = parcelRequire("jEjVx");
const $6328b84ac3e18183$var$CommentBase = (0, $7XYc4.componentWithCondition)(()=>{
    const isSoftwareProject = (0, $bsdOm.useIsSoftwareIssue)();
    const isBusinessProject = (0, $bsdOm.useIsBusinessIssue)();
    if (!(0, $4R6GH.fg)('jira_custom_comment_component_refactor')) return false;
    if (!isSoftwareProject && !isBusinessProject) return false;
    return true;
}, (0, $8RfOY.CommentBase), (0, $eUE6n.CommentBase));
const $6328b84ac3e18183$var$COMMENT_SLACK_FLAG_ID = 'comment_slack_id';
const $6328b84ac3e18183$var$CommentWithIssueOfIncidentsPracticeAndAiDefinitions = (props)=>{
    const { author: author } = props;
    const isIssueOfIncidentsPractice = (0, $kLoIs.useIsIssueOfIncidentsPractice)();
    const commentRef = (0, $5uXOq.useRef)(null);
    const { highlightAcronyms: highlightAcronyms, resetAcronymsData: resetAcronymsData } = (0, $9P99f.useAcronymHighlighter)(commentRef, (0, $bEaSU.FIELD_TYPE_COMMENT), author?.id ?? undefined);
    const { register: register, unregister: unregister } = (0, $9xeZK.useOnHighlight)(commentRef, (0, $bEaSU.FIELD_TYPE_COMMENT));
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('thor_ai_definitions_issue_comment')) {
            if (commentRef.current && !props.isEditing) {
                highlightAcronyms(props.bodyAdf);
                return resetAcronymsData;
            }
        }
    }, [
        props.bodyAdf,
        highlightAcronyms,
        resetAcronymsData,
        props.isEditing
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('thor_ai_definitions_issue_comment')) {
            if (!props.isEditing) register();
            return unregister;
        }
    }, [
        unregister,
        register,
        props.isEditing
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($6328b84ac3e18183$var$CommentBase, {
        ...props,
        commentRef: !props.isEditing && (0, $4R6GH.fg)('thor_ai_definitions_issue_comment') ? commentRef : undefined,
        isIssueOfIncidentsPractice: isIssueOfIncidentsPractice
    });
};
const $6328b84ac3e18183$var$CommentsWithCreateIssueFromComment = (props)=>{
    const { author: author, fullIssueUrl: fullIssueUrl, bodyAdf: bodyAdf } = props;
    const { onClickCreateIssue: onClickCreateIssue, currentUserAccountId: currentUserAccountId } = (0, $k4owb.useOpenGICFromComment)({
        author: author,
        fullIssueUrl: fullIssueUrl,
        bodyAdf: bodyAdf
    });
    return /*#__PURE__*/ $5uXOq.createElement($6328b84ac3e18183$var$CommentWithIssueOfIncidentsPracticeAndAiDefinitions, {
        ...props,
        onClickCreateIssue: onClickCreateIssue,
        currentUserAccountId: currentUserAccountId
    });
};
const $6328b84ac3e18183$var$CommentWithCreateIssueFromCommentFeatureFlags = (props)=>{
    const isTargetedForCreateIssueFromCommentExp = (0, $6oCZK.useIsTargetedForCreateIssueFromCommentExp)();
    const commonProps = {
        ...props,
        hasFloatingMenu: false
    };
    if (isTargetedForCreateIssueFromCommentExp && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasWorkItemCreate', false)) return /*#__PURE__*/ $5uXOq.createElement($6328b84ac3e18183$var$CommentsWithCreateIssueFromComment, commonProps);
    return /*#__PURE__*/ $5uXOq.createElement($6328b84ac3e18183$var$CommentWithIssueOfIncidentsPracticeAndAiDefinitions, commonProps);
};
const $6328b84ac3e18183$var$CommentWithSlackInfo = (props)=>{
    const [commentSlackFlagDismissed, { setValue: setValue }] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$32a0b5eafccd5141));
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClickUnderstood = (0, $5uXOq.useCallback)(()=>{
        setValue('true');
        dismissFlag($6328b84ac3e18183$var$COMMENT_SLACK_FLAG_ID); // TODO: fire analytics
    }, [
        dismissFlag,
        setValue
    ]);
    const onShowFlagForSlackSync = (0, $5uXOq.useCallback)(()=>{
        showFlag({
            id: $6328b84ac3e18183$var$COMMENT_SLACK_FLAG_ID,
            icon: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
                label: formatMessage((0, $jEjVx.default).slackFlagTitle),
                color: "var(--ds-icon-information, #1D7AFC)"
            }),
            messageId: 'issue-comment-base.ui.comment.show-flag.info',
            messageType: 'transactional',
            type: 'info',
            title: formatMessage((0, $jEjVx.default).slackFlagTitle),
            description: formatMessage((0, $jEjVx.default).slackFlagBody),
            isAutoDismiss: false,
            actions: [
                {
                    onClick: onClickUnderstood,
                    content: formatMessage((0, $jEjVx.default).slackFlagBtn)
                }
            ]
        });
    }, [
        onClickUnderstood,
        showFlag,
        formatMessage
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($6328b84ac3e18183$var$CommentWithCreateIssueFromCommentFeatureFlags, {
        ...props,
        isThirdPartySyncOn: true,
        thirdPartyLink: "https://www.atlassian.com/",
        thirdPartyCommentSource: (0, $g2C8o.THIRD_PARTY_SOURCE_SLACK),
        showCommentSlackFlag: commentSlackFlagDismissed !== 'true',
        onShowFlagForSlackSync: onShowFlagForSlackSync
    });
};
const $6328b84ac3e18183$var$CommentWithSlackInfoFeatureFlags = (props)=>{
    // TODO: check thirdPartyLink data exists once BE change is done
    if ((props.projectType === (0, $2vSU6.SOFTWARE_PROJECT) || props.projectType === (0, $2vSU6.CORE_PROJECT)) && (0, $6s1PB.expVal)('jira_slack_sync_slack_thread', 'isEnabled', false)) return /*#__PURE__*/ $5uXOq.createElement($6328b84ac3e18183$var$CommentWithSlackInfo, props);
    return /*#__PURE__*/ $5uXOq.createElement($6328b84ac3e18183$var$CommentWithCreateIssueFromCommentFeatureFlags, props);
};
const $6328b84ac3e18183$export$4d299b491347818a = $6328b84ac3e18183$var$CommentWithSlackInfoFeatureFlags;
var $6328b84ac3e18183$export$2e2bcd8739ae039 = $6328b84ac3e18183$export$4d299b491347818a;

});
parcelRegister("k4owb", function(module, exports) {

$parcel$export(module.exports, "useOpenGICFromComment", () => $80ab67522f4c86bc$export$24a7637e7d87de91);

var $5uXOq = parcelRequire("5uXOq");

var $bPWvi = parcelRequire("bPWvi");
var $d4vM2 = parcelRequire("d4vM2");
var $kF5bw = parcelRequire("kF5bw");
var $50sdg = parcelRequire("50sdg");
var $7ipfu = parcelRequire("7ipfu");
var $gBTcG = parcelRequire("gBTcG");

var $koVbs = parcelRequire("koVbs");

var $5rzqz = parcelRequire("5rzqz");

var $hULKg = parcelRequire("hULKg");

var $cYlk7 = parcelRequire("cYlk7");

var $dAfqg = parcelRequire("dAfqg");

var $g5X3G = parcelRequire("g5X3G");

var $6hmea = parcelRequire("6hmea");
const $80ab67522f4c86bc$export$24a7637e7d87de91 = ({ author: author, fullIssueUrl: fullIssueUrl, bodyAdf: bodyAdf })=>{
    const openIssueCreateModal = (0, $5rzqz.useOpenIssueCreateModal)();
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    const currentUserData = (0, $cYlk7.useCurrentUser)();
    const currentUserAccountId = currentUserData?.data?.user?.accountId;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const descriptionContent = (0, $5uXOq.useMemo)(()=>{
        if (author?.id && bodyAdf?.content && fullIssueUrl) return (0, $bPWvi.doc)((0, $50sdg.paragraph)((0, $kF5bw.mention)({
            id: author?.id,
            text: `@${author?.displayName}`
        }), (0, $gBTcG.text)(formatMessage((0, $6hmea.default).commentOn)), (0, $d4vM2.inlineCard)({
            url: fullIssueUrl
        })), (0, $7ipfu.rule)(), ...bodyAdf.content);
        return '';
    }, [
        author?.id,
        author?.displayName,
        bodyAdf?.content,
        fullIssueUrl,
        formatMessage
    ]);
    const payload = (0, $5uXOq.useMemo)(()=>{
        return {
            ...projectData?.projectId && {
                project: {
                    projectId: (0, $g5X3G.toProjectId)(`${projectData?.projectId}`)
                }
            },
            defaultValues: {
                ...descriptionContent && {
                    richTextFields: [
                        {
                            fieldId: 'description',
                            richText: {
                                adfValue: descriptionContent
                            }
                        }
                    ]
                },
                ...currentUserAccountId && {
                    singleSelectUserPickerFields: [
                        {
                            fieldId: 'assignee',
                            user: {
                                accountId: currentUserAccountId
                            }
                        }
                    ]
                }
            }
        };
    }, [
        currentUserAccountId,
        descriptionContent,
        projectData?.projectId
    ]);
    const onClickCreateIssue = (0, $5uXOq.useCallback)(({ onIssueCreate: onIssueCreate })=>{
        openIssueCreateModal({
            payload: payload,
            onIssueCreate: onIssueCreate,
            triggerPointKey: (0, $hULKg.JIRA_ISSUE_COMMENT),
            displayCreateAnotherIssueToggle: false,
            disableProjectDropdown: false,
            disableIssueTypeDropdown: false,
            disableCreationSuccessFlag: true
        });
    }, [
        openIssueCreateModal,
        payload
    ]);
    return {
        onClickCreateIssue: onClickCreateIssue,
        currentUserAccountId: currentUserAccountId
    };
};

});
parcelRegister("d4vM2", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $8d65e560851b736e$export$cbf8224b64e0d942);
const $8d65e560851b736e$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });

});

parcelRegister("kF5bw", function(module, exports) {

$parcel$export(module.exports, "mention", () => $618c09a53fa6d6e8$export$db83999c14438df4);
const $618c09a53fa6d6e8$export$db83999c14438df4 = (attrs)=>({
        type: 'mention',
        attrs: {
            accessLevel: '',
            ...attrs
        }
    });

});

parcelRegister("7ipfu", function(module, exports) {

$parcel$export(module.exports, "rule", () => $67886bc2f1f35cc0$export$fbeb3a3956e8a3c7);
const $67886bc2f1f35cc0$export$fbeb3a3956e8a3c7 = ()=>({
        type: 'rule'
    });

});

parcelRegister("6hmea", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8282ea10cca2d82$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d8282ea10cca2d82$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    commentOn: {
        "id": "create-issue-from-comment.controllers.use-open-gic-from-comment.comment",
        "defaultMessage": "commented on"
    }
});

});


parcelRegister("6oCZK", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForCreateIssueFromCommentExp", () => $1a9370aa1dc4ca35$export$3767fca3e1539c89);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $2e4p8 = parcelRequire("2e4p8");
const $1a9370aa1dc4ca35$export$3767fca3e1539c89 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const isSoftwareProject = data?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isBusinessProject = data?.projectType === (0, $2vSU6.CORE_PROJECT);
    const isEmbedMode = (0, $2e4p8.useIsEmbedMode)();
    return (isSoftwareProject || isBusinessProject) && !isEmbedMode;
};

});

const $31848aa9a0db89de$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $31848aa9a0db89de$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $31848aa9a0db89de$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $31848aa9a0db89de$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $31848aa9a0db89de$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $31848aa9a0db89de$export$2cf981c493d79a21 = 'jira.user.issue.details.activity-layout-setting';
const $31848aa9a0db89de$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $31848aa9a0db89de$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $31848aa9a0db89de$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $31848aa9a0db89de$export$1a08240e14f65aa = 'jira.user.issue.collapsible-sections-state';
const $31848aa9a0db89de$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("eUE6n", function(module, exports) {

$parcel$export(module.exports, "CommentBase", () => $4a7699c30f340a9a$export$b3f0cdb4c764ce3e);
/* legacy-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7Jxgt = parcelRequire("7Jxgt");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $ujWmd = parcelRequire("ujWmd");

var $2kKir = parcelRequire("2kKir");
var $9DgQp = parcelRequire("9DgQp");
var $i3LhB = parcelRequire("i3LhB");
var $kB744 = parcelRequire("kB744");

var $aYAc3 = parcelRequire("aYAc3");

var $3bDjY = parcelRequire("3bDjY");

var $8w53e = parcelRequire("8w53e");

var $bPWvi = parcelRequire("bPWvi");
var $d4vM2 = parcelRequire("d4vM2");
var $kF5bw = parcelRequire("kF5bw");
var $50sdg = parcelRequire("50sdg");
var $7ipfu = parcelRequire("7ipfu");
var $gBTcG = parcelRequire("gBTcG");

var $7O2cr = parcelRequire("7O2cr");

var $5nRKm = parcelRequire("5nRKm");

var $8U6zd = parcelRequire("8U6zd");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $9JHBt = parcelRequire("9JHBt");

var $2vSU6 = parcelRequire("2vSU6");

var $bMyd4 = parcelRequire("bMyd4");

var $b71gk = parcelRequire("b71gk");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");


var $6ZEN7 = parcelRequire("6ZEN7");

var $g2C8o = parcelRequire("g2C8o");


var $b8JO7 = parcelRequire("b8JO7");

var $7DhFg = parcelRequire("7DhFg");

var $aqnOi = parcelRequire("aqnOi");

var $75neI = parcelRequire("75neI");

var $h5GPI = parcelRequire("h5GPI");


var $7p8Xy = parcelRequire("7p8Xy");

var $2HbP2 = parcelRequire("2HbP2");

var $6mahi = parcelRequire("6mahi");

var $2KAtx = parcelRequire("2KAtx");

var $6Z846 = parcelRequire("6Z846");

var $8zOmE = parcelRequire("8zOmE");

var $fCo6Y = parcelRequire("fCo6Y");

var $9OXo1 = parcelRequire("9OXo1");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $bSSG7 = parcelRequire("bSSG7");

var $lssfC = parcelRequire("lssfC");

var $jEjVx = parcelRequire("jEjVx");

var $jOvmQ = parcelRequire("jOvmQ");

var $iyA9O = parcelRequire("iyA9O");

var $kOHWv = parcelRequire("kOHWv");

var $awxly = parcelRequire("awxly");

var $88XcY = parcelRequire("88XcY");

var $j57jo = parcelRequire("j57jo");

var $dHOuF = parcelRequire("dHOuF");

var $VuurY = parcelRequire("VuurY");

var $6iXgG = parcelRequire("6iXgG");

var $iBYZ7 = parcelRequire("iBYZ7");

var $iDRQC = parcelRequire("iDRQC");

var $hdUJF = parcelRequire("hdUJF");

var $3un1S = parcelRequire("3un1S");

var $aIJnf = parcelRequire("aIJnf");

var $5y0Rn = parcelRequire("5y0Rn");

var $hdrGw = parcelRequire("hdrGw");

var $kFfVd = parcelRequire("kFfVd");
const $4a7699c30f340a9a$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('atl-issue-view-comment');
const $4a7699c30f340a9a$var$UNREAD_COMMENT_LOZENGE_VIEWED_KEY = 'unread-comment-lozenge-viewed'; // eslint-disable-next-line jira/react/no-class-components
class $4a7699c30f340a9a$export$b3f0cdb4c764ce3e extends (0, $5uXOq.Component) {
    static{
        this.displayName = 'Comment';
    }
    static{
        this.defaultProps = {
            isEditing: false,
            isIssueOfIncidentsPractice: false,
            visibility: (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC),
            updatedDate: null,
            edited: false,
            eventOccurredAt: null,
            jsdIncidentActivityViewHidden: null
        };
    }
    constructor(props){
        super(props), this.unreadCommentLozengeTimeoutId = undefined, this.changeEventOccurredAt = (val)=>{
            this.setState({
                selectedEventOccurredAt: val
            });
        }, this.updateUnreadCommentRef = (ref)=>{
            this.unreadCommentRef = ref;
        }, this.isUnreadComment = ()=>{
            if ((this.props.projectType === (0, $2vSU6.SOFTWARE_PROJECT) || this.props.projectType === (0, $2vSU6.CORE_PROJECT)) && (0, $4R6GH.fg)('thor_issue_view_realtime_updates_gate')) {
                const { createdDate: createdDate, latestCommentViewInteractedTime: latestCommentViewInteractedTime, author: author, currentUserAaid: currentUserAaid } = this.props;
                return author?.id !== currentUserAaid && latestCommentViewInteractedTime && new Date(latestCommentViewInteractedTime).getTime() < new Date(createdDate).getTime() || false;
            }
            return false;
        }, this.onCommentInteraction = ()=>{
            if ((this.props.projectType === (0, $2vSU6.SOFTWARE_PROJECT) || this.props.projectType === (0, $2vSU6.CORE_PROJECT)) && (0, $4R6GH.fg)('thor_issue_view_realtime_updates_gate')) {
                const { onCommentInteractionUpdateCommentViewInteractionTimeMarker: onCommentInteractionUpdateCommentViewInteractionTimeMarker } = this.props;
                this.isUnreadComment() && onCommentInteractionUpdateCommentViewInteractionTimeMarker && onCommentInteractionUpdateCommentViewInteractionTimeMarker();
            }
        } // Function to add analytics when delete action item is clicked
        , this.onDeleteClick = ()=>{
            const { parentId: parentId, createAnalyticsEvent: createAnalyticsEvent, hasReplies: hasReplies } = this.props;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'deleteCommentButton', {
                isRootComment: !!parentId,
                hasReplies: hasReplies
            });
        }, this.onEditClick = (_, analyticsEvent, isSiteAdmin)=>{
            const { getOnEditClick: getOnEditClick, isInternal: isInternal, hasDraft: hasDraft, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const commentSessionId = (0, $7Jxgt.v4)();
            getOnEditClick(isInternal, commentSessionId);
            this.onCommentInteraction(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'editCommentEditor expanded', {
                hasDraft: hasDraft
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'commentEdit',
                action: 'started'
            }), {
                hasDraft: hasDraft,
                commentSessionId: commentSessionId,
                ...this.jsmLoomExperiment?.enabled && {
                    isSiteAdmin: isSiteAdmin,
                    loomJsmAgentExperimentCohort: this.jsmLoomExperiment?.cohort
                }
            });
        }, this.onEditSave = (value)=>{
            const isValueEmpty = (0, $fCo6Y.isOnlyWhitespaceAdf)(value);
            if (!isValueEmpty) {
                const { author: author, commentId: commentId, createdDate: createdDate, bodyHtml: bodyHtml, shouldShowCommentVisibility: shouldShowCommentVisibility, visibility: visibility, visibilityEdited: visibilityEdited, getOnEditSave: getOnEditSave, createAnalyticsEvent: createAnalyticsEvent, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden, fullIssueUrl: fullIssueUrl, isIssueOfIncidentsPractice: isIssueOfIncidentsPractice, isEditingInternal: isEditingInternal, projectType: projectType, parentId: parentId, commentSessionId: commentSessionId, isRealTimeCommentUpdated: isRealTimeCommentUpdated } = this.props;
                const authorId = author ? author.id : null;
                const analyticsEvent = createAnalyticsEvent({
                    action: 'updated'
                });
                this.state.selectedEventOccurredAt ? analyticsEvent.update({
                    commentEditWithEventOccurredAt: true
                }) : analyticsEvent.update({
                    commentEditWithEventOccurredAt: false
                });
                if (shouldShowCommentVisibility) analyticsEvent.update({
                    isVisibilityUpdated: !(0, $j57jo.areCommentVisibilitiesEqual)(visibility, visibilityEdited)
                });
                if ((0, $4R6GH.fg)('thor_send_realtime_attribute')) analyticsEvent.update({
                    isRealTimeCommentUpdated: isRealTimeCommentUpdated
                });
                getOnEditSave({
                    authorId: authorId,
                    createdDate: createdDate,
                    bodyAdf: value,
                    bodyHtml: bodyHtml,
                    isNewComment: commentId.includes((0, $7a0695d910e98a34$export$c4134c813c47beb0)),
                    visibility: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && !isEditingInternal ? (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC) : visibilityEdited,
                    ...isIssueOfIncidentsPractice && isEditingInternal ? {
                        eventOccurredAt: this.state.selectedEventOccurredAt,
                        jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden,
                        fullIssueUrl: fullIssueUrl,
                        triggerIncidentSaveCommentFlag: isIssueOfIncidentsPractice
                    } : {},
                    parentId: parentId
                }, analyticsEvent, commentSessionId);
            }
        }, this.onHideSave = ()=>{
            const { author: author, commentId: commentId, createdDate: createdDate, bodyHtml: bodyHtml, bodyAdf: bodyAdf, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden, visibilityEdited: visibilityEdited, projectType: projectType, isEditingInternal: isEditingInternal, getOnEditSave: getOnEditSave, createAnalyticsEvent: createAnalyticsEvent, eventOccurredAt: eventOccurredAt, commentSessionId: commentSessionId } = this.props;
            const authorId = author ? author.id : null;
            const analyticsEvent = createAnalyticsEvent({
                action: 'updated'
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), jsdIncidentActivityViewHidden ? 'unhide clicked' : 'hide clicked');
            getOnEditSave({
                authorId: authorId,
                createdDate: createdDate,
                bodyAdf: bodyAdf,
                bodyHtml: bodyHtml,
                isNewComment: commentId.includes((0, $7a0695d910e98a34$export$c4134c813c47beb0)),
                visibility: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && !isEditingInternal ? (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC) : visibilityEdited,
                eventOccurredAt: eventOccurredAt,
                jsdIncidentActivityViewHidden: !jsdIncidentActivityViewHidden
            }, analyticsEvent, commentSessionId);
        }, this.getAuthorDisplayName = (author)=>author ? author.displayName : this.props.intl.formatMessage((0, $jEjVx.default).anonymous), this.onReplyClick = ()=>{
            this.onReplyWithExtraCommentContent();
        }, this.onReplyWithExtraCommentContent = (extraCommentContent)=>{
            const { onReplyClick: onReplyClick, parentId: parentId, commentId: commentId, author: author, shouldShowCommentVisibility: shouldShowCommentVisibility, visibility: visibility, createAnalyticsEvent: createAnalyticsEvent, hasReplies: hasReplies, showCommentSlackFlag: showCommentSlackFlag, onShowFlagForSlackSync: onShowFlagForSlackSync } = this.props;
            if (!onReplyClick) return;
            if (showCommentSlackFlag && onShowFlagForSlackSync) onShowFlagForSlackSync();
            const replyingToCommentId = parentId || commentId;
            const authorId = author ? author.id : null;
            const authorDisplayName = this.getAuthorDisplayName(author);
            const replyVisibility = shouldShowCommentVisibility ? visibility : undefined;
            const commentSessionId = (0, $7Jxgt.v4)();
            this.onCommentInteraction();
            onReplyClick(replyingToCommentId, authorId, authorDisplayName, replyVisibility, commentSessionId, extraCommentContent && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasWorkItemCreate', false) ? extraCommentContent : undefined);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'replyButton', {
                isRootComment: !!parentId,
                hasReplies: hasReplies,
                commentSessionId: commentSessionId,
                // This attribute is used to track if the reply button is auto open with a template filled in
                ...extraCommentContent && {
                    isTriggeredByCommentTemplate: true
                }
            });
        }, this.onClickCreateIssueButton = ()=>{
            const { onClickCreateIssue: onClickCreateIssue } = this.props;
            if (!onClickCreateIssue) return;
            onClickCreateIssue({
                onIssueCreate: this.onIssueCreate
            });
        }, this.onIssueCreate = (data)=>{
            const { author: author, currentUserAccountId: currentUserAccountId, intl: intl } = this.props;
            const issueUrl = (0, $lssfC.createFullIssueUrl)('', data.issueKey);
            const authorId = author ? author.id : null;
            const authorDisplayName = this.getAuthorDisplayName(author);
            const quotedCommentAndIssue = [
                (0, $50sdg.paragraph)((0, $d4vM2.inlineCard)({
                    url: issueUrl
                })),
                (0, $7ipfu.rule)(),
                ...this.props.bodyAdf.content
            ];
            const extraCommentContent = currentUserAccountId === authorId ? (0, $bPWvi.doc)((0, $50sdg.paragraph)((0, $gBTcG.text)(this.props.intl.formatMessage((0, $jEjVx.default).createdIssueBySelf))), ...quotedCommentAndIssue) : (0, $bPWvi.doc)((0, $50sdg.paragraph)(authorId ? (0, $kF5bw.mention)({
                id: authorId,
                text: `@${authorDisplayName}`
            }) : (0, $gBTcG.text)(''), (0, $gBTcG.text)(' '), (0, $gBTcG.text)(intl.formatMessage((0, $jEjVx.default).createdIssue))), ...quotedCommentAndIssue);
            this.onReplyWithExtraCommentContent(extraCommentContent);
        }, this.getCommentReactions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "issue-comment-base.ui.comment.reactions-container",
                className: (0, $bwpsq.default)([
                    "_otyr1b66 _4t3igktf _1tke1ns9"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kOHWv.IssueCommentReactionsBoundary), {
                packageName: "issue",
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "IssueCommentReactions"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $awxly.default), {
                commentId: this.props.commentId,
                showQuickReactions: (0, $6s1PB.expVal)('thor_surface_reaction_comment_experiment', 'isSurfaceReactionsEnabled', false) && this.props.isHighlighted,
                onReactionSuccess: this.onCommentInteraction
            })))), this.deleteConfirmModalProps = {
            width: 'small',
            testId: 'issue-comment-base.ui.comment.confirmation-modal.modal-dialog'
        }, this.jsmLoomExperiment = {
            ...(0, $7p8Xy.isJsmLoomExperimentEnabled)()
        }, this.handleCopy = async ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            try {
                await globalThis.navigator.clipboard.writeText(`${this.props.fullIssueUrl}?focusedCommentId=${this.props.commentId}`);
                this.setState({
                    tooltipMessage: (0, $jEjVx.default).linkCopied
                });
                setTimeout(()=>{
                    this.setState({
                        isCommentMoreActionMenuOpen: false,
                        tooltipMessage: (0, $jEjVx.default).copyLink
                    });
                }, 800);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                }), 'meatballMenuCopyLinkButton');
            } catch (e) {
            // show error flag.
            }
        }, this.handleDropdownClick = (eventName)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), eventName);
            if (!this.state.isCommentMoreActionMenuOpen) this.setState({
                isCommentMoreActionMenuOpen: true
            });
            else this.setState({
                isCommentMoreActionMenuOpen: false
            });
        }, this.handleOpenChange = ({ event: event })=>{
            // workaround as we don't have callback when clicking outside the dropdown menu
            if (event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null) this.setState({
                isCommentMoreActionMenuOpen: false
            });
        }, this.getCommentActions = ()=>{
            return [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                    key: "actions"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                    space: "space.100",
                    alignBlock: "start",
                    shouldWrap: true
                }, this.props.canAdd && this.props.isThreadedCommentsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                    key: "reply"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: this.props.intl.formatMessage((0, $jEjVx.default).reply)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                    onClick: this.onReplyClick,
                    xcss: $4a7699c30f340a9a$var$commentActionButtonStyles,
                    testId: "issue-comment-base.ui.comment.reply-tooltip"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7O2cr))), {
                    label: this.props.intl.formatMessage((0, $jEjVx.default).reply)
                })))), (0, $6s1PB.expVal)('thor_surface_reaction_comment_experiment', 'isSurfaceReactionsEnabled', false) ? this.props.showReactions && this.getCommentReactions() : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, this.props.canEdit && (this.jsmLoomExperiment.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: { isSiteAdmin: isSiteAdmin } })=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                        content: this.props.isThirdPartySyncOn && (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') ? this.props.intl.formatMessage((0, $jEjVx.default).disabledEditTooltip) : this.props.intl.formatMessage((0, $jEjVx.default).edit)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                        key: "edit",
                        xcss: $4a7699c30f340a9a$var$commentActionButtonStyles,
                        onClick: (...args)=>this.onEditClick(...args, isSiteAdmin),
                        testId: "issue-comment-base.ui.comment.edit-tooltip",
                        ...(0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') && {
                            isDisabled: !!this.props.isThirdPartySyncOn
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))), {
                        label: this.props.intl.formatMessage((0, $jEjVx.default).edit)
                    })), this.props.hasDraft ? ` (${this.props.intl.formatMessage((0, $75neI.default).draftIndicator)})` : '');
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: this.props.isThirdPartySyncOn && (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') ? this.props.intl.formatMessage((0, $jEjVx.default).disabledEditTooltip) : this.props.intl.formatMessage((0, $jEjVx.default).edit)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                    ...(0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') && {
                        isDisabled: !!this.props.isThirdPartySyncOn
                    },
                    key: "edit",
                    onClick: this.onEditClick,
                    xcss: $4a7699c30f340a9a$var$commentActionButtonStyles,
                    testId: "issue-comment-base.ui.comment.edit-tooltip"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))), {
                    label: this.props.intl.formatMessage((0, $jEjVx.default).edit)
                }), this.props.hasDraft ? ` (${this.props.intl.formatMessage((0, $75neI.default).draftIndicator)})` : '')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
                    trigger: ({ triggerRef: triggerRef, ...props })=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                            content: this.props.intl.formatMessage((0, $jEjVx.default).moreActions)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                            ...props,
                            ref: triggerRef,
                            onClick: ()=>{
                                this.handleDropdownClick('meatballMenuMoreActionsButton');
                            },
                            xcss: $4a7699c30f340a9a$var$commentActionButtonStyles,
                            testId: "issue-comment-base.ui.comment.more-actions-tooltip"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                            label: this.props.intl.formatMessage((0, $jEjVx.default).moreActions)
                        })));
                    },
                    shouldRenderToParent: true,
                    isOpen: this.state.isCommentMoreActionMenuOpen,
                    onOpenChange: this.handleOpenChange
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: ()=>{
                        return this.props.intl.formatMessage(this.state.tooltipMessage);
                    }
                }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                        ...tooltipProps,
                        onClick: this.handleCopy
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                        alignBlock: "center",
                        space: "space.200"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, this.props.intl.formatMessage((0, $jEjVx.default).copyLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8w53e))), {
                        label: this.props.intl.formatMessage((0, $jEjVx.default).copyLink)
                    })))), this.props.canAdd && this.props.isThreadedCommentsEnabled && this.props.canCreateWorkItemInComment && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasWorkItemCreate', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                    onClick: ()=>this.onClickCreateIssueButton()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $jEjVx.default).createWorkItem)), this.props.canPin && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasPinComment', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdrGw.default), {
                    handleDropdownClick: this.handleDropdownClick
                }), this.props.canScrollToOriginalCommentFromPinned && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasPinComment', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kFfVd.default), {
                    handleDropdownClick: this.handleDropdownClick
                }), this.props.canDelete && (this.props.isThirdPartySyncOn && (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: this.props.intl.formatMessage((0, $jEjVx.default).disabledDeleteTooltip)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                    key: "delete",
                    isDisabled: true
                }, this.props.intl.formatMessage((0, $jEjVx.default).delete))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JHBt.ModalDropdownItemTrigger), {
                    entryPoint: (0, $dHOuF.deleteIssueLinkConfirmationEntryPoint),
                    entryPointProps: {
                        commentId: this.props.commentId,
                        eventOccurredAt: this.props.eventOccurredAt,
                        jsdIncidentActivityViewHidden: this.props.jsdIncidentActivityViewHidden,
                        hasReplies: this.props.hasReplies,
                        parentId: this.props.parentId,
                        isRealTimeCommentUpdated: this.props.isRealTimeCommentUpdated
                    },
                    modalProps: this.deleteConfirmModalProps,
                    onClick: ()=>{
                        this.handleDropdownClick('meatballMenuDeleteCommentButton');
                        (0, $4R6GH.fg)('add-analytics-for-delete-comment-ken-1993') ? this.onDeleteClick() : undefined;
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $jEjVx.default).delete))), this.props.canEdit && this.props.isInternal && this.props.isIssueOfIncidentsPractice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                    key: "hide",
                    onClick: this.onHideSave
                }, this.props.intl.formatMessage(this.props.jsdIncidentActivityViewHidden ? (0, $jEjVx.default).unhide : (0, $jEjVx.default).hide)))))))
            ].filter((action)=>!!action);
        }, this.getCommentActionsOld = ()=>[
                (0, $6s1PB.expVal)('thor_surface_reaction_comment_experiment', 'isSurfaceReactionsEnabled', false) ? this.props.showReactions && this.getCommentReactions() : undefined,
                this.props.canAdd && this.props.isThreadedCommentsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                    key: "reply",
                    onClick: this.onReplyClick
                }, this.props.intl.formatMessage((0, $jEjVx.default).reply)),
                this.props.canEdit && !this.props.hasFloatingMenu && (this.jsmLoomExperiment.enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: { isSiteAdmin: isSiteAdmin } })=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                        key: "edit",
                        onClick: (...args)=>this.onEditClick(...args, isSiteAdmin)
                    }, this.props.intl.formatMessage((0, $jEjVx.default).edit), this.props.hasDraft ? ` (${this.props.intl.formatMessage((0, $75neI.default).draftIndicator)})` : '');
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                    key: "edit",
                    onClick: this.onEditClick
                }, this.props.intl.formatMessage((0, $jEjVx.default).edit), this.props.hasDraft ? ` (${this.props.intl.formatMessage((0, $75neI.default).draftIndicator)})` : '')),
                this.props.canDelete && !this.props.hasFloatingMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
                    entryPoint: (0, $dHOuF.deleteIssueLinkConfirmationEntryPoint),
                    entryPointProps: {
                        commentId: this.props.commentId,
                        eventOccurredAt: this.props.eventOccurredAt,
                        jsdIncidentActivityViewHidden: this.props.jsdIncidentActivityViewHidden,
                        hasReplies: this.props.hasReplies,
                        parentId: this.props.parentId,
                        isRealTimeCommentUpdated: this.props.isRealTimeCommentUpdated
                    },
                    modalProps: this.deleteConfirmModalProps,
                    useInternalModal: true
                }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                        key: "delete",
                        ref: ref,
                        ...(0, $4R6GH.fg)('add-analytics-for-delete-comment-ken-1993') && {
                            onClick: this.onDeleteClick
                        }
                    }, this.props.intl.formatMessage((0, $jEjVx.default).delete))),
                this.props.canEdit && this.props.isInternal && this.props.isIssueOfIncidentsPractice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                    key: "hide",
                    onClick: this.onHideSave
                }, this.props.intl.formatMessage(this.props.jsdIncidentActivityViewHidden ? (0, $jEjVx.default).unhide : (0, $jEjVx.default).hide)),
                (0, $6s1PB.expVal)('thor_surface_reaction_comment_experiment', 'isSurfaceReactionsEnabled', false) ? undefined : this.props.showReactions && this.getCommentReactions()
            ].filter((action)=>!!action), this.onSaveCancelClick = ()=>{
            const { onSaveCancel: onSaveCancel, parentId: parentId } = this.props;
            onSaveCancel(parentId);
        }, this.getCommentSaveFailedActions = ()=>[
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                    key: "retry",
                    onClick: this.props.onSaveRetry
                }, this.props.intl.formatMessage((0, $jEjVx.default).retrySave)),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                    key: "edit",
                    onClick: this.props.onSaveEdit
                }, this.props.intl.formatMessage((0, $jEjVx.default).edit)),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                    key: "cancel",
                    onClick: this.onSaveCancelClick
                }, this.props.intl.formatMessage((0, $jEjVx.default).cancelSave))
            ].filter((action)=>!!action), this.getCommentSavedWithFloatingMenu = ()=>[
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                    key: "retry",
                    onClick: this.props.onSaveRetry
                }, this.props.intl.formatMessage((0, $jEjVx.default).retrySave)),
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
                    key: "cancel",
                    onClick: this.onSaveCancelClick
                }, this.props.intl.formatMessage((0, $jEjVx.default).cancelSave))
            ].filter((action)=>!!action), this.renderAdfRendererFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $VuurY.IssueCommentEditorReadonly), {
                bodyHtml: this.props.bodyHtml
            }), this.getCommentContent = ()=>{
            const { bodyAdf: bodyAdf, commentId: commentId, isEditing: isEditing, onEditCancel: onEditCancel, onEditUpdate: onEditUpdate, onEditPaste: onEditPaste, onBlur: onBlur, visibilityEdited: visibilityEdited, onCommentVisibilityChange: onCommentVisibilityChange, shouldShowCommentVisibility: shouldShowCommentVisibility, eventOccurredAt: eventOccurredAt, isEditingInternal: isEditingInternal, projectType: projectType, parentId: parentId, pinnedCommentBodyAdf: pinnedCommentBodyAdf, isPinned: isPinned } = this.props;
            const shouldShowCommentVisibilitySelector = shouldShowCommentVisibility && !parentId; // should not show for replies
            const jsmTimelineComponents = isEditingInternal ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iBYZ7.EventOccurredAtSelector), {
                    key: "eventOccurredAtSelector",
                    initialValue: eventOccurredAt,
                    onChange: (newEventOccurredAt)=>{
                        this.changeEventOccurredAt(newEventOccurredAt);
                    }
                })
            ] : [];
            let secondaryToolbarComponents = shouldShowCommentVisibilitySelector ? [
                ...jsmTimelineComponents,
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88XcY.default), {
                    key: "commentVisibilitySelector",
                    initialValue: visibilityEdited,
                    onChange: onCommentVisibilityChange
                })
            ] : jsmTimelineComponents;
            secondaryToolbarComponents = shouldShowCommentVisibilitySelector && (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) ? this.props.isEditingInternal : true) ? [
                ...jsmTimelineComponents,
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88XcY.default), {
                    key: "commentVisibilitySelector",
                    initialValue: visibilityEdited,
                    onChange: onCommentVisibilityChange
                })
            ] : jsmTimelineComponents;
            let commentContentProps = {
                commentId: commentId,
                isEditing: isEditing,
                secondaryToolbarComponents: secondaryToolbarComponents,
                canEdit: this.props.canEdit,
                onCancel: onEditCancel,
                onChange: onEditUpdate,
                onSave: this.onEditSave,
                onPaste: onEditPaste,
                onBlur: onBlur,
                onHideSave: this.onHideSave
            };
            if ((0, $4R6GH.fg)('change_comment_editorstate_props_to_propdrill')) commentContentProps = {
                ...commentContentProps,
                mentionProvider: this.props.mentionProvider,
                contextIdentifier: this.props.contextIdentifier,
                mediaContext: this.props.mediaContext
            };
            if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6iXgG.default), {
                ...commentContentProps,
                bodyAdf: isPinned ? pinnedCommentBodyAdf : bodyAdf
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
                id: "issue-comment-editor",
                packageName: "issue",
                render: this.renderAdfRendererFallback
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6iXgG.default), {
                ...commentContentProps,
                bodyAdf: isPinned ? pinnedCommentBodyAdf : bodyAdf
            }));
        }, this.getRestrictedTo = (restrictedTo, restrictedToText)=>{
            const { isOptimistic: isOptimistic, isDeleted: isDeleted } = this.props;
            if (isDeleted) return undefined;
            return !isOptimistic ? restrictedTo : restrictedToText;
        }, this.getCommentTime = ()=>{
            const { intl: { formatMessage: formatMessage }, createdDate: createdDate, showAddedCommentDescription: showAddedCommentDescription, showLozenge: showLozenge, eventOccurredAt: eventOccurredAt, isDeleted: isDeleted, commentId: commentId } = this.props;
            if (isDeleted) return undefined;
            const value = eventOccurredAt ? (0, $bMyd4.default)(eventOccurredAt) : createdDate;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showAddedCommentDescription !== undefined && showAddedCommentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$DescriptionAction, {
                "data-testid": "issue-comment-base.ui.comment.action",
                dangerouslySetInnerHTML: {
                    __html: formatMessage((0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $jEjVx.default).addedCommentDescriptionLowercase : (0, $jEjVx.default).addedCommentDescription, undefined, {
                        ignoreTag: true
                    })
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZEN7.default), {
                value: value,
                tooltipPosition: "top",
                extraStyles: (0, $iDRQC.ActivityTimestampStylesControl)
            }), showLozenge !== undefined && showLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), null, formatMessage((0, $jEjVx.default).lozenge))), (this.props.projectType === (0, $2vSU6.SOFTWARE_PROJECT) || this.props.projectType === (0, $2vSU6.CORE_PROJECT)) && this.isUnreadComment() && (0, $6s1PB.expVal)('thor_issue_view_realtime_updates_experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "span",
                ref: this.updateUnreadCommentRef,
                testId: `issue-comment-base.ui.comment.unread.${commentId}`,
                xcss: [
                    $4a7699c30f340a9a$var$unreadCss,
                    this.state.showNewUnreadCommentLozenge && $4a7699c30f340a9a$var$unreadNewBadgeCss
                ]
            }, this.state.showNewUnreadCommentLozenge && formatMessage((0, $jEjVx.default).new)));
        }, this.getCommentEditedToolTip = ()=>{
            const { intl: intl, hasFloatingMenu: hasFloatingMenu, hasDraft: hasDraft } = this.props;
            const editTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $jEjVx.default).editedBy,
                values: {
                    author: this.getAuthorDisplayName(this.props.updateAuthor),
                    timestamp: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZEN7.default), {
                        value: this.props.updatedDate || ''
                    })
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: editTooltip,
                position: "top",
                testId: "issue-comment-base.ui.comment.ak-tool-tip"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i3LhB.default), null, intl.formatMessage((0, $jEjVx.default).edited), hasFloatingMenu && hasDraft && ` (${this.props.intl.formatMessage((0, $75neI.default).draftIndicatorAfterEdited)})`));
        }, this.getFormattedGridContainer = (itemOne, itemTwo)=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$GridContentContainerVisualRefresh, {
                "data-testid": "issue-comment-base.ui.comment.grid-content-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$GridContainer, null, itemOne), itemTwo != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$GridContainer, null, itemTwo) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$GridContentContainer, {
                "data-testid": "issue-comment-base.ui.comment.grid-content-container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$GridContainer, null, itemOne), itemTwo != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$GridContainer, null, itemTwo) : null), this.getPermalinkIcon = (permalink)=>{
            const { commentId: commentId, fullIssueUrl: fullIssueUrl, onCopyClick: onCopyClick, intl: { formatMessage: formatMessage } } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7DhFg.PermalinkButton), {
                id: commentId,
                fullIssueUrl: `${fullIssueUrl}?focusedCommentId=${commentId}`,
                label: formatMessage((0, $jEjVx.default).copy),
                onCopyClick: onCopyClick,
                isVisible: permalink.isVisible
            });
        }, this.renderEditedOld = ()=>this.props.edited ? this.getCommentEditedToolTip() : null, this.renderEditedOldWithOptimistic = (permalink)=>{
            if (this.props.hasFloatingMenu) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.renderEditedOld(), this.getFloatingMenu(this.props.isDeleted, permalink));
            return this.renderEditedOld();
        }, this.getFloatingMenu = (isDeletedComment, permalink)=>{
            const { intl: intl, fullIssueUrl: fullIssueUrl, commentId: commentId, isOptimistic: isOptimistic, isEditing: isEditing, canDelete: canDelete, canEdit: canEdit, onCopyClick: onCopyClick, onClickCreateIssue: onClickCreateIssue, hasSaveFailed: hasSaveFailed, onSaveEdit: onSaveEdit, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const entryPointProps = {
                commentId: commentId,
                eventOccurredAt: this.props.eventOccurredAt,
                jsdIncidentActivityViewHidden: this.props.jsdIncidentActivityViewHidden,
                hasReplies: this.props.hasReplies,
                parentId: this.props.parentId,
                isRealTimeCommentUpdated: this.props.isRealTimeCommentUpdated
            };
            const shouldShowFloatingMenu = permalink.isVisible && !isDeletedComment && !isEditing;
            if (shouldShowFloatingMenu && isOptimistic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdUJF.CommentFloatingMenu), {
                menuItems: (0, $3un1S.getFloatingMenuItemsForOptimisticComment)({
                    formatMessage: intl.formatMessage,
                    hasSaveFailed: hasSaveFailed,
                    onSaveEdit: onSaveEdit
                })
            });
            if (shouldShowFloatingMenu && !isOptimistic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdUJF.CommentFloatingMenu), {
                menuItems: (0, $3un1S.getFloatingMenuItems)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    formatMessage: intl.formatMessage,
                    fullIssueUrl: fullIssueUrl,
                    commentId: commentId,
                    onClickCreateIssue: onClickCreateIssue ? this.onClickCreateIssueButton : undefined,
                    onCopyClick: onCopyClick,
                    onEditClick: this.onEditClick,
                    onDeleteClick: this.onDeleteClick,
                    canDelete: canDelete,
                    canEdit: canEdit,
                    deleteEntryPointProps: entryPointProps,
                    shouldShowCreateButton: this.props.canAdd && this.props.isThreadedCommentsEnabled && this.props.canCreateWorkItemInComment
                })
            });
        }, this.getEditingAndRestrictedTo = (restrictedToText, permalink)=>{
            const { isEditing: isEditing, hasSaveFailed: hasSaveFailed, isOptimistic: isOptimistic, isDeleted: isDeleted, intl: intl, hasFloatingMenu: hasFloatingMenu, hasDraft: hasDraft } = this.props; // if comment is deleted, show only deleted component in edited field
            if (isDeleted) return {
                restrictedTo: null,
                edited: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iyA9O.default), {
                    intl: intl
                })
            };
            const copyIcon = !hasFloatingMenu ? this.getPermalinkIcon(permalink) : null;
            const hasRestrictedToText = restrictedToText.length > 0; // comment being saved and showing save label text
            // return null as otherwise would render the copy icon
            if (isOptimistic && !hasSaveFailed) return {
                restrictedTo: null,
                edited: null
            };
            const restrictedTo = hasRestrictedToText ? this.getFormattedGridContainer(restrictedToText, copyIcon) : null;
            const editedCopyIcon = hasRestrictedToText ? null : copyIcon;
            const editedComment = this.getCommentEditedToolTip(); // don't show copy icon while editing
            if (isEditing) return {
                restrictedTo: null,
                edited: this.props.edited ? editedComment : null
            };
             // if there are 3 things to show (edited, restrictedTo, and copy icon) then the icon will need to be shown in the restrictedTo prop
            if (this.props.edited) return {
                restrictedTo: restrictedTo,
                edited: hasFloatingMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.getFormattedGridContainer(editedComment, editedCopyIcon), this.getFloatingMenu(isDeleted, permalink)) : this.getFormattedGridContainer(editedComment, editedCopyIcon)
            };
            const editedWithFloatingMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i3LhB.default), null, hasDraft && intl.formatMessage((0, $75neI.default).draftIndicator)), this.getFloatingMenu(isDeleted, permalink)); // show copy icon if comment is not an internal comment.
            return {
                restrictedTo: restrictedTo,
                edited: hasFloatingMenu ? editedWithFloatingMenu : editedCopyIcon
            };
        }, this.isRequestParticipant = ()=>this.props.jsdAuthorCanSeeRequest === false, this.getAuthorAdditionalInfo = ()=>{
            if ((0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return this.isRequestParticipant() ? ` ${this.props.intl.formatMessage((0, $jEjVx.default).notRequestParticipant)}` : '';
            return this.isRequestParticipant() ? this.props.intl.formatMessage((0, $jEjVx.default).notRequestParticipant) : '';
        }, this.renderComment = (restrictedToText)=>{
            const { author: author, isOptimistic: isOptimistic, hasSaveFailed: hasSaveFailed, isEditing: isEditing, isHighlighted: isHighlighted, isInternal: isInternal, commentId: commentId, showSmallAvatar: showSmallAvatar, children: children, isReplyingToComment: isReplyingToComment, hasReplies: hasReplies, isDeleted: isDeleted, parentId: parentId, isThreadedCommentsEnabled: isThreadedCommentsEnabled, commentRef: commentRef, hasFloatingMenu: hasFloatingMenu } = this.props;
            const isBusinessOrSoftwareProject = this.props.projectType === (0, $2vSU6.SOFTWARE_PROJECT) || this.props.projectType === (0, $2vSU6.CORE_PROJECT);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aqnOi.default), null, (permalink)=>{
                // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'restrictedTo' implicitly has an 'any' type. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'edited' implicitly has an 'any' type.
                const { restrictedTo: restrictedTo, edited: edited } = !isOptimistic ? this.getEditingAndRestrictedTo(restrictedToText, permalink) : {};
                const shouldHighlightComment = !isInternal && !isEditing && isHighlighted;
                const comment = isBusinessOrSoftwareProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0Rn.default), {
                    ...this.props,
                    isThreadedCommentsEnabled: isThreadedCommentsEnabled,
                    parentId: parentId,
                    authorDisplayName: this.getAuthorDisplayName(author),
                    authorAdditionalInfo: this.getAuthorAdditionalInfo(),
                    commentId: commentId,
                    hasReplies: hasReplies,
                    isReplyingToComment: isReplyingToComment,
                    isDeleted: isDeleted,
                    isOptimistic: isOptimistic,
                    author: author,
                    time: this.getCommentTime(),
                    edited: this.props.edited,
                    shouldHighlightComment: shouldHighlightComment,
                    showSmallAvatar: showSmallAvatar,
                    hasSaveFailed: hasSaveFailed,
                    isEditing: isEditing,
                    content: !isDeleted && (!isEditing && (0, $4R6GH.fg)('thor_ai_definitions_issue_comment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                        ref: commentRef
                    }, this.getCommentContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, this.getCommentContent())),
                    actions: (0, $6s1PB.expVal)('jira_work_item_comment_action_modernisation', 'isEnabled', false) ? this.getCommentActions() : this.getCommentActionsOld(),
                    errorActions: hasFloatingMenu ? this.getCommentSavedWithFloatingMenu() : this.getCommentSaveFailedActions(),
                    hasChildren: !!children,
                    restrictedToText: restrictedToText,
                    showNewUnreadCommentLozenge: this.state.showNewUnreadCommentLozenge,
                    isUnreadComment: this.isUnreadComment(),
                    setUnreadCommentScrollRef: this.updateUnreadCommentRef,
                    createdDate: this.props.createdDate,
                    permalink: permalink,
                    fullIssueUrl: this.props.fullIssueUrl,
                    onCopyClick: this.props.onCopyClick,
                    displayNameForUpdateAuthor: this.getAuthorDisplayName(this.props.updateAuthor),
                    updatedDate: this.props.updatedDate,
                    eventOccurredAt: this.props.eventOccurredAt,
                    floatingMenu: this.getFloatingMenu(isDeleted, permalink),
                    showAddedCommentDescription: this.props.showAddedCommentDescription,
                    showLozenge: this.props.showLozenge,
                    hasFloatingMenu: hasFloatingMenu,
                    projectType: this.props.projectType,
                    hasDraft: this.props.hasDraft,
                    isPinned: this.props.isPinned
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIJnf.default), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kB744.default), {
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$AvatarWrapper, {
                        isThreadedComments: isThreadedCommentsEnabled,
                        showLinesOnRoot: (hasReplies || isReplyingToComment) ?? false,
                        isDeletedComment: isDeleted || false
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5GPI.default), {
                        userAccount: isDeleted ? undefined : author,
                        analyticsData: {
                            trigger: 'comment-avatar'
                        },
                        testId: `issue-comment-base.ui.comment.${commentId}.avatar`,
                        ariaHideProfileTrigger: true,
                        isChildComment: isThreadedCommentsEnabled && !!parentId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        borderColor: "transparent",
                        src: !isDeleted && author && author.avatarUrl || undefined,
                        size: showSmallAvatar ? 'small' : 'medium',
                        imgLoading: (0, $4R6GH.fg)('avatar-lazy-load-iv-llc') ? 'lazy' : undefined
                    }))),
                    author: !isDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5GPI.default), {
                        userAccount: author,
                        analyticsData: {
                            trigger: 'comment-author'
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DgQp.default), null, this.getAuthorDisplayName(author), !(0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "\xa0"), this.getAuthorAdditionalInfo())),
                    time: this.getCommentTime(),
                    edited: !isOptimistic ? edited : this.renderEditedOldWithOptimistic(permalink),
                    content: !isDeleted && (!isEditing && (0, $4R6GH.fg)('thor_ai_definitions_issue_comment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                        ref: commentRef
                    }, this.getCommentContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, this.getCommentContent())),
                    afterContent: // this is a workaround for an issue in @atlaskit/comment where it adds an extra padding even if "children" return null
                    isThreadedCommentsEnabled && !hasReplies && !isReplyingToComment && children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jOvmQ.default), {
                        isHighlighted: shouldHighlightComment
                    }),
                    restrictedTo: this.getRestrictedTo(restrictedTo, restrictedToText),
                    actions: !isDeleted && !isOptimistic && !isEditing ? this.getCommentActionsOld() : [],
                    isError: hasSaveFailed && !isEditing,
                    errorActions: hasFloatingMenu ? this.getCommentSavedWithFloatingMenu() : this.getCommentSaveFailedActions(),
                    isSaving: isOptimistic && !hasSaveFailed,
                    savingText: this.props.intl.formatMessage((0, $jEjVx.default).saving),
                    highlighted: shouldHighlightComment,
                    testId: `issue-comment-base.ui.comment.ak-comment.${commentId}`
                }, isThreadedCommentsEnabled && children);
                return !isOptimistic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$IssueCommentWrapper, {
                    isRootComment: !this.props?.parentId,
                    isContainerOverlapFixEnabled: (0, $6s1PB.expVal)('issue_create_from_comment_experiment', 'hasFloatingMenu', false),
                    isCommentMultiLineDesignEnabled: true,
                    onMouseOver: (e)=>$4a7699c30f340a9a$var$showPermalink(e, permalink),
                    onMouseOut: (e)=>$4a7699c30f340a9a$var$hidePermalink(e, permalink),
                    onFocus: (e)=>$4a7699c30f340a9a$var$showPermalink(e, permalink),
                    onBlur: (e)=>$4a7699c30f340a9a$var$hidePermalink(e, permalink),
                    "data-testid": "issue-comment-base.ui.comment.custom-comment.container"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                    "data-testid": `comment-base-item-${commentId}`,
                    ref: this.setCommentPermalinkContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2HbP2.ModalContextProvider), null, comment))) : this.renderOptimisticComment(comment, permalink);
            });
        }, this.renderOptimisticComment = (comment, permalink)=>{
            if (this.props.hasFloatingMenu && this.props.isThreadedCommentsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$IssueCommentWrapper, {
                isRootComment: !this.props?.parentId,
                isContainerOverlapFixEnabled: (0, $6s1PB.expVal)('issue_create_from_comment_experiment', 'hasFloatingMenu', false),
                isCommentMultiLineDesignEnabled: true,
                onMouseOver: (e)=>$4a7699c30f340a9a$var$showPermalink(e, permalink),
                onMouseOut: (e)=>$4a7699c30f340a9a$var$hidePermalink(e, permalink),
                onFocus: (e)=>$4a7699c30f340a9a$var$showPermalink(e, permalink),
                onBlur: (e)=>$4a7699c30f340a9a$var$hidePermalink(e, permalink),
                "data-testid": "issue-comment-base.ui.comment.custom-comment.container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.setOptimisticCommentPermalinkContainer
            }, comment));
            if (this.props.isThreadedCommentsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a7699c30f340a9a$var$IssueCommentWrapper, {
                isRootComment: !this.props?.parentId,
                isContainerOverlapFixEnabled: (0, $6s1PB.expVal)('issue_create_from_comment_experiment', 'hasFloatingMenu', false),
                isCommentMultiLineDesignEnabled: true // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                ,
                "data-testid": "issue-comment-base.ui.comment.custom-comment.container"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.setOptimisticCommentPermalinkContainer
            }, comment));
            return (0, $4R6GH.fg)('jira_comment_alignment_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $4a7699c30f340a9a$var$optimisticNonThreadedCommentStyles,
                ref: this.setOptimisticCommentPermalinkContainer
            }, comment) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.setOptimisticCommentPermalinkContainer
            }, comment);
        }, this.renderInternalComment = ()=>{
            const { visibility: visibility, intl: intl, isEditing: isEditing, isHighlighted: isHighlighted } = this.props;
            const highlightColor = isHighlighted ? "var(--ds-background-accent-yellow-subtler, #F8E6A0)" : "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
            const restrictedToText = visibility.type === (0, $b276debff3ef22b6$export$a3863626f98a38c2) ? `${intl.formatMessage((0, $jEjVx.default).internalNote)}` : `${visibility.value} \u{2022} ${intl.formatMessage((0, $jEjVx.default).internalNote)}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDRQC.InternalCommentContainer), {
                isEditing: isEditing,
                highlightColor: highlightColor
            }, this.renderComment(restrictedToText));
        }, this.setCommentPermalinkContainer = (container)=>{
            this.commentPermalinkContainer = container;
        }, this.setOptimisticCommentPermalinkContainer = (container)=>{
            this.optimisticCommentContainerRef = container;
        }, this.scrollCommentIntoView = ()=>{
            const { hasScrolledPermalink: hasScrolledPermalink, shouldScrollAfterAsyncComponentsLoaded: shouldScrollAfterAsyncComponentsLoaded, setScrollStatus: setScrollStatus, createAnalyticsEvent: createAnalyticsEvent, commentId: commentId, topMostUnreadCommentId: topMostUnreadCommentId, commentScrollStatusForRealTimeUpdates: commentScrollStatusForRealTimeUpdates, setScrollStatusForRealTimeUpdate: setScrollStatusForRealTimeUpdate } = this.props; // hasScrolledPermalink ensures we only scroll once on initial page load.
            // ensure we don't scroll if we resize after initial load.
            // shouldScrollAfterAsyncComponentsLoaded used to ensure we only scroll when all async data is finished fetching.
            if (!hasScrolledPermalink && shouldScrollAfterAsyncComponentsLoaded) {
                (0, $b8JO7.smoothScrollIntoViewIfNeeded)(this.commentPermalinkContainer, {
                    scrollMode: 'always',
                    behavior: 'smooth'
                });
                setScrollStatus(true);
                const analyticsEvent = createAnalyticsEvent({
                    action: 'scrolled'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'permalink comment', {
                    name: 'comment'
                });
            } // scroll to unread comment during real time updates
            if ((this.props.projectType === (0, $2vSU6.SOFTWARE_PROJECT) || this.props.projectType === (0, $2vSU6.CORE_PROJECT)) && commentScrollStatusForRealTimeUpdates && commentId === topMostUnreadCommentId && this.isUnreadComment() && (0, $6s1PB.expVal)('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)) {
                (0, $b8JO7.smoothScrollIntoViewIfNeeded)(this.unreadCommentRef, {
                    scrollMode: 'always',
                    behavior: 'smooth'
                });
                setScrollStatusForRealTimeUpdate?.(false);
            }
        };
        this.state = {
            tooltipMessage: (0, $jEjVx.default).copyLink,
            isCommentMoreActionMenuOpen: false,
            selectedEventOccurredAt: props.eventOccurredAt,
            showNewUnreadCommentLozenge: !$4a7699c30f340a9a$var$localStorageProvider.get($4a7699c30f340a9a$var$UNREAD_COMMENT_LOZENGE_VIEWED_KEY) && props.commentId === props.topMostUnreadCommentId && !props.isActivityFeedInViewPort
        };
    }
    componentDidMount() {
        const { props: { isOptimistic: isOptimistic, commentId: commentId, createAnalyticsEvent: createAnalyticsEvent, isHighlighted: isHighlighted }, optimisticCommentContainerRef: optimisticCommentContainerRef } = this;
        if (isOptimistic && commentId.includes((0, $7a0695d910e98a34$export$c4134c813c47beb0)) && optimisticCommentContainerRef) (0, $b8JO7.smoothScrollIntoViewIfNeeded)(optimisticCommentContainerRef, {
            scrollMode: 'always',
            behavior: 'smooth'
        });
        if (isHighlighted) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'focussed comment', {
                isParent: this.props?.parentId
            });
            if ((0, $4R6GH.fg)('reply_on_comment_notification_gate')) {
                // check if url params has action=REPLY_TO_COMMENT
                const urlParams = new URLSearchParams(globalThis.window.location.search);
                const isReplyToCommentParamSet = urlParams.get((0, $8cd124aefa461409$export$27f4b9edd0b118b8)) === (0, $8cd124aefa461409$export$65c681ec26344d06);
                const isTarget = (this.props.projectType === (0, $2vSU6.SOFTWARE_PROJECT) || this.props.projectType === (0, $2vSU6.CORE_PROJECT)) && this.props.canAdd && this.props.isThreadedCommentsEnabled;
                if (isReplyToCommentParamSet && !isTarget) {
                    urlParams.delete((0, $8cd124aefa461409$export$27f4b9edd0b118b8));
                    globalThis.window.history.replaceState({}, '', `?${urlParams.toString()}`);
                }
                if (isReplyToCommentParamSet && isTarget && (0, $6s1PB.expVal)('reply_on_comment_notification', 'isEnabled', false)) {
                    this.onReplyClick();
                    urlParams.delete((0, $8cd124aefa461409$export$27f4b9edd0b118b8));
                    globalThis.window.history.replaceState({}, '', `?${urlParams.toString()}`);
                }
            }
        }
        this.scrollCommentIntoView();
    }
    shouldComponentUpdate(nextProps) {
        if (!this.props.shouldScrollAfterAsyncComponentsLoaded && nextProps.shouldScrollAfterAsyncComponentsLoaded || !this.props.hasScrolledPermalink && nextProps.hasScrolledPermalink) {
            const propsWithPermalinkUpdates = {
                ...this.props,
                // make the props equal to preform shallow equal, a different
                // approach to using omit
                shouldScrollAfterAsyncComponentsLoaded: nextProps.shouldScrollAfterAsyncComponentsLoaded,
                hasScrolledPermalink: nextProps.hasScrolledPermalink
            }; // check to see if any other props has changed
            const propsShallowEqual = (0, $6Z846.isShallowEqual)(propsWithPermalinkUpdates, nextProps);
            if (propsShallowEqual) // We only need to need to scroll to comments that are highlighted
            // and have not already scrolled. Which is true when the user
            // views the issue from a permalink. Most cases it will be false
            // so lets stop the re-rendering of comments that aren't highlighted.
            return nextProps.isHighlighted && !nextProps.hasScrolledPermalink;
        }
        return true;
    }
    componentDidUpdate() {
        this.scrollCommentIntoView();
        if ((this.props.projectType === (0, $2vSU6.SOFTWARE_PROJECT) || this.props.projectType === (0, $2vSU6.CORE_PROJECT)) && this.props.isActivityFeedInViewPort && this.state.showNewUnreadCommentLozenge && this.isUnreadComment() && (0, $6s1PB.expVal)('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)) {
            $4a7699c30f340a9a$var$localStorageProvider.set($4a7699c30f340a9a$var$UNREAD_COMMENT_LOZENGE_VIEWED_KEY, true);
            this.unreadCommentLozengeTimeoutId = setTimeout(()=>{
                this.setState({
                    showNewUnreadCommentLozenge: false
                });
            }, 5000);
        }
        if ((this.props.projectType === (0, $2vSU6.SOFTWARE_PROJECT) || this.props.projectType === (0, $2vSU6.CORE_PROJECT)) && this.props.commentId !== this.props.topMostUnreadCommentId && this.state.showNewUnreadCommentLozenge && this.isUnreadComment() && (0, $6s1PB.expVal)('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)) this.setState({
            showNewUnreadCommentLozenge: false
        });
    }
    componentWillUnmount() {
        if (this.unreadCommentLozengeTimeoutId) {
            clearTimeout(this.unreadCommentLozengeTimeoutId);
            this.unreadCommentLozengeTimeoutId = undefined;
        }
    }
    render() {
        const { visibility: visibility, isInternal: isInternal } = this.props;
        if (isInternal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6mahi.ModalContextProvider), null, this.renderInternalComment());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6mahi.ModalContextProvider), null, this.renderComment(visibility.value));
    }
}
const $4a7699c30f340a9a$var$showPermalink = (e, permalink)=>{
    e.stopPropagation();
    permalink.show();
};
const $4a7699c30f340a9a$var$hidePermalink = (e, permalink)=>{
    e.stopPropagation();
    permalink.hide();
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a7699c30f340a9a$var$GridContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7kb7n _18u01b66 _o5721q9c",
            __cmplp.className
        ])
    });
});
$4a7699c30f340a9a$var$GridContainer.displayName = 'GridContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a7699c30f340a9a$var$GridContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a7699c30f340a9a$var$GridContentContainerVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
$4a7699c30f340a9a$var$GridContentContainer.displayName = 'GridContentContainer';
$4a7699c30f340a9a$var$GridContentContainerVisualRefresh.displayName = 'GridContentContainer'; // TODO https://product-fabric.atlassian.net/browse/FS-4202
// Ideally we would style the Reactions component itself, but currently
// AK doesn't allow us to do it. So we're wrapping the component on this div
// and pulling it to the left as much as we can without covering the item separator (".")
// we're also giving it a specific height so the item separator will be properly aligned.
const $4a7699c30f340a9a$var$AvatarWrapper = ({ showLinesOnRoot: showLinesOnRoot, children: children, isThreadedComments: isThreadedComments, isDeletedComment: isDeletedComment })=>{
    if (isThreadedComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1hjgt94y _161e1v33 _4t3i1osq",
            showLinesOnRoot && "_1kt9b3bt _1cs8stnw _z5wtgm6u _19woze3t _1mp4qk1p _1aukdrbf _1rus1qe4",
            showLinesOnRoot && "_1auklpf4",
            isDeletedComment && "_otyrutpp"
        ])
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $4a7699c30f340a9a$var$deletedCommentStyles = null;
const $4a7699c30f340a9a$var$profileCardWrapperStyles = null;
const $4a7699c30f340a9a$var$rootCommentStyles = null;
const $4a7699c30f340a9a$var$rootCommentStylesOverride = null;
const $4a7699c30f340a9a$var$optimisticNonThreadedCommentStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});
const $4a7699c30f340a9a$var$reactionsContainerStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a7699c30f340a9a$var$CommentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _kth9idpf _19ysidpf _1trxidpf _1djhidpf _18pzidpf _982hidpf _10nsidpf _1lhcidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a7699c30f340a9a$var$CommentWrapperVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRootComment: isRootComment, isContainerOverlapFixEnabled: isContainerOverlapFixEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            !__cmplp && "_otyru2gc",
            __cmplp.isRootComment && "_2hwxu2gc _18u0u2gc _kth9idpf _19ysidpf _1trxidpf _1djhidpf _18pzidpf _982hidpf _10nsidpf _1lhcidpf",
            __cmplp.isRootComment && __cmplp.isContainerOverlapFixEnabled && "_19pkv47k",
            __cmplp.className
        ])
    });
});
const $4a7699c30f340a9a$var$IssueCommentWrapper = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), $4a7699c30f340a9a$var$CommentWrapperVisualRefresh, $4a7699c30f340a9a$var$CommentWrapper); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a7699c30f340a9a$var$LozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _18u0utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a7699c30f340a9a$var$DescriptionAction = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _18u0r5cr _2hwxu2gc _18t31wq8",
            __cmplp.className
        ])
    });
});
const $4a7699c30f340a9a$var$unreadCss = (0, $8CUq3.xcss)({
    height: "var(--ds-space-075, 6px)",
    width: "var(--ds-space-075, 6px)",
    borderRadius: 'border.radius.circle',
    backgroundColor: 'color.background.accent.blue.bolder',
    transition: 'all 0.2s ease-in-out'
});
const $4a7699c30f340a9a$var$unreadNewBadgeCss = (0, $8CUq3.xcss)({
    textAlign: 'center',
    font: 'font.body.small',
    color: 'color.text.inverse',
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.200'
});
const $4a7699c30f340a9a$var$commentActionButtonStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    position: 'relative',
    background: 'none',
    borderRadius: 'border.radius',
    marginLeft: 'space.negative.050',
    marginBottom: 'space.050',
    paddingBlockEnd: 'space.025',
    paddingInlineStart: 'space.050',
    paddingInlineEnd: 'space.050',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});

});
parcelRegister("2kKir", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1016f496401ee1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $fVnbM = parcelRequire("fVnbM");
const $0d1016f496401ee1$var$ActionItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver, isDisabled: isDisabled }, ref)=>{
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAction',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to add support for analytics instead of creating an inaccessible
     * custom element, we can add role="presentation" so that there are no negative
     * impacts to assistive technologies.
     */ // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
            ref: ref,
            appearance: "subtle-link",
            spacing: "none",
            type: "button",
            isDisabled: isDisabled,
            children: children
        })
    }));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0d1016f496401ee1$export$2e2bcd8739ae039 = $0d1016f496401ee1$var$ActionItem;

});

parcelRegister("9DgQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4acc0087bf83024c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $lF5mE = parcelRequire("lF5mE");
const $4acc0087bf83024c$var$Author = ({ children: children, href: href, onClick: providedOnClick, onFocus: onFocus, onMouseOver: onMouseOver })=>{
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>providedOnClick && providedOnClick(event, analyticsEvent),
        action: 'clicked',
        componentName: 'commentAuthor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lF5mE.default), {
        hasAuthor: true,
        href: href,
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        children: children
    });
};
$4acc0087bf83024c$var$Author.displayName = 'CommentAuthor';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4acc0087bf83024c$export$2e2bcd8739ae039 = $4acc0087bf83024c$var$Author;

});
parcelRegister("lF5mE", function(module, exports) {

$parcel$export(module.exports, "default", () => $34e78094d090f875$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $5McnS = parcelRequire("5McnS");
const $34e78094d090f875$var$textStyles = {
    root: "_syaz1gjq"
};
const $34e78094d090f875$var$anchorStyles = {
    root: "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _1nrm18uv _c2waglyw _1iohnqa1 _9h8h16c2"
};
const $34e78094d090f875$var$noAuthorStyles = {
    root: "_k48p1kw7"
};
const $34e78094d090f875$var$hasAuthorStyles = {
    root: "_k48p1wq8"
};
/**
 * __Field__
 *
 * A field appears in the comment header to add metadata to the comment.
 *
 * @internal
 */ const $34e78094d090f875$var$Field = ({ children: children, hasAuthor: hasAuthor, href: href, onClick: onClick, onFocus: onFocus, onMouseOver: onMouseOver, testId: testId })=>{
    return href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
        href: href,
        xcss: (0, $3JT92.cx)($34e78094d090f875$var$textStyles.root, $34e78094d090f875$var$anchorStyles.root, hasAuthor ? $34e78094d090f875$var$hasAuthorStyles.root : $34e78094d090f875$var$noAuthorStyles.root),
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        /**
   * It is not normally acceptable to add key handlers to non-interactive elements
   * as this is an accessibility anti-pattern. However, because this instance is
   * to add support for analytics instead of creating an inaccessible
   * custom element, we can add role="presentation" so that there are no negative
   * impacts to assistive technologies.
   */ role: "presentation",
        onClick: onClick,
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $34e78094d090f875$var$textStyles.root,
            hasAuthor ? $34e78094d090f875$var$hasAuthorStyles.root : $34e78094d090f875$var$noAuthorStyles.root
        ]),
        children: children
    });
};
var $34e78094d090f875$export$2e2bcd8739ae039 = $34e78094d090f875$var$Field;

});


parcelRegister("i3LhB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4213033a8e5e013$export$2e2bcd8739ae039);
/* edited.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $a4213033a8e5e013$var$editedContentStyles = {
    root: "_syaz1wmz"
};
const $a4213033a8e5e013$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $bwpsq.default)([
            $a4213033a8e5e013$var$editedContentStyles.root
        ]),
        children: children
    });
$a4213033a8e5e013$var$Edited.displayName = 'Edited';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a4213033a8e5e013$export$2e2bcd8739ae039 = $a4213033a8e5e013$var$Edited;

});

parcelRegister("kB744", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e100742c3cb953$export$2e2bcd8739ae039);
/* comment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $7A6oH = parcelRequire("7A6oH");

var $hwDAP = parcelRequire("hwDAP");

var $apq0k = parcelRequire("apq0k");
const $d0e100742c3cb953$var$textStyles = {
    root: "_syaz1fxt",
    disabled: "_syaz1lh4"
};
/**
 * __Comment__
 *
 * Comments enable discussions on an entity such as a page, blog post, work item, or pull request.
 */ const $d0e100742c3cb953$var$Comment = ({ actions: actions = [], restrictedTo: restrictedTo = '', highlighted: highlighted = false, isSaving: isSaving = false, savingText: savingText = 'Sending...', isError: isError = false, errorActions: errorActions = [], errorIconLabel: errorIconLabel = '', author: author, avatar: avatar, children: children, content: content, edited: edited, time: time, type: type, testId: testId, id: id, afterContent: afterContent, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const headerProps = {
        author: author,
        edited: edited,
        isError: isError,
        isSaving: isSaving,
        restrictedTo: restrictedTo,
        savingText: savingText,
        time: time,
        type: type,
        headingLevel: headingLevel,
        shouldHeaderWrap: shouldHeaderWrap
    };
    const footerProps = {
        actions: actions,
        errorActions: errorActions,
        errorIconLabel: errorIconLabel,
        isError: isError,
        isSaving: isSaving
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $apq0k.default), {
        testId: testId,
        shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline,
        id: id,
        avatar: avatar,
        content: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
            space: "space.075",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hwDAP.default), {
                            testId: testId && `${testId}-header`,
                            ...headerProps
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            testId: testId && `${testId}-content`,
                            xcss: (0, $3JT92.cx)($d0e100742c3cb953$var$textStyles.root, (isSaving || isError) && $d0e100742c3cb953$var$textStyles.disabled),
                            children: content
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7A6oH.default), {
                    testId: testId && `${testId}-footer`,
                    ...footerProps
                }),
                afterContent
            ]
        }),
        highlighted: highlighted,
        children: children
    });
};
$d0e100742c3cb953$var$Comment.displayName = 'Comment';
var $d0e100742c3cb953$export$2e2bcd8739ae039 = $d0e100742c3cb953$var$Comment;

});
parcelRegister("7A6oH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7687d7e33a960b9e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $f5TWP = parcelRequire("f5TWP");

/**
 * __Footer items__
 *
 * The footer items in the comment. Usually reserved for error messages.
 *
 * @internal
 */ const $7687d7e33a960b9e$var$Footer = ({ actions: actions = [], errorActions: errorActions = [], errorIconLabel: errorIconLabel, isError: isError, isSaving: isSaving, testId: testId })=>{
    if (isSaving || !(actions.length || errorActions.length)) return null;
    const items = isError ? errorActions : actions;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
        alignBlock: "center",
        shouldWrap: true,
        testId: testId,
        space: "space.100",
        separator: "\xb7",
        children: [
            isError && /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                spacing: "spacious",
                color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`,
                label: errorIconLabel ? errorIconLabel : ''
            }),
            items.map((item, key)=>Object.assign({}, item, {
                    key: key
                }))
        ]
    });
};
$7687d7e33a960b9e$var$Footer.displayName = 'CommentFooter';
var $7687d7e33a960b9e$export$2e2bcd8739ae039 = $7687d7e33a960b9e$var$Footer;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("hwDAP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab92f3409e0ce38e$export$2e2bcd8739ae039);
/* header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bwyQI = parcelRequire("bwyQI");

var $gs7PQ = parcelRequire("gs7PQ");

var $aYAc3 = parcelRequire("aYAc3");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $dS3PR = parcelRequire("dS3PR");
const $ab92f3409e0ce38e$var$headingStyles = {
    root: "_11c82smr"
};
const $ab92f3409e0ce38e$var$iconWrapperStyles = {
    root: "_18zrv77o _1e0c1txw"
};
/**
 * __Header items__
 *
 * Comment header items.
 *
 * @internal
 */ const $ab92f3409e0ce38e$var$Header = ({ author: author, edited: edited, isError: isError, isSaving: isSaving, restrictedTo: restrictedTo, savingText: savingText, time: time, testId: testId, type: type, headingLevel: headingLevel = '3', shouldHeaderWrap: shouldHeaderWrap })=>{
    const Heading = `h${headingLevel}`;
    const shouldRender = author || time || restrictedTo || isSaving && savingText || edited || type;
    return shouldRender ? /*#__PURE__*/ (0, $2OMIu.jsx)(Heading, {
        className: (0, $bwpsq.default)([
            $ab92f3409e0ce38e$var$headingStyles.root
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            alignBlock: "center",
            testId: testId,
            space: "space.100",
            as: "span",
            shouldWrap: (0, $VSDnB.fg)('platform-comment-header-wrap') && shouldHeaderWrap,
            children: [
                author,
                type && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aYAc3.default), {
                    testId: testId && `${testId}-type`,
                    children: type
                }),
                time && !isSaving && !isError && time,
                edited || null,
                isSaving ? savingText : null,
                restrictedTo && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                        alignBlock: "center",
                        space: "space.050",
                        as: "span",
                        children: [
                            "\u2022",
                            (0, $VSDnB.fg)('platform-visual-refresh-icons-legacy-facade') || (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                as: "span",
                                xcss: $ab92f3409e0ce38e$var$iconWrapperStyles.root,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
                                    color: "currentColor",
                                    label: "",
                                    size: "small"
                                })
                            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gs7PQ))), {
                                size: "small",
                                label: ""
                            }),
                            restrictedTo
                        ]
                    })
                })
            ]
        })
    }) : null;
};
$ab92f3409e0ce38e$var$Header.displayName = 'CommentHeader';
var $ab92f3409e0ce38e$export$2e2bcd8739ae039 = $ab92f3409e0ce38e$var$Header;

});

parcelRegister("apq0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $3524187037de8a98$export$2e2bcd8739ae039);
/* layout.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
var $joKkQ = parcelRequire("joKkQ");
var $414Wj = parcelRequire("414Wj");

var $8KZoD = parcelRequire("8KZoD");

var $dwJ1r = parcelRequire("dwJ1r");
const $3524187037de8a98$var$containerStyles = {
    root: "_kqswh2mm _yv0e5bpd _1lmc1gx3"
};
const $3524187037de8a98$var$inlineCommentStyles = {
    root: "_1lmc1rav"
};
const $3524187037de8a98$var$noChildrenStyles = {
    root: "_1lmcvpz5"
};
// if the background is appied on Box and tokens are not switched on it breaks.
// This can be safely removed (and applied on Box) when tokens are on by default
const $3524187037de8a98$var$highlightOverlayStyles = {
    root: "_1r04x0bf _nd5l1sux _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _kqswstnw _lcxvglyw"
};
const $3524187037de8a98$var$stackOverrideStyles = {
    root: "_nd5l1dav _1q511ejb"
};
/**
 * __CommentLayout__
 *
 * The base layout for the comment component.
 *
 */ const $3524187037de8a98$var$Layout = ({ content: content, children: children, highlighted: highlighted, id: id, shouldRenderNestedCommentsInline: shouldRenderNestedCommentsInline, testId: testId, avatar: avatar })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $joKkQ.default), {
        gap: "space.100",
        xcss: (0, $3JT92.cx)($3524187037de8a98$var$containerStyles.root, shouldRenderNestedCommentsInline && $3524187037de8a98$var$inlineCommentStyles.root, !children && $3524187037de8a98$var$noChildrenStyles.root),
        testId: testId,
        id: id,
        children: [
            avatar && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8KZoD.default), {
                children: avatar
            }),
            content && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dwJ1r.default), {
                children: content
            }),
            children && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
                xcss: $3524187037de8a98$var$stackOverrideStyles.root,
                space: "space.400",
                children: children
            }),
            highlighted && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $3524187037de8a98$var$highlightOverlayStyles.root,
                backgroundColor: "color.background.neutral",
                testId: testId && `${testId}-highlighted`
            })
        ]
    });
$3524187037de8a98$var$Layout.displayName = 'CommentLayout';
var $3524187037de8a98$export$2e2bcd8739ae039 = $3524187037de8a98$var$Layout;

});
parcelRegister("8KZoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $18163810ef634ca5$export$2e2bcd8739ae039);
/* avatar-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $18163810ef634ca5$var$avatarSectionStyles = {
    root: "_nd5l1ofd"
};
/**
 * __Avatar slot is used to nest an avatar in a comment__
 *
 * The avatar slot is used to nest an avatar in a comment's layout.
 *
 */ const $18163810ef634ca5$var$AvatarSlot = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $18163810ef634ca5$var$avatarSectionStyles.root,
        children: children
    });
var $18163810ef634ca5$export$2e2bcd8739ae039 = $18163810ef634ca5$var$AvatarSlot;

});

parcelRegister("dwJ1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $4332109108529f83$export$2e2bcd8739ae039);
/* content-slot.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $4332109108529f83$var$contentSlotStyles = {
    root: "_nd5l8niw _1ul9idpf _1q51v77o _slp31hna"
};
/**
 * __ContentSlot__
 *
 * The content slot is used to nest content in a comment's layout. It should be used inside a CommentLayout.
 *
 */ const $4332109108529f83$var$ContentSlot = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $4332109108529f83$var$contentSlotStyles.root
        ]),
        children: children
    });
var $4332109108529f83$export$2e2bcd8739ae039 = $4332109108529f83$var$ContentSlot;

});



parcelRegister("7O2cr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f8edb6727fde4af1134d5ff170a3316>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5aeee8b8f2cc5620$var$_react = $5aeee8b8f2cc5620$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5aeee8b8f2cc5620$var$_baseNew = $5aeee8b8f2cc5620$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5aeee8b8f2cc5620$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ReplyLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: replying to a message thread
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5aeee8b8f2cc5620$var$ReplyLeftIcon = (props)=>/*#__PURE__*/ $5aeee8b8f2cc5620$var$_react.default.createElement($5aeee8b8f2cc5620$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 5.72 4.5-4.5 1.06 1.06L2.56 5.5H7a8 8 0 0 1 8 8v.5h-1.5v-.5A6.5 6.5 0 0 0 7 7H2.56l3.22 3.22-1.06 1.06-4.5-4.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$5aeee8b8f2cc5620$var$ReplyLeftIcon.displayName = 'ReplyLeftIcon';
var $5aeee8b8f2cc5620$var$_default = module.exports.default = $5aeee8b8f2cc5620$var$ReplyLeftIcon;

});

const $8cd124aefa461409$export$27f4b9edd0b118b8 = 'action';
const $8cd124aefa461409$export$65c681ec26344d06 = 'REPLY_TO_COMMENT';

parcelRegister("aqnOi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce6d97225cb56de2$export$2e2bcd8739ae039);

var $kaJy2 = parcelRequire("kaJy2");
// Expose the useVisibility hook's functionality in the form of a provider for class components
const $ce6d97225cb56de2$var$Provider = (props)=>{
    const [isVisible, show, hide] = (0, $kaJy2.default)(props.defaultIsVisible);
    return props.children({
        isVisible: isVisible,
        show: show,
        hide: hide
    });
};
$ce6d97225cb56de2$var$Provider.defaultProps = {
    defaultIsVisible: false
};
var $ce6d97225cb56de2$export$2e2bcd8739ae039 = $ce6d97225cb56de2$var$Provider;

});
parcelRegister("kaJy2", function(module, exports) {

$parcel$export(module.exports, "default", () => $231f6f0701d542c7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$231f6f0701d542c7$export$2e2bcd8739ae039 = (defaultIsVisible = false)=>{
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(defaultIsVisible);
    const show = ()=>{
        setIsVisible(true);
    };
    const hide = ()=>{
        setIsVisible(false);
    };
    return [
        isVisible,
        show,
        hide
    ];
};

});


const $7a0695d910e98a34$export$c4134c813c47beb0 = 'NEW_OPTIMISTIC_COMMENT';
const $7a0695d910e98a34$export$56251dcfec1ad08d = 'NEW_OPTIMISTIC_COMMENT_REPLY';

parcelRegister("7p8Xy", function(module, exports) {

$parcel$export(module.exports, "isJsmLoomExperimentEnabled", () => $c6f46fb6614e6080$export$88d0b9661263edc1);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");
const $c6f46fb6614e6080$export$88d0b9661263edc1 = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [configLoomJSM] = (0, $6s1PB.UNSAFE_noExposureExp)('loom_jsm_agent_response_touchpoint');
    const cohort = configLoomJSM.get('cohort', 'not-enrolled');
    // Adding feature gate check as loom_jsm_agent_response_touchpoint experiment is running in production.
    const enabled = (cohort === 'control' || cohort === 'variation') && (0, $4R6GH.fg)('loom_jsm_experiment_controller');
    return {
        enabled: enabled,
        cohort: cohort
    };
};

});

parcelRegister("jEjVx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c38b471ac63a7f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c3c38b471ac63a7f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editedBy: {
        "id": "issue-comment-base.comment.edited-by",
        "defaultMessage": "{timestamp} by {author}"
    },
    anonymous: {
        "id": "issue-comment-base.comment.anonymous",
        "defaultMessage": "Anonymous"
    },
    edit: {
        "id": "issue-comment-base.comment.edit",
        "defaultMessage": "Edit"
    },
    disabledEditTooltip: {
        "id": "issue-comment-base.comment.disabled-edit-tooltip.non-final",
        "defaultMessage": "View thread in Slack"
    },
    disabledDeleteTooltip: {
        "id": "issue-comment-base.comment.disabled-delete-tooltip.non-final",
        "defaultMessage": "View thread in Slack"
    },
    create: {
        "id": "issue-comment-base.comment.create",
        "defaultMessage": "Create"
    },
    createdIssue: {
        "id": "issue-comment-base.comment.created-issue",
        "defaultMessage": "I have created a work item from your comment"
    },
    createdIssueBySelf: {
        "id": "issue-comment-base.comment.created-issue-by-self",
        "defaultMessage": "I have created a work item from my comment"
    },
    new: {
        "id": "issue-comment-base.comment.new",
        "defaultMessage": "New"
    },
    hide: {
        "id": "issue-comment-base.comment.hide",
        "defaultMessage": "Hide"
    },
    unhide: {
        "id": "issue-comment-base.comment.unhide",
        "defaultMessage": "Unhide"
    },
    delete: {
        "id": "issue-comment-base.comment.delete",
        "defaultMessage": "Delete"
    },
    commentDeleted: {
        "id": "issue-comment-base.comment.comment-deleted",
        "defaultMessage": "Comment deleted"
    },
    edited: {
        "id": "issue-comment-base.comment.edited",
        "defaultMessage": "Edited"
    },
    retrySave: {
        "id": "issue-comment-base.comment.retry-save",
        "defaultMessage": "Retry"
    },
    cancelSave: {
        "id": "issue-comment-base.comment.cancel-save",
        "defaultMessage": "Cancel"
    },
    saving: {
        "id": "issue-comment-base.comment.saving",
        "defaultMessage": "Saving..."
    },
    internalNote: {
        "id": "issue-comment-base.comment.internal-note",
        "defaultMessage": "Internal note"
    },
    copy: {
        "id": "issue-comment-base.comment.copy",
        "defaultMessage": "Copy link to comment"
    },
    createWorkItem: {
        "id": "issue-comment-base.comment.create-work-item",
        "defaultMessage": "Create work item"
    },
    lozenge: {
        "id": "issue-comment-base.comment.lozenge",
        "defaultMessage": "Comments"
    },
    addedCommentDescription: {
        "id": "issue-comment-base.comment.added-comment-description",
        "defaultMessage": "added a <span>Comment</span>"
    },
    addedCommentDescriptionLowercase: {
        "id": "issue-comment-base.comment.added-comment-description-lowercase",
        "defaultMessage": "added a <span>comment</span>"
    },
    notRequestParticipant: {
        "id": "issue-comment-base.comment.not-request-participant",
        "defaultMessage": "(not a request participant)"
    },
    comment: {
        "id": "issue-comment-base.comment.comment",
        "defaultMessage": "Comment"
    },
    reply: {
        "id": "issue-comment-base.comment.reply",
        "defaultMessage": "Reply"
    },
    copyLink: {
        "id": "issue-comment-base.comment.copy-link",
        "defaultMessage": "Copy link"
    },
    moreActions: {
        "id": "issue-comment-base.comment.more-actions",
        "defaultMessage": "More actions"
    },
    linkCopied: {
        "id": "issue-comment-base.comment.link-copied",
        "defaultMessage": "Link copied"
    },
    viaSlack: {
        "id": "issue-comment-base.comment.via-slack",
        "defaultMessage": "via Slack"
    },
    viaSlackTooltip: {
        "id": "issue-comment-base.comment.via-slack-tooltip",
        "defaultMessage": "View thread in Slack"
    },
    slackFlagTitle: {
        "id": "issue-comment-base.comment.slack-flag-title.non-final",
        "defaultMessage": "You\u2019re posting in a synced thread"
    },
    slackFlagBody: {
        "id": "issue-comment-base.comment.slack-flag-body.non-final",
        "defaultMessage": "By posting this comment here in Jira, you will also be posting it in slack."
    },
    slackFlagBtn: {
        "id": "issue-comment-base.comment.slack-flag-btn.non-final",
        "defaultMessage": "Understood"
    },
    pinComment: {
        "id": "issue-comment-base.comment.pin-comment",
        "defaultMessage": "Pin comment"
    },
    unpinComment: {
        "id": "issue-comment-base.comment.unpin-comment",
        "defaultMessage": "Unpin comment"
    },
    scrollToComment: {
        "id": "issue-comment-base.comment.navigate-to-comment",
        "defaultMessage": "Navigate to comment"
    }
});

});

parcelRegister("jOvmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $616fd428c3473118$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $616fd428c3473118$var$CommentAfterContent = ({ isHighlighted: isHighlighted })=>{
    // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        style: {
            marginTop: '-38px'
        }
    }, isHighlighted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $616fd428c3473118$var$styles
    }));
};
var $616fd428c3473118$export$2e2bcd8739ae039 = $616fd428c3473118$var$CommentAfterContent;
const $616fd428c3473118$var$styles = (0, $8CUq3.xcss)({
    position: 'absolute',
    backgroundColor: 'color.background.neutral',
    pointerEvents: 'none',
    bottom: 'space.negative.100',
    right: 'space.negative.100',
    left: 'space.negative.100',
    height: 'size.300'
});

});

parcelRegister("iyA9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e526e48ed8b730a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i3LhB = parcelRequire("i3LhB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jEjVx = parcelRequire("jEjVx");
const $1e526e48ed8b730a$var$CommentDeleted = ({ intl: intl })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1e526e48ed8b730a$var$commentDeletedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i3LhB.default), null, intl.formatMessage((0, $jEjVx.default).commentDeleted)));
};
const $1e526e48ed8b730a$var$commentDeletedStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.075'
});
var $1e526e48ed8b730a$export$2e2bcd8739ae039 = $1e526e48ed8b730a$var$CommentDeleted;

});

parcelRegister("kOHWv", function(module, exports) {

$parcel$export(module.exports, "IssueCommentReactionsBoundary", () => $ef3d5e51a7c6c06e$export$e1ee03717a519cb5);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");
const $ef3d5e51a7c6c06e$export$e1ee03717a519cb5 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-comment-reactions",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-comment-reactions-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("awxly", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad0f4be86044b79d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3GQ1w = parcelRequire("3GQ1w");

var $cSD7y = parcelRequire("cSD7y");

var $2xRn9 = parcelRequire("2xRn9");

var $82tv3 = parcelRequire("82tv3");
const $ad0f4be86044b79d$var$ConnectedCommentReactionsOld = /*#__PURE__*/ (0, $5uXOq.memo)(({ showQuickReactions: showQuickReactions, onReactionSuccess: onReactionSuccess })=>{
    const [{ issueAri: issueAri, commentAri: commentAri }] = (0, $2xRn9.useContextStateIssueAri)();
    const [{ isActive: isActive }] = (0, $2xRn9.useReactionsStateIsActive)();
    const props = (0, $5uXOq.useMemo)(()=>({
            visible: isActive,
            issueAri: issueAri,
            commentAri: commentAri,
            showQuickReactions: showQuickReactions,
            onReactionSuccess: onReactionSuccess
        }), [
        isActive,
        issueAri,
        commentAri,
        showQuickReactions,
        onReactionSuccess
    ]);
    const MemoizedCommentReactions = /*#__PURE__*/ (0, $5uXOq.memo)((0, $82tv3.CommentReactions));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MemoizedCommentReactions, props);
});
const $ad0f4be86044b79d$var$ConnectedCommentReactions = /*#__PURE__*/ (0, $5uXOq.memo)(({ showQuickReactions: showQuickReactions, onReactionSuccess: onReactionSuccess, commentId: commentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3GQ1w.default), {
        commentId: commentId,
        showQuickReactions: showQuickReactions,
        onReactionSuccess: onReactionSuccess
    });
});
var $ad0f4be86044b79d$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('improve_issue_view_comment_reaction_buttons', $ad0f4be86044b79d$var$ConnectedCommentReactions, $ad0f4be86044b79d$var$ConnectedCommentReactionsOld);

});
parcelRegister("3GQ1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $345f4461e5d9e9f5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $2NMNM = parcelRequire("2NMNM");

var $lvAdf = parcelRequire("lvAdf");
var $a81KM = parcelRequire("a81KM");

var $8AQ0R = parcelRequire("8AQ0R");

var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $jL9KB = parcelRequire("jL9KB");

var $hXRXz = parcelRequire("hXRXz");

var $g9XSY = parcelRequire("g9XSY");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $hxqfC = parcelRequire("hxqfC");

var $cEbDs = parcelRequire("cEbDs");

var $8zOmE = parcelRequire("8zOmE");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $7XYc4 = parcelRequire("7XYc4");

var $cSD7y = parcelRequire("cSD7y");

var $6s1PB = parcelRequire("6s1PB");

var $9pF5v = parcelRequire("9pF5v");

var $fKtck = parcelRequire("fKtck");

var $fNobW = parcelRequire("fNobW");

var $dCm1o = parcelRequire("dCm1o");

var $9AfTz = parcelRequire("9AfTz");

var $bsdOm = parcelRequire("bsdOm");

var $bcoYn = parcelRequire("bcoYn");

var $d6UIQ = parcelRequire("d6UIQ");

var $9C9hZ = parcelRequire("9C9hZ");
// memoize reaction store so it can store all reaction data from issue view comments
const $345f4461e5d9e9f5$var$memoizedStoreFactory = (0, $8QpSo.default)((0, $g9XSY.store));
function $345f4461e5d9e9f5$var$EmojiProviderUFOLoadHold({ emojiProvider: emojiProvider }) {
    const [emojiProviderInitialising, setEmojiProviderInitialising] = (0, $5uXOq.useState)(true);
    (0, $5uXOq.useEffect)(()=>{
        emojiProvider?.finally(()=>setEmojiProviderInitialising(false));
    }, [
        emojiProvider
    ]);
    return emojiProviderInitialising ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "reactions-view-emoji-provider"
    }) : null;
}
const $345f4461e5d9e9f5$export$c45f4b0846a2ffc5 = ({ containerAri: containerAri = '', objectAri: objectAri = '', reactionsStore: reactionsStoreProp, showReactions: showReactions, showQuickReactions: showQuickReactions, isRealTimeCommentUpdated: isRealTimeCommentUpdated, onReactionSuccess: onReactionSuccess })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isReactionAlreadyPresent, setIsReactionAlreadyPresent] = (0, $5uXOq.useState)(false);
    const [isReady, setIsReady] = (0, $5uXOq.useState)(false);
    const loggedInUserAccountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isSoftwareProject = (0, $bsdOm.useIsSoftwareIssue)();
    const isBusinessProject = (0, $bsdOm.useIsBusinessIssue)();
    const reactionsStore = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('batch-reactions-iv-llc-comments')) return reactionsStoreProp ?? $345f4461e5d9e9f5$var$memoizedStoreFactory();
        return reactionsStoreProp ?? (0, $g9XSY.store)();
    }, [
        reactionsStoreProp
    ]);
    const checkReactionsState = (0, $5uXOq.useCallback)(()=>{
        const reactionsState = reactionsStore.getState().reactions[`${containerAri}|${objectAri}`];
        setIsReady(reactionsState?.status === 'READY');
        setIsReactionAlreadyPresent(reactionsState?.status === 'READY' ? reactionsState.reactions.length > 0 : false);
    }, [
        containerAri,
        objectAri,
        reactionsStore
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Register the callback
        reactionsStore.onChange(checkReactionsState);
        // Initial check when the component mounts
        checkReactionsState();
        // Cleanup on unmount
        return ()=>{
            reactionsStore.removeOnChangeListener(checkReactionsState);
        };
    }, [
        checkReactionsState,
        reactionsStore
    ]);
    const isModernReactionsEnabled = (0, $5uXOq.useMemo)(()=>{
        return (isSoftwareProject || isBusinessProject) && (0, $6s1PB.expVal)('jira_work_item_comment_action_modernisation', 'isEnabled', false);
    }, [
        isSoftwareProject,
        isBusinessProject
    ]);
    const emojiProvider = (0, $5uXOq.useMemo)(()=>(0, $4R6GH.fg)('improve_issue_comment_reaction_emoji_provider') ? (0, $hXRXz.getEmojiProviderWithCustomEmoji)(cloudId, loggedInUserAccountId, false) : (0, $hXRXz.getEmojiProviderWithCustomEmojiUploadDisabled)(cloudId, loggedInUserAccountId, false), [
        cloudId,
        loggedInUserAccountId
    ]);
    const reactionSuccessEvent = (0, $5uXOq.useCallback)((action, commentAri, emojiId, reactionsCount, isDefault = false)=>{
        const reactionCountHierarchy = reactionsCount > 1 ? 1 : 0;
        const commentId = (0, $jL9KB.JiraCommentAri).parse(commentAri).resourceId;
        const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $fKtck.getPermalinkStatus)((0, $9pF5v.COMMENTS));
        if ((0, $4R6GH.fg)('thor-experiment-surface-reaction-comment-analytics')) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `reaction ${action}`, emojiId, {
            ...action === (0, $a81KM.ReactionUpdateType).added && {
                reactionCountHierarchy: reactionCountHierarchy
            },
            commentId: commentId,
            isFocusedComment: hasPermalink && commentId === permalinkId,
            isDefaultReaction: isDefault,
            isRealTimeCommentUpdated: isRealTimeCommentUpdated
        });
        else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `reaction ${action}`, emojiId, {
            ...action === (0, $a81KM.ReactionUpdateType).added && {
                reactionCountHierarchy: reactionCountHierarchy
            },
            commentId: commentId,
            isRealTimeCommentUpdated: isRealTimeCommentUpdated
        });
        onReactionSuccess?.(commentId);
    }, [
        createAnalyticsEvent,
        isRealTimeCommentUpdated,
        onReactionSuccess
    ]);
    const addThumbsUpReaction = (0, $5uXOq.useCallback)(()=>{
        reactionsStore.addReaction(containerAri, objectAri, (0, $d6UIQ.thumbsUpEmojiId), (action, commentAri, emojiId, reactionsCount)=>{
            reactionSuccessEvent(action, commentAri, emojiId, reactionsCount, true);
        });
    }, [
        containerAri,
        objectAri,
        reactionSuccessEvent,
        reactionsStore
    ]);
    if (!showReactions || !reactionsStore || !emojiProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jiv_vc_blindspot_fixes') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345f4461e5d9e9f5$var$EmojiProviderUFOLoadHold, {
        emojiProvider: emojiProvider
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: isModernReactionsEnabled ? 'space.100' : 'space.050',
        shouldWrap: true
    }, !isReactionAlreadyPresent && !showQuickReactions && isModernReactionsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $9C9hZ.default).thumbsUp)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        testId: "issue.component.reactions.thumbs-up-button",
        onClick: addThumbsUpReaction,
        xcss: [
            $345f4461e5d9e9f5$var$reactionStylesModernisation,
            !isReady && $345f4461e5d9e9f5$var$disabledStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && $345f4461e5d9e9f5$var$reactionStylesRefresh
        ],
        isDisabled: !isReady
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8AQ0R))), {
        color: !isReady ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)",
        label: formatMessage((0, $9C9hZ.default).addThumbsUpReactionLabel)
    }))), !isReactionAlreadyPresent && !showQuickReactions && !isModernReactionsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        testId: "issue.component.reactions.thumbs-up-button",
        onClick: addThumbsUpReaction,
        xcss: [
            $345f4461e5d9e9f5$var$reactionStyles,
            !isReady && $345f4461e5d9e9f5$var$disabledStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && $345f4461e5d9e9f5$var$reactionStylesRefresh
        ],
        isDisabled: !isReady
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8AQ0R))), {
        color: !isReady ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)",
        label: formatMessage((0, $9C9hZ.default).addThumbsUpReactionLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvAdf.ConnectedReactionsView), {
        ari: objectAri,
        containerAri: containerAri,
        store: reactionsStore,
        emojiProvider: emojiProvider,
        subtleReactionsSummaryAndPicker: isModernReactionsEnabled,
        allowAllEmojis: true,
        quickReactionEmojis: showQuickReactions ? {
            ari: objectAri,
            containerAri: containerAri,
            emojiIds: (0, $d6UIQ.quickEmojiIds)
        } : undefined,
        onReactionSuccess: reactionSuccessEvent
    })));
};
const $345f4461e5d9e9f5$export$f1c1fd79a1d9c243 = ({ containerAri: containerAri = '', objectAri: objectAri = '', reactionsStore: reactionsStoreProp, showReactions: showReactions, isRealTimeCommentUpdated: isRealTimeCommentUpdated, onReactionSuccess: onReactionSuccess })=>{
    const loggedInUserAccountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const reactionsStore = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('batch-reactions-iv-llc-comments')) return reactionsStoreProp ?? $345f4461e5d9e9f5$var$memoizedStoreFactory();
        return reactionsStoreProp ?? (0, $g9XSY.store)();
    }, [
        reactionsStoreProp
    ]);
    const emojiProvider = (0, $5uXOq.useMemo)(()=>(0, $4R6GH.fg)('improve_issue_comment_reaction_emoji_provider') ? (0, $hXRXz.getEmojiProviderWithCustomEmoji)(cloudId, loggedInUserAccountId, false) : (0, $hXRXz.getEmojiProviderWithCustomEmojiUploadDisabled)(cloudId, loggedInUserAccountId, false), [
        cloudId,
        loggedInUserAccountId
    ]);
    const reactionSuccessEvent = (0, $5uXOq.useCallback)((action, commentAri, emojiId, reactionsCount)=>{
        const reactionCountHierarchy = reactionsCount > 1 ? 1 : 0;
        const commentId = (0, $jL9KB.JiraCommentAri).parse(commentAri).resourceId;
        const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $fKtck.getPermalinkStatus)((0, $9pF5v.COMMENTS));
        if ((0, $4R6GH.fg)('thor-experiment-surface-reaction-comment-analytics')) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `reaction ${action}`, emojiId, {
            ...action === (0, $a81KM.ReactionUpdateType).added && {
                reactionCountHierarchy: reactionCountHierarchy
            },
            commentId: commentId,
            isRealTimeCommentUpdated: isRealTimeCommentUpdated,
            isFocusedComment: hasPermalink && commentId === permalinkId
        });
        else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `reaction ${action}`, emojiId, {
            ...action === (0, $a81KM.ReactionUpdateType).added && {
                reactionCountHierarchy: reactionCountHierarchy
            },
            commentId: commentId,
            isRealTimeCommentUpdated: isRealTimeCommentUpdated
        });
        onReactionSuccess?.(commentId);
    }, [
        createAnalyticsEvent,
        isRealTimeCommentUpdated,
        onReactionSuccess
    ]);
    if (!showReactions || !reactionsStore || !emojiProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jiv_vc_blindspot_fixes') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345f4461e5d9e9f5$var$EmojiProviderUFOLoadHold, {
        emojiProvider: emojiProvider
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lvAdf.ConnectedReactionsView), {
        ari: objectAri,
        containerAri: containerAri,
        store: reactionsStore,
        emojiProvider: emojiProvider,
        allowAllEmojis: true,
        onReactionSuccess: reactionSuccessEvent
    }));
};
const $345f4461e5d9e9f5$export$aeca1041cccf17f7 = (0, $7XYc4.componentWithCondition)(()=>{
    const isSoftwareProject = (0, $bsdOm.useIsSoftwareIssue)();
    const isBusinessProject = (0, $bsdOm.useIsBusinessIssue)();
    return (isSoftwareProject || isBusinessProject) && (0, $6s1PB.expVal)('thor_surface_reaction_comment_experiment', 'isSurfaceReactionsEnabled', false);
}, $345f4461e5d9e9f5$export$c45f4b0846a2ffc5, $345f4461e5d9e9f5$export$f1c1fd79a1d9c243);
const $345f4461e5d9e9f5$var$ReactionsWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345f4461e5d9e9f5$export$aeca1041cccf17f7, props));
const $345f4461e5d9e9f5$var$ReactionsWithRealtimeData = (props)=>{
    const [{ isRealTimeCommentUpdated: isRealTimeCommentUpdated }] = (0, $9AfTz.useRealTimeComments)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($345f4461e5d9e9f5$var$ReactionsWithErrorBoundary, {
        ...props,
        isRealTimeCommentUpdated: isRealTimeCommentUpdated
    });
};
const $345f4461e5d9e9f5$export$44cd1c46d5ca2376 = (0, $cSD7y.componentWithFG)('thor_send_realtime_attribute', $345f4461e5d9e9f5$var$ReactionsWithRealtimeData, $345f4461e5d9e9f5$var$ReactionsWithErrorBoundary);
var $345f4461e5d9e9f5$export$2e2bcd8739ae039 = (0, $hxqfC.connect)((state, { commentId: commentId })=>{
    let reactionAris = {};
    if ((0, $4R6GH.fg)('improve_issue_view_comment_reaction_buttons')) {
        let objectAri;
        if (commentId) objectAri = (0, $cEbDs.commentAriSelector)(commentId)(state) ?? undefined;
        reactionAris = {
            containerAri: (0, $bcoYn.issueAriSelector)(state) ?? undefined,
            objectAri: objectAri
        };
    }
    return {
        showReactions: (0, $cEbDs.shouldShowReactionsSelector)(state),
        ...reactionAris
    };
}, {})($345f4461e5d9e9f5$export$44cd1c46d5ca2376);
const $345f4461e5d9e9f5$var$reactionStylesRefresh = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius'
});
const $345f4461e5d9e9f5$var$reactionStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.circle',
    position: 'relative',
    color: 'color.text.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $345f4461e5d9e9f5$var$reactionStylesModernisation = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    position: 'relative',
    background: 'none',
    paddingBlockStart: 'space.025',
    paddingBlockEnd: 'space.025',
    paddingInlineStart: 'space.050',
    paddingInlineEnd: 'space.050',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $345f4461e5d9e9f5$var$disabledStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border.disabled',
    backgroundColor: 'color.background.disabled'
});

});
parcelRegister("lvAdf", function(module, exports) {

$parcel$export(module.exports, "ConnectedReactionsView", () => $07718fd55c607d26$export$2398a0345cce916e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1PVpv = parcelRequire("1PVpv");

var $2NMNM = parcelRequire("2NMNM");

var $euYSr = parcelRequire("euYSr");

var $hKaiv = parcelRequire("hKaiv");

var $5m4Qa = parcelRequire("5m4Qa");

var $a81KM = parcelRequire("a81KM");
const $07718fd55c607d26$export$2e41c70ec6b7fb4b = (containerAri, ari, particleEffectByEmojiEnabled, state)=>{
    const reactionsState = state && state.reactions[`${containerAri}|${ari}`];
    if (!state || !reactionsState) return {
        status: (0, $a81KM.ReactionStatus).notLoaded,
        reactions: []
    };
    switch(reactionsState.status){
        case (0, $a81KM.ReactionStatus).ready:
            return {
                reactions: reactionsState.reactions,
                status: reactionsState.status,
                flash: state.flash[`${containerAri}|${ari}`],
                particleEffectByEmoji: particleEffectByEmojiEnabled ? state.particleEffectByEmoji[`${containerAri}|${ari}`] : {}
            };
        case (0, $a81KM.ReactionStatus).error:
            return {
                status: (0, $a81KM.ReactionStatus).error,
                reactions: []
            };
        default:
            return {
                status: (0, $a81KM.ReactionStatus).loading,
                reactions: []
            };
    }
};
const $07718fd55c607d26$export$276dc3795b0fdd93 = (actions, containerAri, ari, successCallBack)=>{
    return {
        loadReaction: ()=>{
            actions.getReactions(containerAri, ari);
        },
        onReactionClick: (emojiId)=>{
            if (successCallBack) {
                actions.toggleReaction(containerAri, ari, emojiId, successCallBack);
                return;
            }
            actions.toggleReaction(containerAri, ari, emojiId);
        },
        getReactionDetails: (emojiId)=>{
            actions.getDetailedReaction(containerAri, ari, emojiId);
        },
        onSelection: (emojiId)=>{
            if (successCallBack) {
                actions.addReaction(containerAri, ari, emojiId, successCallBack);
                return;
            }
            actions.addReaction(containerAri, ari, emojiId);
        }
    };
};
const $07718fd55c607d26$export$2398a0345cce916e = (props)=>{
    const { ari: ari, containerAri: containerAri, store: store, particleEffectByEmojiEnabled: particleEffectByEmojiEnabled, onReactionSuccess: onReactionSuccess, ...rest } = props;
    /**
	 * Reference to the <Reactions /> component instance mandatory props
	 */ const [stateData, setStateData] = (0, $5uXOq.useState)();
    const [dispatchData, setDispatchData] = (0, $5uXOq.useState)();
    // compose a UFO experience object
    const experienceInstance = (0, $5uXOq.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        experienceInstance.current = (0, $5m4Qa.ufoExperiences).render(ari);
    }, [
        ari
    ]);
    // abort when component gets unmounted
    (0, $5uXOq.useEffect)(()=>{
        return function cleanup() {
            experienceInstance.current?.abort({
                metadata: {
                    source: 'ConnectedReactionsView',
                    ari: ari,
                    containerAri: containerAri,
                    reason: 'unmount'
                }
            });
        };
    }, [
        experienceInstance,
        containerAri,
        ari
    ]);
    /**
	 * Maps the store instance "reactions" data to the <Reactions /> component state data
	 * @param state store instance latest data
	 */ const mapStateToProps = (0, $5uXOq.useCallback)((state)=>{
        return $07718fd55c607d26$export$2e41c70ec6b7fb4b(containerAri, ari, particleEffectByEmojiEnabled, state);
    }, [
        containerAri,
        ari,
        particleEffectByEmojiEnabled
    ]);
    /**
	 * Map the store instance "actions" methods to the <Reactions /> component actions methods
	 * @param actions list of actions in the store instance
	 */ const mapDispatchToProps = (0, $5uXOq.useCallback)((actions)=>{
        return $07718fd55c607d26$export$276dc3795b0fdd93(actions, containerAri, ari, onReactionSuccess);
    }, [
        ari,
        containerAri,
        onReactionSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            const _store = await Promise.resolve(store);
            if (_store.setCreateAnalyticsEvent && createAnalyticsEvent) _store.setCreateAnalyticsEvent(createAnalyticsEvent);
            const state = mapStateToProps(_store.getState());
            const dispatch = mapDispatchToProps(_store);
            setStateData(state);
            setDispatchData(dispatch);
        })();
    }, [
        createAnalyticsEvent,
        store,
        ari,
        containerAri,
        mapStateToProps,
        mapDispatchToProps
    ]);
    /**
	 * Listen to changes on the store data.
	 * TODO: Needs to be refactored inside the MemoryReactionsStore to different pattern, currently it relies on internal callbacks variable to trigger changes to the store.
	 * The flow that each action method triggers a call to "setState" => "triggerOnChange" => calls the callback function registered by the onChange method and de-register by the "removeOnChangeListener" method
	 */ (0, $5uXOq.useEffect)(()=>{
        const onChangeCallback = (state)=>{
            const stateProps = mapStateToProps(state);
            setStateData(stateProps);
        };
        (async ()=>{
            const _store = await Promise.resolve(store);
            _store.onChange(onChangeCallback);
        })();
        return function cleanup() {
            (async ()=>{
                const _store = await Promise.resolve(store);
                _store.removeOnChangeListener(onChangeCallback);
            })();
        };
    }, [
        mapStateToProps,
        store
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: {
            containerAri: containerAri,
            ari: ari
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $euYSr.UfoErrorBoundary), {
            experiences: experienceInstance.current ? [
                experienceInstance.current
            ] : [],
            children: stateData && dispatchData && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hKaiv.Reactions), {
                ...rest,
                ...dispatchData,
                ...stateData
            }, `${containerAri}|${ari}`)
        })
    });
};

});
parcelRegister("euYSr", function(module, exports) {

$parcel$export(module.exports, "UfoErrorBoundary", () => $0caffce1f9a68353$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");
class $0caffce1f9a68353$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences)exp.failure({
            metadata: {
                source: 'UfoErrorBoundary',
                reason: 'error',
                error: {
                    name: error.name,
                    message: error.message,
                    infoStack: errorInfo.componentStack ?? undefined
                }
            }
        });
    }
    render() {
        return this.props.children;
    }
}

});

parcelRegister("hKaiv", function(module, exports) {

$parcel$export(module.exports, "Reactions", () => $845ea3703f2025c4$export$44cd1c46d5ca2376);
/* Reactions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $2NMNM = parcelRequire("2NMNM");

var $i8Qvm = parcelRequire("i8Qvm");

var $8Ec39 = parcelRequire("8Ec39");

var $igcqY = parcelRequire("igcqY");

var $dMkEH = parcelRequire("dMkEH");

var $ihA8Z = parcelRequire("ihA8Z");

var $a81KM = parcelRequire("a81KM");

var $lWCY0 = parcelRequire("lWCY0");

var $lzU1B = parcelRequire("lzU1B");

var $jYy4G = parcelRequire("jYy4G");

var $2e3ok = parcelRequire("2e3ok");

var $deKQb = parcelRequire("deKQb");

var $1MAvn = parcelRequire("1MAvn");

var $bL5sD = parcelRequire("bL5sD");
const $845ea3703f2025c4$var$ReactionPicker = (0, $bL5sD.componentWithFG)('platform_editor_reactions_picker_fix', (0, $deKQb.ReactionPicker), (0, $2e3ok.ReactionPicker));
const $845ea3703f2025c4$var$wrapperStyle = null;
const $845ea3703f2025c4$var$noFlexWrapStyles = null;
const $845ea3703f2025c4$var$noContainerPositionStyles = null;
const $845ea3703f2025c4$var$reactionPickerStyle = null;
const $845ea3703f2025c4$export$615f888019c45765 = {
    /**
   * Experience when a reaction dialog is opened
   */ openDialog: (0, $lWCY0.ReactionDialogOpened),
    /**
   * Experience when a reaction changed/fetched from inside the modal dialog
   */ selectedReactionChangeInsideDialog: (0, $lWCY0.ReactionDialogSelectedReactionChanged)
};
const $845ea3703f2025c4$export$45beea5a8efd4cda = 'render-reactions';
const $845ea3703f2025c4$export$6fd545f57ca8a08a = 'viewall-reacted-users-dialog';
const $845ea3703f2025c4$export$23a875699bfce51b = 'reaction-summary-view';
function $845ea3703f2025c4$export$46455b4476d4b8e1(status, errorMessage, tooltipContent) {
    switch(status){
        case (0, $a81KM.ReactionStatus).error:
            return errorMessage || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $ihA8Z.messages).unexpectedError
            });
        // When reaction is not available don't show any tooltip (e.g. Archive page in Confluence)
        case (0, $a81KM.ReactionStatus).disabled:
            return null;
        case (0, $a81KM.ReactionStatus).notLoaded:
        case (0, $a81KM.ReactionStatus).loading:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $ihA8Z.messages).loadingReactions
            });
        case (0, $a81KM.ReactionStatus).ready:
            return !!tooltipContent ? tooltipContent : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $ihA8Z.messages).addReaction
            });
    }
}
const $845ea3703f2025c4$export$44cd1c46d5ca2376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ flash: flash = {}, particleEffectByEmoji: particleEffectByEmoji = {}, status: status, errorMessage: errorMessage, loadReaction: loadReaction, quickReactionEmojis: quickReactionEmojis, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, getReactionDetails: getReactionDetails = ()=>{}, onSelection: onSelection, reactions: reactions = [], emojiProvider: emojiProvider, allowAllEmojis: allowAllEmojis, onReactionClick: onReactionClick, allowUserDialog: allowUserDialog, onDialogOpenCallback: onDialogOpenCallback = ()=>{}, onDialogCloseCallback: onDialogCloseCallback = ()=>{}, onDialogSelectReactionCallback: onDialogSelectReactionCallback = ()=>{}, onDialogPageChangeCallback: onDialogPageChangeCallback = ()=>{}, emojiPickerSize: emojiPickerSize = 'medium', miniMode: miniMode = false, summaryViewEnabled: summaryViewEnabled = false, summaryViewThreshold: summaryViewThreshold = 3, summaryViewPlacement: summaryViewPlacement, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, hideDefaultReactions: hideDefaultReactions = false, ProfileCardWrapper: ProfileCardWrapper, onlyRenderPicker: onlyRenderPicker = false, isViewOnly: isViewOnly = false, noWrap: noWrap = false, noRelativeContainer: noRelativeContainer = false, showSubtleDefaultReactions: showSubtleDefaultReactions, reactionPickerTriggerTooltipContent: reactionPickerTriggerTooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, allowSelectFromSummaryView: allowSelectFromSummaryView = false, useButtonAlignmentStyling: useButtonAlignmentStyling = false, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: hoverableSummaryView = false, isListItem: isListItem = false, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, reactionPickerPlacement: reactionPickerPlacement, summaryButtonIconAfter: summaryButtonIconAfter, renderParticleEffectOnSummaryView: renderParticleEffectOnSummaryView = false })=>{
    const [selectedEmojiId, setSelectedEmojiId] = (0, $5uXOq.useState)('');
    const [summaryViewParticleEffectEmojiId, setSummaryViewParticleEffectEmojiId] = (0, $5uXOq.useState)(null);
    // if the reactions are empty, then set summaryViewParticleEffectEmojiId to null to clear the particle effect state
    (0, $5uXOq.useEffect)(()=>{
        if (reactions.length === 0) setSummaryViewParticleEffectEmojiId(null);
    }, [
        reactions
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    let openTime = (0, $5uXOq.useRef)();
    let renderTime = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (status === (0, $a81KM.ReactionStatus).notLoaded) loadReaction();
    }, [
        status,
        loadReaction
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== (0, $a81KM.ReactionStatus).ready) renderTime.current = Date.now();
        else {
            const isSSR = undefined;
            if ((0, $igcqY.isSampled)((0, $dMkEH.SAMPLING_RATE_REACTIONS_RENDERED_EXP)) && !isSSR) (0, $igcqY.createAndFireSafe)(createAnalyticsEvent, (0, $igcqY.createReactionsRenderedEvent), renderTime.current ?? Date.now() //renderTime.current can be null during unit test cases
            );
            renderTime.current = undefined;
        }
    }, [
        createAnalyticsEvent,
        status
    ]);
    const handleReactionMouseEnter = (0, $5uXOq.useCallback)((emojiId)=>{
        getReactionDetails(emojiId);
    }, [
        getReactionDetails
    ]);
    const handleReactionFocused = (0, $5uXOq.useCallback)((emojiId)=>{
        getReactionDetails(emojiId);
    }, [
        getReactionDetails
    ]);
    const handlePickerOpen = (0, $5uXOq.useCallback)(()=>{
        openTime.current = Date.now();
        (0, $igcqY.createAndFireSafe)(createAnalyticsEvent, (0, $igcqY.createPickerButtonClickedEvent), reactions.length);
    }, [
        createAnalyticsEvent,
        reactions
    ]);
    const handleOnCancel = (0, $5uXOq.useCallback)(()=>{
        (0, $igcqY.createAndFireSafe)(createAnalyticsEvent, (0, $igcqY.createPickerCancelledEvent), openTime.current);
        openTime.current = undefined;
    }, [
        createAnalyticsEvent
    ]);
    const handleOnMore = (0, $5uXOq.useCallback)(()=>{
        (0, $igcqY.createAndFireSafe)(createAnalyticsEvent, (0, $igcqY.createPickerMoreClickedEvent), openTime.current);
    }, [
        createAnalyticsEvent
    ]);
    const handleSetSummaryViewParticleEffectEmojiId = (0, $5uXOq.useCallback)((emojiId)=>{
        // Find if this emoji is already in existing reactions
        const existingReaction = reactions.find((reaction)=>reaction.emojiId === emojiId);
        // Only set mostRecentlyClickedId if user hasn't reacted with this emoji yet
        if (!existingReaction?.reacted) setSummaryViewParticleEffectEmojiId({
            id: emojiId,
            shortName: ''
        });
        else setSummaryViewParticleEffectEmojiId(null);
    }, [
        reactions,
        setSummaryViewParticleEffectEmojiId
    ]);
    const handleOnSelection = (0, $5uXOq.useCallback)((emojiId, source)=>{
        (0, $igcqY.createAndFireSafe)(createAnalyticsEvent, (0, $igcqY.createReactionSelectionEvent), source, emojiId, reactions.find((reaction)=>reaction.emojiId === emojiId), openTime.current);
        openTime.current = undefined;
        onSelection(emojiId);
        handleSetSummaryViewParticleEffectEmojiId(emojiId);
    }, [
        createAnalyticsEvent,
        onSelection,
        reactions,
        handleSetSummaryViewParticleEffectEmojiId
    ]);
    const handleSummaryViewReactionClick = (0, $5uXOq.useCallback)((emojiId, event)=>{
        onReactionClick(emojiId, event);
        handleSetSummaryViewParticleEffectEmojiId(emojiId);
    }, [
        onReactionClick,
        handleSetSummaryViewParticleEffectEmojiId
    ]);
    const handleCloseReactionsDialog = (e, analyticsEvent)=>{
        setSelectedEmojiId('');
        onDialogCloseCallback(e, analyticsEvent);
    };
    const handleSelectReactionInDialog = (emojiId)=>{
        // ufo selected reaction inside the modal dialog
        $845ea3703f2025c4$export$615f888019c45765.selectedReactionChangeInsideDialog.start();
        handleReactionMouseEnter(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogSelectReactionCallback(emojiId);
        // ufo selected reaction inside the modal dialog success
        $845ea3703f2025c4$export$615f888019c45765.selectedReactionChangeInsideDialog.success({
            metadata: {
                emojiId: emojiId,
                source: 'Reactions',
                reason: 'Selected Emoji changed'
            }
        });
    };
    const handlePaginationChange = (0, $5uXOq.useCallback)((emojiId, currentPage, maxPages)=>{
        // fetch the latest active emoji from the new page
        getReactionDetails(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogPageChangeCallback(emojiId, currentPage, maxPages);
    }, // Exclude unstable getReactionDetails to avoid extra re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setSelectedEmojiId
    ]);
    /**
   * Get the reactions that we want to render are any reactions with a count greater than zero as well as any default emoji not already shown
   */ const memorizedReactions = (0, $5uXOq.useMemo)(()=>{
        //
        /**
     * If reactions not empty, don't show quick reactions Pre defined emoji or if its empty and default reactions not hidden => return the current list of reactions
     */ if (reactions.length === 0 && hideDefaultReactions || reactions.length > 0 || !quickReactionEmojis) return reactions;
        // add any missing default reactions
        const { ari: ari, containerAri: containerAri, emojiIds: emojiIds } = quickReactionEmojis;
        const items = emojiIds.filter((emojiId)=>!reactions.some((reaction)=>reaction.emojiId === emojiId)).map((emojiId)=>{
            return {
                ari: ari,
                containerAri: containerAri,
                emojiId: emojiId,
                count: 0,
                reacted: false
            };
        });
        return reactions.concat(items);
    }, [
        quickReactionEmojis,
        reactions,
        hideDefaultReactions
    ]);
    const shouldShowSummaryView = summaryViewEnabled && memorizedReactions.length >= summaryViewThreshold && reactions.length > 0;
    // criteria to show Reactions Dialog
    const hasEmojiWithFivePlusReactions = reactions.some((reaction)=>reaction.count >= 5);
    const sortedReactions = (0, $5uXOq.useMemo)(()=>{
        return [
            ...memorizedReactions
        ].sort((a, b)=>b?.count - a?.count);
    }, [
        memorizedReactions
    ]);
    /**
   * event handler to open dialog with selected reaction
   * @param emojiId initial emoji id to load dialog with
   */ const handleOpenReactionsDialog = ({ emojiId: emojiId = sortedReactions[0].emojiId, source: source = 'endOfPageReactions' } = {})=>{
        // ufo start opening reaction dialog
        $845ea3703f2025c4$export$615f888019c45765.openDialog.start();
        getReactionDetails(emojiId);
        setSelectedEmojiId(emojiId);
        onDialogOpenCallback(emojiId, source);
        // ufo opening reaction dialog success
        $845ea3703f2025c4$export$615f888019c45765.openDialog.success({
            metadata: {
                emojiId: emojiId,
                source: 'Reactions',
                reason: 'Opening Reactions Dialog successfully'
            }
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ec39.default), {
        name: "reactions",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            "data-testid": $845ea3703f2025c4$export$45beea5a8efd4cda,
            className: (0, $bwpsq.default)([
                "_2rkoo7ao _1e0c1txw _1n261g80 _kqswh2mm _4cvr1h6o _19pkr5cr _13vtidpf",
                noWrap && "_1n261q9c",
                noRelativeContainer && "_kqswpfqs"
            ]),
            children: [
                !onlyRenderPicker && (shouldShowSummaryView ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-testid": $845ea3703f2025c4$export$23a875699bfce51b,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1MAvn.ReactionSummaryView), {
                        reactions: sortedReactions,
                        emojiProvider: emojiProvider,
                        flash: flash,
                        particleEffectByEmoji: particleEffectByEmoji,
                        onSelection: handleOnSelection,
                        onReactionClick: handleSummaryViewReactionClick,
                        onReactionFocused: handleReactionFocused,
                        onReactionMouseEnter: handleReactionMouseEnter,
                        placement: summaryViewPlacement,
                        showOpaqueBackground: showOpaqueBackground,
                        subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                        handleOpenReactionsDialog: ()=>handleOpenReactionsDialog({
                                source: 'summaryView'
                            }),
                        allowUserDialog: allowUserDialog && hasEmojiWithFivePlusReactions,
                        isViewOnly: isViewOnly,
                        allowSelectFromSummaryView: allowSelectFromSummaryView,
                        disabled: status !== (0, $a81KM.ReactionStatus).ready,
                        reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                        tooltipContent: $845ea3703f2025c4$export$46455b4476d4b8e1(status, errorMessage, reactionPickerTriggerTooltipContent),
                        emojiPickerSize: emojiPickerSize,
                        onOpen: handlePickerOpen,
                        useButtonAlignmentStyling: useButtonAlignmentStyling,
                        reactionPickerTriggerText: reactionPickerTriggerText,
                        hoverableSummaryView: hoverableSummaryView,
                        summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
                        summaryButtonIconAfter: summaryButtonIconAfter,
                        summaryViewParticleEffectEmojiId: renderParticleEffectOnSummaryView ? summaryViewParticleEffectEmojiId : null
                    })
                }) : memorizedReactions.map((reaction)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lzU1B.Reaction), {
                        reaction: reaction,
                        emojiProvider: emojiProvider,
                        onClick: onReactionClick,
                        onMouseEnter: handleReactionMouseEnter,
                        onFocused: handleReactionFocused,
                        flash: flash[reaction.emojiId],
                        showParticleEffect: particleEffectByEmoji[reaction.emojiId],
                        showOpaqueBackground: showOpaqueBackground,
                        allowUserDialog: allowUserDialog && hasEmojiWithFivePlusReactions,
                        handleOpenReactionsDialog: handleOpenReactionsDialog,
                        isViewOnly: isViewOnly,
                        showSubtleStyle: showSubtleDefaultReactions && reactions.length === 0
                    }, reaction.emojiId))),
                isViewOnly || !onlyRenderPicker && shouldShowSummaryView && allowSelectFromSummaryView ? null : /*#__PURE__*/ (0, $2OMIu.jsx)($845ea3703f2025c4$var$ReactionPicker, {
                    emojiProvider: emojiProvider,
                    allowAllEmojis: allowAllEmojis,
                    pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
                    disabled: status !== (0, $a81KM.ReactionStatus).ready,
                    onSelection: handleOnSelection,
                    onOpen: handlePickerOpen,
                    onCancel: handleOnCancel,
                    onShowMore: handleOnMore,
                    tooltipContent: hoverableSummaryView ? null : $845ea3703f2025c4$export$46455b4476d4b8e1(status, errorMessage, reactionPickerTriggerTooltipContent),
                    emojiPickerSize: emojiPickerSize,
                    miniMode: miniMode,
                    showOpaqueBackground: showOpaqueBackground,
                    showAddReactionText: showAddReactionText,
                    subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                    reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                    reactionPickerTriggerText: reactionPickerTriggerText,
                    isListItem: isListItem,
                    hoverableReactionPicker: hoverableSummaryView,
                    hoverableReactionPickerDelay: hoverableSummaryView ? 300 : 0,
                    reactionPickerPlacement: reactionPickerPlacement,
                    className: (0, $bwpsq.default)([
                        "_1e0c1o8l _19pk1b66"
                    ])
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
                    children: !!selectedEmojiId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Ec39.default), {
                        name: "reactions-dialog",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jYy4G.ReactionsDialog), {
                            selectedEmojiId: selectedEmojiId,
                            reactions: sortedReactions,
                            emojiProvider: emojiProvider,
                            handleCloseReactionsDialog: handleCloseReactionsDialog,
                            handleSelectReaction: handleSelectReactionInDialog,
                            handlePaginationChange: handlePaginationChange,
                            ProfileCardWrapper: ProfileCardWrapper
                        })
                    })
                })
            ]
        })
    });
});

});
parcelRegister("igcqY", function(module, exports) {

$parcel$export(module.exports, "isSampled", () => $3451617d0a2667ed$export$ed7a494f7df966be);
$parcel$export(module.exports, "createAndFireSafe", () => $3451617d0a2667ed$export$1b95a6072f2f9fae);
$parcel$export(module.exports, "createRestSucceededEvent", () => $3451617d0a2667ed$export$d61cc4fea6b821c6);
$parcel$export(module.exports, "createRestFailedEvent", () => $3451617d0a2667ed$export$33f46652cacb6853);
$parcel$export(module.exports, "createReactionsRenderedEvent", () => $3451617d0a2667ed$export$fd86d4b03f87495);
$parcel$export(module.exports, "createPickerButtonClickedEvent", () => $3451617d0a2667ed$export$5797d4afdfbf7ff2);
$parcel$export(module.exports, "createPickerCancelledEvent", () => $3451617d0a2667ed$export$aa268ce0cc416ab4);
$parcel$export(module.exports, "createPickerMoreClickedEvent", () => $3451617d0a2667ed$export$280ed8781309406f);
$parcel$export(module.exports, "createReactionSelectionEvent", () => $3451617d0a2667ed$export$6181167d075f0ec0);
$parcel$export(module.exports, "createReactionHoveredEvent", () => $3451617d0a2667ed$export$c7349958d247ace6);
$parcel$export(module.exports, "createReactionFocusedEvent", () => $3451617d0a2667ed$export$2402f68e3d87389c);
$parcel$export(module.exports, "createReactionClickedEvent", () => $3451617d0a2667ed$export$d3f48819b8df93ec);
$parcel$export(module.exports, "extractErrorInfo", () => $3451617d0a2667ed$export$74aaf4784c2edb2c);

var $gB4mS = parcelRequire("gB4mS");

const $3451617d0a2667ed$var$packageName = "platform-pkg";
const $3451617d0a2667ed$var$packageVersion = "0.0.0-use.local";
const $3451617d0a2667ed$export$ed7a494f7df966be = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $3451617d0a2667ed$export$53eef0dcd9611650 = (0, $gB4mS.default)('fabric-elements');
const $3451617d0a2667ed$export$1b95a6072f2f9fae = (createAnalyticsEvent, creator, ...args)=>{
    if (createAnalyticsEvent) $3451617d0a2667ed$export$53eef0dcd9611650(creator(...args))(createAnalyticsEvent);
};
const $3451617d0a2667ed$var$createPayload = (action, actionSubject, eventType, actionSubjectId)=>(attributes = {})=>({
            action: action,
            actionSubject: actionSubject,
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes,
                packageName: $3451617d0a2667ed$var$packageName,
                packageVersion: $3451617d0a2667ed$var$packageVersion
            }
        });
const $3451617d0a2667ed$var$calculateDuration = (startTime)=>startTime ? Date.now() - startTime : undefined;
const $3451617d0a2667ed$var$getPreviousState = (reaction)=>{
    if (reaction) {
        if (reaction.reacted) return 'existingReacted';
        return 'existingNotReacted';
    }
    return 'new';
};
const $3451617d0a2667ed$export$d61cc4fea6b821c6 = (actionSubject)=>$3451617d0a2667ed$var$createPayload('succeeded', actionSubject, (0, $676c5e519aa5ba55$export$12346a674644c156))();
const $3451617d0a2667ed$export$33f46652cacb6853 = (actionSubject, errorCode)=>$3451617d0a2667ed$var$createPayload('failed', actionSubject, (0, $676c5e519aa5ba55$export$12346a674644c156))({
        errorCode: errorCode
    });
const $3451617d0a2667ed$export$fd86d4b03f87495 = (startTime)=>$3451617d0a2667ed$var$createPayload('rendered', 'reactionView', (0, $676c5e519aa5ba55$export$12346a674644c156))({
        duration: $3451617d0a2667ed$var$calculateDuration(startTime)
    });
const $3451617d0a2667ed$export$5797d4afdfbf7ff2 = (reactionEmojiCount)=>$3451617d0a2667ed$var$createPayload('clicked', 'reactionPickerButton', (0, $676c5e519aa5ba55$export$a1562d08625f5d7e))({
        reactionEmojiCount: reactionEmojiCount
    });
const $3451617d0a2667ed$export$aa268ce0cc416ab4 = (startTime)=>$3451617d0a2667ed$var$createPayload('cancelled', 'reactionPicker', (0, $676c5e519aa5ba55$export$a1562d08625f5d7e))({
        duration: $3451617d0a2667ed$var$calculateDuration(startTime)
    });
const $3451617d0a2667ed$export$280ed8781309406f = (startTime)=>$3451617d0a2667ed$var$createPayload('clicked', 'reactionPicker', (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), 'more')({
        duration: $3451617d0a2667ed$var$calculateDuration(startTime)
    });
const $3451617d0a2667ed$export$6181167d075f0ec0 = (source, emojiId, reaction, startTime)=>$3451617d0a2667ed$var$createPayload('clicked', 'reactionPicker', (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), 'emoji')({
        duration: $3451617d0a2667ed$var$calculateDuration(startTime),
        source: source,
        previousState: $3451617d0a2667ed$var$getPreviousState(reaction),
        emojiId: emojiId
    });
const $3451617d0a2667ed$export$c7349958d247ace6 = (startTime)=>$3451617d0a2667ed$var$createPayload('hovered', 'existingReaction', (0, $676c5e519aa5ba55$export$a1562d08625f5d7e))({
        duration: $3451617d0a2667ed$var$calculateDuration(startTime)
    });
const $3451617d0a2667ed$export$2402f68e3d87389c = (startTime)=>$3451617d0a2667ed$var$createPayload('focused', 'existingReaction', (0, $676c5e519aa5ba55$export$a1562d08625f5d7e))({
        duration: $3451617d0a2667ed$var$calculateDuration(startTime)
    });
const $3451617d0a2667ed$export$d3f48819b8df93ec = (added, emojiId)=>$3451617d0a2667ed$var$createPayload('clicked', 'existingReaction', (0, $676c5e519aa5ba55$export$a1562d08625f5d7e))({
        added: added,
        emojiId: emojiId
    });
const $3451617d0a2667ed$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';


parcelRegister("dMkEH", function(module, exports) {

$parcel$export(module.exports, "DefaultReactions", () => $67012bc269146057$export$a1b2ffe56d40782b);
$parcel$export(module.exports, "TOOLTIP_USERS_LIMIT", () => $67012bc269146057$export$59a228d10bdb32fa);
$parcel$export(module.exports, "NUMBER_OF_REACTIONS_TO_DISPLAY", () => $67012bc269146057$export$85d1598de110e7b3);
$parcel$export(module.exports, "SAMPLING_RATE_REACTIONS_RENDERED_EXP", () => $67012bc269146057$export$50b3c15a723386a7);
$parcel$export(module.exports, "RESOURCED_EMOJI_COMPACT_HEIGHT", () => $67012bc269146057$export$d78bee0d9fab78ad);
const $67012bc269146057$export$a1b2ffe56d40782b = [
    {
        id: '1f44d',
        shortName: ':thumbsup:'
    },
    {
        id: '1f44f',
        shortName: ':clap:'
    },
    {
        id: '1f525',
        shortName: ':fire:'
    },
    {
        id: '2764',
        shortName: ':heart:'
    },
    {
        id: '1f632',
        shortName: ':astonished:'
    },
    {
        id: '1f914',
        shortName: ':thinking:'
    }
];
const $67012bc269146057$export$86ad6a676949132c = [
    {
        id: '1f44d',
        shortName: ':thumbsup:'
    },
    {
        id: '1f44f',
        shortName: ':clap:'
    },
    {
        id: '1f525',
        shortName: ':fire:'
    },
    {
        id: '2764',
        shortName: ':heart:'
    },
    {
        id: '1f632',
        shortName: ':astonished:'
    },
    {
        id: '1f914',
        shortName: ':thinking:'
    },
    {
        id: '1f44e',
        shortName: ':thumbsdown:'
    },
    {
        id: '1f4a1',
        shortName: ':bulb:'
    },
    {
        id: '2b50',
        shortName: ':star:'
    },
    {
        id: '1f49a',
        shortName: ':green_heart:'
    },
    {
        id: '1f499',
        shortName: ':blue_heart:'
    },
    {
        id: '1f494',
        shortName: ':broken_heart:'
    },
    {
        id: '1f600',
        shortName: ':grinning:'
    },
    {
        id: '1f642',
        shortName: ':slight_smile:'
    }
];
const $67012bc269146057$export$d8c2ebcd0ee41219 = new Map($67012bc269146057$export$a1b2ffe56d40782b.map((reaction)=>[
        reaction.shortName,
        reaction
    ]));
const $67012bc269146057$export$865044c189f353c2 = new Map($67012bc269146057$export$86ad6a676949132c.map((reaction)=>[
        reaction.shortName,
        reaction
    ]));
const $67012bc269146057$export$59a228d10bdb32fa = 5;
const $67012bc269146057$export$85d1598de110e7b3 = 8;
const $67012bc269146057$export$50b3c15a723386a7 = 50;
const $67012bc269146057$export$d78bee0d9fab78ad = 16;

});

parcelRegister("ihA8Z", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b4969729d2b79031$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b4969729d2b79031$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    addReaction: {
        id: 'fabric.reactions.add',
        defaultMessage: 'Add reaction',
        description: 'Message for add reaction button'
    },
    addNewReaction: {
        id: 'fabric.reactions.add.new',
        defaultMessage: 'Add new',
        description: 'Message for add new reaction button in hoverable reaction picker'
    },
    loadingReactions: {
        id: 'fabric.reactions.loading',
        defaultMessage: 'Loading...',
        description: 'Message while reactions are being loaded'
    },
    moreEmoji: {
        id: 'fabric.reactions.more.emojis',
        defaultMessage: 'More emojis',
        description: 'Tooltip of the "show more" button in the quick reaction selector. The full emoji selector is displayed when the user clicks on it.'
    },
    reactWithEmoji: {
        id: 'fabric.reactions.reactwithemoji',
        defaultMessage: 'React with {emoji} emoji',
        description: 'Aria label on reaction button'
    },
    reactWithEmojiAndCount: {
        id: 'fabric.reactions.reactwithemojiandcount',
        defaultMessage: '{count, plural, one {# {emoji} emoji} other {# {emoji} emojis}}. React with {emoji} emoji',
        description: 'Aria label on reaction button'
    },
    summary: {
        id: 'fabric.reactions.summary',
        defaultMessage: 'View all user reactions',
        description: 'Aria label on summary reaction button. Clicking this button shows who reacted in a popup'
    },
    unexpectedError: {
        id: 'fabric.reactions.error.unexpected',
        defaultMessage: 'Reactions are temporarily unavailable',
        description: 'Unexpected error message'
    },
    otherUsers: {
        id: 'fabric.reactions.other.reacted.users',
        defaultMessage: '{count, plural, one {and one other} other {and {count} others}}',
        description: "The number of users that have reacted similarly, but aren't shown"
    },
    closeReactionsDialog: {
        id: 'reactions.dialog.close',
        defaultMessage: 'Close',
        description: 'Close Reactions Dialog'
    },
    reactionsCount: {
        id: 'reactions.dialog.reactions.count',
        defaultMessage: `{count, plural,
        one {# total reaction}
        other {# total reactions}
      }`,
        description: 'The count of Reactions displayed in Reactions Dialog'
    },
    leftNavigateLabel: {
        id: 'reactions.dialog.left.navigate',
        defaultMessage: 'Left Navigate',
        description: 'Navigation Link to navigate to left'
    },
    rightNavigateLabel: {
        id: 'reactions.dialog.right.navigate',
        defaultMessage: 'Right Navigate',
        description: 'Navigation Link to navigate to right'
    },
    emojiName: {
        id: 'reactions.dialog.emoji.name',
        defaultMessage: '{emojiName}',
        description: 'Description of the emoji'
    },
    seeWhoReacted: {
        id: 'reactions.dialog.viewall',
        defaultMessage: 'View all',
        description: 'Link button to show who reacted in a modal'
    },
    seeWhoReactedTooltip: {
        id: 'reactions.dialog.viewall.tooltip',
        defaultMessage: 'View all user reactions',
        description: 'Tooltip content of see who reacted link'
    },
    popperWrapperLabel: {
        id: 'reactions-reaction.picker-label',
        defaultMessage: 'Add reactions',
        description: 'A label to the reaction picker group'
    }
});

});

parcelRegister("a81KM", function(module, exports) {

$parcel$export(module.exports, "ReactionUpdateType", () => $f0d7148638e83999$export$3618cac445fcd41d);
$parcel$export(module.exports, "ReactionStatus", () => $f0d7148638e83999$export$ae1bec9d610f93d3);
var $f0d7148638e83999$export$3618cac445fcd41d = /*#__PURE__*/ function(ReactionUpdateType) {
    ReactionUpdateType["added"] = "added";
    ReactionUpdateType["removed"] = "removed";
    return ReactionUpdateType;
}({});
var $f0d7148638e83999$export$ae1bec9d610f93d3 = /*#__PURE__*/ function(ReactionStatus) {
    ReactionStatus["ready"] = "READY";
    ReactionStatus["loading"] = "LOADING";
    ReactionStatus["error"] = "ERROR";
    ReactionStatus["notLoaded"] = "NOT_LOADED";
    ReactionStatus["disabled"] = "DISABLED";
    return ReactionStatus;
}({});

});

parcelRegister("lWCY0", function(module, exports) {

$parcel$export(module.exports, "PickerRender", () => $4bf8ff04edf8256a$export$6a3784263f4fa16e);
$parcel$export(module.exports, "ReactionsAdd", () => $4bf8ff04edf8256a$export$2fe905192bb057);
$parcel$export(module.exports, "ReactionDialogOpened", () => $4bf8ff04edf8256a$export$6d84aa1577071ff0);
$parcel$export(module.exports, "ReactionDialogSelectedReactionChanged", () => $4bf8ff04edf8256a$export$ef9cf69898a6ff56);
$parcel$export(module.exports, "ReactionDetailsFetch", () => $4bf8ff04edf8256a$export$517f7e3ffbcd0621);
$parcel$export(module.exports, "ReactionsRemove", () => $4bf8ff04edf8256a$export$4f07dc8d2bdd140d);
$parcel$export(module.exports, "sampledReactionsRendered", () => $4bf8ff04edf8256a$export$45a4d1bf25d8455d);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
var $boHLC = parcelRequire("boHLC");

var $bHWpv = parcelRequire("bHWpv");
/**
 * Helper method for create the config type for an individual/Concurrent experience
 * @param componentName
 */ const $4bf8ff04edf8256a$var$createExperienceConfig = (componentName, type, performanceType)=>{
    return {
        platform: {
            component: componentName
        },
        type: type,
        performanceType: performanceType
    };
};
var $4bf8ff04edf8256a$export$b881bd9f00ed8ed1 = /*#__PURE__*/ function(ExperienceName) {
    ExperienceName["REACTIONS_RENDERED"] = "reactions-rendered";
    ExperienceName["PICKER_OPENED"] = "reactions-picker-opened";
    ExperienceName["REACTION_ADDED"] = "reaction-added";
    ExperienceName["REACTION_REMOVED"] = "reaction-removed";
    ExperienceName["REACTION_DETAILS_FETCHED"] = "reaction-details-fetched";
    ExperienceName["REACTION_DIALOG_OPENED"] = "reaction-dialog-opened";
    ExperienceName["REACTION_DIALOG_CLOSED"] = "reaction-dialog-closed";
    ExperienceName["REACTION_DIALOG_SELECTED_REACTION_CHANGED"] = "reaction-dialog-selected-reaction-changed";
    ExperienceName["REACTION_DIALOG_PAGE_NAVIGATION"] = "reaction-dialog-page-navigation";
    return ExperienceName;
}({});
var $4bf8ff04edf8256a$export$57d347d1902b5fe6 = /*#__PURE__*/ function(ComponentName) {
    ComponentName["PICKER_RENDERED"] = "reactions-picker";
    ComponentName["REACTIONS"] = "reactions-list";
    ComponentName["REACTION_ITEM"] = "reaction-item";
    ComponentName["REACTION_DIALOG"] = "reaction-dialog";
    return ComponentName;
}({});
const $4bf8ff04edf8256a$export$6a3784263f4fa16e = new (0, $boHLC.UFOExperience)("reactions-picker-opened", $4bf8ff04edf8256a$var$createExperienceConfig("reactions-picker", (0, $7Zbvr.ExperienceTypes).Experience, (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult));
const $4bf8ff04edf8256a$export$5990348071f4d2f = new (0, $cBycP.ConcurrentExperience)("reactions-rendered", $4bf8ff04edf8256a$var$createExperienceConfig("reactions-list", (0, $7Zbvr.ExperienceTypes).Load, (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad));
const $4bf8ff04edf8256a$export$2fe905192bb057 = new (0, $cBycP.ConcurrentExperience)("reaction-added", $4bf8ff04edf8256a$var$createExperienceConfig("reactions-list", (0, $7Zbvr.ExperienceTypes).Experience, (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult));
const $4bf8ff04edf8256a$export$6d84aa1577071ff0 = new (0, $boHLC.UFOExperience)("reaction-dialog-opened", $4bf8ff04edf8256a$var$createExperienceConfig("reaction-dialog", (0, $7Zbvr.ExperienceTypes).Experience, (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult));
const $4bf8ff04edf8256a$export$ef9cf69898a6ff56 = new (0, $boHLC.UFOExperience)("reaction-dialog-selected-reaction-changed", $4bf8ff04edf8256a$var$createExperienceConfig("reaction-dialog", (0, $7Zbvr.ExperienceTypes).Experience, (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult));
const $4bf8ff04edf8256a$export$517f7e3ffbcd0621 = new (0, $cBycP.ConcurrentExperience)("reaction-details-fetched", $4bf8ff04edf8256a$var$createExperienceConfig("reaction-item", (0, $7Zbvr.ExperienceTypes).Experience, (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult));
const $4bf8ff04edf8256a$export$4f07dc8d2bdd140d = new (0, $cBycP.ConcurrentExperience)("reaction-removed", $4bf8ff04edf8256a$var$createExperienceConfig("reactions-list", (0, $7Zbvr.ExperienceTypes).Experience, (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult));
const $4bf8ff04edf8256a$export$45a4d1bf25d8455d = (instanceId)=>(0, $bHWpv.withSampling)($4bf8ff04edf8256a$export$5990348071f4d2f.getInstance(instanceId));

});

parcelRegister("lzU1B", function(module, exports) {

$parcel$export(module.exports, "Reaction", () => $4814c1443312b728$export$d2ae4167a30cf6bb);
/* Reaction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $2l0ub = parcelRequire("2l0ub");

var $igcqY = parcelRequire("igcqY");

var $idI8K = parcelRequire("idI8K");

var $2DWJV = parcelRequire("2DWJV");

var $fN5xL = parcelRequire("fN5xL");

var $ihA8Z = parcelRequire("ihA8Z");

var $E3WGX = parcelRequire("E3WGX");

var $dMkEH = parcelRequire("dMkEH");

var $25NfL = parcelRequire("25NfL");

var $84c1t = parcelRequire("84c1t");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $4814c1443312b728$var$styles = {
    container: "_kqswh2mm"
};
const $4814c1443312b728$var$emojiStyle = null;
const $4814c1443312b728$var$emojiNoReactionStyle = null;
const $4814c1443312b728$export$b64f94cf5ea5f111 = 'render_reaction_wrapper';
const $4814c1443312b728$export$d2ae4167a30cf6bb = ({ emojiProvider: emojiProvider, onClick: onClick, reaction: reaction, onMouseEnter: onMouseEnter = ()=>{}, onFocused: onFocused = ()=>{}, flash: flash = false, showParticleEffect: showParticleEffect = false, showOpaqueBackground: showOpaqueBackground = false, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: isViewOnly = false, showSubtleStyle: showSubtleStyle })=>{
    const intl = (0, $koVbs.default)();
    const hoverStart = (0, $5uXOq.useRef)();
    const focusStart = (0, $5uXOq.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [emojiName, setEmojiName] = (0, $5uXOq.useState)();
    const [isTooltipEnabled, setIsTooltipEnabled] = (0, $5uXOq.useState)(true);
    const { reacted: reacted } = reaction;
    const emojiId = {
        id: reaction.emojiId,
        shortName: ''
    };
    // TODO: Extract the flow to a custom hook to retrieve emoji detailed description from an id using a custom hook. This will benefit a better optimization instead of the emojiProvider resolving everytime.
    // Also optimize in future version to fetch in batch several emojiIds
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            const emojiResource = await Promise.resolve(emojiProvider);
            const foundEmoji = await emojiResource.findById(reaction.emojiId);
            if (foundEmoji) setEmojiName(foundEmoji.name);
        })();
    }, [
        emojiProvider,
        reaction.emojiId
    ]);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        if ((0, $E3WGX.isLeftClick)(event)) {
            const { reacted: reacted, emojiId: emojiId } = reaction;
            (0, $igcqY.createAndFireSafe)(createAnalyticsEvent, (0, $igcqY.createReactionClickedEvent), !reacted, emojiId);
            onClick(reaction.emojiId, event);
        }
    }, [
        createAnalyticsEvent,
        reaction,
        onClick
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        setIsTooltipEnabled(true);
        if (!reaction.users || !reaction.users.length) focusStart.current = Date.now();
        (0, $igcqY.createAndFireSafe)(createAnalyticsEvent, (0, $igcqY.createReactionHoveredEvent), focusStart.current);
        onMouseEnter(reaction.emojiId, event);
    }, [
        createAnalyticsEvent,
        reaction,
        onMouseEnter
    ]);
    const handleFocused = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        setIsTooltipEnabled(true);
        if (!reaction.users || !reaction.users.length) hoverStart.current = Date.now();
        (0, $igcqY.createAndFireSafe)(createAnalyticsEvent, (0, $igcqY.createReactionFocusedEvent), hoverStart.current);
        onFocused(reaction.emojiId, event);
    }, [
        createAnalyticsEvent,
        reaction,
        onFocused
    ]);
    const dismissTooltip = ()=>{
        setIsTooltipEnabled(false);
    };
    const emojiAndCount = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_8hrz1nam _vwz41crf _ca0q1b66 _u5f31b66 _n3td1b66 _19bvu2gc",
                    reaction.count === 0 && "_ca0q1b66 _u5f3v77o _n3td1b66 _19bv19bv"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2l0ub.default), {
                    emojiProvider: emojiProvider,
                    emojiId: emojiId,
                    fitToHeight: (0, $dMkEH.RESOURCED_EMOJI_COMPACT_HEIGHT)
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idI8K.Counter), {
                value: reaction.count,
                highlight: !isViewOnly && reaction.reacted
            })
        ]
    });
    let reactionAriaLabel = intl.formatMessage((0, $ihA8Z.messages).reactWithEmoji, {
        emoji: emojiName
    });
    if (reaction.count) reactionAriaLabel = intl.formatMessage((0, $ihA8Z.messages).reactWithEmojiAndCount, {
        emoji: emojiName,
        count: reaction.count
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
        xcss: $4814c1443312b728$var$styles.container,
        children: [
            showParticleEffect && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2DWJV.ReactionParticleEffect), {
                emojiId: emojiId,
                emojiProvider: emojiProvider
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fN5xL.ReactionTooltip), {
                emojiName: emojiName,
                reaction: reaction,
                isEnabled: isTooltipEnabled,
                allowUserDialog: allowUserDialog,
                handleOpenReactionsDialog: handleOpenReactionsDialog,
                dismissTooltip: dismissTooltip,
                children: isViewOnly ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $84c1t.StaticReaction), {
                    onMouseEnter: handleMouseEnter,
                    onFocus: handleFocused,
                    testId: $4814c1443312b728$export$b64f94cf5ea5f111,
                    dataAttributes: {
                        'data-emoji-id': reaction.emojiId
                    },
                    children: emojiAndCount
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $25NfL.ReactionButton), {
                    onClick: handleClick,
                    flash: flash,
                    ariaLabel: reactionAriaLabel,
                    ariaPressed: reacted,
                    onMouseEnter: handleMouseEnter,
                    onFocus: handleFocused,
                    testId: $4814c1443312b728$export$b64f94cf5ea5f111,
                    dataAttributes: {
                        'data-emoji-id': reaction.emojiId,
                        'data-emoji-button-id': reaction.emojiId
                    },
                    showOpaqueBackground: showOpaqueBackground,
                    showSubtleStyle: showSubtleStyle,
                    reacted: reacted,
                    children: emojiAndCount
                })
            })
        ]
    });
};

});
parcelRegister("2l0ub", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dfb11fb8acb3045$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cC0Yc = parcelRequire("cC0Yc");

var $jagXT = parcelRequire("jagXT");

var $d2UcN = parcelRequire("d2UcN");

var $kin1Z = parcelRequire("kin1Z");
const $1dfb11fb8acb3045$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $kin1Z.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $d2UcN.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jagXT.UfoErrorBoundary), {
        experiences: [
            (0, $d2UcN.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cC0Yc.ResourcedEmojiComponent), {
            ...props
        })
    });
};
var $1dfb11fb8acb3045$export$2e2bcd8739ae039 = $1dfb11fb8acb3045$var$ResourcedEmoji;

});
parcelRegister("cC0Yc", function(module, exports) {

$parcel$export(module.exports, "ResourcedEmojiComponent", () => $7e04d51fabd85670$export$7bfde52eceb3e2f6);
/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kin1Z = parcelRequire("kin1Z");

var $5B9Cy = parcelRequire("5B9Cy");

var $9AR2K = parcelRequire("9AR2K");

var $7LZcH = parcelRequire("7LZcH");

var $kAeq1 = parcelRequire("kAeq1");

var $d2UcN = parcelRequire("d2UcN");

var $fIUtB = parcelRequire("fIUtB");

var $d2UcN = parcelRequire("d2UcN");
var $7e04d51fabd85670$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($7e04d51fabd85670$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $7e04d51fabd85670$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $kin1Z.defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $5uXOq.useState)();
    const [loaded, setLoaded] = (0, $5uXOq.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $5uXOq.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $5uXOq.useState)();
    const fetchOrGetEmoji = (0, $5uXOq.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
        (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).mark((0, $9AR2K.UfoEmojiTimings).METADATA_START);
        if ((0, $5B9Cy.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                    // emoji is undefined
                    (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).mark((0, $9AR2K.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).mark((0, $9AR2K.UfoEmojiTimings).METADATA_END);
        }
    }, [
        onEmojiLoadFail
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $d2UcN.hasUfoMarked)((0, $d2UcN.sampledUfoRenderedEmoji)(emojiId), (0, $9AR2K.UfoEmojiTimings).FMP_END)) (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
   * Setting resolved emoji provider for optimistic rendering
   */ (0, $5uXOq.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $5uXOq.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $5uXOq.useMemo)(()=>{
        if (optimisticImageURL) {
            if (emoji && ((0, $5B9Cy.isImageRepresentation)(emoji.representation) || (0, $5B9Cy.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $kin1Z.defaultEmojiHeight),
                    width: fitToHeight || (0, $kin1Z.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName
    ]);
    const handleOnLoadError = (0, $5uXOq.useCallback)((emojiId)=>{
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $d2UcN.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail
    ]);
    const handleOnLoadSuccess = (0, $5uXOq.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fIUtB.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName,
            "data-ssr-placeholder": `emoji-${id ?? shortName}`,
            "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
            children: [
                emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kAeq1.default), {
                    shortName: shortName,
                    showTooltip: showTooltip,
                    size: fitToHeight || (0, $kin1Z.defaultEmojiHeight),
                    loading: true,
                    xcss: placeholderXcss
                }),
                emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: customFallback || fallback || shortName
                }),
                emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LZcH.default), {
                    emoji: optimisticEmojiDescription,
                    onLoadError: handleOnLoadError,
                    onLoadSuccess: handleOnLoadSuccess,
                    showTooltip: showTooltip,
                    fitToHeight: fitToHeight,
                    autoWidth: !!emoji ? false : true,
                    editorEmoji: editorEmoji
                })
            ]
        })
    });
};
var $7e04d51fabd85670$export$2e2bcd8739ae039 = $7e04d51fabd85670$export$7bfde52eceb3e2f6;

});
parcelRegister("7LZcH", function(module, exports) {

$parcel$export(module.exports, "EmojiNodeWrapper", () => $e978b8e9836bc944$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $e978b8e9836bc944$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $0Bueq = parcelRequire("0Bueq");

var $kin1Z = parcelRequire("kin1Z");

var $5B9Cy = parcelRequire("5B9Cy");

var $9AR2K = parcelRequire("9AR2K");

var $6f82C = parcelRequire("6f82C");

var $8L6cL = parcelRequire("8L6cL");


var $d2UcN = parcelRequire("d2UcN");
var $d8gl8 = parcelRequire("d8gl8");

var $lsSGz = parcelRequire("lsSGz");

var $7zSof = parcelRequire("7zSof");

var $d2UcN = parcelRequire("d2UcN");

var $jtKZR = parcelRequire("jtKZR");

var $50JWu = parcelRequire("50JWu");
const $e978b8e9836bc944$var$emojiSpriteContainer = null;
const $e978b8e9836bc944$var$emojiImageContainer = null;
const $e978b8e9836bc944$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $kin1Z.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $6f82C.leftClick)(event)) onSelected((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$var$handleKeyDown = (props, event)=>{
    if (!(0, $kin1Z.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $kin1Z.KeyboardKeys).Enter || event.key === (0, $kin1Z.KeyboardKeys).Space)) onSelected((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $kin1Z.KeyboardKeys).Backspace) $e978b8e9836bc944$var$handleDelete(props, event);
};
const $e978b8e9836bc944$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $5B9Cy.toEmojiId)(emoji), emoji, event);
};
const $e978b8e9836bc944$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $63856011855bb785$export$b06c4aab1d012063)} ${selected ? (0, $63856011855bb785$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $63856011855bb785$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
    };
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($e978b8e9836bc944$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $63856011855bb785$export$1c10634420a08d8a),
            style: style
        })
    }));
};
const $e978b8e9836bc944$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $7zSof.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $d2UcN.sampledUfoRenderedEmoji)(emoji);
    const classes = `${(0, $63856011855bb785$export$11462c0756c24ab6)} ${(0, $63856011855bb785$export$b06c4aab1d012063)} ${selected ? (0, $63856011855bb785$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $63856011855bb785$export$860109dfd198259b) : ''} ${(0, $63856011855bb785$export$da61cef1c8919f7c)} ${className ? className : ''} ${showDelete ? (0, $63856011855bb785$export$22b19c311e9caa4) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $0Bueq.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $5B9Cy.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $5B9Cy.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) // Presize image, to prevent reflow due to size changes after loading
    sizing = {
        // Size of <img> needs to be deterministic when rendered on server-side. Auto will cause width to be 0 before image is loaded.
        width: autoWidth && !(0, $50JWu.isSSR)() ? 'auto' : fitToHeight / height * width,
        height: fitToHeight
    };
    const onError = (0, $5uXOq.useCallback)((event)=>{
        $e978b8e9836bc944$var$handleImageError(props, event);
    }, [
        props
    ]);
    const onLoad = (0, $5uXOq.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9AR2K.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, (0, $9AR2K.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9AR2K.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9AR2K.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, (0, $9AR2K.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $9AR2K.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $lsSGz.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, (0, $9AR2K.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9AR2K.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $5uXOq.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!document.activeElement?.contains(e.target)) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $5uXOq.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        //@ts-ignore
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        alt: emoji.name || emoji.shortName,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }, src);
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtKZR.DeletableEmojiTooltipContent), {}),
        position: "right-start",
        tag: "span",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($e978b8e9836bc944$export$ce5eef59d8e46687, {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: onMouseOver,
            children: [
                emojiNode,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8L6cL.default), {
                    onClick: (event)=>$e978b8e9836bc944$var$handleDelete(props, event)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtKZR.DeletableEmojiTooltipContentForScreenReader), {
                    emoji: emoji
                })
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($e978b8e9836bc944$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref,
        children: emojiNode
    }));
};
const $e978b8e9836bc944$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    let accessibilityProps;
    if (editorEmoji) accessibilityProps = {
        role: undefined
    };
    else if (shouldBeInteractive) accessibilityProps = {
        role: 'button',
        'aria-label': emoji.shortName
    };
    else accessibilityProps = {
        role: 'img',
        'aria-label': emoji.shortName
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...accessibilityProps,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50scvx _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j14ae _3naf14ae _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc" : "_2rkosqtm _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j14ae _3naf14ae _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc",
            className
        ]),
        onKeyDown: (event)=>$e978b8e9836bc944$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $e978b8e9836bc944$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $e978b8e9836bc944$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $e978b8e9836bc944$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other,
        children: children
    });
});
const $e978b8e9836bc944$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $d8gl8.useSampledUFOComponentExperience)((0, $d2UcN.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $kin1Z.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $5uXOq.useEffect)(()=>{
        const ufoExp = (0, $d2UcN.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $d2UcN.hasUfoMarked)(ufoExp, (0, $9AR2K.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $9AR2K.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $5B9Cy.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $2OMIu.jsx)($e978b8e9836bc944$export$ef49ddbb198ce334, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e978b8e9836bc944$export$99dfeb9d71c11788, {
        ...props
    });
};
var $e978b8e9836bc944$export$2e2bcd8739ae039 = $e978b8e9836bc944$export$56cc48506ff790a;

});
parcelRegister("6f82C", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $4e45da7e67a9a10d$export$34ebdaf2c517ae75);
function $4e45da7e67a9a10d$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $4e45da7e67a9a10d$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $4e45da7e67a9a10d$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("8L6cL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebae65259713fbe9$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $kxFlx = parcelRequire("kxFlx");


var $kin1Z = parcelRequire("kin1Z");


var $MHKc7 = parcelRequire("MHKc7");
const $ebae65259713fbe9$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $ebae65259713fbe9$var$deleteButton = null;
const $ebae65259713fbe9$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $ebae65259713fbe9$var$DeleteButton = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            (0, $63856011855bb785$export$b11fa39b56a371f6)
        ]),
        "data-testid": $ebae65259713fbe9$export$28fc7374cf1206d4,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $ebae65259713fbe9$var$styles.boxWrapperStyle,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kxFlx))), {
                    label: (0, $kin1Z.deleteEmojiLabel),
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
                    LEGACY_size: "small",
                    size: "small"
                })
            }),
            onClick: props.onClick,
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        })
    });
var $ebae65259713fbe9$export$2e2bcd8739ae039 = $ebae65259713fbe9$var$DeleteButton;

});
const $63856011855bb785$export$8633a0edef8e95dd = 'emoji-common-selected';
const $63856011855bb785$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $63856011855bb785$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $63856011855bb785$export$b06c4aab1d012063 = 'emoji-common-node';
const $63856011855bb785$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $63856011855bb785$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $63856011855bb785$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $63856011855bb785$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $63856011855bb785$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $63856011855bb785$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("d8gl8", function(module, exports) {

$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $56723850686121aa$export$f959821a7419dee1);

var $5uXOq = parcelRequire("5uXOq");

var $bHWpv = parcelRequire("bHWpv");
const $56723850686121aa$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $56723850686121aa$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            (0, $bHWpv.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $56723850686121aa$var$useConstructor(()=>{
        (0, $bHWpv.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("lsSGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b352fff4283dbda5$export$2e2bcd8739ae039);
const $b352fff4283dbda5$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $b352fff4283dbda5$var$result.mac = /Mac/.test(navigator.platform);
    $b352fff4283dbda5$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $b352fff4283dbda5$export$2e2bcd8739ae039 = $b352fff4283dbda5$var$result;

});

parcelRegister("7zSof", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $58303c715e6c41b6$export$2f62ee6831462844);

var $6ggyj = parcelRequire("6ggyj");

var $lsSGz = parcelRequire("lsSGz");
const $58303c715e6c41b6$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $6ggyj.useInView)(options);
    if (!(0, $lsSGz.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("6ggyj", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $48f113a7cf9419a6$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $48f113a7cf9419a6$var$_extends() {
    $48f113a7cf9419a6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48f113a7cf9419a6$var$_extends.apply(this, arguments);
}
function $48f113a7cf9419a6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $48f113a7cf9419a6$var$_setPrototypeOf(subClass, superClass);
}
function $48f113a7cf9419a6$var$_setPrototypeOf(o, p) {
    $48f113a7cf9419a6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $48f113a7cf9419a6$var$_setPrototypeOf(o, p);
}
function $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $48f113a7cf9419a6$var$observerMap = new Map();
var $48f113a7cf9419a6$var$RootIds = new WeakMap();
var $48f113a7cf9419a6$var$rootId = 0;
var $48f113a7cf9419a6$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $48f113a7cf9419a6$export$2ef3a60ee1f37bec(inView) {
    $48f113a7cf9419a6$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $48f113a7cf9419a6$var$getRootId(root) {
    if (!root) return '0';
    if ($48f113a7cf9419a6$var$RootIds.has(root)) return $48f113a7cf9419a6$var$RootIds.get(root);
    $48f113a7cf9419a6$var$rootId += 1;
    $48f113a7cf9419a6$var$RootIds.set(root, $48f113a7cf9419a6$var$rootId.toString());
    return $48f113a7cf9419a6$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $48f113a7cf9419a6$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $48f113a7cf9419a6$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $48f113a7cf9419a6$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $48f113a7cf9419a6$var$optionsToId(options);
    var instance = $48f113a7cf9419a6$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $48f113a7cf9419a6$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $48f113a7cf9419a6$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $48f113a7cf9419a6$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $48f113a7cf9419a6$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $48f113a7cf9419a6$var$observerMap["delete"](id);
        }
    };
}
var $48f113a7cf9419a6$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $48f113a7cf9419a6$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $48f113a7cf9419a6$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $48f113a7cf9419a6$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$48f113a7cf9419a6$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $48f113a7cf9419a6$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$48f113a7cf9419a6$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(_this$props2, $48f113a7cf9419a6$var$_excluded);
        return /*#__PURE__*/ $5uXOq.createElement(as || 'div', $48f113a7cf9419a6$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($5uXOq.Component);
$48f113a7cf9419a6$export$a62107ca74432f44.displayName = 'InView';
$48f113a7cf9419a6$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $48f113a7cf9419a6$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $5uXOq.useRef();
    var _React$useState = $5uXOq.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $5uXOq.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $48f113a7cf9419a6$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $5uXOq.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


parcelRegister("jtKZR", function(module, exports) {

$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $1932ba1320ae3825$export$4727956877b6f612);
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $1932ba1320ae3825$export$d151e4941072147c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $aSE1r = parcelRequire("aSE1r");

var $bjlYp = parcelRequire("bjlYp");

var $cH8IX = parcelRequire("cH8IX");

var $jldZL = parcelRequire("jldZL");
const $1932ba1320ae3825$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bjlYp.ToolTipContentWithKeymap), {
        description: formatMessage((0, $aSE1r.messages).deleteEmojiTooltip),
        keymap: (0, $cH8IX.backspace)
    });
};
const $1932ba1320ae3825$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
        id: `screenreader-emoji-${emoji.id}`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $aSE1r.messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        })
    });
};

});
parcelRegister("bjlYp", function(module, exports) {

$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $bf61861434f5a860$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cH8IX = parcelRequire("cH8IX");
const $bf61861434f5a860$var$tooltipShortcutStyle = null;
const $bf61861434f5a860$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $cH8IX.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            description,
            shortcut && description && '\u00A0',
            shortcut && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_2rko1l7b _bfhk17rn _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
                ]),
                children: shortcut
            })
        ]
    }) : null;
});

});
parcelRegister("cH8IX", function(module, exports) {

$parcel$export(module.exports, "backspace", () => $8c801b5eb0fedf3e$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "formatShortcut", () => $8c801b5eb0fedf3e$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $lsSGz = parcelRequire("lsSGz");
const $8c801b5eb0fedf3e$export$1ea584ca7009bcc1 = $8c801b5eb0fedf3e$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $8c801b5eb0fedf3e$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $8c801b5eb0fedf3e$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $8c801b5eb0fedf3e$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $8c801b5eb0fedf3e$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $8c801b5eb0fedf3e$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $lsSGz.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $8c801b5eb0fedf3e$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $lsSGz.default).mac ? '' : '+');
}

});



parcelRegister("50JWu", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $ea1a71963de9abbf$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $ea1a71963de9abbf$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && $6cAn5?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("kAeq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b03b8ed1cdbc30$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $kin1Z = parcelRequire("kin1Z");

const $e3b03b8ed1cdbc30$var$placeholderContainer = null;
const $e3b03b8ed1cdbc30$var$easeSweep = null;
const $e3b03b8ed1cdbc30$var$placeholderContainerAnimated = null;
const $e3b03b8ed1cdbc30$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $e3b03b8ed1cdbc30$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $kin1Z.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": $e3b03b8ed1cdbc30$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkosqtm _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhkttw1 _s7n4nkob _o5721q9c _y3gn1h6o",
            loading && !(0, $VSDnB.fg)('cc_complexit_fe_remove_emoji_animation') && "",
            loading && !(0, $VSDnB.fg)('cc_complexit_fe_remove_emoji_animation') && "_1kt9b3bt _cfu11ule _1cs8stnw _1rusiw92 _kfgt1osq _1mp41osq _1088zfu5 _joxl9cwz _zo24167c _evp612c5",
            [
                (0, $63856011855bb785$export$c7187bbd1a7a9244),
                (0, $VSDnB.fg)('platform_reactions_placeholder_custom_background') ? xcss : ''
            ].join(' ')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $e3b03b8ed1cdbc30$export$2e2bcd8739ae039 = $e3b03b8ed1cdbc30$var$EmojiPlaceholder;

});

parcelRegister("fIUtB", function(module, exports) {

$parcel$export(module.exports, "EmojiCommonProvider", () => $bccbd11b1b65c6ff$export$1120e666998e21b5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jXu3z = parcelRequire("jXu3z");
const $bccbd11b1b65c6ff$export$1120e666998e21b5 = (props)=>{
    if (props.emojiProvider) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jXu3z.EmojiContextProvider), {
        emojiContextValue: {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        },
        children: props.children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: props.children
    });
};

});
parcelRegister("jXu3z", function(module, exports) {

$parcel$export(module.exports, "EmojiContextProvider", () => $13463f47d01f8908$export$f4a09143833145ed);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hXj7Q = parcelRequire("hXj7Q");

var $b8sgr = parcelRequire("b8sgr");
const $13463f47d01f8908$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $5uXOq.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $b8sgr.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hXj7Q.EmojiContext).Provider, {
        value: memoizedEmojiContextValue,
        children: children
    });
};

});
parcelRegister("hXj7Q", function(module, exports) {

$parcel$export(module.exports, "EmojiContext", () => $328171771ca4c781$export$9fab6c37a453c65e);

var $5uXOq = parcelRequire("5uXOq");
const $328171771ca4c781$export$9fab6c37a453c65e = (0, $5uXOq.createContext)(null);

});




parcelRegister("jagXT", function(module, exports) {

$parcel$export(module.exports, "UfoErrorBoundary", () => $e764d90a3b7c2797$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");
class $e764d90a3b7c2797$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("idI8K", function(module, exports) {

$parcel$export(module.exports, "Counter", () => $e2c5b7c70df37267$export$1b74141c5fe63a28);
/* Counter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $35XSW = parcelRequire("35XSW");
var $8Sbj3 = parcelRequire("8Sbj3");

var $E3WGX = parcelRequire("E3WGX");
const $e2c5b7c70df37267$var$containerStyle = null;
const $e2c5b7c70df37267$var$counterLabelStyle = null;
const $e2c5b7c70df37267$var$countStyle = null;
const $e2c5b7c70df37267$var$highlightStyle = null;
const $e2c5b7c70df37267$var$darkerFontStyle = null;
const $e2c5b7c70df37267$var$updatedStyles = null;
const $e2c5b7c70df37267$export$abd04e330cfe02b = 'counter-wrapper';
const $e2c5b7c70df37267$export$5d72ec7afc5923f4 = 'counter-container';
const $e2c5b7c70df37267$export$3b4c1ed5ad4af669 = 'counter_label_wrapper';
const $e2c5b7c70df37267$export$1b74141c5fe63a28 = ({ highlight: highlight = false, limit: limit, overLimitLabel: overLimitLabel, className: className, value: value, animationDuration: animationDuration = 'medium', useDarkerFont: useDarkerFont, useUpdatedStyles: useUpdatedStyles })=>{
    const getLabel = (value)=>{
        // Check if reached limit
        if (limit && overLimitLabel && value >= limit) return overLimitLabel || '';
        else if (value === 0) return '';
        else return (0, $E3WGX.formatLargeNumber)(value);
    };
    const lastValue = (0, $5uXOq.useRef)();
    const label = getLabel(value);
    (0, $5uXOq.useEffect)(()=>{
        lastValue.current = value;
    }, [
        value
    ]);
    const isIncreasing = (0, $5uXOq.useMemo)(()=>{
        return lastValue.current ? lastValue.current < value : false;
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1ifp _kqswh2mm _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvidpf _vwz4dlk8",
            useDarkerFont && "_syaz1gjq",
            useUpdatedStyles && "_19pkv77o",
            className
        ]),
        "data-testid": $e2c5b7c70df37267$export$abd04e330cfe02b,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
                enterFrom: isIncreasing ? 'top' : 'bottom',
                exitTo: isIncreasing ? 'top' : 'bottom',
                duration: animationDuration,
                children: (motion, direction)=>{
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ref: motion.ref,
                        style: {
                            position: direction === 'exiting' ? 'absolute' : undefined
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $bwpsq.default)([
                            "_1e0c1txw _2lx21bp4",
                            motion.className
                        ]),
                        "data-testid": $e2c5b7c70df37267$export$5d72ec7afc5923f4,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": $e2c5b7c70df37267$export$3b4c1ed5ad4af669,
                            className: (0, $bwpsq.default)([
                                "_1x821ts4",
                                highlight && "_syaz1ldt"
                            ]),
                            children: label
                        }, value)
                    });
                }
            }, value)
        })
    });
};

});
parcelRegister("E3WGX", function(module, exports) {

$parcel$export(module.exports, "isLeftClick", () => $ed6a4e9652e211f3$export$698c4f0ff5e11e52);
$parcel$export(module.exports, "formatLargeNumber", () => $ed6a4e9652e211f3$export$2369f32a5da9d5b8);

var $dMkEH = parcelRequire("dMkEH");
const $ed6a4e9652e211f3$export$698c4f0ff5e11e52 = (event)=>event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
const $ed6a4e9652e211f3$export$486a422686c27c1 = (item)=>(0, $dMkEH.DefaultReactions).some((otherEmojiId)=>$ed6a4e9652e211f3$var$isEqualEmojiId(otherEmojiId, item));
/**
 * compare 2 emoji items if they are same input
 * @param a first emoji item
 * @param b second emoji item
 */ const $ed6a4e9652e211f3$var$isEqualEmojiId = (a, b)=>{
    if ($ed6a4e9652e211f3$var$isEmojiId(a) && $ed6a4e9652e211f3$var$isEmojiId(b)) return a === b || a && b && a.id === b.id && a.shortName === b.shortName;
    else return a === b;
};
/**
 * Type guard if provided object is a string id or an object info collection for the emoji
 * @param item given item
 */ const $ed6a4e9652e211f3$var$isEmojiId = (item)=>{
    return item.id !== undefined;
};
const $ed6a4e9652e211f3$export$cabcad7683a98538 = (value, decimalPlaces)=>{
    const decimalIndex = value.indexOf('.');
    if (decimalIndex === -1) // Integers with trailing 0s will have no decimal (Ex. 18000, 7700000, 500)
    return value.substring(0, value.length);
    if (decimalPlaces === 0) // Return an integer value
    return value.substring(0, decimalIndex);
    return value.substring(0, decimalIndex + decimalPlaces + 1);
};
const $ed6a4e9652e211f3$export$2369f32a5da9d5b8 = (value)=>{
    // 999M+
    const maxLimit = 999999999;
    const thounsandSeparator = 1000;
    const millionSeparator = 1000000;
    const valueInK = value / thounsandSeparator;
    const valueInM = value / millionSeparator;
    if (value > maxLimit) return '999.9M+';
    if (value >= 1000000) {
        // determine the decimal breakpoints by length and check its value
        // 1234567 -> 1.234567 and decimal value is 2
        const numDigits = value.toString().length;
        const decimalIndexValue = valueInM.toString().charAt(numDigits - 5);
        return decimalIndexValue === '0' ? $ed6a4e9652e211f3$export$cabcad7683a98538(valueInM.toString(), 0) + 'M' : $ed6a4e9652e211f3$export$cabcad7683a98538(valueInM.toString(), 1) + 'M';
    }
    if (value >= 1000) {
        const numDigits = value.toString().length;
        const decimalIndexValue = valueInK.toString().charAt(numDigits - 2);
        return decimalIndexValue === '0' ? $ed6a4e9652e211f3$export$cabcad7683a98538(valueInK.toString(), 0) + 'K' : $ed6a4e9652e211f3$export$cabcad7683a98538(valueInK.toString(), 1) + 'K';
    }
    // <999
    return value.toString();
};

});


parcelRegister("2DWJV", function(module, exports) {

$parcel$export(module.exports, "ReactionParticleEffect", () => $0b482f92cdd485a8$export$2538eeb2e8d3da5e);
/* ReactionParticleEffect.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2l0ub = parcelRequire("2l0ub");

var $dMkEH = parcelRequire("dMkEH");
const $0b482f92cdd485a8$var$containerStyle = null;
const $0b482f92cdd485a8$var$reactionParticleStyle = null;
const $0b482f92cdd485a8$export$ffc0241869fe445 = 4;
const $0b482f92cdd485a8$export$2538eeb2e8d3da5e = ({ emojiProvider: emojiProvider, emojiId: emojiId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1ltvftgi _1pbyifev _m602idpf"
        ]),
        children: [
            ...Array($0b482f92cdd485a8$export$ffc0241869fe445)
        ].map((_, index)=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_y44v7u0o _kqswstnw _154iidpf _1ltvidpf _lcxvglyw _tzy4idpf _5sagpwmj _1qen1lpd _xg4k6ebc _91vyftgi _1lac188d _jsy51n1a _7vm81dfm"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2l0ub.default), {
                    emojiProvider: emojiProvider,
                    emojiId: emojiId,
                    fitToHeight: (0, $dMkEH.RESOURCED_EMOJI_COMPACT_HEIGHT)
                })
            }, index);
        })
    });

});

parcelRegister("fN5xL", function(module, exports) {

$parcel$export(module.exports, "ReactionTooltip", () => $f028e0d5ee32c9fd$export$22b33b34188069b6);
/* ReactionTooltip.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");

var $dMkEH = parcelRequire("dMkEH");

var $ihA8Z = parcelRequire("ihA8Z");
const $f028e0d5ee32c9fd$export$507197e0ca3872c2 = 5;
const $f028e0d5ee32c9fd$var$tooltipStyle = null;
const $f028e0d5ee32c9fd$var$emojiNameStyle = null;
const $f028e0d5ee32c9fd$var$footerStyle = null;
const $f028e0d5ee32c9fd$var$underlineStyle = null;
const $f028e0d5ee32c9fd$export$4850cb7690e62d5f = 'render-reactionTooltip';
const $f028e0d5ee32c9fd$export$22b33b34188069b6 = ({ children: children, emojiName: emojiName, reaction: { users: users = [] }, maxReactions: maxReactions = (0, $dMkEH.TOOLTIP_USERS_LIMIT), isEnabled: isEnabled = true, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, dismissTooltip: dismissTooltip })=>{
    const handleClick = ()=>{
        if (allowUserDialog && handleOpenReactionsDialog) {
            dismissTooltip();
            handleOpenReactionsDialog();
        }
    };
    const content = !users || users.length === 0 || !isEnabled ? null : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        tabIndex: 0,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _p12f1w81 _1bto1l2s _o5721q9c _otyr14y2 _d1n8glyw _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hziidpf _3n4midpf _ltofidpf _k7zyidpf _1ywo1e5h _1pru15vq _u0h115vq _5qec1l2s _1eg614y2"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("ul", {
            children: [
                emojiName ? /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                    className: (0, $bwpsq.default)([
                        "_1p1d1dk0 _syaz6r0x _k48p1pd9"
                    ]),
                    children: emojiName
                }) : null,
                users.slice(0, maxReactions).map((user)=>{
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                        children: user.displayName
                    }, user.id);
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                    onMouseDown: handleClick,
                    onClick: handleClick,
                    className: (0, $bwpsq.default)([
                        "_syaz6r0x",
                        allowUserDialog && "_4bfu18uv _1hms8stv _ajmmnqa1 _80omtlke _irr3gkf6 _30l315cr"
                    ]),
                    children: users.length > maxReactions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $ihA8Z.messages).otherUsers,
                        values: {
                            count: users.length - maxReactions
                        }
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: content,
        position: "bottom",
        testId: $f028e0d5ee32c9fd$export$4850cb7690e62d5f,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children)
    });
};

});

parcelRegister("25NfL", function(module, exports) {

$parcel$export(module.exports, "ReactionButton", () => $16f4d4c406fae3ee$export$6ce3894c36b53067);
/* ReactionButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $1wJK6 = parcelRequire("1wJK6");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");
const $16f4d4c406fae3ee$var$styles = {
    reactionButton: "_2rko14q2 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _2lx2vrvc _4cvr1y6m _1ul914no _4t3i1tcg _bfhk1w7a _syaz1gjq _1pfh1b66 _12l21b66 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _irr3166n _1di61dty",
    reactionStylesRefresh: "_2rkoglpi",
    reacted: "_1h6d1yqz _bfhkfg4m _irr3i1yw _1di619ru",
    opaqueBackground: "_bfhkvuon _irr3108i _1di61ji5",
    compactButton: "_4t3igktf _4cvr1h6o _19pk12x7",
    borderless: "_1dqoglyw"
};
/**
 * Default styling px height for an emoji reaction
 */ const $16f4d4c406fae3ee$var$akHeight = 24;
const $16f4d4c406fae3ee$var$flashHeight = $16f4d4c406fae3ee$var$akHeight - 2; // height without the 1px border
const $16f4d4c406fae3ee$var$flashStyle = null;
const $16f4d4c406fae3ee$var$flashStyleOld = null;
const $16f4d4c406fae3ee$export$6ce3894c36b53067 = ({ onClick: onClick, flash: flash = false, showSubtleStyle: showSubtleStyle, showOpaqueBackground: showOpaqueBackground, useCompactStyles: useCompactStyles, reacted: reacted, ariaLabel: ariaLabel, ariaPressed: ariaPressed, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, children: children, dataAttributes: dataAttributes = {}, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        testId: testId,
        xcss: (0, $DEWI6.cx)($16f4d4c406fae3ee$var$styles.reactionButton, useCompactStyles && $16f4d4c406fae3ee$var$styles.compactButton, reacted && $16f4d4c406fae3ee$var$styles.reacted, !reacted && showSubtleStyle && $16f4d4c406fae3ee$var$styles.borderless, !reacted && showOpaqueBackground && $16f4d4c406fae3ee$var$styles.opaqueBackground, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $VSDnB.fg)('platform-component-visual-refresh') && $16f4d4c406fae3ee$var$styles.reactionStylesRefresh),
        ...dataAttributes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1wJK6.FlashAnimation), {
            flash: flash,
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            className: (0, $bwpsq.default)([
                (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_2rkogqwt _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3iqslr" : "_2rko19bv _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3iqslr"
            ]),
            children: children
        })
    });
};

});
parcelRegister("1wJK6", function(module, exports) {

$parcel$export(module.exports, "FlashAnimation", () => $c30ef2e4d0f647a5$export$2b501aee548bae06);
/* FlashAnimation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c30ef2e4d0f647a5$var$flashTime = 700;
const $c30ef2e4d0f647a5$var$flashAnimation = null;
const $c30ef2e4d0f647a5$var$containerStyle = null;
const $c30ef2e4d0f647a5$var$flashStyle = null;
const $c30ef2e4d0f647a5$export$101a417749e701a3 = 'flash-animation';
const $c30ef2e4d0f647a5$export$2b501aee548bae06 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq",
            props.flash && "",
            props.flash && "_j7hqdjji _5sagpwmj _1pgl1ytf",
            props.className
        ]),
        "data-testid": $c30ef2e4d0f647a5$export$101a417749e701a3,
        children: props.children
    });

});


parcelRegister("84c1t", function(module, exports) {

$parcel$export(module.exports, "StaticReaction", () => $203408b0835a35b1$export$1a66ed011c614568);
/* StaticReaction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3Lty3 = parcelRequire("3Lty3");
const $203408b0835a35b1$var$styles = {
    staticReaction: "_1reo15vq _18m915vq _19itglyw _2rkoglpi _1e0c1txw _2lx2vrvc _4cvr1y6m _1ul914no _4t3i1tcg _bfhk1w7a _syaz1gjq _1pfh1b66 _12l21b66 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0al73ad _irr3166n"
};
const $203408b0835a35b1$export$1a66ed011c614568 = ({ onMouseEnter: onMouseEnter, onFocus: onFocus, children: children, testId: testId, dataAttributes: dataAttributes = {} })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        testId: testId,
        xcss: $203408b0835a35b1$var$styles.staticReaction,
        ...dataAttributes,
        children: children
    });
};

});


parcelRegister("jYy4G", function(module, exports) {

$parcel$export(module.exports, "ReactionsDialog", () => $f21ae73d1f16d399$export$df84a24235404de6);
/* ReactionsDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fphHl = parcelRequire("fphHl");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");

var $MHKc7 = parcelRequire("MHKc7");

var $dMkEH = parcelRequire("dMkEH");

var $aUA9v = parcelRequire("aUA9v");

var $jvrtL = parcelRequire("jvrtL");
const $f21ae73d1f16d399$var$styles = {
    modalBodyStyle: "_otyr1ejb"
};
/* Reactions Container. Using pseudo Element :after to set border since with onClick of Reaction to higlight the
border blue below the reaction. */ const $f21ae73d1f16d399$var$containerStyle = null;
const $f21ae73d1f16d399$export$ef88759cddab4775 = 'render-reactions-modal';
const $f21ae73d1f16d399$export$df84a24235404de6 = ({ reactions: reactions = [], handleCloseReactionsDialog: handleCloseReactionsDialog = ()=>{}, emojiProvider: emojiProvider, selectedEmojiId: selectedEmojiId, handleSelectReaction: handleSelectReaction = ()=>{}, handlePaginationChange: handlePaginationChange = ()=>{}, ProfileCardWrapper: ProfileCardWrapper })=>{
    const [hasNavigatedPages, setHasNavigatedPages] = (0, $5uXOq.useState)(false);
    const [currentPage, setCurrentPage] = (0, $5uXOq.useState)(1);
    const totalReactionsCount = (0, $5uXOq.useMemo)(()=>{
        return reactions.reduce((accum, current)=>{
            return accum += current?.count;
        }, 0);
    }, [
        reactions
    ]);
    const maxPages = Math.max(1, Math.ceil(reactions.length / (0, $dMkEH.NUMBER_OF_REACTIONS_TO_DISPLAY)));
    const currentReactions = (0, $5uXOq.useMemo)(()=>{
        const start = (currentPage - 1) * (0, $dMkEH.NUMBER_OF_REACTIONS_TO_DISPLAY);
        const end = start + (0, $dMkEH.NUMBER_OF_REACTIONS_TO_DISPLAY);
        return reactions.slice(start, end);
    }, [
        reactions,
        currentPage
    ]);
    const handleNextPage = ()=>{
        setCurrentPage((prevPage)=>Math.min(prevPage + 1, maxPages));
        setHasNavigatedPages(true);
    };
    const handlePreviousPage = ()=>{
        setCurrentPage((prevPage)=>Math.max(prevPage - 1, 1));
        setHasNavigatedPages(true);
    };
    const firstEmojiOnPage = currentReactions[0]?.emojiId;
    (0, $5uXOq.useEffect)(()=>{
        // trigger the handler with the first emoji when the page changes
        if (hasNavigatedPages && firstEmojiOnPage) handlePaginationChange(firstEmojiOnPage, currentPage, maxPages);
    }, [
        hasNavigatedPages,
        currentPage,
        maxPages,
        firstEmojiOnPage,
        handlePaginationChange
    ]);
    const selectedIndex = currentReactions.findIndex((reaction)=>reaction.emojiId === selectedEmojiId);
    const onTabChange = (0, $5uXOq.useCallback)((index)=>{
        if (index === selectedIndex) return;
        const emojiId = currentReactions[index].emojiId;
        handleSelectReaction(emojiId);
    }, [
        selectedIndex,
        currentReactions,
        handleSelectReaction
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
        onClose: handleCloseReactionsDialog,
        height: 600,
        testId: $f21ae73d1f16d399$export$ef88759cddab4775,
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fphHl.default), {
            id: "reactions-dialog-tabs",
            onChange: onTabChange,
            selected: selectedIndex,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jvrtL.ReactionsDialogHeader), {
                    totalReactionsCount: totalReactionsCount,
                    maxPages: maxPages,
                    handlePreviousPage: handlePreviousPage,
                    handleNextPage: handleNextPage,
                    currentPage: currentPage,
                    emojiProvider: emojiProvider,
                    currentReactions: currentReactions,
                    handleCloseReactionsDialog: handleCloseReactionsDialog
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $f21ae73d1f16d399$var$styles.modalBodyStyle,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                "_1reo15vq _18m915vq _4t3i1osq _1e0c1txw _1bahv2br _kqswh2mm _1dm8q5uf _aetrb3bt _1bqqidpf _1ywu1ule _1yd81osq _1x88idpf _18postnw"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aUA9v.ReactionsList), {
                                selectedEmojiId: selectedEmojiId,
                                reactions: currentReactions,
                                ProfileCardWrapper: ProfileCardWrapper
                            })
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("aUA9v", function(module, exports) {

$parcel$export(module.exports, "ReactionsList", () => $eb310345f8ec5b46$export$a87089fe362b9d93);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $2kzjf = parcelRequire("2kzjf");
const $eb310345f8ec5b46$export$a87089fe362b9d93 = ({ reactions: reactions, selectedEmojiId: selectedEmojiId, ProfileCardWrapper: ProfileCardWrapper })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        children: reactions.map((reaction)=>{
            if (reaction.emojiId === selectedEmojiId) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2kzjf.ReactionView), {
                reaction: reaction,
                ProfileCardWrapper: ProfileCardWrapper
            }, reaction.emojiId);
            else return null;
        })
    });
};

});
parcelRegister("2kzjf", function(module, exports) {

$parcel$export(module.exports, "ReactionView", () => $06df4d1eed4dc97b$export$5ad09c2943879b39);
/* ReactionView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $eZJjh = parcelRequire("eZJjh");

var $8TQB5 = parcelRequire("8TQB5");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
const $06df4d1eed4dc97b$var$userListStyle = null;
const $06df4d1eed4dc97b$var$userStyle = null;
const $06df4d1eed4dc97b$var$styles = {
    userDescriptionStyle: "_18u0utpp",
    profileWrapperStyle: "_18u0ze3t",
    reactionViewStyle: "_19pkutpp _1tke1mjv _1ul91deq",
    centerSpinnerStyle: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1osq _19pk1ejb"
};
const $06df4d1eed4dc97b$export$5ad09c2943879b39 = ({ reaction: reaction, ProfileCardWrapper: ProfileCardWrapper })=>{
    const alphabeticalNames = (0, $5uXOq.useMemo)(()=>{
        const reactionObj = reaction;
        return reactionObj.users?.sort((a, b)=>a.displayName.localeCompare(b.displayName)) || [];
    }, [
        reaction
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8TQB5.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
            direction: "column",
            xcss: $06df4d1eed4dc97b$var$styles.reactionViewStyle,
            children: alphabeticalNames.length === 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $06df4d1eed4dc97b$var$styles.centerSpinnerStyle,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                    size: "large",
                    interactionName: "reactions-spinner"
                })
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
                className: (0, $bwpsq.default)([
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkpxbi _y3gn1e5h _nccu2smr _thoc10s3"
                ]),
                children: alphabeticalNames.map((user)=>{
                    const profile = user.profilePicture?.path;
                    return /*#__PURE__*/ (0, $2OMIu.jsxs)("li", {
                        className: (0, $bwpsq.default)([
                            "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _19bvidpf _u5f3idpf _24rcpxbi"
                        ]),
                        children: [
                            ProfileCardWrapper && user.accountId ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                xcss: $06df4d1eed4dc97b$var$styles.profileWrapperStyle,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)(ProfileCardWrapper, {
                                    userId: user.accountId,
                                    isAnonymous: false,
                                    canViewProfile: true,
                                    position: "left-start",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
                                        size: "medium",
                                        src: profile,
                                        testId: "profile"
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ujWmd.default), {
                                size: "medium",
                                src: profile,
                                testId: "profile"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                                xcss: $06df4d1eed4dc97b$var$styles.userDescriptionStyle,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    children: user.displayName
                                })
                            })
                        ]
                    }, user.id);
                })
            })
        })
    });
};

});


parcelRegister("jvrtL", function(module, exports) {

$parcel$export(module.exports, "ReactionsDialogHeader", () => $aaa2dfa2f56578d6$export$6c6a0fee39bccb13);
/* ReactionsDialogHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $hxoiH = parcelRequire("hxoiH");

var $gjZMs = parcelRequire("gjZMs");
var $kdO7l = parcelRequire("kdO7l");

var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $3bDjY = parcelRequire("3bDjY");

var $bpC55 = parcelRequire("bpC55");

var $ks8FD = parcelRequire("ks8FD");

var $i28qQ = parcelRequire("i28qQ");

var $2l0ub = parcelRequire("2l0ub");

var $VSDnB = parcelRequire("VSDnB");

var $ihA8Z = parcelRequire("ihA8Z");

var $idI8K = parcelRequire("idI8K");

var $dMkEH = parcelRequire("dMkEH");
const $aaa2dfa2f56578d6$var$styles = {
    leftNavigationStyle: "_19pk1b66 _1wpzynz6 _19bvpxbi _n3tdutpp",
    rightNavigationStyle: "_19pk1b66 _1wpzynz6 _18u01wug _2hwxu2gc",
    fullWidthStyle: "_1bsb1osq _ca0q1ejb _19bv1ejb _u5f31ejb _85i5xy5q",
    emoji: "_1rjc1b66 _8hrz1nam _bozgu2gc _y4ti1b66",
    counterStyle: "_19pkv77o"
};
const $aaa2dfa2f56578d6$var$REACTIONS_CONTAINER_WIDTH = 56;
const $aaa2dfa2f56578d6$var$REACTION_CONTAINER_HEIGHT = 40;
const $aaa2dfa2f56578d6$var$customTabListStyles = null;
const $aaa2dfa2f56578d6$var$customTabWrapper = {
    base: "_1o9zidpf _1e0c1txw _2lx21bp4 _y3gn1h6o _4cvr1h6o _1bah1h6o _1ul98vuz _vchhusvi _kqswh2mm _ogwtgrf3 _6tingrf3 _1cezgrf3 _m3zkgrf3 _6kbe8vuz _1yfp1ylp _dzc21h6o _tij01h6o _nhkt1ecz _2t1tb3bt _mwnsstnw _axenidpf _1xogidpf _1gbg8vuz _rqy31ylp _1jzxidpf _j5n71tsn _c0nrb3bt _1wqistnw _5e04idpf _clnfidpf _1ks28vuz _1ira1ylp _8bggidpf _10d67vkz _aezr7vkz",
    darkTheme: "_nhktj96x _j5n7zopo"
};
const $aaa2dfa2f56578d6$var$firstElement = null;
const $aaa2dfa2f56578d6$var$CloseButtonCustom = ({ handleCloseReactionsDialog: handleCloseReactionsDialog })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
        onClick: handleCloseReactionsDialog,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))),
        label: intl.formatMessage((0, $ihA8Z.messages).closeReactionsDialog),
        appearance: "subtle",
        isTooltipDisabled: false
    });
};
const $aaa2dfa2f56578d6$var$LeftNavigationButton = ({ handlePreviousPage: handlePreviousPage })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
        xcss: $aaa2dfa2f56578d6$var$styles.leftNavigationStyle,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
            spacing: "compact",
            onClick: handlePreviousPage,
            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ks8FD))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $ihA8Z.messages).leftNavigateLabel),
            isTooltipDisabled: false
        })
    });
};
const $aaa2dfa2f56578d6$var$RightNavigationButton = ({ handleNextPage: handleNextPage })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
        xcss: $aaa2dfa2f56578d6$var$styles.rightNavigationStyle,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
            spacing: "compact",
            onClick: handleNextPage,
            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $ihA8Z.messages).rightNavigateLabel),
            isTooltipDisabled: false
        })
    });
};
const $aaa2dfa2f56578d6$export$6c6a0fee39bccb13 = ({ totalReactionsCount: totalReactionsCount, handlePreviousPage: handlePreviousPage, handleNextPage: handleNextPage, currentPage: currentPage, maxPages: maxPages, currentReactions: currentReactions, emojiProvider: emojiProvider, handleCloseReactionsDialog: handleCloseReactionsDialog })=>{
    const [cache, setCache] = (0, $5uXOq.useState)({});
    const { titleId: titleId } = (0, $kdO7l.useModal)();
    const intl = (0, $koVbs.default)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const isSinglePage = maxPages === 1;
    const isOnFirstPage = currentPage === 1;
    const isOnLastPage = currentPage === maxPages;
    const handleMouseEnter = (reaction)=>{
        const { emojiId: emojiId } = reaction;
        if (!emojiId || cache[emojiId]) return;
        (async ()=>{
            // Note: not a network request e.g. ReactedUsersQuery
            const provider = await emojiProvider;
            const emoji = await provider.findByEmojiId({
                shortName: '',
                id: emojiId
            });
            if (emoji?.name) {
                // capitalize first letter of each string
                const capitalizedName = emoji.name.replace(/\b\w/g, (char)=>char.toUpperCase());
                setCache((prevCache)=>({
                        ...prevCache,
                        [emojiId]: capitalizedName
                    }));
            }
        })();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                xcss: $aaa2dfa2f56578d6$var$styles.fullWidthStyle,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "medium",
                        id: titleId,
                        children: intl.formatMessage((0, $ihA8Z.messages).reactionsCount, {
                            count: totalReactionsCount
                        })
                    }),
                    (0, $VSDnB.fg)('platform-make-accessible-close-button') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gjZMs.CloseButton), {
                        onClick: handleCloseReactionsDialog
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($aaa2dfa2f56578d6$var$CloseButtonCustom, {
                        handleCloseReactionsDialog: handleCloseReactionsDialog
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    id: "reactions-dialog-tabs-list",
                    className: (0, $bwpsq.default)([
                        "_1reo1wug _18m91wug _n7zl1l7n _1e0c1txw _1bsb1osq _4cvr1y6m _80wau2gc _s2c4kb7n _141m18uv"
                    ]),
                    children: [
                        !isSinglePage && !isOnFirstPage && /*#__PURE__*/ (0, $2OMIu.jsx)($aaa2dfa2f56578d6$var$LeftNavigationButton, {
                            handlePreviousPage: handlePreviousPage
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cte3m.default), {
                            children: [
                                currentReactions.map((reaction, index)=>{
                                    const emojiId = {
                                        id: reaction.emojiId,
                                        shortName: ''
                                    };
                                    return /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    , {
                                        className: (0, $bwpsq.default)([
                                            $aaa2dfa2f56578d6$var$customTabWrapper.base,
                                            colorMode === 'dark' && $aaa2dfa2f56578d6$var$customTabWrapper.darkTheme,
                                            index === 0 && "_19bvpxbi",
                                            "reaction-elements"
                                        ]),
                                        "data-testid": emojiId?.id,
                                        onMouseEnter: ()=>{
                                            handleMouseEnter(reaction);
                                        },
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jxIT3.default), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                                                content: cache[reaction.emojiId],
                                                canAppear: ()=>!!cache[reaction.emojiId],
                                                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bUmQV.default), {
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    direction: "row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                                            xcss: $aaa2dfa2f56578d6$var$styles.emoji,
                                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2l0ub.default), {
                                                                emojiProvider: emojiProvider,
                                                                emojiId: emojiId,
                                                                fitToHeight: (0, $dMkEH.RESOURCED_EMOJI_COMPACT_HEIGHT),
                                                                showTooltip: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                                            xcss: $aaa2dfa2f56578d6$var$styles.counterStyle,
                                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idI8K.Counter), {
                                                                value: reaction.count
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }, reaction.emojiId);
                                }),
                                !isSinglePage && !isOnLastPage && /*#__PURE__*/ (0, $2OMIu.jsx)($aaa2dfa2f56578d6$var$RightNavigationButton, {
                                    handleNextPage: handleNextPage
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});


parcelRegister("2e3ok", function(module, exports) {

$parcel$export(module.exports, "ReactionPicker", () => $e684828570854ebd$export$1d5ec51e9af399a5);
/* ReactionPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $k9ixM = parcelRequire("k9ixM");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");

var $k5uoT = parcelRequire("k5uoT");

var $MHKc7 = parcelRequire("MHKc7");

var $VSDnB = parcelRequire("VSDnB");

var $jMJTw = parcelRequire("jMJTw");

var $a31i7 = parcelRequire("a31i7");

var $dN7jw = parcelRequire("dN7jw");

var $ihA8Z = parcelRequire("ihA8Z");

var $lWCY0 = parcelRequire("lWCY0");

var $eFqrQ = parcelRequire("eFqrQ");

var $vnfLC = parcelRequire("vnfLC");

var $lPMe5 = parcelRequire("lPMe5");
const $e684828570854ebd$var$pickerStyle = null;
const $e684828570854ebd$var$popupWrapperStyle = null;
const $e684828570854ebd$var$popupStyle = null;
const $e684828570854ebd$var$popupStyleWithMarginTop = null;
const $e684828570854ebd$var$additionalStyles = {
    selectorContainer: "_1e0c1txw"
};
const $e684828570854ebd$export$4e9694165fb83edd = 'reactionPicker-testid';
const $e684828570854ebd$export$d52b610bc836b6d7 = 'reactionPickerPanel-testid';
/**
 * Emoji Picker Controller Id for Accessibility Labels
 */ const $e684828570854ebd$var$PICKER_CONTROL_ID = 'emoji-picker';
const $e684828570854ebd$export$1d5ec51e9af399a5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { miniMode: miniMode, className: className, emojiProvider: emojiProvider, onSelection: onSelection, allowAllEmojis: allowAllEmojis, disabled: disabled, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, onShowMore: onShowMore = ()=>{}, onOpen: onOpen = ()=>{}, onCancel: onCancel = ()=>{}, tooltipContent: tooltipContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $ihA8Z.messages).addReaction
    }), emojiPickerSize: emojiPickerSize, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText, reactionPickerPlacement: reactionPickerPlacement, isListItem: isListItem = false, hoverableReactionPicker: hoverableReactionPicker = false, hoverableReactionPickerDelay: hoverableReactionPickerDelay = 0 } = props;
    const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)(null);
    const [isHoverableReactionPickerEmojiPickerOpen, setIsHoverableReactionPickerEmojiPickerOpen] = (0, $5uXOq.useState)(false);
    const [isHoveringTrigger, setIsHoveringTrigger] = (0, $5uXOq.useState)(false);
    const [isHoveringPopup, setIsHoveringPopup] = (0, $5uXOq.useState)(false);
    const [isTriggerClicked, setIsTriggerClicked] = (0, $5uXOq.useState)(false);
    const [isPopupTrayOpen, setIsPopupTrayOpen] = (0, $a31i7.useDelayedState)(false, hoverableReactionPickerDelay);
    /**
   * Container <div /> reference (used by custom hook to detect click outside)
   */ const wrapperRef = (0, $5uXOq.useRef)(null);
    const updatePopper = (0, $5uXOq.useRef)();
    const popperPlacement = reactionPickerPlacement || 'bottom-start';
    const popperModifiers = [
        /**
    Removing this applyStyle modifier as it throws client errors ref:
   https://popper.js.org/docs/v1/#modifiers
   https://popper.js.org/docs/v1/#modifiers..applyStyle
   { name: 'applyStyle', enabled: false },
    */ {
            name: 'hide',
            enabled: false
        },
        {
            name: 'offset',
            enabled: true,
            options: {
                offset: [
                    0,
                    (0, $VSDnB.fg)('platform-reactions-offset-based-popper') ? 4 : 0
                ]
            }
        },
        {
            name: 'flip',
            enabled: true,
            options: {
                flipVariations: true,
                boundariesElement: 'scrollParent'
            }
        }
    ];
    const [settings, setSettings] = (0, $5uXOq.useState)({
        /**
     * Show the full custom emoji list picker or the default list of emojis
     */ showFullPicker: !!allowAllEmojis && Array.isArray(pickerQuickReactionEmojiIds) && pickerQuickReactionEmojiIds.length === 0,
        popperPlacement: /**
     * Use placement for popper based on reactionPickerPlacement prop
     */ popperPlacement
    });
    /**
   * Custom hook triggers when user clicks outside the reactions picker
   */ (0, $jMJTw.useCloseManager)(wrapperRef, (callbackType)=>{
        close();
        onCancel();
        if (triggerRef && callbackType === 'ESCAPE') requestAnimationFrame(()=>triggerRef.focus());
    }, true, isPopupTrayOpen);
    /**
   * Event callback when the picker is closed
   * @param _id Optional id if an emoji button was selected or undefineed if was clicked outside the picker
   */ const close = (0, $5uXOq.useCallback)((_id)=>{
        setIsPopupTrayOpen(false, true);
        // ufo abort reaction experience
        (0, $lWCY0.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(false);
            setIsTriggerClicked(false);
            setIsHoveringTrigger(false);
            setIsHoveringPopup(false);
        }
    }, [
        setIsPopupTrayOpen,
        setIsHoverableReactionPickerEmojiPickerOpen,
        hoverableReactionPicker,
        setIsTriggerClicked,
        setIsHoveringTrigger,
        setIsHoveringPopup
    ]);
    /**
   * Event handle rwhen selecting to show the custom emoji icons picker
   * @param e event param
   */ const onSelectMoreClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setSettings({
            showFullPicker: hoverableReactionPicker ? settings.showFullPicker : true,
            popperPlacement: popperPlacement
        });
        setIsPopupTrayOpen(true);
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(!isHoverableReactionPickerEmojiPickerOpen);
            setIsTriggerClicked(false);
        }
        onShowMore();
    }, [
        settings.showFullPicker,
        setIsPopupTrayOpen,
        onShowMore,
        popperPlacement,
        hoverableReactionPicker,
        setIsHoverableReactionPickerEmojiPickerOpen,
        isHoverableReactionPickerEmojiPickerOpen
    ]);
    /**
   * Event callback when an emoji icon is selected
   * @param item selected item
   */ const onEmojiSelected = (0, $5uXOq.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? 'emojiPicker' : 'quickSelector');
        close(item.id);
    }, [
        close,
        onSelection,
        settings.showFullPicker,
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen
    ]);
    /**
   * Event handler when the emoji icon to open the custom picker is selected
   */ const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $lWCY0.PickerRender).start();
        setSettings({
            ...settings,
            popperPlacement: popperPlacement
        });
        if (hoverableReactionPicker) {
            if (isHoverableReactionPickerEmojiPickerOpen || isTriggerClicked) {
                // if either the emoji picker is open or the trigger was clicked, close the popup and reset the state
                setIsTriggerClicked(false);
                setIsPopupTrayOpen(false, true);
            } else {
                // if neither condition is true, open the popup and set the state
                setIsTriggerClicked(true);
                setIsPopupTrayOpen(true, true);
            }
            // close the emoji picker
            setIsHoverableReactionPickerEmojiPickerOpen(false);
        } else setIsPopupTrayOpen(!isPopupTrayOpen);
        onOpen();
        // ufo reactions picker opened success
        (0, $lWCY0.PickerRender).success();
    }, [
        hoverableReactionPicker,
        isPopupTrayOpen,
        setIsPopupTrayOpen,
        isTriggerClicked,
        setIsTriggerClicked,
        isHoverableReactionPickerEmojiPickerOpen,
        onOpen,
        settings,
        popperPlacement
    ]);
    const handleTriggerMouseEnter = (0, $5uXOq.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handleTriggerMouseLeave = (0, $5uXOq.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(false);
            if (!isHoveringPopup && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringPopup,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const handlePopupMouseEnter = (0, $5uXOq.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handlePopupMouseLeave = (0, $5uXOq.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(false);
            if (!isHoveringTrigger && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringTrigger,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const wrapperClassName = ` ${isPopupTrayOpen ? 'isOpen' : ''} ${miniMode ? 'miniMode' : ''} ${className}`;
    (0, $5uXOq.useLayoutEffect)(()=>{
        updatePopper.current?.();
    }, [
        settings
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_s7n4nkob _1pra1o8l",
            wrapperClassName
        ]),
        "data-testid": $e684828570854ebd$export$4e9694165fb83edd,
        ref: wrapperRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                    children: ({ ref: ref })=>// Render a button to open the <Selector /> panel
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            onMouseEnter: handleTriggerMouseEnter,
                            onMouseLeave: handleTriggerMouseLeave,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vnfLC.Trigger), {
                                ariaAttributes: {
                                    'aria-expanded': isPopupTrayOpen,
                                    'aria-controls': $e684828570854ebd$var$PICKER_CONTROL_ID
                                },
                                ref: (node)=>{
                                    if (node && isPopupTrayOpen) {
                                        if (typeof ref === 'function') ref(node);
                                        else ref.current = node;
                                        setTriggerRef(node);
                                    }
                                },
                                isSelected: isPopupTrayOpen,
                                onClick: onTriggerClick,
                                miniMode: miniMode,
                                disabled: disabled,
                                tooltipContent: isPopupTrayOpen ? null : tooltipContent,
                                showOpaqueBackground: showOpaqueBackground,
                                showAddReactionText: showAddReactionText,
                                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                                reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                                reactionPickerTriggerText: reactionPickerTriggerText,
                                isListItem: isListItem
                            })
                        })
                }),
                isPopupTrayOpen && /*#__PURE__*/ (0, $2OMIu.jsx)($e684828570854ebd$export$8c62d061746e97b3, {
                    settings: settings,
                    popperModifiers: popperModifiers,
                    children: settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9ixM.default), {
                        emojiProvider: emojiProvider,
                        onSelection: onEmojiSelected,
                        size: emojiPickerSize
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $e684828570854ebd$var$additionalStyles.selectorContainer,
                        onMouseEnter: handlePopupMouseEnter,
                        onMouseLeave: handlePopupMouseLeave,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eFqrQ.Selector), {
                            emojiProvider: emojiProvider,
                            onSelection: onEmojiSelected,
                            showMore: allowAllEmojis,
                            onMoreClick: onSelectMoreClick,
                            pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
                            hoverableReactionPickerSelector: hoverableReactionPicker
                        })
                    })
                })
            ]
        })
    });
});
const $e684828570854ebd$export$8c62d061746e97b3 = (props)=>{
    const { settings: settings, children: children, popperModifiers: popperModifiers } = props;
    const [popupRef, setPopupRef] = (0, $5uXOq.useState)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    /**
   * add focus lock to popup
   */ (0, $dN7jw.useFocusTrap)({
        initialFocusRef: null,
        targetRef: popupRef
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
        placement: settings.popperPlacement,
        modifiers: popperModifiers,
        strategy: "absolute",
        children: ({ ref: ref, style: style, update: update })=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                role: "group",
                "aria-label": formatMessage((0, $ihA8Z.messages).popperWrapperLabel),
                id: $e684828570854ebd$var$PICKER_CONTROL_ID,
                "data-testid": $e684828570854ebd$export$d52b610bc836b6d7,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    zIndex: (0, $k5uoT.layers).layer(),
                    ...style
                },
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex: 0,
                className: (0, $bwpsq.default)([
                    "_nt751r31 _49pcglyw _1hvw1o36"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lPMe5.RepositionOnUpdate), {
                    update: update,
                    settings: settings,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_2rko1sit _bfhk1bhr _16qs1mxi _79pa1b66",
                            !(0, $VSDnB.fg)('platform-reactions-offset-based-popper') && "_1bch1b66"
                        ]),
                        children: children
                    })
                })
            });
        }
    });
};

});
parcelRegister("k9ixM", function(module, exports) {

$parcel$export(module.exports, "preloadEmojiPicker", () => $18908061011bd1ae$export$6b47bb4986b03271);
$parcel$export(module.exports, "default", () => $18908061011bd1ae$export$2e2bcd8739ae039);
/* EmojiPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $d2UcN = parcelRequire("d2UcN");

var $1h51u = parcelRequire("1h51u");

var $gDHgg = parcelRequire("gDHgg");

var $jagXT = parcelRequire("jagXT");

var $kin1Z = parcelRequire("kin1Z");

var $fIUtB = parcelRequire("fIUtB");
const $18908061011bd1ae$var$emojiPicker = null;

const $18908061011bd1ae$var$emojiPickerModuleLoader = ()=>(parcelRequire("aLNYB"));
const $18908061011bd1ae$var$emojiPickerLoader = ()=>$18908061011bd1ae$var$emojiPickerModuleLoader().then((module)=>module.default);
const $18908061011bd1ae$export$6b47bb4986b03271 = ()=>{
    $18908061011bd1ae$var$emojiPickerLoader().then((component)=>{
        $18908061011bd1ae$export$bcf219a275f21b24.AsyncLoadedComponent = component;
    });
};
class $18908061011bd1ae$export$bcf219a275f21b24 extends (0, $1h51u.default) {
    static{
        this.defaultProps = {
            size: (0, $kin1Z.defaultEmojiPickerSize)
        };
    }
    constructor(props){
        super(props, {}), this.state = {
            asyncLoadedComponent: $18908061011bd1ae$export$bcf219a275f21b24.AsyncLoadedComponent
        };
        (0, $d2UcN.ufoExperiences)['emoji-picker-opened'].start();
    }
    asyncLoadComponent() {
        $18908061011bd1ae$var$emojiPickerLoader().then((component)=>{
            $18908061011bd1ae$export$bcf219a275f21b24.AsyncLoadedComponent = component;
            this.setAsyncState(component);
        });
    }
    renderLoading() {
        const item = new (0, $gDHgg.LoadingItem)();
        const handlePickerRef = (ref)=>{
            if (this.props.onPickerRef) this.props.onPickerRef(ref);
        };
        (0, $d2UcN.ufoExperiences)['emoji-picker-opened'].markFMP();
        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: handlePickerRef,
            className: (0, $bwpsq.default)([
                "_19itcyqh _2rkosqtm _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs1gxp _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"
            ]),
            children: item.renderItem()
        });
    }
    renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
        const { emojiProvider: emojiProvider, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jagXT.UfoErrorBoundary), {
            experiences: [
                (0, $d2UcN.ufoExperiences)['emoji-picker-opened']
            ],
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fIUtB.EmojiCommonProvider), {
                emojiProvider: loadedEmojiProvider,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(EmojiPickerComponent, {
                    ...otherProps
                })
            })
        });
    }
}
const $18908061011bd1ae$var$EmojiPicker = (0, $cb25w.default)()($18908061011bd1ae$export$bcf219a275f21b24);
var $18908061011bd1ae$export$2e2bcd8739ae039 = $18908061011bd1ae$var$EmojiPicker;

});
parcelRegister("1h51u", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a2073a204c061f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
class $44a2073a204c061f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props, state){
        super(props), this.isUnmounted = false, this.loaded = (state)=>!!state.asyncLoadedComponent && !!state.loadedEmojiProvider;
        this.state = state;
        // initializing here instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentDidMount() {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) this.asyncLoadComponent();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!(0, $VSDnB.fg)('platform_editor_react18_elements_emoji') || !(0, $VSDnB.fg)('platform_editor_react18_elements_emoji_jira_bb')) this.loadEmojiProvider(nextProps.emojiProvider);
    }
    componentDidUpdate(prevProps) {
        if ((0, $VSDnB.fg)('platform_editor_react18_elements_emoji') || (0, $VSDnB.fg)('platform_editor_react18_elements_emoji_jira_bb')) {
            if (this.props !== prevProps) this.loadEmojiProvider(this.props.emojiProvider);
        }
    }
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    loadEmojiProvider(futureEmojiProvider) {
        futureEmojiProvider.then((loadedEmojiProvider)=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: loadedEmojiProvider
            });
        }).catch(()=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: undefined
            });
        });
    }
    setAsyncState(asyncLoadedComponent) {
        if (!this.isUnmounted) this.setState({
            asyncLoadedComponent: asyncLoadedComponent
        });
    }
    renderLoading() {
        return null;
    }
    render() {
        if (this.loaded(this.state)) {
            const { loadedEmojiProvider: loadedEmojiProvider, asyncLoadedComponent: asyncLoadedComponent } = this.state;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    }
}

});

parcelRegister("gDHgg", function(module, exports) {

$parcel$export(module.exports, "EmojisRowItem", () => $dc40d18219354582$export$99598b6ddae6b40f);
$parcel$export(module.exports, "LoadingItem", () => $dc40d18219354582$export$a16bfd7fb92e211d);
$parcel$export(module.exports, "CategoryHeadingItem", () => $dc40d18219354582$export$7fb68de373aba588);
$parcel$export(module.exports, "virtualItemRenderer", () => $dc40d18219354582$export$1786779f88a71e20);
/* EmojiPickerVirtualItems.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $ch8Ni = parcelRequire("ch8Ni");

var $8Uus1 = parcelRequire("8Uus1");

var $idvip = parcelRequire("idvip");
const $dc40d18219354582$var$emojiPickerSpinner = null;
class $dc40d18219354582$export$8faa7b3aa4960e00 {
    constructor(props, height){
        this.props = props;
        this.height = height;
    }
}
class $dc40d18219354582$export$99598b6ddae6b40f extends $dc40d18219354582$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $idvip.sizes).emojiRowHeight), this.renderItem = (context)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Uus1.default), {
                ...this.props,
                virtualItemContext: context
            });
    }
}
class $dc40d18219354582$export$a16bfd7fb92e211d extends $dc40d18219354582$export$8faa7b3aa4960e00 {
    constructor(){
        super({}, (0, $idvip.sizes).loadingRowHeight), this.renderItem = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _1bsb1osq _4t3i1w81 _1bah1h6o _4cvr1h6o _nphsidpf _t1edidpf _1t3b1wug"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                        size: "medium"
                    })
                })
            });
    }
}
class $dc40d18219354582$export$7fb68de373aba588 extends $dc40d18219354582$export$8faa7b3aa4960e00 {
    constructor(props){
        super(props, (0, $idvip.sizes).categoryHeadingHeight), this.renderItem = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ch8Ni.default), {
                ...this.props
            });
    }
}
const $dc40d18219354582$export$1786779f88a71e20 = (rows, context)=>{
    const { index: index, key: key } = context;
    const row = rows[index];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        children: row && row.renderItem(context)
    }, key);
};

});
parcelRegister("ch8Ni", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab28caab6a65832$export$2e2bcd8739ae039);
/* EmojiPickerCategoryHeading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $5B9Cy = parcelRequire("5B9Cy");

var $aSE1r = parcelRequire("aSE1r");
const $3ab28caab6a65832$var$emojiCategoryTitle = null;
const $3ab28caab6a65832$export$354d69a9ad71a0a0 = 'render-emoji-picker-categorty-heading';
const $3ab28caab6a65832$var$EmojiPickerCategoryHeading = ({ id: id, title: title, className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: id,
        "data-category-id": id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": $3ab28caab6a65832$export$354d69a9ad71a0a0,
        role: "rowheader",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_11c82smr _vchhusvi _syazj3m3 _ca0q12x7 _n3td12x7 _19bvu2gc _u5f3u2gc _1p1d1qyh _299mangw"
            ]),
            children: (0, $5B9Cy.isMessagesKey)(title) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $aSE1r.messages)[title]
            }) : title
        })
    });
var $3ab28caab6a65832$export$2e2bcd8739ae039 = $3ab28caab6a65832$var$EmojiPickerCategoryHeading;

});

parcelRegister("8Uus1", function(module, exports) {

$parcel$export(module.exports, "default", () => $55af6a6500a6382e$export$2e2bcd8739ae039);
/* EmojiPickerEmojiRow.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $9MC40 = parcelRequire("9MC40");

var $lWKb4 = parcelRequire("lWKb4");

var $aSE1r = parcelRequire("aSE1r");
const $55af6a6500a6382e$var$emojiItem = null;
const $55af6a6500a6382e$var$emojiPickerRow = null;
const $55af6a6500a6382e$var$EmojiPickerEmojiRow = ({ emojis: emojis, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, title: title, showDelete: showDelete, onDelete: onDelete, virtualItemContext: virtualItemContext })=>{
    const { currentEmojisFocus: currentEmojisFocus, setEmojisFocus: setEmojisFocus } = (0, $lWKb4.useEmojiPickerListContext)();
    const rowIndex = virtualItemContext?.index || 0;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleFocus = (index)=>(emojiId, emoji, event)=>{
            setEmojisFocus({
                rowIndex: rowIndex,
                columnIndex: index
            });
            onFocus && onFocus(emojiId, emoji, event);
        };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "presentation",
        className: (0, $bwpsq.default)([
            "_18u0u2gc"
        ]),
        children: emojis.map((emoji, index)=>{
            const { shortName: shortName, id: id } = emoji;
            const key = id ? `${id}-${title}` : `${shortName}-${title}`;
            const focus = currentEmojisFocus.rowIndex === rowIndex && currentEmojisFocus.columnIndex === index;
            return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                role: "gridcell",
                "aria-colindex": index + 1,
                className: (0, $bwpsq.default)([
                    "_1e0c1o8l _y3gn1h6o _1bsb1ylp _1wcg14y2 _1678tlke _7b50u2gc _1rf4u2gc _b4kiu2gc _bm9mu2gc _1lvc1tcg _1cf71tcg _8vlfze3t _1909ze3t _1tcfze3t _n7xcze3t _4ubfu2gc _18x3u2gc _fw9su2gc _29jju2gc _qpkw1tcg _elsp1tcg _vtzrze3t _w2q0ze3t _o5kcze3t _1mc3ze3t _115ch2mm _yrst1ssb _85ft1ssb _5mfndbra _1k8z1tcg _17dz1tcg _zdyf1ule _1mn81tcg _u5ah1tcg"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MC40.default), {
                    emoji: emoji,
                    selectOnHover: true,
                    onSelected: onSelected,
                    onMouseMove: onMouseMove,
                    onFocus: handleFocus(index),
                    showDelete: showDelete,
                    onDelete: onDelete,
                    placeholderSize: 24,
                    "data-focus-index": `${rowIndex}-${index}`,
                    tabIndex: focus ? 0 : -1,
                    "aria-roledescription": formatMessage((0, $aSE1r.messages).emojiButtonRoleDescription),
                    shouldBeInteractive: true
                })
            }, key);
        })
    });
};
var $55af6a6500a6382e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($55af6a6500a6382e$var$EmojiPickerEmojiRow);

});
parcelRegister("9MC40", function(module, exports) {

$parcel$export(module.exports, "default", () => $edb6887b165c9a7a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5B9Cy = parcelRequire("5B9Cy");

var $9AR2K = parcelRequire("9AR2K");

var $b8sgr = parcelRequire("b8sgr");

var $7LZcH = parcelRequire("7LZcH");

var $kAeq1 = parcelRequire("kAeq1");

var $y0CvJ = parcelRequire("y0CvJ");

var $jagXT = parcelRequire("jagXT");

var $d2UcN = parcelRequire("d2UcN");
var $d8gl8 = parcelRequire("d8gl8");

var $kin1Z = parcelRequire("kin1Z");

var $d2UcN = parcelRequire("d2UcN");

var $4tMKr = parcelRequire("4tMKr");

var $bNyWE = parcelRequire("bNyWE");
const $edb6887b165c9a7a$export$e81207f376d36133 = (props)=>{
    // Optimisation to only render CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    const { emoji: emoji, placeholderSize: placeholderSize, ...restProps } = props;
    // start emoji rendered experience, it may have already started earlier in `ResourcedEmoji`.
    (0, $d8gl8.useSampledUFOComponentExperience)((0, $d2UcN.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $kin1Z.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'CachingEmoji',
        emojiId: emoji.id
    });
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $d2UcN.hasUfoMarked)((0, $d2UcN.sampledUfoRenderedEmoji)(emoji), 'fmp')) (0, $d2UcN.sampledUfoRenderedEmoji)(emoji).markFMP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const emojiNode = ()=>{
        if ((0, $5B9Cy.isMediaEmoji)(emoji)) return /*#__PURE__*/ (0, $2OMIu.jsx)($edb6887b165c9a7a$export$aa961da7639f7a98, {
            emoji: emoji,
            placeholderSize: placeholderSize,
            ...restProps
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)($edb6887b165c9a7a$var$StandardEmoji, {
            emoji: emoji,
            ...restProps
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jagXT.UfoErrorBoundary), {
        experiences: [
            (0, $d2UcN.ufoExperiences)['emoji-rendered'].getInstance(props.emoji.id || props.emoji.shortName)
        ],
        children: emojiNode()
    });
};
const $edb6887b165c9a7a$var$StandardEmoji = (props)=>{
    const { emoji: emoji, ...restProps } = props;
    const [imageLoadError, setImageLoadError] = (0, $5uXOq.useState)(false);
    const handleLoadError = (_emojiId)=>{
        setImageLoadError(true);
    };
    if (imageLoadError) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $y0CvJ.default), {
        emoji: emoji,
        ...restProps
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LZcH.default), {
        emoji: emoji,
        onLoadError: handleLoadError,
        ...restProps
    });
};
const $edb6887b165c9a7a$export$aa961da7639f7a98 = (props)=>{
    const { emoji: emoji, placeholderSize: placeholderSize, showTooltip: showTooltip, fitToHeight: fitToHeight, children: children, ...restProps } = props;
    const { shortName: shortName, representation: representation } = emoji;
    const [cachedEmoji, setCachedEmoji] = (0, $5uXOq.useState)();
    const [inValidImage, setInvalidImage] = (0, $5uXOq.useState)(false);
    const { emojiProvider: emojiProvider } = (0, $4tMKr.useEmoji)();
    const loadEmoji = (0, $5uXOq.useCallback)((emojiProvider)=>{
        (0, $b8sgr.default)('Loading image via media cache', emoji.shortName);
        (0, $d2UcN.sampledUfoRenderedEmoji)(emoji).mark((0, $9AR2K.UfoEmojiTimings).MEDIA_START);
        emojiProvider.getMediaEmojiDescriptionURLWithInlineToken(emoji).then((cachedEmoji)=>{
            setCachedEmoji(cachedEmoji);
            setInvalidImage(false);
            (0, $d2UcN.sampledUfoRenderedEmoji)(emoji).mark((0, $9AR2K.UfoEmojiTimings).MEDIA_END);
        }).catch((error)=>{
            setCachedEmoji(undefined);
            setInvalidImage(true);
            (0, $d2UcN.sampledUfoRenderedEmoji)(emoji).failure({
                metadata: {
                    error: (0, $bNyWE.extractErrorInfo)(error),
                    reason: 'failed to load media emoji',
                    source: 'CachingMediaEmoji',
                    emojiId: emoji.id
                }
            });
        });
    }, [
        emoji
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (emojiProvider) loadEmoji(emojiProvider);
    }, [
        emojiProvider,
        loadEmoji
    ]);
    const handleLoadError = (_emojiId)=>{
        (0, $d2UcN.sampledUfoRenderedEmoji)(_emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'CachingMediaEmoji',
                emojiId: _emojiId.id
            }
        });
        setInvalidImage(true);
    };
    if (cachedEmoji && !inValidImage) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LZcH.default), {
        ...restProps,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        emoji: cachedEmoji,
        onLoadError: handleLoadError
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kAeq1.default), {
        size: fitToHeight || placeholderSize,
        shortName: shortName,
        showTooltip: showTooltip,
        representation: representation
    });
};
var $edb6887b165c9a7a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($edb6887b165c9a7a$export$e81207f376d36133);

});
parcelRegister("y0CvJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0941aaec1b8f39$export$2e2bcd8739ae039);
/* EmojiFallback.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $7LZcH = parcelRequire("7LZcH");

const $fe0941aaec1b8f39$var$emojiFallbackStyles = null;
const $fe0941aaec1b8f39$export$e3a226c1c0d61870 = (props)=>{
    const { emoji: emoji, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const { fallback: fallback, shortName: shortName } = emoji;
    const classes = `${(0, $63856011855bb785$export$b06c4aab1d012063)} ${selected ? (0, $63856011855bb785$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $63856011855bb785$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LZcH.EmojiNodeWrapper), {
        type: "image",
        ...props,
        className: classes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $bwpsq.default)([
                "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4t3i1osq _1bah1h6o _4cvr1h6o"
            ]),
            children: fallback || shortName
        })
    }));
};
var $fe0941aaec1b8f39$export$2e2bcd8739ae039 = $fe0941aaec1b8f39$export$e3a226c1c0d61870;

});

parcelRegister("4tMKr", function(module, exports) {

$parcel$export(module.exports, "useEmoji", () => $764410eb7b73b8ee$export$482903c4ce3f5633);

var $5uXOq = parcelRequire("5uXOq");

var $hXj7Q = parcelRequire("hXj7Q");
const $764410eb7b73b8ee$var$supportsUploadFeature = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
const $764410eb7b73b8ee$export$482903c4ce3f5633 = ()=>{
    const context = (0, $5uXOq.useContext)((0, $hXj7Q.EmojiContext));
    // Hooks API
    const [isUploadSupported, setIsUploadSupported] = (0, $5uXOq.useState)(false);
    if (!context) throw new Error('useEmoji must be used within EmojiContext');
    const { emojiProvider: emojiProvider } = context.emoji;
    (0, $5uXOq.useEffect)(()=>{
        if ($764410eb7b73b8ee$var$supportsUploadFeature(emojiProvider)) {
            const checkIfUploadIsSupported = async ()=>{
                try {
                    const supported = await emojiProvider.isUploadSupported();
                    setIsUploadSupported(supported);
                } catch (error) {
                    return false;
                }
            };
            checkIfUploadIsSupported();
        }
    }, [
        emojiProvider
    ]);
    return {
        emojiProvider: emojiProvider,
        isUploadSupported: isUploadSupported
    };
};

});

parcelRegister("bNyWE", function(module, exports) {

$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $c50d4677eacae213$export$53eef0dcd9611650);
$parcel$export(module.exports, "recordSucceededEmoji", () => $c50d4677eacae213$export$3125c3f60f61a0a9);
$parcel$export(module.exports, "recordFailedEmoji", () => $c50d4677eacae213$export$ccd0c8bcbda28b7a);
$parcel$export(module.exports, "openedPickerEvent", () => $c50d4677eacae213$export$956acef77052d363);
$parcel$export(module.exports, "closedPickerEvent", () => $c50d4677eacae213$export$151c59c3f6a1ff5f);
$parcel$export(module.exports, "pickerClickedEvent", () => $c50d4677eacae213$export$d69b5cd43769bb6b);
$parcel$export(module.exports, "categoryClickedEvent", () => $c50d4677eacae213$export$8e021f755a07e0d2);
$parcel$export(module.exports, "pickerSearchedEvent", () => $c50d4677eacae213$export$d800a6d814034c48);
$parcel$export(module.exports, "toneSelectedEvent", () => $c50d4677eacae213$export$e559e98af3da9d17);
$parcel$export(module.exports, "toneSelectorOpenedEvent", () => $c50d4677eacae213$export$7274b855c80879c4);
$parcel$export(module.exports, "toneSelectorClosedEvent", () => $c50d4677eacae213$export$301f0d0181307f7);
$parcel$export(module.exports, "uploadBeginButton", () => $c50d4677eacae213$export$be48de448ed1f64f);
$parcel$export(module.exports, "uploadConfirmButton", () => $c50d4677eacae213$export$b82a2393560e5893);
$parcel$export(module.exports, "uploadCancelButton", () => $c50d4677eacae213$export$47ef032c3ec0a60a);
$parcel$export(module.exports, "uploadSucceededEvent", () => $c50d4677eacae213$export$6aed2b90719a7d39);
$parcel$export(module.exports, "uploadFailedEvent", () => $c50d4677eacae213$export$18cfbd0c8c6d2297);
$parcel$export(module.exports, "deleteBeginEvent", () => $c50d4677eacae213$export$d74d89c79fff5a67);
$parcel$export(module.exports, "deleteConfirmEvent", () => $c50d4677eacae213$export$87a8007f9e978b47);
$parcel$export(module.exports, "deleteCancelEvent", () => $c50d4677eacae213$export$9877255e5a8f0cde);
$parcel$export(module.exports, "selectedFileEvent", () => $c50d4677eacae213$export$fc14407a1d009938);
$parcel$export(module.exports, "recordSelectionSucceededSli", () => $c50d4677eacae213$export$524400435f62e003);
$parcel$export(module.exports, "recordSelectionFailedSli", () => $c50d4677eacae213$export$d1176b797f0912b8);
$parcel$export(module.exports, "extractErrorInfo", () => $c50d4677eacae213$export$74aaf4784c2edb2c);

var $gB4mS = parcelRequire("gB4mS");

var $9AR2K = parcelRequire("9AR2K");
const $c50d4677eacae213$export$53eef0dcd9611650 = (0, $gB4mS.default)('fabric-elements');
const $c50d4677eacae213$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes
        }
    });
const $c50d4677eacae213$export$3125c3f60f61a0a9 = (emoji)=>(source)=>{
        return $c50d4677eacae213$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
const $c50d4677eacae213$export$4e713a2b020a4dca = (source)=>{
    return $c50d4677eacae213$var$createEvent('operational', 'succeeded', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $c50d4677eacae213$export$ccd0c8bcbda28b7a = (emoji)=>(source)=>{
        return $c50d4677eacae213$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
const $c50d4677eacae213$export$5bd025a43378005c = (source)=>{
    return $c50d4677eacae213$var$createEvent('operational', 'failed', 'recordEmojiSelection', undefined, {
        source: source
    });
};
const $c50d4677eacae213$var$emojiPickerEvent = (action, attributes = {}, actionSubjectId)=>$c50d4677eacae213$var$createEvent('ui', action, 'emojiPicker', actionSubjectId, attributes);
const $c50d4677eacae213$export$956acef77052d363 = ()=>$c50d4677eacae213$var$emojiPickerEvent('opened');
const $c50d4677eacae213$export$151c59c3f6a1ff5f = (attributes)=>$c50d4677eacae213$var$emojiPickerEvent('closed', attributes);
const $c50d4677eacae213$var$skinTones = [
    {
        id: '-1f3fb',
        skinToneModifier: 'light'
    },
    {
        id: '-1f3fc',
        skinToneModifier: 'mediumLight'
    },
    {
        id: '-1f3fd',
        skinToneModifier: 'medium'
    },
    {
        id: '-1f3fe',
        skinToneModifier: 'mediumDark'
    },
    {
        id: '-1f3ff',
        skinToneModifier: 'dark'
    }
];
const $c50d4677eacae213$var$getSkinTone = (emojiId)=>{
    if (!emojiId) return {};
    for (const { id: id, skinToneModifier: skinToneModifier } of $c50d4677eacae213$var$skinTones){
        if (emojiId.indexOf(id) !== -1) return {
            skinToneModifier: skinToneModifier,
            baseEmojiId: emojiId.replace(id, '')
        };
    }
    return {};
};
const $c50d4677eacae213$export$d69b5cd43769bb6b = (attributes)=>$c50d4677eacae213$var$emojiPickerEvent('clicked', {
        ...$c50d4677eacae213$var$getSkinTone(attributes.emojiId),
        ...attributes
    }, 'emoji');
const $c50d4677eacae213$export$8e021f755a07e0d2 = (attributes)=>$c50d4677eacae213$var$emojiPickerEvent('clicked', attributes, 'category');
const $c50d4677eacae213$export$d800a6d814034c48 = (attributes)=>$c50d4677eacae213$var$emojiPickerEvent('searched', attributes, 'query');
const $c50d4677eacae213$var$skintoneSelectorEvent = (action, attributes = {})=>$c50d4677eacae213$var$createEvent('ui', action, 'emojiSkintoneSelector', undefined, attributes);
const $c50d4677eacae213$export$e559e98af3da9d17 = (attributes)=>$c50d4677eacae213$var$skintoneSelectorEvent('clicked', attributes);
const $c50d4677eacae213$export$7274b855c80879c4 = (attributes)=>$c50d4677eacae213$var$skintoneSelectorEvent('opened', attributes);
const $c50d4677eacae213$export$301f0d0181307f7 = ()=>$c50d4677eacae213$var$skintoneSelectorEvent('cancelled');
const $c50d4677eacae213$var$emojiUploaderEvent = (action, actionSubjectId, attributes)=>$c50d4677eacae213$var$createEvent('ui', action, 'emojiUploader', actionSubjectId, attributes);
const $c50d4677eacae213$export$be48de448ed1f64f = ()=>$c50d4677eacae213$var$emojiUploaderEvent('clicked', 'addButton');
const $c50d4677eacae213$export$b82a2393560e5893 = (attributes)=>$c50d4677eacae213$var$emojiUploaderEvent('clicked', 'confirmButton', attributes);
const $c50d4677eacae213$export$47ef032c3ec0a60a = ()=>$c50d4677eacae213$var$emojiUploaderEvent('clicked', 'cancelButton');
const $c50d4677eacae213$export$6aed2b90719a7d39 = (attributes)=>$c50d4677eacae213$var$createEvent('operational', 'finished', 'emojiUploader', undefined, attributes);
const $c50d4677eacae213$export$18cfbd0c8c6d2297 = (attributes)=>$c50d4677eacae213$var$createEvent('operational', 'failed', 'emojiUploader', undefined, attributes);
const $c50d4677eacae213$export$d74d89c79fff5a67 = (attributes)=>$c50d4677eacae213$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiTrigger', attributes);
const $c50d4677eacae213$export$87a8007f9e978b47 = (attributes)=>$c50d4677eacae213$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiConfirm', attributes);
const $c50d4677eacae213$export$9877255e5a8f0cde = (attributes)=>$c50d4677eacae213$var$createEvent('ui', 'clicked', 'emojiPicker', 'deleteEmojiCancel', attributes);
const $c50d4677eacae213$export$fc14407a1d009938 = ()=>$c50d4677eacae213$var$createEvent('ui', 'clicked', 'emojiUploader', 'selectFile');
const $c50d4677eacae213$var$extractCommonAttributes = (query, emojiList)=>{
    return {
        queryLength: query ? query.length : 0,
        spaceInQuery: query ? query.indexOf(' ') !== -1 : false,
        emojiIds: emojiList ? emojiList.map((emoji)=>emoji.id).filter(Boolean).slice(0, 20) : []
    };
};
const $c50d4677eacae213$export$89566522a5321393 = (duration, query, emojiList)=>$c50d4677eacae213$var$createEvent('ui', 'cancelled', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$c50d4677eacae213$var$extractCommonAttributes(query, emojiList)
    });
const $c50d4677eacae213$var$getPosition = (emojiList, selectedEmoji)=>{
    if (emojiList) {
        const index = emojiList.findIndex((emoji)=>emoji.id === selectedEmoji.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $c50d4677eacae213$export$475603c082d8a174 = (pressed, duration, emoji, emojiList, query, exactMatch)=>$c50d4677eacae213$var$createEvent('ui', pressed ? 'pressed' : 'clicked', 'emojiTypeahead', undefined, {
        duration: duration,
        position: $c50d4677eacae213$var$getPosition(emojiList, emoji),
        ...$c50d4677eacae213$var$extractCommonAttributes(query, emojiList),
        ...$c50d4677eacae213$var$getSkinTone(emoji.id),
        emojiType: emoji.type,
        exactMatch: exactMatch || false
    });
const $c50d4677eacae213$export$bbbb081930a4e19d = (duration, query, emojiList)=>$c50d4677eacae213$var$createEvent('operational', 'rendered', 'emojiTypeahead', undefined, {
        duration: duration,
        ...$c50d4677eacae213$var$extractCommonAttributes(query, emojiList)
    });
const $c50d4677eacae213$export$524400435f62e003 = (emoji, options)=>()=>{
        if (options && options.createAnalyticsEvent) (0, $gB4mS.default)('editor')($c50d4677eacae213$export$3125c3f60f61a0a9(emoji)((0, $9AR2K.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
    };
const $c50d4677eacae213$export$d1176b797f0912b8 = (emoji, options)=>(err)=>{
        if (options && options.createAnalyticsEvent) (0, $gB4mS.default)('editor')($c50d4677eacae213$export$ccd0c8bcbda28b7a(emoji)((0, $9AR2K.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
        return Promise.reject(err);
    };
const $c50d4677eacae213$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};

});


parcelRegister("lWKb4", function(module, exports) {

$parcel$export(module.exports, "useEmojiPickerListContext", () => $8bc24763db69c878$export$1d569b16c0178739);

var $5uXOq = parcelRequire("5uXOq");

var $e7rQA = parcelRequire("e7rQA");
const $8bc24763db69c878$export$1d569b16c0178739 = ()=>(0, $5uXOq.useContext)((0, $e7rQA.EmojiPickerListContext));

});
parcelRegister("e7rQA", function(module, exports) {

$parcel$export(module.exports, "EmojiPickerListContext", () => $df2e7a5f6081bf32$export$968c8d71e683bcd1);
$parcel$export(module.exports, "EmojiPickerListContextProvider", () => $df2e7a5f6081bf32$export$6f4d9357992f0254);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $df2e7a5f6081bf32$export$968c8d71e683bcd1 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    currentEmojisFocus: {
        rowIndex: 0,
        columnIndex: 0
    },
    setEmojisFocus: ()=>{}
});
const $df2e7a5f6081bf32$export$6f4d9357992f0254 = (props)=>{
    const [currentEmojisFocus, setEmojisFocus] = (0, $5uXOq.useState)(props.initialEmojisFocus);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($df2e7a5f6081bf32$export$968c8d71e683bcd1.Provider, {
        value: {
            currentEmojisFocus: currentEmojisFocus,
            setEmojisFocus: setEmojisFocus
        },
        children: props.children
    });
};

});



parcelRegister("idvip", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $d3af91510c24d35d$export$c647cb0ee6e282fe);

var $kin1Z = parcelRequire("kin1Z");
const $d3af91510c24d35d$export$c647cb0ee6e282fe = {
    listHeight: (0, $kin1Z.emojiPickerListHeight),
    listWidth: (0, $kin1Z.emojiPickerWidth),
    searchHeight: 52,
    categoryHeadingHeight: 30,
    emojiRowHeight: 40,
    addEmojiHeight: 32,
    loadingRowHeight: 150,
    uploadActionHeight: 40,
    emojiPerRow: 8
};

});


parcelRegister("aLNYB", function(module, exports) {

let $7d750f70e467e4a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7d750f70e467e4a1$var$load("ffQaD"),
    $7d750f70e467e4a1$var$load("kvRbA"),
    $7d750f70e467e4a1$var$load("2fbRS")
]).then(()=>parcelRequire('h7V3i'));

});


parcelRegister("jMJTw", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $432a65282ae04b25$export$92dae2778ae88f9d);
$parcel$export(module.exports, "useCloseManagerV2", () => $432a65282ae04b25$export$d6c3c92a8b7167c2);

var $5uXOq = parcelRequire("5uXOq");
function $432a65282ae04b25$export$92dae2778ae88f9d(ref, callback, useCapture = false, enabled = true) {
    (0, $5uXOq.useEffect)(()=>{
        if (!enabled) return;
        /**
		 * Alert if clicked on outside of element
		 */ function handleClickOutside(event) {
            if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) callback('CLICK_OUTSIDE');
        }
        function handleKeydown(event) {
            const { key: key } = event;
            if (key === 'Escape' || key === 'Esc') callback('ESCAPE');
        }
        // Bind the event listener
        document.addEventListener('click', handleClickOutside, useCapture);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener('click', handleClickOutside, useCapture);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        ref,
        callback,
        useCapture,
        enabled
    ]);
}
function $432a65282ae04b25$export$d6c3c92a8b7167c2(popupRef, triggerRef, callback, useCapture = false, enabled = true) {
    (0, $5uXOq.useEffect)(()=>{
        if (!enabled) return;
        /**
		 * Alert if clicked on outside of element
		 */ function handleClickOutside(event) {
            const target = event.target;
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) callback('CLICK_OUTSIDE');
        }
        function handleKeydown(event) {
            const { key: key } = event;
            if (key === 'Escape' || key === 'Esc') callback('ESCAPE');
        }
        // Bind the event listener
        document.addEventListener('click', handleClickOutside, useCapture);
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Unbind the event listener on clean up
            document.removeEventListener('click', handleClickOutside, useCapture);
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        triggerRef,
        popupRef,
        callback,
        useCapture,
        enabled
    ]);
}

});

parcelRegister("a31i7", function(module, exports) {

$parcel$export(module.exports, "useDelayedState", () => $2b41efc775d3ffdf$export$94d25041dfc7e5be);

var $5uXOq = parcelRequire("5uXOq");
const $2b41efc775d3ffdf$export$94d25041dfc7e5be = (initialState, delay)=>{
    const [state, setState] = (0, $5uXOq.useState)(initialState);
    const timeoutRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const handleDelayedStateChange = (0, $5uXOq.useCallback)((newState, immediate = false)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        if (immediate || delay === 0) setState(newState);
        else timeoutRef.current = setTimeout(()=>{
            setState(newState);
        }, delay);
    }, [
        delay
    ]);
    return [
        state,
        handleDelayedStateChange
    ];
};

});

parcelRegister("dN7jw", function(module, exports) {

$parcel$export(module.exports, "useFocusTrap", () => $9e4c7aafcff16daf$export$5562a1f223a0d314);
/**
 * Custom hook to add focus trap
 * used for focus trap in ReactionPicker
 * copied from useFocusManager in @atlaskit/popup
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $fGOj2 = parcelRequire("fGOj2");
const $9e4c7aafcff16daf$export$5562a1f223a0d314 = ({ targetRef: targetRef, initialFocusRef: initialFocusRef })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!targetRef) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: false
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($fGOj2)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef,
        initialFocusRef
    ]);
};

});

parcelRegister("eFqrQ", function(module, exports) {

$parcel$export(module.exports, "Selector", () => $b3e63f1f6f624bf5$export$d15f4cd5286f9b1e);
/* Selector.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $ihA8Z = parcelRequire("ihA8Z");

var $dMkEH = parcelRequire("dMkEH");

var $4L79y = parcelRequire("4L79y");

var $2qzIe = parcelRequire("2qzIe");

var $vnfLC = parcelRequire("vnfLC");
const $b3e63f1f6f624bf5$var$styles = {
    container: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    separator: "_t6vde4h9 _5wramuej _1p3lnqa1 _ahbq1b66 _12l2u2gc _4t3i1tcg _1e0c1o8l",
    hoverableReactionPickerSelectorContainer: "_zulp1b66 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $b3e63f1f6f624bf5$var$revealAnimation = null;
const $b3e63f1f6f624bf5$var$revealStyle = null;
const $b3e63f1f6f624bf5$export$fbfb01485b140555 = 'render-selector';
const $b3e63f1f6f624bf5$var$Reveal = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_j7hqordv _5sag6ebc _1pgl1ytf _1o51q7pw _tzy4idpf"
        ]),
        children: children
    });
};
const $b3e63f1f6f624bf5$export$d15f4cd5286f9b1e = ({ emojiProvider: emojiProvider, onMoreClick: onMoreClick, onSelection: onSelection, showMore: showMore, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds = (0, $dMkEH.DefaultReactions), hoverableReactionPickerSelector: hoverableReactionPickerSelector = false })=>{
    /**
   * Render the default emoji icon
   * @param emoji emoji item
   * @param index location of the emoji in the array
   */ const renderEmoji = (emoji, index)=>{
        const emojiButtonAndTooltip = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: emoji.shortName,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4L79y.EmojiButton), {
                emojiId: emoji,
                emojiProvider: emojiProvider,
                onClick: onSelection,
                hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelector
            })
        });
        return hoverableReactionPickerSelector ? emojiButtonAndTooltip : /*#__PURE__*/ (0, $2OMIu.jsx)($b3e63f1f6f624bf5$var$Reveal, {
            testId: $b3e63f1f6f624bf5$export$fbfb01485b140555,
            children: emojiButtonAndTooltip
        }, emoji.id ?? emoji.shortName);
    };
    if (hoverableReactionPickerSelector) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
        xcss: $b3e63f1f6f624bf5$var$styles.hoverableReactionPickerSelectorContainer,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vnfLC.Trigger), {
                tooltipContent: (0, $ihA8Z.messages).addReaction.defaultMessage,
                onClick: onMoreClick,
                showAddReactionText: true,
                reactionPickerTriggerText: (0, $ihA8Z.messages).addNewReaction.defaultMessage,
                fullWidthSelectorTrayReactionPickerTrigger: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                alignBlock: "center",
                xcss: hoverableReactionPickerSelector ? $b3e63f1f6f624bf5$var$styles.hoverableReactionPickerSelectorContainer : $b3e63f1f6f624bf5$var$styles.container,
                children: pickerQuickReactionEmojiIds ? pickerQuickReactionEmojiIds.map(renderEmoji) : null
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        alignBlock: "center",
        xcss: $b3e63f1f6f624bf5$var$styles.container,
        children: [
            pickerQuickReactionEmojiIds ? pickerQuickReactionEmojiIds.map(renderEmoji) : null,
            showMore ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $b3e63f1f6f624bf5$var$styles.separator
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)($b3e63f1f6f624bf5$var$Reveal, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2qzIe.ShowMore), {
                            onClick: onMoreClick
                        }, "more")
                    })
                ]
            }) : null
        ]
    });
};

});
parcelRegister("4L79y", function(module, exports) {

$parcel$export(module.exports, "EmojiButton", () => $7ef6f21bd07945d9$export$e6ce3311a4d41b7f);
/* EmojiButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2l0ub = parcelRequire("2l0ub");

var $ihA8Z = parcelRequire("ihA8Z");

var $E3WGX = parcelRequire("E3WGX");

var $dMkEH = parcelRequire("dMkEH");

var $3Lty3 = parcelRequire("3Lty3");
const $7ef6f21bd07945d9$var$styles = {
    emojiButton: "_12ji1r31 _1qu2glyw _12y31o36 _2rkoglpi _189eidpf _1e0c1txw _bfhk1w7a _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _o7ksrkh3 _1llw1q5f",
    hoverableReactionPickerSelectorEmojiButton: "_12ji1r31 _1qu2glyw _12y31o36 _2rkoiti9 _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _8hrz1nam _ca0qv77o _u5f31b66 _n3td1b66 _19bv1b66 _bfhk1w7a _syaz1gjq _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _irr3166n _1di61dty"
};
const $7ef6f21bd07945d9$export$116e2ec39db7c58e = 'button-emoji-id';
const $7ef6f21bd07945d9$export$e6ce3311a4d41b7f = ({ emojiId: emojiId, onClick: onClick, emojiProvider: emojiProvider, hoverableReactionPickerSelectorEmoji: hoverableReactionPickerSelectorEmoji })=>{
    const onButtonClick = (event)=>{
        event.preventDefault();
        if (onClick && (0, $E3WGX.isLeftClick)(event)) onClick(emojiId, undefined, event);
    };
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        testId: $7ef6f21bd07945d9$export$116e2ec39db7c58e,
        onClick: onButtonClick,
        "aria-label": intl.formatMessage((0, $ihA8Z.messages).reactWithEmoji, {
            emoji: emojiId.shortName
        }),
        xcss: hoverableReactionPickerSelectorEmoji ? $7ef6f21bd07945d9$var$styles.hoverableReactionPickerSelectorEmojiButton : $7ef6f21bd07945d9$var$styles.emojiButton,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2l0ub.default), {
            emojiProvider: emojiProvider,
            emojiId: emojiId,
            fitToHeight: hoverableReactionPickerSelectorEmoji ? (0, $dMkEH.RESOURCED_EMOJI_COMPACT_HEIGHT) : undefined
        })
    });
};

});

parcelRegister("2qzIe", function(module, exports) {

$parcel$export(module.exports, "ShowMore", () => $171f9b81b0c480d4$export$ca7697601dcd7803);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $42CjB = parcelRequire("42CjB");

var $fP8bU = parcelRequire("fP8bU");

var $3bDjY = parcelRequire("3bDjY");

var $ihA8Z = parcelRequire("ihA8Z");
const $171f9b81b0c480d4$export$3b6c19440cd8324b = 'show-more-button';
const $171f9b81b0c480d4$export$ca7697601dcd7803 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $ihA8Z.messages).moreEmoji,
        children: (message)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: message,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    label: (0, $ihA8Z.messages).moreEmoji.defaultMessage,
                    onClick: onClick,
                    testId: $171f9b81b0c480d4$export$3b6c19440cd8324b,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($fP8bU))),
                    appearance: "subtle"
                })
            })
    });
};

});
parcelRegister("fP8bU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aad5194e08f67bfe24a1828a13f5785c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b851f9035a4ffaf9$var$_react = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b851f9035a4ffaf9$var$_showMoreHorizontal = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("8U6zd")));

var $b851f9035a4ffaf9$var$_more = $b851f9035a4ffaf9$var$_interopRequireDefault((parcelRequire("6qrUW")));
function $b851f9035a4ffaf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b851f9035a4ffaf9$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $b851f9035a4ffaf9$var$_react.default.createElement($b851f9035a4ffaf9$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $b851f9035a4ffaf9$var$_more.default
    }, props));
$b851f9035a4ffaf9$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $b851f9035a4ffaf9$var$_default = module.exports.default = $b851f9035a4ffaf9$var$ShowMoreHorizontalIcon;

});
parcelRegister("6qrUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4adad3971ebc70ba$var$_react = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4adad3971ebc70ba$var$_showMoreHorizontal = $4adad3971ebc70ba$var$_interopRequireDefault((parcelRequire("8U6zd")));
function $4adad3971ebc70ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4adad3971ebc70ba$var$EditorMoreIcon = (props)=>/*#__PURE__*/ $4adad3971ebc70ba$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>`
    }, props, {
        newIcon: $4adad3971ebc70ba$var$_showMoreHorizontal.default
    }));
$4adad3971ebc70ba$var$EditorMoreIcon.displayName = 'EditorMoreIcon';
var $4adad3971ebc70ba$var$_default = module.exports.default = $4adad3971ebc70ba$var$EditorMoreIcon;

});



parcelRegister("vnfLC", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $b56952531538bbd4$export$41fb9f06171c75f4);
/* Trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $3bDjY = parcelRequire("3bDjY");

var $dASv8 = parcelRequire("dASv8");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");

var $DEWI6 = parcelRequire("DEWI6");

var $5uXOq = parcelRequire("5uXOq");
const $b56952531538bbd4$var$styles = {
    trigger: "_2rko14q2 _189ee4h9 _1dqonqa1 _1ul9zwfg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1e0c1txw _1bah1h6o _4cvr1h6o",
    subtleTrigger: "_1dqoglyw _1ul91tcg",
    expandedTrigger: "_1ul9146b",
    triggerStylesRefresh: "_2rkoglpi",
    transparentEnabledTrigger: "_1h6dmuej _bfhk1w7a _irr3166n _1di61dty",
    opaqueEnabledTrigger: "_1h6dmuej _bfhkvuon _irr3108i _1di61ji5",
    disabledTrigger: "_1h6d13gt _bfhksyzs",
    miniMode: "_2rkoglpi _1dqoglyw _1ul91tcg _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    fullWidthSummaryViewReactionPickerTrigger: "_1bsb1osq _ca0qu2gc _19bvu2gc _u5f3u2gc",
    fullWidthSelectorTrayReactionPickerTrigger: "_1bsb1osq _ca0q1b66 _19bv1b66 _u5f31b66",
    fullWidth: "_1bsb1osq _p12f3xl8"
};
const $b56952531538bbd4$export$456835f64b911ea5 = 'render-tooltip-trigger';
const $b56952531538bbd4$export$4397a1ddb3e8d706 = 'render-trigger-button';
const $b56952531538bbd4$export$361f8ee5961b2075 = 'render-trigger-container';
const $b56952531538bbd4$export$2243b1861b17bb3b = 'render-list-item-wrapper';
const $b56952531538bbd4$var$i18n = (0, $7VHMR.defineMessages)({
    addReaction: {
        id: 'reaction-picker-trigger.add.reaction.message',
        description: 'Message displayed when there are no page reactions existing on the page.',
        defaultMessage: 'Add a reaction'
    }
});
const $b56952531538bbd4$var$addReactionStyles = {
    addReactionMessage: "_11c8dcr7 _syaz1gjq _18u01b66"
};
const $b56952531538bbd4$var$noMarkerListStyle = null;
const $b56952531538bbd4$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onClick: onClick, miniMode: miniMode, tooltipContent: tooltipContent, disabled: disabled = false, ariaAttributes: ariaAttributes = {}, showOpaqueBackground: showOpaqueBackground = false, showAddReactionText: showAddReactionText = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText = formatMessage($b56952531538bbd4$var$i18n.addReaction), fullWidthSummaryViewReactionPickerTrigger: fullWidthSummaryViewReactionPickerTrigger = false, isListItem: isListItem = false, fullWidthSelectorTrayReactionPickerTrigger: fullWidthSelectorTrayReactionPickerTrigger = false } = props;
    const handleMouseDown = (e, analyticsEvent)=>{
        if (onClick && !disabled) onClick(e, analyticsEvent);
    };
    const renderPressableButton = ()=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Lty3.default), {
            testId: $b56952531538bbd4$export$4397a1ddb3e8d706,
            xcss: (0, $DEWI6.cx)($b56952531538bbd4$var$styles.trigger, (fullWidthSummaryViewReactionPickerTrigger || fullWidthSelectorTrayReactionPickerTrigger) && $b56952531538bbd4$var$styles.fullWidth, subtleReactionsSummaryAndPicker && $b56952531538bbd4$var$styles.subtleTrigger, showAddReactionText && $b56952531538bbd4$var$styles.expandedTrigger, disabled ? $b56952531538bbd4$var$styles.disabledTrigger : showOpaqueBackground ? $b56952531538bbd4$var$styles.opaqueEnabledTrigger : $b56952531538bbd4$var$styles.transparentEnabledTrigger, miniMode && $b56952531538bbd4$var$styles.miniMode, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $b56952531538bbd4$var$styles.triggerStylesRefresh),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
                lineHeight: '16px'
            },
            onClick: handleMouseDown,
            isDisabled: disabled,
            ref: ref,
            "data-subtle": subtleReactionsSummaryAndPicker,
            "data-mini-mode": miniMode,
            ...ariaAttributes,
            children: [
                !!reactionPickerTriggerIcon ? reactionPickerTriggerIcon : // TODO: https://product-fabric.atlassian.net/browse/DSP-21007
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dASv8))), {
                    testId: "emoji-add-icon",
                    color: disabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)",
                    LEGACY_size: "small",
                    label: "Add reaction"
                }),
                showAddReactionText && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: (0, $DEWI6.cx)($b56952531538bbd4$var$addReactionStyles.addReactionMessage),
                    children: reactionPickerTriggerText
                })
            ]
        });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $DEWI6.cx)(fullWidthSummaryViewReactionPickerTrigger && $b56952531538bbd4$var$styles.fullWidthSummaryViewReactionPickerTrigger, fullWidthSelectorTrayReactionPickerTrigger && $b56952531538bbd4$var$styles.fullWidthSelectorTrayReactionPickerTrigger),
        testId: $b56952531538bbd4$export$361f8ee5961b2075,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            testId: $b56952531538bbd4$export$456835f64b911ea5,
            content: tooltipContent,
            canAppear: ()=>!showAddReactionText,
            children: isListItem ? /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                "data-testid": $b56952531538bbd4$export$2243b1861b17bb3b,
                className: (0, $bwpsq.default)([
                    "_qtt8glyw"
                ]),
                children: renderPressableButton()
            }) : renderPressableButton()
        })
    });
});

});
parcelRegister("dASv8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73bb0e29c7f7a728c3573234fe0b4d23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e58e9efff88d680$var$_react = $9e58e9efff88d680$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9e58e9efff88d680$var$_emojiAdd = $9e58e9efff88d680$var$_interopRequireDefault((parcelRequire("4orob")));

var $9e58e9efff88d680$var$_emojiAdd2 = $9e58e9efff88d680$var$_interopRequireDefault((parcelRequire("c6gwd")));
function $9e58e9efff88d680$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiAddIcon.
 * This component is EmojiAddIcon, with `UNSAFE_fallbackIcon` set to "EmojiAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e58e9efff88d680$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $9e58e9efff88d680$var$_react.default.createElement($9e58e9efff88d680$var$_emojiAdd.default, Object.assign({
        LEGACY_fallbackIcon: $9e58e9efff88d680$var$_emojiAdd2.default
    }, props));
$9e58e9efff88d680$var$EmojiAddIcon.Name = 'EmojiAddIconMigration';
var $9e58e9efff88d680$var$_default = module.exports.default = $9e58e9efff88d680$var$EmojiAddIcon;

});
parcelRegister("4orob", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd679256a7ffba837ffea22e1b814e43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $332ea63b7d225997$var$_react = $332ea63b7d225997$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $332ea63b7d225997$var$_baseNew = $332ea63b7d225997$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $332ea63b7d225997$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $332ea63b7d225997$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $332ea63b7d225997$var$_react.default.createElement($332ea63b7d225997$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$332ea63b7d225997$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $332ea63b7d225997$var$_default = module.exports.default = $332ea63b7d225997$var$EmojiAddIcon;

});

parcelRegister("c6gwd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cf2dbd3b6261f85$var$_react = $8cf2dbd3b6261f85$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8cf2dbd3b6261f85$var$_emojiAdd = $8cf2dbd3b6261f85$var$_interopRequireDefault((parcelRequire("4orob")));
function $8cf2dbd3b6261f85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8cf2dbd3b6261f85$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $8cf2dbd3b6261f85$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.049 14.197c-.166-.476.103-.991.602-1.15.5-.159 1.039.098 1.205.575.06.174.225.487.495.796.426.488.955.764 1.649.764.693 0 1.223-.276 1.65-.764.27-.31.433-.622.494-.796.166-.476.706-.734 1.204-.575.5.159.77.673.603 1.15-.13.371-.395.876-.839 1.385C14.348 16.458 13.306 17 12 17s-2.348-.542-3.112-1.418a4.4 4.4 0 0 1-.839-1.385M9.5 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M19 5h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0V7h-1a1 1 0 0 1 0-2h1V4a1 1 0 0 1 2 0zm-5-1.777V5.29A7 7 0 1 0 18.71 10h2.067A9 9 0 1 1 14 3.223"/></svg>`
    }, props, {
        newIcon: $8cf2dbd3b6261f85$var$_emojiAdd.default
    }));
$8cf2dbd3b6261f85$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $8cf2dbd3b6261f85$var$_default = module.exports.default = $8cf2dbd3b6261f85$var$EmojiAddIcon;

});




parcelRegister("lPMe5", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", () => $db3d8d5afdcdd194$export$51eddd7655ca235a);
/**
 * Copied from ADS popup component with some tweeks for our use
 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $db3d8d5afdcdd194$export$51eddd7655ca235a = ({ children: children, update: update, settings: settings })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        settings
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children
    });
};

});


parcelRegister("deKQb", function(module, exports) {

$parcel$export(module.exports, "ReactionPicker", () => $fbf79a5c3746e9a5$export$1d5ec51e9af399a5);
/* ReactionPickerNew.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $k9ixM = parcelRequire("k9ixM");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");

var $k5uoT = parcelRequire("k5uoT");

var $MHKc7 = parcelRequire("MHKc7");

var $VSDnB = parcelRequire("VSDnB");

var $jMJTw = parcelRequire("jMJTw");

var $a31i7 = parcelRequire("a31i7");

var $dN7jw = parcelRequire("dN7jw");

var $ihA8Z = parcelRequire("ihA8Z");

var $lWCY0 = parcelRequire("lWCY0");

var $eFqrQ = parcelRequire("eFqrQ");

var $vnfLC = parcelRequire("vnfLC");

var $lPMe5 = parcelRequire("lPMe5");

var $k8nZq = parcelRequire("k8nZq");
const $fbf79a5c3746e9a5$var$pickerStyle = null;
const $fbf79a5c3746e9a5$var$popupWrapperStyle = null;
const $fbf79a5c3746e9a5$var$popupStyle = null;
const $fbf79a5c3746e9a5$var$popupStyleWithMarginTop = null;
const $fbf79a5c3746e9a5$var$additionalStyles = {
    selectorContainer: "_1e0c1txw"
};
const $fbf79a5c3746e9a5$export$4e9694165fb83edd = 'reactionPicker-testid';
const $fbf79a5c3746e9a5$export$d52b610bc836b6d7 = 'reactionPickerPanel-testid';
/**
 * Emoji Picker Controller Id for Accessibility Labels
 */ const $fbf79a5c3746e9a5$var$PICKER_CONTROL_ID = 'emoji-picker';
const $fbf79a5c3746e9a5$export$1d5ec51e9af399a5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    const { miniMode: miniMode, className: className, emojiProvider: emojiProvider, onSelection: onSelection, allowAllEmojis: allowAllEmojis, disabled: disabled, pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds, onShowMore: onShowMore = ()=>{}, onOpen: onOpen = ()=>{}, onCancel: onCancel = ()=>{}, tooltipContent: tooltipContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $ihA8Z.messages).addReaction
    }), emojiPickerSize: emojiPickerSize, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, showAddReactionText: showAddReactionText = false, reactionPickerTriggerIcon: reactionPickerTriggerIcon, reactionPickerTriggerText: reactionPickerTriggerText, reactionPickerPlacement: reactionPickerPlacement, isListItem: isListItem = false, hoverableReactionPicker: hoverableReactionPicker = false, hoverableReactionPickerDelay: hoverableReactionPickerDelay = 0 } = props;
    const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)(null);
    const [isHoverableReactionPickerEmojiPickerOpen, setIsHoverableReactionPickerEmojiPickerOpen] = (0, $5uXOq.useState)(false);
    const [isHoveringTrigger, setIsHoveringTrigger] = (0, $5uXOq.useState)(false);
    const [isHoveringPopup, setIsHoveringPopup] = (0, $5uXOq.useState)(false);
    const [isTriggerClicked, setIsTriggerClicked] = (0, $5uXOq.useState)(false);
    const [isPopupTrayOpen, setIsPopupTrayOpen] = (0, $a31i7.useDelayedState)(false, hoverableReactionPickerDelay);
    /**
   * Container <div /> reference (used by custom hook to detect click outside)
   */ const wrapperRef = (0, $5uXOq.useRef)(null);
    const updatePopper = (0, $5uXOq.useRef)();
    const popperPlacement = reactionPickerPlacement || 'bottom-start';
    const popperModifiers = [
        /**
    Removing this applyStyle modifier as it throws client errors ref:
   https://popper.js.org/docs/v1/#modifiers
   https://popper.js.org/docs/v1/#modifiers..applyStyle
   { name: 'applyStyle', enabled: false },
    */ {
            name: 'hide',
            enabled: false
        },
        {
            name: 'offset',
            enabled: true,
            options: {
                offset: [
                    0,
                    (0, $VSDnB.fg)('platform-reactions-offset-based-popper') ? 4 : 0
                ]
            }
        },
        {
            name: 'flip',
            enabled: true,
            options: {
                flipVariations: true,
                boundariesElement: 'scrollParent'
            }
        }
    ];
    const [settings, setSettings] = (0, $5uXOq.useState)({
        /**
     * Show the full custom emoji list picker or the default list of emojis
     */ showFullPicker: !!allowAllEmojis && Array.isArray(pickerQuickReactionEmojiIds) && pickerQuickReactionEmojiIds.length === 0,
        popperPlacement: /**
     * Use placement for popper based on reactionPickerPlacement prop
     */ popperPlacement
    });
    /**
   * Event callback when the picker is closed
   * @param _id Optional id if an emoji button was selected or undefineed if was clicked outside the picker
   */ const close = (0, $5uXOq.useCallback)((_id)=>{
        setIsPopupTrayOpen(false, true);
        // ufo abort reaction experience
        (0, $lWCY0.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(false);
            setIsTriggerClicked(false);
            setIsHoveringTrigger(false);
            setIsHoveringPopup(false);
        }
    }, [
        setIsPopupTrayOpen,
        setIsHoverableReactionPickerEmojiPickerOpen,
        hoverableReactionPicker,
        setIsTriggerClicked,
        setIsHoveringTrigger,
        setIsHoveringPopup
    ]);
    /**
   * Event handle rwhen selecting to show the custom emoji icons picker
   * @param e event param
   */ const onSelectMoreClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setSettings({
            showFullPicker: hoverableReactionPicker ? settings.showFullPicker : true,
            popperPlacement: popperPlacement
        });
        setIsPopupTrayOpen(true);
        if (hoverableReactionPicker) {
            setIsHoverableReactionPickerEmojiPickerOpen(!isHoverableReactionPickerEmojiPickerOpen);
            setIsTriggerClicked(false);
        }
        onShowMore();
    }, [
        settings.showFullPicker,
        setIsPopupTrayOpen,
        onShowMore,
        popperPlacement,
        hoverableReactionPicker,
        setIsHoverableReactionPickerEmojiPickerOpen,
        isHoverableReactionPickerEmojiPickerOpen
    ]);
    /**
   * Event callback when an emoji icon is selected
   * @param item selected item
   */ const onEmojiSelected = (0, $5uXOq.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? 'emojiPicker' : 'quickSelector');
        close(item.id);
    }, [
        close,
        onSelection,
        settings.showFullPicker,
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen
    ]);
    /**
   * Event handler when the emoji icon to open the custom picker is selected
   */ const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $lWCY0.PickerRender).start();
        setSettings({
            ...settings,
            popperPlacement: popperPlacement
        });
        if (hoverableReactionPicker) {
            if (isHoverableReactionPickerEmojiPickerOpen || isTriggerClicked) {
                // if either the emoji picker is open or the trigger was clicked, close the popup and reset the state
                setIsTriggerClicked(false);
                setIsPopupTrayOpen(false, true);
            } else {
                // if neither condition is true, open the popup and set the state
                setIsTriggerClicked(true);
                setIsPopupTrayOpen(true, true);
            }
            // close the emoji picker
            setIsHoverableReactionPickerEmojiPickerOpen(false);
        } else setIsPopupTrayOpen(!isPopupTrayOpen);
        onOpen();
        // ufo reactions picker opened success
        (0, $lWCY0.PickerRender).success();
    }, [
        hoverableReactionPicker,
        isPopupTrayOpen,
        setIsPopupTrayOpen,
        isTriggerClicked,
        setIsTriggerClicked,
        isHoverableReactionPickerEmojiPickerOpen,
        onOpen,
        settings,
        popperPlacement
    ]);
    const handleTriggerMouseEnter = (0, $5uXOq.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handleTriggerMouseLeave = (0, $5uXOq.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringTrigger(false);
            if (!isHoveringPopup && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringPopup,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const handlePopupMouseEnter = (0, $5uXOq.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(true);
            if (!isHoverableReactionPickerEmojiPickerOpen) setIsPopupTrayOpen(true);
        }
    }, [
        hoverableReactionPicker,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen
    ]);
    const handlePopupMouseLeave = (0, $5uXOq.useCallback)(()=>{
        if (hoverableReactionPicker) {
            setIsHoveringPopup(false);
            if (!isHoveringTrigger && !isHoverableReactionPickerEmojiPickerOpen && !isTriggerClicked) setIsPopupTrayOpen(false);
        }
    }, [
        hoverableReactionPicker,
        isHoveringTrigger,
        isHoverableReactionPickerEmojiPickerOpen,
        setIsPopupTrayOpen,
        isTriggerClicked
    ]);
    const wrapperClassName = ` ${isPopupTrayOpen ? 'isOpen' : ''} ${miniMode ? 'miniMode' : ''} ${className}`;
    (0, $5uXOq.useLayoutEffect)(()=>{
        updatePopper.current?.();
    }, [
        settings
    ]);
    const onClose = ()=>{
        close();
        onCancel();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_s7n4nkob _1pra1o8l",
            wrapperClassName
        ]),
        "data-testid": $fbf79a5c3746e9a5$export$4e9694165fb83edd,
        ref: wrapperRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                    children: ({ ref: ref })=>// Render a button to open the <Selector /> panel
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            onMouseEnter: handleTriggerMouseEnter,
                            onMouseLeave: handleTriggerMouseLeave,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vnfLC.Trigger), {
                                ariaAttributes: {
                                    'aria-expanded': isPopupTrayOpen,
                                    'aria-controls': $fbf79a5c3746e9a5$var$PICKER_CONTROL_ID
                                },
                                ref: (node)=>{
                                    if (node && isPopupTrayOpen) {
                                        if (typeof ref === 'function') ref(node);
                                        else ref.current = node;
                                        setTriggerRef(node);
                                    }
                                },
                                isSelected: isPopupTrayOpen,
                                onClick: onTriggerClick,
                                miniMode: miniMode,
                                disabled: disabled,
                                tooltipContent: isPopupTrayOpen ? null : tooltipContent,
                                showOpaqueBackground: showOpaqueBackground,
                                showAddReactionText: showAddReactionText,
                                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                                reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                                reactionPickerTriggerText: reactionPickerTriggerText,
                                isListItem: isListItem
                            })
                        })
                }),
                isPopupTrayOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                    zIndex: (0, $k5uoT.layers).layer(),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($fbf79a5c3746e9a5$export$8c62d061746e97b3, {
                        settings: settings,
                        popperModifiers: popperModifiers,
                        isOpen: isPopupTrayOpen,
                        onClose: onClose,
                        triggerRef: triggerRef,
                        children: settings.showFullPicker || hoverableReactionPicker && isHoverableReactionPickerEmojiPickerOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9ixM.default), {
                            emojiProvider: emojiProvider,
                            onSelection: onEmojiSelected,
                            size: emojiPickerSize
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $fbf79a5c3746e9a5$var$additionalStyles.selectorContainer,
                            onMouseEnter: handlePopupMouseEnter,
                            onMouseLeave: handlePopupMouseLeave,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eFqrQ.Selector), {
                                emojiProvider: emojiProvider,
                                onSelection: onEmojiSelected,
                                showMore: allowAllEmojis,
                                onMoreClick: onSelectMoreClick,
                                pickerQuickReactionEmojiIds: pickerQuickReactionEmojiIds,
                                hoverableReactionPickerSelector: hoverableReactionPicker
                            })
                        })
                    })
                })
            ]
        })
    });
});
const $fbf79a5c3746e9a5$export$8c62d061746e97b3 = (props)=>{
    const { triggerRef: triggerRef, settings: settings, isOpen: isOpen, onClose: onClose, children: children, popperModifiers: popperModifiers } = props;
    const [popupRef, setPopupRef] = (0, $5uXOq.useState)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    /**
   * add focus lock to popup
   */ (0, $dN7jw.useFocusTrap)({
        initialFocusRef: null,
        targetRef: popupRef
    });
    /**
   * Custom hook triggers when user clicks outside the reactions picker
   */ (0, $jMJTw.useCloseManagerV2)(popupRef, triggerRef, (callbackType)=>{
        onClose();
        if (popupRef && callbackType === 'ESCAPE') requestAnimationFrame(()=>triggerRef?.focus());
    }, true, isOpen);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
        placement: settings.popperPlacement,
        modifiers: popperModifiers,
        children: ({ ref: ref, style: style, update: update })=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                role: "group",
                "aria-label": formatMessage((0, $ihA8Z.messages).popperWrapperLabel),
                id: $fbf79a5c3746e9a5$var$PICKER_CONTROL_ID,
                "data-testid": $fbf79a5c3746e9a5$export$d52b610bc836b6d7,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    zIndex: (0, $k5uoT.layers).layer(),
                    ...style
                },
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex: 0,
                className: (0, $bwpsq.default)([
                    "_nt751r31 _49pcglyw _1hvw1o36"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lPMe5.RepositionOnUpdate), {
                    update: update,
                    settings: settings,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_2rko1sit _bfhk1bhr _16qs1mxi _79pa1b66",
                            !(0, $VSDnB.fg)('platform-reactions-offset-based-popper') && "_1bch1b66"
                        ]),
                        children: children
                    })
                })
            });
        }
    });
};

});

parcelRegister("1MAvn", function(module, exports) {

$parcel$export(module.exports, "ReactionSummaryView", () => $2a1754b8ce87782f$export$d441f1c2eaaec099);
/* ReactionSummaryView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $k9ixM = parcelRequire("k9ixM");

var $VSDnB = parcelRequire("VSDnB");

var $a31i7 = parcelRequire("a31i7");

var $lzU1B = parcelRequire("lzU1B");

var $vnfLC = parcelRequire("vnfLC");

var $jtBeo = parcelRequire("jtBeo");

var $lWCY0 = parcelRequire("lWCY0");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");
const $2a1754b8ce87782f$var$styles = {
    summaryPopup: "_ca0q1b66 _u5f3u2gc _n3tdu2gc _19bvu2gc _p12foiq5"
};
const $2a1754b8ce87782f$export$55d575bd4bcbc45e = 'render-summary-view-popup';
const $2a1754b8ce87782f$export$d441f1c2eaaec099 = ({ emojiProvider: emojiProvider, reactions: reactions = [], flash: flash = {}, particleEffectByEmoji: particleEffectByEmoji = {}, placement: placement = 'auto-start', onReactionClick: onReactionClick, onReactionFocused: onReactionFocused, onReactionMouseEnter: onReactionMouseEnter, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, allowUserDialog: allowUserDialog, handleOpenReactionsDialog: handleOpenReactionsDialog, isViewOnly: isViewOnly = false, allowSelectFromSummaryView: allowSelectFromSummaryView, disabled: disabled, emojiPickerSize: emojiPickerSize, onSelection: onSelection, tooltipContent: tooltipContent, reactionPickerTriggerIcon: reactionPickerTriggerIcon, onOpen: onOpen, useButtonAlignmentStyling: useButtonAlignmentStyling, reactionPickerTriggerText: reactionPickerTriggerText, hoverableSummaryView: hoverableSummaryView = false, hoverableSummaryViewDelay: hoverableSummaryViewDelay = 300, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId })=>{
    const [isSummaryPopupOpen, setSummaryPopupOpen] = (0, $a31i7.useDelayedState)(false, hoverableSummaryViewDelay);
    const [isHoveringSummaryView, setIsHoveringSummaryView] = (0, $5uXOq.useState)(false);
    const [isSummaryViewButtonHovered, setIsSummaryViewButtonHovered] = (0, $5uXOq.useState)(false);
    const [isSummaryViewButtonClicked, setIsSummaryViewButtonClicked] = (0, $5uXOq.useState)(false);
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = (0, $5uXOq.useState)(false);
    /**
   * Event callback when the picker is closed
   * @param _id Optional id if an emoji button was selected or undefined if was clicked outside the picker
   */ const close = (0, $5uXOq.useCallback)((_id)=>{
        setIsEmojiPickerOpen(false);
        // ufo abort reaction experience
        (0, $lWCY0.PickerRender).abort({
            metadata: {
                emojiId: _id,
                source: 'ReactionPicker',
                reason: 'close dialog'
            }
        });
    }, []);
    /**
   * Event callback when an emoji icon is selected
   * @param item selected item
   */ const onEmojiSelected = (0, $5uXOq.useCallback)((item)=>{
        // no emoji was selected
        if (!item.id) return;
        onSelection(item.id, 'emojiPicker');
        close(item.id);
    }, [
        onSelection,
        close
    ]);
    const handlePopupClose = (0, $5uXOq.useCallback)(()=>{
        setSummaryPopupOpen(false, true);
        setIsEmojiPickerOpen(false);
        setIsSummaryViewButtonClicked(false);
        setIsSummaryViewButtonHovered(false);
        setIsHoveringSummaryView(false);
    }, [
        setSummaryPopupOpen,
        setIsEmojiPickerOpen,
        setIsSummaryViewButtonClicked,
        setIsSummaryViewButtonHovered,
        setIsHoveringSummaryView
    ]);
    const openEmojiPicker = (0, $5uXOq.useCallback)(()=>{
        // ufo start reactions picker open experience
        (0, $lWCY0.PickerRender).start();
        onOpen && onOpen();
        // ufo reactions picker opened success
        setIsEmojiPickerOpen(true);
        (0, $lWCY0.PickerRender).success();
    }, [
        onOpen
    ]);
    const handleEmojiPickerTriggerClick = (0, $5uXOq.useCallback)(()=>{
        openEmojiPicker();
        setSummaryPopupOpen(false, true);
        setIsSummaryViewButtonClicked(false);
        setIsSummaryViewButtonHovered(false);
        setIsHoveringSummaryView(false);
    }, [
        openEmojiPicker,
        setSummaryPopupOpen
    ]);
    const handleSummaryClick = (0, $5uXOq.useCallback)(()=>{
        if (hoverableSummaryView) {
            setIsHoveringSummaryView(false);
            setIsSummaryViewButtonHovered(false);
            if (isEmojiPickerOpen || isSummaryViewButtonClicked) {
                // if either the emoji picker is open or the button was clicked, close the popup and reset the state
                setSummaryPopupOpen(false, true);
                setIsSummaryViewButtonClicked(false);
            } else {
                // if neither condition is true, open the popup and set the state
                setSummaryPopupOpen(true, true);
                setIsSummaryViewButtonClicked(true);
            }
            // close the emoji picker
            setIsEmojiPickerOpen(false);
        } else if (isSummaryPopupOpen) handlePopupClose();
        else setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        isEmojiPickerOpen,
        setSummaryPopupOpen,
        isSummaryPopupOpen,
        handlePopupClose,
        isSummaryViewButtonClicked,
        setIsSummaryViewButtonClicked
    ]);
    const handleButtonMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsSummaryViewButtonHovered(true);
        if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        setSummaryPopupOpen,
        setIsSummaryViewButtonHovered,
        isEmojiPickerOpen
    ]);
    const handleButtonMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsSummaryViewButtonHovered(false);
        if (hoverableSummaryView && !isHoveringSummaryView && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
    }, [
        hoverableSummaryView,
        isHoveringSummaryView,
        setSummaryPopupOpen,
        setIsSummaryViewButtonHovered,
        isSummaryViewButtonClicked
    ]);
    const handleSummaryViewTrayMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHoveringSummaryView(true);
        if (hoverableSummaryView && !isEmojiPickerOpen) setSummaryPopupOpen(true);
    }, [
        hoverableSummaryView,
        setSummaryPopupOpen,
        setIsHoveringSummaryView,
        isEmojiPickerOpen
    ]);
    const handleSummaryViewTrayMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHoveringSummaryView(false);
        if (hoverableSummaryView && !isSummaryViewButtonHovered && !isSummaryViewButtonClicked) setSummaryPopupOpen(false);
    }, [
        hoverableSummaryView,
        isSummaryViewButtonHovered,
        setIsHoveringSummaryView,
        setSummaryPopupOpen,
        isSummaryViewButtonClicked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
        placement: placement,
        content: ({ update: recalculatePopupPosition })=>isEmojiPickerOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9ixM.default), {
                emojiProvider: emojiProvider,
                onSelection: onEmojiSelected,
                size: emojiPickerSize
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                testId: $2a1754b8ce87782f$export$55d575bd4bcbc45e,
                onMouseEnter: handleSummaryViewTrayMouseEnter,
                onMouseLeave: handleSummaryViewTrayMouseLeave,
                children: [
                    allowSelectFromSummaryView && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
                        justifyContent: "center",
                        testId: "reaction-summary-view-emoji-picker-container",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vnfLC.Trigger), {
                            disabled: disabled,
                            reactionPickerTriggerIcon: reactionPickerTriggerIcon,
                            tooltipContent: tooltipContent,
                            onClick: ()=>{
                                handleEmojiPickerTriggerClick();
                                recalculatePopupPosition();
                            },
                            showAddReactionText: true,
                            reactionPickerTriggerText: reactionPickerTriggerText,
                            fullWidthSummaryViewReactionPickerTrigger: true
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                        xcss: $2a1754b8ce87782f$var$styles.summaryPopup,
                        space: "space.025",
                        shouldWrap: true,
                        alignBlock: "center",
                        children: reactions.map((reaction)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lzU1B.Reaction), {
                                reaction: reaction,
                                emojiProvider: emojiProvider,
                                onClick: onReactionClick,
                                onFocused: onReactionFocused,
                                onMouseEnter: onReactionMouseEnter,
                                flash: flash[reaction.emojiId],
                                showParticleEffect: particleEffectByEmoji[reaction.emojiId],
                                allowUserDialog: allowUserDialog,
                                handleOpenReactionsDialog: handleOpenReactionsDialog,
                                isViewOnly: isViewOnly
                            }, reaction.emojiId))
                    })
                ]
            }),
        isOpen: isSummaryPopupOpen || isEmojiPickerOpen,
        onClose: handlePopupClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtBeo.ReactionSummaryButton), {
                ...triggerProps,
                emojiProvider: emojiProvider,
                reactions: reactions,
                onClick: handleSummaryClick,
                onMouseEnter: handleButtonMouseEnter,
                onMouseLeave: handleButtonMouseLeave,
                showOpaqueBackground: showOpaqueBackground,
                subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
                useButtonAlignmentStyling: useButtonAlignmentStyling,
                summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
                summaryButtonIconAfter: summaryButtonIconAfter,
                summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId
            }),
        shouldRenderToParent: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-editor-coll')
    });
};

});
parcelRegister("jtBeo", function(module, exports) {

$parcel$export(module.exports, "ReactionSummaryButton", () => $21bf30ff3669f1cc$export$cc50c972184463a7);
/* ReactionSummaryButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2l0ub = parcelRequire("2l0ub");

var $ihA8Z = parcelRequire("ihA8Z");

var $dMkEH = parcelRequire("dMkEH");

var $idI8K = parcelRequire("idI8K");

var $25NfL = parcelRequire("25NfL");

var $2DWJV = parcelRequire("2DWJV");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $DEWI6 = parcelRequire("DEWI6");
const $21bf30ff3669f1cc$var$styles = {
    emoji: "_8hrz1nam",
    button: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bvu2gc",
    container: "_kqswh2mm",
    summaryButtonIconAfter: "_u5f3u2gc _1e0c1txw _4cvr1h6o _1bah1h6o",
    emojiPlaceholderBackground: "_bfhkn82g",
    particleEffectContainer: "_u5f31ejb"
};
const $21bf30ff3669f1cc$export$bf8263842b2b0eb6 = 'reaction-summary-button';
const $21bf30ff3669f1cc$export$6adb00c908f27fce = 'summary-emoji-display';
const $21bf30ff3669f1cc$export$cc50c972184463a7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ emojiProvider: emojiProvider, reactions: reactions = [], emojisToShow: emojisToShow = 3, onClick: onClick, showOpaqueBackground: showOpaqueBackground = false, subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker = false, useButtonAlignmentStyling: useButtonAlignmentStyling = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, summaryGetOptimisticImageURL: summaryGetOptimisticImageURL, summaryButtonIconAfter: summaryButtonIconAfter, summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId }, ref)=>{
    const intl = (0, $koVbs.default)();
    // Helper function to sort reactions by count and return top N
    const getTopReactions = (reactions, topN)=>{
        return [
            ...reactions
        ].sort((a, b)=>b.count - a.count).slice(0, topN);
    };
    const totalReactionsCount = (0, $5uXOq.useMemo)(()=>{
        return reactions.reduce((accum, current)=>{
            return accum += current?.count || 0;
        }, 0);
    }, [
        reactions
    ]);
    const topReactions = (0, $5uXOq.useMemo)(()=>getTopReactions(reactions, emojisToShow), [
        emojisToShow,
        reactions
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
        xcss: $21bf30ff3669f1cc$var$styles.container,
        ref: ref,
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
            alignInline: "center",
            children: [
                summaryViewParticleEffectEmojiId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $21bf30ff3669f1cc$var$styles.particleEffectContainer,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2DWJV.ReactionParticleEffect), {
                        emojiId: summaryViewParticleEffectEmojiId,
                        emojiProvider: emojiProvider
                    }, summaryViewParticleEffectEmojiId.id)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $25NfL.ReactionButton), {
                    onClick: onClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    testId: $21bf30ff3669f1cc$export$bf8263842b2b0eb6,
                    ariaLabel: intl.formatMessage((0, $ihA8Z.messages).summary),
                    showSubtleStyle: subtleReactionsSummaryAndPicker,
                    showOpaqueBackground: showOpaqueBackground,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            space: "space.050",
                            xcss: (0, $DEWI6.cx)($21bf30ff3669f1cc$var$styles.button),
                            testId: "reaction-summary-wrapper",
                            children: topReactions.map((reaction)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                    xcss: $21bf30ff3669f1cc$var$styles.emoji,
                                    testId: $21bf30ff3669f1cc$export$6adb00c908f27fce,
                                    style: {
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography
                                        lineHeight: '12px'
                                    },
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2l0ub.default), {
                                        emojiProvider: emojiProvider,
                                        emojiId: {
                                            id: reaction.emojiId,
                                            shortName: ''
                                        },
                                        fitToHeight: (0, $dMkEH.RESOURCED_EMOJI_COMPACT_HEIGHT),
                                        optimisticImageURL: summaryGetOptimisticImageURL?.(reaction.emojiId),
                                        placeholderXcss: $21bf30ff3669f1cc$var$styles.emojiPlaceholderBackground
                                    }, reaction.emojiId)
                                }))
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idI8K.Counter), {
                            value: totalReactionsCount,
                            useDarkerFont: useButtonAlignmentStyling,
                            useUpdatedStyles: useButtonAlignmentStyling
                        }),
                        summaryButtonIconAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $21bf30ff3669f1cc$var$styles.summaryButtonIconAfter,
                            children: summaryButtonIconAfter
                        })
                    ]
                })
            ]
        })
    });
});

});


parcelRegister("bL5sD", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", () => $fdd65d30971656f3$export$cf56d0f54cfcce4);

var $VSDnB = parcelRequire("VSDnB");

var $gmmd2 = parcelRequire("gmmd2");
const $fdd65d30971656f3$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $gmmd2.componentWithCondition)(()=>(0, $VSDnB.fg)(featureFlagName), ComponentTrue, ComponentFalse);

});
parcelRegister("gmmd2", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $5b194bd8d7426f4b$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $5b194bd8d7426f4b$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});



parcelRegister("5m4Qa", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $1eef4830c60f0af5$export$615f888019c45765);
$parcel$export(module.exports, "MemoryReactionsStore", () => $1eef4830c60f0af5$export$c1d9193a4043bee1);

var $igcqY = parcelRequire("igcqY");

var $a81KM = parcelRequire("a81KM");

var $iVKAk = parcelRequire("iVKAk");

var $gZM1z = parcelRequire("gZM1z");

var $dMkEH = parcelRequire("dMkEH");

var $lWCY0 = parcelRequire("lWCY0");

var $a81KM = parcelRequire("a81KM");
const $1eef4830c60f0af5$export$615f888019c45765 = {
    /**
	 * Experience when a reaction emoji gets added
	 */ add: (0, $lWCY0.ReactionsAdd),
    /**
	 * Experience when a reaction emoji gets removed/decrement
	 */ remove: (0, $lWCY0.ReactionsRemove),
    /**
	 * Experience when the list of reactions gets rendered with sampling
	 */ render: (instanceId)=>(0, $lWCY0.sampledReactionsRendered)(instanceId),
    /**
	 * Experience when a reaction details gets fetched
	 */ fetchDetails: (0, $lWCY0.ReactionDetailsFetch)
};
class $1eef4830c60f0af5$export$c1d9193a4043bee1 {
    constructor(client, state, metadata){
        this.callbacks = [];
        /**
	 * default initial store data
	 */ this.initialState = {
            reactions: {},
            flash: {},
            particleEffectByEmoji: {}
        };
        /**
	 * Update the store state data with a new data
	 * @param newState new store data
	 */ this.setState = (newState)=>{
            this.state = {
                ...this.state,
                ...newState
            };
            this.triggerOnChange();
        };
        /**
	 * Calls any onChange callbacks in the store using latest state data.
	 */ this.triggerOnChange = (0, $iVKAk.batch)(()=>this.callbacks.forEach((callback)=>callback(this.state)));
        this.setReactions = (containerAri, ari, reactions)=>{
            this.setState({
                reactions: {
                    ...this.state.reactions,
                    [`${containerAri}|${ari}`]: reactions
                }
            });
        };
        this.handleDetailedReactionResponse = (detailedReaction)=>{
            const { containerAri: containerAri, ari: ari, emojiId: emojiId } = detailedReaction;
            this.withReaction((reaction)=>({
                    ...reaction,
                    users: detailedReaction.users
                }))(containerAri, ari, emojiId);
        };
        this.flash = (reaction)=>{
            this.setFlash(reaction.containerAri, reaction.ari, reaction.emojiId, true);
            window.setTimeout(()=>this.setFlash(reaction.containerAri, reaction.ari, reaction.emojiId, false), 700);
        };
        this.displayParticleEffect = (reaction)=>{
            this.setParticleEffectForEmoji(reaction.containerAri, reaction.ari, reaction.emojiId, true);
            window.setTimeout(()=>{
                this.setParticleEffectForEmoji(reaction.containerAri, reaction.ari, reaction.emojiId, false);
            }, 1500);
        };
        this.optmisticUpdate = (containerAri, ari, emojiId)=>(updater)=>{
                this.withReadyReaction(containerAri, ari)((reactionState)=>{
                    let found = false;
                    const reactions = reactionState.reactions.map((reaction)=>{
                        if (reaction.emojiId === emojiId) {
                            found = true;
                            const updated = updater(reaction);
                            if (updated) return {
                                ...updated,
                                optimisticallyUpdated: true
                            };
                        }
                        return reaction;
                    });
                    if (!found) {
                        const updated = updater({
                            containerAri: containerAri,
                            ari: ari,
                            emojiId: emojiId,
                            count: 0,
                            reacted: false
                        });
                        if (updated) reactions.push({
                            ...updated,
                            optimisticallyUpdated: true
                        });
                    }
                    return (0, $gZM1z.readyState)(reactions);
                });
            };
        this.doAddReaction = (reaction, onSuccess)=>{
            const { containerAri: containerAri, ari: ari, emojiId: emojiId } = reaction;
            this.optmisticUpdate(containerAri, ari, emojiId)((0, $gZM1z.addOne));
            this.flash(reaction);
            this.displayParticleEffect(reaction);
            const exp = $1eef4830c60f0af5$export$615f888019c45765.add.getInstance(`${ari}|${emojiId}`);
            // ufo start reaction experience
            exp.start();
            exp.addMetadata({
                source: 'MemoryReactionsStore',
                storeMetadata: this.metadata,
                ari: ari,
                containerAri: containerAri,
                emojiId: emojiId
            });
            this.client.addReaction(containerAri, ari, emojiId, this.metadata).then((_)=>{
                if (this.createAnalyticsEvent) (0, $igcqY.createAndFireSafe)(this.createAnalyticsEvent, (0, $igcqY.createRestSucceededEvent), 'addReaction');
                // ufo add reaction success
                exp.success();
                onSuccess?.((0, $a81KM.ReactionUpdateType).added, ari, emojiId, reaction.count + 1);
            }).catch((error)=>{
                if ((0, $gZM1z.isRealErrorFromService)(error.code)) {
                    this.createAnalyticsEvent && (0, $igcqY.createAndFireSafe)(this.createAnalyticsEvent, (0, $igcqY.createRestFailedEvent), 'addReaction', error.code);
                    // ufo add reaction failure
                    exp.failure({
                        metadata: {
                            error: (0, $igcqY.extractErrorInfo)(error),
                            reason: 'addReaction fetch failed'
                        }
                    });
                }
                return Promise.reject(error);
            });
        };
        this.doRemoveReaction = (reaction, onSuccess)=>{
            const { containerAri: containerAri, ari: ari, emojiId: emojiId } = reaction;
            const exp = $1eef4830c60f0af5$export$615f888019c45765.remove.getInstance(`${ari}|${emojiId}`);
            this.setParticleEffectForEmoji(containerAri, ari, emojiId, false);
            // ufo start reaction experience
            exp.start();
            exp.addMetadata({
                source: 'MemoryReactionsStore',
                storeMetadata: this.metadata,
                ari: ari,
                containerAri: containerAri,
                emojiId: emojiId
            });
            this.optmisticUpdate(containerAri, ari, emojiId)((0, $gZM1z.removeOne));
            this.client.deleteReaction(containerAri, ari, emojiId, this.metadata).then((_)=>{
                // ufo add reaction success
                exp.success();
                onSuccess?.((0, $a81KM.ReactionUpdateType).removed, ari, emojiId, reaction.count - 1);
            }).catch((error)=>{
                // ufo add reaction failure
                exp.failure({
                    metadata: {
                        error: (0, $igcqY.extractErrorInfo)(error),
                        reason: 'deleteReaction fetch failed'
                    }
                });
            });
        };
        this.setCreateAnalyticsEvent = (createAnalyticsEvent)=>{
            this.createAnalyticsEvent = createAnalyticsEvent;
        };
        this.getReactions = (0, $iVKAk.batchByKey)((containerAri, aris)=>{
            /**
		 * TODO:
		 * All reactions are usually fetched in a single call to reactions-service. Need to check why "getReactions" gets called randomly 1-2 times everytime on each fetch request despite using same containerAri.
		 */ const sampledExp = $1eef4830c60f0af5$export$615f888019c45765.render(containerAri);
            const arisArr = aris.reduce((0, $gZM1z.flattenAris));
            // ufo start reaction experience
            sampledExp.start({
                samplingRate: (0, $dMkEH.SAMPLING_RATE_REACTIONS_RENDERED_EXP)
            });
            sampledExp.addMetadata({
                source: 'MemoryReactionsStore',
                storeMetadata: this.metadata,
                containerAri: containerAri,
                aris: arisArr.join(',')
            });
            this.client.getReactions(containerAri, arisArr).then((value)=>{
                Object.keys(value).map((ari)=>{
                    const reactionsState = this.getReactionsState(containerAri, ari);
                    const reactions = reactionsState && reactionsState.status === (0, $a81KM.ReactionStatus).ready ? reactionsState.reactions : undefined;
                    this.setReactions(containerAri, ari, (0, $gZM1z.readyState)(value[ari].sort((0, $gZM1z.getReactionsSortFunction)(reactions))));
                });
            }).then(()=>{
                if (this.createAnalyticsEvent) (0, $igcqY.createAndFireSafe)(this.createAnalyticsEvent, (0, $igcqY.createRestSucceededEvent), 'getReactions');
                sampledExp.success();
            }).catch((error)=>{
                if ((0, $gZM1z.isRealErrorFromService)(error.code)) {
                    if (this.createAnalyticsEvent) (0, $igcqY.createAndFireSafe)(this.createAnalyticsEvent, (0, $igcqY.createRestFailedEvent), 'getReactions');
                    sampledExp.failure({
                        metadata: {
                            error: (0, $igcqY.extractErrorInfo)(error),
                            reason: 'getReactions fetch failed'
                        }
                    });
                }
                const reactionsState = arisArr.reduce((acc, ari)=>({
                        ...acc,
                        [`${containerAri}|${ari}`]: {
                            reactions: [],
                            status: (0, $a81KM.ReactionStatus).error
                        }
                    }), {});
                this.setState({
                    ...this.state,
                    reactions: {
                        ...this.state.reactions,
                        ...reactionsState
                    }
                });
            });
        });
        this.toggleReaction = this.withReaction(this.doRemoveReaction, this.doAddReaction);
        this.addReaction = this.withReaction(this.flash, this.doAddReaction);
        this.getDetailedReaction = (containerAri, ari, emojiId)=>{
            const exp = $1eef4830c60f0af5$export$615f888019c45765.fetchDetails.getInstance(`${ari}|${emojiId}`);
            exp.start();
            exp.addMetadata({
                source: 'MemoryReactionsStore',
                storeMetadata: this.metadata,
                ari: ari,
                containerAri: containerAri,
                emojiId: emojiId
            });
            this.client.getDetailedReaction(containerAri, ari, emojiId).then((summary)=>{
                // ufo get reaction details success
                exp.success();
                this.handleDetailedReactionResponse(summary);
            }).catch((error)=>{
                // ufo get reaction details failure
                exp.failure({
                    metadata: {
                        error: (0, $igcqY.extractErrorInfo)(error),
                        reason: 'getDetailedReaction fetch failed'
                    }
                });
            });
        };
        this.getState = ()=>this.state;
        this.onChange = (callback)=>{
            this.callbacks.push(callback);
        };
        this.removeOnChangeListener = (toRemove)=>{
            this.callbacks = this.callbacks.filter((callback)=>callback !== toRemove);
        };
        this.client = client;
        this.state = state ?? this.initialState;
        this.metadata = metadata;
    }
    getReactionsState(containerAri, ari) {
        return this.state.reactions[`${containerAri}|${ari}`];
    }
    setFlash(containerAri, ari, emojiId, flash) {
        this.setState({
            flash: {
                ...this.state.flash,
                [`${containerAri}|${ari}`]: {
                    ...this.state.flash[`${containerAri}|${ari}`],
                    [emojiId]: flash
                }
            }
        });
    }
    setParticleEffectForEmoji(containerAri, ari, emojiId, enable) {
        this.setState({
            particleEffectByEmoji: {
                ...this.state.particleEffectByEmoji,
                [`${containerAri}|${ari}`]: {
                    ...this.state.particleEffectByEmoji[`${containerAri}|${ari}`],
                    [emojiId]: enable
                }
            }
        });
    }
    /**
	 * Utility function to help execute a callback to Reaction if its state is ready.
	 *
	 *
	 * @param containerAri
	 * @param ari
	 *
	 * @returns (updater: Updater<ReactionsReadyState>) => ReactionsState?
	 *  A function that will execute the received callback with the ReactionsState if
	 *  ready. If some state is returned, the new state will be applied.
	 */ withReadyReaction(containerAri, ari) {
        return (updater)=>{
            const reactionsState = this.getReactionsState(containerAri, ari);
            if (reactionsState && reactionsState.status === (0, $a81KM.ReactionStatus).ready) {
                const updated = updater(reactionsState);
                if (updated) this.setReactions(containerAri, ari, updated);
            }
        };
    }
    /**
	 * Utility function to help execute actions with a reaction. It handles reaction discovery
	 * and branching between reacted and not reacted.
	 *
	 * @param reactedCallback callback that will be executed when the user has already reacted
	 * with the emoji
	 * @param notReactedCallback callback that will be executed when the user hasn't reacted
	 * with the emoji
	 *
	 * @returns (containerAri: string, ari: string, emojiId: string) => ReactionsState?
	 *  A function that will execute the correct callback to the triple containerAri, ari and
	 *  emojiId. If some state is returned, the new state will be applied.
	 */ withReaction(reactedCallback, notReactedCallback) {
        return (containerAri, ari, emojiId, onSuccess)=>{
            this.withReadyReaction(containerAri, ari)((reactionsState)=>{
                const reaction = reactionsState.reactions.find((0, $gZM1z.byEmojiId)(emojiId)) || {
                    containerAri: containerAri,
                    ari: ari,
                    emojiId: emojiId,
                    count: 0,
                    reacted: false
                };
                const callback = reaction.reacted || !notReactedCallback ? reactedCallback : notReactedCallback;
                const updatedReaction = callback(reaction, onSuccess);
                if (updatedReaction && !(updatedReaction instanceof Function)) return (0, $gZM1z.readyState)(reactionsState.reactions.map((0, $gZM1z.updateByEmojiId)(emojiId, updatedReaction)));
                return;
            });
        };
    }
}

});
parcelRegister("iVKAk", function(module, exports) {

$parcel$export(module.exports, "batch", () => $2b8df8ec83e51286$export$712ea50be43a7858);
$parcel$export(module.exports, "batchByKey", () => $2b8df8ec83e51286$export$da86c38211c1c0a8);
function $2b8df8ec83e51286$export$712ea50be43a7858(callback) {
    let calls = [];
    return (...args)=>{
        if (calls.length === 0) {
            window.setTimeout(()=>{
                callback(calls);
                calls = [];
            });
            calls = [];
        }
        calls.push(args);
    };
}
function $2b8df8ec83e51286$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("gZM1z", function(module, exports) {

$parcel$export(module.exports, "readyState", () => $53375069742c9c5e$export$1ae2b664eea77b7e);
$parcel$export(module.exports, "byEmojiId", () => $53375069742c9c5e$export$5cab043602308ae4);
$parcel$export(module.exports, "addOne", () => $53375069742c9c5e$export$670f5032953f9f57);
$parcel$export(module.exports, "removeOne", () => $53375069742c9c5e$export$ff7478e674f87216);
$parcel$export(module.exports, "updateByEmojiId", () => $53375069742c9c5e$export$1509cfbcc99f59ae);
$parcel$export(module.exports, "getReactionsSortFunction", () => $53375069742c9c5e$export$bdb6754878b12c6c);
$parcel$export(module.exports, "flattenAris", () => $53375069742c9c5e$export$7d9b3ef061f4ea88);
$parcel$export(module.exports, "isRealErrorFromService", () => $53375069742c9c5e$export$7952e263c7eb9592);

var $a81KM = parcelRequire("a81KM");
const $53375069742c9c5e$var$compareEmojiId = (l, r)=>{
    return l.localeCompare(r);
};
const $53375069742c9c5e$var$sortByRelevance = (a, b)=>{
    if (a.count > b.count) return -1;
    else if (a.count < b.count) return 1;
    else return $53375069742c9c5e$var$compareEmojiId(a.emojiId, b.emojiId);
};
const $53375069742c9c5e$var$sortByPreviousPosition = (reactions)=>{
    const indexes = reactions.reduce((map, reaction, index)=>{
        map[reaction.emojiId] = index;
        return map;
    }, {});
    const getPosition = ({ emojiId: emojiId })=>indexes[emojiId] === undefined ? reactions.length : indexes[emojiId];
    return (a, b)=>getPosition(a) - getPosition(b);
};
const $53375069742c9c5e$export$1ae2b664eea77b7e = (reactions)=>({
        status: (0, $a81KM.ReactionStatus).ready,
        reactions: reactions.filter((reaction)=>reaction.count > 0)
    });
const $53375069742c9c5e$export$5cab043602308ae4 = (emojiId)=>(reaction)=>reaction.emojiId === emojiId;
const $53375069742c9c5e$export$670f5032953f9f57 = (reaction)=>({
        ...reaction,
        count: reaction.count + 1,
        reacted: true
    });
const $53375069742c9c5e$export$ff7478e674f87216 = (reaction)=>({
        ...reaction,
        count: reaction.count - 1,
        reacted: false
    });
const $53375069742c9c5e$export$1509cfbcc99f59ae = (emojiId, updater)=>(reaction)=>reaction.emojiId === emojiId ? updater instanceof Function ? updater(reaction) : updater : reaction;
const $53375069742c9c5e$export$bdb6754878b12c6c = (reactions)=>reactions && reactions.length ? $53375069742c9c5e$var$sortByPreviousPosition(reactions) : $53375069742c9c5e$var$sortByRelevance;
const $53375069742c9c5e$export$7d9b3ef061f4ea88 = (a, b)=>a.concat(b);
function $53375069742c9c5e$export$7952e263c7eb9592(errorCode) {
    // we don't count 401 or 403 as a real error from services
    return !errorCode || !(errorCode === 401 || errorCode === 403);
}

});



parcelRegister("jL9KB", function(module, exports) {

$parcel$export(module.exports, "JiraCommentAri", () => $e629f85e8995735a$export$cff772a5cd1406e9);

var $68FrD = parcelRequire("68FrD");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/comment/manifest.ts
var $e629f85e8995735a$var$jiraCommentAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $68FrD.JiraCommentAriResourceOwner),
    resourceType: (0, $68FrD.JiraCommentAriResourceType),
    resourceIdSlug: "{commentId}",
    resourceIdSegmentFormats: {
        commentId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/comment/index.ts
var $e629f85e8995735a$export$cff772a5cd1406e9 = class _JiraCommentAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._commentId = opts.resourceIdSegmentValues.commentId;
    }
    get siteId() {
        return this._siteId;
    }
    get commentId() {
        return this._commentId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e629f85e8995735a$var$jiraCommentAriStaticOpts.qualifier,
            platformQualifier: $e629f85e8995735a$var$jiraCommentAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e629f85e8995735a$var$jiraCommentAriStaticOpts.resourceOwner,
            resourceType: $e629f85e8995735a$var$jiraCommentAriStaticOpts.resourceType,
            resourceId: `${opts.commentId}`,
            resourceIdSegmentValues: {
                commentId: opts.commentId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $e629f85e8995735a$var$jiraCommentAriStaticOpts);
        return new _JiraCommentAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $e629f85e8995735a$var$jiraCommentAriStaticOpts);
        return new _JiraCommentAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            commentId: this.commentId
        };
    }
};

});
parcelRegister("68FrD", function(module, exports) {

$parcel$export(module.exports, "JiraCommentAriResourceOwner", () => $4783a382b5765135$export$f9209c8de5de398e);
$parcel$export(module.exports, "JiraCommentAriResourceType", () => $4783a382b5765135$export$5914670dc71919d0);
// src/jira/comment/types.ts
var $4783a382b5765135$export$f9209c8de5de398e = "jira", $4783a382b5765135$export$5914670dc71919d0 = "comment";

});


parcelRegister("g9XSY", function(module, exports) {

$parcel$export(module.exports, "store", () => $1b6d4296131e0d41$export$6f57813fe9f31bf9);

var $5m4Qa = parcelRequire("5m4Qa");
var $5iReS = parcelRequire("5iReS");

var $9CGZY = parcelRequire("9CGZY");
const $1b6d4296131e0d41$var$url = ()=>(0, $9CGZY.default)('reactions') || '';
const $1b6d4296131e0d41$var$client = ()=>new (0, $5iReS.ReactionServiceClient)($1b6d4296131e0d41$var$url());
const $1b6d4296131e0d41$export$6f57813fe9f31bf9 = ()=>new (0, $5m4Qa.MemoryReactionsStore)($1b6d4296131e0d41$var$client());

});
parcelRegister("5iReS", function(module, exports) {

$parcel$export(module.exports, "ReactionServiceClient", () => $fce4ed22d5e478ef$export$892ebee61319c51c);

var $dS9cn = parcelRequire("dS9cn");
class $fce4ed22d5e478ef$export$892ebee61319c51c {
    /**
	 *
	 * @param baseUrl base domain url
	 * @param sessionToken oAuth token for reactions emoji services
	 */ constructor(baseUrl, sessionToken){
        /**
	 * Send a request to remote service
	 * @param path endpoint api url
	 * @param options Optional custom params
	 */ this.requestService = (path, options)=>(0, $dS9cn.utils).requestService(this.serviceConfig, {
                ...options,
                path: path
            });
        this.serviceConfig = {
            url: baseUrl
        };
        this.sessionToken = sessionToken;
    }
    /**
	 * Get http headers for the "fetch" request
	 * @param hasBody
	 */ getHeaders() {
        const headers = {};
        headers['Accept'] = 'application/json';
        headers['Content-Type'] = 'application/json';
        if (this.sessionToken) headers['Authorization'] = this.sessionToken;
        return headers;
    }
    getReactions(containerAri, aris) {
        if (aris.length === 0) return Promise.resolve({});
        return this.requestService('reactions/view', {
            requestInit: {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({
                    containerAri: containerAri,
                    aris: aris
                })
            }
        });
    }
    getDetailedReaction(containerAri, ari, emojiId) {
        const reactionId = `${containerAri}|${ari}|${emojiId}`;
        const headers = this.getHeaders();
        return this.requestService('reactions', {
            queryParams: {
                reactionId: reactionId
            },
            requestInit: {
                headers: headers,
                method: 'GET',
                credentials: 'include'
            }
        });
    }
    addReaction(containerAri, ari, emojiId, metadata) {
        return this.requestService('reactions', {
            requestInit: {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({
                    emojiId: emojiId,
                    ari: ari,
                    containerAri: containerAri,
                    ...metadata ? {
                        metadata: JSON.stringify(metadata)
                    } : {}
                }),
                credentials: 'include'
            }
        }).then(({ reactions: reactions })=>reactions);
    }
    deleteReaction(containerAri, ari, emojiId, metadata) {
        return this.requestService('reactions', {
            queryParams: {
                ari: ari,
                emojiId: emojiId,
                containerAri: containerAri,
                ...metadata ? {
                    metadata: JSON.stringify(metadata)
                } : {}
            },
            requestInit: {
                method: 'DELETE',
                headers: this.getHeaders(),
                credentials: 'include'
            }
        }).then(({ reactions: reactions })=>reactions);
    }
}

});


parcelRegister("cEbDs", function(module, exports) {

$parcel$export(module.exports, "commentAriSelector", () => $1e29d580d3decfae$export$b600fd41c88f35c8);
$parcel$export(module.exports, "shouldShowReactionsSelector", () => $1e29d580d3decfae$export$595ba3a824affd54);

var $dGvGJ = parcelRequire("dGvGJ");

var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");
const $1e29d580d3decfae$export$b600fd41c88f35c8 = (commentId)=>(0, $dGvGJ.createSelector)((0, $bcoYn.baseAriSelector), (baseAri)=>{
        if (!baseAri || !commentId) return null;
        return `${baseAri}:comment/${commentId}`;
    });
const $1e29d580d3decfae$export$595ba3a824affd54 = (0, $dGvGJ.createSelector)((0, $hKi22.permissionsSelector), (0, $a1ky2.cloudIdSelector), (permissions, cloudId)=>!!(permissions.canAddComments && cloudId));

});

parcelRegister("d6UIQ", function(module, exports) {

$parcel$export(module.exports, "thumbsUpEmojiId", () => $2c8b8e7ba685016c$export$ae238a16574604eb);
$parcel$export(module.exports, "quickEmojiIds", () => $2c8b8e7ba685016c$export$85b37b483e783c4c);
const $2c8b8e7ba685016c$export$ae238a16574604eb = '1f44d';
const $2c8b8e7ba685016c$export$85b37b483e783c4c = [
    '1f44d',
    '1f44f',
    '1f525',
    '2764'
];

});

parcelRegister("9C9hZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42cc378af9856700$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $42cc378af9856700$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addThumbsUpReactionLabel: {
        "id": "issue.reactions.add-thumbs-up-reaction",
        "defaultMessage": "Add thumbs up reaction"
    },
    thumbsUp: {
        "id": "issue.reactions.thumbs-up",
        "defaultMessage": "Thumbs up"
    }
});

});


parcelRegister("82tv3", function(module, exports) {

$parcel$export(module.exports, "CommentReactions", () => $0b87dc9421078ef2$export$b24b6fef7fa69c3f);

var $5uXOq = parcelRequire("5uXOq");

var $3GQ1w = parcelRequire("3GQ1w");
function $0b87dc9421078ef2$export$b24b6fef7fa69c3f(props) {
    const { issueAri: issueAri, commentAri: commentAri, visible: visible, showQuickReactions: showQuickReactions, onReactionSuccess: onReactionSuccess } = props;
    const containerAri = issueAri === null ? undefined : issueAri;
    const objectAri = commentAri === null ? undefined : commentAri;
    return visible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3GQ1w.default), {
        containerAri: containerAri,
        objectAri: objectAri,
        showQuickReactions: showQuickReactions,
        onReactionSuccess: onReactionSuccess
    }) : null;
}
$0b87dc9421078ef2$export$b24b6fef7fa69c3f.defaultProps = {
    issueAri: null,
    visible: false,
    commentAri: null,
    showQuickReactions: false
};

});


parcelRegister("88XcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad8cc8a326aefc6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8y9vs = parcelRequire("8y9vs");

var $4YS3Y = parcelRequire("4YS3Y");

var $4JO2I = parcelRequire("4JO2I");
const $8ad8cc8a326aefc6$var$CommentVisibilitySelect = ({ initialValue: initialValue, onChange: onChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YS3Y.default), null, ({ loading: loading, error: error, data: data }, { fetch: fetch })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4JO2I.default), {
            initialValue: initialValue,
            onChange: onChange,
            isLoading: loading,
            error: error,
            options: data ? data.commentVisibilities : null,
            getCommentVisibilityData: fetch
        }));
var $8ad8cc8a326aefc6$export$2e2bcd8739ae039 = (0, $8y9vs.safeComponent)()($8ad8cc8a326aefc6$var$CommentVisibilitySelect);

});
parcelRegister("4JO2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $4807deac45e65329$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $7fkNT = parcelRequire("7fkNT");
const $4807deac45e65329$export$36518eb9cbf30f69 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        prefixOverride: "issue",
        id: "safe(CommentVisibilityViewWithAnalytics)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (analyticsEvent)=>{
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'commentVisibilitySelect mounted', {
                isLoading: props.isLoading
            });
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7fkNT.CommentVisibilityView), props)));
var $4807deac45e65329$export$2e2bcd8739ae039 = $4807deac45e65329$export$36518eb9cbf30f69;

});
parcelRegister("7fkNT", function(module, exports) {

$parcel$export(module.exports, "CommentVisibilityView", () => $7387c6672e51214a$export$84044fded70e314d);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hm7zS = parcelRequire("hm7zS");

var $gccSB = parcelRequire("gccSB");

var $ky7e4 = parcelRequire("ky7e4");

var $a8hd9 = parcelRequire("a8hd9");

var $lu848 = parcelRequire("lu848");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");


var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $5VdxV = parcelRequire("5VdxV");

var $a26bP = parcelRequire("a26bP");

var $6axaw = parcelRequire("6axaw");

var $bx8Ip = parcelRequire("bx8Ip");

var $cEseJ = parcelRequire("cEseJ");
const $7387c6672e51214a$var$OPTION_FILTER_THRESHOLD = 30;
const $7387c6672e51214a$var$OPTION_TOOLTIP_DELAY = 2000;
const $7387c6672e51214a$var$actionSubjectId = 'commentVisibilityView';
const $7387c6672e51214a$var$formatGroupLabel = ({ label: label })=>label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7387c6672e51214a$var$GroupLabel, null, label); // @ts-expect-error - TS7031 - Binding element 'selected' implicitly has an 'any' type. | TS7031 - Binding element 'isFocused' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7387c6672e51214a$var$customOptionStyles = (baseStyles, { data: { selected: selected }, isFocused: isFocused })=>{
    const maybeFocusedColor = isFocused ? "var(--ds-background-neutral-hovered, #091E4224)" : baseStyles.backgroundColor;
    const backgroundColor = selected ? "var(--ds-background-selected, #E9F2FF)" : maybeFocusedColor;
    return {
        ...baseStyles,
        backgroundColor: backgroundColor
    };
};
const $7387c6672e51214a$var$styles = {
    // @ts-expect-error - TS7006 - Parameter 'baseStyles' implicitly has an 'any' type.
    container: (baseStyles)=>({
            ...baseStyles,
            paddingBottom: '0',
            paddingTop: '0'
        }),
    // @ts-expect-error - TS7006 - Parameter 'baseStyles' implicitly has an 'any' type.
    group: (baseStyles)=>({
            ...baseStyles,
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingTop: '0'
        }),
    option: $7387c6672e51214a$var$customOptionStyles
};
const $7387c6672e51214a$var$popperProps = ()=>({
        placement: 'bottom-end',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        (0, $gwIPs.gridSize)
                    ]
                }
            },
            {
                // Update the z-index of the portaled popper (menu) component so menu is visible when viewing issue in dialog.
                // The same thing could be achieved with setting positionFixed to true but that caused us to loose the ability
                // to interact with the menu using keyboard (see BENTO-5561).
                name: 'setZIndex',
                enabled: true,
                phase: 'read',
                // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type.
                fn: ({ state: state })=>({
                        ...state,
                        styles: {
                            ...state.styles,
                            popper: {
                                ...state.styles?.popper,
                                zIndex: (0, $gwIPs.layers).modal
                            }
                        }
                    })
            },
            {
                // Ensure menu is not detached from the trigger (button) and remain in view when trigger is no longer in view (see BENTO-5551).
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    escapeWithReference: true
                }
            }
        ]
    });
const $7387c6672e51214a$var$PopupSelectWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('commentVisibilitySelect', {
    onOpen: 'opened',
    onChange: 'changed'
})((0, $b9dFI.default));
const $7387c6672e51214a$export$2cf7ef1e2dd6c6b1 = ({ value: value, selected: selected, isPublic: isPublic, toolTipDelay: toolTipDelay = $7387c6672e51214a$var$OPTION_TOOLTIP_DELAY })=>{
    const Icon = isPublic ? (0, (/*@__PURE__*/$parcel$interopDefault($lu848))) : (0, (/*@__PURE__*/$parcel$interopDefault($a8hd9)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: value,
        delay: toolTipDelay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7387c6672e51214a$var$OptionContainer, {
        "data-testid": "issue-comment-base.ui.comment.comment-visibility.option-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7387c6672e51214a$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        color: "var(--ds-text, #172B4D)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7387c6672e51214a$var$OptionText, null, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7387c6672e51214a$var$CheckedContainer, null, selected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
        color: "var(--ds-text-selected, #0C66E4)",
        label: ""
    }) : null)));
};
const $7387c6672e51214a$export$84044fded70e314d = ({ isLoading: isLoading, options: options, getCommentVisibilityData: getCommentVisibilityData, initialValue: initialValue, onChange: onChange, error: error })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isErrorOrLoading = isLoading || error;
    const [selectedOption, setValue] = (0, $5uXOq.useState)(initialValue);
    const onChangeAction = (option)=>{
        onChange(option);
        setValue(option);
    };
    const [isOpen, setOpen] = (0, $5uXOq.useState)(false);
    const onOpen = (0, $5uXOq.useCallback)(()=>setOpen(true), []);
    const onClose = (0, $5uXOq.useCallback)(()=>setOpen(false), []);
    (0, $5uXOq.useEffect)(()=>{
        if (options === null && !isErrorOrLoading) getCommentVisibilityData();
    }, [
        getCommentVisibilityData,
        options,
        isErrorOrLoading
    ]);
    const isInitialOptionPublic = initialValue.type === (0, $b276debff3ef22b6$export$a3863626f98a38c2);
    if ((isErrorOrLoading || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options)) && isInitialOptionPublic) return null;
    const optionGroups = isErrorOrLoading || options == null ? (0, $bx8Ip.getEmptyOptionsWithInitialValue)(initialValue, selectedOption, formatMessage) : (0, $bx8Ip.getDefaultOptionGroups)(options, formatMessage, selectedOption); // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const MenuList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, props, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7387c6672e51214a$var$StyledFooter, null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a26bP.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEseJ.LoadingSpinner), null)));
    const componentsList = isErrorOrLoading ? {
        MenuList: MenuList
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (analyticsEvent)=>(0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'commentVisibilitySelect rendered')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7387c6672e51214a$var$CommentVisibilityWrapper, {
        "data-testid": "issue-comment-base.ui.comment.comment-visibility.comment-visibility-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7387c6672e51214a$var$PopupSelectWithAnalytics, {
        onClose: onClose,
        onOpen: (analyticsEvent)=>{
            onOpen();
            const optionTypeCounts = (0, (/*@__PURE__*/$parcel$interopDefault($hm7zS)))(options, 'type');
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, $7387c6672e51214a$var$actionSubjectId, {
                roleCount: optionTypeCounts[0, $b276debff3ef22b6$export$28a8bb936dce2def] || 0,
                groupCount: optionTypeCounts[0, $b276debff3ef22b6$export$537a061b2f9c8800] || 0,
                // the +1 is for the public option
                totalCount: options == null ? 1 : options.length + 1
            });
        },
        maxMenuWidth: (0, $5VdxV.buttonMaxWidth),
        minMenuWidth: 175,
        maxMenuHeight: 340,
        formatOptionLabel: ({ type: type, value: value, selected: selected })=>{
            const isPublic = type === (0, $b276debff3ef22b6$export$a3863626f98a38c2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7387c6672e51214a$export$2cf7ef1e2dd6c6b1, {
                isPublic: isPublic,
                selected: selected,
                value: isPublic ? formatMessage((0, $6axaw.default).visibleToAllUsers) : value
            });
        },
        popperProps: $7387c6672e51214a$var$popperProps(),
        components: componentsList,
        styles: $7387c6672e51214a$var$styles,
        formatGroupLabel: $7387c6672e51214a$var$formatGroupLabel,
        options: optionGroups,
        target: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5VdxV.default), {
                selectedOption: selectedOption,
                isSelected: isOpen
            })),
        isLoading: isLoading,
        error: error,
        onChange: (opt, _, analyticsEvent)=>{
            onChangeAction((0, $bx8Ip.transformOption)(opt));
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, $7387c6672e51214a$var$actionSubjectId);
        },
        isSearchable: // The +1 is for the public option
        options == null ? false : options.length + 1 > $7387c6672e51214a$var$OPTION_FILTER_THRESHOLD,
        searchThreshold: $7387c6672e51214a$var$OPTION_FILTER_THRESHOLD,
        classNamePrefix: "comment-visibility"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7387c6672e51214a$var$OptionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1e5h _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7387c6672e51214a$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f314y2 _n3tdidpf _19bvidpf _1o9zidpf _c71l1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7387c6672e51214a$var$CheckedContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _c71l1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7387c6672e51214a$var$GroupLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _ca0q1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7387c6672e51214a$var$OptionText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7387c6672e51214a$var$StyledFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7387c6672e51214a$var$CommentVisibilityWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul914no _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hm7zS", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $ca2a5e84e2b42ea9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca2a5e84e2b42ea9$var$hasOwnProperty = $ca2a5e84e2b42ea9$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $ca2a5e84e2b42ea9$var$countBy = $4CZTG(function(result, value, key) {
    if ($ca2a5e84e2b42ea9$var$hasOwnProperty.call(result, key)) ++result[key];
    else $1m3dq(result, key, 1);
});
module.exports = $ca2a5e84e2b42ea9$var$countBy;

});

parcelRegister("5VdxV", function(module, exports) {

$parcel$export(module.exports, "buttonMaxWidth", () => $18676d32b76b1409$export$ffcfc0a1074ba0d6);
$parcel$export(module.exports, "default", () => $18676d32b76b1409$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $a8hd9 = parcelRequire("a8hd9");

var $lu848 = parcelRequire("lu848");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");


var $6riHv = parcelRequire("6riHv");
const $18676d32b76b1409$export$ffcfc0a1074ba0d6 = 300; // px
const $18676d32b76b1409$var$TargetButton = ({ selectedOption: selectedOption, isSelected: isSelected })=>{
    const isPublic = selectedOption.type === (0, $b276debff3ef22b6$export$a3863626f98a38c2);
    const Icon = isPublic ? (0, (/*@__PURE__*/$parcel$interopDefault($lu848))) : (0, (/*@__PURE__*/$parcel$interopDefault($a8hd9)));
    const tooltipContent = !isPublic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $6riHv.default).optionsTooltip,
        values: {
            value: selectedOption.value
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $6riHv.default).publicTooltip);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($18676d32b76b1409$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "default",
        isSelected: isSelected,
        shouldFitContainer: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($18676d32b76b1409$var$ButtonContent, {
            removeIconMargin: !isPublic
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            color: "currentColor",
            label: ""
        })),
        "aria-label": isPublic ? formatMessage((0, $6riHv.default).publicTooltip) : undefined,
        testId: "issue-comment-base.ui.comment.comment-visibility.button",
        interactionName: "auto-generated.issue-comment-base.ui.comment.comment-visibility.button.button"
    }, !isPublic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($18676d32b76b1409$var$OptionText, null, selectedOption.value))));
};
var $18676d32b76b1409$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $18676d32b76b1409$var$TargetButton;
const $18676d32b76b1409$var$ButtonContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { removeIconMargin: removeIconMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.removeIconMargin && "_18s83l1n",
            __cmplp.className
        ])
    });
});
const $18676d32b76b1409$var$OptionText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fr0r7 _18u01b66",
            __cmplp.className
        ])
    });
});
const $18676d32b76b1409$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1mjv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6riHv", function(module, exports) {

$parcel$export(module.exports, "default", () => $843a6b25775f460e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $843a6b25775f460e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    publicTooltip: {
        "id": "issue-comment-base.comment.comment-visibility.button.public-tooltip",
        "defaultMessage": "Visible to all users"
    },
    optionsTooltip: {
        "id": "issue-comment-base.comment.comment-visibility.button.options-tooltip",
        "defaultMessage": "Only visible to {value}"
    }
});

});


parcelRegister("a26bP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e58fe90b3d1c64bd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7q5TP = parcelRequire("7q5TP");

var $aWse0 = parcelRequire("aWse0");

var $2N82C = parcelRequire("2N82C");
const $e58fe90b3d1c64bd$var$ErrorImage = ()=>{
    const intl = (0, $aWse0.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e58fe90b3d1c64bd$var$DialogContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e58fe90b3d1c64bd$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e58fe90b3d1c64bd$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7q5TP.default), {
        alt: "",
        width: 50,
        height: 40
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e58fe90b3d1c64bd$var$ErrorMessageStyling, null, intl.formatMessage((0, $2N82C.default).errorMessage))));
};
var $e58fe90b3d1c64bd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $e58fe90b3d1c64bd$var$ErrorImage;
const $e58fe90b3d1c64bd$var$DialogContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbuuw1",
            __cmplp.className
        ])
    });
});
const $e58fe90b3d1c64bd$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e58fe90b3d1c64bd$var$ErrorMessageStyling = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $e58fe90b3d1c64bd$var$imageWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.150'
});

});
parcelRegister("7q5TP", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc8d7b09135bd30b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3RXYN")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jb8SM")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = jx8k5z4r4cbqfnn3t56t46v9
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/jx8k5z4r4cbqfnn3t56t46v9

var $dCLgq = parcelRequire("dCLgq");

var $jb8SM = parcelRequire("jb8SM");

var $3RXYN = parcelRequire("3RXYN");
const $dc8d7b09135bd30b$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3RXYN)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jb8SM))
});
var $dc8d7b09135bd30b$export$2e2bcd8739ae039 = $dc8d7b09135bd30b$var$Illustration;
// for advanced use only
const $dc8d7b09135bd30b$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("jb8SM", function(module, exports) {
module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();

});

parcelRegister("3RXYN", function(module, exports) {
module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();

});


parcelRegister("2N82C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c6788e4426b83ac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c6788e4426b83ac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "issue-comment-base.comment.comment-visibility.error-image.error-message",
        "defaultMessage": "We couldn't load the visibility options"
    }
});

});


parcelRegister("6axaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a63093e1df74941d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a63093e1df74941d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    visibleToAllUsers: {
        "id": "issue-comment-base.comment.comment-visibility.visible-to-all-users",
        "defaultMessage": "Visible to all users"
    },
    projectRolesLabel: {
        "id": "issue-comment-base.comment.comment-visibility.project-roles-label",
        "defaultMessage": "Project roles"
    },
    groupsLabel: {
        "id": "issue-comment-base.comment.comment-visibility.groups-label",
        "defaultMessage": "Groups"
    }
});

});

parcelRegister("bx8Ip", function(module, exports) {

$parcel$export(module.exports, "transformOption", () => $976bc4ed37f42e03$export$bd33285d78067b38);
$parcel$export(module.exports, "getDefaultOptionGroups", () => $976bc4ed37f42e03$export$20e276c91fecd7dc);
$parcel$export(module.exports, "getEmptyOptionsWithInitialValue", () => $976bc4ed37f42e03$export$7f1f10c5f9865ca9);


var $g2C8o = parcelRequire("g2C8o");

var $6axaw = parcelRequire("6axaw");

var $j57jo = parcelRequire("j57jo");
const $976bc4ed37f42e03$export$bd33285d78067b38 = ({ type: type, value: value, groupId: groupId })=>({
        type: type,
        value: value,
        groupId: groupId
    });
const $976bc4ed37f42e03$var$transformCommentVisibilities = (options, value, type)=>options.filter((item)=>item.type === type).map((item)=>({
            ...item,
            selected: item ? (0, $j57jo.areCommentVisibilitiesEqual)(item, value) : false
        }));
const $976bc4ed37f42e03$var$publicOption = (selectedOption)=>({
        label: '',
        options: [
            {
                ...(0, $g2C8o.COMMENT_VISIBILITY_PUBLIC),
                selected: selectedOption.type === (0, $b276debff3ef22b6$export$a3863626f98a38c2)
            }
        ]
    });
const $976bc4ed37f42e03$export$20e276c91fecd7dc = (options, formatMessage, selectedOption)=>[
        $976bc4ed37f42e03$var$publicOption(selectedOption),
        {
            label: formatMessage((0, $6axaw.default).projectRolesLabel),
            options: $976bc4ed37f42e03$var$transformCommentVisibilities(options, selectedOption, (0, $b276debff3ef22b6$export$28a8bb936dce2def))
        },
        {
            label: formatMessage((0, $6axaw.default).groupsLabel),
            options: $976bc4ed37f42e03$var$transformCommentVisibilities(options, selectedOption, (0, $b276debff3ef22b6$export$537a061b2f9c8800))
        }
    ];
const $976bc4ed37f42e03$export$7f1f10c5f9865ca9 = (initialValue, selectedOption, formatMessage)=>{
    const emptyOptionsGroup = [
        $976bc4ed37f42e03$var$publicOption(selectedOption)
    ];
    if (initialValue) {
        const isInitialValueSelected = initialValue.type === selectedOption.type && initialValue.value === selectedOption.value;
        emptyOptionsGroup.push({
            label: initialValue.type === (0, $b276debff3ef22b6$export$537a061b2f9c8800) ? formatMessage((0, $6axaw.default).groupsLabel) : formatMessage((0, $6axaw.default).projectRolesLabel),
            options: [
                {
                    ...initialValue,
                    selected: isInitialValueSelected
                }
            ]
        });
    }
    return emptyOptionsGroup;
};

});
parcelRegister("j57jo", function(module, exports) {

$parcel$export(module.exports, "areCommentVisibilitiesEqual", () => $57ce8a9bf69b80fb$export$fa22c427e1c7f9e8);
const $57ce8a9bf69b80fb$export$fa22c427e1c7f9e8 = (item, item2)=>item.value === item2.value && item.type === item2.type;

});


parcelRegister("cEseJ", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $1e1b106d20733ff0$export$b08b517936747730);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $1e1b106d20733ff0$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e1b106d20733ff0$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        testId: "issue-comment-base.ui.comment.comment-visibility.spinner.spinner"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1e1b106d20733ff0$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3iqkoa",
            __cmplp.className
        ])
    });
});

});




parcelRegister("dHOuF", function(module, exports) {

$parcel$export(module.exports, "deleteIssueLinkConfirmationEntryPoint", () => $46b6181aabff5e58$export$a3cedbbf99deeb98);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $46b6181aabff5e58$export$a3cedbbf99deeb98 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("1NxGD")), {
        moduleId: "e538a30a"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1NxGD", function(module, exports) {

let $14f47f839a6579b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $14f47f839a6579b5$var$load("sP1aS").then(()=>parcelRequire('eDPN5'));

});


parcelRegister("VuurY", function(module, exports) {

$parcel$export(module.exports, "IssueCommentEditorReadonly", () => $8c16516bf336c8bd$export$1021c1a3291c5127);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $eIGAZ = parcelRequire("eIGAZ");
const $8c16516bf336c8bd$export$1021c1a3291c5127 = ({ bodyHtml: bodyHtml })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eIGAZ.default), {
        bodyHtml: bodyHtml
    });
const $8c16516bf336c8bd$export$f0392ced41f66055 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-comment-editor",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-comment-editor-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("eIGAZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aecd049b4e01ae8e$export$2e2bcd8739ae039);

var $8y9vs = parcelRequire("8y9vs");

var $4lB8P = parcelRequire("4lB8P");
var // PreviewCommentContent doesn't not have any usage of intl
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$aecd049b4e01ae8e$export$2e2bcd8739ae039 = (0, $8y9vs.safeComponent)()((0, $4lB8P.PreviewCommentContent));

});
parcelRegister("4lB8P", function(module, exports) {

$parcel$export(module.exports, "PreviewCommentContent", () => $70a4b4976c4f625f$export$54012c04acf2ecfb);

var $5uXOq = parcelRequire("5uXOq");

var $3m977 = parcelRequire("3m977");

var $qymVE = parcelRequire("qymVE");
const $70a4b4976c4f625f$export$54012c04acf2ecfb = ({ bodyHtml: bodyHtml })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qymVE.EditorContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3m977.default), {
        html: bodyHtml
    }));

});
parcelRegister("3m977", function(module, exports) {

$parcel$export(module.exports, "default", () => $d16f27d42bcc6bd2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $kzbcS = parcelRequire("kzbcS");

var $bkuwM = parcelRequire("bkuwM");
class $d16f27d42bcc6bd2$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            html: ''
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bkuwM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line react/no-danger
        , {
            dangerouslySetInnerHTML: {
                __html: this.props.html
            },
            onClick: this.onContentClick,
            role: "presentation"
        }));
    }
    constructor(...args){
        super(...args), this.onContentClick = (e)=>{
            // @ts-expect-error - TS2559 - Type 'EventTarget' has no properties in common with type 'ElementToCheck'.
            if ((0, $kzbcS.default)(e.target, e.currentTarget)) e.stopPropagation();
        };
    }
}

});
parcelRegister("bkuwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4a8a0d6903951ec$export$2e2bcd8739ae039);
/* html-style-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $a4a8a0d6903951ec$var$StyleWrapper = ({ children: children })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _vwz41ejb _19pkidpf _otyridpf _sw6v1wug _cxe51wug _43ds14q2"
        ])
    }, children);
};
const $a4a8a0d6903951ec$var$styles = null;
var $a4a8a0d6903951ec$export$2e2bcd8739ae039 = $a4a8a0d6903951ec$var$StyleWrapper;

});


parcelRegister("qymVE", function(module, exports) {

$parcel$export(module.exports, "CommentContent", () => $bd4c59f716a9dd47$export$9cb18b34ecc5c89e);
$parcel$export(module.exports, "EditorContainer", () => $bd4c59f716a9dd47$export$b38a2fd24b22fb35);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $7aCJt = parcelRequire("7aCJt");

var $fGddq = parcelRequire("fGddq");

var $kxZPA = parcelRequire("kxZPA");

var $jEjVx = parcelRequire("jEjVx");

var $1e96J = parcelRequire("1e96J");

const $bd4c59f716a9dd47$export$9746802d6f14e3e8 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("d0jbS")), {
    moduleId: "./src/packages/issue/issue-actions/issue-comment-base/src/ui/comment/content/comment-editor/index.tsx"
});
class $bd4c59f716a9dd47$export$9cb18b34ecc5c89e extends (0, $5uXOq.Component) {
    static{
        this.displayName = 'CommentContent';
    }
    static{
        this.defaultProps = {
            isServiceDesk: false,
            isCustomerService: false,
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onPaste: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onHideSave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd4c59f716a9dd47$export$b38a2fd24b22fb35, null, this.props.isEditing ? this.renderEditor() : this.fgConnectedRenderer());
    }
    constructor(...args){
        super(...args), this.getEditValue = ()=>this.props.draftValue || this.props.bodyAdf, this.fgConnectedRenderer = ()=>{
            if (// this checks can also go on change_comment_editorstate_props_to_propdrill clean up. They are here to avoid type errors. The actual check is done earlier
            this.props.mentionProvider && this.props.contextIdentifier && this.props.mediaContext && (0, $4R6GH.fg)('change_comment_editorstate_props_to_propdrill')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1e96J.ConnectedRendererNew), {
                key: `comment-${this.props.commentId}`,
                adf: this.props.bodyAdf,
                canEdit: this.props.canEdit,
                commentId: this.props.commentId,
                mentionProvider: this.props.mentionProvider,
                contextIdentifier: this.props.contextIdentifier,
                mediaContext: this.props.mediaContext
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1e96J.ConnectedRendererOld), {
                key: `comment-${this.props.commentId}`,
                adf: this.props.bodyAdf,
                canEdit: this.props.canEdit,
                commentId: this.props.commentId
            });
        }, this.getIssueCommentEditor = ({ assistiveLabel: assistiveLabel = '', renderCustomSecondaryToolbar: renderCustomSecondaryToolbar, isLoomJSMBannerEnabled: isLoomJSMBannerEnabled })=>{
            const editorProps = {
                isExpanded: true,
                isExpandedByDefault: true,
                shouldFocus: true,
                defaultValue: this.getEditValue(),
                secondaryToolbarComponents: this.props.secondaryToolbarComponents,
                onBlur: this.props.onBlur,
                onSave: this.props.onSave,
                onCancel: this.props.onCancel,
                onChange: this.props.onChange,
                onPaste: this.props.onPaste,
                onHideSave: this.props.onHideSave
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7aCJt.IssueEditorBoundary), {
                packageName: "issue",
                fallback: this.fgConnectedRenderer()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd4c59f716a9dd47$export$9746802d6f14e3e8, {
                ...editorProps,
                ...assistiveLabel && {
                    assistiveLabel: assistiveLabel
                },
                ...renderCustomSecondaryToolbar && (0, $4R6GH.fg)('jcs_master_flag') && {
                    renderCustomSecondaryToolbar: renderCustomSecondaryToolbar
                },
                isLoomJSMBannerEnabled: isLoomJSMBannerEnabled
            }));
        }, this.renderEditor = ()=>this.props.isServiceDesk || this.props.isCustomerService && (0, $4R6GH.fg)('jcs_project_type_m3') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fGddq.default), {
                isExpanded: true,
                commentId: this.props.commentId
            }, this.getIssueCommentEditor) : this.getIssueCommentEditor({
                assistiveLabel: this.props.intl.formatMessage((0, $jEjVx.default).comment)
            });
    }
}
const $bd4c59f716a9dd47$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _swxz1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fGddq", function(module, exports) {

$parcel$export(module.exports, "default", () => $61ee1705bbdebde8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");


var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $8dFNe = parcelRequire("8dFNe");

var $hKi22 = parcelRequire("hKi22");

var $d4MOh = parcelRequire("d4MOh");

var $4R6GH = parcelRequire("4R6GH");

var $04yyc = parcelRequire("04yyc");
const $61ee1705bbdebde8$export$4f89d6b3093c3570 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $acf4ef636a959927$export$d3dadb39db0c423)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $04yyc.default), props));
var $61ee1705bbdebde8$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $hxqfC.connect)((state, ownProps)=>({
        isInternal: (0, $d4MOh.isEditingInternalCommentSelector)(ownProps.commentId)(state),
        isPublicCommentAllowed: (0, $hKi22.canUseServiceDeskAgentFeaturesSelector)(state),
        hasPublicComments: (0, $4R6GH.fg)('loom_jsm_experiment_controller') ? (0, $d4MOh.hasPublicCommentsSelector)(state) : false
    }), (dispatch, ownProps)=>({
        onCommentVisibilityChange: (isInternal)=>{
            dispatch((0, $8dFNe.changeCommentVisibility)(ownProps.commentId, isInternal));
        }
    }), (stateProps, dispatchProps, allOwnProps)=>{
    // Omit commentId from the props that get passed to the component
    const { commentId: commentId, ...ownProps } = allOwnProps;
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}))($61ee1705bbdebde8$export$4f89d6b3093c3570);

});
/**
 * Opt into the new issue view modal key. To be cleaned up with issue.details.opt-back-in
 * This key is stored in the API and should not be renamed.
 * @see https://hello.atlassian.net/wiki/spaces/JIE/pages/920124493/How+to+re-set+new+Bento+Change+Boarding#Re-set-Opt-In-Back-Modal
 */ const $acf4ef636a959927$export$a3338d0a4845edfa = 'jira.details.opt-in-back.next-reminding-date';
const $acf4ef636a959927$export$26de4b42c139644c = 'jira.user.issue.should.show.welcome.message';
const $acf4ef636a959927$export$ece45f325779a5d5 = 'jira.user.issue.opt.in.back.modal.has.dismissed';
const $acf4ef636a959927$export$4603581e6066a63f = 'jira.user.issue.opt.in.back.banner.has.dismissed';
const $acf4ef636a959927$export$af60a7ae4202be66 = 'issue-details-changeboarding';
const $acf4ef636a959927$export$7b98e5a33c854454 = 30;
const $acf4ef636a959927$export$956fcd3a2e5c48a8 = 'SOFTWARE_ISSUE_STATUS';
const $acf4ef636a959927$export$ebb7dcd60318cfac = 'SERVICEDESK_ISSUE_STATUS';
const $acf4ef636a959927$export$a446d697df3d6b2c = 'SERVICEDESK_REQUEST_PANEL';
const $acf4ef636a959927$export$d3dadb39db0c423 = 'SERVICEDESK_CREATE_COMMENT_ACTIONS';
const $acf4ef636a959927$export$75867eab2abae162 = 'SERVICEDESK_PLACEHOLDER_CREATE_COMMENT_ACTIONS';
const $acf4ef636a959927$export$483d9bcbbd8280a6 = 'status-spotlight';
const $acf4ef636a959927$export$95f98990d7202b31 = 'SHOW_MORE';
const $acf4ef636a959927$export$95ff4d03075475e2 = 'PIN_FIELD';
const $acf4ef636a959927$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $acf4ef636a959927$export$6f48b612d5c03f4d = 'PERMALINK';
const $acf4ef636a959927$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $acf4ef636a959927$export$fa5ad81958817beb = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.details-group';
const $acf4ef636a959927$export$1ba8bc5ff9e50d09 = 'QUICK_ADDS';
const $acf4ef636a959927$export$f9baa44349b5d6b8 = 'JSW_ACTIVITY_FEED_BUTTONS';
const $acf4ef636a959927$export$f49830a0e4ffb3f9 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.sla-group';
const $acf4ef636a959927$export$efb12103a5e32a1e = 'PIN_FIELD_PLACEHOLDER_BANNER';
const $acf4ef636a959927$export$4288bce987c22af4 = 'PINNED_FIELDS_PANEL';
const $acf4ef636a959927$export$ddb80c23a62a41e = 'jira.user.issue.has.seen.quick-actions.change-boarding.message';

parcelRegister("04yyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $817ca1d3587d560c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $fphHl = parcelRequire("fphHl");
var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");
var $8TQB5 = parcelRequire("8TQB5");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $jBnf2 = parcelRequire("jBnf2");

var $jEJ7g = parcelRequire("jEJ7g");

var $2gCtH = parcelRequire("2gCtH");

var $93Yeu = parcelRequire("93Yeu");

var $aCMMa = parcelRequire("aCMMa");

var $eFjOA = parcelRequire("eFjOA");

var $iMJne = parcelRequire("iMJne");

var $fu9Hs = parcelRequire("fu9Hs");
const $817ca1d3587d560c$export$516dbae3e1050541 = 'internal';
const $817ca1d3587d560c$export$c8c375193052eb0 = 'public';
const $817ca1d3587d560c$var$TABS = {
    public: {
        id: $817ca1d3587d560c$export$c8c375193052eb0,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fu9Hs.default).replyToCustomer),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null)
    },
    internal: {
        id: $817ca1d3587d560c$export$516dbae3e1050541,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fu9Hs.default).addInternalNote),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null)
    }
};
const $817ca1d3587d560c$var$JCS_TABS = {
    public: {
        id: $817ca1d3587d560c$export$c8c375193052eb0,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fu9Hs.default).replyToCustomer),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null)
    },
    internal: {
        id: $817ca1d3587d560c$export$516dbae3e1050541,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $fu9Hs.default).addNote),
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null)
    }
};
const $817ca1d3587d560c$var$ExpandedView = ({ isInternal: isInternal, isPublicCommentAllowed: isPublicCommentAllowed, hasPublicComments: hasPublicComments, children: children, onTabSelect: onTabSelect })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectType);
    const currentTabs = isJCS ? $817ca1d3587d560c$var$JCS_TABS : $817ca1d3587d560c$var$TABS;
    const selectedTabIndex = isPublicCommentAllowed && !isInternal ? currentTabs.public : currentTabs.internal;
    const tabs = isPublicCommentAllowed ? [
        currentTabs.internal,
        currentTabs.public
    ] : [
        currentTabs.internal
    ];
    // Loom banner in JSM Agent response Experiment
    const isLoomJSMBannerEnabled = (0, $4R6GH.fg)('loom_jsm_experiment_controller') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jBnf2.useLoomJSMAgentBanner)({
        hasPublicComments: hasPublicComments,
        isEditingInternal: isInternal,
        isServiceDesk: true
    }) : undefined;
    const handleChange = (0, $5uXOq.useCallback)((index)=>{
        onTabSelect({
            id: index === 0 ? $817ca1d3587d560c$export$516dbae3e1050541 : $817ca1d3587d560c$export$c8c375193052eb0
        });
    }, [
        onTabSelect
    ]);
    const getAssistiveLabel = ()=>{
        const internalMessage = isJCS ? (0, $fu9Hs.default).addNote : (0, $fu9Hs.default).addInternalNote;
        return formatMessage(isInternal ? internalMessage : (0, $fu9Hs.default).replyToCustomer);
    };
    const renderCustomSecondaryToolbar = (onSave, onCancel, editorApiRef, secondaryToolbarComponents)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJne.CustomSecondaryToolbar), {
            isInternal: isInternal,
            onSave: onSave,
            onCancel: onCancel,
            editorApiRef: editorApiRef,
            secondaryToolbarComponents: secondaryToolbarComponents
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $817ca1d3587d560c$var$tabsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
        selected: selectedTabIndex.id === $817ca1d3587d560c$export$516dbae3e1050541 ? 0 : 1,
        onChange: handleChange,
        id: "comment-editor-container-tabs",
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cte3m.default), null, tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxIT3.default), {
            key: index
        }, tab.label))), tabs.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TQB5.default), {
            key: index
        }, tab.content)))), isJCS && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eFjOA.CustomBanner), {
        isInternal: isInternal
    }), children({
        assistiveLabel: (0, $4R6GH.fg)('jcs_master_flag') ? getAssistiveLabel() : formatMessage(isInternal ? (0, $fu9Hs.default).addInternalNote : (0, $fu9Hs.default).replyToCustomer),
        renderCustomSecondaryToolbar: isJCS ? renderCustomSecondaryToolbar : undefined,
        isLoomJSMBannerEnabled: isLoomJSMBannerEnabled
    }));
};
const $817ca1d3587d560c$var$CollapsedView = ({ onReplyToCustomer: onReplyToCustomer, onAddInternalNote: onAddInternalNote, isPublicCommentAllowed: isPublicCommentAllowed, replyToCustomerButtonActions: replyToCustomerButtonActions, addInternalNoteButtonActions: addInternalNoteButtonActions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCMMa.default), {
        onReplyToCustomer: onReplyToCustomer,
        onAddInternalNote: onAddInternalNote,
        isPublicCommentAllowed: isPublicCommentAllowed,
        replyToCustomerButtonActions: replyToCustomerButtonActions,
        addInternalNoteButtonActions: addInternalNoteButtonActions
    });
const $817ca1d3587d560c$export$403b6d98f3dc0f95 = ({ isExpanded: isExpanded = false, isInternal: isInternal = false, isPublicCommentAllowed: isPublicCommentAllowed = false, hasPublicComments: hasPublicComments, onExpanded: onExpanded = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCommentVisibilityChange: onCommentVisibilityChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children, commentButtonActions: commentButtonActions })=>{
    const expandEditor = (0, $5uXOq.useCallback)(()=>{
        if (!isExpanded) onExpanded && onExpanded();
    }, [
        isExpanded,
        onExpanded
    ]);
    const onReplyToCustomer = (0, $5uXOq.useCallback)(()=>{
        onCommentVisibilityChange(false);
        expandEditor();
    }, [
        expandEditor,
        onCommentVisibilityChange
    ]);
    const onAddInternalNote = (0, $5uXOq.useCallback)(()=>{
        onCommentVisibilityChange(true);
        expandEditor();
    }, [
        expandEditor,
        onCommentVisibilityChange
    ]);
    const onTabSelect = (0, $5uXOq.useCallback)((selectedTab)=>{
        onCommentVisibilityChange(selectedTab.id === $817ca1d3587d560c$export$516dbae3e1050541);
    }, [
        onCommentVisibilityChange
    ]);
    return isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($817ca1d3587d560c$var$ExpandedView, {
        isInternal: isInternal,
        isPublicCommentAllowed: isPublicCommentAllowed,
        hasPublicComments: hasPublicComments,
        onTabSelect: onTabSelect
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($817ca1d3587d560c$var$CollapsedView, {
        onReplyToCustomer: onReplyToCustomer,
        onAddInternalNote: onAddInternalNote,
        isPublicCommentAllowed: isPublicCommentAllowed,
        replyToCustomerButtonActions: commentButtonActions,
        addInternalNoteButtonActions: commentButtonActions
    });
};
var $817ca1d3587d560c$export$2e2bcd8739ae039 = $817ca1d3587d560c$export$403b6d98f3dc0f95;
const $817ca1d3587d560c$var$tabsContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});
parcelRegister("jBnf2", function(module, exports) {

$parcel$export(module.exports, "useLoomJSMAgentBanner", () => $61ab95e50a4aadee$export$322fac8e0ee6fd56);

var $5uXOq = parcelRequire("5uXOq");

var $c04PQ = parcelRequire("c04PQ");

var $4Pf62 = parcelRequire("4Pf62");

var $2gCtH = parcelRequire("2gCtH");

var $3c83i = parcelRequire("3c83i");

var $44n8X = parcelRequire("44n8X");

var $5fc53 = parcelRequire("5fc53");

var $hqBSi = parcelRequire("hqBSi");
const $61ab95e50a4aadee$export$322fac8e0ee6fd56 = ({ hasPublicComments: hasPublicComments, isEditingInternal: isEditingInternal, isServiceDesk: isServiceDesk })=>{
    const isFedRampInstance = (0, $c04PQ.isFedRamp)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const tenantHasLoomTCS = Boolean(licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).LOOM]);
    const issueKey = (0, $2gCtH.useIssueKey)();
    const [{ value: createdDate }] = (0, $3c83i.useDateTimeField)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.CREATED)
    });
    const [{ value: resolution }] = (0, $44n8X.useResolutionField)({
        issueKey: issueKey
    });
    const isSupportedJSMIssue = (0, $5uXOq.useMemo)(()=>{
        return isServiceDesk && !resolution && !!createdDate && (hasPublicComments || new Date().getTime() - new Date(createdDate).getTime() >= 86400000);
    }, [
        createdDate,
        isServiceDesk,
        resolution,
        hasPublicComments
    ]);
    return !isEditingInternal && !tenantHasLoomTCS && !isFedRampInstance && isSupportedJSMIssue;
};

});

parcelRegister("aCMMa", function(module, exports) {

$parcel$export(module.exports, "default", () => $bee62922f6e51004$export$2e2bcd8739ae039);

var $iQv12 = parcelRequire("iQv12");

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $d4MOh = parcelRequire("d4MOh");

var $1rTSt = parcelRequire("1rTSt");
const $bee62922f6e51004$var$CollapsedEditor = (0, $dRLCn.flowWithSafeComponent)(// @ts-expect-error - Argument of type '<T extends ComponentType<any>, Props = PropsWithoutRef<ComponentProps<T>>>(WrappedComponent: T) => WithUIAnalyticsEvent<Props, { onReplyToCustomer: string; onAddInternalNote: string; }>' is not assignable to parameter of type 'FlowStep<T, ComponentType<Matching<StateProps & {}, Props & { onReplyToCustomer?: ("onReplyToCustomer" extends keyof Props ? Props[keyof Props & "onReplyToCustomer"] : AnalyticsCallback) | undefined; onAddInternalNote?: ("onAddInternalNote" extends keyof Props ? Props[keyof Props & "onAddInternalNote"] : AnalyticsCa...'.
(0, $iQv12.default)({
    onReplyToCustomer: 'onReplyToCustomer',
    onAddInternalNote: 'onAddInternalNote'
}), (0, $hxqfC.connect)((state)=>({
        isCommentAttachmentInProgress: (0, $d4MOh.isCommentAttachmentInProgressSelector)(state)
    }), {}));
var $bee62922f6e51004$export$2e2bcd8739ae039 = $bee62922f6e51004$var$CollapsedEditor((0, $1rTSt.CollapsedEditorView));

});
parcelRegister("1rTSt", function(module, exports) {

$parcel$export(module.exports, "CollapsedEditorView", () => $a0caceb3798aed97$export$19e20a01fb7ade55);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/i18n/text-wrapped-in-format-message */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $bUmQV = parcelRequire("bUmQV");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $kLoIs = parcelRequire("kLoIs");

var $7xynd = parcelRequire("7xynd");

var $amv56 = parcelRequire("amv56");

var $8zOmE = parcelRequire("8zOmE");

var $93Yeu = parcelRequire("93Yeu");

var $17Gip = parcelRequire("17Gip");

var $jEJ7g = parcelRequire("jEJ7g");

var $kwGW2 = parcelRequire("kwGW2");


var $6DC49 = parcelRequire("6DC49");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $fu9Hs = parcelRequire("fu9Hs");

var $Dhj0l = parcelRequire("Dhj0l");
const $a0caceb3798aed97$var$UpdateStakeholderLinkInnerOld = ()=>{
    const [isStakeHolderModalOpen, setIsStakeHolderModalOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "\xa0/\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: (event, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewUpdateStakeholderModal');
            setIsStakeHolderModalOpen(true);
        },
        interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.button"
    }, (0, $4R6GH.fg)('fe_stakeholder_email_templates_in_jsm') ? formatMessage((0, $fu9Hs.default).notifyStakeholders) : formatMessage((0, $fu9Hs.default).informStakeholders)), isStakeHolderModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $amv56.AsyncSendStakeholderUpdatesModal), {
        onCloseUpdateStakeholderModal: ()=>setIsStakeHolderModalOpen(false)
    }));
};
const $a0caceb3798aed97$var$UpdateStakeholderLinkInner = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isStakeHolderModalOpen, setIsStakeHolderModalOpen] = (0, $5uXOq.useState)(false);
    const [{ limits: limits, issueVersion: issueVersion }] = (0, $7xynd.useStakeholderUpdatesStore)();
    if (issueVersion.isNew) {
        const isLimitsExceed = limits.isEmailQuotaExceeded && limits.isTrial;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "\xa0/\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isLimitsExceed ? formatMessage((0, $fu9Hs.default).informStakeholderLimitExceed) : ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            isDisabled: isLimitsExceed,
            appearance: "link",
            onClick: (event, analyticsEvent)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewUpdateStakeholderModal');
                setIsStakeHolderModalOpen(true);
            },
            interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.button1"
        }, (0, $4R6GH.fg)('fe_stakeholder_email_templates_in_jsm') ? formatMessage((0, $fu9Hs.default).notifyStakeholders) : formatMessage((0, $fu9Hs.default).informStakeholders))), isStakeHolderModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $amv56.AsyncSendStakeholderUpdatesModal), {
            onCloseUpdateStakeholderModal: ()=>setIsStakeHolderModalOpen(false)
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0caceb3798aed97$var$UpdateStakeholderLinkInnerOld, null);
};
const $a0caceb3798aed97$export$54c002f5d9342e56 = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const issueId = (0, $2gCtH.useIssueId)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const isStakeholderVisible = (0, $17Gip.useCanUseServiceDeskAgentFeatures)(projectKey);
    const [hasOpsgenieAccount] = (0, $kwGW2.useHasCurrentUserOpsgenieAccount)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const [{ data: incidentCapabilities }] = (0, $6DC49.useIncidentCapabilitiesProvisionState)();
    const hasSystemIncident = incidentCapabilities?.provisionState === (0, $b2790c71f80dc6c9$export$71efb3495f6084f2);
    const showStakeholderUpdatesLink = isStakeholderVisible && hasOpsgenieAccount === true;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (incidentCapabilities === undefined || !hasSystemIncident || !showStakeholderUpdatesLink) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7xynd.StakeholderUpdatesStoreContainer), {
        analyticsEvent: createAnalyticsEvent({}),
        issueId: issueId,
        cloudId: cloudId,
        scope: issueId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0caceb3798aed97$var$UpdateStakeholderLinkInner, null));
};
const $a0caceb3798aed97$export$19e20a01fb7ade55 = ({ onReplyToCustomer: onReplyToCustomer, onAddInternalNote: onAddInternalNote, isCommentAttachmentInProgress: isCommentAttachmentInProgress, isPublicCommentAllowed: isPublicCommentAllowed, replyToCustomerButtonActions: replyToCustomerButtonActions, addInternalNoteButtonActions: addInternalNoteButtonActions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isIssueOfIncidentsPractice = (0, $kLoIs.useIsIssueOfIncidentsPractice)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0caceb3798aed97$var$ServiceDeskCommentButtonsContainer, null, isCommentAttachmentInProgress ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0caceb3798aed97$var$LoadingAttachmentStatus, null, formatMessage((0, $fu9Hs.default).loadingAttachments)) : // DO NOT REMOVE  the testId below, it is being used in by <GenerateComment/> to locate 'reply to customer' button
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        testId: "issue-view-servicedesk-editor-container.collapsed-editor-view.add-comment-buttons-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: onAddInternalNote,
        interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.button2",
        ...addInternalNoteButtonActions
    }, formatMessage(isJCS ? (0, $fu9Hs.default).addNote : (0, $fu9Hs.default).addInternalNote)), isPublicCommentAllowed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "\xa0/\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: onReplyToCustomer,
        interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.button3",
        ...replyToCustomerButtonActions
    }, formatMessage((0, $fu9Hs.default).replyToCustomer))), isIssueOfIncidentsPractice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0caceb3798aed97$export$54c002f5d9342e56, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Dhj0l.default), null));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0caceb3798aed97$var$ServiceDeskCommentButtonsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1reo15vq _18m915vq _189et94y _1dqonqa1 _1h6dmuej _o5721q9c _4t3i1ylp _vchhusvi _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf _1e0c1txw _4cvr1h6o _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a0caceb3798aed97$var$LoadingAttachmentStatus = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a0caceb3798aed97$export$7ed12d2a5241e393 = {
    LoadingAttachmentStatus: $a0caceb3798aed97$var$LoadingAttachmentStatus
};

});
parcelRegister("7xynd", function(module, exports) {

$parcel$export(module.exports, "StakeholderUpdatesStoreContainer", () => $289d483c043a80c2$export$7060c723b1b08025);
$parcel$export(module.exports, "useStakeholderUpdatesStore", () => $289d483c043a80c2$export$2af4ca59866e845);
$parcel$export(module.exports, "useUpdatedServices", () => $289d483c043a80c2$export$17227b41fe2f368);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dpuVE = parcelRequire("dpuVE");
const $289d483c043a80c2$export$7060c723b1b08025 = (0, $gg7kZ.createContainer)();
const $289d483c043a80c2$export$d4c72bab9d6cc13a = {
    issueVersion: {
        isNew: undefined
    },
    emailTemplatesList: {
        data: undefined,
        paginationKey: null,
        count: 0,
        isLoading: false,
        error: undefined
    },
    emailTemplate: {
        data: undefined,
        loading: false,
        error: undefined
    },
    limits: {
        emailQuota: 50,
        isEmailQuotaExceeded: false,
        isTrial: false,
        stakeholderTemplatesEnabled: false
    },
    informModal: {
        isUpdateStakeholderLoading: false,
        latestUpdate: {
            isLoading: false
        }
    },
    isStakeholderUpdatesModalOpen: false,
    stakeholders: {
        loading: true
    }
};
const $289d483c043a80c2$export$dc3fed948a31751d = (0, $iXqE5.createStore)({
    name: 'JSDIncidentManagementStakeholderUpdatesStore',
    initialState: $289d483c043a80c2$export$d4c72bab9d6cc13a,
    actions: $dpuVE.actions,
    containedBy: $289d483c043a80c2$export$7060c723b1b08025,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch, getState: getState })=>{
                await dispatch((0, $dpuVE.actions).getIssueVersion());
                const { issueVersion: issueVersion } = getState();
                if (issueVersion.isNew) await dispatch((0, $dpuVE.actions).getLimits());
            }
    }
});
const $289d483c043a80c2$export$2af4ca59866e845 = (0, $3sQ5x.createHook)($289d483c043a80c2$export$dc3fed948a31751d);
const $289d483c043a80c2$var$delays = [
    10000,
    15000,
    25000
];
const $289d483c043a80c2$var$updatedServicesStore = (0, $iXqE5.createStore)({
    initialState: {
        hasServicesUpdated: ''
    },
    actions: {
        updateServices: ()=>// @ts-expect-error - TS2322 - Type '({ setState }: StoreActionApi<AffectedServicesUpdatedState>) => void' is not assignable to type 'Action<AffectedServicesUpdatedState, void, Promise<undefined> | undefined>'.
            ({ setState: setState })=>{
                $289d483c043a80c2$var$delays.forEach((delay)=>{
                    setTimeout(()=>{
                        setState({
                            hasServicesUpdated: new Date().toISOString()
                        });
                    }, delay);
                });
            }
    }
});
const $289d483c043a80c2$export$17227b41fe2f368 = (0, $3sQ5x.createHook)($289d483c043a80c2$var$updatedServicesStore);

});
parcelRegister("dpuVE", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b0695fcf3982e4dd$export$e324594224ef24da);

var $16v4p = parcelRequire("16v4p");

var $5GIbu = parcelRequire("5GIbu");

var $ldbF4 = parcelRequire("ldbF4");

var $iVStp = parcelRequire("iVStp");

var $17XVT = parcelRequire("17XVT");

var $apoOl = parcelRequire("apoOl");

var $hDNWP = parcelRequire("hDNWP");

var $fa3z3 = parcelRequire("fa3z3");

var $3UpVD = parcelRequire("3UpVD");
const $b0695fcf3982e4dd$export$e324594224ef24da = {
    getStakeholders: $ldbF4.getStakeholders,
    addStakeholder: $16v4p.addStakeholder,
    removeStakeholder: $fa3z3.removeStakeholder,
    updateStakeholder: $3UpVD.updateStakeholder,
    getLatestUpdate: $apoOl.getLatestUpdate,
    getLimits: $hDNWP.getLimits,
    getIssueVersion: $17XVT.getIssueVersion,
    fetchEmailTemplates: $5GIbu.fetchEmailTemplates,
    getEmailTemplate: $iVStp.getEmailTemplate,
    resetStakeholderUpdateLoading: $3UpVD.resetStakeholderUpdateLoading,
    resetEmailTemplatesList: $5GIbu.resetEmailTemplatesList,
    resetLatestUpdate: $apoOl.resetLatestUpdate,
    resetEmailTemplate: $iVStp.resetEmailTemplate
};

});
parcelRegister("16v4p", function(module, exports) {

$parcel$export(module.exports, "addStakeholder", () => $30c63d42a9c82489$export$54a1b87b3e67636f);

var $k8IPx = parcelRequire("k8IPx");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $i2KdD = parcelRequire("i2KdD");

var $dRh41 = parcelRequire("dRh41");

var $9A9vw = parcelRequire("9A9vw");
const $30c63d42a9c82489$export$54a1b87b3e67636f = (updatedStakeholders)=>async ({ getState: getState, setState: setState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent })=>{
        const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
        const { stakeholders: stakeholders, issueVersion: issueVersion } = getState();
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        // @ts-expect-error - TS2345 - Argument of type 'Stakeholders | undefined' is not assignable to parameter of type 'List<Stakeholder>'.
        const addedStakeholders = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(updatedStakeholders, stakeholders.data);
        if (issueVersion.isNew) setState({
            stakeholders: {
                ...stakeholders,
                error: undefined,
                isAddStakeholderLoading: true
            }
        });
        else {
            // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            const data = (0, $dRh41.transformStkeholdersDetailResponseData)(updatedStakeholders);
            setState({
                stakeholders: {
                    error: undefined,
                    data: data
                }
            });
        }
        try {
            let url;
            if (issueVersion.isNew) url = `/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}`;
            else url = `${(0, $i2KdD.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/stakeholders`;
            const response = await (0, $eusud.performPostRequest)(url, {
                body: JSON.stringify({
                    stakeholderAris: issueVersion.isNew ? addedStakeholders : addedStakeholders.map((stakeholder)=>stakeholder.ari)
                })
            });
            if (issueVersion.isNew) setState({
                stakeholders: {
                    data: [
                        ...stakeholders.data ?? [],
                        ...response
                    ],
                    error: undefined,
                    isAddStakeholderLoading: false
                }
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/59451
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'addStakeholder succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // https://data-portal.internal.atlassian.com/analytics/registry/41051
            (0, $jcw0u.default)({
                event: analyticsEvent,
                meta: {
                    id: 'addStakeholder',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            if (issueVersion.isNew) setState({
                stakeholders: {
                    ...stakeholders,
                    isAddStakeholderLoading: false,
                    error: e.message
                }
            });
            else setState({
                stakeholders: {
                    error: e.message
                }
            });
            showFlag({
                type: 'error',
                title: (0, $9A9vw.default).failureHeading,
                description: (0, $9A9vw.default).failureDescription,
                messageId: 'jsm-stakeholder-updates.services.actions.add-stakeholder.show-flag.error',
                messageType: 'transactional'
            });
        }
    };

});
parcelRegister("dRh41", function(module, exports) {

$parcel$export(module.exports, "transformStkeholdersDetailResponseData", () => $8cf4451e1843d1a7$export$e741ef7a988a6aec);
$parcel$export(module.exports, "toServiceListString", () => $8cf4451e1843d1a7$export$f13a341bd4969e8);
const $8cf4451e1843d1a7$export$e741ef7a988a6aec = (stakeholders)=>// @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
    stakeholders.map((stakeholder)=>({
            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Stakeholder | Stakeholder'. | TS2339 - Property 'name' does not exist on type 'Stakeholder | Stakeholder'. | TS2339 - Property 'fullName' does not exist on type 'Stakeholder | Stakeholder'.
            name: stakeholder.name !== undefined ? stakeholder.name : stakeholder.fullName,
            avatarUrl: stakeholder.avatarUrl,
            // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            ari: stakeholder.ari,
            // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            id: stakeholder.ari,
            // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            isManuallyAdded: stakeholder?.isManuallyAdded,
            services: stakeholder?.services
        }));
const $8cf4451e1843d1a7$export$f13a341bd4969e8 = (services)=>{
    if (!services || !services.length) return '';
    return services.join(', ');
};

});

parcelRegister("9A9vw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1835d7bcd438c023$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1835d7bcd438c023$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failureHeading: {
        "id": "jsm-stakeholder-updates.services.actions.add-stakeholder.failure-heading",
        "defaultMessage": "Stakeholder was not added"
    },
    failureDescription: {
        "id": "jsm-stakeholder-updates.services.actions.add-stakeholder.failure-description",
        "defaultMessage": "Something went wrong. Try refreshing the page."
    }
});

});


parcelRegister("5GIbu", function(module, exports) {

$parcel$export(module.exports, "fetchEmailTemplates", () => $3f6c1b66ba9324d5$export$d285cf124e8ebaa6);
$parcel$export(module.exports, "resetEmailTemplatesList", () => $3f6c1b66ba9324d5$export$723ba53d6e196f0);

var $7f4tk = parcelRequire("7f4tk");

var $i2KdD = parcelRequire("i2KdD");
const $3f6c1b66ba9324d5$export$d285cf124e8ebaa6 = (limit, paginationKey)=>async ({ getState: getState, setState: setState }, { cloudId: cloudId })=>{
        const { emailTemplatesList: emailTemplatesList } = getState();
        if (emailTemplatesList.isLoading) return;
        setState({
            emailTemplatesList: {
                ...emailTemplatesList,
                isLoading: true,
                error: undefined
            }
        });
        try {
            const queryParams = new URLSearchParams({
                limit: limit.toString(),
                ...paginationKey ? {
                    paginationKey: paginationKey
                } : {}
            });
            const response = await (0, $7f4tk.default)(`${(0, $i2KdD.getJsmSesameBaseUrl)(cloudId)}/v1/stakeholders/template/list?${queryParams.toString()}`);
            setState({
                emailTemplatesList: {
                    data: paginationKey ? [
                        ...emailTemplatesList.data || [],
                        ...response.templates
                    ] : response.templates,
                    paginationKey: response.paginationKey,
                    count: response.count,
                    isLoading: false,
                    error: undefined
                }
            });
        } catch (e) {
            setState({
                emailTemplatesList: {
                    ...emailTemplatesList,
                    isLoading: false,
                    error: {
                        value: e instanceof Error ? e.message : 'Unknown error'
                    }
                }
            });
        }
    };
const $3f6c1b66ba9324d5$export$723ba53d6e196f0 = ()=>({ setState: setState })=>{
        setState({
            emailTemplatesList: {
                data: undefined,
                paginationKey: null,
                count: 0,
                isLoading: false,
                error: undefined
            }
        });
    };

});

parcelRegister("ldbF4", function(module, exports) {

$parcel$export(module.exports, "getStakeholders", () => $310650fc4be6e01a$export$30370cfbc42a80a5);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $i2KdD = parcelRequire("i2KdD");

var $dRh41 = parcelRequire("dRh41");

var $5WMxH = parcelRequire("5WMxH");
const $310650fc4be6e01a$export$30370cfbc42a80a5 = ()=>async ({ setState: setState, getState: getState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent })=>{
        const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
        const { issueVersion: issueVersion } = getState();
        if (!issueId) {
            setState({
                stakeholders: {
                    loading: null,
                    error: 'Missing issueId'
                }
            });
            return;
        }
        try {
            let url;
            if (issueVersion.isNew) url = `/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}`;
            else url = `${(0, $i2KdD.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/v2/stakeholders`;
            const response = await (0, $7f4tk.default)(url);
            setState({
                stakeholders: {
                    loading: true
                }
            });
            let data;
            if (issueVersion.isNew) data = response;
            else // @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
            data = (0, $dRh41.transformStkeholdersDetailResponseData)(response.stakeholders);
            setState({
                stakeholders: {
                    loading: null,
                    data: data
                }
            });
            if (issueVersion.isNew) // https://data-portal.internal.atlassian.com/analytics/registry/41036
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getStakeholders succeeded');
            else (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getStakeholdersV2 succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // https://data-portal.internal.atlassian.com/analytics/registry/41045
            (0, $jcw0u.default)({
                event: analyticsEvent,
                meta: {
                    id: 'getStakeholders',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                stakeholders: {
                    loading: null,
                    error: e.message
                }
            });
            showFlag({
                type: 'error',
                title: (0, $5WMxH.default).failureHeading,
                description: (0, $5WMxH.default).failureDescription,
                messageId: 'jsm-stakeholder-updates.services.actions.fetch-stakeholders.show-flag.error',
                messageType: 'transactional'
            });
        }
    };

});
parcelRegister("5WMxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $390971136180c3d2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $390971136180c3d2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failureHeading: {
        "id": "jsm-stakeholder-updates.services.actions.fetch-stakeholders.failure-heading",
        "defaultMessage": "Stakeholders were not populated"
    },
    failureDescription: {
        "id": "jsm-stakeholder-updates.services.actions.fetch-stakeholders.failure-description",
        "defaultMessage": "Something went wrong. Try refreshing the page."
    }
});

});


parcelRegister("iVStp", function(module, exports) {

$parcel$export(module.exports, "getEmailTemplate", () => $2467b93b7fae4fe3$export$1f73ea8e3d4d925d);
$parcel$export(module.exports, "resetEmailTemplate", () => $2467b93b7fae4fe3$export$14e4117e2c60b9ea);

var $7f4tk = parcelRequire("7f4tk");

var $i2KdD = parcelRequire("i2KdD");
const $2467b93b7fae4fe3$export$1f73ea8e3d4d925d = (templateId)=>async ({ getState: getState, setState: setState }, { cloudId: cloudId })=>{
        const { emailTemplate: emailTemplate } = getState();
        if (emailTemplate.loading) return;
        setState({
            emailTemplate: {
                ...emailTemplate,
                loading: true,
                error: undefined
            }
        });
        try {
            const response = await (0, $7f4tk.default)(`${(0, $i2KdD.getJsmSesameBaseUrl)(cloudId)}/v1/stakeholders/template/${templateId}`);
            setState({
                emailTemplate: {
                    data: response,
                    loading: false,
                    error: undefined
                }
            });
        } catch (e) {
            setState({
                emailTemplate: {
                    data: undefined,
                    loading: false,
                    error: {
                        value: e instanceof Error ? e.message : 'Unknown error'
                    }
                }
            });
        }
    };
const $2467b93b7fae4fe3$export$14e4117e2c60b9ea = ()=>({ setState: setState })=>{
        setState({
            emailTemplate: {
                data: undefined,
                loading: false,
                error: undefined
            }
        });
    };

});

parcelRegister("17XVT", function(module, exports) {

$parcel$export(module.exports, "getIssueVersion", () => $21429d433714e4ad$export$2ccef744c0739e3b);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $21429d433714e4ad$export$2ccef744c0739e3b = ()=>async ({ setState: setState }, { cloudId: cloudId, analyticsEvent: analyticsEvent, issueId: issueId })=>{
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        try {
            const response = await (0, $7f4tk.default)(`/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}/new-issue-property`);
            setState({
                issueVersion: {
                    isNew: response.value
                }
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/59452
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getIssueVersion succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setState({
                issueVersion: {
                    isNew: false
                }
            });
            (0, $jcw0u.default)({
                // https://data-portal.internal.atlassian.com/analytics/registry/59453
                event: analyticsEvent,
                meta: {
                    id: 'getIssueVersion',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };

});

parcelRegister("apoOl", function(module, exports) {

$parcel$export(module.exports, "getLatestUpdate", () => $557fafa9007ee256$export$eaeb7cc2c34ef8a9);
$parcel$export(module.exports, "resetLatestUpdate", () => $557fafa9007ee256$export$ac9e67f92028a2f9);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
const $557fafa9007ee256$export$eaeb7cc2c34ef8a9 = ()=>async ({ getState: getState, setState: setState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent })=>{
        const { informModal: { latestUpdate: { isLoading: isLoading }, ...rest } } = getState();
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        if (isLoading) return;
        setState({
            informModal: {
                ...rest,
                latestUpdate: {
                    isLoading: true,
                    data: undefined
                }
            }
        });
        try {
            const data = await (0, $eusud.performGetRequest)(`/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}/status-update/latest`);
            setState({
                informModal: {
                    ...rest,
                    latestUpdate: {
                        isLoading: false,
                        data: data
                    }
                }
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/59451
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getLatestUpdate succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // https://data-portal.internal.atlassian.com/analytics/registry/59455
            (0, $jcw0u.default)({
                event: analyticsEvent,
                meta: {
                    id: 'getLatestUpdate',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                informModal: {
                    ...rest,
                    latestUpdate: {
                        isLoading: false,
                        data: undefined
                    }
                }
            });
        }
    };
const $557fafa9007ee256$export$ac9e67f92028a2f9 = ()=>({ getState: getState, setState: setState })=>{
        const { informModal: { latestUpdate: latestUpdate, ...rest } } = getState();
        setState({
            informModal: {
                ...rest,
                latestUpdate: {
                    ...latestUpdate,
                    data: undefined,
                    isLoading: false
                }
            }
        });
    };

});

parcelRegister("hDNWP", function(module, exports) {

$parcel$export(module.exports, "getLimits", () => $a846fa8cd03390b4$export$fb6dcbdbba8c49f1);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $a846fa8cd03390b4$export$fb6dcbdbba8c49f1 = ()=>async ({ setState: setState }, { cloudId: cloudId, analyticsEvent: analyticsEvent, issueId: issueId })=>{
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        try {
            const limits = await (0, $7f4tk.default)(`/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/feature-gating`);
            setState({
                limits: limits
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/59456
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getLimits succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // https://data-portal.internal.atlassian.com/analytics/registry/59457
            (0, $jcw0u.default)({
                event: analyticsEvent,
                meta: {
                    id: 'getLimits',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };

});

parcelRegister("fa3z3", function(module, exports) {

$parcel$export(module.exports, "removeStakeholder", () => $eb056303f5ca7a57$export$20b3a8c5e5d20c9b);

var $k8IPx = parcelRequire("k8IPx");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $i2KdD = parcelRequire("i2KdD");

var $dRh41 = parcelRequire("dRh41");

var $iuHoq = parcelRequire("iuHoq");
const $eb056303f5ca7a57$export$20b3a8c5e5d20c9b = (updatedStakeholders)=>async ({ setState: setState, getState: getState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent })=>{
        const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
        const { stakeholders: stakeholders, issueVersion: issueVersion } = getState();
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        const removedStakeholders = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(stakeholders.data, updatedStakeholders);
        let data;
        if (issueVersion.isNew) data = updatedStakeholders;
        else data = (0, $dRh41.transformStkeholdersDetailResponseData)(updatedStakeholders);
        setState({
            stakeholders: {
                error: undefined,
                data: data
            }
        });
        try {
            if (issueVersion.isNew) (0, $eusud.performDeleteRequest)(`/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}`, {
                body: JSON.stringify({
                    stakeholderIds: removedStakeholders.map((stakeholder)=>stakeholder.id)
                })
            });
            else await (0, $eusud.performPutRequest)(`${(0, $i2KdD.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/stakeholders`, {
                body: JSON.stringify({
                    stakeholderAris: removedStakeholders.map(// @ts-expect-error: After old version of stakeholders removed/deprecated, that util will be removed. `isNew` is the condition
                    (stakeholder)=>stakeholder.ari)
                })
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/41046
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'removeStakeholder succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // https://data-portal.internal.atlassian.com/analytics/registry/41048
            (0, $jcw0u.default)({
                event: analyticsEvent,
                meta: {
                    id: 'removeStakeholder',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: e,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                stakeholders: {
                    error: e.message
                }
            });
            showFlag({
                type: 'error',
                title: (0, $iuHoq.default).failureHeading,
                description: (0, $iuHoq.default).failureDescription,
                messageId: 'jsm-stakeholder-updates.services.actions.remove-stakeholder.show-flag.error',
                messageType: 'transactional'
            });
        }
    };

});
parcelRegister("iuHoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $52db521298682ee3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $52db521298682ee3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    failureHeading: {
        "id": "jsm-stakeholder-updates.services.actions.remove-stakeholder.failure-heading",
        "defaultMessage": "Stakeholder was not removed"
    },
    failureDescription: {
        "id": "jsm-stakeholder-updates.services.actions.remove-stakeholder.failure-description",
        "defaultMessage": "Something went wrong. Try refreshing the page."
    }
});

});


parcelRegister("3UpVD", function(module, exports) {

$parcel$export(module.exports, "updateStakeholder", () => $7625c903b49f2185$export$817fb696654404cf);
$parcel$export(module.exports, "resetStakeholderUpdateLoading", () => $7625c903b49f2185$export$e45e67193e7d36bf);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");

var $i2KdD = parcelRequire("i2KdD");

var $4R6GH = parcelRequire("4R6GH");

var $amQQr = parcelRequire("amQQr");
const $7625c903b49f2185$export$817fb696654404cf = (stakeholderPayload)=>async ({ getState: getState, setState: setState }, { issueId: issueId, cloudId: cloudId, analyticsEvent: analyticsEvent, onCloseUpdateStakeholderModal: onCloseUpdateStakeholderModal })=>{
        const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
        const { message: message, description: description, templateId: templateId } = stakeholderPayload;
        const { informModal: { isUpdateStakeholderLoading: isUpdateStakeholderLoading, ...rest }, issueVersion: issueVersion } = getState();
        if (isUpdateStakeholderLoading) return;
        if (!issueId) {
            setState({
                stakeholders: {
                    error: 'Missing issueId'
                }
            });
            return;
        }
        setState({
            informModal: {
                ...rest,
                isUpdateStakeholderLoading: true
            }
        });
        const url = issueVersion.isNew ? `/gateway/api/jsm/stakeholders/cloudId/${cloudId}/v1/stakeholders/issue/${issueId}/status-update        ` : `${(0, $i2KdD.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/communication/status-update`;
        const requestBody = {
            message: message,
            description: description,
            templateId: templateId,
            ...(0, $4R6GH.fg)('fe_stakeholder_email_templates_in_jsm') ? {
                contentType: 'adf'
            } : {}
        };
        try {
            await (0, $eusud.performPostRequest)(url, {
                body: JSON.stringify(requestBody)
            });
            setState({
                informModal: {
                    ...rest,
                    isUpdateStakeholderLoading: false
                }
            });
            let successMessage;
            if (issueVersion.isNew) successMessage = (0, $4R6GH.fg)('fe_stakeholder_email_templates_in_jsm') ? (0, $amQQr.default).updateSuccessNew : (0, $amQQr.default).updateSuccess;
            else successMessage = (0, $amQQr.default).updateStakeholderSuccess;
            const sendStakeholderUpdateEvent = {
                action: 'succeeded',
                actionSubject: 'updateStakeholder',
                actionSubjectId: undefined,
                attributes: {
                    issueId: issueId,
                    templateId: templateId
                }
            };
            showFlag({
                type: 'success',
                title: successMessage,
                messageId: 'jsm-stakeholder-updates.services.actions.update-stakeholder.show-flag.success',
                messageType: 'transactional'
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/41055
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, sendStakeholderUpdateEvent);
            onCloseUpdateStakeholderModal?.();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // https://data-portal.internal.atlassian.com/analytics/registry/41054
            (0, $jcw0u.default)({
                event: analyticsEvent,
                meta: {
                    id: 'updateStakeholder',
                    packageName: 'jiraJsmStakeholderUpdates',
                    teamName: 'itsm-agni'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                informModal: {
                    ...rest,
                    isUpdateStakeholderLoading: false
                }
            });
            let errorMessage;
            if (issueVersion.isNew) errorMessage = (0, $4R6GH.fg)('fe_stakeholder_email_templates_in_jsm') ? (0, $amQQr.default).updateErrorNew : (0, $amQQr.default).updateError;
            else errorMessage = (0, $amQQr.default).updateStakeholderError;
            showFlag({
                type: 'error',
                title: errorMessage,
                messageId: 'jsm-stakeholder-updates.services.actions.update-stakeholder.show-flag.error',
                messageType: 'transactional',
                ...(0, $4R6GH.fg)('fe_stakeholder_email_templates_in_jsm') ? {
                    description: (0, $amQQr.default).updateErrorDescription
                } : {}
            });
        }
    };
const $7625c903b49f2185$export$e45e67193e7d36bf = ()=>({ getState: getState, setState: setState })=>{
        const { informModal: { isUpdateStakeholderLoading: isUpdateStakeholderLoading, ...rest } } = getState();
        setState({
            informModal: {
                ...rest,
                isUpdateStakeholderLoading: false
            }
        });
    };

});
parcelRegister("amQQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c49f45d4d21fd87$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8c49f45d4d21fd87$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateStakeholderError: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-stakeholder-error",
        "defaultMessage": "Something went wrong. Please try again."
    },
    updateStakeholderSuccess: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-stakeholder-success",
        "defaultMessage": "Message sent to stakeholders."
    },
    updateError: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-error",
        "defaultMessage": "Couldn\u2019t send message. Try again."
    },
    updateErrorNew: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-error-new",
        "defaultMessage": "We couldn\u2019t send the email"
    },
    updateErrorDescription: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-error.description",
        "defaultMessage": "Try again later."
    },
    updateSuccess: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-success",
        "defaultMessage": "Message sent!"
    },
    updateSuccessNew: {
        "id": "jsm-stakeholder-updates.services.actions.update-stakeholder.update-success-new",
        "defaultMessage": "Email sent to the stakeholders"
    }
});

});




parcelRegister("amv56", function(module, exports) {

$parcel$export(module.exports, "AsyncSendStakeholderUpdatesModal", () => $3a9039adba5bd914$export$6af999048e1303b3);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $3a9039adba5bd914$var$SendStakeholderUpdatesModalLazy = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("b5HEj")), {
    moduleId: "./src/packages/servicedesk/incident-management/issue-view/stakeholder-updates/src/ui/send-stakeholder-updates/index.tsx"
});
const $3a9039adba5bd914$export$6af999048e1303b3 = ({ onCloseUpdateStakeholderModal: onCloseUpdateStakeholderModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "send-stakeholder-updates-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a9039adba5bd914$var$SendStakeholderUpdatesModalLazy, {
        onCloseUpdateStakeholderModal: onCloseUpdateStakeholderModal
    }));

});
parcelRegister("b5HEj", function(module, exports) {

let $813205286bfbf37d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $813205286bfbf37d$var$load("3BpQu").then(()=>parcelRequire('4Lapj'));

});


const $b2790c71f80dc6c9$export$308b1adbd1c265c4 = 'FETCH_INCIDENT_CAPABILITIES_PROVISION_STATE_ERROR';
const $b2790c71f80dc6c9$export$8cf2ab04a7290f8e = 'UPDATE_SYSTEM_INCIDENT_ERROR';
const $b2790c71f80dc6c9$export$2daf2ae6b87b6acf = 'unsuppress_alert_creation';
const $b2790c71f80dc6c9$export$12df15eb7a33df57 = 'suppress_alert_creation';
const $b2790c71f80dc6c9$export$84a9ec0d18610c1e = 'not_provisioned';
const $b2790c71f80dc6c9$export$5a9ac66c2785cc13 = 'in_progress';
const $b2790c71f80dc6c9$export$71efb3495f6084f2 = 'done';
const $b2790c71f80dc6c9$export$103bedf43ba882db = 'error';

parcelRegister("6DC49", function(module, exports) {

$parcel$export(module.exports, "IncidentCapabilitiesProvisionContainer", () => $5ff9d8b1c71543b7$export$a2377e9dd25b3a13);
$parcel$export(module.exports, "useIncidentCapabilitiesProvisionState", () => $5ff9d8b1c71543b7$export$7dafe9ace6d249b2);
$parcel$export(module.exports, "useProvisionIncidentCapabalities", () => $5ff9d8b1c71543b7$export$9f03bf1c2bac0dc7);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $kLoIs = parcelRequire("kLoIs");

var $koeKL = parcelRequire("koeKL");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $9LZg0 = parcelRequire("9LZg0");
const $5ff9d8b1c71543b7$export$d4c72bab9d6cc13a = {
    incidentCapabilitiesProvisionState: {
        data: undefined,
        forIssueId: undefined,
        error: undefined,
        isLoading: false
    },
    provisioningIncidentCapabalities: {
        hasUpdateCompleted: false,
        error: undefined,
        isLoading: false
    }
};
const $5ff9d8b1c71543b7$var$incidentManagementIncidentCapabilitiesProvisionStore = (0, $iXqE5.createStore)({
    name: 'JSDIncidentManagementIncidentCapabilitiesProvision',
    initialState: $5ff9d8b1c71543b7$export$d4c72bab9d6cc13a,
    actions: $9LZg0.actions
});
const $5ff9d8b1c71543b7$export$a2377e9dd25b3a13 = (0, $gg7kZ.createContainer)($5ff9d8b1c71543b7$var$incidentManagementIncidentCapabilitiesProvisionStore);
const $5ff9d8b1c71543b7$export$282e577dbd609d4b = (0, $3sQ5x.createHook)($5ff9d8b1c71543b7$var$incidentManagementIncidentCapabilitiesProvisionStore, {
    selector: ({ incidentCapabilitiesProvisionState: incidentCapabilitiesProvisionState })=>incidentCapabilitiesProvisionState
});
const $5ff9d8b1c71543b7$export$7dafe9ace6d249b2 = ()=>{
    const result = $5ff9d8b1c71543b7$export$282e577dbd609d4b();
    const [{ forIssueId: forIssueId }, { fetchIncidentCapabilitiesProvisionState: fetchIncidentCapabilitiesProvisionState }] = result;
    const issueId = (0, $2gCtH.useIssueId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isIncidentsPracticeEnabled = (0, $kLoIs.useIsIssueOfIncidentsPractice)();
    (0, $5uXOq.useEffect)(()=>{
        if (isIncidentsPracticeEnabled && issueId && forIssueId !== issueId) fetchIncidentCapabilitiesProvisionState(issueId, cloudId);
    }, [
        isIncidentsPracticeEnabled,
        issueId,
        cloudId,
        forIssueId,
        fetchIncidentCapabilitiesProvisionState
    ]);
    return result;
};
const $5ff9d8b1c71543b7$export$9f03bf1c2bac0dc7 = (0, $3sQ5x.createHook)($5ff9d8b1c71543b7$var$incidentManagementIncidentCapabilitiesProvisionStore, {
    selector: ({ provisioningIncidentCapabalities: provisioningIncidentCapabalities })=>provisioningIncidentCapabalities
});

});
parcelRegister("9LZg0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $513e972f20b0be90$export$e324594224ef24da);

var $idnkQ = parcelRequire("idnkQ");

var $jsO5w = parcelRequire("jsO5w");
const $513e972f20b0be90$export$e324594224ef24da = {
    fetchIncidentCapabilitiesProvisionState: $idnkQ.fetchIncidentCapabilitiesProvisionState,
    provisionIncidentCapabalities: $jsO5w.provisionIncidentCapabalities
};

});
parcelRegister("idnkQ", function(module, exports) {

$parcel$export(module.exports, "fetchIncidentCapabilitiesProvisionState", () => $54c1dfff392c62ed$export$9f9b40a56cb5ab43);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");

var $i2KdD = parcelRequire("i2KdD");

const $54c1dfff392c62ed$export$9f9b40a56cb5ab43 = (issueId, cloudId, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { incidentCapabilitiesProvisionState: incidentCapabilitiesProvisionState, provisioningIncidentCapabalities: provisioningIncidentCapabalities } = getState();
        if (incidentCapabilitiesProvisionState.isLoading || !issueId) return;
        setState({
            incidentCapabilitiesProvisionState: {
                ...incidentCapabilitiesProvisionState,
                forIssueId: issueId,
                isLoading: true,
                error: undefined
            }
        });
        try {
            const response = await (0, $7f4tk.default)(`${(0, $i2KdD.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/provision`);
            if (provisioningIncidentCapabalities?.isLoading && response?.provisionState === (0, $b2790c71f80dc6c9$export$71efb3495f6084f2)) setState({
                incidentCapabilitiesProvisionState: {
                    data: response,
                    forIssueId: issueId,
                    isLoading: false,
                    error: undefined
                },
                provisioningIncidentCapabalities: {
                    hasUpdateCompleted: true,
                    isLoading: false,
                    error: undefined
                }
            });
            else setState({
                incidentCapabilitiesProvisionState: {
                    data: response,
                    forIssueId: issueId,
                    isLoading: false,
                    error: undefined
                }
            });
            analyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'fetchIncidentCapabilitiesProvisionState succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.trackFetchErrors)({
                event: analyticsEvent,
                error: e,
                id: 'fetchIncidentCapabilitiesProvisionState',
                sendToPrivacyUnsafeSplunk: true,
                packageName: 'jiraServicedeskSystemIncidentStatus'
            });
            if (provisioningIncidentCapabalities?.isLoading) setState({
                incidentCapabilitiesProvisionState: {
                    data: undefined,
                    forIssueId: issueId,
                    isLoading: false,
                    error: {
                        value: e.message,
                        type: (0, $b2790c71f80dc6c9$export$308b1adbd1c265c4)
                    }
                },
                provisioningIncidentCapabalities: {
                    hasUpdateCompleted: false,
                    isLoading: false,
                    error: undefined
                }
            });
            else setState({
                incidentCapabilitiesProvisionState: {
                    data: undefined,
                    forIssueId: issueId,
                    isLoading: false,
                    error: {
                        value: e.message,
                        type: (0, $b2790c71f80dc6c9$export$308b1adbd1c265c4)
                    }
                }
            });
        }
    };

});

parcelRegister("jsO5w", function(module, exports) {

$parcel$export(module.exports, "provisionIncidentCapabalities", () => $8bae797bf7d5aa5d$export$b83cf9b24594c13c);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $i2KdD = parcelRequire("i2KdD");

const $8bae797bf7d5aa5d$export$b83cf9b24594c13c = (issueId, cloudId, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { provisioningIncidentCapabalities: provisioningIncidentCapabalities } = getState();
        if (provisioningIncidentCapabalities.isLoading || !issueId) return;
        setState({
            provisioningIncidentCapabalities: {
                hasUpdateCompleted: false,
                isLoading: true,
                error: undefined
            }
        });
        try {
            await (0, $eusud.performPostRequest)(`${(0, $i2KdD.getEscalatorBaseUrl)(cloudId)}/issue/${issueId}/incident/provision`);
            /* provisioningIncidentCapabalities state is not updated here as <PeriodicExecutor /> will
            fire once isLoading is true, will be set to updateComplete true and isLoading false once
            async task is finished. Look inside fetch-incident-capabilities-provision-state for more details. */ analyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'provisionIncidentCapabilities succeeded');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.trackFetchErrors)({
                event: analyticsEvent,
                error: e,
                id: 'provisionIncidentCapabilities',
                sendToPrivacyUnsafeSplunk: true,
                packageName: 'jiraServicedeskSystemIncidentStatus'
            });
            setState({
                provisioningIncidentCapabalities: {
                    hasUpdateCompleted: false,
                    isLoading: false,
                    error: {
                        value: e.message,
                        type: (0, $b2790c71f80dc6c9$export$8cf2ab04a7290f8e)
                    }
                }
            });
        }
    };

});



parcelRegister("fu9Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dc2d64494d4ab1c$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $7dc2d64494d4ab1c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    replyToCustomer: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.reply-to-customer-button",
        "defaultMessage": "Reply to customer"
    },
    addInternalNote: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.add-internal-note-button",
        "defaultMessage": "Add internal note"
    },
    addNote: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.add-note-button",
        "defaultMessage": "Add note"
    },
    cancel: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.cancel-button",
        "defaultMessage": "Cancel"
    },
    loadingAttachments: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.loading-attachments",
        "defaultMessage": "Loading attachments\u2026"
    },
    informStakeholders: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.inform-stakeholders",
        "defaultMessage": "Inform stakeholders"
    },
    notifyStakeholders: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.notify-stakeholders",
        "defaultMessage": "Notify stakeholders"
    },
    informStakeholderLimitExceed: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.inform-stakeholder-limit-exceed",
        "defaultMessage": "You cannot send any updates as your trial period limit of 50 stakeholder emails per day is over."
    }
});

});

parcelRegister("Dhj0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac74d7af28336537$export$2e2bcd8739ae039);

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $KH1d8 = parcelRequire("KH1d8");

var $d4MOh = parcelRequire("d4MOh");

var $5sXgE = parcelRequire("5sXgE");
var $ac74d7af28336537$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $hxqfC.connect)((state)=>({
        isCommentAttachmentInProgress: (0, $d4MOh.isCommentAttachmentInProgressSelector)(state)
    }), (dispatch)=>({
        onClick: ()=>{
            dispatch((0, $KH1d8.attachmentPickerPopupOpenSuccess)());
        }
    })))((0, $5sXgE.default));

});
parcelRegister("5sXgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaf49d8c0802762$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $eZ9Cp = parcelRequire("eZ9Cp");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $jSu3W = parcelRequire("jSu3W");
const $8aaf49d8c0802762$var$AttachmentPicker = (props)=>{
    const { onClick: onClick, isCommentAttachmentInProgress: isCommentAttachmentInProgress } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaf49d8c0802762$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jSu3W.default).addAttachmentLabel),
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        spacing: "none",
        appearance: "subtle-link" // @ts-expect-error - TS2322 - Type '{ spacing: "none"; appearance: "subtle-link"; isLoading: boolean; iconBefore: Element; externalId: string; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        ,
        isLoading: isCommentAttachmentInProgress,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaf49d8c0802762$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eZ9Cp))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $jSu3W.default).addAttachmentLabel)
        })),
        externalId: "attachment",
        onClick: onClick,
        interactionName: "auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.attachment-picker.button"
    })));
};
var $8aaf49d8c0802762$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8aaf49d8c0802762$var$AttachmentPicker;
const $8aaf49d8c0802762$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8aaf49d8c0802762$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jSu3W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41a331c74d70c0e$export$2e2bcd8739ae039);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
var $c41a331c74d70c0e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addAttachmentLabel: {
        "id": "issue.label-for-add-attachment-button",
        "defaultMessage": "Add attachment"
    }
});

});





parcelRegister("eFjOA", function(module, exports) {

$parcel$export(module.exports, "CustomBanner", () => $5b94bc586a90b4f5$export$69bb07568c81ae9e);

var $5uXOq = parcelRequire("5uXOq");

var $6N55R = parcelRequire("6N55R");

var $aSByx = parcelRequire("aSByx");

var $1bKdn = parcelRequire("1bKdn");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $2gCtH = parcelRequire("2gCtH");

var $3fAi8 = parcelRequire("3fAi8");

var $4R6GH = parcelRequire("4R6GH");

var $5fc53 = parcelRequire("5fc53");

var $koVbs = parcelRequire("koVbs");

var $7XYc4 = parcelRequire("7XYc4");

var $2SUyp = parcelRequire("2SUyp");
const $5b94bc586a90b4f5$var$CustomerBannerOld = ({ isInternal: isInternal })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $5b94bc586a90b4f5$var$bannerStyles,
            isInternal && $5b94bc586a90b4f5$var$internalBannerStyles
        ],
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6N55R))), {
        color: isInternal ? "var(--ds-icon-accent-yellow, #B38600)" : undefined,
        label: "",
        spacing: "none",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage(isInternal ? (0, $2SUyp.default).internalNoteBanner : (0, $2SUyp.default).replyToCustomerBanner)));
};
const $5b94bc586a90b4f5$var$CustomerBannerNew = ({ isInternal: isInternal })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const [reporter] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.REPORTER_TYPE)
    });
    const displayName = reporter?.displayName;
    const showDisplayName = displayName && !/@/.test(displayName);
    if (isInternal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: [
            $5b94bc586a90b4f5$var$bubleeAlertStyles,
            $5b94bc586a90b4f5$var$internalBubleeStyles
        ],
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aSByx))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "inherit"
    }, formatMessage((0, $2SUyp.default).internalNote)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $5b94bc586a90b4f5$var$bubleeAlertStyles,
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "inherit"
    }, showDisplayName ? formatMessage((0, $2SUyp.default).replyToCustomer, {
        displayName: displayName
    }) : formatMessage((0, $2SUyp.default).replyToCustomerGeneric)));
};
const $5b94bc586a90b4f5$export$69bb07568c81ae9e = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('berry-5112-ugly-panel-uplift'), $5b94bc586a90b4f5$var$CustomerBannerNew, $5b94bc586a90b4f5$var$CustomerBannerOld);
const $5b94bc586a90b4f5$var$bubleeAlertStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    paddingBlock: 'space.075',
    paddingInline: 'space.100',
    alignItems: 'center',
    gap: 'space.050',
    borderStartStartRadius: 'border.radius.100',
    borderStartEndRadius: 'border.radius.100',
    backgroundColor: 'color.background.accent.gray.subtlest'
});
const $5b94bc586a90b4f5$var$internalBubleeStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtlest',
    color: 'color.text.accent.yellow'
});
const $5b94bc586a90b4f5$var$bannerStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.100',
    paddingBlock: 'space.150',
    alignItems: 'center',
    gap: 'space.100'
});
const $5b94bc586a90b4f5$var$internalBannerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtlest'
});

});
parcelRegister("2SUyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fa1fd9d9d13705c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2fa1fd9d9d13705c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    internalNoteBanner: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.customer-service.custom-banner.internal-note-banner--non-final",
        "defaultMessage": "Only team members will see your note."
    },
    replyToCustomerBanner: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.customer-service.custom-banner.reply-to-customer-banner--non-final",
        "defaultMessage": "The customer will see your reply."
    },
    internalNote: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.customer-service.custom-banner.internalnote-banner",
        "defaultMessage": "Only team members will see your note"
    },
    replyToCustomer: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.customer-service.custom-banner.reply-to-customer",
        "defaultMessage": "{displayName} will see your reply"
    },
    replyToCustomerGeneric: {
        "id": "issue.views.issue-base.activity.comment.comment-editor-view.servicedesk-comment-editor-view.customer-service.custom-banner.reply-to-customer-generic",
        "defaultMessage": "The customer will see your reply"
    }
});

});


parcelRegister("iMJne", function(module, exports) {

$parcel$export(module.exports, "CustomSecondaryToolbar", () => $1dba55d58bd610ad$export$bb19a2d648b8828b);

var $5uXOq = parcelRequire("5uXOq");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $awTmI = parcelRequire("awTmI");

var $koVbs = parcelRequire("koVbs");

var $fu9Hs = parcelRequire("fu9Hs");
const $1dba55d58bd610ad$export$bb19a2d648b8828b = ({ isInternal: isInternal, onSave: onSave, onCancel: onCancel, editorApiRef: editorApiRef, secondaryToolbarComponents: secondaryToolbarComponents })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { mediaState: mediaState } = (0, $awTmI.useSharedPluginState)(editorApiRef?.current, [
        'media'
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $1dba55d58bd610ad$var$actionsStyles,
        testId: "issue-view-servicedesk-editor-container.customer-service.custom-secondary-toolbar.flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        isDisabled: saveButtonDisabled,
        onClick: onSave,
        appearance: "primary"
    }, formatMessage(isInternal ? (0, $fu9Hs.default).addNote : (0, $fu9Hs.default).replyToCustomer)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        onClick: onCancel,
        appearance: "subtle"
    }, formatMessage((0, $fu9Hs.default).cancel))), secondaryToolbarComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.050"
    }, Array.isArray(secondaryToolbarComponents) ? secondaryToolbarComponents.map((Component)=>Component) : secondaryToolbarComponents));
};
const $1dba55d58bd610ad$var$actionsStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.150',
    justifyContent: 'space-between'
});

});
parcelRegister("awTmI", function(module, exports) {

$parcel$export(module.exports, "useSharedPluginState", () => $c96ea81c1b46425f$export$a4c4fd90e2b72baa);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $c96ea81c1b46425f$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $c96ea81c1b46425f$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $5uXOq.useMemo)(()=>plugins, []);
}
function $c96ea81c1b46425f$export$a4c4fd90e2b72baa(injectionApi, plugins, options) {
    const pluginNames = $c96ea81c1b46425f$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $5uXOq.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $c96ea81c1b46425f$var$useSharedPluginStateInternal(namedExternalPlugins, options);
}
function $c96ea81c1b46425f$var$useSharedPluginStateInternal(externalPlugins, options = {}) {
    const [pluginStates, setPluginState] = (0, $5uXOq.useState)($c96ea81c1b46425f$var$mapValues(externalPlugins, (value)=>options.disabled ? undefined : value?.sharedState.currentState()));
    const refStates = (0, $5uXOq.useRef)({});
    const mounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (options.disabled) return;
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $c96ea81c1b46425f$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
    return pluginStates;
}

});




parcelRegister("1e96J", function(module, exports) {

$parcel$export(module.exports, "ConnectedRendererOld", () => $42384b6074bf34cc$export$40d8aed56c16c76a);
$parcel$export(module.exports, "ConnectedRendererNew", () => $42384b6074bf34cc$export$3d1a5041756dc8b);

var $5uXOq = parcelRequire("5uXOq");

var $flIRE = parcelRequire("flIRE");

var $6AKJI = parcelRequire("6AKJI");

var $cwbAJ = parcelRequire("cwbAJ");

var $2xRn9 = parcelRequire("2xRn9");
const $42384b6074bf34cc$export$40d8aed56c16c76a = (props)=>{
    const { adf: adf, canEdit: canEdit, commentId: commentId } = props;
    const [{ mentionProvider: mentionProvider, contextIdentifier: contextIdentifier, mediaContext: mediaContext }] = (0, $2xRn9.useEditorState)();
    const toggleTask = (0, $6AKJI.useCommentTasksUpdater)(commentId);
    const taskDecisionProvider = (0, $5uXOq.useMemo)(()=>new (0, $flIRE.IssueTaskDecisionProvider)(toggleTask), [
        toggleTask
    ]);
    if (!mentionProvider || !contextIdentifier || !mediaContext) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwbAJ.default), {
        adf: adf,
        disableActions: !canEdit,
        taskDecisionProvider: taskDecisionProvider,
        mentionProvider: mentionProvider,
        contextIdentifier: contextIdentifier,
        mediaContext: mediaContext
    });
};
const $42384b6074bf34cc$export$3d1a5041756dc8b = (props)=>{
    const { adf: adf, canEdit: canEdit, commentId: commentId } = props;
    const toggleTask = (0, $6AKJI.useCommentTasksUpdater)(commentId);
    const taskDecisionProvider = (0, $5uXOq.useMemo)(()=>new (0, $flIRE.IssueTaskDecisionProvider)(toggleTask), [
        toggleTask
    ]);
    if (!props.mentionProvider || !props.contextIdentifier || !props.mediaContext) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwbAJ.default), {
        adf: adf,
        disableActions: !canEdit,
        taskDecisionProvider: taskDecisionProvider,
        mentionProvider: props.mentionProvider,
        contextIdentifier: props.contextIdentifier,
        mediaContext: props.mediaContext
    });
};

});
parcelRegister("6AKJI", function(module, exports) {

$parcel$export(module.exports, "useCommentTasksUpdater", () => $96f9477c9791c613$export$d4825011365157d0);

var $5uXOq = parcelRequire("5uXOq");

var $8dFNe = parcelRequire("8dFNe");

var $2NMNM = parcelRequire("2NMNM");

var $kVVL1 = parcelRequire("kVVL1");

var $lXqhz = parcelRequire("lXqhz");
const $96f9477c9791c613$export$d4825011365157d0 = (commentId)=>{
    const store = (0, $kVVL1.useStore)();
    const dispatch = (0, $kVVL1.useDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const getAdfValue = (0, $5uXOq.useCallback)(()=>store.getState().entities.comments[commentId]?.bodyAdf, [
        commentId,
        store
    ]);
    const changeAdfValue = (0, $5uXOq.useCallback)((updatedAdf)=>{
        dispatch((0, $8dFNe.setCommentValue)(commentId, updatedAdf));
    }, [
        commentId,
        dispatch
    ]);
    const saveAdfValue = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $8dFNe.saveCommentRequest)(store.getState().entities.comments[commentId], createAnalyticsEvent({}), store.getState().ui.comments.commentSessionId));
    }, [
        commentId,
        createAnalyticsEvent,
        dispatch,
        store
    ]);
    const toggleTask = (0, $lXqhz.useTasksUpdater)({
        getAdfValue: getAdfValue,
        onChange: changeAdfValue,
        onSave: saveAdfValue
    });
    return toggleTask;
};

});


parcelRegister("d0jbS", function(module, exports) {

let $977a294f1ed05440$var$load = (parcelRequire("28QjX"))(4);
module.exports = $977a294f1ed05440$var$load("iEIoy").then(()=>parcelRequire('2ho4Z'));

});





parcelRegister("6iXgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $77eae6db848bec4a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $jEJ7g = parcelRequire("jEJ7g");

var $2xRn9 = parcelRequire("2xRn9");

var $qymVE = parcelRequire("qymVE");

const $77eae6db848bec4a$var$ConnectedCommentContent = (props)=>{
    const [{ projectType: projectType }] = (0, $2xRn9.useContextState)();
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectType);
    const intl = (0, $koVbs.default)();
    if (!(0, $2xRn9.useContextState)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qymVE.CommentContent), {
        ...props,
        isServiceDesk: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT),
        isCustomerService: isJCS,
        intl: intl
    });
};
var $77eae6db848bec4a$export$2e2bcd8739ae039 = $77eae6db848bec4a$var$ConnectedCommentContent;

});

parcelRegister("iBYZ7", function(module, exports) {

$parcel$export(module.exports, "EventOccurredAtSelector", () => $4b5476ac44bc4786$export$b28045135b1492ee);

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");

var $7CMcV = parcelRequire("7CMcV");
var $3Mgup = parcelRequire("3Mgup");

var $fVnbM = parcelRequire("fVnbM");

var $htnpT = parcelRequire("htnpT");

var $feC7X = parcelRequire("feC7X");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eGLgs = parcelRequire("eGLgs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $kLoIs = parcelRequire("kLoIs");

var $6yeNV = parcelRequire("6yeNV");

var $cYlk7 = parcelRequire("cYlk7");

var $1p96B = parcelRequire("1p96B");

var $ehdJY = parcelRequire("ehdJY");

var $DVljb = parcelRequire("DVljb");

var $8fUri = parcelRequire("8fUri");

var $aVyi8 = parcelRequire("aVyi8");
const $4b5476ac44bc4786$export$dc59854f87f8c633 = (args)=>args ? new Date(args) : new Date();
const $4b5476ac44bc4786$var$CustomPopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, 'data-testid': testId, xcss: _xcss, ...containerProps }, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4b5476ac44bc4786$var$dateTimePickerWrapperStyle,
        testId: testId,
        ...containerProps,
        ref: ref
    }, children));
const $4b5476ac44bc4786$export$b28045135b1492ee = (props)=>{
    const locale = (0, $DVljb.useLocale)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $koVbs.default)();
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
    const currentUser = (0, $cYlk7.useCurrentUser)();
    const timeZone = !currentUser.loading && !currentUser.error && 'timeZone' in currentUser.data.user && currentUser.data.user.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [dateTimeValue, updateDateTimeValue] = (0, $5uXOq.useState)(props.initialValue ? (0, $7CMcV.default)($4b5476ac44bc4786$export$dc59854f87f8c633(props.initialValue), timeZone).toISOString() : null);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const [showDateTimePicker, changeShowDateTimePicker] = (0, $5uXOq.useState)(false);
    const isIssueOfIncidentPractice = (0, $kLoIs.useIsIssueOfIncidentsPractice)();
    const isAgentOrProjectAdmin = (0, $kLoIs.useIsAgentOrProjectAdmin)();
    const timePickerOptions = (()=>{
        const options = [];
        let currentDate = $4b5476ac44bc4786$export$dc59854f87f8c633($4b5476ac44bc4786$export$dc59854f87f8c633().setHours(0, 0, 0, 0));
        const currentDateDay = Number(currentDate.getDay());
        while(currentDate.getDay() === currentDateDay){
            options.push((0, $k7m40.default)(currentDate, 'HH:mm'));
            currentDate = $4b5476ac44bc4786$export$dc59854f87f8c633(currentDate.valueOf() + 900000);
        }
        return options;
    })();
    const onChangeDateTimePicker = (value)=>{
        if (value !== '') {
            const zonedTimeInUtc = (0, $3Mgup.default)($4b5476ac44bc4786$export$dc59854f87f8c633(value), timeZone);
            updateDateTimeValue(value);
            changeShowDateTimePicker(false);
            props.onChange(zonedTimeInUtc.getTime());
        } else {
            updateDateTimeValue(null);
            props.onChange(null);
        }
    };
    if (!isIssueOfIncidentPractice || !isAgentOrProjectAdmin) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: showDateTimePicker,
        onClose: ()=>changeShowDateTimePicker(false),
        popupComponent: $4b5476ac44bc4786$var$CustomPopupContainer,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
                onChange: onChangeDateTimePicker,
                locale: standardizedLocale,
                value: dateTimeValue || undefined,
                datePickerProps: {
                    ...dateTimeValue == null ? {
                        placeholder: (0, $1p96B.formatWithLocale)((0, $7CMcV.default)($4b5476ac44bc4786$export$dc59854f87f8c633(), timeZone), 'P', locale)
                    } : {},
                    maxDate: (0, $7CMcV.default)($4b5476ac44bc4786$export$dc59854f87f8c633(), timeZone).toISOString()
                },
                timePickerProps: {
                    timeIsEditable: true,
                    ...dateTimeValue == null && {
                        placeholder: (0, $1p96B.formatWithLocale)((0, $7CMcV.default)($4b5476ac44bc4786$export$dc59854f87f8c633(), timeZone), 'p', locale)
                    },
                    times: timePickerOptions
                }
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                ...(0, $4R6GH.fg)('enghealth-11183_a11y_violation_fix') ? {} : triggerProps,
                xcss: $4b5476ac44bc4786$var$wrapperStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: "send-events-to-past-target"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($feC7X))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                }),
                onClick: ()=>{
                    changeShowDateTimePicker(!showDateTimePicker);
                },
                isSelected: showDateTimePicker,
                ...(0, $4R6GH.fg)('enghealth-11183_a11y_violation_fix') ? triggerProps : {}
            }, showDateTimePicker ? formatMessage((0, $aVyi8.default).selectDateAndTimeText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, dateTimeValue ? formatDate(dateTimeValue, (0, $8fUri.DATE_FORMAT)) : formatMessage((0, $aVyi8.default).addToPast)))))
    }), isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: "issue-comment-base.ui.comment.event-occurred-at-selector.coordination-client.spotlight-for-manual-incident-timelines",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        actions: [
            {
                onClick: ()=>setIsSpotlightActive(false),
                text: 'Dismiss'
            },
            {
                appearance: 'subtle',
                onClick: ()=>{
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.open('https://support.atlassian.com/jira-service-management-cloud/docs/what-is-the-incident-timeline/', '_blank');
                },
                text: 'Learn more'
            }
        ],
        heading: formatMessage((0, $aVyi8.default).spotlightHeading),
        target: "send-events-to-past-target",
        key: "send-events-to-past-target",
        targetRadius: 3,
        dialogPlacement: "right middle",
        messageId: "issue-comment-base.ui.comment.event-occurred-at-selector.jira-spotlight.send-events-to-past-target",
        messageType: "engagement"
    }, formatMessage((0, $aVyi8.default).spotlightDescription)))));
};
const $4b5476ac44bc4786$var$dateTimePickerWrapperStyle = (0, $8CUq3.xcss)({
    width: '21rem'
});
const $4b5476ac44bc4786$var$wrapperStyle = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050'
});

});
parcelRegister("8fUri", function(module, exports) {

$parcel$export(module.exports, "DATE_FORMAT", () => $f9adfe0d4303b389$export$45c85543ba71221d);
const $f9adfe0d4303b389$export$45c85543ba71221d = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};

});

parcelRegister("aVyi8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f45f0e189d618803$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f45f0e189d618803$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToPast: {
        "id": "issue-comment-base.comment.event-occurred-at-selector.add-to-past",
        "defaultMessage": "Add to past"
    },
    selectDateAndTimeText: {
        "id": "issue-comment-base.comment.event-occurred-at-selector.select-date-and-time-text",
        "defaultMessage": "Select date & time"
    },
    spotlightHeading: {
        "id": "issue-comment-base.comment.event-occurred-at-selector.spotlight-heading",
        "defaultMessage": "Add internal notes to the past"
    },
    spotlightDescription: {
        "id": "issue-comment-base.comment.event-occurred-at-selector.spotlight-description",
        "defaultMessage": "Assign any incident or post-incident review related activity to a specific date and time in the past using the internal notes feature. Click Add internal note > Select your desired date and time in the past > Save."
    }
});

});


parcelRegister("iDRQC", function(module, exports) {

$parcel$export(module.exports, "ActivityTimestampStylesControl", () => $868662e969060c84$export$fd88f64c579568bc);
$parcel$export(module.exports, "InternalCommentContainer", () => $868662e969060c84$export$40a0e317999628a4);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");
const $868662e969060c84$export$fd88f64c579568bc = {
    // @ts-expect-error - TS2322 - Type 'InterpolationValue[]' is not assignable to type 'string'.
    always: (0, $47bDC.css)({
        color: "var(--ds-text-subtlest, #626F86)"
    }),
    // @ts-expect-error - TS2322 - Type 'InterpolationValue[]' is not assignable to type 'string'.
    whenDisplaySettingSwitchable: (0, $47bDC.css)({
        '&:hover': {
            color: 'inherit'
        }
    })
};
const $868662e969060c84$export$26f6620e3ce19b6f = {
    // @ts-expect-error - TS2322 - Type 'InterpolationValue[]' is not assignable to type 'string'.
    always: null,
    // @ts-expect-error - TS2322 - Type 'InterpolationValue[]' is not assignable to type 'string'.
    whenDisplaySettingSwitchable: null
};
const $868662e969060c84$export$40a0e317999628a4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEditing: isEditing, highlightColor: highlightColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_57lgh5": (0, $lD23V.default)(__cmplp.highlightColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _ca0qu2gc _u5f3idpf _n3td1b66 _19bvu2gc _19pkv47k _2hwxidpf _otyrr5cr _18u0x0bf",
            !__cmplp.isEditing && "_bfhk3c9o",
            __cmplp.className
        ])
    });
});
const $868662e969060c84$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u0r5cr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hdUJF", function(module, exports) {

$parcel$export(module.exports, "CommentFloatingMenu", () => $57e5cbe32044d51e$export$a35ed2b7e1d186e0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $9Xkny = parcelRequire("9Xkny");
const $57e5cbe32044d51e$export$a35ed2b7e1d186e0 = ({ menuItems: menuItems })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return menuItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $57e5cbe32044d51e$var$containerStyle,
        role: "toolbar",
        "aria-label": formatMessage((0, $9Xkny.default).commentActions)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "end",
        xcss: $57e5cbe32044d51e$var$floatingMenuStyle,
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, menuItems))) : null;
};
const $57e5cbe32044d51e$var$floatingMenuStyle = (0, $8CUq3.xcss)({
    padding: 'space.050',
    display: 'inline-block'
});
const $57e5cbe32044d51e$var$containerStyle = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: "var(--ds-space-negative-100, -8px)",
    right: "var(--ds-space-negative-100, -8px)",
    backgroundColor: 'elevation.surface',
    zIndex: '1',
    borderRadius: 'border.radius',
    border: `1px solid ${"var(--ds-surface, #FFFFFF)"}`
});

});
parcelRegister("9Xkny", function(module, exports) {

$parcel$export(module.exports, "default", () => $c061356216ed413d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c061356216ed413d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    commentActions: {
        "id": "issue-comment-base.comment.comment-floating-menu.comment-actions",
        "defaultMessage": "Comment actions"
    },
    createWorkItem: {
        "id": "issue-comment-base.comment.comment-floating-menu.create-work-item",
        "defaultMessage": "Create work item"
    },
    copy: {
        "id": "issue-comment-base.comment.comment-floating-menu.copy",
        "defaultMessage": "Copy link to comment"
    },
    edit: {
        "id": "issue-comment-base.comment.comment-floating-menu.edit",
        "defaultMessage": "Edit"
    },
    delete: {
        "id": "issue-comment-base.comment.comment-floating-menu.delete",
        "defaultMessage": "Delete"
    }
});

});


parcelRegister("3un1S", function(module, exports) {

$parcel$export(module.exports, "getFloatingMenuItems", () => $1dc69ac86654714b$export$62413090aa623ff3);
$parcel$export(module.exports, "getFloatingMenuItemsForOptimisticComment", () => $1dc69ac86654714b$export$5333f210f9325264);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $42CjB = parcelRequire("42CjB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4IrpZ = parcelRequire("4IrpZ");

var $k51tD = parcelRequire("k51tD");

var $5nRKm = parcelRequire("5nRKm");

var $7DhFg = parcelRequire("7DhFg");

var $8zOmE = parcelRequire("8zOmE");

var $2KAtx = parcelRequire("2KAtx");

var $6tI1D = parcelRequire("6tI1D");

var $dHOuF = parcelRequire("dHOuF");

var $9Xkny = parcelRequire("9Xkny");
const $1dc69ac86654714b$var$BaseIconButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: ref,
        appearance: "subtle",
        spacing: "compact",
        isTooltipDisabled: false,
        tooltip: {
            position: 'top'
        }
    }));
const $1dc69ac86654714b$export$62413090aa623ff3 = ({ formatMessage: formatMessage, fullIssueUrl: fullIssueUrl, commentId: commentId, shouldShowCreateButton: shouldShowCreateButton, canDelete: canDelete, canEdit: canEdit, onClickCreateIssue: onClickCreateIssue, onCopyClick: onCopyClick, onEditClick: onEditClick, onDeleteClick: onDeleteClick, deleteEntryPointProps: deleteEntryPointProps, createAnalyticsEvent: createAnalyticsEvent })=>{
    const deleteConfirmModalProps = {
        width: 'small',
        testId: 'issue-comment-base.ui.comment.confirmation-modal.modal-dialog'
    };
    const items = [];
    const onMouseEnterWithAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((buttonKey)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'hovered',
            actionSubject: 'button'
        }), buttonKey, {});
    }, 250);
    const onMouseLeaveWithAnalytics = ()=>{
        onMouseEnterWithAnalytics.cancel();
    };
    if (onClickCreateIssue && shouldShowCreateButton) items.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dc69ac86654714b$var$BaseIconButton, {
        key: "create-work-item",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($k51tD))),
        label: formatMessage((0, $9Xkny.default).createWorkItem),
        onClick: onClickCreateIssue,
        onMouseEnter: ()=>onMouseEnterWithAnalytics('createWorkItem'),
        onMouseLeave: onMouseLeaveWithAnalytics
    }));
    items.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1dc69ac86654714b$var$copyLinkStyle,
        key: "permalink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7DhFg.PermalinkButton), {
        label: formatMessage((0, $9Xkny.default).copy),
        onCopyClick: onCopyClick,
        isVisible: true,
        id: commentId,
        fullIssueUrl: `${fullIssueUrl}?${(0, $6tI1D.PermalinkType).COMMENTS}=${commentId}`,
        disableTransition: true,
        onMouseEnter: ()=>onMouseEnterWithAnalytics('copyLink'),
        onMouseLeave: onMouseLeaveWithAnalytics
    })));
    if (canEdit) items.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dc69ac86654714b$var$BaseIconButton, {
        key: "edit",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))),
        label: formatMessage((0, $9Xkny.default).edit),
        onClick: onEditClick,
        onMouseEnter: ()=>onMouseEnterWithAnalytics('editComment'),
        onMouseLeave: onMouseLeaveWithAnalytics
    }));
    if (canDelete) items.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $dHOuF.deleteIssueLinkConfirmationEntryPoint),
        entryPointProps: deleteEntryPointProps,
        useInternalModal: true,
        modalProps: deleteConfirmModalProps,
        key: "delete-entry-point"
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dc69ac86654714b$var$BaseIconButton, {
            key: "delete",
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))),
            label: formatMessage((0, $9Xkny.default).delete),
            onClick: onDeleteClick,
            onMouseEnter: ()=>onMouseEnterWithAnalytics('deleteComment'),
            onMouseLeave: onMouseLeaveWithAnalytics
        })));
    return items;
};
const $1dc69ac86654714b$var$copyLinkStyle = (0, $8CUq3.xcss)({
    paddingRight: 'space.050',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    borderRadius: 'border.radius'
});
const $1dc69ac86654714b$export$5333f210f9325264 = ({ hasSaveFailed: hasSaveFailed, onSaveEdit: onSaveEdit, formatMessage: formatMessage })=>{
    if (hasSaveFailed) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dc69ac86654714b$var$BaseIconButton, {
            key: "edit",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))),
            label: formatMessage((0, $9Xkny.default).edit),
            onClick: onSaveEdit
        })
    ];
    return [];
};

});
parcelRegister("k51tD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3fcac6ef8a976dfd90e31248626c32e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9e56b986ebd8af5$var$_react = $e9e56b986ebd8af5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e9e56b986ebd8af5$var$_baseNew = $e9e56b986ebd8af5$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e9e56b986ebd8af5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItemAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for adding or creating a new work item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e9e56b986ebd8af5$var$WorkItemAddIcon = (props)=>/*#__PURE__*/ $e9e56b986ebd8af5$var$_react.default.createElement($e9e56b986ebd8af5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m11.573 5.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5.5V14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4v4.5h-1.5z"/><path fill="currentcolor" d="M13.5 9.5V12H16v1.5h-2.5V16H12v-2.5H9.5V12H12V9.5z"/>`
    }, props));
$e9e56b986ebd8af5$var$WorkItemAddIcon.displayName = 'WorkItemAddIcon';
var $e9e56b986ebd8af5$var$_default = module.exports.default = $e9e56b986ebd8af5$var$WorkItemAddIcon;

});


parcelRegister("aIJnf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e92331826328656$export$2e2bcd8739ae039);
/* AkCommentComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $kB744 = parcelRequire("kB744");

var $5y0Rn = parcelRequire("5y0Rn");

var $3JBQJ = parcelRequire("3JBQJ");

var $d0UPJ = parcelRequire("d0UPJ");

var $28HrN = parcelRequire("28HrN");

var $52C90 = parcelRequire("52C90");
const $6e92331826328656$var$AkCommentComponent = ({ children: children })=>{
    const { isThreadedCommentsEnabled: isThreadedCommentsEnabled, commentId: commentId, shouldHighlightComment: shouldHighlightComment, errorActions: errorActions, actions: actions, isError: isError, isSaving: isSaving } = (0, $5y0Rn.useCommentContext)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $kB744.default), {
        avatar: /*#__PURE__*/ $5uXOq.createElement((0, $3JBQJ.default), null),
        author: /*#__PURE__*/ $5uXOq.createElement((0, $28HrN.default), null),
        content: /*#__PURE__*/ $5uXOq.createElement((0, $52C90.default), null),
        actions: actions,
        afterContent: /*#__PURE__*/ $5uXOq.createElement((0, $d0UPJ.default), null),
        errorActions: errorActions,
        isError: isError,
        highlighted: shouldHighlightComment,
        testId: `issue-comment-base.ui.comment.ak-comment.${commentId}`,
        isSaving: isSaving,
        savingText: ""
    }, isThreadedCommentsEnabled && children);
};
var $6e92331826328656$export$2e2bcd8739ae039 = $6e92331826328656$var$AkCommentComponent;

});
parcelRegister("5y0Rn", function(module, exports) {

$parcel$export(module.exports, "useCommentContext", () => $b96fc99e57bde10a$export$8bff54243693f1dd);
$parcel$export(module.exports, "default", () => $b96fc99e57bde10a$export$2e2bcd8739ae039);
/* CommentContextProvider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $li94A = parcelRequire("li94A");

var $g2C8o = parcelRequire("g2C8o");

var $jEjVx = parcelRequire("jEjVx");
const $b96fc99e57bde10a$var$CommentContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isThreadedCommentsEnabled: false,
    updatedDate: null,
    commentId: '',
    isOptimistic: false,
    jsdIncidentActivityViewHidden: null,
    eventOccurredAt: null,
    isInternal: false,
    isEditing: false,
    hasSaveFailed: false,
    hasChildren: false,
    createdDate: '',
    fullIssueUrl: '',
    onCopyClick: ()=>undefined,
    permalink: {
        isVisible: false,
        show: ()=>undefined,
        hide: ()=>undefined
    },
    showNewUnreadCommentLozenge: false,
    showLozenge: undefined,
    showAddedCommentDescription: undefined,
    hasDraft: false,
    edited: false,
    parentId: undefined,
    isSaving: false,
    isError: false,
    savingText: 'Saving...',
    isIssueOfIncidentsPractice: false,
    isHighlighted: false,
    hasScrolledPermalink: false,
    shouldScrollAfterAsyncComponentsLoaded: false,
    shouldShowCommentVisibility: false,
    canEdit: false,
    canDelete: false,
    bodyAdf: (0, $li94A.createSampleAdf)(''),
    bodyHtml: '',
    createAnalyticsEvent: undefined,
    showReactions: false,
    visibility: (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC),
    visibilityEdited: {
        type: 'role',
        value: '',
        groupId: undefined
    },
    isEditingInternal: false,
    setScrollStatus: ()=>undefined,
    getOnEditSave: ()=>undefined,
    getOnEditClick: ()=>undefined,
    onSaveRetry: ()=>undefined,
    onSaveEdit: ()=>undefined,
    onSaveCancel: ()=>undefined,
    onEditCancel: ()=>undefined,
    onEditUpdate: ()=>undefined,
    onEditPaste: ()=>undefined,
    onBlur: ()=>undefined,
    onCommentVisibilityChange: ()=>undefined,
    topMostUnreadCommentId: null,
    authorDisplayName: '',
    authorAdditionalInfo: undefined,
    isUnreadComment: false,
    displayNameForUpdateAuthor: '',
    restrictedToText: '',
    shouldHighlightComment: false,
    selectedEventOccurredAt: null,
    setSelectedEventOccuredAt: ()=>undefined,
    setShowNewUnreadCommentLozenge: ()=>undefined,
    setOptimisticCommentContainer: ()=>undefined,
    setCommentPermalinkContainer: ()=>undefined,
    commentPermalinkContainer: undefined,
    unreadCommentElement: undefined,
    isPinned: false,
    onPinClick: ()=>undefined,
    onUnpinClick: ()=>undefined,
    canPin: false,
    isPinnedCommentsLimitReached: false,
    pinnedCommentBodyAdf: (0, $li94A.createSampleAdf)(''),
    isThirdPartySyncOn: undefined,
    thirdPartyLink: undefined,
    canScrollToOriginalCommentFromPinned: false
});
const $b96fc99e57bde10a$export$8bff54243693f1dd = ()=>{
    const context = (0, $5uXOq.useContext)($b96fc99e57bde10a$var$CommentContext);
    if (!context) throw new Error('useCommentContext must be used within a CommentContextProvider');
    return context;
};
const $b96fc99e57bde10a$var$CommentContextProvider = ({ children: children, ...restProps })=>{
    const { hasSaveFailed: hasSaveFailed, isEditing: isEditing, isOptimistic: isOptimistic, isDeleted: isDeleted, actions: actions, isInternal: isInternal, isHighlighted: isHighlighted, shouldHighlightComment: shouldHighlightComment } = restProps;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const value = (0, $5uXOq.useMemo)(()=>({
            ...restProps,
            isError: hasSaveFailed && !isEditing,
            isSaving: isOptimistic && !hasSaveFailed,
            savingText: formatMessage((0, $jEjVx.default).saving),
            actions: !isDeleted && !isOptimistic && !isEditing ? actions : [],
            shouldHighlightComment: shouldHighlightComment || !isInternal && !isEditing && isHighlighted
        }), [
        actions,
        formatMessage,
        hasSaveFailed,
        isDeleted,
        isEditing,
        isHighlighted,
        isInternal,
        isOptimistic,
        restProps,
        shouldHighlightComment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b96fc99e57bde10a$var$CommentContext.Provider, {
        value: value
    }, children);
};
var $b96fc99e57bde10a$export$2e2bcd8739ae039 = $b96fc99e57bde10a$var$CommentContextProvider;

});
parcelRegister("li94A", function(module, exports) {

$parcel$export(module.exports, "createSampleAdf", () => $71e5bac5e73a9653$export$618c1301b1e6a2cb);
const $71e5bac5e73a9653$export$618c1301b1e6a2cb = (content)=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: content ? [
                    {
                        type: 'text',
                        text: `${content}`
                    }
                ] : []
            }
        ]
    });
const $71e5bac5e73a9653$export$d8937471b3093b36 = (id)=>({
        type: 'mediaSingle',
        attrs: {
            layout: 'center'
        },
        content: {
            type: 'media',
            attrs: {
                id: id,
                type: 'file',
                collection: 'jira-16161-comment-12278',
                width: 873,
                height: 233
            }
        }
    });
const $71e5bac5e73a9653$export$37d245bfdded08af = (id)=>({
        type: 'mention',
        attrs: {
            id: id,
            text: 'No name'
        }
    });
const $71e5bac5e73a9653$export$47709e1fd283e31 = (url)=>({
        type: 'inlineCard',
        attrs: {
            url: url
        }
    });
const $71e5bac5e73a9653$export$6f14b4784cacd34b = {
    content: [
        {
            type: 'mediaGroup',
            content: [
                {
                    type: 'media',
                    attrs: {
                        height: 564,
                        id: '657b1eb4-f37e-4f12-87c8-cb744eefa182',
                        type: 'file',
                        collection: '',
                        occurrenceKey: 'e60db371-2c26-4e2f-8294-77497bde6fe3',
                        width: 860
                    }
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};
const $71e5bac5e73a9653$export$4413560fefca59a4 = {
    content: [
        ...$71e5bac5e73a9653$export$6f14b4784cacd34b.content,
        {
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: 'hello'
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};
const $71e5bac5e73a9653$export$a8903d0873f9baa = '{"version":1,"type":"doc","content":[{"type":"mediaGroup","content":[{"type":"media","attrs":{"id":"657b1eb4-f37e-4f12-87c8-cb744eefa182","type":"file","collection":"jira-10180-comment-10242","occurrenceKey":"e60db371-2c26-4e2f-8294-77497bde6fe3","width":860,"height":564}}]}]}';

});


parcelRegister("3JBQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2624eeab70766a13$export$2e2bcd8739ae039);
/* AkCommentAvatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $h5GPI = parcelRequire("h5GPI");

var $5y0Rn = parcelRequire("5y0Rn");

var $7nQQ8 = parcelRequire("7nQQ8");
const $2624eeab70766a13$var$AkCommentAvatar = ()=>{
    const { isThreadedCommentsEnabled: isThreadedCommentsEnabled, isDeleted: isDeleted, author: author, commentId: commentId, showSmallAvatar: showSmallAvatar, parentId: parentId } = (0, $5y0Rn.useCommentContext)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $7nQQ8.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $h5GPI.default), {
        userAccount: isDeleted ? undefined : author,
        analyticsData: {
            trigger: 'comment-avatar'
        },
        testId: `issue-comment-base.ui.comment.${commentId}.avatar`,
        ariaHideProfileTrigger: true,
        isChildComment: isThreadedCommentsEnabled && !!parentId
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        borderColor: "transparent",
        src: !isDeleted && author && author.avatarUrl || undefined,
        size: showSmallAvatar ? 'small' : 'medium'
    })));
};
var $2624eeab70766a13$export$2e2bcd8739ae039 = $2624eeab70766a13$var$AkCommentAvatar;

});
parcelRegister("7nQQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $11070dab3acc29de$export$2e2bcd8739ae039);
/* AkCommentAvatarWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $5y0Rn = parcelRequire("5y0Rn");
// TODO https://product-fabric.atlassian.net/browse/FS-4202
// Ideally we would style the Reactions component itself, but currently
// AK doesn't allow us to do it. So we're wrapping the component on this div
// and pulling it to the left as much as we can without covering the item separator (".")
// we're also giving it a specific height so the item separator will be properly aligned.
const $11070dab3acc29de$var$AkCommentAvatarWrapper = ({ children: children })=>{
    const { isThreadedCommentsEnabled: isThreadedCommentsEnabled, hasReplies: hasReplies, isReplyingToComment: isReplyingToComment, isDeleted: isDeleted } = (0, $5y0Rn.useCommentContext)();
    const showLinesOnRoot = (hasReplies || isReplyingToComment) ?? false;
    const isDeletedComment = isDeleted || false;
    if (isThreadedCommentsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_ca0q12x7",
            "_kqswh2mm _1hjgt94y _161e1v33 _4t3i1osq",
            showLinesOnRoot && "_1kt9b3bt _1cs8stnw _z5wtgm6u _19woze3t _1mp4qk1p _1aukdrbf _1rus1qe4",
            showLinesOnRoot && "_1auklpf4",
            isDeletedComment && "_otyrutpp"
        ])
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_ca0q12x7"
        ])
    }, children);
};
var $11070dab3acc29de$export$2e2bcd8739ae039 = $11070dab3acc29de$var$AkCommentAvatarWrapper;
const $11070dab3acc29de$var$profileCardRootStyles = null;
const $11070dab3acc29de$var$profileCardWrapperStyles = null;
const $11070dab3acc29de$var$rootCommentStyles = null;
const $11070dab3acc29de$var$rootCommentStylesOverride = null;
const $11070dab3acc29de$var$deletedCommentStyles = null;

});


parcelRegister("d0UPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1cd6680bfc30dc$export$2e2bcd8739ae039);
/* AkCommentAfterContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $jOvmQ = parcelRequire("jOvmQ");

var $5y0Rn = parcelRequire("5y0Rn");
const $8b1cd6680bfc30dc$var$AkCommentAfterContent = ()=>{
    const { isThreadedCommentsEnabled: isThreadedCommentsEnabled, isReplyingToComment: isReplyingToComment, hasReplies: hasReplies, shouldHighlightComment: shouldHighlightComment, hasChildren: hasChildren } = (0, $5y0Rn.useCommentContext)();
    if (!isThreadedCommentsEnabled) return null;
    if (hasReplies) return null;
    if (isReplyingToComment) return null;
    if (!hasChildren) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $jOvmQ.default), {
        isHighlighted: shouldHighlightComment
    });
};
var $8b1cd6680bfc30dc$export$2e2bcd8739ae039 = $8b1cd6680bfc30dc$var$AkCommentAfterContent;

});

parcelRegister("28HrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f259325a8fdfbfa$export$2e2bcd8739ae039);
/* AKCommentCustomHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $g2C8o = parcelRequire("g2C8o");

var $3FbSH = parcelRequire("3FbSH");

var $dv9Yh = parcelRequire("dv9Yh");

var $7iyJO = parcelRequire("7iyJO");

var $iaY9h = parcelRequire("iaY9h");

var $b3r1R = parcelRequire("b3r1R");

var $jSPU2 = parcelRequire("jSPU2");

var $jilzA = parcelRequire("jilzA");

var $lC4En = parcelRequire("lC4En");

var $1lCUZ = parcelRequire("1lCUZ");

var $7XRyn = parcelRequire("7XRyn");

var $e4qkJ = parcelRequire("e4qkJ");

var $5y0Rn = parcelRequire("5y0Rn");

var $kLGvV = parcelRequire("kLGvV");

var $fkShn = parcelRequire("fkShn");
const $9f259325a8fdfbfa$var$AKCommentCustomHeader = ()=>{
    const { hasFloatingMenu: hasFloatingMenu, floatingMenu: floatingMenu, showLozenge: showLozenge, isDeleted: isDeleted, parentId: parentId, projectType: projectType, isThirdPartySyncOn: isThirdPartySyncOn, thirdPartyLink: thirdPartyLink, thirdPartyCommentSource: thirdPartyCommentSource } = (0, $5y0Rn.useCommentContext)();
    const getTooltip = (0, $5uXOq.useCallback)(()=>{
        // TODO: add comment slack-sync status prop check at beginning of condition
        if (!(0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') || projectType !== (0, $2vSU6.SOFTWARE_PROJECT) && projectType !== (0, $2vSU6.CORE_PROJECT) || !isThirdPartySyncOn || parentId || thirdPartyCommentSource !== (0, $g2C8o.THIRD_PARTY_SOURCE_SLACK)) return null;
        return /*#__PURE__*/ $5uXOq.createElement((0, $kLGvV.SlackTooltip), {
            href: thirdPartyLink
        });
    }, [
        projectType,
        isThirdPartySyncOn,
        parentId,
        thirdPartyCommentSource,
        thirdPartyLink
    ]);
    if (isDeleted) return /*#__PURE__*/ $5uXOq.createElement((0, $7XRyn.default), null);
    return /*#__PURE__*/ $5uXOq.createElement((0, $luBm6.default), {
        grow: "fill",
        space: "space.050",
        xcss: $9f259325a8fdfbfa$var$customHeaderStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $luBm6.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: [
            $9f259325a8fdfbfa$var$truncatedStyles,
            (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') && $9f259325a8fdfbfa$var$withSlackIcons
        ]
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c8140y"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3FbSH.default), null)), getTooltip()), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $9f259325a8fdfbfa$var$nonTruncatedStyles
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c8140y"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $b3r1R.default), null), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $jilzA.default), null), /*#__PURE__*/ $5uXOq.createElement((0, $jSPU2.default), null), /*#__PURE__*/ $5uXOq.createElement((0, $dv9Yh.default), null), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        paddingInlineStart: "space.050",
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $lC4En.default), null)), hasFloatingMenu && floatingMenu))))), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "start"
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c81o8v"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $7iyJO.default), null)), /*#__PURE__*/ $5uXOq.createElement((0, $fkShn.default), null), /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c81o8v"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $1lCUZ.default), null))), /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "start"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $e4qkJ.default), null))), showLozenge && /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        paddingBlock: "space.075"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $iaY9h.default), null))));
};
var $9f259325a8fdfbfa$export$2e2bcd8739ae039 = $9f259325a8fdfbfa$var$AKCommentCustomHeader;
const $9f259325a8fdfbfa$var$customHeaderStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    paddingBlockEnd: 'space.025'
});
const $9f259325a8fdfbfa$var$primaryRowStyles = null;
const $9f259325a8fdfbfa$var$secondaryRowStyles = null;
const $9f259325a8fdfbfa$var$truncatedStyles = (0, $8CUq3.xcss)({
    minWidth: '0px'
});
const $9f259325a8fdfbfa$var$nonTruncatedStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});
const $9f259325a8fdfbfa$var$withSlackIcons = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("3FbSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $07d86c629fbc3da1$export$2e2bcd8739ae039);
/* AkCommentAuthorWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $9DgQp = parcelRequire("9DgQp");

var $dS3PR = parcelRequire("dS3PR");

var $h5GPI = parcelRequire("h5GPI");

var $6s1PB = parcelRequire("6s1PB");

var $5y0Rn = parcelRequire("5y0Rn");
const $07d86c629fbc3da1$var$Separator = ()=>{
    if (!(0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "\xa0");
    return null;
};
const $07d86c629fbc3da1$var$AkCommentAuthorWrapper = ()=>{
    const { isDeleted: isDeleted, authorDisplayName: authorDisplayName, authorAdditionalInfo: authorAdditionalInfo, author: author } = (0, $5y0Rn.useCommentContext)();
    if (isDeleted) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5GPI.default), {
        userAccount: author,
        analyticsData: {
            trigger: 'comment-author'
        },
        shouldTruncate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DgQp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        weight: "bold"
    }, authorDisplayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($07d86c629fbc3da1$var$Separator, null), authorAdditionalInfo));
};
var $07d86c629fbc3da1$export$2e2bcd8739ae039 = $07d86c629fbc3da1$var$AkCommentAuthorWrapper;

});

parcelRegister("dv9Yh", function(module, exports) {

$parcel$export(module.exports, "default", () => $62bc49485fb4ba26$export$2e2bcd8739ae039);
/* CommentUnreadIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $cSD7y = parcelRequire("cSD7y");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");

var $3kevq = parcelRequire("3kevq");
const $62bc49485fb4ba26$var$CustomCommentUnreadIndicator = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isDeleted: isDeleted, commentId: commentId, showNewUnreadCommentLozenge: showNewUnreadCommentLozenge, setUnreadCommentScrollRef: setUnreadCommentScrollRef, projectType: projectType } = (0, $5y0Rn.useCommentContext)();
    const isUnreadComment = (0, $3kevq.useUnreadComment)();
    const isEligibleProjectType = projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT);
    if (!isDeleted && isEligibleProjectType && isUnreadComment && (0, $6s1PB.expVal)('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        ref: setUnreadCommentScrollRef,
        testId: `issue-comment-base.ui.comment.unread.${commentId}`,
        xcss: [
            $62bc49485fb4ba26$var$unreadCss,
            showNewUnreadCommentLozenge && $62bc49485fb4ba26$var$unreadNewBadgeCss
        ]
    }, showNewUnreadCommentLozenge && formatMessage((0, $jEjVx.default).new));
    return null;
};
const $62bc49485fb4ba26$var$AkCommentUnreadIndicator = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isDeleted: isDeleted, commentId: commentId, isUnreadComment: isUnreadComment, showNewUnreadCommentLozenge: showNewUnreadCommentLozenge, setUnreadCommentScrollRef: setUnreadCommentScrollRef, projectType: projectType } = (0, $5y0Rn.useCommentContext)();
    const isEligibleProjectType = projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT);
    if (!isDeleted && isEligibleProjectType && isUnreadComment && (0, $6s1PB.expVal)('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        ref: setUnreadCommentScrollRef,
        testId: `issue-comment-base.ui.comment.unread.${commentId}`,
        xcss: [
            $62bc49485fb4ba26$var$unreadCss,
            showNewUnreadCommentLozenge && $62bc49485fb4ba26$var$unreadNewBadgeCss
        ]
    }, showNewUnreadCommentLozenge && formatMessage((0, $jEjVx.default).new));
};
const $62bc49485fb4ba26$var$CommentUnreadIndicator = (0, $cSD7y.componentWithFG)('jira_custom_comment_component_refactor', $62bc49485fb4ba26$var$CustomCommentUnreadIndicator, $62bc49485fb4ba26$var$AkCommentUnreadIndicator);
var $62bc49485fb4ba26$export$2e2bcd8739ae039 = $62bc49485fb4ba26$var$CommentUnreadIndicator;
const $62bc49485fb4ba26$var$unreadCss = (0, $8CUq3.xcss)({
    height: "var(--ds-space-075, 6px)",
    width: "var(--ds-space-075, 6px)",
    borderRadius: 'border.radius.circle',
    backgroundColor: 'color.background.accent.blue.bolder',
    transition: 'all 0.2s ease-in-out'
});
const $62bc49485fb4ba26$var$unreadNewBadgeCss = (0, $8CUq3.xcss)({
    textAlign: 'center',
    font: 'font.body.small',
    color: 'color.text.inverse',
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-200, 16px)",
    borderRadius: 'border.radius.200'
});

});
parcelRegister("3kevq", function(module, exports) {

$parcel$export(module.exports, "useAuthorAdditionalInfo", () => $ef644817a7099d65$export$6f2fd9214503c31e);
$parcel$export(module.exports, "useUnreadComment", () => $ef644817a7099d65$export$c5f9435d0e22f91);
$parcel$export(module.exports, "useRestrictedToText", () => $ef644817a7099d65$export$5a2ba0f1a2d6ca8f);
$parcel$export(module.exports, "useUnreadCommentLozengeState", () => $ef644817a7099d65$export$58b0eb6e325534ee);
$parcel$export(module.exports, "useSmoothScrollIntoView", () => $ef644817a7099d65$export$cb40d30e5f5c366a);
$parcel$export(module.exports, "useScrollCommentIntoView", () => $ef644817a7099d65$export$a3c40175898fe9f9);
$parcel$export(module.exports, "useFireHiglightedCommentAnalytics", () => $ef644817a7099d65$export$2e43d71e0e17babf);
$parcel$export(module.exports, "useEditSave", () => $ef644817a7099d65$export$10d73e041bd4ba52);
$parcel$export(module.exports, "useHideSave", () => $ef644817a7099d65$export$5dd6acbf87bf9e35);
$parcel$export(module.exports, "useCommentInteraction", () => $ef644817a7099d65$export$b8101e20d4fbdd58);
$parcel$export(module.exports, "useReply", () => $ef644817a7099d65$export$897fac1ce6c72c7d);
$parcel$export(module.exports, "useDelete", () => $ef644817a7099d65$export$60acb8fd13afd60d);
$parcel$export(module.exports, "useEdit", () => $ef644817a7099d65$export$4940312fb76ff4c1);
$parcel$export(module.exports, "useAuthor", () => $ef644817a7099d65$export$ed7ae60d899fb4f);
$parcel$export(module.exports, "useIssueCreate", () => $ef644817a7099d65$export$a506f75d1ed3e618);
$parcel$export(module.exports, "useReplyToComment", () => $ef644817a7099d65$export$4a2d52fbf1785c72);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $bPWvi = parcelRequire("bPWvi");
var $d4vM2 = parcelRequire("d4vM2");
var $kF5bw = parcelRequire("kF5bw");
var $50sdg = parcelRequire("50sdg");
var $7ipfu = parcelRequire("7ipfu");
var $gBTcG = parcelRequire("gBTcG");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $g2C8o = parcelRequire("g2C8o");


var $b8JO7 = parcelRequire("b8JO7");

var $8zOmE = parcelRequire("8zOmE");

var $fCo6Y = parcelRequire("fCo6Y");

var $7p8Xy = parcelRequire("7p8Xy");

var $lssfC = parcelRequire("lssfC");

var $ieDtd = parcelRequire("ieDtd");


var $j57jo = parcelRequire("j57jo");

var $jEjVx = parcelRequire("jEjVx");

var $bEaSU = parcelRequire("bEaSU");

var $5y0Rn = parcelRequire("5y0Rn");
const $ef644817a7099d65$export$6f2fd9214503c31e = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { jsdAuthorCanSeeRequest: jsdAuthorCanSeeRequest } = (0, $5y0Rn.useCommentContext)();
    const isRequestParticipant = jsdAuthorCanSeeRequest === false;
    if ((0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return isRequestParticipant ? ` ${formatMessage((0, $jEjVx.default).notRequestParticipant)}` : '';
    return isRequestParticipant ? formatMessage((0, $jEjVx.default).notRequestParticipant) : '';
};
const $ef644817a7099d65$export$6b17aa8176081ded = ()=>{
    const { author: author } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (author?.displayName) return author.displayName;
    return formatMessage((0, $jEjVx.default).anonymous);
};
const $ef644817a7099d65$export$3b3248d550d2fbd7 = ()=>{
    const { updateAuthor: updateAuthor } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (updateAuthor?.displayName) return updateAuthor.displayName;
    return formatMessage((0, $jEjVx.default).anonymous);
};
const $ef644817a7099d65$export$c5f9435d0e22f91 = ()=>{
    const { author: author, projectType: projectType, createdDate: createdDate, latestCommentViewInteractedTime: latestCommentViewInteractedTime, currentUserAaid: currentUserAaid } = (0, $5y0Rn.useCommentContext)();
    if ((projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && (0, $4R6GH.fg)('thor_issue_view_realtime_updates_gate')) return author?.id !== currentUserAaid && latestCommentViewInteractedTime && new Date(latestCommentViewInteractedTime).getTime() < new Date(createdDate).getTime() || false;
    return false;
};
const $ef644817a7099d65$export$5a2ba0f1a2d6ca8f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { visibility: visibility, isInternal: isInternal } = (0, $5y0Rn.useCommentContext)();
    if (isInternal) {
        const restrictedToText = visibility.type === (0, $g2C8o.COMMENT_VISIBILITY_TYPE_PUBLIC) ? `${formatMessage((0, $jEjVx.default).internalNote)}` : `${visibility.value} \u{2022} ${formatMessage((0, $jEjVx.default).internalNote)}`;
        return restrictedToText;
    }
    return visibility?.value || '';
};
const $ef644817a7099d65$export$58b0eb6e325534ee = ()=>{
    const { projectType: projectType, commentId: commentId, isActivityFeedInViewPort: isActivityFeedInViewPort, showNewUnreadCommentLozenge: showNewUnreadCommentLozenge, setShowNewUnreadCommentLozenge: setShowNewUnreadCommentLozenge, topMostUnreadCommentId: topMostUnreadCommentId } = (0, $5y0Rn.useCommentContext)();
    const isUnreadComment = $ef644817a7099d65$export$c5f9435d0e22f91();
    (0, $5uXOq.useEffect)(()=>{
        let unreadCommentLozengeTimeout;
        if ((projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && isActivityFeedInViewPort && showNewUnreadCommentLozenge && isUnreadComment && (0, $6s1PB.expVal)('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)) {
            (0, $bEaSU.localStorageProvider).set((0, $bEaSU.UNREAD_COMMENT_LOZENGE_VIEWED_KEY), true);
            unreadCommentLozengeTimeout = setTimeout(()=>{
                setShowNewUnreadCommentLozenge?.(false);
            }, 5000);
        }
        if ((projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && commentId !== topMostUnreadCommentId && showNewUnreadCommentLozenge && isUnreadComment && (0, $6s1PB.expVal)('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)) setShowNewUnreadCommentLozenge?.(false);
        return ()=>{
            if (unreadCommentLozengeTimeout) {
                clearTimeout(unreadCommentLozengeTimeout);
                unreadCommentLozengeTimeout = undefined;
            }
        };
    }, [
        commentId,
        isActivityFeedInViewPort,
        isUnreadComment,
        projectType,
        setShowNewUnreadCommentLozenge,
        showNewUnreadCommentLozenge,
        topMostUnreadCommentId
    ]);
};
const $ef644817a7099d65$export$cb40d30e5f5c366a = ()=>{
    const { commentId: commentId, optimisticCommentContainer: optimisticCommentContainer, isOptimistic: isOptimistic } = (0, $5y0Rn.useCommentContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (isOptimistic && commentId.includes((0, $7a0695d910e98a34$export$c4134c813c47beb0)) && optimisticCommentContainer) (0, $b8JO7.smoothScrollIntoViewIfNeeded)(optimisticCommentContainer, {
            scrollMode: 'always',
            behavior: 'smooth'
        });
    }, [
        commentId,
        isOptimistic,
        optimisticCommentContainer
    ]);
};
const $ef644817a7099d65$export$a3c40175898fe9f9 = ()=>{
    const { commentId: commentId, commentPermalinkContainer: commentPermalinkContainer, hasScrolledPermalink: hasScrolledPermalink, setScrollStatus: setScrollStatus, setScrollStatusForRealTimeUpdate: setScrollStatusForRealTimeUpdate, commentScrollStatusForRealTimeUpdates: commentScrollStatusForRealTimeUpdates, topMostUnreadCommentId: topMostUnreadCommentId, unreadCommentElement: unreadCommentElement, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType, shouldScrollAfterAsyncComponentsLoaded: shouldScrollAfterAsyncComponentsLoaded } = (0, $5y0Rn.useCommentContext)();
    const isUnreadComment = $ef644817a7099d65$export$c5f9435d0e22f91();
    (0, $5uXOq.useEffect)(()=>{
        // hasScrolledPermalink ensures we only scroll once on initial page load.
        // ensure we don't scroll if we resize after initial load.
        // shouldScrollAfterAsyncComponentsLoaded used to ensure we only scroll when all async data is finished fetching.
        if (!hasScrolledPermalink && shouldScrollAfterAsyncComponentsLoaded && commentPermalinkContainer) {
            (0, $b8JO7.smoothScrollIntoViewIfNeeded)(commentPermalinkContainer, {
                scrollMode: 'always',
                behavior: 'smooth'
            });
            setScrollStatus(true);
            const analyticsEvent = createAnalyticsEvent({
                action: 'scrolled'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'permalink comment', {
                name: 'comment'
            });
        }
        // scroll to unread comment during real time updates
        if ((projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && commentScrollStatusForRealTimeUpdates && commentId === topMostUnreadCommentId && isUnreadComment && (0, $6s1PB.expVal)('thor_issue_view_realtime_updates_experiment', 'isEnabled', false)) {
            (0, $b8JO7.smoothScrollIntoViewIfNeeded)(unreadCommentElement, {
                scrollMode: 'always',
                behavior: 'smooth'
            });
            setScrollStatusForRealTimeUpdate?.(false);
        }
    }, [
        commentId,
        commentPermalinkContainer,
        commentScrollStatusForRealTimeUpdates,
        createAnalyticsEvent,
        hasScrolledPermalink,
        isUnreadComment,
        projectType,
        setScrollStatus,
        setScrollStatusForRealTimeUpdate,
        shouldScrollAfterAsyncComponentsLoaded,
        topMostUnreadCommentId,
        unreadCommentElement
    ]);
};
const $ef644817a7099d65$export$2e43d71e0e17babf = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent, isHighlighted: isHighlighted, parentId: parentId } = (0, $5y0Rn.useCommentContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (isHighlighted) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'focussed comment', {
                isParent: parentId
            });
        }
    }, [
        createAnalyticsEvent,
        isHighlighted,
        parentId
    ]);
};
const $ef644817a7099d65$export$10d73e041bd4ba52 = ()=>{
    const { author: author, commentId: commentId, createdDate: createdDate, bodyHtml: bodyHtml, shouldShowCommentVisibility: shouldShowCommentVisibility, visibility: visibility, visibilityEdited: visibilityEdited, getOnEditSave: getOnEditSave, createAnalyticsEvent: createAnalyticsEvent, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden, fullIssueUrl: fullIssueUrl, isIssueOfIncidentsPractice: isIssueOfIncidentsPractice, isEditingInternal: isEditingInternal, projectType: projectType, parentId: parentId, commentSessionId: commentSessionId, isRealTimeCommentUpdated: isRealTimeCommentUpdated, selectedEventOccurredAt: selectedEventOccurredAt } = (0, $5y0Rn.useCommentContext)();
    const onEditSave = (0, $5uXOq.useCallback)((value)=>{
        const isValueEmpty = (0, $fCo6Y.isOnlyWhitespaceAdf)(value);
        if (!isValueEmpty) {
            const authorId = author ? author.id : null;
            const analyticsEvent = createAnalyticsEvent({
                action: 'updated'
            });
            selectedEventOccurredAt ? analyticsEvent.update({
                commentEditWithEventOccurredAt: true
            }) : analyticsEvent.update({
                commentEditWithEventOccurredAt: false
            });
            if (shouldShowCommentVisibility) analyticsEvent.update({
                isVisibilityUpdated: !(0, $j57jo.areCommentVisibilitiesEqual)(visibility, visibilityEdited)
            });
            if ((0, $4R6GH.fg)('thor_send_realtime_attribute')) analyticsEvent.update({
                isRealTimeCommentUpdated: isRealTimeCommentUpdated
            });
            getOnEditSave({
                authorId: authorId,
                createdDate: createdDate,
                bodyAdf: value,
                bodyHtml: bodyHtml,
                isNewComment: commentId.includes((0, $7a0695d910e98a34$export$c4134c813c47beb0)),
                visibility: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && !isEditingInternal ? (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC) : visibilityEdited,
                ...isIssueOfIncidentsPractice && isEditingInternal ? {
                    eventOccurredAt: selectedEventOccurredAt,
                    jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden,
                    fullIssueUrl: fullIssueUrl,
                    triggerIncidentSaveCommentFlag: isIssueOfIncidentsPractice
                } : {},
                parentId: parentId
            }, analyticsEvent, commentSessionId);
        }
    }, [
        author,
        bodyHtml,
        commentId,
        commentSessionId,
        createAnalyticsEvent,
        createdDate,
        fullIssueUrl,
        getOnEditSave,
        isEditingInternal,
        isIssueOfIncidentsPractice,
        isRealTimeCommentUpdated,
        jsdIncidentActivityViewHidden,
        parentId,
        projectType,
        selectedEventOccurredAt,
        shouldShowCommentVisibility,
        visibility,
        visibilityEdited
    ]);
    return onEditSave;
};
const $ef644817a7099d65$export$5dd6acbf87bf9e35 = ()=>{
    const { author: author, commentId: commentId, createdDate: createdDate, bodyHtml: bodyHtml, bodyAdf: bodyAdf, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden, visibilityEdited: visibilityEdited, projectType: projectType, isEditingInternal: isEditingInternal, getOnEditSave: getOnEditSave, createAnalyticsEvent: createAnalyticsEvent, eventOccurredAt: eventOccurredAt, commentSessionId: commentSessionId } = (0, $5y0Rn.useCommentContext)();
    const onHideSave = (0, $5uXOq.useCallback)(()=>{
        const authorId = author ? author.id : null;
        const analyticsEvent = createAnalyticsEvent({
            action: 'updated'
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), jsdIncidentActivityViewHidden ? 'unhide clicked' : 'hide clicked');
        getOnEditSave({
            authorId: authorId,
            createdDate: createdDate,
            bodyAdf: bodyAdf,
            bodyHtml: bodyHtml,
            isNewComment: commentId.includes((0, $7a0695d910e98a34$export$c4134c813c47beb0)),
            visibility: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && !isEditingInternal ? (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC) : visibilityEdited,
            eventOccurredAt: eventOccurredAt,
            jsdIncidentActivityViewHidden: !jsdIncidentActivityViewHidden
        }, analyticsEvent, commentSessionId);
    }, [
        author,
        bodyAdf,
        bodyHtml,
        commentId,
        commentSessionId,
        createAnalyticsEvent,
        createdDate,
        eventOccurredAt,
        getOnEditSave,
        isEditingInternal,
        jsdIncidentActivityViewHidden,
        projectType,
        visibilityEdited
    ]);
    return onHideSave;
};
const $ef644817a7099d65$export$b8101e20d4fbdd58 = ()=>{
    const { projectType: projectType, onCommentInteractionUpdateCommentViewInteractionTimeMarker: onCommentInteractionUpdateCommentViewInteractionTimeMarker } = (0, $5y0Rn.useCommentContext)();
    const isUnreadComment = $ef644817a7099d65$export$c5f9435d0e22f91();
    const onCommentInteraction = (0, $5uXOq.useCallback)(()=>{
        if ((projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && (0, $4R6GH.fg)('thor_issue_view_realtime_updates_gate')) isUnreadComment && onCommentInteractionUpdateCommentViewInteractionTimeMarker && onCommentInteractionUpdateCommentViewInteractionTimeMarker();
    }, [
        isUnreadComment,
        onCommentInteractionUpdateCommentViewInteractionTimeMarker,
        projectType
    ]);
    return onCommentInteraction;
};
const $ef644817a7099d65$export$897fac1ce6c72c7d = ()=>{
    const { onReplyClick: onReplyClick, parentId: parentId, commentId: commentId, author: author, shouldShowCommentVisibility: shouldShowCommentVisibility, visibility: visibility, createAnalyticsEvent: createAnalyticsEvent, hasReplies: hasReplies, showCommentSlackFlag: showCommentSlackFlag, onShowFlagForSlackSync: onShowFlagForSlackSync } = (0, $5y0Rn.useCommentContext)();
    const authorDisplayName = $ef644817a7099d65$export$6b17aa8176081ded();
    const onCommentInteraction = $ef644817a7099d65$export$b8101e20d4fbdd58();
    const onReplyWithExtraCommentContent = (extraCommentContent)=>{
        if (!onReplyClick) return;
        if (showCommentSlackFlag && onShowFlagForSlackSync) onShowFlagForSlackSync();
        const replyingToCommentId = parentId || commentId;
        const authorId = author ? author.id : null;
        const replyVisibility = shouldShowCommentVisibility ? visibility : undefined;
        const commentSessionId = (0, $7Jxgt.v4)();
        onCommentInteraction();
        onReplyClick(replyingToCommentId, authorId, authorDisplayName, replyVisibility, commentSessionId, extraCommentContent && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasWorkItemCreate', false) ? extraCommentContent : undefined);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'replyButton', {
            isRootComment: !!parentId,
            hasReplies: hasReplies,
            commentSessionId: commentSessionId,
            // This attribute is used to track if the reply button is auto open with a template filled in
            ...extraCommentContent && {
                isTriggeredByCommentTemplate: true
            }
        });
    };
    return onReplyWithExtraCommentContent;
};
const $ef644817a7099d65$export$60acb8fd13afd60d = ()=>{
    const { parentId: parentId, createAnalyticsEvent: createAnalyticsEvent, hasReplies: hasReplies } = (0, $5y0Rn.useCommentContext)();
    const onDeleteClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'deleteCommentButton', {
            isRootComment: !!parentId,
            hasReplies: hasReplies
        });
    };
    return onDeleteClick;
};
const $ef644817a7099d65$export$4940312fb76ff4c1 = ()=>{
    const { getOnEditClick: getOnEditClick, isInternal: isInternal, hasDraft: hasDraft, createAnalyticsEvent: createAnalyticsEvent } = (0, $5y0Rn.useCommentContext)();
    const onCommentInteraction = $ef644817a7099d65$export$b8101e20d4fbdd58();
    const onEditClick = (0, $5uXOq.useCallback)((_, analyticsEvent, isSiteAdmin)=>{
        const commentSessionId = (0, $7Jxgt.v4)();
        getOnEditClick(isInternal, commentSessionId);
        onCommentInteraction();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'editCommentEditor expanded', {
            hasDraft: hasDraft
        });
        const jsmLoomExperiment = (0, $7p8Xy.isJsmLoomExperimentEnabled)();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'commentEdit',
            action: 'started'
        }), {
            hasDraft: hasDraft,
            commentSessionId: commentSessionId,
            ...jsmLoomExperiment?.enabled && {
                isSiteAdmin: isSiteAdmin,
                loomJsmAgentExperimentCohort: jsmLoomExperiment?.cohort
            }
        });
    }, [
        createAnalyticsEvent,
        getOnEditClick,
        hasDraft,
        isInternal,
        onCommentInteraction
    ]);
    return onEditClick;
};
const $ef644817a7099d65$export$ed7ae60d899fb4f = ()=>{
    const { author: author } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const anonymousUser = {
        id: null,
        ...author,
        displayName: formatMessage((0, $jEjVx.default).anonymous)
    };
    if (!author) return anonymousUser;
    return author;
};
const $ef644817a7099d65$export$a506f75d1ed3e618 = ()=>{
    const { author: author, currentUserAccountId: currentUserAccountId, bodyAdf: bodyAdf } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const authorId = author ? author.id : null;
    const authorDisplayName = $ef644817a7099d65$export$6b17aa8176081ded();
    const onReplyWithExtraCommentContent = $ef644817a7099d65$export$897fac1ce6c72c7d();
    const onIssueCreate = (data)=>{
        const issueUrl = (0, $lssfC.createFullIssueUrl)('', data.issueKey);
        const quotedCommentAndIssue = [
            (0, $50sdg.paragraph)((0, $d4vM2.inlineCard)({
                url: issueUrl
            })),
            (0, $7ipfu.rule)(),
            ...bodyAdf.content
        ];
        const extraCommentContent = currentUserAccountId === authorId ? (0, $bPWvi.doc)((0, $50sdg.paragraph)((0, $gBTcG.text)(formatMessage((0, $jEjVx.default).createdIssueBySelf))), ...quotedCommentAndIssue) : (0, $bPWvi.doc)((0, $50sdg.paragraph)(authorId ? (0, $kF5bw.mention)({
            id: authorId,
            text: `@${authorDisplayName}`
        }) : (0, $gBTcG.text)(''), (0, $gBTcG.text)(' '), (0, $gBTcG.text)(formatMessage((0, $jEjVx.default).createdIssue))), ...quotedCommentAndIssue);
        onReplyWithExtraCommentContent(extraCommentContent);
    };
    return onIssueCreate;
};
const $ef644817a7099d65$export$4a2d52fbf1785c72 = ()=>{
    const { projectType: projectType, canAdd: canAdd, isThreadedCommentsEnabled: isThreadedCommentsEnabled, isHighlighted: isHighlighted } = (0, $5y0Rn.useCommentContext)();
    const onReplyClick = $ef644817a7099d65$export$897fac1ce6c72c7d();
    const [replyToCommentParamValue, setReplyToCommentParamValue] = (0, $ieDtd.useQueryParam)((0, $8cd124aefa461409$export$27f4b9edd0b118b8));
    const isReplyToCommentParamSet = replyToCommentParamValue === (0, $8cd124aefa461409$export$65c681ec26344d06);
    const isTarget = (projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && canAdd && isThreadedCommentsEnabled;
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('reply_on_comment_notification_gate')) return;
        if (!isHighlighted) return;
        if (isReplyToCommentParamSet && !isTarget) {
            setReplyToCommentParamValue(undefined);
            return;
        }
        if (isReplyToCommentParamSet && isTarget && (0, $6s1PB.expVal)('reply_on_comment_notification', 'isEnabled', false)) {
            onReplyClick();
            setReplyToCommentParamValue(undefined);
        }
    }, [
        canAdd,
        isHighlighted,
        isReplyToCommentParamSet,
        isTarget,
        isThreadedCommentsEnabled,
        projectType,
        onReplyClick,
        setReplyToCommentParamValue
    ]);
};

});
parcelRegister("bEaSU", function(module, exports) {

$parcel$export(module.exports, "UNREAD_COMMENT_LOZENGE_VIEWED_KEY", () => $5c1003e9fa04451c$export$4a1aa3e6881d4707);
$parcel$export(module.exports, "localStorageProvider", () => $5c1003e9fa04451c$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "FIELD_TYPE_COMMENT", () => $5c1003e9fa04451c$export$3595b5f13ae19e8c);

var $bSSG7 = parcelRequire("bSSG7");
const $5c1003e9fa04451c$export$4a1aa3e6881d4707 = 'unread-comment-lozenge-viewed';
const $5c1003e9fa04451c$export$aa821bfb3308a1f5 = (0, $bSSG7.createLocalStorageProvider)('atl-issue-view-comment');
const $5c1003e9fa04451c$export$3595b5f13ae19e8c = 'comment';

});



parcelRegister("7iyJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f37996a1e628969$export$2e2bcd8739ae039);
/* CommentTime.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bMyd4 = parcelRequire("bMyd4");

var $6ZEN7 = parcelRequire("6ZEN7");

var $iDRQC = parcelRequire("iDRQC");

var $5y0Rn = parcelRequire("5y0Rn");

var $B7zKq = parcelRequire("B7zKq");
const $0f37996a1e628969$var$CommentTime = ()=>{
    const { createdDate: createdDate, eventOccurredAt: eventOccurredAt, isDeleted: isDeleted, isSaving: isSaving, isError: isError } = (0, $5y0Rn.useCommentContext)();
    if (isDeleted || isSaving || isError) return null;
    const value = eventOccurredAt ? (0, $bMyd4.default)(eventOccurredAt) : createdDate;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $B7zKq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6ZEN7.default), {
        value: value,
        tooltipPosition: "top",
        extraStyles: (0, $iDRQC.ActivityTimestampStylesControl)
    }));
};
var $0f37996a1e628969$export$2e2bcd8739ae039 = $0f37996a1e628969$var$CommentTime;

});
parcelRegister("B7zKq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa2ab26cab321eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $4R6GH = parcelRequire("4R6GH");
const $3fa2ab26cab321eb$export$7d8e28ee821f8624 = ({ children: children })=>{
    if (!(0, $4R6GH.fg)('jira_custom_comment_component_refactor')) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtlest"
    }, children);
};
var $3fa2ab26cab321eb$export$2e2bcd8739ae039 = $3fa2ab26cab321eb$export$7d8e28ee821f8624;

});


parcelRegister("iaY9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6e3e0d0571de7d1$export$2e2bcd8739ae039);
/* CommentLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");
const $d6e3e0d0571de7d1$var$CommentLozenge = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showLozenge: showLozenge, isDeleted: isDeleted } = (0, $5y0Rn.useCommentContext)();
    if (isDeleted || !showLozenge) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $aYAc3.default), {
        appearance: "default"
    }, formatMessage((0, $jEjVx.default).lozenge));
};
var $d6e3e0d0571de7d1$export$2e2bcd8739ae039 = $d6e3e0d0571de7d1$var$CommentLozenge;

});

parcelRegister("b3r1R", function(module, exports) {

$parcel$export(module.exports, "default", () => $009c997449ef23fb$export$2e2bcd8739ae039);
/* CommentAuthorActivity.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");
const $009c997449ef23fb$var$CommentAuthorActivity = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showAddedCommentDescription: showAddedCommentDescription, isDeleted: isDeleted } = (0, $5y0Rn.useCommentContext)();
    if (isDeleted || !showAddedCommentDescription) return null;
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        testId: "issue-comment-base.ui.comment.action"
    }, (0, $6s1PB.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? formatMessage((0, $jEjVx.default).addedCommentDescriptionLowercase, {
        span: (...text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                weight: "medium"
            }, text)
    }) : formatMessage((0, $jEjVx.default).addedCommentDescription, {
        span: (...text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                weight: "medium"
            }, text)
    })));
};
var $009c997449ef23fb$export$2e2bcd8739ae039 = $009c997449ef23fb$var$CommentAuthorActivity;

});

parcelRegister("jSPU2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1caf4300a02b375$export$2e2bcd8739ae039);
/* CommentRestrictedToIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwyQI = parcelRequire("bwyQI");

var $3bDjY = parcelRequire("3bDjY");

var $c0aEF = parcelRequire("c0aEF");

var $5y0Rn = parcelRequire("5y0Rn");

var $3kevq = parcelRequire("3kevq");
const $a1caf4300a02b375$var$CommentRestrictedToIndicator = ()=>{
    const { isDeleted: isDeleted, isSaving: isSaving, isEditing: isEditing, isOptimistic: isOptimistic } = (0, $5y0Rn.useCommentContext)();
    const restrictedToText = (0, $3kevq.useRestrictedToText)();
    const hasRestrictedToText = restrictedToText.length > 0;
    if (!hasRestrictedToText || isDeleted) return null;
    if (!isOptimistic && (isSaving || !hasRestrictedToText || isEditing)) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $c0aEF.default), {
        alignBlock: "center",
        space: "space.050",
        as: "span",
        testId: "issue-comment-base.ui.comment.custom-comment.restricted-to"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: restrictedToText
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small",
        size: "small"
    })));
};
var $a1caf4300a02b375$export$2e2bcd8739ae039 = $a1caf4300a02b375$var$CommentRestrictedToIndicator;

});

parcelRegister("jilzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8088869227e25f3e$export$2e2bcd8739ae039);
/* CommentPinIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $ay27n = parcelRequire("ay27n");

var $c0aEF = parcelRequire("c0aEF");

var $5y0Rn = parcelRequire("5y0Rn");
const $8088869227e25f3e$var$CommentPinIndicator = ()=>{
    const { isPinned: isPinned } = (0, $5y0Rn.useCommentContext)();
    if (!isPinned) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $c0aEF.default), {
        alignBlock: "center",
        space: "space.050",
        as: "span",
        testId: "issue-comment-base.ui.comment.custom-comment.pin-indicator"
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ay27n))), {
        color: "currentColor",
        label: "",
        size: "medium"
    }));
};
var $8088869227e25f3e$export$2e2bcd8739ae039 = $8088869227e25f3e$var$CommentPinIndicator;

});

parcelRegister("lC4En", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a105a8ab9afda47$export$2e2bcd8739ae039);
/* CommentCopyLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $koVbs = parcelRequire("koVbs");

var $7DhFg = parcelRequire("7DhFg");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");
const $2a105a8ab9afda47$var$CommentCopyLink = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { hasFloatingMenu: hasFloatingMenu, isEditing: isEditing, commentId: commentId, fullIssueUrl: fullIssueUrl, onCopyClick: onCopyClick, permalink: permalink, isDeleted: isDeleted, isOptimistic: isOptimistic, isSaving: isSaving } = (0, $5y0Rn.useCommentContext)();
    if (isDeleted) return null;
    if (isSaving) return null;
    if (isEditing) return null;
    if (hasFloatingMenu) return null;
    if (isOptimistic) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        testId: "issue-comment-base.ui.comment.custom-comment.copy-link"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $7DhFg.PermalinkButton), {
        id: commentId,
        fullIssueUrl: `${fullIssueUrl}?focusedCommentId=${commentId}`,
        label: formatMessage((0, $jEjVx.default).copy),
        onCopyClick: onCopyClick,
        isVisible: permalink.isVisible,
        isFlush: true
    }));
};
var $2a105a8ab9afda47$export$2e2bcd8739ae039 = $2a105a8ab9afda47$var$CommentCopyLink;

});

parcelRegister("1lCUZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $81adf1866350366b$export$2e2bcd8739ae039);
/* CommentEditedIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $i3LhB = parcelRequire("i3LhB");

var $6ZEN7 = parcelRequire("6ZEN7");

var $koVbs = parcelRequire("koVbs");

var $75neI = parcelRequire("75neI");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");

var $B7zKq = parcelRequire("B7zKq");
const $81adf1866350366b$var$CommentEditedIndicator = ()=>{
    const { isDeleted: isDeleted, displayNameForUpdateAuthor: displayNameForUpdateAuthor, hasFloatingMenu: hasFloatingMenu, updatedDate: updatedDate, hasDraft: hasDraft, edited: edited, isSaving: isSaving } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = (0, $5uXOq.useMemo)(()=>{
        return formatMessage((0, $jEjVx.default).editedBy, {
            author: displayNameForUpdateAuthor,
            timestamp: /*#__PURE__*/ $5uXOq.createElement((0, $6ZEN7.default), {
                value: updatedDate || ''
            })
        });
    }, [
        displayNameForUpdateAuthor,
        formatMessage,
        updatedDate
    ]);
    const shouldDisplayDraft = hasFloatingMenu && hasDraft;
    const editedMessage = (0, $5uXOq.useMemo)(()=>{
        const chunks = [];
        const editedText = formatMessage((0, $jEjVx.default).edited).toLocaleLowerCase();
        const draftText = formatMessage((0, $75neI.default).draftIndicatorAfterEdited);
        if (edited) chunks.push(editedText);
        if (shouldDisplayDraft) chunks.push(draftText);
        if (chunks.length === 0) return null;
        return chunks.join(" \u2022 ");
    }, [
        edited,
        formatMessage,
        shouldDisplayDraft
    ]);
    if (isDeleted || isSaving || !edited && !shouldDisplayDraft) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: tooltipContent,
        position: "top" // Test ID will be changed once the old comment component is deleted
        ,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "issue-comment-base.ui.comment.ak-tool-tip"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $B7zKq.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $i3LhB.default), null, `(${editedMessage})`)));
};
var $81adf1866350366b$export$2e2bcd8739ae039 = $81adf1866350366b$var$CommentEditedIndicator;

});

parcelRegister("7XRyn", function(module, exports) {

$parcel$export(module.exports, "default", () => $aea6eb7d486d06e9$export$2e2bcd8739ae039);
/* CommentDeletedIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $i3LhB = parcelRequire("i3LhB");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");
const $aea6eb7d486d06e9$var$CommentDeletedIndicator = ()=>{
    const { isDeleted: isDeleted } = (0, $5y0Rn.useCommentContext)();
    const intl = (0, $koVbs.default)();
    if (!isDeleted) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $luBm6.default), {
        xcss: $aea6eb7d486d06e9$var$commentDeletedStyles,
        alignBlock: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $i3LhB.default), null, intl.formatMessage((0, $jEjVx.default).commentDeleted)));
};
const $aea6eb7d486d06e9$var$commentDeletedStyles = (0, $8CUq3.xcss)({
    minHeight: '40px'
});
var $aea6eb7d486d06e9$export$2e2bcd8739ae039 = $aea6eb7d486d06e9$var$CommentDeletedIndicator;

});

parcelRegister("e4qkJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b17d14d51bdacd26$export$2e2bcd8739ae039);
/* CommentSavingIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");

var $B7zKq = parcelRequire("B7zKq");
const $b17d14d51bdacd26$var$CommentSavingIndicator = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSaving: isSaving } = (0, $5y0Rn.useCommentContext)();
    if (!isSaving) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $B7zKq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $jEjVx.default).saving)));
};
var $b17d14d51bdacd26$export$2e2bcd8739ae039 = $b17d14d51bdacd26$var$CommentSavingIndicator;

});

parcelRegister("kLGvV", function(module, exports) {

$parcel$export(module.exports, "SlackTooltip", () => $1db84fb33af7bda4$export$d60da2e2b1dc8c19);
/* SlackTooltip.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $jhmo0 = parcelRequire("jhmo0");

var $koVbs = parcelRequire("koVbs");

var $1wFwe = parcelRequire("1wFwe");
const $1db84fb33af7bda4$var$SlackIcon = ()=>/*#__PURE__*/ $5uXOq.createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ $5uXOq.createElement("g", {
        clipPath: "url(#clip0_672_84381)"
    }, /*#__PURE__*/ $5uXOq.createElement("path", {
        d: "M5.00277 9.23771C5.00277 9.81815 4.5286 10.2923 3.94816 10.2923C3.36772 10.2923 2.89355 9.81815 2.89355 9.23771C2.89355 8.65727 3.36772 8.18311 3.94816 8.18311H5.00277V9.23771Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ $5uXOq.createElement("path", {
        d: "M5.53418 9.23771C5.53418 8.65727 6.00835 8.18311 6.58879 8.18311C7.16924 8.18311 7.6434 8.65727 7.6434 9.23771V11.8783C7.6434 12.4588 7.16924 12.9329 6.58879 12.9329C6.00835 12.9329 5.53418 12.4588 5.53418 11.8783V9.23771Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ $5uXOq.createElement("path", {
        d: "M6.58879 5.00277C6.00835 5.00277 5.53418 4.5286 5.53418 3.94816C5.53418 3.36772 6.00835 2.89355 6.58879 2.89355C7.16924 2.89355 7.6434 3.36772 7.6434 3.94816V5.00277H6.58879Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ $5uXOq.createElement("path", {
        d: "M6.58878 5.53418C7.16922 5.53418 7.64338 6.00834 7.64338 6.58878C7.64338 7.16922 7.16922 7.64338 6.58878 7.64338H3.94816C3.36772 7.64338 2.89355 7.16922 2.89355 6.58878C2.89355 6.00834 3.36772 5.53418 3.94816 5.53418H6.58878Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ $5uXOq.createElement("path", {
        d: "M10.8232 6.58878C10.8232 6.00834 11.2974 5.53418 11.8778 5.53418C12.4583 5.53418 12.9324 6.00834 12.9324 6.58878C12.9324 7.16922 12.4583 7.64338 11.8778 7.64338H10.8232V6.58878Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ $5uXOq.createElement("path", {
        d: "M10.2919 6.58878C10.2919 7.16922 9.81768 7.64338 9.23723 7.64338C8.65679 7.64338 8.18262 7.16922 8.18262 6.58878V3.94816C8.18262 3.36772 8.65679 2.89355 9.23723 2.89355C9.81768 2.89355 10.2919 3.36772 10.2919 3.94816V6.58878Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ $5uXOq.createElement("path", {
        d: "M9.23723 10.8237C9.81768 10.8237 10.2919 11.2979 10.2919 11.8783C10.2919 12.4588 9.81768 12.9329 9.23723 12.9329C8.65679 12.9329 8.18262 12.4588 8.18262 11.8783V10.8237H9.23723Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ $5uXOq.createElement("path", {
        d: "M9.23722 10.2923C8.65678 10.2923 8.18262 9.81815 8.18262 9.23771C8.18262 8.65727 8.65678 8.18311 9.23722 8.18311H11.8778C12.4583 8.18311 12.9324 8.65727 12.9324 9.23771C12.9324 9.81815 12.4583 10.2923 11.8778 10.2923H9.23722Z",
        fill: "#ECB22E"
    })), /*#__PURE__*/ $5uXOq.createElement("defs", null, /*#__PURE__*/ $5uXOq.createElement("clipPath", {
        id: "clip0_672_84381"
    }, /*#__PURE__*/ $5uXOq.createElement("rect", {
        width: "10.6667",
        height: "10.6667",
        fill: "none",
        transform: "translate(2.6665 2.66675)"
    }))));
const $1db84fb33af7bda4$export$d60da2e2b1dc8c19 = ({ href: href })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: formatMessage((0, $1wFwe.default).content)
    }, (tooltipProps)=>/*#__PURE__*/ $5uXOq.createElement("span", {
            className: (0, $bwpsq.default)([
                "_4t3ipxbi _1bsbpxbi _18u01b66"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement((0, $jhmo0.default), {
            ...tooltipProps,
            href: href ?? 'https://www.atlassian.com/',
            target: "_blank",
            rel: "noopener noreferrer",
            testId: "issue-comment-base.ui.comment.custom-comment.slack-tooltip.link",
            "aria-label": formatMessage((0, $1wFwe.default).icon)
        }, /*#__PURE__*/ $5uXOq.createElement($1db84fb33af7bda4$var$SlackIcon, null))));
};
const $1db84fb33af7bda4$var$tooltipContainer = null;

});
parcelRegister("1wFwe", function(module, exports) {

$parcel$export(module.exports, "default", () => $205640fdd302545f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $205640fdd302545f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    icon: {
        "id": "issue-comment-base.comment.slack-tooltip.button",
        "defaultMessage": "Link to conversation on Slack"
    },
    content: {
        "id": "issue-comment-base.comment.slack-tooltip.content",
        "defaultMessage": "This conversation thread is synced with Slack. Replying to comments in Jira will also post them in the synced Slack channel"
    }
});

});


parcelRegister("fkShn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed49ec6a06a4bc33$export$2e2bcd8739ae039);
/* SlackLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");

var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $g2C8o = parcelRequire("g2C8o");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");
const $ed49ec6a06a4bc33$var$SlackLink = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { projectType: projectType, thirdPartyLink: thirdPartyLink, thirdPartyCommentSource: thirdPartyCommentSource } = (0, $5y0Rn.useCommentContext)();
    if (!(0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') || projectType !== (0, $2vSU6.SOFTWARE_PROJECT) && projectType !== (0, $2vSU6.CORE_PROJECT) || !thirdPartyLink || thirdPartyCommentSource !== (0, $g2C8o.THIRD_PARTY_SOURCE_SLACK)) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jEjVx.default).viaSlackTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), {
            size: "small"
        }, /*#__PURE__*/ $5uXOq.createElement((0, $jhmo0.default), {
            ...tooltipProps,
            xcss: $ed49ec6a06a4bc33$var$anchorStyles,
            href: thirdPartyLink,
            target: "_blank",
            rel: "noopener noreferrer",
            testId: "issue-comment-base.ui.comment.custom-comment.link",
            "aria-label": formatMessage((0, $jEjVx.default).viaSlack)
        }, formatMessage((0, $jEjVx.default).viaSlack))));
};
var $ed49ec6a06a4bc33$export$2e2bcd8739ae039 = $ed49ec6a06a4bc33$var$SlackLink;
const $ed49ec6a06a4bc33$var$anchorStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    textDecoration: 'none',
    ':hover': {
        color: 'color.text',
        textDecoration: 'underline'
    },
    ':focus': {
        color: 'color.text.subtlest',
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.text.subtlest',
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.text.subtlest',
        textDecoration: 'none'
    },
    ':visited:active': {
        color: 'color.text.subtlest',
        textDecoration: 'none'
    }
});

});


parcelRegister("52C90", function(module, exports) {

$parcel$export(module.exports, "default", () => $39c63cd063c89851$export$2e2bcd8739ae039);
/* AkCommentContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $5y0Rn = parcelRequire("5y0Rn");
const $39c63cd063c89851$var$AkCommentContent = ()=>{
    const { content: content, commentId: commentId } = (0, $5y0Rn.useCommentContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        testId: `issue-comment-base.ui.comment.ak-comment.${commentId}.content`,
        paddingBlock: "space.075"
    }, content);
};
var $39c63cd063c89851$export$2e2bcd8739ae039 = $39c63cd063c89851$var$AkCommentContent;

});


parcelRegister("hdrGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9ad221cd0d57b4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $koVbs = parcelRequire("koVbs");

var $5y0Rn = parcelRequire("5y0Rn");

var $jEjVx = parcelRequire("jEjVx");
const $db9ad221cd0d57b4$var$PinAction = ({ handleDropdownClick: handleDropdownClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { canPin: canPin, isPinned: isPinned, isPinnedCommentsLimitReached: isPinnedCommentsLimitReached, onPinClick: onPinClick, onUnpinClick: onUnpinClick } = (0, $5y0Rn.useCommentContext)();
    const onPinClickHandler = (0, $5uXOq.useCallback)(()=>{
        if (!onPinClick || !onUnpinClick) return;
        isPinned ? onUnpinClick() : onPinClick();
        handleDropdownClick('meatballMenuPinCommentButton');
    }, [
        onPinClick,
        onUnpinClick,
        isPinned,
        handleDropdownClick
    ]);
    if (!canPin || isPinnedCommentsLimitReached && !isPinned) return null;
    const messageKey = isPinned ? (0, $jEjVx.default).unpinComment : (0, $jEjVx.default).pinComment;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: "pin",
        onClick: ()=>onPinClickHandler()
    }, formatMessage(messageKey));
};
var $db9ad221cd0d57b4$export$2e2bcd8739ae039 = $db9ad221cd0d57b4$var$PinAction;

});

parcelRegister("kFfVd", function(module, exports) {

$parcel$export(module.exports, "default", () => $88267da53be7beb9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $koVbs = parcelRequire("koVbs");

var $kVVL1 = parcelRequire("kVVL1");

var $iowjP = parcelRequire("iowjP");

var $kiiIS = parcelRequire("kiiIS");

var $iI3Lw = parcelRequire("iI3Lw");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");
const $88267da53be7beb9$var$ScrollToCommentAction = ({ handleDropdownClick: handleDropdownClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { commentId: commentId } = (0, $5y0Rn.useCommentContext)();
    const dispatch = (0, $kVVL1.useDispatch)();
    const [, { setScrollTarget: setScrollTarget }] = (0, $iI3Lw.useIssueScroll)();
    const scrollToComment = (0, $5uXOq.useCallback)(()=>{
        handleDropdownClick('meatballMenuScrollToCommentButton');
        const setAndScrollToTarget = (scrollTargetType, scrollToTargetAction)=>{
            setScrollTarget({
                type: scrollTargetType,
                id: commentId
            });
            scrollToTargetAction();
        };
        setAndScrollToTarget((0, $kiiIS.SCROLL_TARGET_TYPES).COMMENT, ()=>dispatch((0, $iowjP.scrollToPinnedComment)()));
    }, [
        commentId,
        handleDropdownClick,
        setScrollTarget,
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: "scrollToComment",
        onClick: scrollToComment
    }, formatMessage((0, $jEjVx.default).scrollToComment));
};
var $88267da53be7beb9$export$2e2bcd8739ae039 = $88267da53be7beb9$var$ScrollToCommentAction;

});


parcelRegister("8RfOY", function(module, exports) {

$parcel$export(module.exports, "CommentBase", () => $69c575c464c39f68$export$b3f0cdb4c764ce3e);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $aqnOi = parcelRequire("aqnOi");

var $6mahi = parcelRequire("6mahi");

var $2vSU6 = parcelRequire("2vSU6");

var $iDRQC = parcelRequire("iDRQC");

var $iZ11O = parcelRequire("iZ11O");

var $5y0Rn = parcelRequire("5y0Rn");

var $bEaSU = parcelRequire("bEaSU");

var $eg1eY = parcelRequire("eg1eY");

var $3kevq = parcelRequire("3kevq");

var $eUE6n = parcelRequire("eUE6n");
const $69c575c464c39f68$var$RenderOptimisticComment = ({ children: children })=>{
    const { permalink: permalink, hasFloatingMenu: hasFloatingMenu, isThreadedCommentsEnabled: isThreadedCommentsEnabled } = (0, $5y0Rn.useCommentContext)();
    if (hasFloatingMenu && isThreadedCommentsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eg1eY.FloatingMenuContainer), {
        permalink: permalink
    }, children);
    if (isThreadedCommentsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eg1eY.ThreadedCommentContainer), {
        permalink: permalink
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eg1eY.OptimisticCommentContainer), {
        permalink: permalink
    }, children);
};
const $69c575c464c39f68$var$WithInternalCommentContainer = ({ children: children })=>{
    const { isEditing: isEditing, isHighlighted: isHighlighted, isInternal: isInternal } = (0, $5y0Rn.useCommentContext)();
    const highlightColor = isHighlighted ? "var(--ds-background-accent-yellow-subtler, #F8E6A0)" : "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
    if (!isInternal) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDRQC.InternalCommentContainer), {
        isEditing: isEditing,
        highlightColor: highlightColor
    }, children);
};
const $69c575c464c39f68$var$CommentRender = ({ children: children })=>{
    const { isOptimistic: isOptimistic, permalink: permalink } = (0, $5y0Rn.useCommentContext)();
    if (isOptimistic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69c575c464c39f68$var$RenderOptimisticComment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eg1eY.default), {
        permalink: permalink
    }, children);
};
const $69c575c464c39f68$var$CommentBaseInner = ({ children: children })=>{
    const { isThreadedCommentsEnabled: isThreadedCommentsEnabled } = (0, $5y0Rn.useCommentContext)();
    (0, $3kevq.useScrollCommentIntoView)();
    (0, $3kevq.useUnreadCommentLozengeState)();
    (0, $3kevq.useSmoothScrollIntoView)();
    (0, $3kevq.useFireHiglightedCommentAnalytics)();
    (0, $3kevq.useReplyToComment)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69c575c464c39f68$var$WithInternalCommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69c575c464c39f68$var$CommentRender, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iZ11O.default), null, isThreadedCommentsEnabled && children)));
};
const $69c575c464c39f68$export$b3f0cdb4c764ce3e = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const [selectedEventOccurredAt, setSelectedEventOccuredAt] = (0, $5uXOq.useState)(props.eventOccurredAt);
    const [showNewUnreadCommentLozenge, setShowNewUnreadCommentLozenge] = (0, $5uXOq.useState)(!(0, $bEaSU.localStorageProvider).get((0, $bEaSU.UNREAD_COMMENT_LOZENGE_VIEWED_KEY)) && props.commentId === props.topMostUnreadCommentId && !props.isActivityFeedInViewPort);
    const [optimisticCommentContainer, setOptimisticCommentPermalinkContainer] = (0, $5uXOq.useState)(undefined);
    const [unreadCommentRef, updateUnreadCommentRef] = (0, $5uXOq.useState)(undefined);
    const [commentPermalinkContainer, setCommentPermalinkContainer] = (0, $5uXOq.useState)(undefined);
    if (props.hasFloatingMenu || props.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eUE6n.CommentBase), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6mahi.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aqnOi.default), null, (permalink)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0Rn.default), {
            setShowNewUnreadCommentLozenge: setShowNewUnreadCommentLozenge,
            optimisticCommentContainer: optimisticCommentContainer,
            setOptimisticCommentContainer: setOptimisticCommentPermalinkContainer,
            commentPermalinkContainer: commentPermalinkContainer,
            setCommentPermalinkContainer: setCommentPermalinkContainer,
            unreadCommentElement: unreadCommentRef,
            hasChildren: !!props.children,
            restrictedToText: "" // this props can be removed once we clean up fg jira_custom_comment_component_refactor
            ,
            showNewUnreadCommentLozenge: showNewUnreadCommentLozenge,
            setUnreadCommentScrollRef: updateUnreadCommentRef,
            permalink: permalink,
            selectedEventOccurredAt: selectedEventOccurredAt,
            setSelectedEventOccuredAt: setSelectedEventOccuredAt,
            ...props
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69c575c464c39f68$var$CommentBaseInner, null, props.children))));
});

});
parcelRegister("iZ11O", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4daf5d4d634f4d4$export$2e2bcd8739ae039);
/* CommentComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $8u00d = parcelRequire("8u00d");

var $5Giut = parcelRequire("5Giut");

var $7OkHF = parcelRequire("7OkHF");

var $3SGdI = parcelRequire("3SGdI");

var $dzxpz = parcelRequire("dzxpz");

var $dRVOI = parcelRequire("dRVOI");

var $4rqPQ = parcelRequire("4rqPQ");

var $b9U41 = parcelRequire("b9U41");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");

var $3kevq = parcelRequire("3kevq");

var $h5smc = parcelRequire("h5smc");

var $7iyJO = parcelRequire("7iyJO");

var $b3r1R = parcelRequire("b3r1R");

var $iaY9h = parcelRequire("iaY9h");

var $9bylq = parcelRequire("9bylq");

var $1lCUZ = parcelRequire("1lCUZ");

var $ikGpk = parcelRequire("ikGpk");

var $e4qkJ = parcelRequire("e4qkJ");

var $fkShn = parcelRequire("fkShn");
const $d4daf5d4d634f4d4$var$CommentDefault = ()=>{
    const { isThreadedCommentsEnabled: isThreadedCommentsEnabled, commentId: commentId, parentId: parentId, hasReplies: hasReplies, isReplyingToComment: isReplyingToComment, showLozenge: showLozenge, isSaving: isSaving, isDeleted: isDeleted, isError: isError } = (0, $5y0Rn.useCommentContext)();
    const authorAdditionalInfo = (0, $3kevq.useAuthorAdditionalInfo)();
    const author = (0, $3kevq.useAuthor)();
    const isParent = isThreadedCommentsEnabled && (hasReplies || isReplyingToComment);
    const isNested = isThreadedCommentsEnabled && !!parentId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Giut.default), {
        testId: `issue-comment-base.ui.comment.ak-comment.${commentId}`,
        showThreadLines: isParent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7OkHF.default), {
        testId: `issue-comment-base.ui.comment.ak-comment.${commentId}-header`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3SGdI.default), {
        user: author,
        isNested: isNested
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzxpz.default), {
        user: author,
        authorInfo: authorAdditionalInfo,
        authorActivity: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b3r1R.default), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9bylq.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9U41.default), {
        space: "space.050"
    }, !isDeleted && !isSaving && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iyJO.default), null), !isDeleted && !isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkShn.default), null), !isDeleted && !isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1lCUZ.default), null), isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4qkJ.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRVOI.default), {
        testId: `issue-comment-base.ui.comment.ak-comment.${commentId}-body`
    }, showLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaY9h.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5smc.default), null)), !isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4rqPQ.default), {
        testId: `issue-comment-base.ui.comment.ak-comment.${commentId}-footer`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikGpk.default), null)));
};
const $d4daf5d4d634f4d4$var$deletedTemplateAreas = [
    'header header'
];
const $d4daf5d4d634f4d4$var$CommentDeleted = ()=>{
    const { isThreadedCommentsEnabled: isThreadedCommentsEnabled, commentId: commentId, hasReplies: hasReplies, isReplyingToComment: isReplyingToComment } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isParent = isThreadedCommentsEnabled && (hasReplies || isReplyingToComment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Giut.default), {
        testId: `issue-comment-base.ui.comment.ak-comment.${commentId}`,
        showThreadLines: isParent,
        templateAreas: $d4daf5d4d634f4d4$var$deletedTemplateAreas
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7OkHF.default), {
        testId: `issue-comment-base.ui.comment.ak-comment.${commentId}-header`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3SGdI.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, formatMessage((0, $jEjVx.default).commentDeleted)))));
};
const $d4daf5d4d634f4d4$var$CommentComponent = ({ children: children })=>{
    const { isDeleted: isDeleted, isThreadedCommentsEnabled: isThreadedCommentsEnabled, hasReplies: hasReplies, isReplyingToComment: isReplyingToComment, isInternal: isInternal, shouldHighlightComment: shouldHighlightComment } = (0, $5y0Rn.useCommentContext)();
    const isParent = isThreadedCommentsEnabled && (hasReplies || isReplyingToComment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8u00d.default), {
        appearance: isInternal ? 'internal' : 'legacy',
        isFocused: shouldHighlightComment
    }, isDeleted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d4daf5d4d634f4d4$var$CommentDeleted, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d4daf5d4d634f4d4$var$CommentDefault, null)), isParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d4daf5d4d634f4d4$var$nestedChildrenWrapperStyles
    }, children));
};
var $d4daf5d4d634f4d4$export$2e2bcd8739ae039 = $d4daf5d4d634f4d4$var$CommentComponent;
const $d4daf5d4d634f4d4$var$nestedChildrenWrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.400',
    paddingLeft: 'space.150'
});

});
parcelRegister("8u00d", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f279f7137708a85$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $9f279f7137708a85$var$Card = ({ children: children, isFocused: isFocused, padding: padding = 'space.150', paddingBlock: paddingBlock, paddingBlockEnd: paddingBlockEnd, paddingBlockStart: paddingBlockStart, paddingInline: paddingInline, paddingInlineEnd: paddingInlineEnd, paddingInlineStart: paddingInlineStart, appearance: appearance = 'default' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockEnd: paddingBlockEnd,
        paddingBlockStart: paddingBlockStart,
        paddingInline: paddingInline,
        paddingInlineEnd: paddingInlineEnd,
        paddingInlineStart: paddingInlineStart,
        xcss: [
            appearance === 'internal' ? $9f279f7137708a85$var$internalCardStyles : $9f279f7137708a85$var$defaultCardStyles,
            isFocused && appearance === 'internal' && $9f279f7137708a85$var$internalFocusCardStyles,
            isFocused && appearance === 'legacy' && $9f279f7137708a85$var$legacyFocusCardStyles,
            isFocused && appearance === 'default' && $9f279f7137708a85$var$defaultFocusCardStyles
        ]
    }, children);
const $9f279f7137708a85$var$legacyFocusCardStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $9f279f7137708a85$var$defaultCardStyles = (0, $8CUq3.xcss)({
    transition: 'background-color 2s'
});
const $9f279f7137708a85$var$defaultFocusCardStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.selected'
});
const $9f279f7137708a85$var$internalCardStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtlest'
});
const $9f279f7137708a85$var$internalFocusCardStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtle'
});
var $9f279f7137708a85$export$2e2bcd8739ae039 = $9f279f7137708a85$var$Card;

});

parcelRegister("5Giut", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6432987dddf4dde$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bgrar = parcelRequire("bgrar");

var $9TwjM = parcelRequire("9TwjM");
const $a6432987dddf4dde$var$defaultTemplateAreas = [
    'header header',
    '. body',
    '. footer'
];
const $a6432987dddf4dde$var$parentTemplateAreas = [
    'header header',
    'thread-line body',
    'thread-line footer'
];
const $a6432987dddf4dde$var$Comment = ({ children: children, templateAreas: templateAreasProp, templateRows: templateRows = '1fr', templateColumns: templateColumns = '36px 1fr', gap: gap, columnGap: columnGap = 'space.100', rowGap: rowGap = 'space.150', testId: testId, showThreadLines: showThreadLines })=>{
    const templateAreas = showThreadLines ? $a6432987dddf4dde$var$parentTemplateAreas : $a6432987dddf4dde$var$defaultTemplateAreas;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), {
        templateAreas: templateAreasProp || templateAreas,
        templateRows: templateRows,
        templateColumns: templateColumns,
        gap: gap,
        columnGap: columnGap,
        rowGap: rowGap,
        testId: testId
    }, children, showThreadLines && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TwjM.default), null));
};
var $a6432987dddf4dde$export$2e2bcd8739ae039 = $a6432987dddf4dde$var$Comment;

});
parcelRegister("9TwjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $743216bf3b96a0e4$export$2e2bcd8739ae039);
/* thread-line.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $743216bf3b96a0e4$var$ThreadLine = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_nd5ll2x3 _kqswh2mm _1hjgt94y _161e1v33 _4t3i1osq _1kt9b3bt _1cs8stnw _z5wt1ssb _19woze3t _1mp4qk1p _1aukidpf _1rus1qe4"
        ])
    }, children);
};
var $743216bf3b96a0e4$export$2e2bcd8739ae039 = $743216bf3b96a0e4$var$ThreadLine;
const $743216bf3b96a0e4$var$threadLineStyles = null;

});


parcelRegister("7OkHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9cfef5c8f608747$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $bgrar = parcelRequire("bgrar");
var $8CUq3 = parcelRequire("8CUq3");
const $b9cfef5c8f608747$var$defaultTemplateAreas = [
    'header-avatar header-author .',
    'header-avatar header-subtext header-subtext'
];
const $b9cfef5c8f608747$var$Header = ({ children: children, templateAreas: templateAreas = $b9cfef5c8f608747$var$defaultTemplateAreas, templateRows: templateRows = '1fr', templateColumns: templateColumns = '36px minmax(min-content, max-content) 1fr', gap: gap, columnGap: columnGap = 'space.100', rowGap: rowGap, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b9cfef5c8f608747$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bgrar.default), {
        templateAreas: templateAreas,
        templateRows: templateRows,
        templateColumns: templateColumns,
        columnGap: columnGap,
        rowGap: rowGap,
        gap: gap,
        testId: testId
    }, children));
};
const $b9cfef5c8f608747$var$headerStyles = (0, $8CUq3.xcss)({
    gridArea: 'header'
});
var $b9cfef5c8f608747$export$2e2bcd8739ae039 = $b9cfef5c8f608747$var$Header;

});

parcelRegister("3SGdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f16ec02a146f6ec0$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $h5GPI = parcelRequire("h5GPI");
const $f16ec02a146f6ec0$var$Avatar = ({ user: user, isNested: isNested })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_nd5l1uxi",
            isNested && "_p12f1kdh _kqswh2mm _1hjgt94y _1pty1eak _161e1v33 _2kncueha _qlwiueha _aetrb3bt _631ousvi _18postnw _g0nf1yie _15l2qlgl _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq _19do1j0o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5GPI.default), {
        userAccount: user,
        analyticsData: {
            trigger: 'comment-avatar'
        },
        testId: "comment.ui.header.avatar",
        ariaHideProfileTrigger: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        borderColor: "transparent",
        size: "medium",
        src: user?.avatarUrl
    })));
};
const $f16ec02a146f6ec0$var$avatarStyles = null;
const $f16ec02a146f6ec0$var$nestedStyles = null;
var $f16ec02a146f6ec0$export$2e2bcd8739ae039 = $f16ec02a146f6ec0$var$Avatar;

});

parcelRegister("dzxpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $45301ff0e3d13307$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $h5GPI = parcelRequire("h5GPI");
const $45301ff0e3d13307$var$Author = ({ user: user, authorInfo: authorInfo, authorActivity: authorActivity })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center",
        grow: "fill",
        xcss: $45301ff0e3d13307$var$authorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $45301ff0e3d13307$var$userNameStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5GPI.default), {
        userAccount: user,
        analyticsData: {
            trigger: 'comment-author'
        },
        shouldTruncate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, user?.displayName))), !!authorInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $45301ff0e3d13307$var$additionalContentStyles
    }, authorInfo), !!authorActivity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $45301ff0e3d13307$var$additionalContentStyles
    }, authorActivity));
};
var $45301ff0e3d13307$export$2e2bcd8739ae039 = $45301ff0e3d13307$var$Author;
const $45301ff0e3d13307$var$authorStyles = (0, $8CUq3.xcss)({
    gridArea: 'header-author',
    overflow: 'hidden'
});
const $45301ff0e3d13307$var$userNameStyles = (0, $8CUq3.xcss)({
    minWidth: '0px'
});
const $45301ff0e3d13307$var$additionalContentStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});

});

parcelRegister("dRVOI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8108a822040ada4e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");
const $8108a822040ada4e$var$Body = ({ children: children, gap: gap = 'space.100', direction: direction = 'column', alignItems: alignItems = 'stretch', justifyContent: justifyContent = 'center', testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $8108a822040ada4e$var$bodyStyles,
        gap: gap,
        direction: direction,
        alignItems: alignItems,
        justifyContent: justifyContent,
        testId: testId
    }, children);
};
const $8108a822040ada4e$var$bodyStyles = (0, $8CUq3.xcss)({
    gridArea: 'body',
    minWidth: '0'
});
var $8108a822040ada4e$export$2e2bcd8739ae039 = $8108a822040ada4e$var$Body;

});

parcelRegister("4rqPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d0ef1093c7f6178$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $7d0ef1093c7f6178$var$Footer = ({ children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7d0ef1093c7f6178$var$footerStyles,
        testId: testId
    }, children);
};
const $7d0ef1093c7f6178$var$footerStyles = (0, $8CUq3.xcss)({
    gridArea: 'footer'
});
var $7d0ef1093c7f6178$export$2e2bcd8739ae039 = $7d0ef1093c7f6178$var$Footer;

});

parcelRegister("b9U41", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e69985d64df6d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");
const $f9e69985d64df6d5$var$Subtext = ({ children: children, alignBlock: alignBlock = 'center', space: space, alignInline: alignInline })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $f9e69985d64df6d5$var$subtextStyles,
        alignBlock: alignBlock,
        alignInline: alignInline,
        space: space
    }, children);
};
const $f9e69985d64df6d5$var$subtextStyles = (0, $8CUq3.xcss)({
    gridArea: 'header-subtext'
});
var $f9e69985d64df6d5$export$2e2bcd8739ae039 = $f9e69985d64df6d5$var$Subtext;

});

parcelRegister("h5smc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d556b46820a1da0$export$2e2bcd8739ae039);
/* CommentContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $b71gk = parcelRequire("b71gk");

var $cSD7y = parcelRequire("cSD7y");

var $6iXgG = parcelRequire("6iXgG");

var $VuurY = parcelRequire("VuurY");

var $88XcY = parcelRequire("88XcY");

var $iBYZ7 = parcelRequire("iBYZ7");

var $5y0Rn = parcelRequire("5y0Rn");

var $3kevq = parcelRequire("3kevq");

var $52C90 = parcelRequire("52C90");
const $4d556b46820a1da0$var$CommentContentAIWrapper = ({ children: children })=>{
    const { isDeleted: isDeleted, isEditing: isEditing, commentRef: commentRef } = (0, $5y0Rn.useCommentContext)();
    if (isDeleted) return null;
    if (!isEditing && (0, $4R6GH.fg)('thor_ai_definitions_issue_comment')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: commentRef
    }, children);
    return children;
};
const $4d556b46820a1da0$var$CommentContentDefault = ()=>{
    const { bodyAdf: bodyAdf, bodyHtml: bodyHtml, commentId: commentId, isEditing: isEditing, onEditCancel: onEditCancel, onEditUpdate: onEditUpdate, onEditPaste: onEditPaste, onBlur: onBlur, visibilityEdited: visibilityEdited, onCommentVisibilityChange: onCommentVisibilityChange, shouldShowCommentVisibility: shouldShowCommentVisibility, eventOccurredAt: eventOccurredAt, isEditingInternal: isEditingInternal, projectType: projectType, parentId: parentId, canEdit: canEdit, mentionProvider: mentionProvider, contextIdentifier: contextIdentifier, mediaContext: mediaContext, setSelectedEventOccuredAt: setSelectedEventOccuredAt, pinnedCommentBodyAdf: pinnedCommentBodyAdf, isPinned: isPinned } = (0, $5y0Rn.useCommentContext)();
    const onEditSave = (0, $3kevq.useEditSave)();
    const shouldShowCommentVisibilitySelector = shouldShowCommentVisibility && !parentId; // should not show for replies
    const onHideSave = (0, $3kevq.useHideSave)();
    const jsmTimelineComponents = isEditingInternal ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iBYZ7.EventOccurredAtSelector), {
            key: "eventOccurredAtSelector",
            initialValue: eventOccurredAt,
            onChange: (newEventOccurredAt)=>{
                setSelectedEventOccuredAt?.(newEventOccurredAt);
            }
        })
    ] : [];
    let secondaryToolbarComponents = shouldShowCommentVisibilitySelector ? [
        ...jsmTimelineComponents,
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88XcY.default), {
            key: "commentVisibilitySelector",
            initialValue: visibilityEdited,
            onChange: onCommentVisibilityChange
        })
    ] : jsmTimelineComponents;
    secondaryToolbarComponents = shouldShowCommentVisibilitySelector && (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) ? isEditingInternal : true) ? [
        ...jsmTimelineComponents,
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88XcY.default), {
            key: "commentVisibilitySelector",
            initialValue: visibilityEdited,
            onChange: onCommentVisibilityChange
        })
    ] : jsmTimelineComponents;
    let commentContentProps = {
        commentId: commentId,
        isEditing: isEditing,
        secondaryToolbarComponents: secondaryToolbarComponents,
        canEdit: canEdit,
        onCancel: onEditCancel,
        onChange: onEditUpdate,
        onSave: onEditSave,
        onPaste: onEditPaste,
        onBlur: onBlur,
        onHideSave: onHideSave
    };
    if ((0, $4R6GH.fg)('change_comment_editorstate_props_to_propdrill')) commentContentProps = {
        ...commentContentProps,
        mentionProvider: mentionProvider,
        contextIdentifier: contextIdentifier,
        mediaContext: mediaContext
    };
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d556b46820a1da0$var$CommentContentAIWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6iXgG.default), {
        ...commentContentProps,
        bodyAdf: isPinned ? pinnedCommentBodyAdf : bodyAdf
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d556b46820a1da0$var$CommentContentAIWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-comment-editor",
        packageName: "issue",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $VuurY.IssueCommentEditorReadonly), {
                bodyHtml: bodyHtml
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6iXgG.default), {
        ...commentContentProps,
        bodyAdf: isPinned ? pinnedCommentBodyAdf : bodyAdf
    })));
};
const $4d556b46820a1da0$var$CommentContent = (0, $cSD7y.componentWithFG)('jira_custom_comment_component_refactor', $4d556b46820a1da0$var$CommentContentDefault, (0, $52C90.default));
var $4d556b46820a1da0$export$2e2bcd8739ae039 = $4d556b46820a1da0$var$CommentContent;

});

parcelRegister("9bylq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5591cdbdaf09db20$export$2e2bcd8739ae039);
/* CommentStatus.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $c0aEF = parcelRequire("c0aEF");

var $jSPU2 = parcelRequire("jSPU2");

var $dv9Yh = parcelRequire("dv9Yh");

var $lC4En = parcelRequire("lC4En");

var $3QHhj = parcelRequire("3QHhj");

var $jilzA = parcelRequire("jilzA");
const $5591cdbdaf09db20$var$CommentStatus = ()=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $c0aEF.default), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3QHhj.default), null), /*#__PURE__*/ $5uXOq.createElement((0, $jilzA.default), null), /*#__PURE__*/ $5uXOq.createElement((0, $jSPU2.default), null), /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $lC4En.default), null))), /*#__PURE__*/ $5uXOq.createElement((0, $dv9Yh.default), null));
};
var $5591cdbdaf09db20$export$2e2bcd8739ae039 = $5591cdbdaf09db20$var$CommentStatus;

});
parcelRegister("3QHhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2a04acf53d8c7bb$export$2e2bcd8739ae039);
/* SlackSyncStatus.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $g2C8o = parcelRequire("g2C8o");

var $kLGvV = parcelRequire("kLGvV");

var $5y0Rn = parcelRequire("5y0Rn");
const $d2a04acf53d8c7bb$var$SlackSyncStatus = ()=>{
    const { parentId: parentId, projectType: projectType, isThirdPartySyncOn: isThirdPartySyncOn, thirdPartyLink: thirdPartyLink, thirdPartyCommentSource: thirdPartyCommentSource } = (0, $5y0Rn.useCommentContext)();
    if (!(0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') || projectType !== (0, $2vSU6.SOFTWARE_PROJECT) && projectType !== (0, $2vSU6.CORE_PROJECT) || !isThirdPartySyncOn || parentId || thirdPartyCommentSource !== (0, $g2C8o.THIRD_PARTY_SOURCE_SLACK)) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $kLGvV.SlackTooltip), {
        href: thirdPartyLink
    });
};
var $d2a04acf53d8c7bb$export$2e2bcd8739ae039 = $d2a04acf53d8c7bb$var$SlackSyncStatus;

});


parcelRegister("ikGpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ae9b06fc0d8922$export$2e2bcd8739ae039);
/* CommentActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $7O2cr = parcelRequire("7O2cr");

var $5nRKm = parcelRequire("5nRKm");

var $8U6zd = parcelRequire("8U6zd");

var $8w53e = parcelRequire("8w53e");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $9OXo1 = parcelRequire("9OXo1");

var $7p8Xy = parcelRequire("7p8Xy");

var $75neI = parcelRequire("75neI");

var $9JHBt = parcelRequire("9JHBt");

var $8zOmE = parcelRequire("8zOmE");

var $7XYc4 = parcelRequire("7XYc4");

var $dHOuF = parcelRequire("dHOuF");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");

var $9RUbE = parcelRequire("9RUbE");

var $3kevq = parcelRequire("3kevq");

var $g4tAu = parcelRequire("g4tAu");

var $jtv9z = parcelRequire("jtv9z");

var $3K9OL = parcelRequire("3K9OL");

var $1NQYx = parcelRequire("1NQYx");

var $8hcmO = parcelRequire("8hcmO");

var $1Taxc = parcelRequire("1Taxc");

var $5Ue0F = parcelRequire("5Ue0F");

var $hdrGw = parcelRequire("hdrGw");

var $kFfVd = parcelRequire("kFfVd");
const $87ae9b06fc0d8922$var$deleteConfirmModalProps = {
    width: 'small',
    testId: 'issue-comment-base.ui.comment.confirmation-modal.modal-dialog'
};
const $87ae9b06fc0d8922$var$CommentActionsModern = ()=>{
    const [isCommentMoreActionMenuOpen, setIsCommentMoreActionMenuOpen] = (0, $5uXOq.useState)(false);
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $jEjVx.default).copyLink);
    const context = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onEditClick = (0, $3kevq.useEdit)();
    const onHideSave = (0, $3kevq.useHideSave)();
    const onDeleteClick = (0, $3kevq.useDelete)();
    const onReplyClick = (0, $3kevq.useReply)();
    const onIssueCreate = (0, $3kevq.useIssueCreate)();
    const handleDropdownClick = (0, $5uXOq.useCallback)((eventName)=>{
        (0, $8zOmE.fireUIAnalytics)(context.createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), eventName);
        if (!isCommentMoreActionMenuOpen) setIsCommentMoreActionMenuOpen(true);
        else setIsCommentMoreActionMenuOpen(false);
    }, [
        context,
        isCommentMoreActionMenuOpen
    ]);
    const onClickCreateIssueButton = ()=>{
        if (!context.onClickCreateIssue) return;
        context.onClickCreateIssue({
            onIssueCreate: onIssueCreate
        });
    };
    const handleCopy = (0, $5uXOq.useCallback)(async ()=>{
        try {
            await globalThis.navigator.clipboard.writeText(`${context.fullIssueUrl}?focusedCommentId=${context.commentId}`);
            setTooltipMessage((0, $jEjVx.default).linkCopied);
            setTimeout(()=>{
                setTooltipMessage((0, $jEjVx.default).copyLink);
                setIsCommentMoreActionMenuOpen(false);
            }, 800);
            (0, $8zOmE.fireUIAnalytics)(context.createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'meatballMenuCopyLinkButton');
        } catch (e) {
        // show error flag.
        }
    }, [
        context
    ]);
    const handleOpenChange = (0, $5uXOq.useCallback)(({ event: event })=>{
        // workaround as we don't have callback when clicking outside the dropdown menu
        if (event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null) setIsCommentMoreActionMenuOpen(false);
    }, []);
    if (context.isDeleted || context.isOptimistic || context.isEditing) return [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        key: "actions",
        testId: `issue-comment-base.ui.comment.custom-comment.${context.commentId}.comment-actions`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "start",
        shouldWrap: true
    }, context.canAdd && context.isThreadedCommentsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        key: "reply"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jEjVx.default).reply)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        onClick: ()=>onReplyClick(),
        xcss: $87ae9b06fc0d8922$var$commentActionButtonStyles,
        testId: "issue-comment-base.ui.comment.custom-comment.reply-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7O2cr))), {
        label: formatMessage((0, $jEjVx.default).reply)
    })))), context.showReactions && (0, $6s1PB.expVal)('thor_surface_reaction_comment_experiment', 'isSurfaceReactionsEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RUbE.default), null) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, context.canEdit && ((0, $7p8Xy.isJsmLoomExperimentEnabled)().enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: { isSiteAdmin: isSiteAdmin } })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: context.isThirdPartySyncOn && (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') ? formatMessage((0, $jEjVx.default).disabledEditTooltip) : formatMessage((0, $jEjVx.default).edit)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            key: "edit",
            xcss: $87ae9b06fc0d8922$var$commentActionButtonStyles,
            onClick: (...args)=>onEditClick(...args, isSiteAdmin),
            testId: "issue-comment-base.ui.comment.edit-tooltip",
            isDisabled: (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') ? context.isThirdPartySyncOn : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))), {
            label: formatMessage((0, $jEjVx.default).edit)
        })), context.hasDraft ? ` (${formatMessage((0, $75neI.default).draftIndicator)})` : '');
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: context.isThirdPartySyncOn && (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') ? formatMessage((0, $jEjVx.default).disabledEditTooltip) : formatMessage((0, $jEjVx.default).edit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        key: "edit",
        onClick: onEditClick,
        xcss: $87ae9b06fc0d8922$var$commentActionButtonStyles,
        testId: "issue-comment-base.ui.comment.custom-comment.edit-tooltip",
        isDisabled: (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') ? context.isThirdPartySyncOn : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))), {
        label: formatMessage((0, $jEjVx.default).edit)
    }), context.hasDraft ? ` (${formatMessage((0, $75neI.default).draftIndicator)})` : '')))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $jEjVx.default).moreActions)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                ...props,
                ref: triggerRef,
                onClick: ()=>{
                    handleDropdownClick('meatballMenuMoreActionsButton');
                },
                xcss: $87ae9b06fc0d8922$var$commentActionButtonStyles,
                testId: "issue-comment-base.ui.comment.custom-comment.more-actions-tooltip"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                label: formatMessage((0, $jEjVx.default).moreActions)
            })));
        },
        shouldRenderToParent: true,
        isOpen: isCommentMoreActionMenuOpen,
        onOpenChange: handleOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: ()=>{
            return formatMessage(tooltipMessage);
        }
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            ...tooltipProps,
            onClick: handleCopy
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center",
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $jEjVx.default).copyLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8w53e))), {
            label: formatMessage((0, $jEjVx.default).copyLink)
        })))), context.canAdd && context.isThreadedCommentsEnabled && context.canCreateWorkItemInComment && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasWorkItemCreate', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>onClickCreateIssueButton()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $jEjVx.default).createWorkItem)), context.canPin && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasPinComment', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdrGw.default), {
        handleDropdownClick: handleDropdownClick
    }), context.canScrollToOriginalCommentFromPinned && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasPinComment', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kFfVd.default), {
        handleDropdownClick: handleDropdownClick
    }), context.canDelete && (context.isThirdPartySyncOn && (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jEjVx.default).disabledDeleteTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: "delete",
        isDisabled: true
    }, formatMessage((0, $jEjVx.default).delete))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JHBt.ModalDropdownItemTrigger), {
        entryPoint: (0, $dHOuF.deleteIssueLinkConfirmationEntryPoint),
        entryPointProps: {
            commentId: context.commentId,
            eventOccurredAt: context.eventOccurredAt,
            jsdIncidentActivityViewHidden: context.jsdIncidentActivityViewHidden,
            hasReplies: context.hasReplies,
            parentId: context.parentId,
            isRealTimeCommentUpdated: context.isRealTimeCommentUpdated
        },
        modalProps: $87ae9b06fc0d8922$var$deleteConfirmModalProps,
        onClick: ()=>{
            handleDropdownClick('meatballMenuDeleteCommentButton');
            (0, $4R6GH.fg)('add-analytics-for-delete-comment-ken-1993') ? onDeleteClick() : undefined;
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $jEjVx.default).delete))), context.canEdit && context.isInternal && context.isIssueOfIncidentsPractice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: "hide",
        onClick: onHideSave
    }, formatMessage(context.jsdIncidentActivityViewHidden ? (0, $jEjVx.default).unhide : (0, $jEjVx.default).hide)))))));
};
const $87ae9b06fc0d8922$var$CommentActionsLegacy = ()=>{
    const context = (0, $5y0Rn.useCommentContext)();
    if (context.isDeleted || context.isOptimistic || context.isEditing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87ae9b06fc0d8922$var$ActionsLayout, null, (0, $6s1PB.expVal)('thor_surface_reaction_comment_experiment', 'isSurfaceReactionsEnabled', false) ? context.showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RUbE.default), {
        key: "reactions"
    }) : undefined, context.canAdd && context.isThreadedCommentsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g4tAu.default), {
        key: "reply"
    }), context.canEdit && !context.hasFloatingMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jtv9z.default), {
        key: "edit"
    }), context.canDelete && !context.hasFloatingMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3K9OL.default), {
        key: "delete"
    }), context.canEdit && context.isInternal && context.isIssueOfIncidentsPractice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1NQYx.default), {
        key: "hide"
    }), (0, $6s1PB.expVal)('thor_surface_reaction_comment_experiment', 'isSurfaceReactionsEnabled', false) ? undefined : context.showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RUbE.default), {
        key: "reactions"
    }));
};
const $87ae9b06fc0d8922$var$ActionsError = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87ae9b06fc0d8922$var$ActionsLayout, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hcmO.default), {
        key: "retry"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Taxc.default), {
        key: "edit"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ue0F.default), {
        key: "cancel"
    }));
const $87ae9b06fc0d8922$var$ActionsLayout = ({ children: children })=>{
    const { commentId: commentId } = (0, $5y0Rn.useCommentContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        testId: `issue-comment-base.ui.comment.custom-comment.${commentId}.comment-actions`,
        alignBlock: "center"
    }, children);
};
const $87ae9b06fc0d8922$var$ActionsComponent = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jira_work_item_comment_action_modernisation', 'isEnabled', false), $87ae9b06fc0d8922$var$CommentActionsModern, $87ae9b06fc0d8922$var$CommentActionsLegacy);
const $87ae9b06fc0d8922$var$CommentActions = ()=>{
    const { isError: isError, isOptimistic: isOptimistic, hasSaveFailed: hasSaveFailed } = (0, $5y0Rn.useCommentContext)();
    if (isOptimistic && !hasSaveFailed) return null;
    if (isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87ae9b06fc0d8922$var$ActionsError, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87ae9b06fc0d8922$var$ActionsComponent, null);
};
var $87ae9b06fc0d8922$export$2e2bcd8739ae039 = $87ae9b06fc0d8922$var$CommentActions;
const $87ae9b06fc0d8922$var$commentActionButtonStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '24px',
    position: 'relative',
    background: 'none',
    borderRadius: 'border.radius',
    marginBottom: 'space.050',
    paddingBlockStart: 'space.025',
    paddingBlockEnd: 'space.025',
    paddingInlineStart: 'space.050',
    paddingInlineEnd: 'space.050',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});

});
parcelRegister("9RUbE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f2d9b4e7f79ad6f$export$2e2bcd8739ae039);
/* CommentReactions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $l8ruj = parcelRequire("l8ruj");

var $kOHWv = parcelRequire("kOHWv");

var $awxly = parcelRequire("awxly");

var $5y0Rn = parcelRequire("5y0Rn");

var $3kevq = parcelRequire("3kevq");
const $3f2d9b4e7f79ad6f$var$CommentReactions = ()=>{
    const { showReactions: showReactions, isHighlighted: isHighlighted, commentId: commentId } = (0, $5y0Rn.useCommentContext)();
    const onCommentInteraction = (0, $3kevq.useCommentInteraction)();
    if (!showReactions) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "issue-comment-base.ui.comment.reactions-container",
        className: (0, $bwpsq.default)([
            "_4t3igktf _1tke1ns9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kOHWv.IssueCommentReactionsBoundary), {
        packageName: "issue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "IssueCommentReactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $awxly.default), {
        commentId: commentId,
        showQuickReactions: (0, $6s1PB.expVal)('thor_surface_reaction_comment_experiment', 'isSurfaceReactionsEnabled', false) && isHighlighted,
        onReactionSuccess: onCommentInteraction
    }))));
};
const $3f2d9b4e7f79ad6f$var$reactionsContainerStyles = null;
var $3f2d9b4e7f79ad6f$export$2e2bcd8739ae039 = $3f2d9b4e7f79ad6f$var$CommentReactions;

});

parcelRegister("g4tAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fe74606e24e1302$export$2e2bcd8739ae039);
/* ReplyAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2kKir = parcelRequire("2kKir");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");

var $3kevq = parcelRequire("3kevq");
const $5fe74606e24e1302$var$ReplyAction = ()=>{
    const { canAdd: canAdd, isThreadedCommentsEnabled: isThreadedCommentsEnabled, isSaving: isSaving } = (0, $5y0Rn.useCommentContext)();
    const onReply = (0, $3kevq.useReply)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!canAdd || !isThreadedCommentsEnabled) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $2kKir.default), {
        isDisabled: isSaving,
        key: "reply",
        onClick: ()=>onReply()
    }, formatMessage((0, $jEjVx.default).reply));
};
var $5fe74606e24e1302$export$2e2bcd8739ae039 = $5fe74606e24e1302$var$ReplyAction;

});

parcelRegister("jtv9z", function(module, exports) {

$parcel$export(module.exports, "default", () => $765094a31a4d0ba1$export$2e2bcd8739ae039);
/* EditAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $2kKir = parcelRequire("2kKir");

var $3bDjY = parcelRequire("3bDjY");

var $7p8Xy = parcelRequire("7p8Xy");

var $9OXo1 = parcelRequire("9OXo1");

var $75neI = parcelRequire("75neI");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");

var $3kevq = parcelRequire("3kevq");
const $765094a31a4d0ba1$var$EditActionComponent = ({ onClick: onClick })=>{
    const { hasDraft: hasDraft, isSaving: isSaving, isThirdPartySyncOn: isThirdPartySyncOn } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (isThirdPartySyncOn && (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jEjVx.default).disabledEditTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
        key: "edit",
        onClick: onClick,
        isDisabled: true
    }, formatMessage((0, $jEjVx.default).edit), hasDraft ? ` (${formatMessage((0, $75neI.default).draftIndicator)})` : '')));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2kKir.default), {
        key: "edit",
        onClick: onClick,
        isDisabled: isSaving
    }, formatMessage((0, $jEjVx.default).edit), hasDraft ? ` (${formatMessage((0, $75neI.default).draftIndicator)})` : ''));
};
const $765094a31a4d0ba1$var$EditAction = ()=>{
    const { canEdit: canEdit, hasFloatingMenu: hasFloatingMenu } = (0, $5y0Rn.useCommentContext)();
    const onEditClick = (0, $3kevq.useEdit)();
    const jsmLoomExperimentEnabled = (0, $5uXOq.useMemo)(()=>(0, $7p8Xy.isJsmLoomExperimentEnabled)(), []);
    if (!canEdit || hasFloatingMenu) return null;
    if (jsmLoomExperimentEnabled.enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: { isSiteAdmin: isSiteAdmin } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($765094a31a4d0ba1$var$EditActionComponent, {
            onClick: (event, analyticsEvent)=>onEditClick(event, analyticsEvent, isSiteAdmin)
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($765094a31a4d0ba1$var$EditActionComponent, {
        onClick: onEditClick
    });
};
var $765094a31a4d0ba1$export$2e2bcd8739ae039 = $765094a31a4d0ba1$var$EditAction;

});

parcelRegister("3K9OL", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f92916d7ccce3d$export$2e2bcd8739ae039);
/* DeleteAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2kKir = parcelRequire("2kKir");

var $3bDjY = parcelRequire("3bDjY");

var $2KAtx = parcelRequire("2KAtx");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $dHOuF = parcelRequire("dHOuF");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");

var $3kevq = parcelRequire("3kevq");
const $16f92916d7ccce3d$var$deleteConfirmModalProps = {
    width: 'small',
    testId: 'issue-comment-base.ui.comment.confirmation-modal.modal-dialog'
};
const $16f92916d7ccce3d$var$DeleteAction = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { hasFloatingMenu: hasFloatingMenu, canDelete: canDelete, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden, commentId: commentId, eventOccurredAt: eventOccurredAt, hasReplies: hasReplies, parentId: parentId, isRealTimeCommentUpdated: isRealTimeCommentUpdated, isThirdPartySyncOn: isThirdPartySyncOn } = (0, $5y0Rn.useCommentContext)();
    const onDeleteClick = (0, $3kevq.useDelete)();
    if (!canDelete || hasFloatingMenu) return null;
    if (isThirdPartySyncOn && (0, $4R6GH.fg)('jira_issue_view_show_slack_sync_info')) return /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: formatMessage((0, $jEjVx.default).disabledDeleteTooltip)
    }, /*#__PURE__*/ $5uXOq.createElement((0, $2kKir.default), {
        key: "delete",
        isDisabled: true
    }, formatMessage((0, $jEjVx.default).delete)));
    return /*#__PURE__*/ $5uXOq.createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $dHOuF.deleteIssueLinkConfirmationEntryPoint),
        entryPointProps: {
            commentId: commentId,
            eventOccurredAt: eventOccurredAt,
            jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden,
            hasReplies: hasReplies,
            parentId: parentId,
            isRealTimeCommentUpdated: isRealTimeCommentUpdated
        },
        modalProps: $16f92916d7ccce3d$var$deleteConfirmModalProps,
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ $5uXOq.createElement((0, $2kKir.default), {
            key: "delete",
            ref: ref,
            ...(0, $4R6GH.fg)('add-analytics-for-delete-comment-ken-1993') && {
                onClick: onDeleteClick
            }
        }, formatMessage((0, $jEjVx.default).delete)));
};
var $16f92916d7ccce3d$export$2e2bcd8739ae039 = $16f92916d7ccce3d$var$DeleteAction;

});

parcelRegister("1NQYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $47207be252218429$export$2e2bcd8739ae039);
/* HideAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $2kKir = parcelRequire("2kKir");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");

var $3kevq = parcelRequire("3kevq");
const $47207be252218429$var$HideAction = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { canEdit: canEdit, isInternal: isInternal, isIssueOfIncidentsPractice: isIssueOfIncidentsPractice, jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden, isSaving: isSaving } = (0, $5y0Rn.useCommentContext)();
    const onHideSave = (0, $3kevq.useHideSave)();
    if (!canEdit || !isInternal || !isIssueOfIncidentsPractice) return null;
    return /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        testId: "issue-comment-base.ui.comment.custom-comment.hide-action"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $2kKir.default), {
        key: "hide",
        onClick: onHideSave,
        isDisabled: isSaving
    }, formatMessage(jsdIncidentActivityViewHidden ? (0, $jEjVx.default).unhide : (0, $jEjVx.default).hide)));
};
var $47207be252218429$export$2e2bcd8739ae039 = $47207be252218429$var$HideAction;

});

parcelRegister("8hcmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $796472f17ba4a687$export$2e2bcd8739ae039);
/* RetryAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2kKir = parcelRequire("2kKir");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");
const $796472f17ba4a687$var$RetryAction = ()=>{
    const { onSaveRetry: onSaveRetry } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $2kKir.default), {
        key: "retry",
        onClick: onSaveRetry
    }, formatMessage((0, $jEjVx.default).retrySave));
};
var $796472f17ba4a687$export$2e2bcd8739ae039 = $796472f17ba4a687$var$RetryAction;

});

parcelRegister("1Taxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c1364138a47d69e$export$2e2bcd8739ae039);
/* ErrorEditAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2kKir = parcelRequire("2kKir");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");
const $9c1364138a47d69e$var$ErrorEditAction = ()=>{
    const { onSaveEdit: onSaveEdit } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $2kKir.default), {
        key: "edit",
        onClick: onSaveEdit
    }, formatMessage((0, $jEjVx.default).edit));
};
var $9c1364138a47d69e$export$2e2bcd8739ae039 = $9c1364138a47d69e$var$ErrorEditAction;

});

parcelRegister("5Ue0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $a19cba9dc8759be5$export$2e2bcd8739ae039);
/* CancelAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2kKir = parcelRequire("2kKir");

var $koVbs = parcelRequire("koVbs");

var $jEjVx = parcelRequire("jEjVx");

var $5y0Rn = parcelRequire("5y0Rn");
const $a19cba9dc8759be5$var$CancelAction = ()=>{
    const { onSaveCancel: onSaveCancel, parentId: parentId } = (0, $5y0Rn.useCommentContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        onSaveCancel(parentId);
    }, [
        onSaveCancel,
        parentId
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $2kKir.default), {
        key: "cancel",
        onClick: handleClick
    }, formatMessage((0, $jEjVx.default).cancelSave));
};
var $a19cba9dc8759be5$export$2e2bcd8739ae039 = $a19cba9dc8759be5$var$CancelAction;

});



parcelRegister("eg1eY", function(module, exports) {

$parcel$export(module.exports, "ThreadedCommentContainer", () => $1074baf37c596957$export$180556f9a4a95e89);
$parcel$export(module.exports, "FloatingMenuContainer", () => $1074baf37c596957$export$c0abbf3d3959cce4);
$parcel$export(module.exports, "OptimisticCommentContainer", () => $1074baf37c596957$export$73ed11154a18bdf2);
$parcel$export(module.exports, "default", () => $1074baf37c596957$export$2e2bcd8739ae039);
/* CommentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $2HbP2 = parcelRequire("2HbP2");

var $4R6GH = parcelRequire("4R6GH");

var $5y0Rn = parcelRequire("5y0Rn");
const $1074baf37c596957$var$ContainerBase = ({ children: children, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur })=>/*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onFocus: onFocus,
        onBlur: onBlur,
        testId: "issue-comment-base.ui.comment.custom-comment.container"
    }, children);
const $1074baf37c596957$export$180556f9a4a95e89 = ({ children: children })=>{
    const { setOptimisticCommentContainer: setOptimisticCommentContainer } = (0, $5y0Rn.useCommentContext)();
    return /*#__PURE__*/ $5uXOq.createElement($1074baf37c596957$var$ContainerBase, null, /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: setOptimisticCommentContainer
    }, children));
};
const $1074baf37c596957$export$c0abbf3d3959cce4 = ({ children: children, permalink: permalink })=>{
    const { setOptimisticCommentContainer: setOptimisticCommentContainer } = (0, $5y0Rn.useCommentContext)();
    return /*#__PURE__*/ $5uXOq.createElement($1074baf37c596957$var$ContainerBase, {
        onMouseOver: (e)=>$1074baf37c596957$var$showPermalink(e, permalink),
        onMouseOut: (e)=>$1074baf37c596957$var$hidePermalink(e, permalink),
        onFocus: (e)=>$1074baf37c596957$var$showPermalink(e, permalink),
        onBlur: (e)=>$1074baf37c596957$var$hidePermalink(e, permalink)
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: setOptimisticCommentContainer
    }, children));
};
const $1074baf37c596957$export$73ed11154a18bdf2 = ({ children: children })=>{
    const { setOptimisticCommentContainer: setOptimisticCommentContainer } = (0, $5y0Rn.useCommentContext)();
    if ((0, $4R6GH.fg)('jira_comment_alignment_fix')) return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $1074baf37c596957$var$optimisticNonThreadedCommentStyles,
        ref: setOptimisticCommentContainer
    }, children);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: setOptimisticCommentContainer
    }, children);
};
const $1074baf37c596957$var$CommentContainer = ({ children: children, permalink: permalink })=>{
    const { setCommentPermalinkContainer: setCommentPermalinkContainer, commentId: commentId } = (0, $5y0Rn.useCommentContext)();
    return /*#__PURE__*/ $5uXOq.createElement($1074baf37c596957$var$ContainerBase, {
        onMouseOver: (e)=>$1074baf37c596957$var$showPermalink(e, permalink),
        onMouseOut: (e)=>$1074baf37c596957$var$hidePermalink(e, permalink),
        onFocus: (e)=>$1074baf37c596957$var$showPermalink(e, permalink),
        onBlur: (e)=>$1074baf37c596957$var$hidePermalink(e, permalink)
    }, /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-testid": `comment-base-item-${commentId}`,
        ref: setCommentPermalinkContainer
    }, /*#__PURE__*/ $5uXOq.createElement((0, $2HbP2.ModalContextProvider), null, children)));
};
var $1074baf37c596957$export$2e2bcd8739ae039 = $1074baf37c596957$var$CommentContainer;
const $1074baf37c596957$var$optimisticNonThreadedCommentStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});
const $1074baf37c596957$var$showPermalink = (e, permalink)=>{
    e.stopPropagation();
    permalink.show();
};
const $1074baf37c596957$var$hidePermalink = (e, permalink)=>{
    e.stopPropagation();
    permalink.hide();
};

});




parcelRegister("7aBQD", function(module, exports) {

$parcel$export(module.exports, "contextIdentifierSelector", () => $d65bfb1c5b6df700$export$e7b98f351757f9e8);
$parcel$export(module.exports, "memoizedContextIdentifierSelector", () => $d65bfb1c5b6df700$export$99bf3c0aef0a8445);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");


var $a1ky2 = parcelRequire("a1ky2");

var $bcoYn = parcelRequire("bcoYn");
const $d65bfb1c5b6df700$var$commentIdSelector = (state, { commentId: commentId })=>commentId || (0, $7a0695d910e98a34$export$c4134c813c47beb0);
const $d65bfb1c5b6df700$var$contextIdentifierSelectorResultFn = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId, containerId, childObjectId)=>({
        objectId: issueId,
        containerId: containerId,
        childObjectId: childObjectId
    }), (...args)=>args.join('_'));
const $d65bfb1c5b6df700$export$e7b98f351757f9e8 = (0, $dGvGJ.createSelector)((0, $a1ky2.issueIdSelector), (0, $bcoYn.projectIdSelector), $d65bfb1c5b6df700$var$commentIdSelector, (issueId, containerId, childObjectId)=>$d65bfb1c5b6df700$var$contextIdentifierSelectorResultFn(issueId, containerId, childObjectId));
// sadly there is no easy way to reuse the list of arguments:
// https://stackoverflow.com/questions/46596235/flow-generic-type-for-function-expression-arrow-functions
const $d65bfb1c5b6df700$var$memoizeContextIdentifierObject = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId, projectId, commentId)=>({
        objectId: String(issueId),
        containerId: String(projectId),
        ...typeof commentId === 'string' && {
            childObjectId: commentId
        }
    }), (issueId, projectId, commentId)=>`${String(issueId)}-${String(projectId)}-${String(commentId)}`);
const $d65bfb1c5b6df700$export$99bf3c0aef0a8445 = (state, commentId)=>{
    const { objectId: objectId, containerId: containerId, childObjectId: childObjectId } = $d65bfb1c5b6df700$export$e7b98f351757f9e8(state, {
        commentId: commentId
    });
    return $d65bfb1c5b6df700$var$memoizeContextIdentifierObject(objectId, containerId, childObjectId);
};

});

parcelRegister("j7n8D", function(module, exports) {

$parcel$export(module.exports, "getDraftKey", () => $c684d4a7ef6eb77b$export$53536c2ff0d5fb3b);
$parcel$export(module.exports, "getFieldNameFromKey", () => $c684d4a7ef6eb77b$export$c357c0c800ae448e);
$parcel$export(module.exports, "createHashKey", () => $c684d4a7ef6eb77b$export$a2b7936fd03903ac);
$parcel$export(module.exports, "createCommentDraftKey", () => $c684d4a7ef6eb77b$export$41174b2245477cc4);

var $fOGZN = parcelRequire("fOGZN");
const $c684d4a7ef6eb77b$export$53536c2ff0d5fb3b = (loggedInAccountId, issueKey, id)=>`${String(loggedInAccountId)}.${issueKey}.${id}`;
const $c684d4a7ef6eb77b$export$c357c0c800ae448e = (key)=>key.split('.')[2];
const $c684d4a7ef6eb77b$export$a2b7936fd03903ac = (draftKey)=>`${draftKey}-previous-hash`;
const $c684d4a7ef6eb77b$export$41174b2245477cc4 = (commentId)=>`${0, $fOGZN.COMMENT}_${commentId}`;

});

parcelRegister("cgobB", function(module, exports) {

$parcel$export(module.exports, "isIssueRemoteDataLoadingCompleteSelector", () => $be3b8f967b233bbe$export$f8309130a0175daf);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");
const $be3b8f967b233bbe$var$issueRemoteDataSelector = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.issueRemoteData);
const $be3b8f967b233bbe$export$f8309130a0175daf = (0, $dGvGJ.createSelector)($be3b8f967b233bbe$var$issueRemoteDataSelector, (issueRemoteData)=>issueRemoteData.isLoadingComplete);
const $be3b8f967b233bbe$export$b4236ef2a16ce1cc = (0, $dGvGJ.createSelector)($be3b8f967b233bbe$var$issueRemoteDataSelector, (issueRemoteData)=>issueRemoteData.isLoading);

});

parcelRegister("zzDIW", function(module, exports) {

$parcel$export(module.exports, "getValueForSharingAsComment", () => $0bc1fee73f9916e6$export$6d3010314bcab531);
$parcel$export(module.exports, "getTimestampForSharingAsComment", () => $0bc1fee73f9916e6$export$8b1df3c94dcc37b3);

var $dGvGJ = parcelRequire("dGvGJ");
const $0bc1fee73f9916e6$var$shareAsCommentSelector = (state)=>state.shareAsComment;
const $0bc1fee73f9916e6$export$6d3010314bcab531 = (0, $dGvGJ.createSelector)($0bc1fee73f9916e6$var$shareAsCommentSelector, (shareAsComment)=>shareAsComment.value);
const $0bc1fee73f9916e6$export$8b1df3c94dcc37b3 = (0, $dGvGJ.createSelector)($0bc1fee73f9916e6$var$shareAsCommentSelector, (shareAsComment)=>shareAsComment.timestamp);

});

parcelRegister("6R7Gx", function(module, exports) {

$parcel$export(module.exports, "hasFetchedConfluenceWhiteboardsSelector", () => $93d5f670cb2e1744$export$55cf5978bfd80007);

var $dGvGJ = parcelRequire("dGvGJ");

var $bcoYn = parcelRequire("bcoYn");
const $93d5f670cb2e1744$export$b82fc34b89513c4f = (0, $dGvGJ.createSelector)((0, $bcoYn.entitiesSelector), (entities)=>entities.confluenceWhiteboards || []);
const $93d5f670cb2e1744$export$55cf5978bfd80007 = (0, $dGvGJ.createSelector)($93d5f670cb2e1744$export$b82fc34b89513c4f, (confluenceWhiteboards)=>confluenceWhiteboards.hasFetchedLinkedWhiteboards);

});


parcelRegister("uTOCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $76dc60ee9bc78514$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");


var $hzt89 = parcelRequire("hzt89");


var $g2C8o = parcelRequire("g2C8o");

var $k1L82 = parcelRequire("k1L82");

var $hchBL = parcelRequire("hchBL");

var $6s1PB = parcelRequire("6s1PB");

var $3AVPf = parcelRequire("3AVPf");

var $2gYDP = parcelRequire("2gYDP");

var $2Mf7e = parcelRequire("2Mf7e");

var $dzJSM = parcelRequire("dzJSM");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$76dc60ee9bc78514$export$2e2bcd8739ae039 = (props)=>{
    const { list: list, loadingStage: loadingStage, canAddComments: canAddComments, selectedSortOrder: selectedSortOrder, rootRelayFragment: rootRelayFragment, hasPrevComments: hasPrevComments, pinnedCommentsIds: pinnedCommentsIds = [] } = props;
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const { isActivityInVerticalSidePanel: isActivityInVerticalSidePanel } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    const onRef = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $acf4ef636a959927$export$6f48b612d5c03f4d), ref);
    }, [
        register
    ]);
    const onCommentActionRef = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $acf4ef636a959927$export$75867eab2abae162), ref);
    }, [
        register
    ]);
    // Note: since the comments feed is only being fetched with orderBy="-created",
    // we can assume hasPrevComments will always represent whether there are
    // OLDER comments to load. With a dynamic orderBy value, we normally cannot
    // make this assumption as orderBy="created" would result in hasPrevComments
    // to be the whether there are NEWER comments more to load.
    const isLatestCommentNotVisible = hasPrevComments;
    if (loadingStage === (0, $g2C8o.LOADING) || loadingStage === (0, $g2C8o.SAVE_COMMENT_LOADING) && isLatestCommentNotVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AVPf.FeedContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gYDP.default), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $acf4ef636a959927$export$6f48b612d5c03f4d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: onRef
    }), " "), !canAddComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $acf4ef636a959927$export$75867eab2abae162)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: onCommentActionRef
    })), canAddComments && selectedSortOrder === (0, $c97bf8752afb1bcb$export$eda5fe8da1abb04c) && !isActivityInVerticalSidePanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzt89.default), {
        rootRelayFragment: rootRelayFragment
    }), pinnedCommentsIds?.length > 0 && (0, $6s1PB.expVal)('work_item_create_from_comment_and_pin_comment', 'hasPinComment', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Mf7e.PinnedComments), {
        pinnedCommentsIds: pinnedCommentsIds
    }), list, list === null && canAddComments && isActivityInVerticalSidePanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzJSM.CommentEmptyState), null) : null, canAddComments && (selectedSortOrder === (0, $c97bf8752afb1bcb$export$e86669f498228fff) || isActivityInVerticalSidePanel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzt89.default), {
        rootRelayFragment: rootRelayFragment
    }));
};

});
parcelRegister("hzt89", function(module, exports) {

$parcel$export(module.exports, "default", () => $4048e80e86f27e08$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $8oe80 = parcelRequire("8oe80");

var $4R6GH = parcelRequire("4R6GH");

var $88XcY = parcelRequire("88XcY");

var $iBYZ7 = parcelRequire("iBYZ7");

var $kLoIs = parcelRequire("kLoIs");


var $g2C8o = parcelRequire("g2C8o");

var $dRLCn = parcelRequire("dRLCn");

var $6IWM9 = parcelRequire("6IWM9");

var $hxqfC = parcelRequire("hxqfC");

var $8dFNe = parcelRequire("8dFNe");

var $a1ky2 = parcelRequire("a1ky2");

var $7Ow8a = parcelRequire("7Ow8a");

var $bcoYn = parcelRequire("bcoYn");

var $hKi22 = parcelRequire("hKi22");

var $j7n8D = parcelRequire("j7n8D");

var $2QmDq = parcelRequire("2QmDq");

var $lssfC = parcelRequire("lssfC");


var $d4MOh = parcelRequire("d4MOh");

var $13dnH = parcelRequire("13dnH");

var $8zOmE = parcelRequire("8zOmE");

var $cSD7y = parcelRequire("cSD7y");

var $9AfTz = parcelRequire("9AfTz");

var $8syFD = parcelRequire("8syFD");

var $hJyCc = parcelRequire("hJyCc");

var $92Zd5 = parcelRequire("92Zd5");
const $4048e80e86f27e08$var$isCannedResponseEnabled = (state)=>{
    const isServiceDesk = (0, $a1ky2.isServiceDeskSelector)(state);
    const isMobile = (0, $a1ky2.isMobileSelector)(state);
    const isAdminOrAgent = (0, $hKi22.canAdministerJiraPermissionsSelector)(state) || (0, $hKi22.canAdministerProjectPermissionsSelector)(state) || (0, $hKi22.canUseServiceDeskAgentFeaturesSelector)(state);
    return isServiceDesk && !isMobile && isAdminOrAgent;
};
const $4048e80e86f27e08$var$isSmartRepliesEnabled = (state)=>{
    if ((0, $4R6GH.fg)('smart_replies_m1_kill_switch')) {
        const projectType = (0, $bcoYn.projectTypeSelector)(state);
        return projectType === 'software' || projectType === 'business';
    }
    return false;
};
const $4048e80e86f27e08$var$isQuickRepliesEnabled = (state)=>{
    if ((0, $4R6GH.fg)('smart_reply_on_issue_updates_events_gate')) {
        const projectType = (0, $bcoYn.projectTypeSelector)(state);
        return projectType === 'software' || projectType === 'business';
    }
    return false;
};
const $4048e80e86f27e08$var$mapStateToProps = (state)=>({
        authorId: (0, $a1ky2.accountIdloggedInUserSelector)(state),
        avatarUrl: (0, $bcoYn.loggedInUserAvatarUrlSelector)(state),
        displayName: (0, $bcoYn.loggedInUserDisplayNameSelector)(state),
        newCommentDraft: (0, $d4MOh.commentEditingOrViewBodyAdfSelector)((0, $7a0695d910e98a34$export$c4134c813c47beb0))(state),
        hasDraft: (0, $13dnH.fieldHasDraftSelector)((0, $j7n8D.createCommentDraftKey)((0, $7a0695d910e98a34$export$c4134c813c47beb0)))(state),
        // We should expand if we have explicitly requested expansion
        // or if we have currently have a draft
        isExpanded: (0, $d4MOh.isAddCommentEditorExpandedSelector)(state) || (0, $d4MOh.commentEditingBodySelector)((0, $7a0695d910e98a34$export$c4134c813c47beb0))(state) != null,
        forceFocus: (0, $d4MOh.addCommentEditorForceFocusSelector)(state),
        isServiceDesk: (0, $a1ky2.isServiceDeskSelector)(state),
        isEditorFocused: (0, $7Ow8a.isRichTextFieldEditingSelector)(state) || (0, $d4MOh.isEditingAnyCommentSelector)(state),
        isLoading: (0, $a1ky2.isServiceDeskSelector)(state) && (0, $d4MOh.isCommentAttachmentInProgressSelector)(state),
        shouldShowCommentVisibilitySelect: (0, $d4MOh.isCommentVisibilityRestrictionSupportedSelector)(state),
        visibility: (0, $d4MOh.commentEditingVisibilitySelector)((0, $7a0695d910e98a34$export$c4134c813c47beb0))(state) || (0, $g2C8o.COMMENT_VISIBILITY_PUBLIC),
        sortOrder: (0, $2QmDq.getSelectedActivitySortOrder)(state),
        eventOccurredAt: (0, $d4MOh.commentEditingEventOccurredAtSelector)((0, $7a0695d910e98a34$export$c4134c813c47beb0))(state) || null,
        isEditingInternal: (0, $d4MOh.isEditingInternalCommentSelector)((0, $7a0695d910e98a34$export$c4134c813c47beb0))(state),
        editSessionContainsAttachmentsUsage: (0, $d4MOh.commentEditSessionContainsAttachmentsUsageSelector)((0, $7a0695d910e98a34$export$c4134c813c47beb0))(state),
        fullIssueUrl: (0, $lssfC.fullIssueUrlSelector)(state),
        isCannedResponseEnabled: $4048e80e86f27e08$var$isCannedResponseEnabled(state),
        isSmartRepliesEnabled: $4048e80e86f27e08$var$isSmartRepliesEnabled(state),
        isQuickRepliesEnabled: $4048e80e86f27e08$var$isQuickRepliesEnabled(state),
        commentSessionId: (0, $d4MOh.commentSessionIdSelector)(state)
    });
const $4048e80e86f27e08$var$mapDispatchToProps = (dispatch)=>({
        onExpand: ()=>dispatch((0, $8dFNe.addCommentFormExpand)()),
        onEdit: (value)=>dispatch((0, $8dFNe.editCommentUpdate)((0, $7a0695d910e98a34$export$c4134c813c47beb0), value)),
        onVisibilityChange: (visibility)=>dispatch((0, $8dFNe.editCommentVisibility)((0, $7a0695d910e98a34$export$c4134c813c47beb0), visibility)),
        onPaste: (pastedContent)=>dispatch((0, $8dFNe.pastedIntoCommentForm)((0, $7a0695d910e98a34$export$c4134c813c47beb0), pastedContent)),
        onBlur: ()=>dispatch((0, $8dFNe.addCommentFormCollapse)()),
        onCancel: ()=>dispatch((0, $8dFNe.addCommentFormCancel)()),
        onEventOccurredAtChange: (eventOccurredAt)=>{
            dispatch((0, $8dFNe.editCommentEventOccurredAt)((0, $7a0695d910e98a34$export$c4134c813c47beb0), eventOccurredAt));
        },
        getOnSave: (eventData, analyticsEvent, commentSessionId)=>dispatch((0, $8dFNe.saveCommentRequest)({
                id: `${(0, $7a0695d910e98a34$export$c4134c813c47beb0)}_${new Date().getTime()}`,
                createdDate: new Date().toISOString(),
                isNewComment: true,
                ...eventData
            }, analyticsEvent, commentSessionId)),
        onCommentInteractionUpdateCommentViewInteractionTimeMarker: ()=>// Update interaction time marker with the current time when user interacted with new comments
            dispatch((0, $8dFNe.updateCommentViewInteractionTimeMarker)(new Date().toISOString()))
    });
const $4048e80e86f27e08$var$editorSecondaryToolbarComponentsFactory = (0, $8QpSo.default)((shouldShowCommentVisibility, visibility, onVisibilityChange, jsmTimelineComponents)=>shouldShowCommentVisibility ? [
        ...jsmTimelineComponents,
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88XcY.default), {
            key: "commentVisibilitySelect",
            initialValue: visibility,
            onChange: onVisibilityChange
        })
    ] : jsmTimelineComponents);
const $4048e80e86f27e08$var$onSaveFactory = (0, $8QpSo.default)((eventOccurredAt, shouldShowCommentVisibilitySelect, visibility, getOnSave, authorId, isIssueOfIncidentsPractice, isUserJSMAgentOrProjectAdmin, isEditingInternal, fullIssueUrl, commentSessionId, editSessionContainsAttachmentsUsage, isRealTimeCommentUpdated, getCannedCommentAnalyticsAttributes)=>(value, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('comments_mentioned_users_analytics')) {
            if (value?.content) {
                const mentions = (0, $hJyCc.findMentionsInAdfContent)(value.content);
                analyticsEvent.update({
                    mentionedUserIds: mentions.map((mention)=>mention.attrs.id)
                });
            }
        }
        eventOccurredAt ? analyticsEvent.update({
            isEventOccurredAtSelected: true
        }) : analyticsEvent.update({
            isEventOccurredAtSelected: false
        });
        if (shouldShowCommentVisibilitySelect) analyticsEvent.update({
            isCommentRestricted: visibility.type !== (0, $b276debff3ef22b6$export$a3863626f98a38c2)
        });
        if ((0, $4R6GH.fg)('thor_send_realtime_attribute')) analyticsEvent.update({
            isRealTimeCommentUpdated: isRealTimeCommentUpdated
        });
        if (getCannedCommentAnalyticsAttributes && (0, $4R6GH.fg)('smart-replies-remove-event-comment-saved')) {
            const { cannedCommentUsed: cannedCommentUsed, cannedCommentExactMatch: cannedCommentExactMatch } = getCannedCommentAnalyticsAttributes(value);
            analyticsEvent.update({
                cannedCommentUsed: cannedCommentUsed,
                cannedCommentExactMatch: cannedCommentExactMatch
            });
        }
        getOnSave({
            authorId: authorId,
            bodyAdf: value,
            bodyHtml: undefined,
            richContent: undefined,
            visibility: visibility,
            ...isIssueOfIncidentsPractice && isUserJSMAgentOrProjectAdmin && isEditingInternal ? {
                eventOccurredAt: eventOccurredAt,
                jsdIncidentActivityViewHidden: false,
                fullIssueUrl: fullIssueUrl,
                triggerIncidentSaveCommentFlag: Boolean(isIssueOfIncidentsPractice && isUserJSMAgentOrProjectAdmin && eventOccurredAt)
            } : {},
            editSessionContainsAttachmentsUsage: editSessionContainsAttachmentsUsage
        }, analyticsEvent, commentSessionId);
    });
const $4048e80e86f27e08$var$onEditorExpandedWithAnalyticsFactory = (0, $8QpSo.default)((onExpand, hasDraft)=>(analyticsEvent)=>{
        onExpand();
        (0, $8zOmE.fireOperationalAnalytics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        analyticsEvent, 'addCommentEditor expanded', {
            hasDraft: hasDraft
        });
    });
const $4048e80e86f27e08$var$jsmTimelineComponentsFactory = (0, $8QpSo.default)((isEditingInternal, statePropsEventOccurredAt, onEventOccurredAtChange)=>isEditingInternal ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iBYZ7.EventOccurredAtSelector), {
            key: "eventOccurredAtSelector",
            initialValue: statePropsEventOccurredAt,
            onChange: (eventOccurredAt)=>{
                onEventOccurredAtChange(eventOccurredAt);
            }
        })
    ] : []);
const $4048e80e86f27e08$var$mergeProps = (stateProps, dispatchProps, ownProps)=>{
    const jsmTimelineComponents = $4048e80e86f27e08$var$jsmTimelineComponentsFactory(stateProps.isEditingInternal, stateProps.eventOccurredAt, dispatchProps.onEventOccurredAtChange);
    const shouldShowCommentVisibility = stateProps.shouldShowCommentVisibilitySelect && stateProps.isEditingInternal;
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        editorSecondaryToolbarComponents: $4048e80e86f27e08$var$editorSecondaryToolbarComponentsFactory(shouldShowCommentVisibility, stateProps.visibility, dispatchProps.onVisibilityChange, jsmTimelineComponents),
        onSave: $4048e80e86f27e08$var$onSaveFactory(stateProps.eventOccurredAt, stateProps.shouldShowCommentVisibilitySelect, stateProps.visibility, dispatchProps.getOnSave, stateProps.authorId, ownProps.isIssueOfIncidentsPractice, ownProps.isUserJSMAgentOrProjectAdmin, stateProps.isEditingInternal, stateProps.fullIssueUrl, stateProps.commentSessionId, stateProps.editSessionContainsAttachmentsUsage, ownProps.isRealTimeCommentUpdated, ownProps.getCannedCommentAnalyticsAttributes),
        onEditorExpandedWithAnalytics: $4048e80e86f27e08$var$onEditorExpandedWithAnalyticsFactory(dispatchProps.onExpand, stateProps.hasDraft)
    };
};
const $4048e80e86f27e08$var$ConnectedAddCommentFormBaseWithoutSmartRepliesAnalytics = (0, $dRLCn.flowWithSafeComponent)((0, $6IWM9.default), (0, $8oe80.default)('issueFields', {
    onSave: 'created',
    onEditorExpandedWithAnalytics: 'commentExpanded'
}), // @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ editorSecondaryToolbarComponents: Element[]; onSave: (value: DocNode, analyticsEvent: UIAnalyticsEvent) => void; onEditorExpandedWithAnalytics: (analyticsEvent: UIAnalyticsEvent) => void; ... 25 more ...; isIssueOfIncidentsPractice?: boolean | undefined; }, { ...; }>' is not assignable to parameter of type 'FlowStep<FC<Omit<{ [K in keyof PropsWithRef<Omit<P, "containerWidth">>]: K extends "onSave" | "onEditorExpandedWithAnalytics" ? (...args: [...Parameters<PropsWithRef<Omit<P, "containerWidth">>[K]>, UIAnalyticsEvent]) => ReturnType<...> : PropsWithRef<...>[K]; }, keyof WithAnalyticsEventsProps>>, ConnectedComponent<....'.
(0, $hxqfC.connect)($4048e80e86f27e08$var$mapStateToProps, $4048e80e86f27e08$var$mapDispatchToProps, $4048e80e86f27e08$var$mergeProps))((0, $92Zd5.AddCommentForm));
const $4048e80e86f27e08$var$ConnectedAddCommentFormBaseWithSmartRepliesAnalytics = (props)=>{
    const { getCannedCommentAnalyticsAttributes: getCannedCommentAnalyticsAttributes } = (0, $8syFD.useCannedCommentAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4048e80e86f27e08$var$ConnectedAddCommentFormBaseWithoutSmartRepliesAnalytics, {
        ...props,
        getCannedCommentAnalyticsAttributes: getCannedCommentAnalyticsAttributes
    });
};
const $4048e80e86f27e08$export$a6ea964337458074 = (0, $cSD7y.componentWithFG)('smart-replies-remove-event-comment-saved', $4048e80e86f27e08$var$ConnectedAddCommentFormBaseWithSmartRepliesAnalytics, $4048e80e86f27e08$var$ConnectedAddCommentFormBaseWithoutSmartRepliesAnalytics);
const $4048e80e86f27e08$var$ConnectedAddCommentFormWithRealtime = (props)=>{
    const [{ isRealTimeCommentUpdated: isRealTimeCommentUpdated }] = (0, $9AfTz.useRealTimeComments)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4048e80e86f27e08$export$a6ea964337458074, {
        ...props,
        isRealTimeCommentUpdated: isRealTimeCommentUpdated
    });
};
const $4048e80e86f27e08$export$e581f83e003b33cb = (0, $cSD7y.componentWithFG)('thor_send_realtime_attribute', $4048e80e86f27e08$var$ConnectedAddCommentFormWithRealtime, $4048e80e86f27e08$export$a6ea964337458074);
const $4048e80e86f27e08$export$f7155506fc77105 = ({ rootRelayFragment: rootRelayFragment })=>{
    const isIssueOfIncidentsPractice = (0, $kLoIs.useIsIssueOfIncidentsPractice)();
    const isUserJSMAgentOrProjectAdmin = (0, $kLoIs.useIsAgentOrProjectAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4048e80e86f27e08$export$e581f83e003b33cb, {
        isIssueOfIncidentsPractice: isIssueOfIncidentsPractice,
        isUserJSMAgentOrProjectAdmin: isUserJSMAgentOrProjectAdmin,
        rootRelayFragment: rootRelayFragment
    });
};
var $4048e80e86f27e08$export$2e2bcd8739ae039 = $4048e80e86f27e08$export$f7155506fc77105;

});
parcelRegister("8syFD", function(module, exports) {

$parcel$export(module.exports, "useCannedCommentAnalyticsAttributes", () => $930f7dc4eeb83fd4$export$92b8e484b7e469d5);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $1PBgo = parcelRequire("1PBgo");

var $90OM1 = parcelRequire("90OM1");

var $fnBG3 = parcelRequire("fnBG3");
const $930f7dc4eeb83fd4$export$92b8e484b7e469d5 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cannedComments = (0, $5uXOq.useMemo)(()=>(0, $1PBgo.CANNED_COMMENTS_KEY).map((key)=>`${key.emoji.text} ${formatMessage((0, $90OM1.default)[key.commentKey])}`.trim()), [
        formatMessage
    ]);
    const getCannedCommentAnalyticsAttributes = (0, $5uXOq.useCallback)((doc)=>{
        // The experiment is already finished, so we don't care firing exposure event here
        const { cannedCommentExactMatch: cannedCommentExactMatch, cannedCommentUsed: cannedCommentUsed } = (0, $6s1PB.expVal)('smart_replies_m1', 'isEnabled', false) ? (0, $fnBG3.isCannedCommentInContent)(doc, cannedComments, createAnalyticsEvent({})) : {
            cannedCommentExactMatch: undefined,
            cannedCommentUsed: undefined
        };
        return {
            cannedCommentUsed: cannedCommentUsed,
            cannedCommentExactMatch: cannedCommentExactMatch
        };
    }, [
        cannedComments,
        createAnalyticsEvent
    ]);
    return {
        getCannedCommentAnalyticsAttributes: getCannedCommentAnalyticsAttributes
    };
};

});
parcelRegister("1PBgo", function(module, exports) {

$parcel$export(module.exports, "CANNED_COMMENTS_KEY", () => $0a422e877869ad68$export$dff3083614283324);
$parcel$export(module.exports, "ASSIGNED_USER_CANNED_COMMENTS_KEY", () => $0a422e877869ad68$export$87c31e4aa331adda);
$parcel$export(module.exports, "CANNED_COMMENTS_TYPE", () => $0a422e877869ad68$export$2776995d104d4a0a);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $0a422e877869ad68$export$2cea7f14750b8c19);
$parcel$export(module.exports, "AI_COMMENTS_FEATURE", () => $0a422e877869ad68$export$bdac1123a4d65ff4);
const $0a422e877869ad68$export$dff3083614283324 = [
    {
        buttonTextKey: 'looksGoodButton',
        commentKey: 'looksGood',
        emoji: {
            shortName: ':tada:',
            text: "\uD83C\uDF89"
        }
    },
    {
        buttonTextKey: 'needHelpButton',
        commentKey: 'needHelp',
        emoji: {
            shortName: ':wave:',
            text: "\uD83D\uDC4B"
        }
    },
    {
        buttonTextKey: 'blockerButton',
        commentKey: 'blocker',
        emoji: {
            shortName: ':no_entry:',
            text: "\u26D4"
        }
    },
    {
        buttonTextKey: 'clarifyButton',
        commentKey: 'clarify',
        emoji: {
            shortName: ':mag:',
            text: "\uD83D\uDD0D"
        }
    },
    {
        buttonTextKey: 'onTrackButton',
        commentKey: 'onTrack',
        emoji: {
            shortName: ':check_mark:',
            text: "\u2705"
        }
    }
];
const $0a422e877869ad68$export$87c31e4aa331adda = [
    {
        buttonTextKey: 'takingALookButton',
        commentKey: 'takingALook',
        emoji: {
            shortName: ':wave:',
            text: "\uD83D\uDC4B"
        }
    },
    {
        buttonTextKey: 'onItButton',
        commentKey: 'onIt',
        emoji: {
            shortName: ':check_mark:',
            text: "\u2705"
        }
    },
    {
        buttonTextKey: 'clarifyButton',
        commentKey: 'clarify',
        emoji: {
            shortName: ':mag:',
            text: "\uD83D\uDD0D"
        }
    }
];
const $0a422e877869ad68$export$2776995d104d4a0a = {
    DEFAULT: 'default',
    ASSIGNED_USER: 'assignedUser'
};
const $0a422e877869ad68$export$2cea7f14750b8c19 = 'jira-canned-comments';
const $0a422e877869ad68$export$bdac1123a4d65ff4 = 'aiSuggestedComments';

});

parcelRegister("90OM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $74e135ce4b08a450$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $74e135ce4b08a450$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    looksGood: {
        "id": "canned-comments.common.looks-good",
        "defaultMessage": "Looks good!"
    },
    needHelp: {
        "id": "canned-comments.common.need-help",
        "defaultMessage": "Need help?"
    },
    blocker: {
        "id": "canned-comments.common.blocker",
        "defaultMessage": "This is blocked "
    },
    clarify: {
        "id": "canned-comments.common.clarify",
        "defaultMessage": "Can you clarify "
    },
    onTrack: {
        "id": "canned-comments.common.on-track",
        "defaultMessage": "This is on track"
    },
    takingALook: {
        "id": "canned-comments.common.taking-a-look",
        "defaultMessage": "Taking a look"
    },
    onIt: {
        "id": "canned-comments.common.on-it",
        "defaultMessage": "I'm on it"
    },
    looksGoodButton: {
        "id": "canned-comments.common.looks-good-button",
        "defaultMessage": "\uD83C\uDF89 Looks good!"
    },
    needHelpButton: {
        "id": "canned-comments.common.need-help-button",
        "defaultMessage": "\uD83D\uDC4B Need help?"
    },
    blockerButton: {
        "id": "canned-comments.common.blocker-button",
        "defaultMessage": "\u26D4 This is blocked..."
    },
    clarifyButton: {
        "id": "canned-comments.common.clarify-button",
        "defaultMessage": "\uD83D\uDD0D Can you clarify...?"
    },
    onTrackButton: {
        "id": "canned-comments.common.on-track-button",
        "defaultMessage": "\u2705 This is on track"
    },
    takingALookButton: {
        "id": "canned-comments.common.taking-a-look-button",
        "defaultMessage": "\uD83D\uDC4B Taking a look"
    },
    onItButton: {
        "id": "canned-comments.common.on-it-button",
        "defaultMessage": "\u2705 I'm on it"
    },
    moreOptions: {
        "id": "canned-comments.common.more-options",
        "defaultMessage": "More options"
    },
    buttonGroupLabel: {
        "id": "canned-comments.common.button-group-label",
        "defaultMessage": "Quick comments"
    }
});

});

parcelRegister("fnBG3", function(module, exports) {

$parcel$export(module.exports, "adfToText", () => $8aae83c0b80fc46e$export$b6c28c4658e402a0);
$parcel$export(module.exports, "isCannedCommentInContent", () => $8aae83c0b80fc46e$export$cbe56300bfcf5636);

var $kOFhM = parcelRequire("kOFhM");

var $12yAL = parcelRequire("12yAL");

var $fLTqo = parcelRequire("fLTqo");

var $8zOmE = parcelRequire("8zOmE");
const $8aae83c0b80fc46e$var$serializer = (0, $fLTqo.default).fromSchema((0, $kOFhM.defaultSchema));
const $8aae83c0b80fc46e$export$b6c28c4658e402a0 = (doc)=>{
    if (doc.content.length < 1) // renderer has a bug where empty adf returns null instead of empty string
    return '';
    const outputText = (0, $12yAL.renderDocument)(doc, $8aae83c0b80fc46e$var$serializer, (0, $kOFhM.defaultSchema)).result;
    if (outputText === null) throw new Error('Unable to convert adf to text');
    return outputText;
};
const $8aae83c0b80fc46e$export$cbe56300bfcf5636 = (doc, cannedComments, analyticsEvent)=>{
    try {
        if (!doc || cannedComments.length === 0) return {
            cannedCommentExactMatch: false,
            cannedCommentUsed: false
        };
        const contentText = $8aae83c0b80fc46e$export$b6c28c4658e402a0(doc);
        const cannedCommentExactMatch = cannedComments.some((canned)=>canned.trim() === contentText.trim());
        if (cannedCommentExactMatch) return {
            cannedCommentExactMatch: cannedCommentExactMatch,
            cannedCommentUsed: true
        };
        return {
            cannedCommentExactMatch: false,
            cannedCommentUsed: cannedComments.some((canned)=>contentText.trim().includes(canned.trim()))
        };
    } catch (e) {
        // In case the function to check throw an error, we should not block the user from using the feature
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'isCannedCommentInContent failed');
        return {
            cannedCommentExactMatch: undefined,
            cannedCommentUsed: undefined
        };
    }
};

});


parcelRegister("hJyCc", function(module, exports) {

$parcel$export(module.exports, "findMentionsInAdfContent", () => $896cbaafc051d809$export$d300fdcf6968c7ca);

var $4Y8b7 = parcelRequire("4Y8b7");

var $5yUQz = parcelRequire("5yUQz");
const $896cbaafc051d809$export$d300fdcf6968c7ca = (elements)=>{
    if (!elements) return [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Y8b7)))((0, (/*@__PURE__*/$parcel$interopDefault($5yUQz)))(elements, (element)=>{
        if (element?.type && element.type === 'mention') return element;
        if (element?.content) return $896cbaafc051d809$export$d300fdcf6968c7ca(element.content);
        return null;
    }));
};

});
parcelRegister("5yUQz", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/** Used as references for various `Number` constants. */ var $40cc395748a0fa81$var$INFINITY = 1 / 0;
/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $40cc395748a0fa81$var$flatMapDeep(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), $40cc395748a0fa81$var$INFINITY);
}
module.exports = $40cc395748a0fa81$var$flatMapDeep;

});


parcelRegister("92Zd5", function(module, exports) {

$parcel$export(module.exports, "AddCommentForm", () => $74cea3d9a65de758$export$3b1e45ae95278b31);

var $bp88J = parcelRequire("bp88J");

var $lMxQ0 = parcelRequire("lMxQ0");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $34ck9 = parcelRequire("34ck9");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $aYAc3 = parcelRequire("aYAc3");

var $dS3PR = parcelRequire("dS3PR");

var $lK0fB = parcelRequire("lK0fB");

var $6bjT9 = parcelRequire("6bjT9");

var $3QDDz = parcelRequire("3QDDz");

var $7rzkj = parcelRequire("7rzkj");

var $Dw8Xs = parcelRequire("Dw8Xs");

var $jpY8v = parcelRequire("jpY8v");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $aWse0 = parcelRequire("aWse0");

var $qymVE = parcelRequire("qymVE");

var $2gCtH = parcelRequire("2gCtH");

var $59Fha = parcelRequire("59Fha");


var $1FeCu = parcelRequire("1FeCu");

var $92wsG = parcelRequire("92wsG");

var $b8JO7 = parcelRequire("b8JO7");

var $dcc5D = parcelRequire("dcc5D");

var $2e4p8 = parcelRequire("2e4p8");

var $fGddq = parcelRequire("fGddq");


var $7p8Xy = parcelRequire("7p8Xy");

var $iixvy = parcelRequire("iixvy");

var $5NH95 = parcelRequire("5NH95");

var $1XJ20 = parcelRequire("1XJ20");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $93Yeu = parcelRequire("93Yeu");

var $fCo6Y = parcelRequire("fCo6Y");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $k1L82 = parcelRequire("k1L82");

var $fKtck = parcelRequire("fKtck");

var $jCKQx = parcelRequire("jCKQx");

var $kCwbc = parcelRequire("kCwbc");

var $9pF5v = parcelRequire("9pF5v");

var $jEJ7g = parcelRequire("jEJ7g");

var $2vSU6 = parcelRequire("2vSU6");

var $3YmID = parcelRequire("3YmID");

var $eMow4 = parcelRequire("eMow4");

var $dOZvO = parcelRequire("dOZvO");

var $gCOpU = parcelRequire("gCOpU");

var $lOVyz = parcelRequire("lOVyz");

var $jprhX = parcelRequire("jprhX");
const $74cea3d9a65de758$export$ae2611ff27e7ff5 = (projectType)=>{
    switch(projectType){
        case 'business':
            return 'JWM';
        case 'software':
            return 'JSW';
        case 'service_desk':
            return 'JSM';
        case 'product_discovery':
            return 'JPD';
        default:
            return null;
    }
};
const $74cea3d9a65de758$var$useIsAIUpsellInEditorFreeEnabled = ()=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const product = $74cea3d9a65de758$export$ae2611ff27e7ff5(projectType);
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const optInStatus = (0, $iixvy.useOptInStatus)(isAiOptInEnabled, product);
    const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled } = (0, $5NH95.useAIUpsellInEditorFree)(optInStatus, product);
    return isAIUpsellInEditorFreeEnabled;
};
const $74cea3d9a65de758$var$useIsAIRepliesEnabled = (isSmartRepliesEnabled)=>{
    const { core: core, software: software } = (0, $k9JTq.useAppEditions)();
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    return isAiOptInEnabled && (core === (0, $ldyPw.PREMIUM_EDITION) || software === (0, $ldyPw.PREMIUM_EDITION)) && isSmartRepliesEnabled;
};
const $74cea3d9a65de758$var$checkIsAIRepliesEnabled = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('ai_smart_replies_gate'), (isSmartRepliesEnabled)=>{
    const isAIRepliesEnabled = $74cea3d9a65de758$var$useIsAIRepliesEnabled(isSmartRepliesEnabled);
    return isAIRepliesEnabled;
}, ()=>{
    return false;
});
const $74cea3d9a65de758$var$STICKY_NAME = 'comment-add';
const $74cea3d9a65de758$var$COMPACT_EDITOR_WIDTH = 550;
const $74cea3d9a65de758$var$FIELD_ID = 'comment-field';
const $74cea3d9a65de758$export$3b1e45ae95278b31 = ({ isServiceDesk: isServiceDesk = false, isLoading: isLoading = false, hasDraft: hasDraft = false, avatarUrl: avatarUrl, displayName: displayName = null, newCommentDraft: newCommentDraft = null, onExpand: onExpand = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSave: onSave = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onEdit: onEdit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onPaste: onPaste = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isExpanded: isExpanded, isEditorFocused: isEditorFocused, editorSecondaryToolbarComponents: editorSecondaryToolbarComponents, sortOrder: sortOrder, onEditorExpandedWithAnalytics: onEditorExpandedWithAnalytics, containerWidth: containerWidth, isCannedResponseEnabled: isCannedResponseEnabled, isSmartRepliesEnabled: isSmartRepliesEnabledState, isQuickRepliesEnabled: isQuickRepliesEnabled, forceFocus: forceFocus, commentSessionId: commentSessionId, rootRelayFragment: rootRelayFragment, onCommentInteractionUpdateCommentViewInteractionTimeMarker: onCommentInteractionUpdateCommentViewInteractionTimeMarker })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const isEmbedMode = (0, $2e4p8.useIsEmbedMode)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const addCommentContainerRef = (0, $5uXOq.useRef)(null);
    const addCommentContainerBlockRef = (0, $5uXOq.useRef)(null);
    const editorContainerRef = (0, $5uXOq.useRef)(null);
    const containerBottomRef = (0, $5uXOq.useRef)(null);
    const containerTopRef = (0, $5uXOq.useRef)(null);
    const editorEndOrStartElementRef = (0, $5uXOq.useRef)(null);
    const overflowNodeRef = (0, $5uXOq.useRef)(null);
    const observerRef = (0, $5uXOq.useRef)(null);
    const mountedRef = (0, $5uXOq.useRef)(false);
    const editorActionsRef = (0, $5uXOq.useRef)(null);
    const [isKeylineVisible, setIsKeylineVisible] = (0, $5uXOq.useState)(false);
    const [shouldHide, setShouldHide] = (0, $5uXOq.useState)(false);
    const [touchingTop, setTouchingTop] = (0, $5uXOq.useState)(false); // is the form touching (or past) the top of the scroll area
    const [previousForceFocus, setPreviousForceFocus] = (0, $5uXOq.useState)(forceFocus);
    const previousIsExpanded = (0, $1XJ20.usePrevious)(isExpanded);
    const previousIsEditorFocused = (0, $1XJ20.usePrevious)(isEditorFocused);
    const isCompact = (0, $dcc5D.useIsCompactMode)();
    const isModal = (0, $2gCtH.useIsModal)();
    const isLayered = isModal || isEmbedMode;
    const { registerSticky: registerSticky, deregisterSticky: deregisterSticky } = (0, $59Fha.useStickyHeaderRegistration)();
    const [signatureCrQueryReference, loadSignatureCrQuery] = (0, $8Uumt.useQueryLoader)((0, $Dw8Xs.SignatureCrFetchComponentQuery));
    const projectAri = (0, $6bjT9.useProjectAri)();
    const [signature, { setSignature: setSignature, resetSignature: resetSignature }] = (0, $lK0fB.useSignature)();
    const { checkAndDisplayMessage: checkAndDisplayMessage } = (0, $jprhX.useMobileSectionMessage)();
    const setEditorContainerRef = (0, $5uXOq.useCallback)((container)=>{
        editorContainerRef.current = container;
    }, []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const isJCS = (0, $jEJ7g.useIsJCSProjectType)(projectType);
    let isSmartRepliesEnabled = isSmartRepliesEnabledState;
    if ((0, $4R6GH.fg)('smart-replies-system-setting')) {
        // eslint-disable-next-line @atlassian/relay/query-restriction, react-hooks/rules-of-hooks
        const jira = (0, $8Uumt.useFragment)((0, $lMxQ0.default), rootRelayFragment?.jira || null);
        isSmartRepliesEnabled = isSmartRepliesEnabled && jira?.isIssueViewSmartRepliesAdminEnabled?.find(({ key: key })=>key === 'jira.smart.replies.admin.is-enabled')?.value !== 'false' && jira?.userPreferences?.isIssueViewSmartRepliesUserEnabled !== false;
    }
    if (isSmartRepliesEnabled && !(0, $4R6GH.fg)('smart-replies-system-setting')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isSmartRepliesPreferenceEnabled: isSmartRepliesPreferenceEnabled } = (0, $1FeCu.useSmartRepliesPreferencesResources)();
        isSmartRepliesEnabled = isSmartRepliesPreferenceEnabled;
    }
    let picture;
    if ((0, $4R6GH.fg)('relay-avatar-iv-llc-comments')) {
        // eslint-disable-next-line @atlassian/relay/query-restriction, react-hooks/rules-of-hooks
        const data = (0, $8Uumt.useFragment)((0, $bp88J.default), rootRelayFragment || null);
        picture = data?.me?.user?.picture;
    }
    const isAIRepliesEnabled = $74cea3d9a65de758$var$checkIsAIRepliesEnabled(isSmartRepliesEnabled);
    const { enableFieldsDropZone: enableFieldsDropZone } = (0, $jCKQx.useIssueDropzoneContext)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'drag',
        actionSubject: $74cea3d9a65de758$var$FIELD_ID,
        actionSubjectId: $74cea3d9a65de758$var$FIELD_ID,
        source: 'drag-and-drop'
    });
    const { onEditorReadyCallback: onEditorReadyCallback, resetDropZoneState: resetDropZoneState } = (0, $kCwbc.useEditorDropzoneCallback)({
        setFieldInEditMode: onEditorExpandedWithAnalytics,
        setFieldInReadMode: onCancel,
        fieldId: $74cea3d9a65de758$var$FIELD_ID,
        isEditing: isExpanded,
        fieldRef: enableFieldsDropZone ? editorContainerRef : null,
        analyticsEvent: analyticsEvent
    });
    const handleOnEditorExpandedWithAnalytics = (0, $5uXOq.useCallback)(()=>{
        onEditorExpandedWithAnalytics();
    }, [
        onEditorExpandedWithAnalytics
    ]);
    const onCancelCallback = (0, $5uXOq.useCallback)(()=>{
        onCancel?.();
        enableFieldsDropZone && resetDropZoneState();
    }, [
        onCancel,
        enableFieldsDropZone,
        resetDropZoneState
    ]);
    const handleOnSave = (0, $5uXOq.useCallback)((value)=>{
        const isValueEmpty = (0, $fCo6Y.isOnlyWhitespaceAdf)(value);
        if (!isValueEmpty) {
            onSave?.(value);
            onCancelCallback();
            if ((0, $4R6GH.fg)('jira_issue_mobile_section_message')) checkAndDisplayMessage();
            isCannedResponseEnabled && signature && (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'signatureCannedResponse inserted');
            if ((projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && (0, $4R6GH.fg)('thor_issue_view_realtime_updates_gate')) onCommentInteractionUpdateCommentViewInteractionTimeMarker();
        }
    }, [
        onSave,
        onCancelCallback,
        isCannedResponseEnabled,
        signature,
        createAnalyticsEvent,
        checkAndDisplayMessage,
        onCommentInteractionUpdateCommentViewInteractionTimeMarker,
        projectType
    ]);
    const prefetchSignatureCr = (0, $5uXOq.useCallback)(()=>{
        !signatureCrQueryReference && loadSignatureCrQuery({
            projectAri: projectAri
        });
    }, [
        loadSignatureCrQuery,
        projectAri,
        signatureCrQueryReference
    ]);
    const handleOnExpand = (0, $5uXOq.useCallback)(()=>{
        onExpand?.();
    }, [
        onExpand
    ]);
    const setSticky = (0, $5uXOq.useCallback)(()=>{
        if (sortOrder === (0, $c97bf8752afb1bcb$export$e86669f498228fff)) {
            if (overflowNodeRef.current && containerBottomRef.current) {
                const { current: currentOverflowNodeRef } = overflowNodeRef;
                const { current: currentContainerBottomRef } = containerBottomRef;
                const overflowNodeRect = currentOverflowNodeRef.getBoundingClientRect();
                const containerRect = currentContainerBottomRef.getBoundingClientRect(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const overflowNodeBottom = Math.min(overflowNodeRect.bottom, window.innerHeight);
                const isKeylineVisibleNew = !isExpanded && containerRect.bottom >= overflowNodeBottom;
                setIsKeylineVisible(isKeylineVisibleNew);
            }
        } else if (sortOrder === (0, $c97bf8752afb1bcb$export$eda5fe8da1abb04c)) {
            if (overflowNodeRef.current && containerTopRef.current && containerBottomRef.current) {
                const { current: currentOverflowNodeRef } = overflowNodeRef;
                const { current: currentContainerBottomRef } = containerBottomRef;
                const { current: currentContainerTopRef } = containerTopRef;
                const overflowNodeRect = currentOverflowNodeRef.getBoundingClientRect();
                const containerTopRect = currentContainerTopRef.getBoundingClientRect();
                const containerBottomRect = currentContainerBottomRef.getBoundingClientRect(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const overflowNodeBottom = Math.min(overflowNodeRect.bottom, window.innerHeight); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const overflowNodeTop = Math.min(overflowNodeRect.top, window.innerHeight);
                const isKeylineVisibleToTop = !isExpanded && containerTopRect.top <= overflowNodeTop;
                const isKeylineVisibleToBottom = !isExpanded && containerBottomRect.bottom >= overflowNodeBottom;
                const isKeylineVisibleNew = isKeylineVisibleToTop || isKeylineVisibleToBottom;
                setIsKeylineVisible(isKeylineVisibleNew);
            }
        }
    }, [
        isExpanded,
        sortOrder
    ]);
    const throttledSticky = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setSticky, 100), [
        setSticky
    ]);
    const getScrollParent = (0, $5uXOq.useCallback)((node)=>{
        // If we reach the issue app wrapper class we have gone too far, this check is in place to
        // ensure we don't stick to the view port or another scrollable div further up the DOM tree.
        if (!node || node.className === (0, $92wsG.issueAppModalWrapperClassName)) return null;
        if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getComputedStyle(node).overflowY === 'auto' || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getComputedStyle(node).overflowY === 'scroll') return node;
        return getScrollParent(node.parentElement);
    }, []);
    const setOverflowNode = (0, $5uXOq.useCallback)(()=>{
        if (!overflowNodeRef.current) overflowNodeRef.current = getScrollParent(containerBottomRef.current);
        setSticky();
    }, [
        getScrollParent,
        setSticky
    ]);
    const scrollEditorIntoView = (0, $5uXOq.useCallback)(()=>{
        // The purpose of the timeout is to wait until the editor has expanded,
        // so we get the correct height for this calculation.
        setTimeout(()=>{
            (0, $b8JO7.smoothScrollIntoViewIfNeeded)(addCommentContainerRef.current, {
                scrollMode: 'if-needed',
                behavior: 'auto',
                // This takes into account a user who may have turned off scrolling animations at the browser level who may have animation sickness etc.
                block: 'end'
            });
        });
    }, []); /**
           * This sets up an IntersectionObserver to check whether the comment form is outside of the viewport. In that case
           * we need to update the `isKeylineVisible` state to show the keyline above the comment form. There is no other good way to be notified
           * whether an element has entered the 'sticky' position or not.
           *
           * We also use the same IntersectionObserver to monitor when the
           * editor has entered or left the viewport to decide if we should hide the sticky add comment box
           *
           * It is required for cases where the position of the comment box changes independent of resizes, for example when
           * content above the comment form pushes it down below the viewport (for example, when an image has finished loading).
           *
           * This does not work in Safari / IE11, so they won't see the keyline. The comment form will still be sticky however, as
           * that's solved by just CSS (except for IE11).
           */ 
    const setupStickyObserver = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.IntersectionObserver && containerBottomRef.current && containerTopRef.current) {
            const { current: currentContainerBottomRef } = containerBottomRef;
            const { current: currentContainerTopRef } = containerTopRef;
            const handleIntersect = (entries)=>{
                entries.forEach((entry)=>{
                    const isKeylineVisibleNewValue = !isExpanded && !entry.isIntersecting;
                    switch(entry.target){
                        case currentContainerTopRef:
                            if (entry.boundingClientRect && entry.rootBounds && entry.boundingClientRect.top <= entry.rootBounds.top) setTouchingTop(true);
                            else setTouchingTop(false);
                            setIsKeylineVisible(isKeylineVisibleNewValue);
                            break;
                        case editorEndOrStartElementRef.current:
                            {
                                // We are checking boundingClientRect.y to ensure that the editor
                                // is trailing off the bottom of the page, not the top
                                const oldestFirstShouldHide = !entry.rootBounds || !entry.isIntersecting && entry.boundingClientRect.y >= 0 && entry.boundingClientRect.y >= entry.rootBounds.y;
                                const newestFirstShouldHide = !entry.rootBounds || !entry.isIntersecting && entry.boundingClientRect.y <= entry.rootBounds.y;
                                const shouldHideNew = sortOrder === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? oldestFirstShouldHide : newestFirstShouldHide;
                                setShouldHide(shouldHideNew);
                                break;
                            }
                        default:
                            break;
                    }
                });
            };
            const options = {
                root: overflowNodeRef.current,
                rootMargin: '0px',
                threshold: 0
            };
            observerRef.current = new IntersectionObserver(handleIntersect, options);
            const { current: observer } = observerRef;
            observer.observe(currentContainerBottomRef);
            observer.observe(currentContainerTopRef);
        }
    }, [
        isExpanded,
        sortOrder
    ]);
    const setupStickyHidingObserver = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.IntersectionObserver && observerRef.current) setTimeout(()=>{
            // find markers pointing to the Editor's "nearest" edge
            const nodes = overflowNodeRef.current?.getElementsByClassName(sortOrder === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? (0, $92wsG.EDITOR_END_CLASS_NAME) : (0, $92wsG.EDITOR_START_CLASS_NAME)) || []; // expectation is to have two nodes - one is "add-comment-form", and another is the real editor
            // the order depends on the sortOrder
            editorEndOrStartElementRef.current = nodes.length === 2 ? nodes[sortOrder === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? 0 : 1] : // if we have any other number of nodes - consider as undefined behavior and ignore
            null; // FIXME: editorEndOrStartElementRef.current should be stored in State, not in ref
            // that will simplify and unify logic to observe and unobserve
            if (editorEndOrStartElementRef.current && observerRef.current) observerRef.current.observe(editorEndOrStartElementRef.current);
        });
    }, [
        sortOrder
    ]);
    const deferredComponentDidMount = (0, $5uXOq.useCallback)(()=>{
        overflowNodeRef.current = getScrollParent(containerBottomRef.current); // We only want to react to resize and scroll events and ensure stickiness when
        // *NOT* running in IE11. In IE11, sticky simply does not work and by registering
        // these listeners in IE11, we end up sending a lot of errors to Sentry.
        if (!(0, $jpY8v.isIE11)()) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('resize', setOverflowNode);
            if (overflowNodeRef.current) {
                overflowNodeRef.current.addEventListener('scroll', throttledSticky);
                setSticky();
            }
        }
        if (isExpanded) scrollEditorIntoView();
        setupStickyObserver();
        if (isEditorFocused) setupStickyHidingObserver();
    }, [
        getScrollParent,
        isEditorFocused,
        isExpanded,
        scrollEditorIntoView,
        setOverflowNode,
        setSticky,
        throttledSticky,
        setupStickyHidingObserver,
        setupStickyObserver
    ]);
    const removeStickyHidingObserver = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.IntersectionObserver && observerRef.current && editorEndOrStartElementRef.current) observerRef.current.unobserve(editorEndOrStartElementRef.current);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        requestAnimationFrame(()=>deferredComponentDidMount());
        return ()=>{
            if (!(0, $jpY8v.isIE11)()) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.removeEventListener('resize', setOverflowNode);
                if (overflowNodeRef.current) overflowNodeRef.current.removeEventListener('scroll', throttledSticky);
            }
            const { current: currentContainerBottomRef } = containerBottomRef;
            const { current: currentContainerTopRef } = containerTopRef;
            if (observerRef.current && currentContainerBottomRef) observerRef.current.unobserve(currentContainerBottomRef);
            if (observerRef.current && currentContainerTopRef) observerRef.current.unobserve(currentContainerTopRef);
            if (observerRef.current && editorEndOrStartElementRef.current) observerRef.current.unobserve(editorEndOrStartElementRef.current);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            resetSignature();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $5uXOq.useEffect)(()=>{
        if (!mountedRef.current) mountedRef.current = true;
        else {
            if (Boolean(previousIsExpanded) === false && isExpanded) {
                scrollEditorIntoView();
                const jsmLoomExperiment = (0, $7p8Xy.isJsmLoomExperimentEnabled)();
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: 'commentAdd',
                    action: 'started'
                }), {
                    hasDraft: hasDraft,
                    commentSessionId: commentSessionId,
                    isSiteAdmin: isSiteAdmin,
                    ...jsmLoomExperiment?.enabled && {
                        loomJsmAgentExperimentCohort: jsmLoomExperiment?.cohort
                    }
                });
            }
            if (previousIsEditorFocused !== isEditorFocused) {
                if (isEditorFocused) setupStickyHidingObserver();
                else // Since the DOM element we are observing will be removed from the page, we should stop observing
                removeStickyHidingObserver();
            }
        }
    }, [
        isEditorFocused,
        isExpanded,
        previousIsEditorFocused,
        previousIsExpanded,
        removeStickyHidingObserver,
        scrollEditorIntoView,
        setupStickyHidingObserver,
        deregisterSticky,
        createAnalyticsEvent,
        hasDraft,
        commentSessionId,
        isSiteAdmin
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (addCommentContainerBlockRef.current && touchingTop && !shouldHide && !isCompact && sortOrder === (0, $c97bf8752afb1bcb$export$eda5fe8da1abb04c) && !isExpanded) registerSticky($74cea3d9a65de758$var$STICKY_NAME, addCommentContainerBlockRef);
        else deregisterSticky($74cea3d9a65de758$var$STICKY_NAME);
        return ()=>{
            deregisterSticky($74cea3d9a65de758$var$STICKY_NAME);
        };
    }, [
        shouldHide,
        touchingTop,
        isCompact,
        sortOrder,
        isExpanded,
        deregisterSticky,
        registerSticky
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (forceFocus !== previousForceFocus && editorActionsRef?.current) {
            editorActionsRef?.current.focus();
            setPreviousForceFocus(forceFocus);
        }
    }, [
        editorActionsRef,
        forceFocus,
        previousForceFocus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isCannedResponseEnabled && !signatureCrQueryReference && isExpanded) loadSignatureCrQuery && loadSignatureCrQuery({
            projectAri: projectAri
        });
    }, [
        isExpanded,
        isCannedResponseEnabled,
        signatureCrQueryReference,
        loadSignatureCrQuery,
        projectAri
    ]);
    const isHidden = isEditorFocused && shouldHide && !isExpanded; // We need to be able to determine if add comment should stick to the top.
    // Normally it should when sorted NEWEST_FIRST, but we want to avoid this when the issue isCompact
    // to prevent it from blocking the issue actions at the top.
    const shouldApplyTopSticky = sortOrder !== (0, $c97bf8752afb1bcb$export$e86669f498228fff) && !isCompact;
    const setSignatureCRData = (0, $5uXOq.useCallback)((signatureCR)=>{
        setSignature(signatureCR);
    }, [
        setSignature
    ]); // AI Upsell In Editor Experiment
    const isAIUpsellInEditorFreeEnabled = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') && $74cea3d9a65de758$var$useIsAIUpsellInEditorFreeEnabled();
    const addCommentEditor = (0, $5uXOq.useMemo)(()=>{
        const placeholder = hasDraft && !(0, $fCo6Y.isOnlyWhitespaceAdf)(newCommentDraft) ? `\u{2022} ${formatMessage((0, $gCOpU.messages).draftPlaceholder)}` : formatMessage((0, $gCOpU.messages).placeholder);
        const fallback = /*#__PURE__*/ $5uXOq.createElement((0, $3YmID.IssueAddCommentEditorLoading), {
            ...(0, $4R6GH.fg)('smart_replies_m1_kill_switch') && {
                isSmartRepliesEnabled: isSmartRepliesEnabled && !hasDraft
            },
            placeholder: placeholder,
            onExpanded: handleOnEditorExpandedWithAnalytics
        });
        const isEditorCompact = !!containerWidth && containerWidth < $74cea3d9a65de758$var$COMPACT_EDITOR_WIDTH;
        const primaryToolbarComponents = isCannedResponseEnabled ? (editorActions)=>[
                /*#__PURE__*/ $5uXOq.createElement((0, $3QDDz.CannedResponseToolbarButton), {
                    key: "cannedResponseToolbarButton",
                    editorActions: editorActions,
                    isCompact: isEditorCompact
                })
            ] : undefined;
        const commentButtonActions = isCannedResponseEnabled ? {
            onFocus: prefetchSignatureCr,
            onMouseEnter: prefetchSignatureCr
        } : undefined;
        const focusAtStart = !!(isCannedResponseEnabled && !newCommentDraft && signature);
        const addCommentEditorComponent = ({ assistiveLabel: assistiveLabel = '', renderCustomSecondaryToolbar: renderCustomSecondaryToolbar, isLoomJSMBannerEnabled: isLoomJSMBannerEnabled })=>{
            if (isCannedResponseEnabled && signatureCrQueryReference && signature === undefined) return /*#__PURE__*/ $5uXOq.createElement((0, $7rzkj.SignatureCrFetchWrapper), {
                queryReference: signatureCrQueryReference,
                setSignatureCR: setSignatureCRData
            });
            return /*#__PURE__*/ $5uXOq.createElement((0, $3YmID.IssueAddCommentEditorBoundary), {
                packageName: "issue",
                fallback: fallback
            }, /*#__PURE__*/ $5uXOq.createElement((0, $l8ruj.default), {
                name: "IssueAddCommentEditorReadView"
            }, /*#__PURE__*/ $5uXOq.createElement((0, $eMow4.default), {
                externalId: "issue.comment.add-form",
                defaultValue: newCommentDraft || signature || undefined,
                isExpanded: isExpanded,
                shouldFocus: true,
                collapsedPlaceholder: placeholder,
                placeholder: // eslint-disable-next-line no-nested-ternary
                isCannedResponseEnabled ? formatMessage((0, $gCOpU.messages).cannedResponsesPlaceholder) : isAIUpsellInEditorFreeEnabled ? formatMessage((0, $gCOpU.messages).aiUpsellPlaceholder) : formatMessage((0, $gCOpU.messages).easyMentionsPlaceholder),
                onExpanded: handleOnEditorExpandedWithAnalytics,
                onChange: onEdit,
                onSave: handleOnSave,
                onPaste: onPaste,
                onBlur: onBlur,
                onCancel: onCancelCallback,
                onEditorReady: onEditorReadyCallback,
                isLoading: isLoading,
                secondaryToolbarComponents: editorSecondaryToolbarComponents,
                isCannedResponseEnabled: isCannedResponseEnabled,
                ...(0, $4R6GH.fg)('smart_replies_m1_kill_switch') && {
                    isSmartRepliesEnabled: isSmartRepliesEnabled && !hasDraft,
                    isAIRepliesEnabled: isAIRepliesEnabled,
                    hasDraft: hasDraft
                },
                isQuickRepliesEnabled: isQuickRepliesEnabled && !hasDraft,
                isLoomJSMBannerEnabled: isLoomJSMBannerEnabled,
                primaryToolbarComponents: primaryToolbarComponents,
                actionsRef: editorActionsRef,
                ...assistiveLabel && {
                    assistiveLabel: assistiveLabel
                },
                focusAtStart: focusAtStart,
                renderCustomSecondaryToolbar: renderCustomSecondaryToolbar
            })));
        };
        return isServiceDesk || isJCS && (0, $4R6GH.fg)('jcs_project_type_m3') ? /*#__PURE__*/ $5uXOq.createElement((0, $fGddq.default), {
            isExpanded: isExpanded,
            onExpanded: handleOnExpand,
            commentId: (0, $7a0695d910e98a34$export$c4134c813c47beb0),
            commentButtonActions: commentButtonActions
        }, addCommentEditorComponent) : addCommentEditorComponent({
            assistiveLabel: formatMessage((0, $gCOpU.messages).comment)
        });
    }, [
        hasDraft,
        newCommentDraft,
        formatMessage,
        handleOnEditorExpandedWithAnalytics,
        containerWidth,
        isCannedResponseEnabled,
        isExpanded,
        onEdit,
        handleOnSave,
        onPaste,
        onBlur,
        onEditorReadyCallback,
        onCancelCallback,
        isJCS,
        isLoading,
        editorSecondaryToolbarComponents,
        editorActionsRef,
        isServiceDesk,
        handleOnExpand,
        signatureCrQueryReference,
        signature,
        setSignatureCRData,
        prefetchSignatureCr,
        isSmartRepliesEnabled,
        isAIUpsellInEditorFreeEnabled,
        isQuickRepliesEnabled,
        isAIRepliesEnabled
    ]);
    const shortcutKey = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ $5uXOq.createElement((0, $aYAc3.default), null, "M"), []);
    const proTipText = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
            as: "strong",
            color: "color.text.subtle",
            size: "UNSAFE_small"
        }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), (0, $gCOpU.messages).commentShortcutHintHeading)), []);
    const avatarAriaLabel = (0, $5uXOq.useMemo)(()=>displayName !== null && displayName !== '' ? formatMessage((0, $gCOpU.messages).userAvatarAriaLabel, {
            displayName: displayName
        }) : undefined, [
        displayName,
        formatMessage
    ]);
    const commentShortCutHint = (0, $5uXOq.useMemo)(()=>!isExpanded && /*#__PURE__*/ $5uXOq.createElement((0, $dOZvO.default), {
            messageDescriptor: (0, $gCOpU.messages).commentShortcutHintMessage,
            values: {
                shortcutKey: shortcutKey,
                proTipText: proTipText
            }
        }), [
        isExpanded,
        proTipText,
        shortcutKey
    ]);
    const { isActivityInVerticalSidePanel: isActivityInVerticalSidePanel } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    const checkFocusedComment = ()=>{
        const { hasPermalink: hasPermalink } = (0, $fKtck.getPermalinkStatus)((0, $9pF5v.COMMENTS));
        return hasPermalink;
    };
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        ref: addCommentContainerRef
    }, /*#__PURE__*/ $5uXOq.createElement("span", {
        ref: containerTopRef
    }), /*#__PURE__*/ $5uXOq.createElement((0, $lOVyz.StickyWrapper), {
        sortOrder: sortOrder,
        isModal: isLayered,
        isHidden: isHidden,
        isKeylineVisible: (0, $4R6GH.fg)('sticky-editor-iv-llc-comments') ? true : isKeylineVisible,
        shouldApplySticky: !isExpanded,
        shouldApplyTopSticky: shouldApplyTopSticky,
        isCompact: isCompact,
        isActivityInVerticalSidePanel: isActivityInVerticalSidePanel
    }, !isExpanded && isKeylineVisible && (0, $4R6GH.fg)('sticky-editor-iv-llc-comments') && /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_1h6dmuej _189ee4h9 _1dqonqa1 _kqswh2mm _154i1i6y"
        ])
    }), /*#__PURE__*/ $5uXOq.createElement((0, $lOVyz.Wrapper), {
        isModal: isLayered,
        isKeylineVisible: (0, $4R6GH.fg)('sticky-editor-iv-llc-comments') ? false : isKeylineVisible,
        sortOrder: sortOrder,
        shouldApplySticky: !isExpanded,
        shouldApplyTopSticky: shouldApplyTopSticky,
        ref: (container)=>{
            addCommentContainerBlockRef.current = container;
        },
        isActivityInVerticalSidePanel: isActivityInVerticalSidePanel
    }, isActivityInVerticalSidePanel ? null : /*#__PURE__*/ $5uXOq.createElement((0, $lOVyz.AvatarContainer), null, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        size: (0, $dCm1o.isVisualRefreshEnabled)() ? 'small' : 'medium',
        src: (0, $4R6GH.fg)('relay-avatar-iv-llc-comments') ? picture || undefined : avatarUrl || undefined,
        name: avatarAriaLabel
    })), /*#__PURE__*/ $5uXOq.createElement((0, $qymVE.EditorContainer), {
        ref: setEditorContainerRef,
        "data-testid": "issue.activity.comment"
    }, (0, $4R6GH.fg)('thor-experiment-surface-reaction-comment-analytics') ? /*#__PURE__*/ $5uXOq.createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "addCommentEditor"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            isFocusedComment: checkFocusedComment()
        }
    }), addCommentEditor) : /*#__PURE__*/ $5uXOq.createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "addCommentEditor"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $5oFIy.FireScreenAnalytics), null), addCommentEditor), commentShortCutHint)), !isExpanded && isKeylineVisible && shouldApplyTopSticky && (0, $4R6GH.fg)('sticky-editor-iv-llc-comments') && /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_1h6dmuej _189ee4h9 _1dqonqa1 _kqswh2mm _154i1i6y",
            "_kqswh2mm _154ipxbi"
        ])
    })), /*#__PURE__*/ $5uXOq.createElement("span", {
        ref: containerBottomRef
    }));
};
const $74cea3d9a65de758$var$keylineWrapperStyles = null; // This is needed to ensure the keyline is positioned correctly when the comment form is sticky
const $74cea3d9a65de758$var$topPaddingStyles = null;

});
parcelRegister("bp88J", function(module, exports) {

$parcel$export(module.exports, "default", () => $f51d69cd66b1ec4a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4592331fc7092df3eb713eacdd6c82dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f51d69cd66b1ec4a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "view_issueViewActivityComment_Avatar",
    "selections": [
        {
            "concreteType": "AuthenticationContext",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$f51d69cd66b1ec4a$var$node.hash = "bdd5e2829fad1b62130bf1dc3cc2daf2";
var $f51d69cd66b1ec4a$export$2e2bcd8739ae039 = $f51d69cd66b1ec4a$var$node;

});

parcelRegister("lMxQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7203bdb62fef750$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<def8b12f23138eae86e48f0caaf427f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b7203bdb62fef750$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "view_issueViewActivityComment_SmartRepliesSettings",
        "selections": [
            {
                "alias": "isIssueViewSmartRepliesAdminEnabled",
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": "jira.smart.replies.admin.is-enabled"
                    }
                ],
                "concreteType": "JiraApplicationProperty",
                "kind": "LinkedField",
                "name": "applicationPropertiesByKey",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            },
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isIssueViewSmartRepliesUserEnabled"
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$b7203bdb62fef750$var$node.hash = "96fcd798dfb1617a3f782eda391c0af6";
var $b7203bdb62fef750$export$2e2bcd8739ae039 = $b7203bdb62fef750$var$node;

});

parcelRegister("lK0fB", function(module, exports) {

$parcel$export(module.exports, "useSignature", () => $2ca79f0e0fc126da$export$9f441453ff0620ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $94sFW = parcelRequire("94sFW");

var $giiCQ = parcelRequire("giiCQ");
const $2ca79f0e0fc126da$var$initialState = {
    signature: undefined
};
const $2ca79f0e0fc126da$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $2ca79f0e0fc126da$var$initialState,
    actions: $94sFW.actions,
    name: 'CannedResponseCommonStore'
});
const $2ca79f0e0fc126da$export$9f441453ff0620ff = (0, $3sQ5x.createHook)($2ca79f0e0fc126da$export$6f57813fe9f31bf9, {
    selector: (0, $giiCQ.getSignature)
});

});
parcelRegister("94sFW", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f89d78631e277ef7$export$e324594224ef24da);

var $gmefy = parcelRequire("gmefy");
const $f89d78631e277ef7$export$e324594224ef24da = {
    setSignature: $gmefy.setSignature,
    resetSignature: $gmefy.resetSignature
};

});
parcelRegister("gmefy", function(module, exports) {

$parcel$export(module.exports, "setSignature", () => $6c0678cbade7d4d4$export$db61683581bf65b7);
$parcel$export(module.exports, "resetSignature", () => $6c0678cbade7d4d4$export$2dca26ca8969a3aa);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $6c0678cbade7d4d4$export$db61683581bf65b7 = (cannedResponseContent)=>async ({ getState: getState, setState: setState })=>{
        const formattedContent = cannedResponseContent && JSON.parse(cannedResponseContent);
        setState({
            ...getState(),
            signature: formattedContent || null
        });
    };
const $6c0678cbade7d4d4$export$2dca26ca8969a3aa = ()=>async ({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            signature: undefined
        });
    };

});


parcelRegister("giiCQ", function(module, exports) {

$parcel$export(module.exports, "getSignature", () => $59033f86fcf9cde5$export$2f768fec5d73d91a);
const $59033f86fcf9cde5$export$2f768fec5d73d91a = (state)=>state.signature;

});


parcelRegister("3QDDz", function(module, exports) {

$parcel$export(module.exports, "CannedResponseToolbarButton", () => $bcf7c9d3635fe71a$export$4f454379b367e814);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $h49qW = parcelRequire("h49qW");

var $3bDjY = parcelRequire("3bDjY");

var $cGegS = parcelRequire("cGegS");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $31xWV = parcelRequire("31xWV");

var $arxFa = parcelRequire("arxFa");
const $bcf7c9d3635fe71a$export$4f454379b367e814 = ({ editorActions: editorActions, isCompact: isCompact = false })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage, locale: locale } = (0, $koVbs.default)();
    const [content, setContent] = (0, $5uXOq.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [issueViewData, setIssueViewData] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        // need to make sure that dropdown is closed before inserting extension node to manage cursor position
        if (!isOpen && content && issueViewData) (0, $cGegS.insertCannedResponseInEditor)(content, issueViewData, editorActions);
        else if (!isOpen && !content) (0, $cGegS.focusEditor)(editorActions);
    }, [
        isOpen,
        content,
        editorActions,
        issueViewData
    ]);
    const openModal = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'cannedResponsesButton clicked');
        setContent(null);
        setIsOpen(true);
    }, [
        createAnalyticsEvent
    ]);
    const closeModal = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const onInsert = (cannedResponseContent, templateVariableData)=>{
        setIsOpen(false);
        setContent(cannedResponseContent);
        setIssueViewData(templateVariableData);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $arxFa.default).cannedResponseToolbarButton),
        testId: "canned-response-extension.ui.canned-response-toolbar-button.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: openModal,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h49qW))), {
            label: formatMessage((0, $arxFa.default).cannedResponseToolbarButton),
            LEGACY_size: "medium",
            spacing: "spacious"
        })
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: openModal,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h49qW))), {
            label: "",
            LEGACY_size: "medium"
        })
    }, formatMessage((0, $arxFa.default).cannedResponseToolbarButton)), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31xWV.default), {
        isOpen: isOpen,
        onClose: closeModal,
        intlLocale: locale,
        onInsert: onInsert
    }));
};
var $bcf7c9d3635fe71a$export$2e2bcd8739ae039 = $bcf7c9d3635fe71a$export$4f454379b367e814;

});
parcelRegister("h49qW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c17f81d56eb3fac7430f9eb7cb829a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6ca20ac29958548$var$_react = $c6ca20ac29958548$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c6ca20ac29958548$var$_commentAdd = $c6ca20ac29958548$var$_interopRequireDefault((parcelRequire("8bAlB")));

var $c6ca20ac29958548$var$_addComment = $c6ca20ac29958548$var$_interopRequireDefault((parcelRequire("2vHGA")));
function $c6ca20ac29958548$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommentAddIcon.
 * This component is CommentAddIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesAddCommentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a comment to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6ca20ac29958548$var$CommentAddIcon = (props)=>/*#__PURE__*/ $c6ca20ac29958548$var$_react.default.createElement($c6ca20ac29958548$var$_commentAdd.default, Object.assign({
        LEGACY_fallbackIcon: $c6ca20ac29958548$var$_addComment.default
    }, props));
$c6ca20ac29958548$var$CommentAddIcon.Name = 'CommentAddIconMigration';
var $c6ca20ac29958548$var$_default = module.exports.default = $c6ca20ac29958548$var$CommentAddIcon;

});
parcelRegister("8bAlB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb2d0be06a266417135359c5b1e35598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f5b8ba5b1e437da$var$_react = $5f5b8ba5b1e437da$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5f5b8ba5b1e437da$var$_baseNew = $5f5b8ba5b1e437da$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5f5b8ba5b1e437da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CommentAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a comment to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f5b8ba5b1e437da$var$CommentAddIcon = (props)=>/*#__PURE__*/ $5f5b8ba5b1e437da$var$_react.default.createElement($5f5b8ba5b1e437da$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM7.25 6.5V4.25h1.5V6.5H11V8H8.75v2.25h-1.5V8H5V6.5z" clip-rule="evenodd"/>`
    }, props));
$5f5b8ba5b1e437da$var$CommentAddIcon.displayName = 'CommentAddIcon';
var $5f5b8ba5b1e437da$var$_default = module.exports.default = $5f5b8ba5b1e437da$var$CommentAddIcon;

});

parcelRegister("2vHGA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d405d1c3ef9abf7$var$_react = $1d405d1c3ef9abf7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1d405d1c3ef9abf7$var$_commentAdd = $1d405d1c3ef9abf7$var$_interopRequireDefault((parcelRequire("8bAlB")));
function $1d405d1c3ef9abf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1d405d1c3ef9abf7$var$MediaServicesAddCommentIcon = (props)=>/*#__PURE__*/ $1d405d1c3ef9abf7$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14 4.187A10.7 10.7 0 0 0 12 4c-4.963 0-9 3.37-9 7.513s4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716v-.002s-1.563-2.26-.766-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513a6 6 0 0 0-.02-.513h-2.008q.03.254.03.513c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51S8.139 6.003 12 6.003c.695 0 1.366.08 2 .229z"/><rect width="2" height="6" x="17" y="4" rx="1"/><rect width="6" height="2" x="15" y="6" rx="1"/></g></svg>`
    }, props, {
        newIcon: $1d405d1c3ef9abf7$var$_commentAdd.default
    }));
$1d405d1c3ef9abf7$var$MediaServicesAddCommentIcon.displayName = 'MediaServicesAddCommentIcon';
var $1d405d1c3ef9abf7$var$_default = module.exports.default = $1d405d1c3ef9abf7$var$MediaServicesAddCommentIcon;

});


parcelRegister("cGegS", function(module, exports) {

$parcel$export(module.exports, "insertADFNodesInEditor", () => $11d5266517fbb09b$export$256652f71aefa6b0);
$parcel$export(module.exports, "insertCannedResponseInEditor", () => $11d5266517fbb09b$export$ce7efcf9a240236b);
$parcel$export(module.exports, "focusEditor", () => $11d5266517fbb09b$export$dae10379fc585a50);
$parcel$export(module.exports, "hasTemplateVariables", () => $11d5266517fbb09b$export$b7761960cfe1604);

var $lmhF9 = parcelRequire("lmhF9");
var $l1C1k = parcelRequire("l1C1k");

var $594Yf = parcelRequire("594Yf");

var $jcw0u = parcelRequire("jcw0u");


var $3jhoZ = parcelRequire("3jhoZ");
const $11d5266517fbb09b$var$DOC_TYPE = 'doc';
const $11d5266517fbb09b$var$PARAGRAPH_NODE_TYPE = 'paragraph';
const $11d5266517fbb09b$export$9b537081e5efeb02 = (document)=>{
    if (document && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.type === $11d5266517fbb09b$var$DOC_TYPE && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    Array.isArray(document.content) && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.content.length && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.content[0].type === $11d5266517fbb09b$var$PARAGRAPH_NODE_TYPE) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const firstNodeContent = document.content[0].content;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const contentWithoutFirstParagraph = document.content.slice(1);
        if (Array.isArray(firstNodeContent) && Array.isArray(contentWithoutFirstParagraph)) {
            const newContent = Array.isArray(firstNodeContent) && Array.isArray(contentWithoutFirstParagraph) ? [
                ...firstNodeContent,
                ...contentWithoutFirstParagraph
            ] : [];
            const formattedDocument = {
                ...document,
                content: newContent
            };
            return formattedDocument;
        }
    }
    return document;
};
const $11d5266517fbb09b$export$d9a4e0037b7dfe53 = (document, issueData)=>{
    const updatedDoc = (0, $l1C1k.traverse)(document, {
        inlineExtension: (extNode)=>{
            if (extNode.attrs) {
                const { extensionKey: extensionKey, text: text, parameters: parameters } = extNode.attrs;
                if (extensionKey === (0, $a8fcc916b468fdf1$export$42c498377b6a6569)) {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    if (!issueData[text]) return false;
                    switch(parameters?.type){
                        case (0, $3jhoZ.ADFNode).INLINE_CARD:
                            return {
                                type: 'inlineCard',
                                attrs: {
                                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                    url: issueData[text]
                                }
                            };
                        case (0, $3jhoZ.ADFNode).TEXT:
                            return {
                                type: 'text',
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                text: issueData[text]
                            };
                        default:
                            return {
                                type: 'text',
                                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                                text: issueData[text]
                            };
                    }
                }
            }
            return extNode;
        }
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return updatedDoc;
};
const $11d5266517fbb09b$export$256652f71aefa6b0 = (doc, editorActions)=>{
    if (editorActions) {
        const editorView = editorActions._privateGetEditorView();
        if (editorView) try {
            editorView.focus();
            const { selection: selection, schema: schema, tr: tr } = editorView.state || {};
            const { from: from, to: to } = selection;
            const formattedDoc = $11d5266517fbb09b$export$9b537081e5efeb02(doc);
            const cannedResponseNodes = schema.nodeFromJSON(formattedDoc);
            const replacementTextLength = cannedResponseNodes.content.size ? from + cannedResponseNodes.content.size : from + 1;
            const emptyPara = schema.nodeFromJSON({
                type: 'text',
                text: ' '
            });
            editorView.dispatch(tr.replaceRangeWith(from, to, cannedResponseNodes));
            (0, $594Yf.setTextSelection)(editorView, replacementTextLength);
            editorView.dispatch(editorView.state.tr.insert(replacementTextLength, emptyPara).scrollIntoView());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'insertADFNodesInEditor'
                }
            });
        }
    }
};
const $11d5266517fbb09b$export$ce7efcf9a240236b = (doc, issueData, editorActions)=>{
    const replacedContent = $11d5266517fbb09b$export$d9a4e0037b7dfe53(doc, issueData);
    if (replacedContent) $11d5266517fbb09b$export$256652f71aefa6b0(replacedContent, editorActions);
};
const $11d5266517fbb09b$export$dae10379fc585a50 = (editorActions)=>{
    if (editorActions) {
        const editorView = editorActions._privateGetEditorView();
        if (editorView) {
            editorView.focus();
            const { selection: selection } = editorView.state || {};
            const { from: from } = selection;
            (0, $594Yf.setTextSelection)(editorView, from);
        }
    }
};
const $11d5266517fbb09b$export$b7761960cfe1604 = (document)=>{
    const links = (0, $lmhF9.filter)(document, (node)=>!!(node.type === 'inlineExtension' && node.attrs?.extensionKey === (0, $a8fcc916b468fdf1$export$42c498377b6a6569)));
    return !!links.length;
};

});
parcelRegister("594Yf", function(module, exports) {

$parcel$export(module.exports, "isEmptyParagraph", () => $91477cc465a54c49$export$b648602b09795358);
$parcel$export(module.exports, "stepHasSlice", () => $91477cc465a54c49$export$53780b185b887309);
$parcel$export(module.exports, "stepAddsOneOf", () => $91477cc465a54c49$export$f4d51ccab05f55c9);
$parcel$export(module.exports, "extractSliceFromStep", () => $91477cc465a54c49$export$d0a9dfe2556a9577);
$parcel$export(module.exports, "isTextSelection", () => $91477cc465a54c49$export$38b50bf35e79aaf3);
$parcel$export(module.exports, "isElementInTableCell", () => $91477cc465a54c49$export$5588122b9eea7733);
$parcel$export(module.exports, "isLastItemMediaGroup", () => $91477cc465a54c49$export$142c0ee6457f50d6);
$parcel$export(module.exports, "setNodeSelection", () => $91477cc465a54c49$export$a367515ca2c9ace1);
$parcel$export(module.exports, "setTextSelection", () => $91477cc465a54c49$export$1df6d14df6b0b758);
$parcel$export(module.exports, "nonNullable", () => $91477cc465a54c49$export$26128561c93f5847);
$parcel$export(module.exports, "isValidPosition", () => $91477cc465a54c49$export$de0495c7bd37bf4e);
$parcel$export(module.exports, "isInLayoutColumn", () => $91477cc465a54c49$export$2de06a6e688827fd);
$parcel$export(module.exports, "filterChildrenBetween", () => $91477cc465a54c49$export$e46323d96cf32194);
$parcel$export(module.exports, "removeBlockMarks", () => $91477cc465a54c49$export$fba8af3b998832b9);

var $gZGBX = parcelRequire("gZGBX");

var $eS2Dn = parcelRequire("eS2Dn");

var $5r0mK = parcelRequire("5r0mK");

var $hFEwm = parcelRequire("hFEwm");

var $VSDnB = parcelRequire("VSDnB");

var $eQcNy = parcelRequire("eQcNy");
function $91477cc465a54c49$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $91477cc465a54c49$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $91477cc465a54c49$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$91477cc465a54c49$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $91477cc465a54c49$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $eS2Dn.ReplaceStep)) && !(step instanceof (0, $eS2Dn.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $91477cc465a54c49$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $gZGBX.TextSelection);
const $91477cc465a54c49$export$5588122b9eea7733 = (element)=>{
    if ((0, $VSDnB.fg)('platform_editor_nested_tables_column_drag_fix')) return (0, $eQcNy.closest)(element, 'td, th');
    else return (0, $eQcNy.closest)(element, 'td') || (0, $eQcNy.closest)(element, 'th');
};
const $91477cc465a54c49$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $91477cc465a54c49$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $gZGBX.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $91477cc465a54c49$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $gZGBX.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $91477cc465a54c49$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $gZGBX.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $91477cc465a54c49$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(state.tr.setSelection((0, $hFEwm.CellSelection).create(state.doc, anchor, head)));
}
function $91477cc465a54c49$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $91477cc465a54c49$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $91477cc465a54c49$export$2de06a6e688827fd = (state)=>{
    return (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $91477cc465a54c49$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $91477cc465a54c49$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($91477cc465a54c49$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $91477cc465a54c49$var$not = (fn)=>(arg)=>!fn(arg);

});

const $a8fcc916b468fdf1$export$64c9f49c3b5c86e4 = 'com.atlassian.template.extensions';
const $a8fcc916b468fdf1$export$42c498377b6a6569 = 'template-variable';

parcelRegister("3jhoZ", function(module, exports) {

$parcel$export(module.exports, "ADFNode", () => $22e1d68a163a608e$export$926dcd1d4040971c);
const $22e1d68a163a608e$export$926dcd1d4040971c = {
    TEXT: 'text',
    INLINE_CARD: 'inlineCard'
};

});


parcelRegister("31xWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a8e62820428133$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c0a8e62820428133$var$CannedResponseModalDI = (0, $kxZPA.lazy)(()=>(parcelRequire("hsJ9W")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/canned-response-issue-view-modal/src/ui/canned-response-modal/index.tsx"
});
const $c0a8e62820428133$var$CannedResponseLazyLoadedModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "canned-response-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c0a8e62820428133$var$CannedResponseModalDI, props));
var $c0a8e62820428133$export$2e2bcd8739ae039 = $c0a8e62820428133$var$CannedResponseLazyLoadedModal;

});
parcelRegister("hsJ9W", function(module, exports) {

let $cb6814ebe0dc0b95$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cb6814ebe0dc0b95$var$load("ffQaD"),
    $cb6814ebe0dc0b95$var$load("kvRbA"),
    $cb6814ebe0dc0b95$var$load("hsahp")
]).then(()=>parcelRequire('hGBZl'));

});


parcelRegister("arxFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $112ac35552878493$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $112ac35552878493$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cannedResponseToolbarButton: {
        "id": "canned-response-extension.canned-response-toolbar-button.canned-response-toolbar-button",
        "defaultMessage": "Canned responses"
    }
});

});


parcelRegister("7rzkj", function(module, exports) {

$parcel$export(module.exports, "SignatureCrFetchWrapper", () => $c3fc497c1a52ad78$export$bea744a379644504);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $Dw8Xs = parcelRequire("Dw8Xs");
const $c3fc497c1a52ad78$export$d57b6b390e78d90f = 'jsm-nebula';
const $c3fc497c1a52ad78$export$b8b9d90f9e5bd72b = 'cannedResponses';
const $c3fc497c1a52ad78$export$f190c2faae0c1cf7 = 'cannedResponsesissueView';
const $c3fc497c1a52ad78$export$bea744a379644504 = ({ queryReference: queryReference, setSignatureCR: setSignatureCR })=>{
    const onError = ()=>{
        setSignatureCR(null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        teamName: $c3fc497c1a52ad78$export$d57b6b390e78d90f,
        packageName: $c3fc497c1a52ad78$export$b8b9d90f9e5bd72b,
        id: $c3fc497c1a52ad78$export$f190c2faae0c1cf7,
        onError: onError,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "canned-response-container",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Dw8Xs.SignatureCrFetchComponent), {
        queryReference: queryReference,
        setSignatureCR: setSignatureCR
    })));
};

});
parcelRegister("Dw8Xs", function(module, exports) {

$parcel$export(module.exports, "SignatureCrFetchComponentQuery", () => $8ba7e6076778f5a0$export$6fe9308419c4febd);
$parcel$export(module.exports, "SignatureCrFetchComponent", () => $8ba7e6076778f5a0$export$19be9b5934b96dee);

var $fqGjA = parcelRequire("fqGjA");

var $5uXOq = parcelRequire("5uXOq");

var $5389t = parcelRequire("5389t");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $8ba7e6076778f5a0$export$6fe9308419c4febd = (0, $fqGjA.default);
const $8ba7e6076778f5a0$export$19be9b5934b96dee = ({ queryReference: queryReference, setSignatureCR: setSignatureCR })=>{
    const response = (0, $5389t.usePreloadedQuery)($8ba7e6076778f5a0$export$6fe9308419c4febd, queryReference);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const searchResponse = response?.jiraCannedResponse?.searchCannedResponses;
    const signatureCR = searchResponse?.edges?.map((edge)=>edge.node).filter((node)=>node?.isSignature)[0] || null;
    const content = signatureCR?.content || null;
    (0, $5uXOq.useEffect)(()=>{
        setSignatureCR(content);
        const hasError = searchResponse?.errors?.find((err)=>err.__typename);
        if (hasError) {
            const extensions = searchResponse?.errors?.[0]?.extensions?.[0];
            const errorType = extensions?.errorType || 'FETCH_FAILED';
            const statusCode = extensions?.statusCode || 500;
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchSignatureCannedResponse'
                },
                error: new (0, $jJZqs.default)(statusCode, errorType)
            });
        } else (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchSignatureCannedResponse succeeded');
    }, [
        setSignatureCR,
        content,
        createAnalyticsEvent,
        searchResponse,
        searchResponse?.errors
    ]);
    return null;
};

});
parcelRegister("fqGjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $150daa833081f09c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ed06e7839b00a7c68abc2d769e062d7>>
 * @relayHash df195733ff48b9549a66bccf7f29c881
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e749ba152221f5828b74b11f741abd8463da006e3d2639e3e11631fce9e8fedb
const $150daa833081f09c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "projectAri",
                    "variableName": "projectAri"
                },
                {
                    "kind": "Literal",
                    "name": "scopes",
                    "value": [
                        "PERSONAL"
                    ]
                },
                {
                    "kind": "Literal",
                    "name": "signature",
                    "value": true
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "name": "lastUpdatedAt",
                "order": "DESC"
            }
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "content"
    }, v3 = {
        "kind": "ScalarField",
        "name": "isSignature"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "signatureCrFetchComponentQuery",
            "selections": [
                {
                    "concreteType": "JiraCannedResponseQueryApi",
                    "kind": "LinkedField",
                    "name": "jiraCannedResponse",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCannedResponseConnection",
                            "kind": "LinkedField",
                            "name": "searchCannedResponses",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraCannedResponseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCannedResponse",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "signatureCrFetchComponentQuery",
            "selections": [
                {
                    "concreteType": "JiraCannedResponseQueryApi",
                    "kind": "LinkedField",
                    "name": "jiraCannedResponse",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCannedResponseConnection",
                            "kind": "LinkedField",
                            "name": "searchCannedResponses",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraCannedResponseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraCannedResponse",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e749ba152221f5828b74b11f741abd8463da006e3d2639e3e11631fce9e8fedb",
            "metadata": {},
            "name": "signatureCrFetchComponentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$150daa833081f09c$var$node.hash = "5a9e6b8f5b19a40a8afe8909b7ad42a2";
var $150daa833081f09c$export$2e2bcd8739ae039 = $150daa833081f09c$var$node;

});

parcelRegister("5389t", function(module, exports) {
/**
 * Relay v0.0.0-main-5980a913
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("dA9Ki"));

});
parcelRegister("dA9Ki", function(module, exports) {
'use strict';

var $9YyJ0 = parcelRequire("9YyJ0");

var $a6M7O = parcelRequire("a6M7O");

var $aKraw = parcelRequire("aKraw");
var $9e363276a1c9481c$var$loadQuery = $aKraw.loadQuery;

var $1auXT = parcelRequire("1auXT");

var $GBSe8 = parcelRequire("GBSe8");

var $8fqWB = parcelRequire("8fqWB");

var $eofgg = parcelRequire("eofgg");

var $ITbUa = parcelRequire("ITbUa");

var $667zR = parcelRequire("667zR");

var $jZlQN = parcelRequire("jZlQN");

var $iEtZE = parcelRequire("iEtZE");

var $6FDcO = parcelRequire("6FDcO");

var $kxGyI = parcelRequire("kxGyI");

var $g3TRS = parcelRequire("g3TRS");

var $jLHdt = parcelRequire("jLHdt");

var $jfy4f = parcelRequire("jfy4f");

var $eiowN = parcelRequire("eiowN");
module.exports = {
    ConnectionHandler: $eiowN.ConnectionHandler,
    applyOptimisticMutation: $eiowN.applyOptimisticMutation,
    commitLocalUpdate: $eiowN.commitLocalUpdate,
    commitMutation: $eiowN.commitMutation,
    graphql: $eiowN.graphql,
    readInlineData: $eiowN.readInlineData,
    requestSubscription: $eiowN.requestSubscription,
    EntryPointContainer: $9YyJ0,
    RelayEnvironmentProvider: $GBSe8,
    ProfilerContext: $1auXT,
    fetchQuery: $eiowN.fetchQuery,
    loadQuery: $9e363276a1c9481c$var$loadQuery,
    loadEntryPoint: $a6M7O,
    useFragment: $eofgg,
    useLazyLoadQuery: $ITbUa,
    useEntryPointLoader: $8fqWB,
    useQueryLoader: $6FDcO,
    useMutation: $667zR,
    usePaginationFragment: $jZlQN,
    usePreloadedQuery: $iEtZE,
    useRefetchableFragment: $kxGyI,
    useRelayEnvironment: $g3TRS,
    useSubscribeToInvalidationState: $jLHdt,
    useSubscription: $jfy4f
};

});




parcelRegister("1FeCu", function(module, exports) {

$parcel$export(module.exports, "smartRepliesOptInStatusResources", () => $420bb98aaad6bbf4$export$d9a3116994d66cfc);
$parcel$export(module.exports, "useSmartRepliesPreferencesResources", () => $420bb98aaad6bbf4$export$8d607fdbd07ed6ca);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");

const $420bb98aaad6bbf4$export$d9a3116994d66cfc = (0, $2M1hQ.createResource)({
    type: (0, $258f696a148ea88e$export$ea895d05049da93c),
    getKey: ()=>(0, $258f696a148ea88e$export$92a8ee31fa2d5df3),
    getData: async ()=>{
        let smartRepliesOptInStatus = null;
        try {
            smartRepliesOptInStatus = await (0, $aHuqL.userPreferenceAPI).get((0, $258f696a148ea88e$export$92a8ee31fa2d5df3));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode !== 404) (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $258f696a148ea88e$export$92a8ee31fa2d5df3), (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b), error);
            (0, $jcw0u.default)({
                meta: {
                    id: 'smartRepliesOptInStatusResources',
                    packageName: (0, $258f696a148ea88e$export$b8b9d90f9e5bd72b),
                    teamName: 'jira-warepil'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            smartRepliesOptInStatus: smartRepliesOptInStatus
        };
    },
    maxAge: Number.MAX_VALUE
});
const $420bb98aaad6bbf4$export$8d607fdbd07ed6ca = ()=>{
    const { data: data, refresh: refresh, loading: loading } = (0, $2YP9W.useResource)($420bb98aaad6bbf4$export$d9a3116994d66cfc);
    return {
        isSmartRepliesPreferenceEnabled: data?.smartRepliesOptInStatus?.isEnabled ?? true,
        loading: loading,
        refreshData: refresh
    };
};

});
const $258f696a148ea88e$export$92a8ee31fa2d5df3 = 'jira.user.smart_replies_feature.status';
const $258f696a148ea88e$export$ea895d05049da93c = 'RESOURCE_TYPE_ISSUE_SMART_REPLIES_STATUS';
const $258f696a148ea88e$export$b8b9d90f9e5bd72b = 'jiraIssueSmartRepliesPreferences';


parcelRegister("3YmID", function(module, exports) {

$parcel$export(module.exports, "IssueAddCommentEditorLoading", () => $94927ae430d8d0c2$export$9261a11fead00f43);
$parcel$export(module.exports, "IssueAddCommentEditorBoundary", () => $94927ae430d8d0c2$export$1e708cc6fee59bcf);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $fpU7r = parcelRequire("fpU7r");
const $94927ae430d8d0c2$export$9261a11fead00f43 = (0, $fpU7r.default);
const $94927ae430d8d0c2$export$1e708cc6fee59bcf = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-add-comment-editor",
        packageName: packageName,
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallback)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-add-comment-editor",
        fallback: fallback
    }, children));

});
parcelRegister("fpU7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc96a0098dce53ed$export$2e2bcd8739ae039);

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $a1ky2 = parcelRequire("a1ky2");

var $36hPx = parcelRequire("36hPx");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$bc96a0098dce53ed$export$2e2bcd8739ae039 = (0, $dRLCn.flowWithSafeComponent)((0, $hxqfC.connect)((state)=>({
        isServiceDesk: (0, $a1ky2.isServiceDeskSelector)(state)
    }), {}))((0, $36hPx.FallbackAddCommentEditor));

});
parcelRegister("36hPx", function(module, exports) {

$parcel$export(module.exports, "FallbackAddCommentEditor", () => $624d79f291f921f5$export$23159fb879e88dfb);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $eZJjh = parcelRequire("eZJjh");

var $eXGmE = parcelRequire("eXGmE");

var $6s1PB = parcelRequire("6s1PB");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $624d79f291f921f5$var$ServiceDeskSpinner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $624d79f291f921f5$var$SpinnerSpan = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66",
            __cmplp.className
        ])
    });
});
const $624d79f291f921f5$var$Flex = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _4t3idlk8 _ca0qv77o",
            __cmplp.className
        ])
    });
});
const $624d79f291f921f5$var$Button = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81kw7 _2rko1l7b _189et94y _1dqonqa1 _1h6d1elr _y3gn1e5h _syaz131l _bfhkvuon _1bsb1osq _4t3i1ylp _19bvv47k _u5f3v47k _ca0qutpp _n3tdutpp _vchhusvi",
            __cmplp.className
        ])
    });
});
class $624d79f291f921f5$export$23159fb879e88dfb extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            placeholder: '',
            onExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isSmartRepliesEnabled: false
        };
    }
    static getServiceDeskFallbackEditor() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($624d79f291f921f5$var$ServiceDeskSpinner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "medium"
        }));
    }
    getGeneralFallbackEditor() {
        const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('smart_replies_m1');
        return this.props.isSmartRepliesEnabled && expConfig.get('isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eXGmE.CannedCommentsPlaceHolderSkeleton), {
            onClick: this.onClick,
            shouldShowLoadingStateSpinner: this.state.changed
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($624d79f291f921f5$var$Button, {
            onClick: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($624d79f291f921f5$var$Flex, null, this.props.placeholder, this.state.changed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($624d79f291f921f5$var$SpinnerSpan, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        }))));
    }
    render() {
        const shouldUseServiceDeskCommentEditor = this.props.isServiceDesk;
        return shouldUseServiceDeskCommentEditor ? $624d79f291f921f5$export$23159fb879e88dfb.getServiceDeskFallbackEditor() : this.getGeneralFallbackEditor();
    }
    constructor(...args){
        super(...args), this.state = {
            changed: false
        }, this.onClick = ()=>{
            this.props.onExpanded();
            this.setState({
                changed: true
            });
        };
    }
}

});
parcelRegister("eXGmE", function(module, exports) {

$parcel$export(module.exports, "CannedCommentsPlaceHolderWithClick", () => $4d2b6e4aeab86ae1$export$a05663d141b9ea49);
$parcel$export(module.exports, "CannedCommentsPlaceHolderSkeleton", () => $4d2b6e4aeab86ae1$export$5e1673b0a17a1d59);

var $5uXOq = parcelRequire("5uXOq");

var $7Yll7 = parcelRequire("7Yll7");
const $4d2b6e4aeab86ae1$export$a05663d141b9ea49 = ({ onChange: onChange, onExpanded: onExpanded, collapsedPlaceholder: collapsedPlaceholder })=>{
    const onClickCannedComment = (0, $5uXOq.useCallback)((value)=>{
        onChange && onChange(value);
        onExpanded && onExpanded();
    }, [
        onExpanded,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Yll7.CannedCommentsPlaceholder), {
        placeholder: collapsedPlaceholder,
        onFocus: onExpanded,
        onClick: onExpanded,
        onClickCannedComment: onClickCannedComment
    });
};
const $4d2b6e4aeab86ae1$export$5e1673b0a17a1d59 = ({ onClick: onClick, shouldShowLoadingStateSpinner: shouldShowLoadingStateSpinner })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Yll7.CannedCommentsPlaceholder), {
        onClick: onClick,
        isLoading: true,
        shouldShowLoadingStateSpinner: shouldShowLoadingStateSpinner
    });

});
parcelRegister("7Yll7", function(module, exports) {

$parcel$export(module.exports, "CannedCommentsPlaceholder", () => $1d15ed6b8c166b85$export$db899e3acfc32b31);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $1wbtX = parcelRequire("1wbtX");

var $cSD7y = parcelRequire("cSD7y");

var $1IOYQ = parcelRequire("1IOYQ");

var $2mMSb = parcelRequire("2mMSb");

var $imfiy = parcelRequire("imfiy");
const $1d15ed6b8c166b85$var$NUM_OF_SKELETON_CANNED_COMMENTS = 5;
const $1d15ed6b8c166b85$export$7283f8c738c7870c = ({ placeholder: placeholder, onFocus: onFocus, onClick: onClick, onChange: onChange, commentsType: commentsType, ...restProps })=>restProps.isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1d15ed6b8c166b85$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mMSb.CommentTextAreaPlaceholder), {
        onClick: onClick,
        onChange: onChange,
        placeholder: placeholder,
        isLoading: restProps.isLoading
    }), restProps.shouldShowLoadingStateSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1d15ed6b8c166b85$var$loadingStateSpinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1d15ed6b8c166b85$var$loadingStateCannedCommentsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1d15ed6b8c166b85$var$loadingStateCannedCommentsContainerInnerStyles
    }, Array.from({
        length: $1d15ed6b8c166b85$var$NUM_OF_SKELETON_CANNED_COMMENTS
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            key: index,
            height: "20px",
            width: "80px"
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $1d15ed6b8c166b85$var$containerStyles,
            $1d15ed6b8c166b85$var$hoveredStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imfiy.CannedCommentList), {
        onClickCannedComment: restProps.onClickCannedComment,
        commentsType: commentsType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mMSb.CommentTextAreaPlaceholder), {
        placeholder: placeholder,
        onFocus: onFocus,
        onClick: onClick
    }));
const $1d15ed6b8c166b85$export$3459f7dda8ab6c6c = ({ placeholder: placeholder, onFocus: onFocus, onClick: onClick, onChange: onChange, commentsType: commentsType, isLoading: isLoading, shouldShowLoadingStateSpinner: shouldShowLoadingStateSpinner, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1IOYQ.CannedCommentsPlaceholder), {
        placeholder: placeholder,
        onFocus: onFocus,
        onClick: onClick,
        onChange: onChange,
        ...'onClickCannedComment' in restProps && {
            renderCannedCommentOptions: (onFocusCannedComment)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imfiy.SmartRepliesCannedCommentList), {
                    onClickCannedComment: restProps.onClickCannedComment,
                    onFocusCannedComment: onFocusCannedComment,
                    commentsType: commentsType
                })
        },
        isLoading: isLoading,
        shouldShowLoadingStateSpinner: shouldShowLoadingStateSpinner
    });
const $1d15ed6b8c166b85$export$db899e3acfc32b31 = (0, $cSD7y.componentWithFG)('ai_smart_replies_gate', $1d15ed6b8c166b85$export$3459f7dda8ab6c6c, $1d15ed6b8c166b85$export$7283f8c738c7870c);
const $1d15ed6b8c166b85$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
/**
 * Add css-var to adjust styling between parents and children.
 * hovering the div should make the background color of the textarea and button right and left the same
 * NOTE: if css-var name gets changed, please search for the usage of it within the children.
 *
 * Arguably, another solution is to use react state and event listener (mouseenter and mouseleave)
 * but we will need to wait extra render cycle for css to change.
 */ const $1d15ed6b8c166b85$var$hoveredStyle = (0, $8CUq3.xcss)({
    '--jira-canned-comments-background-color': "var(--ds-background-input, #FFFFFF)",
    ':hover': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        '--jira-canned-comments-background-color': "var(--ds-background-input-hovered, #F7F8F9)"
    }
});
const $1d15ed6b8c166b85$var$loadingStateSpinnerContainerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    right: 'space.250',
    top: 'space.200'
});
const $1d15ed6b8c166b85$var$loadingStateCannedCommentsContainerStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    position: 'absolute',
    bottom: 'space.250',
    left: 'space.250',
    right: 'space.250'
});
const $1d15ed6b8c166b85$var$loadingStateCannedCommentsContainerInnerStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    gap: 'space.100',
    alignItems: 'center'
});

});
parcelRegister("1IOYQ", function(module, exports) {

$parcel$export(module.exports, "CannedCommentsPlaceholder", () => $e17d8363b2de0e6a$export$db899e3acfc32b31);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $1wbtX = parcelRequire("1wbtX");

var $2mMSb = parcelRequire("2mMSb");

var $d5KjK = parcelRequire("d5KjK");
const $e17d8363b2de0e6a$export$db899e3acfc32b31 = ({ placeholder: placeholder, onFocus: onFocus, onClick: onClick, onChange: onChange, renderCannedCommentOptions: renderCannedCommentOptions, isLoading: isLoading, shouldShowLoadingStateSpinner: shouldShowLoadingStateSpinner, numberOfSkeletonCannedComments: numberOfSkeletonCannedComments = 5, hiddenBorder: hiddenBorder })=>isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $e17d8363b2de0e6a$var$containerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mMSb.CommentTextAreaPlaceholder), {
        onClick: onClick,
        onChange: onChange,
        placeholder: placeholder,
        isLoading: true
    }), shouldShowLoadingStateSpinner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e17d8363b2de0e6a$var$loadingStateSpinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e17d8363b2de0e6a$var$loadingStateCannedCommentsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e17d8363b2de0e6a$var$loadingStateCannedCommentsContainerInnerStyles,
        testId: "canned-comments.common.ui.canned-comment-placeholder.loading-state"
    }, Array.from({
        length: numberOfSkeletonCannedComments
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.SkeletonCompiled), {
            key: index,
            height: "20px",
            width: "80px"
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $e17d8363b2de0e6a$var$containerStyles,
            $e17d8363b2de0e6a$var$hoveredStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2mMSb.CommentTextAreaPlaceholder), {
        placeholder: placeholder,
        onFocus: onFocus,
        onClick: onClick,
        hiddenBorder: hiddenBorder
    }), renderCannedCommentOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d5KjK.CannedCommentList), {
        renderCannedCommentOptions: renderCannedCommentOptions
    }));
const $e17d8363b2de0e6a$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    height: '90px'
});
/**
 * Add css-var to adjust styling between parents and children.
 * hovering the div should make the background color of the textarea and button right and left the same
 * NOTE: if css-var name gets changed, please search for the usage of it within the children.
 *
 * Arguably, another solution is to use react state and event listener (mouseenter and mouseleave)
 * but we will need to wait extra render cycle for css to change.
 */ const $e17d8363b2de0e6a$var$hoveredStyle = (0, $8CUq3.xcss)({
    '--jira-canned-comments-background-color': "var(--ds-background-input, #FFFFFF)",
    ':hover': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        '--jira-canned-comments-background-color': "var(--ds-background-input-hovered, #F7F8F9)"
    }
});
const $e17d8363b2de0e6a$var$loadingStateSpinnerContainerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    right: 'space.250',
    top: 'space.200'
});
const $e17d8363b2de0e6a$var$loadingStateCannedCommentsContainerStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    position: 'absolute',
    bottom: 'space.250',
    left: 'space.250',
    right: 'space.250'
});
const $e17d8363b2de0e6a$var$loadingStateCannedCommentsContainerInnerStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    gap: 'space.100',
    alignItems: 'center'
});

});
parcelRegister("2mMSb", function(module, exports) {

$parcel$export(module.exports, "CommentTextAreaPlaceholder", () => $6eb8f7d7cb6c0a3e$export$664c0615c825fe36);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $k1L82 = parcelRequire("k1L82");

var $8bDD4 = parcelRequire("8bDD4");
const $6eb8f7d7cb6c0a3e$export$664c0615c825fe36 = ({ placeholder: placeholder, onClick: onClick, isLoading: isLoading, hiddenBorder: hiddenBorder })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        "data-testid": "canned-comments.common.ui.comment-text-area-placeholder.textarea",
        onClick: onClick,
        "aria-busy": isLoading ? true : undefined,
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c82smr _189et94y _1dqonqa1 _1h6d1elr _r06hglyw _14zgglyw _bfhk1c3t _vchhusvi _4t3il1r9 _19bvv47k _ca0qutpp _n3tdutpp _1bsb1osq _k48pi7a9 _syaz131l _1e0c116y _4cvr1y6m _nt751r31 _49pcglyw _1hvw1o36 _1ygbugt7 _1ah3v77o _4cvx1elr _irr3eisi _d0al1kdv",
            hiddenBorder && "_189eidpf",
            isInDiscussionLayoutExperiment && "_1h6dmuej"
        ])
    }, placeholder || formatMessage((0, $8bDD4.default).defaultPlaceholderMessages));
};
// NOTE: Styling gets copied from platform/packages/editor/editor-core/src/ui/ChromeCollapsed/styles.ts and adjusted to the design
// Except the focus visible state which is new
const $6eb8f7d7cb6c0a3e$var$textAreaStyles = null;
const $6eb8f7d7cb6c0a3e$var$styles = null;
const $6eb8f7d7cb6c0a3e$var$defaultBorderColor = null;

});
parcelRegister("8bDD4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7462071c40dc6a9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b7462071c40dc6a9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultPlaceholderMessages: {
        "id": "jira-canned-comments.comment-text-area-placeholder.default-placeholder-messages",
        "defaultMessage": "Add Comment..."
    }
});

});


parcelRegister("d5KjK", function(module, exports) {

$parcel$export(module.exports, "CannedCommentList", () => $4d8c82a5122ffac9$export$e08e95f6ce58a028);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bpC55 = parcelRequire("bpC55");

var $ks8FD = parcelRequire("ks8FD");

var $42CjB = parcelRequire("42CjB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $9RlWW = parcelRequire("9RlWW");

var $90OM1 = parcelRequire("90OM1");
const $4d8c82a5122ffac9$export$e08e95f6ce58a028 = ({ renderCannedCommentOptions: renderCannedCommentOptions })=>{
    const { setRef: setRef, setCanScrollDebounced: setCanScrollDebounced, shouldHideScrollLeftButton: shouldHideScrollLeftButton, shouldHideScrollRightButton: shouldHideScrollRightButton, scrollToNext: scrollToNext, scrollToPrevious: scrollToPrevious, onFocusCannedComment: onFocusCannedComment } = (0, $9RlWW.useScrollCarousel)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4d8c82a5122ffac9$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $4d8c82a5122ffac9$var$hoverButtonStyle,
            $4d8c82a5122ffac9$var$leftButtonStyle,
            shouldHideScrollLeftButton && $4d8c82a5122ffac9$var$hiddenButtonStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ks8FD))), {
                ...iconProps,
                size: "small"
            }),
        isTooltipDisabled: true,
        label: formatMessage((0, $90OM1.default).moreOptions),
        onClick: scrollToPrevious,
        tabIndex: -1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: setRef,
        onScroll: setCanScrollDebounced,
        role: "group",
        "aria-label": formatMessage((0, $90OM1.default).buttonGroupLabel),
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1bsb1osq _1e0c1txw _1bah1y6m _4cvr1h6o _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _1reo15zi _1fjgglyw _4pckglyw _1cicglyw"
        ])
    }, renderCannedCommentOptions(onFocusCannedComment)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $4d8c82a5122ffac9$var$hoverButtonStyle,
            $4d8c82a5122ffac9$var$rightButtonStyle,
            shouldHideScrollRightButton && $4d8c82a5122ffac9$var$hiddenButtonStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                ...iconProps,
                size: "small"
            }),
        isTooltipDisabled: true,
        label: formatMessage((0, $90OM1.default).moreOptions),
        onClick: scrollToNext,
        tabIndex: -1
    })));
};
const $4d8c82a5122ffac9$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    position: 'absolute',
    bottom: "var(--ds-space-150, 12px)",
    left: "var(--ds-space-150, 12px)",
    right: "var(--ds-space-150, 12px)",
    alignItems: 'center'
});
const $4d8c82a5122ffac9$var$commentsContainerStyle = null;
const $4d8c82a5122ffac9$var$hoverButtonStyle = (0, $8CUq3.xcss)({
    zIndex: 'layer',
    alignItems: 'center',
    position: 'absolute',
    // NOTE: before changing this.
    // see jira/src/packages/jira-canned-comments/src/ui/canned-comments-placeholder/index.tsx:71
    background: `var(--jira-canned-comments-background-color, ${"var(--ds-background-input, #FFFFFF)"})`
});
const $4d8c82a5122ffac9$var$rightButtonStyle = (0, $8CUq3.xcss)({
    right: 'space.0'
});
const $4d8c82a5122ffac9$var$leftButtonStyle = (0, $8CUq3.xcss)({
    left: 'space.0'
});
const $4d8c82a5122ffac9$var$hiddenButtonStyle = (0, $8CUq3.xcss)({
    display: 'none'
});

});
parcelRegister("9RlWW", function(module, exports) {

$parcel$export(module.exports, "useScrollCarousel", () => $9be18fae5bd16fdc$export$87ee6701bd8502a7);

var $5uXOq = parcelRequire("5uXOq");

var $7nRxN = parcelRequire("7nRxN");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $9be18fae5bd16fdc$var$isScrollAtLeft = (elem)=>elem?.scrollLeft === 0;
const $9be18fae5bd16fdc$var$isScrollAtRight = (elem)=>elem ? Math.abs(elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth) <= 1 : false;
const $9be18fae5bd16fdc$var$getScrollSize = (visibleItems)=>visibleItems.reduce((sum, entry)=>sum + entry.boundingClientRect.width, 0);
const $9be18fae5bd16fdc$export$87ee6701bd8502a7 = ()=>{
    const scrollableContainerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const resizeObserver = (0, $5uXOq.useRef)(null);
    const intersectionObserver = (0, $5uXOq.useRef)(null);
    const visibleItemsRef = (0, $5uXOq.useRef)([]);
    const [shouldHideScrollLeftButton, setShouldHideScrollLeftButton] = (0, $5uXOq.useState)(true);
    const [shouldHideScrollRightButton, setShouldHideScrollRightButton] = (0, $5uXOq.useState)(true);
    const setCanScrollDebounced = (0, $7nRxN.default)(()=>{
        // Refs are null before mounting and after unmount
        if (!scrollableContainerRef.current) return;
        setShouldHideScrollLeftButton($9be18fae5bd16fdc$var$isScrollAtLeft(scrollableContainerRef.current));
        setShouldHideScrollRightButton($9be18fae5bd16fdc$var$isScrollAtRight(scrollableContainerRef.current));
    });
    const updateVisibleItem = (0, $7nRxN.default)((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) visibleItemsRef.current = visibleItemsRef.current.filter((visible)=>!visible.target.isEqualNode(entry.target));
            if (entry.isIntersecting) visibleItemsRef.current = [
                ...visibleItemsRef.current,
                entry
            ];
        });
    });
    const setRef = (0, $5uXOq.useCallback)((node)=>{
        scrollableContainerRef.current = node;
        if (scrollableContainerRef.current) {
            // create resize-observer if we don't have it yet
            if (!resizeObserver.current) resizeObserver.current = new ResizeObserver(()=>{
                setCanScrollDebounced();
            });
            // create intersection-observer if we don't have it yet
            if (!intersectionObserver.current && IntersectionObserver) intersectionObserver.current = new IntersectionObserver(updateVisibleItem, {
                threshold: 1,
                root: scrollableContainerRef.current
            });
            // observe nodes and its children
            resizeObserver.current.observe(scrollableContainerRef.current);
            Array.from(scrollableContainerRef.current.children).forEach((child)=>{
                intersectionObserver.current?.observe(child);
            });
            setCanScrollDebounced();
        }
    }, [
        setCanScrollDebounced,
        updateVisibleItem
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (resizeObserver.current) resizeObserver.current.disconnect();
            if (intersectionObserver.current) intersectionObserver.current.disconnect();
        }, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            setCanScrollDebounced.cancel();
        }, [
        setCanScrollDebounced
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            updateVisibleItem.cancel();
        }, [
        updateVisibleItem
    ]);
    // Function to scroll to the next item
    const scrollToNext = ()=>{
        const container = scrollableContainerRef.current;
        if (container) {
            if (visibleItemsRef.current.length > 0) container.scrollBy({
                top: 0,
                /**
					 * scroll size will be the same amount of the number of visible items
					 * i.e.: we want to scroll to the next section and don't show the items that are visible already
					 */ left: $9be18fae5bd16fdc$var$getScrollSize(visibleItemsRef.current),
                behavior: 'smooth'
            });
            else /**
				 * fallback for 2 scenarios:
				 * 1. IntersectionObserver is not available
				 * 2. User resize the observer root, which makes the visibleItemsRef array empty.
				 *    e.g: if the root container (comment box) gets resized to the point
				 *    where there are no visible canned comments, in this case visibleItemsRef is empty
				 *    and the logic on the other 'if' condition won't work and fallback is needed
				 */ container.scrollBy({
                top: 0,
                left: container.clientWidth / 2,
                behavior: 'smooth'
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'scrollRight');
        }
    };
    // Function to scroll to the previous item
    const scrollToPrevious = ()=>{
        const container = scrollableContainerRef.current;
        if (container) {
            if (visibleItemsRef.current.length > 0) container.scrollBy({
                top: 0,
                /**
					 * scroll size will be the same amount of the number of visible items
					 * i.e.: we want to scroll to the next section and don't show the items that are visible already
					 */ left: -$9be18fae5bd16fdc$var$getScrollSize(visibleItemsRef.current),
                behavior: 'smooth'
            });
            else /**
				 * fallback for 2 scenarios:
				 * 1. IntersectionObserver is not available
				 * 2. User resize the observer root, which makes the visibleItemsRef array empty.
				 *    e.g: if the root container (comment box) gets resized to the point
				 *    where there are no visible canned comments, in this case visibleItemsRef is empty
				 *    and the logic on the other 'if' condition won't work and fallback is needed
				 */ container.scrollBy({
                top: 0,
                left: -container.clientWidth / 2,
                behavior: 'smooth'
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'scrollLeft');
        }
    };
    const onFocusCannedComment = (event)=>{
        const container = scrollableContainerRef.current;
        const cannedCommentElement = event.currentTarget;
        if (container) {
            // Calculate if the element is fully visible
            const containerRect = container.getBoundingClientRect();
            const cannedCommentElementRect = cannedCommentElement.getBoundingClientRect();
            // Element is partially off-screen to the left or right respectively
            if (cannedCommentElementRect.left < containerRect.left || cannedCommentElementRect.right > containerRect.right) cannedCommentElement.scrollIntoView({
                behavior: 'smooth',
                inline: 'center'
            });
        }
    };
    return {
        setCanScrollDebounced: setCanScrollDebounced,
        shouldHideScrollLeftButton: shouldHideScrollLeftButton,
        shouldHideScrollRightButton: shouldHideScrollRightButton,
        scrollToNext: scrollToNext,
        scrollToPrevious: scrollToPrevious,
        setRef: setRef,
        onFocusCannedComment: onFocusCannedComment
    };
};

});



parcelRegister("imfiy", function(module, exports) {

$parcel$export(module.exports, "CannedCommentList", () => $ecd3a588da8b2453$export$e08e95f6ce58a028);
$parcel$export(module.exports, "SmartRepliesCannedCommentList", () => $ecd3a588da8b2453$export$1532d9bf14514193);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bpC55 = parcelRequire("bpC55");

var $ks8FD = parcelRequire("ks8FD");

var $42CjB = parcelRequire("42CjB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $1PBgo = parcelRequire("1PBgo");

var $90OM1 = parcelRequire("90OM1");

var $exXOa = parcelRequire("exXOa");

var $9RlWW = parcelRequire("9RlWW");

var $5Kfe5 = parcelRequire("5Kfe5");
const $ecd3a588da8b2453$export$e08e95f6ce58a028 = ({ onClickCannedComment: onClickCannedComment, commentsType: commentsType })=>{
    const { setRef: setRef, setCanScrollDebounced: setCanScrollDebounced, shouldHideScrollLeftButton: shouldHideScrollLeftButton, shouldHideScrollRightButton: shouldHideScrollRightButton, scrollToNext: scrollToNext, scrollToPrevious: scrollToPrevious, onFocusCannedComment: onFocusCannedComment } = (0, $9RlWW.useScrollCarousel)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const commentsKey = commentsType === (0, $1PBgo.CANNED_COMMENTS_TYPE).ASSIGNED_USER ? (0, $1PBgo.ASSIGNED_USER_CANNED_COMMENTS_KEY) : (0, $1PBgo.CANNED_COMMENTS_KEY);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ecd3a588da8b2453$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $ecd3a588da8b2453$var$hoverButtonStyle,
            $ecd3a588da8b2453$var$leftButtonStyle,
            shouldHideScrollLeftButton && $ecd3a588da8b2453$var$hiddenButtonStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ks8FD))), {
                ...iconProps,
                size: "small"
            }),
        isTooltipDisabled: true,
        label: formatMessage((0, $90OM1.default).moreOptions),
        onClick: scrollToPrevious,
        tabIndex: -1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: setRef,
        onScroll: setCanScrollDebounced,
        role: "group",
        "aria-label": formatMessage((0, $90OM1.default).buttonGroupLabel),
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1bsb1osq _1e0c1txw _1bah1y6m _4cvr1h6o _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _1reo15zi _1fjgglyw _4pckglyw _1cicglyw"
        ])
    }, commentsKey.map((key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Kfe5.default), {
            commentKey: key.commentKey,
            commentText: (0, $exXOa.getCannedCommentContent)(formatMessage((0, $90OM1.default)[key.commentKey]), key.emoji),
            buttonText: formatMessage((0, $90OM1.default)[key.buttonTextKey]),
            key: key.commentKey,
            onClick: onClickCannedComment,
            onFocus: onFocusCannedComment
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $ecd3a588da8b2453$var$hoverButtonStyle,
            $ecd3a588da8b2453$var$rightButtonStyle,
            shouldHideScrollRightButton && $ecd3a588da8b2453$var$hiddenButtonStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                ...iconProps,
                size: "small"
            }),
        isTooltipDisabled: true,
        label: formatMessage((0, $90OM1.default).moreOptions),
        onClick: scrollToNext,
        tabIndex: -1
    })));
};
const $ecd3a588da8b2453$export$1532d9bf14514193 = ({ onClickCannedComment: onClickCannedComment, commentsType: commentsType, onFocusCannedComment: onFocusCannedComment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const commentsKey = commentsType === (0, $1PBgo.CANNED_COMMENTS_TYPE).ASSIGNED_USER ? (0, $1PBgo.ASSIGNED_USER_CANNED_COMMENTS_KEY) : (0, $1PBgo.CANNED_COMMENTS_KEY);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, commentsKey.map((key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Kfe5.default), {
            commentKey: key.commentKey,
            commentText: (0, $exXOa.getCannedCommentContent)(formatMessage((0, $90OM1.default)[key.commentKey]), key.emoji),
            buttonText: formatMessage((0, $90OM1.default)[key.buttonTextKey]),
            key: key.commentKey,
            onClick: onClickCannedComment,
            onFocus: onFocusCannedComment
        })));
};
const $ecd3a588da8b2453$var$containerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    position: 'absolute',
    bottom: "var(--ds-space-150, 12px)",
    left: "var(--ds-space-150, 12px)",
    right: "var(--ds-space-150, 12px)",
    alignItems: 'center'
});
const $ecd3a588da8b2453$var$commentsContainerStyle = null;
const $ecd3a588da8b2453$var$hoverButtonStyle = (0, $8CUq3.xcss)({
    zIndex: 'layer',
    alignItems: 'center',
    position: 'absolute',
    // NOTE: before changing this.
    // see jira/src/packages/jira-canned-comments/src/ui/canned-comments-placeholder/index.tsx:71
    background: `var(--jira-canned-comments-background-color, ${"var(--ds-background-input, #FFFFFF)"})`
});
const $ecd3a588da8b2453$var$rightButtonStyle = (0, $8CUq3.xcss)({
    right: 'space.0'
});
const $ecd3a588da8b2453$var$leftButtonStyle = (0, $8CUq3.xcss)({
    left: 'space.0'
});
const $ecd3a588da8b2453$var$hiddenButtonStyle = (0, $8CUq3.xcss)({
    display: 'none'
});

});
parcelRegister("exXOa", function(module, exports) {

$parcel$export(module.exports, "getCannedCommentContent", () => $11720bf9278ef9b1$export$c4745006e9cab7fb);
$parcel$export(module.exports, "getProductReferrerKey", () => $11720bf9278ef9b1$export$b4fb3304d5d8fc5f);

var $bPWvi = parcelRequire("bPWvi");
var $50sdg = parcelRequire("50sdg");

var $17HKk = parcelRequire("17HKk");

var $2vSU6 = parcelRequire("2vSU6");
const $11720bf9278ef9b1$export$c4745006e9cab7fb = (message, emo)=>(0, $bPWvi.doc)((0, $50sdg.paragraph)(`${emo.text} ${message}`));
const $11720bf9278ef9b1$export$b4fb3304d5d8fc5f = (projectType)=>{
    return projectType === (0, $2vSU6.SOFTWARE_PROJECT) ? (0, $17HKk.PRODUCT_TYPES).JSW : (0, $17HKk.PRODUCT_TYPES).JWM;
};

});
parcelRegister("17HKk", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_TYPES", () => $d9be8bc03b21caf4$export$65d2d1f2fdbe617a);
$parcel$export(module.exports, "SuggestedCommentReplyAgentCommentType", () => $d9be8bc03b21caf4$export$e298aa24226439c4);
$parcel$export(module.exports, "SUGGESTED_COMMENT_AGENT_NAME_ID", () => $d9be8bc03b21caf4$export$69ae5ade6e9d866);
$parcel$export(module.exports, "SUGGESTED_COMMENT_AGENT_EXPERIENCE_ID", () => $d9be8bc03b21caf4$export$5f8e4598b0f9faa0);
// api contract: https://hello.atlassian.net/wiki/spaces/AM3/pages/4383854942/Suggested+Comment+Reply+Agent+API+Design
const $d9be8bc03b21caf4$export$65d2d1f2fdbe617a = {
    JWM: 'JWM',
    JSW: 'JSW'
};
const $d9be8bc03b21caf4$export$e298aa24226439c4 = {
    QUICK_REPLY: 'QUICK_REPLY',
    QUESTION: 'QUESTION',
    SUGGESTION: 'SUGGESTION',
    JIRA_STATUS_UPDATE: 'JIRA_STATUS_UPDATE',
    JIRA_COMMENT_REPLY: 'JIRA_COMMENT_REPLY',
    JIRA_ASSIGNEE_MISSING: 'JIRA_ASSIGNEE_MISSING',
    JIRA_DESCRIPTION_MISSING: 'JIRA_DESCRIPTION_MISSING',
    JIRA_MOTIVATION: 'JIRA_MOTIVATION'
};
const $d9be8bc03b21caf4$export$69ae5ade6e9d866 = 'suggested_comment_reply_agent';
const $d9be8bc03b21caf4$export$5f8e4598b0f9faa0 = 'suggested-comment-reply';

});


parcelRegister("5Kfe5", function(module, exports) {

$parcel$export(module.exports, "default", () => $67307f90a78d8f4d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $67307f90a78d8f4d$var$CannedComment = ({ commentKey: commentKey, buttonText: buttonText, commentText: commentText, onClick: onClick, onFocus: onFocus })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const timer = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timer.current) clearTimeout(timer.current);
        }, []);
    const onClickWithAnalytics = (0, $5uXOq.useCallback)(()=>{
        onClick(commentText);
        // Storing the index instead of the message to avoid sending UGC data in the analytics event
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'cannedComment', {
            commentKey: commentKey
        });
    }, [
        onClick,
        commentText,
        createAnalyticsEvent,
        commentKey
    ]);
    const onMouseEnterWithAnalytics = (0, $5uXOq.useCallback)(()=>{
        // Delay the analytics event to avoid sending too many events
        timer.current = setTimeout(()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button hovered', 'cannedComment', {
                commentKey: commentKey
            });
        }, 500);
    }, [
        commentKey,
        createAnalyticsEvent
    ]);
    const onMouseLeaveWithAnalytics = (0, $5uXOq.useCallback)(()=>{
        if (timer.current) clearTimeout(timer.current);
    }, []);
    // We are aware this is deprecated already, we will put it in the cut corner
    // once the replacement is available we will use xcss with new button instead
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        theme: $67307f90a78d8f4d$export$fd4d27a26b4854f3,
        appearance: "default",
        spacing: "compact",
        onClick: onClickWithAnalytics,
        onFocus: onFocus,
        onMouseEnter: onMouseEnterWithAnalytics,
        onMouseLeave: onMouseLeaveWithAnalytics
    }, buttonText);
};
const $67307f90a78d8f4d$export$fd4d27a26b4854f3 = (current, themeProps)=>{
    const theme = current(themeProps);
    return {
        ...theme,
        buttonStyles: {
            ...theme.buttonStyles,
            borderRadius: '100px'
        }
    };
};
var $67307f90a78d8f4d$export$2e2bcd8739ae039 = $67307f90a78d8f4d$var$CannedComment;

});







parcelRegister("eMow4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf38cfa367c4e819$export$2e2bcd8739ae039);
// This component deals exclusively with the creation of new comments.
// For editing, there is a separate version available from @atlassian/jira-issue-comment-base

var $5uXOq = parcelRequire("5uXOq");

var $i4LRD = parcelRequire("i4LRD");

var $eXGmE = parcelRequire("eXGmE");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $flIRE = parcelRequire("flIRE");

var $jApB6 = parcelRequire("jApB6");

var $dsRaM = parcelRequire("dsRaM");

var $cF333 = parcelRequire("cF333");

var $75rkV = parcelRequire("75rkV");
const $cf38cfa367c4e819$export$f4d6ff133803e635 = ({ isSmartRepliesEnabled: isSmartRepliesEnabled, isQuickRepliesEnabled: isQuickRepliesEnabled, isAIRepliesEnabled: isAIRepliesEnabled, hasDraft: hasDraft, ...props })=>{
    const { hasQuickReply: hasQuickReply } = isQuickRepliesEnabled ? (0, $dsRaM.useHandleQuickReply)(props.onChange) : {
        hasQuickReply: false
    };
    if (!hasQuickReply && isAIRepliesEnabled && (0, $6s1PB.expVal)('ai_smart_replies', 'isEnabled', false)) {
        const renderContent = ()=>{
            if (!props.isExpanded) {
                if (hasDraft) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cF333.CommentsPlaceholder), {
                    placeholder: props.collapsedPlaceholder,
                    onFocus: props.onExpanded,
                    onClick: props.onExpanded
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i4LRD.CommentEditorWithAI), {
                    onChange: props.onChange,
                    onExpanded: props.onExpanded,
                    placeholder: props.collapsedPlaceholder
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jApB6.LazyIssueEditor), {
                ...props,
                isAddComment: true
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "AiSmartReplies",
            packageName: "jiraIssueViewActivityComment",
            teamName: "jira-warepil",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jApB6.LazyIssueEditor), {
                    ...props,
                    isAddComment: true
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i4LRD.CommentEditorWithAIContext), null, renderContent()));
    }
    // Statsig Experiment exposure gets fired here
    if (!hasQuickReply && isSmartRepliesEnabled && (0, $6s1PB.expVal)('smart_replies_m1', 'isEnabled', false)) {
        if (!props.isExpanded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "smartRepliesCannedCommentPlacholder",
            packageName: "jiraIssueViewActivityComment",
            teamName: "jira-warepil",
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jApB6.LazyIssueEditor), {
                    ...props,
                    isAddComment: true
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eXGmE.CannedCommentsPlaceHolderWithClick), {
            onChange: props.onChange,
            onExpanded: props.onExpanded,
            collapsedPlaceholder: props.collapsedPlaceholder
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jApB6.LazyIssueEditor), {
            ...props,
            isAddComment: true
        });
    }
    if (!props.isExpanded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cF333.CommentsPlaceholder), {
        placeholder: props.collapsedPlaceholder,
        onFocus: props.onExpanded,
        onClick: props.onExpanded
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jApB6.LazyIssueEditor), {
        ...props,
        isAddComment: true
    });
};
const $cf38cfa367c4e819$var$IssueEditorWithTaskDecisionProvider = (props)=>{
    // Create empty `TaskDecisionProvider`; `onSave` will handle the ADF update
    const taskDecisionProvider = (0, $5uXOq.useMemo)(()=>new (0, $flIRE.IssueTaskDecisionProvider)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf38cfa367c4e819$export$f4d6ff133803e635, {
        ...props,
        taskDecisionProvider: taskDecisionProvider
    });
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$cf38cfa367c4e819$export$2e2bcd8739ae039 = (0, $75rkV.enhanceIssueCommentEditor)($cf38cfa367c4e819$var$IssueEditorWithTaskDecisionProvider);

});
parcelRegister("i4LRD", function(module, exports) {

$parcel$export(module.exports, "CommentEditorWithAI", () => $3fd68a71d1fd98b2$export$d510fc3619128deb);
$parcel$export(module.exports, "CommentEditorWithAIContext", () => $3fd68a71d1fd98b2$export$732e8ee983981ce0);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $k8FTq = parcelRequire("k8FTq");
var $1mZvd = parcelRequire("1mZvd");

var $94cfG = parcelRequire("94cfG");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $fOGZN = parcelRequire("fOGZN");

var $hxqfC = parcelRequire("hxqfC");

var $7Ow8a = parcelRequire("7Ow8a");

var $d4MOh = parcelRequire("d4MOh");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $93Yeu = parcelRequire("93Yeu");

var $1PBgo = parcelRequire("1PBgo");

var $1IOYQ = parcelRequire("1IOYQ");

var $EUUcN = parcelRequire("EUUcN");

var $dgpjj = parcelRequire("dgpjj");

var $dmU7q = parcelRequire("dmU7q");
const $3fd68a71d1fd98b2$export$d510fc3619128deb = ({ onChange: onChange, onExpanded: onExpanded, placeholder: placeholder })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const { fetchSuggestedComments: fetchSuggestedComments } = (0, $dgpjj.useAIComments)();
    const [{ availableCommentTypes: availableCommentTypes, suggestedComments: suggestedComments, availableCommentTypeOptions: availableCommentTypeOptions, currentCommentType: currentCommentType, showGeneratedComment: showGeneratedComment, isLoading: isLoading }, { setSuggestedComments: setSuggestedComments, setCurrentCommentType: setCurrentCommentType, acceptSuggestedComment: acceptSuggestedComment, setShowGeneratedComment: setShowGeneratedComment, setIsLoading: setIsLoading }] = (0, $EUUcN.useAICommentsStates)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultError: trackAIResultError } = (0, $1mZvd.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onFail = (0, $5uXOq.useCallback)((type)=>(error)=>{
            setShowGeneratedComment(false);
            trackAIResultError({
                aiErrorMessage: error?.message
            }, {
                attributes: {
                    aiExperienceName: type
                }
            });
        }, [
        setShowGeneratedComment,
        trackAIResultError
    ]);
    const onClick = (0, $5uXOq.useCallback)((type)=>{
        trackAIInteractionInit({
            attributes: {
                aiExperienceName: type
            }
        });
        setCurrentCommentType(type);
        setShowGeneratedComment(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'aiCannedComment', {
            commentType: type
        });
        if (!(0, $dgpjj.hasSuggestedComment)(type, suggestedComments) && !isLoading && (projectType === (0, $2vSU6.CORE_PROJECT) || projectType === (0, $2vSU6.SOFTWARE_PROJECT))) {
            setIsLoading(true);
            fetchSuggestedComments({
                issueKey: issueKey,
                projectType: projectType,
                selectedType: type,
                commentTypes: availableCommentTypes,
                onFail: onFail(type)
            }).then((data)=>{
                setSuggestedComments(data);
                setIsLoading(false);
            });
        }
    }, [
        availableCommentTypes,
        createAnalyticsEvent,
        fetchSuggestedComments,
        isLoading,
        issueKey,
        onFail,
        projectType,
        setCurrentCommentType,
        setIsLoading,
        setShowGeneratedComment,
        setSuggestedComments,
        suggestedComments,
        trackAIInteractionInit
    ]);
    const onDismiss = (0, $5uXOq.useCallback)((isDiscard)=>{
        trackAIInteractionDismiss({
            attributes: {
                aiExperienceName: currentCommentType ?? undefined,
                dismissedAction: isDiscard ? 'discardButtonClicked' : 'cancelButtonClicked'
            }
        });
        setShowGeneratedComment(false);
        setCurrentCommentType(null);
        onExpanded?.();
    }, [
        trackAIInteractionDismiss,
        currentCommentType,
        setShowGeneratedComment,
        setCurrentCommentType,
        onExpanded
    ]);
    const onInsertComment = (0, $5uXOq.useCallback)((comment)=>{
        trackAIResultAction('insert', {
            attributes: {
                aiExperienceName: currentCommentType ?? undefined
            }
        });
        setShowGeneratedComment(false);
        currentCommentType && acceptSuggestedComment(currentCommentType);
        onExpanded?.();
        onChange?.(comment);
    }, [
        trackAIResultAction,
        currentCommentType,
        setShowGeneratedComment,
        acceptSuggestedComment,
        onExpanded,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94cfG.default), {
        shouldFitContainer: true,
        spacing: "none",
        testId: "canned-comments.ui.ai-comments.ai-container",
        isLoading: isLoading && showGeneratedComment,
        hasNewBorderExperience: true
    }, showGeneratedComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dmU7q.default), {
        isLoading: isLoading,
        onDismiss: onDismiss,
        onInsertComment: onInsertComment
    }), !showGeneratedComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1IOYQ.CannedCommentsPlaceholder), {
        onClick: onExpanded,
        onFocus: onExpanded,
        placeholder: placeholder,
        hiddenBorder: true,
        renderCannedCommentOptions: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), {
                label: ""
            }, availableCommentTypeOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                    spacing: "compact",
                    onClick: ()=>onClick(option.value),
                    key: option.value
                }, formatMessage(option.message))))
    }));
};
const $3fd68a71d1fd98b2$export$732e8ee983981ce0 = ({ children: children })=>{
    const singleInstrumentationId = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
    const attributes = {
        aiFeatureName: (0, $1PBgo.AI_COMMENTS_FEATURE)
    };
    const issueKey = (0, $2gCtH.useIssueKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3fd68a71d1fd98b2$var$ReduxConnectedJiraIssueAICommentsContainer, {
        scope: issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8FTq.AIEventsInstrumentationProvider), {
        config: {
            ...attributes,
            product: 'jira',
            subproduct: 'jira',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            isAIFeature: 1,
            singleInstrumentationID: singleInstrumentationId.current,
            customAnalyticsFire: (payload, event)=>(0, $8zOmE.fireTrackAnalytics)(event, payload)
        }
    }, children)));
};
const $3fd68a71d1fd98b2$var$ReduxConnectedJiraIssueAICommentsContainer = (0, $hxqfC.connect)((state)=>({
        totalOfComments: (0, $d4MOh.totalCommentsSelector)(state),
        hasMissingAssignee: (0, $7Ow8a.fieldSelector)((0, $fOGZN.ASSIGNEE))(state)?.value === null,
        hasMissingDescription: (0, $7Ow8a.fieldSelector)((0, $fOGZN.DESCRIPTION))(state)?.adfValue?.content.length === 0
    }), {})((0, $EUUcN.JiraIssueAICommentsContainer));

});
parcelRegister("1mZvd", function(module, exports) {

$parcel$export(module.exports, "useAIEventsInstrumentation", () => $371d810fc57e96f9$export$ddf49ad062368ad2);

var $5uXOq = parcelRequire("5uXOq");

var $476Ri = parcelRequire("476Ri");

var $e8KHW = parcelRequire("e8KHW");

var $2NMNM = parcelRequire("2NMNM");

var $3CZ4Z = parcelRequire("3CZ4Z");

var $bL7Ww = parcelRequire("bL7Ww");

var $7gJlQ = parcelRequire("7gJlQ");

var $5eDps = parcelRequire("5eDps");

var $7wX59 = parcelRequire("7wX59");
const $371d810fc57e96f9$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $5uXOq.useContext)((0, $3CZ4Z.AIEventsInstrumentationContext));
    if (customConfig) context = {
        config: {
            ...(0, $bL7Ww.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $7wX59.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $5uXOq.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $476Ri.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $5eDps.AISessionState).unset,
            nextState: (0, $476Ri.P).union((0, $5eDps.AISessionState).viewed, (0, $5eDps.AISessionState).error, (0, $5eDps.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $5eDps.AISessionState).initiated,
            nextState: (0, $476Ri.P).union((0, $5eDps.AISessionState).submitted, (0, $5eDps.AISessionState).actioned, (0, $5eDps.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $5uXOq.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $e8KHW.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $5uXOq.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes
            }
        };
        return (0, $476Ri.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $7gJlQ.getTagsWithPlatfromTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $476Ri.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $476Ri.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        aiExperienceName,
        aiFeatureName,
        product,
        proactiveGeneratedAI,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        userGeneratedAI,
        isAIFeature,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents
    ]);
    const trackAIInteractionInit = (0, $5uXOq.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $5eDps.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $5uXOq.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $5eDps.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $5uXOq.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $5eDps.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $5uXOq.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $5eDps.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $5uXOq.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $5eDps.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $5uXOq.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $5eDps.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'discarded',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $5uXOq.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $5eDps.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    return {
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
};

});
parcelRegister("7gJlQ", function(module, exports) {

$parcel$export(module.exports, "getTagsWithPlatfromTag", () => $1b6527b1fd3259d5$export$8dd34cb3211cf994);
const $1b6527b1fd3259d5$export$8dd34cb3211cf994 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};

});


parcelRegister("EUUcN", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAICommentsContainer", () => $c5641ae752029227$export$c65ed21eaf08fc53);
$parcel$export(module.exports, "useAICommentsStates", () => $c5641ae752029227$export$a504bc7744cc367c);
$parcel$export(module.exports, "useCurrentComment", () => $c5641ae752029227$export$32679da3f57e8e7a);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $aVUXF = parcelRequire("aVUXF");
const $c5641ae752029227$export$d4c72bab9d6cc13a = {
    availableCommentTypeOptions: [],
    availableCommentTypes: [],
    suggestedComments: null,
    acceptedCommentTypes: [],
    currentCommentType: null,
    isLoading: false,
    showGeneratedComment: false
};
const $c5641ae752029227$export$b7e5745f481149f9 = (suggestedComments)=>({ setState: setState })=>{
        setState({
            suggestedComments: suggestedComments
        });
    };
const $c5641ae752029227$export$e8cd75c4cacbbbeb = (currentCommentType)=>({ setState: setState })=>{
        setState({
            currentCommentType: currentCommentType
        });
    };
const $c5641ae752029227$export$9eaa806651dd33f0 = (isLoading)=>({ setState: setState })=>{
        setState({
            isLoading: isLoading
        });
    };
const $c5641ae752029227$export$771df637abf3ab45 = (showGeneratedComment)=>({ setState: setState })=>{
        setState({
            showGeneratedComment: showGeneratedComment
        });
    };
const $c5641ae752029227$export$c822f70817f59389 = (commentType)=>({ setState: setState, getState: getState }, props)=>{
        const acceptedCommentTypes = getState().acceptedCommentTypes.concat(commentType);
        const { commentTypes: commentTypes, commentTypeOptions: commentTypeOptions } = (0, $aVUXF.getAvailableCommentTypeOptions)({
            ...props,
            acceptedCommentTypes: acceptedCommentTypes
        });
        setState({
            availableCommentTypes: commentTypes,
            availableCommentTypeOptions: commentTypeOptions,
            currentCommentType: null,
            suggestedComments: null,
            acceptedCommentTypes: acceptedCommentTypes
        });
    };
const $c5641ae752029227$export$e324594224ef24da = {
    setSuggestedComments: $c5641ae752029227$export$b7e5745f481149f9,
    setCurrentCommentType: $c5641ae752029227$export$e8cd75c4cacbbbeb,
    acceptSuggestedComment: $c5641ae752029227$export$c822f70817f59389,
    setShowGeneratedComment: $c5641ae752029227$export$771df637abf3ab45,
    setIsLoading: $c5641ae752029227$export$9eaa806651dd33f0
};
const $c5641ae752029227$export$c65ed21eaf08fc53 = (0, $gg7kZ.createContainer)({
    displayName: 'JiraIssueAICommentsContainer'
});
const $c5641ae752029227$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $c5641ae752029227$export$d4c72bab9d6cc13a,
    actions: $c5641ae752029227$export$e324594224ef24da,
    name: 'jira-issue-ai-comments',
    containedBy: $c5641ae752029227$export$c65ed21eaf08fc53,
    handlers: {
        onInit: ()=>({ setState: setState }, props)=>{
                const { commentTypes: commentTypes, commentTypeOptions: commentTypeOptions } = (0, $aVUXF.getAvailableCommentTypeOptions)(props);
                setState({
                    availableCommentTypeOptions: commentTypeOptions,
                    availableCommentTypes: commentTypes
                });
            },
        onContainerUpdate: (nextProps)=>({ setState: setState, getState: getState })=>{
                const { commentTypes: commentTypes, commentTypeOptions: commentTypeOptions } = (0, $aVUXF.getAvailableCommentTypeOptions)({
                    ...nextProps,
                    acceptedCommentTypes: getState().acceptedCommentTypes
                });
                // clean the suggestedComments when the container props are updated
                setState({
                    availableCommentTypes: commentTypes,
                    availableCommentTypeOptions: commentTypeOptions,
                    suggestedComments: null,
                    currentCommentType: null
                });
            }
    }
});
const $c5641ae752029227$export$a504bc7744cc367c = (0, $3sQ5x.createHook)($c5641ae752029227$export$390f32400eaf98c9);
const $c5641ae752029227$var$getCurrentComment = (state)=>{
    const currentComment = state.currentCommentType && state.suggestedComments && state.suggestedComments[state.currentCommentType];
    return {
        currentCommentType: state.currentCommentType,
        currentComment: currentComment
    };
};
const $c5641ae752029227$export$32679da3f57e8e7a = (0, $3sQ5x.createHook)($c5641ae752029227$export$390f32400eaf98c9, {
    selector: $c5641ae752029227$var$getCurrentComment
});

});
parcelRegister("aVUXF", function(module, exports) {

$parcel$export(module.exports, "getAvailableCommentTypeOptions", () => $f2be7e7b657bd6d3$export$3aa04d9ec62a82aa);

var $17HKk = parcelRequire("17HKk");

var $cg4p0 = parcelRequire("cg4p0");
const $f2be7e7b657bd6d3$var$maxNumberOfCommentTypes = 3;
const $f2be7e7b657bd6d3$var$getAvailableCommentTypes = ({ totalOfComments: totalOfComments, hasMissingAssignee: hasMissingAssignee, hasMissingDescription: hasMissingDescription, acceptedCommentTypes: acceptedCommentTypes })=>{
    let result = [];
    if (totalOfComments > 0) result.push((0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_COMMENT_REPLY);
    if (hasMissingAssignee) result.push((0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_ASSIGNEE_MISSING);
    if (hasMissingDescription) result.push((0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_DESCRIPTION_MISSING);
    result.push((0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_STATUS_UPDATE);
    result.push((0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_MOTIVATION);
    if (acceptedCommentTypes) result = result.filter((commentType)=>!acceptedCommentTypes.includes(commentType));
    // always returns the three general comment types
    result.push((0, $17HKk.SuggestedCommentReplyAgentCommentType).QUICK_REPLY);
    result.push((0, $17HKk.SuggestedCommentReplyAgentCommentType).QUESTION);
    result.push((0, $17HKk.SuggestedCommentReplyAgentCommentType).SUGGESTION);
    return result;
};
const $f2be7e7b657bd6d3$var$getDisplayMessageForCommentType = (commentType)=>{
    switch(commentType){
        case (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_COMMENT_REPLY:
            return (0, $cg4p0.default).commentReply;
        case (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_ASSIGNEE_MISSING:
            return (0, $cg4p0.default).assigneeMissing;
        case (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_DESCRIPTION_MISSING:
            return (0, $cg4p0.default).descriptionMissing;
        case (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_STATUS_UPDATE:
            return (0, $cg4p0.default).statusUpdate;
        case (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_MOTIVATION:
            return (0, $cg4p0.default).motivation;
        case (0, $17HKk.SuggestedCommentReplyAgentCommentType).QUICK_REPLY:
            return (0, $cg4p0.default).quickReply;
        case (0, $17HKk.SuggestedCommentReplyAgentCommentType).QUESTION:
            return (0, $cg4p0.default).question;
        case (0, $17HKk.SuggestedCommentReplyAgentCommentType).SUGGESTION:
            return (0, $cg4p0.default).suggestion;
        default:
            return null;
    }
};
const $f2be7e7b657bd6d3$export$3aa04d9ec62a82aa = (props)=>{
    const availableCommentTypes = $f2be7e7b657bd6d3$var$getAvailableCommentTypes(props);
    const commentTypes = [];
    const commentTypeOptions = [];
    availableCommentTypes.forEach((commentType)=>{
        const displayMessage = $f2be7e7b657bd6d3$var$getDisplayMessageForCommentType(commentType);
        if (!displayMessage) return;
        commentTypes.push(commentType);
        commentTypeOptions.push({
            value: commentType,
            message: displayMessage
        });
    });
    return {
        commentTypes: commentTypes.slice(0, $f2be7e7b657bd6d3$var$maxNumberOfCommentTypes),
        commentTypeOptions: commentTypeOptions.slice(0, $f2be7e7b657bd6d3$var$maxNumberOfCommentTypes)
    };
};

});
parcelRegister("cg4p0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1001be0b86a54cc4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1001be0b86a54cc4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    commentReply: {
        "id": "canned-comments.ui.ai-comments.comment-reply",
        "defaultMessage": "Suggest a reply..."
    },
    assigneeMissing: {
        "id": "canned-comments.ui.ai-comments.assignee-missing",
        "defaultMessage": "Who is working on this...?"
    },
    descriptionMissing: {
        "id": "canned-comments.ui.ai-comments.description-missing",
        "defaultMessage": "Can I get more info...?"
    },
    statusUpdate: {
        "id": "canned-comments.ui.ai-comments.status-update",
        "defaultMessage": "Status update..."
    },
    motivation: {
        "id": "canned-comments.ui.ai-comments.motivation",
        "defaultMessage": "Thanks..."
    },
    quickReply: {
        "id": "canned-comments.ui.ai-comments.quick-reply",
        "defaultMessage": "Agree..."
    },
    question: {
        "id": "canned-comments.ui.ai-comments.question",
        "defaultMessage": "Ask a question..."
    },
    suggestion: {
        "id": "canned-comments.ui.ai-comments.suggestion",
        "defaultMessage": "Add a suggestion..."
    }
});

});



parcelRegister("dgpjj", function(module, exports) {

$parcel$export(module.exports, "hasSuggestedComment", () => $7e989f8ea8c5b7e1$export$80e3c119f6b7d69d);
$parcel$export(module.exports, "useAIComments", () => $7e989f8ea8c5b7e1$export$3e328d6638b73280);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $3NbJG = parcelRequire("3NbJG");

var $17HKk = parcelRequire("17HKk");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $DVljb = parcelRequire("DVljb");

var $exXOa = parcelRequire("exXOa");

var $8ktBc = parcelRequire("8ktBc");
const $7e989f8ea8c5b7e1$export$bcf31797782cb093 = (comments)=>{
    if (!comments) return null;
    const results = {};
    comments.forEach((comment)=>{
        if (comment.commentReplyType === (0, $17HKk.SuggestedCommentReplyAgentCommentType).QUICK_REPLY || comment.commentReplyType === (0, $17HKk.SuggestedCommentReplyAgentCommentType).QUESTION || comment.commentReplyType === (0, $17HKk.SuggestedCommentReplyAgentCommentType).SUGGESTION || comment.commentReplyType === (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_STATUS_UPDATE || comment.commentReplyType === (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_COMMENT_REPLY || comment.commentReplyType === (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_ASSIGNEE_MISSING || comment.commentReplyType === (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_DESCRIPTION_MISSING || comment.commentReplyType === (0, $17HKk.SuggestedCommentReplyAgentCommentType).JIRA_MOTIVATION) results[comment.commentReplyType] = comment.text;
    });
    return results;
};
const $7e989f8ea8c5b7e1$export$80e3c119f6b7d69d = (selectedType, suggestedComments)=>{
    if (!suggestedComments) return false;
    const comment = suggestedComments[selectedType];
    return !!comment;
};
const $7e989f8ea8c5b7e1$export$3e328d6638b73280 = ()=>{
    const locale = (0, $DVljb.useNativeLocale)();
    const startExperience = (0, $kaHBi.useExperienceStart)((0, $8ktBc.AI_COMMENTS_EXPERIENCE));
    const markExperienceSuccess = (0, $3bQtK.useExperienceSuccess)((0, $8ktBc.AI_COMMENTS_EXPERIENCE));
    const markExperienceFailed = (0, $93jKl.useExperienceFail)((0, $8ktBc.AI_COMMENTS_EXPERIENCE));
    const aiCommentsMetric = (0, $dGrdR.metrics).interaction({
        key: (0, $8ktBc.AI_COMMENTS_METRIC_KEY),
        histogram: (0, $8ktBc.AI_COMMENTS_HISTOGRAM)
    });
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $pa9q9.useFlagsService)();
    const fetchSuggestedComments = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, projectType: projectType, selectedType: selectedType, commentTypes: commentTypes, onFail: onFail })=>{
        startExperience();
        aiCommentsMetric.start();
        if (hasFlag?.((0, $8ktBc.FETCH_SUGGESTED_COMMENTS_FAILED_FLAG_ID))) dismissFlag((0, $8ktBc.FETCH_SUGGESTED_COMMENTS_FAILED_FLAG_ID));
        try {
            const comments = await (0, $3NbJG.invokeAgent)((0, $17HKk.SUGGESTED_COMMENT_AGENT_NAME_ID), {
                experienceId: (0, $17HKk.SUGGESTED_COMMENT_AGENT_EXPERIENCE_ID),
                agent_input_context: {
                    object_id: issueKey,
                    locale: locale,
                    product: (0, $exXOa.getProductReferrerKey)(projectType),
                    comment_types: commentTypes
                }
            });
            aiCommentsMetric.stop();
            const result = $7e989f8ea8c5b7e1$export$bcf31797782cb093(comments?.content?.commentSuggestions);
            if ($7e989f8ea8c5b7e1$export$80e3c119f6b7d69d(selectedType, result)) {
                markExperienceSuccess();
                return result;
            }
            throw new Error('Selected comment type not returned');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            aiCommentsMetric.stop();
            markExperienceFailed('use-ai-comment', error, {
                commentTypes: commentTypes?.toString() || ''
            });
            showFlag((0, $8ktBc.FETCH_SUGGESTED_COMMENTS_FAILED_FLAG));
            onFail?.(error);
            return null;
        }
    }, [
        aiCommentsMetric,
        dismissFlag,
        hasFlag,
        locale,
        markExperienceFailed,
        markExperienceSuccess,
        showFlag,
        startExperience
    ]);
    return {
        fetchSuggestedComments: fetchSuggestedComments
    };
};

});
parcelRegister("3NbJG", function(module, exports) {

$parcel$export(module.exports, "invokeAgent", () => $fbc5633c3e636a02$export$6a8f92fe55e16ec5);
const $fbc5633c3e636a02$export$6a8f92fe55e16ec5 = async (agentNamedId, agentRequest, signal)=>{
    const response = await fetch('/gateway/api/assist/chat/v1/invoke_agent', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': 'jira',
            'X-Experience-Id': agentRequest.experienceId
        },
        body: JSON.stringify({
            recipient_agent_named_id: agentNamedId,
            agent_input_context: agentRequest.agent_input_context
        }),
        signal: signal
    });
    if (!response.ok) throw new Error(`API call failed: ${response.status}`);
    const result = await response.json();
    const data = {
        content: JSON.parse(result.message.content)
    };
    return data;
};

});

parcelRegister("8ktBc", function(module, exports) {

$parcel$export(module.exports, "AI_COMMENTS_EXPERIENCE", () => $020d33a966e23fc1$export$9e8dbe7f414e4b21);
$parcel$export(module.exports, "AI_COMMENTS_METRIC_KEY", () => $020d33a966e23fc1$export$f568908f52305df);
$parcel$export(module.exports, "AI_COMMENTS_HISTOGRAM", () => $020d33a966e23fc1$export$2d97240efd3f3354);
$parcel$export(module.exports, "FETCH_SUGGESTED_COMMENTS_FAILED_FLAG_ID", () => $020d33a966e23fc1$export$2c80090550f69a27);
$parcel$export(module.exports, "FETCH_SUGGESTED_COMMENTS_FAILED_FLAG", () => $020d33a966e23fc1$export$e0e9ed902e4c8515);

var $1PBgo = parcelRequire("1PBgo");

var $llXO0 = parcelRequire("llXO0");
const $020d33a966e23fc1$export$9e8dbe7f414e4b21 = {
    experience: 'AISuggestedComments',
    experienceId: 'fetchAISuggestedComments',
    analyticsSource: (0, $1PBgo.APP_IDENTIFIER)
};
const $020d33a966e23fc1$export$f568908f52305df = `${(0, $1PBgo.APP_IDENTIFIER)}.fetch-ai-suggested-comments`;
const $020d33a966e23fc1$export$2d97240efd3f3354 = {
    result: '1000_2000_3000_4000_5000_10000',
    response: '1000_2000_3000_4000_5000_10000'
};
const $020d33a966e23fc1$export$2c80090550f69a27 = 'fetch-suggested-comments-failed-flag';
const $020d33a966e23fc1$export$e0e9ed902e4c8515 = {
    id: $020d33a966e23fc1$export$2c80090550f69a27,
    type: 'error',
    isAutoDismiss: true,
    title: (0, $llXO0.default).fetchErrorFlagTitle,
    description: (0, $llXO0.default).fetchErrorFlagDescription,
    messageId: 'canned-comments.services.use-ai-comments.fetch-suggested-comments-failed-flag.error.error.fetch-suggested-comments-failed-flag',
    messageType: 'transactional'
};

});
parcelRegister("llXO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a89a80b4bcb930a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a89a80b4bcb930a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fetchErrorFlagTitle: {
        "id": "project-create-importer.upload-flow.fetch-error-flag-title",
        "defaultMessage": "AI generation error"
    },
    fetchErrorFlagDescription: {
        "id": "project-create-importer.upload-flow.fetch-error-flag-description",
        "defaultMessage": "There was an error generating a response. Please wait a while and try again."
    }
});

});



parcelRegister("dmU7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e1cae4cd473cf3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $f5oqj = parcelRequire("f5oqj");

var $1mZvd = parcelRequire("1mZvd");

var $7kcqV = parcelRequire("7kcqV");

var $anQnI = parcelRequire("anQnI");

var $37QwF = parcelRequire("37QwF");

var $2YBWI = parcelRequire("2YBWI");

var $koVbs = parcelRequire("koVbs");

var $EUUcN = parcelRequire("EUUcN");

var $fnBG3 = parcelRequire("fnBG3");

var $3sxUu = parcelRequire("3sxUu");

var $hFECI = parcelRequire("hFECI");
const $66e1cae4cd473cf3$var$AIGeneratedComment = ({ isLoading: isLoading, onDismiss: onDismiss, onInsertComment: onInsertComment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ currentComment: currentComment, currentCommentType: currentCommentType }] = (0, $EUUcN.useCurrentComment)();
    const currentAdfContent = (0, $5uXOq.useMemo)(()=>{
        if (!currentComment) return null;
        return (0, $37QwF.encodeAdf)(currentComment, true);
    }, [
        currentComment
    ]);
    const streamingContent = (0, $5uXOq.useMemo)(()=>{
        return currentAdfContent ? (0, $fnBG3.adfToText)(currentAdfContent) : undefined;
    }, [
        currentAdfContent
    ]);
    const { delayedContent: delayedContent, isComplete: isComplete } = (0, $anQnI.useAIMockStreaming)(streamingContent);
    const adfContent = (0, $5uXOq.useMemo)(()=>{
        if (!delayedContent) return null;
        return isComplete ? currentAdfContent : (0, $37QwF.encodeAdf)(delayedContent, true);
    }, [
        currentAdfContent,
        delayedContent,
        isComplete
    ]);
    const { trackAIResultView: trackAIResultView } = (0, $1mZvd.useAIEventsInstrumentation)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoading && currentComment) trackAIResultView({
            attributes: {
                aiExperienceName: currentCommentType ?? undefined
            }
        });
    }, [
        currentComment,
        currentCommentType,
        isLoading,
        trackAIResultView
    ]);
    const onInsertClick = (0, $5uXOq.useCallback)(()=>{
        adfContent && onInsertComment(adfContent);
    }, [
        adfContent,
        onInsertComment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        padding: "space.200"
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sxUu.GeneratingAnimation), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        padding: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text.subtlest"
    }, formatMessage((0, $hFECI.default).generating)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: ()=>onDismiss(false)
    }, formatMessage((0, $hFECI.default).cancel)))), !isLoading && adfContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7kcqV.AITelepointerWrapper), {
        hideTelepointer: isComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5oqj.default), {
        document: adfContent
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: ()=>onDismiss(true),
        isDisabled: !isComplete
    }, formatMessage((0, $hFECI.default).discard)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: onInsertClick,
        isDisabled: !isComplete
    }, formatMessage((0, $hFECI.default).insert))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2YBWI.AiFooter), {
        testId: "canned-comments.ui.ai-comments.ai-generated-comment.footer",
        isBeta: !isLoading,
        showDisclaimer: !isLoading,
        showAttributionLink: true
    }));
};
var $66e1cae4cd473cf3$export$2e2bcd8739ae039 = $66e1cae4cd473cf3$var$AIGeneratedComment;

});
parcelRegister("7kcqV", function(module, exports) {

$parcel$export(module.exports, "AITelepointerWrapper", () => $bd082ba3dd9909fd$export$e372ffc7075fd6f3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $bd082ba3dd9909fd$var$telepointerStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    position: 'absolute',
    width: '1.5px',
    height: '25px',
    background: 'linear-gradient(45deg, #F8E6A0 -12.02%, #8BDBE5 19.18%, #0C66E4 71.87%)',
    marginLeft: 'space.025',
    marginTop: 'space.negative.100',
    '::after': {
        content: '"AI"',
        position: 'absolute',
        display: 'block',
        top: 'space.0',
        left: 'space.0',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '10px',
        fontWeight: 'font.weight.bold',
        width: '12.5px',
        height: '13px',
        paddingTop: 'space.025',
        paddingLeft: 'space.025',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'initial',
        borderRadius: '0px 2px 2px 0px',
        color: 'color.text.inverse',
        background: 'linear-gradient(45deg, #8BDBE5 -57%, #0C66E4 71.87%)'
    }
});
const $bd082ba3dd9909fd$var$isAValidContainer = (node)=>{
    if (node.hasChildNodes() && node.lastChild?.nodeType !== Node.TEXT_NODE) return true;
    return false;
};
const $bd082ba3dd9909fd$var$getNestedLastChild = (originNode)=>{
    if ($bd082ba3dd9909fd$var$isAValidContainer(originNode) && originNode.lastChild) return $bd082ba3dd9909fd$var$getNestedLastChild(originNode.lastChild);
    else if (originNode.textContent === '' && originNode.parentNode) return originNode.parentNode;
    else return originNode;
};
const $bd082ba3dd9909fd$export$e372ffc7075fd6f3 = ({ hideTelepointer: hideTelepointer = false, children: children })=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const telepointerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!hideTelepointer) {
            const renderer = containerRef.current;
            if (renderer.lastChild && telepointerRef.current) $bd082ba3dd9909fd$var$getNestedLastChild(renderer.lastChild).appendChild(telepointerRef.current);
        }
    }, [
        children,
        hideTelepointer
    ]);
    if (hideTelepointer) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                as: "span",
                ref: telepointerRef,
                xcss: $bd082ba3dd9909fd$var$telepointerStyles,
                testId: "ai-telepointer-cursor"
            }),
            children
        ]
    });
};

});

parcelRegister("anQnI", function(module, exports) {

$parcel$export(module.exports, "useAIMockStreaming", () => $2e2aed8512256f5e$export$400bbe8ab4bcbef3);

var $5uXOq = parcelRequire("5uXOq");
const $2e2aed8512256f5e$export$400bbe8ab4bcbef3 = (content, totalDuration = 1000, intervalDuration = 50)=>{
    const [delayedContent, setDelayedContent] = (0, $5uXOq.useState)('');
    const [isComplete, setIsComplete] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const contentLength = content?.length || 0;
        const numberOfUpdates = totalDuration / intervalDuration;
        const increment = Math.ceil(contentLength / numberOfUpdates);
        let currentIndex = 0;
        let interval;
        if (content?.length) interval = setInterval(()=>{
            currentIndex += increment;
            if (currentIndex >= contentLength) {
                currentIndex = contentLength;
                clearInterval(interval);
                setIsComplete(true);
            }
            setDelayedContent(content.slice(0, currentIndex));
        }, intervalDuration);
        return ()=>clearInterval(interval);
    }, [
        content,
        intervalDuration,
        totalDuration
    ]);
    return {
        delayedContent: delayedContent,
        isComplete: isComplete
    };
};

});

parcelRegister("37QwF", function(module, exports) {

$parcel$export(module.exports, "isAdfContent", () => $0e5f1c394260ab83$export$d801201dc544181);
$parcel$export(module.exports, "appendContent", () => $0e5f1c394260ab83$export$a236f395afded7e0);
$parcel$export(module.exports, "encodeAdf", () => $0e5f1c394260ab83$export$53ded0b846f45216);

var $dPSMN = parcelRequire("dPSMN");

var $K5Jsy = parcelRequire("K5Jsy");

var $kaMno = parcelRequire("kaMno");
const $0e5f1c394260ab83$export$d801201dc544181 = (content)=>{
    /*
	This try-catch is a necessary guard rail against broken content to prevent higher level
	error boundaries from displaying the error and breaking the experience.
	*/ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $0e5f1c394260ab83$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($0e5f1c394260ab83$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $0e5f1c394260ab83$var$pluginConfig = {
    linkify: {
        findFilepaths: $dPSMN.findFilepaths,
        isLinkInMatches: $dPSMN.isLinkInMatches
    },
    smartLinks: {
        regexStorage: $parcel$global.localStorage
    }
};
const $0e5f1c394260ab83$export$3374c63d7715b4ce = new (0, $K5Jsy.ADFEncoder)((schema)=>new (0, $kaMno.AiMateMarkdownTransformer)(schema, $0e5f1c394260ab83$var$pluginConfig, false));
const $0e5f1c394260ab83$var$streamingAdfEncoder = new (0, $K5Jsy.ADFEncoder)((schema)=>new (0, $kaMno.AiMateMarkdownTransformer)(schema, $0e5f1c394260ab83$var$pluginConfig, true));
const $0e5f1c394260ab83$export$53ded0b846f45216 = (content, streaming = false)=>{
    if ($0e5f1c394260ab83$export$d801201dc544181(content)) return content;
    return streaming ? $0e5f1c394260ab83$var$streamingAdfEncoder.encode(content) : $0e5f1c394260ab83$export$3374c63d7715b4ce.encode(content);
};

});
parcelRegister("dPSMN", function(module, exports) {

$parcel$export(module.exports, "LinkMatcher", () => $c71efdd24f85e7a0$export$4490385c12bf3d4);
$parcel$export(module.exports, "normalizeUrl", () => $c71efdd24f85e7a0$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "linkifyContent", () => $c71efdd24f85e7a0$export$5a511fa58fab15e6);
$parcel$export(module.exports, "findFilepaths", () => $c71efdd24f85e7a0$export$d37783fe63e2f0fe);
$parcel$export(module.exports, "isLinkInMatches", () => $c71efdd24f85e7a0$export$5e652e74655163e5);
$parcel$export(module.exports, "getLinkDomain", () => $c71efdd24f85e7a0$export$238a6141b3685c21);
$parcel$export(module.exports, "isFromCurrentDomain", () => $c71efdd24f85e7a0$export$336c6a47b1dfa1bc);
$parcel$export(module.exports, "getLinkCreationAnalyticsEvent", () => $c71efdd24f85e7a0$export$56039faad4eda709);
$parcel$export(module.exports, "canLinkBeCreatedInRange", () => $c71efdd24f85e7a0$export$b7392a423e62dc8c);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/utils/hyperlink.ts
// If changes are made to this file, please make the same update in the linked file.

var $iZOJ9 = parcelRequire("iZOJ9");

var $VSDnB = parcelRequire("VSDnB");

var $gkwXh = parcelRequire("gkwXh");

var $gOwky = parcelRequire("gOwky");

var $7vpuQ = parcelRequire("7vpuQ");
const $c71efdd24f85e7a0$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $c71efdd24f85e7a0$export$dabcc234035f6703 = /^(\$|{)/;
class $c71efdd24f85e7a0$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ($c71efdd24f85e7a0$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                const links = (0, $iZOJ9.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
function $c71efdd24f85e7a0$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $iZOJ9.isSafeUrl)(url)) return url;
    return (0, $iZOJ9.normalizeUrl)(url);
}
function $c71efdd24f85e7a0$export$5a511fa58fab15e6(schema) {
    return (slice)=>(0, $7vpuQ.mapSlice)(slice, (node, parent)=>{
            const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            const link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                const linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const text = node.text;
                const matches = $c71efdd24f85e7a0$var$findLinkMatches(text).filter((0, $gOwky.shouldAutoLinkifyMatch));
                let pos = 0;
                const filepaths = $c71efdd24f85e7a0$export$d37783fe63e2f0fe(text);
                matches.forEach((match)=>{
                    if ($c71efdd24f85e7a0$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $c71efdd24f85e7a0$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
}
function $c71efdd24f85e7a0$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    const currentDomain = window.location.hostname;
    const linkDomain = $c71efdd24f85e7a0$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $c71efdd24f85e7a0$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $iZOJ9.linkify).match(text) || [];
}
const $c71efdd24f85e7a0$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($c71efdd24f85e7a0$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $c71efdd24f85e7a0$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $c71efdd24f85e7a0$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $gkwXh.ACTION).INSERTED,
        actionSubject: (0, $gkwXh.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $gkwXh.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $gkwXh.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $c71efdd24f85e7a0$export$238a6141b3685c21(url)
        }
    };
}
const $c71efdd24f85e7a0$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        const hasInlineCard = node.type === state.schema.nodes.inlineCard && (0, $VSDnB.fg)('platform_editor_controls_patch_11');
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link)) && !hasInlineCard;
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };

});
parcelRegister("gOwky", function(module, exports) {

$parcel$export(module.exports, "shouldAutoLinkifyMatch", () => $a8453eeff8b41d2c$export$e19a09e301eaa6bb);
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ const $a8453eeff8b41d2c$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $a8453eeff8b41d2c$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        const hostname = new URL(`https://${url}`).hostname;
        const parts = hostname.split('.');
        const tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$a8453eeff8b41d2c$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $a8453eeff8b41d2c$export$e19a09e301eaa6bb(match) {
    return $a8453eeff8b41d2c$export$977fe75b90bdd614(match.raw);
}

});

parcelRegister("7vpuQ", function(module, exports) {

$parcel$export(module.exports, "getFragmentBackingArray", () => $cd200aea723473fd$export$7b8536c35e9eb7d2);
$parcel$export(module.exports, "mapFragment", () => $cd200aea723473fd$export$81fe6b3b714fd0bf);
$parcel$export(module.exports, "mapSlice", () => $cd200aea723473fd$export$d8264570c5933bbf);
$parcel$export(module.exports, "flatmap", () => $cd200aea723473fd$export$c575791007f9dbd1);
$parcel$export(module.exports, "mapChildren", () => $cd200aea723473fd$export$e0baa27f47733a4a);

var $kCV8T = parcelRequire("kCV8T");
function $cd200aea723473fd$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $cd200aea723473fd$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($cd200aea723473fd$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $kCV8T.Fragment)) children.push(...$cd200aea723473fd$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $kCV8T.Fragment).fromArray(children);
}
function $cd200aea723473fd$export$d8264570c5933bbf(slice, callback) {
    const fragment = $cd200aea723473fd$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $kCV8T.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $cd200aea723473fd$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $kCV8T.Fragment).fromArray(fragmentContent);
}
function $cd200aea723473fd$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $kCV8T.Fragment) ? node : node.content));
    return array;
}
const $cd200aea723473fd$var$findNode = (predicate)=>(slice)=>{
        let foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
const $cd200aea723473fd$export$b6ae752d7894ad08 = (predicate)=>(slice)=>{
        return !!$cd200aea723473fd$var$findNode(predicate)(slice);
    };

});


parcelRegister("kaMno", function(module, exports) {

$parcel$export(module.exports, "AiMateMarkdownTransformer", () => $0757ea382637289c$export$614853bf2169db97);

var $ivSSX = parcelRequire("ivSSX");

var $4iMad = parcelRequire("4iMad");

var $38KaN = parcelRequire("38KaN");

var $6fRr3 = parcelRequire("6fRr3");

var $kCV8T = parcelRequire("kCV8T");

var $VSDnB = parcelRequire("VSDnB");

var $kboGB = parcelRequire("kboGB");

var $lKkRz = parcelRequire("lKkRz");

var $3p5rU = parcelRequire("3p5rU");

var $htzpC = parcelRequire("htzpC");

var $8ZEpI = parcelRequire("8ZEpI");

var $muDJ0 = parcelRequire("muDJ0");

var $7zJFX = parcelRequire("7zJFX");

var $btItw = parcelRequire("btItw");

var $4bKco = parcelRequire("4bKco");
class $0757ea382637289c$export$614853bf2169db97 extends (0, $38KaN.MarkdownTransformer) {
    constructor(schema, pluginConfig, streaming){
        super();
        const md = (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $4bKco.enableSchemaPlugins)(md, schema);
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $3p5rU.createLinkifyPlugin)(pluginConfig.linkify));
        md.use((0, $kboGB.default));
        if ((0, $VSDnB.fg)('rovo_enable_data_sculptor')) md.use((0, $lKkRz.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) md.use((0, $muDJ0.createSmartLinksPlugin)(pluginConfig.smartLinks));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $8ZEpI.default));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $4iMad.markdownItTable));
            if ((0, $VSDnB.fg)('rovo_chat_enable_markdown_table_break_tags')) md.use((0, $7zJFX.default));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $htzpC.default));
        const filter = (0, $4bKco.filterSchemaMapping)(schema, (0, $btItw.mdToPmSchema));
        this.parser = new (0, $6fRr3.MarkdownParser)(schema, md, filter);
    }
    parse(content) {
        const node = this.parser.parse(content);
        if (!node) return new (0, $kCV8T.Node)();
        return node;
    }
}

});
parcelRegister("ivSSX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7fjdG"));

});
parcelRegister("7fjdG", function(module, exports) {
// Main parser class
'use strict';

var $lKlAe = parcelRequire("lKlAe");

var $1mGdb = parcelRequire("1mGdb");

var $keGIi = parcelRequire("keGIi");

var $aVlnc = parcelRequire("aVlnc");

var $81Ci5 = parcelRequire("81Ci5");

var $58y21 = parcelRequire("58y21");

var $43kHv = parcelRequire("43kHv");

var $aK6mt = parcelRequire("aK6mt");

var $k7qPZ = parcelRequire("k7qPZ");



var $5468d7bb65d238e2$var$config = {
    default: (parcelRequire("gcpUf")),
    zero: (parcelRequire("hbvGf")),
    commonmark: (parcelRequire("8Ubo6"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $5468d7bb65d238e2$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $5468d7bb65d238e2$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $5468d7bb65d238e2$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $5468d7bb65d238e2$var$BAD_PROTO_RE.test(str) ? $5468d7bb65d238e2$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $5468d7bb65d238e2$var$normalizeLink(url) {
    var parsed = $aK6mt.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $k7qPZ.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $aK6mt.encode($aK6mt.format(parsed));
}
function $5468d7bb65d238e2$var$normalizeLinkText(url) {
    var parsed = $aK6mt.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $k7qPZ.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $aK6mt.decode($aK6mt.format(parsed), $aK6mt.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $5468d7bb65d238e2$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $5468d7bb65d238e2$var$MarkdownIt)) return new $5468d7bb65d238e2$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$lKlAe.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $58y21();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $81Ci5();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $aVlnc();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $keGIi();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $43kHv();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $5468d7bb65d238e2$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $5468d7bb65d238e2$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $5468d7bb65d238e2$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $lKlAe;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $lKlAe.assign({}, $1mGdb);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.set = function(options) {
    $lKlAe.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($lKlAe.isString(presets)) {
        presetName = presets;
        presets = $5468d7bb65d238e2$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $5468d7bb65d238e2$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $5468d7bb65d238e2$var$MarkdownIt;

});
parcelRegister("lKlAe", function(module, exports) {

$parcel$export(module.exports, "lib", () => $fd4ea2dc11e83b2a$export$16c08b91f883959a, (v) => $fd4ea2dc11e83b2a$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $fd4ea2dc11e83b2a$export$e6e34fd1f2686227, (v) => $fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $fd4ea2dc11e83b2a$export$844ec244b1367d54, (v) => $fd4ea2dc11e83b2a$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5, (v) => $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03, (v) => $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c, (v) => $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d, (v) => $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $fd4ea2dc11e83b2a$export$73bfc63873071f74, (v) => $fd4ea2dc11e83b2a$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8, (v) => $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $fd4ea2dc11e83b2a$export$f78478f71955b6bc, (v) => $fd4ea2dc11e83b2a$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $fd4ea2dc11e83b2a$export$1d5ccafae59b4926, (v) => $fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $fd4ea2dc11e83b2a$export$3c52dd84024ae72c, (v) => $fd4ea2dc11e83b2a$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $fd4ea2dc11e83b2a$export$829a0d33ae4e744, (v) => $fd4ea2dc11e83b2a$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $fd4ea2dc11e83b2a$export$4888a643af800fc1, (v) => $fd4ea2dc11e83b2a$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d, (v) => $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $fd4ea2dc11e83b2a$export$20ef46802c8744b, (v) => $fd4ea2dc11e83b2a$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $fd4ea2dc11e83b2a$export$16c08b91f883959a;
var $fd4ea2dc11e83b2a$export$e6e34fd1f2686227;
var $fd4ea2dc11e83b2a$export$844ec244b1367d54;
var $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5;
var $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03;
var $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c;
var $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d;
var $fd4ea2dc11e83b2a$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8;
var $fd4ea2dc11e83b2a$export$f78478f71955b6bc;
var $fd4ea2dc11e83b2a$export$1d5ccafae59b4926;
var $fd4ea2dc11e83b2a$export$3c52dd84024ae72c;
var $fd4ea2dc11e83b2a$export$829a0d33ae4e744;
var $fd4ea2dc11e83b2a$export$4888a643af800fc1;
var $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d;
var $fd4ea2dc11e83b2a$export$20ef46802c8744b;
'use strict';
function $fd4ea2dc11e83b2a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $fd4ea2dc11e83b2a$var$isString(obj) {
    return $fd4ea2dc11e83b2a$var$_class(obj) === '[object String]';
}
var $fd4ea2dc11e83b2a$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $fd4ea2dc11e83b2a$var$has(object, key) {
    return $fd4ea2dc11e83b2a$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $fd4ea2dc11e83b2a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $fd4ea2dc11e83b2a$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $fd4ea2dc11e83b2a$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $fd4ea2dc11e83b2a$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $fd4ea2dc11e83b2a$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE = new RegExp($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE.source + '|' + $fd4ea2dc11e83b2a$var$ENTITY_RE.source, 'gi');
var $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $7MxGI = parcelRequire("7MxGI");
function $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, name) {
    var code;
    if ($fd4ea2dc11e83b2a$var$has($7MxGI, name)) return $7MxGI[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($fd4ea2dc11e83b2a$var$isValidEntityCode(code)) return $fd4ea2dc11e83b2a$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $fd4ea2dc11e83b2a$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE, '$1');
}
function $fd4ea2dc11e83b2a$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $fd4ea2dc11e83b2a$var$replaceUnsafeChar(ch) {
    return $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS[ch];
}
function $fd4ea2dc11e83b2a$var$escapeHtml(str) {
    if ($fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE, $fd4ea2dc11e83b2a$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $fd4ea2dc11e83b2a$var$escapeRE(str) {
    return str.replace($fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $fd4ea2dc11e83b2a$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $fd4ea2dc11e83b2a$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $9bBmm = parcelRequire("9bBmm");
// Currently without astral characters support.
function $fd4ea2dc11e83b2a$var$isPunctChar(ch) {
    return $9bBmm.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $fd4ea2dc11e83b2a$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $fd4ea2dc11e83b2a$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$fd4ea2dc11e83b2a$export$16c08b91f883959a = {};

$fd4ea2dc11e83b2a$export$16c08b91f883959a.mdurl = (parcelRequire("aK6mt"));

$fd4ea2dc11e83b2a$export$16c08b91f883959a.ucmicro = (parcelRequire("7G9dc"));
$fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = $fd4ea2dc11e83b2a$var$assign;
$fd4ea2dc11e83b2a$export$844ec244b1367d54 = $fd4ea2dc11e83b2a$var$isString;
$fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = $fd4ea2dc11e83b2a$var$has;
$fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = $fd4ea2dc11e83b2a$var$unescapeMd;
$fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = $fd4ea2dc11e83b2a$var$unescapeAll;
$fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = $fd4ea2dc11e83b2a$var$isValidEntityCode;
$fd4ea2dc11e83b2a$export$73bfc63873071f74 = $fd4ea2dc11e83b2a$var$fromCodePoint;
$fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = $fd4ea2dc11e83b2a$var$escapeHtml;
$fd4ea2dc11e83b2a$export$f78478f71955b6bc = $fd4ea2dc11e83b2a$var$arrayReplaceAt;
$fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = $fd4ea2dc11e83b2a$var$isSpace;
$fd4ea2dc11e83b2a$export$3c52dd84024ae72c = $fd4ea2dc11e83b2a$var$isWhiteSpace;
$fd4ea2dc11e83b2a$export$829a0d33ae4e744 = $fd4ea2dc11e83b2a$var$isMdAsciiPunct;
$fd4ea2dc11e83b2a$export$4888a643af800fc1 = $fd4ea2dc11e83b2a$var$isPunctChar;
$fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = $fd4ea2dc11e83b2a$var$escapeRE;
$fd4ea2dc11e83b2a$export$20ef46802c8744b = $fd4ea2dc11e83b2a$var$normalizeReference;

});
parcelRegister("7MxGI", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("5mepl"));

});
parcelRegister("5mepl", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"\\/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("aK6mt", function(module, exports) {

$parcel$export(module.exports, "encode", () => $7d2322841b1ac049$export$c564cdbbe6da493, (v) => $7d2322841b1ac049$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $7d2322841b1ac049$export$2f872c0f2117be69, (v) => $7d2322841b1ac049$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $7d2322841b1ac049$export$d9468344d3651243, (v) => $7d2322841b1ac049$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $7d2322841b1ac049$export$98e6a39c04603d36, (v) => $7d2322841b1ac049$export$98e6a39c04603d36 = v);
var $7d2322841b1ac049$export$c564cdbbe6da493;
var $7d2322841b1ac049$export$2f872c0f2117be69;
var $7d2322841b1ac049$export$d9468344d3651243;
var $7d2322841b1ac049$export$98e6a39c04603d36;
'use strict';

$7d2322841b1ac049$export$c564cdbbe6da493 = (parcelRequire("6jTHo"));

$7d2322841b1ac049$export$2f872c0f2117be69 = (parcelRequire("qpEB3"));

$7d2322841b1ac049$export$d9468344d3651243 = (parcelRequire("3yKUv"));

$7d2322841b1ac049$export$98e6a39c04603d36 = (parcelRequire("bQztL"));

});
parcelRegister("6jTHo", function(module, exports) {
'use strict';
var $499fb90cb213ebc3$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $499fb90cb213ebc3$var$getEncodeCache(exclude) {
    var i, ch, cache = $499fb90cb213ebc3$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $499fb90cb213ebc3$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $499fb90cb213ebc3$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $499fb90cb213ebc3$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $499fb90cb213ebc3$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$499fb90cb213ebc3$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$499fb90cb213ebc3$var$encode.componentChars = "-_.!~*'()";
module.exports = $499fb90cb213ebc3$var$encode;

});

parcelRegister("qpEB3", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $04f654215177967d$var$decodeCache = {};
function $04f654215177967d$var$getDecodeCache(exclude) {
    var i, ch, cache = $04f654215177967d$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $04f654215177967d$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $04f654215177967d$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $04f654215177967d$var$decode.defaultChars;
    cache = $04f654215177967d$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$04f654215177967d$var$decode.defaultChars = ';/?:@&=+$,#';
$04f654215177967d$var$decode.componentChars = '';
module.exports = $04f654215177967d$var$decode;

});

parcelRegister("3yKUv", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("bQztL", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $8a0012734669979b$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $8a0012734669979b$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $8a0012734669979b$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$8a0012734669979b$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$8a0012734669979b$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$8a0012734669979b$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($8a0012734669979b$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$8a0012734669979b$var$autoEscape = [
    '\''
].concat($8a0012734669979b$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$8a0012734669979b$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($8a0012734669979b$var$autoEscape), $8a0012734669979b$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $8a0012734669979b$var$hostnameMaxLen = 255, $8a0012734669979b$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $8a0012734669979b$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$8a0012734669979b$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$8a0012734669979b$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $8a0012734669979b$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $8a0012734669979b$var$Url) return url;
    var u = new $8a0012734669979b$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$8a0012734669979b$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $8a0012734669979b$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $8a0012734669979b$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $8a0012734669979b$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$8a0012734669979b$var$hostlessProtocol[proto] && (slashes || proto && !$8a0012734669979b$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $8a0012734669979b$var$hostEndingChars.length; i++){
            hec = rest.indexOf($8a0012734669979b$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $8a0012734669979b$var$nonHostChars.length; i++){
            hec = rest.indexOf($8a0012734669979b$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($8a0012734669979b$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($8a0012734669979b$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($8a0012734669979b$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $8a0012734669979b$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($8a0012734669979b$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$8a0012734669979b$var$Url.prototype.parseHost = function(host) {
    var port = $8a0012734669979b$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $8a0012734669979b$var$urlParse;

});


parcelRegister("7G9dc", function(module, exports) {

$parcel$export(module.exports, "Any", () => $597399ee2a9a2974$export$b24b633b1364b94b, (v) => $597399ee2a9a2974$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $597399ee2a9a2974$export$15dafbac7aec8a57, (v) => $597399ee2a9a2974$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $597399ee2a9a2974$export$239cff0cce87eb56, (v) => $597399ee2a9a2974$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $597399ee2a9a2974$export$56c0d5a1e737357d, (v) => $597399ee2a9a2974$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $597399ee2a9a2974$export$dc98b0b04f4c7758, (v) => $597399ee2a9a2974$export$dc98b0b04f4c7758 = v);
var $597399ee2a9a2974$export$b24b633b1364b94b;
var $597399ee2a9a2974$export$15dafbac7aec8a57;
var $597399ee2a9a2974$export$239cff0cce87eb56;
var $597399ee2a9a2974$export$56c0d5a1e737357d;
var $597399ee2a9a2974$export$dc98b0b04f4c7758;
'use strict';

$597399ee2a9a2974$export$b24b633b1364b94b = (parcelRequire("b9ep3"));

$597399ee2a9a2974$export$15dafbac7aec8a57 = (parcelRequire("23ErL"));

$597399ee2a9a2974$export$239cff0cce87eb56 = (parcelRequire("i4n2C"));

$597399ee2a9a2974$export$56c0d5a1e737357d = (parcelRequire("9bBmm"));

$597399ee2a9a2974$export$dc98b0b04f4c7758 = (parcelRequire("oRY4m"));

});
parcelRegister("i4n2C", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("1mGdb", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $0fe896e38fc1beac$export$2a2c8612930e58d0, (v) => $0fe896e38fc1beac$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $0fe896e38fc1beac$export$22bd24080f95f2b3, (v) => $0fe896e38fc1beac$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $0fe896e38fc1beac$export$89650c5477a69db9, (v) => $0fe896e38fc1beac$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $0fe896e38fc1beac$export$2a2c8612930e58d0;
var $0fe896e38fc1beac$export$22bd24080f95f2b3;
var $0fe896e38fc1beac$export$89650c5477a69db9;
'use strict';

$0fe896e38fc1beac$export$2a2c8612930e58d0 = (parcelRequire("8y5kB"));

$0fe896e38fc1beac$export$22bd24080f95f2b3 = (parcelRequire("guwA0"));

$0fe896e38fc1beac$export$89650c5477a69db9 = (parcelRequire("9bSCV"));

});
parcelRegister("8y5kB", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("guwA0", function(module, exports) {
// Parse link destination
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $c018b854bcc71549$require$unescapeAll = $lKlAe.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("9bSCV", function(module, exports) {
// Parse link title
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $6b0f83e20702a9d5$require$unescapeAll = $lKlAe.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $6b0f83e20702a9d5$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("keGIi", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$assign = $lKlAe.assign;

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$unescapeAll = $lKlAe.unescapeAll;

var $lKlAe = parcelRequire("lKlAe");
var $ebb63f71260e6c54$require$escapeHtml = $lKlAe.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $ebb63f71260e6c54$var$default_rules = {};
$ebb63f71260e6c54$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $ebb63f71260e6c54$require$escapeHtml(token.content) + '</code>';
};
$ebb63f71260e6c54$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$ebb63f71260e6c54$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $ebb63f71260e6c54$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $ebb63f71260e6c54$require$escapeHtml(token.content);
    else highlighted = $ebb63f71260e6c54$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$ebb63f71260e6c54$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$ebb63f71260e6c54$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$ebb63f71260e6c54$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$ebb63f71260e6c54$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content);
};
$ebb63f71260e6c54$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$ebb63f71260e6c54$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $ebb63f71260e6c54$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $ebb63f71260e6c54$require$assign({}, $ebb63f71260e6c54$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][0]) + '="' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $ebb63f71260e6c54$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $ebb63f71260e6c54$var$Renderer;

});

parcelRegister("aVlnc", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");







var $7f3fce7f6016210f$var$_rules = [
    [
        'normalize',
        (parcelRequire("iWx6a"))
    ],
    [
        'block',
        (parcelRequire("iY2Wj"))
    ],
    [
        'inline',
        (parcelRequire("16b9L"))
    ],
    [
        'linkify',
        (parcelRequire("lOz8R"))
    ],
    [
        'replacements',
        (parcelRequire("45Efy"))
    ],
    [
        'smartquotes',
        (parcelRequire("6sbf2"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("jEa7S"))
    ]
];
/**
 * new Core()
 **/ function $7f3fce7f6016210f$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $3sin6();
    for(var i = 0; i < $7f3fce7f6016210f$var$_rules.length; i++)this.ruler.push($7f3fce7f6016210f$var$_rules[i][0], $7f3fce7f6016210f$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $7f3fce7f6016210f$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$7f3fce7f6016210f$var$Core.prototype.State = (parcelRequire("dRBf6"));
module.exports = $7f3fce7f6016210f$var$Core;

});
parcelRegister("3sin6", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $28423cd2f7c52093$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$28423cd2f7c52093$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$28423cd2f7c52093$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $28423cd2f7c52093$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $28423cd2f7c52093$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $28423cd2f7c52093$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $28423cd2f7c52093$var$Ruler;

});

parcelRegister("iWx6a", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $dca7516ecd2cb0cd$var$NEWLINES_RE = /\r\n?|\n/g;
var $dca7516ecd2cb0cd$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($dca7516ecd2cb0cd$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($dca7516ecd2cb0cd$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("iY2Wj", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("16b9L", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("lOz8R", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $fe1986eb06b8c500$require$arrayReplaceAt = $lKlAe.arrayReplaceAt;
function $fe1986eb06b8c500$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $fe1986eb06b8c500$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($fe1986eb06b8c500$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($fe1986eb06b8c500$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $fe1986eb06b8c500$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("45Efy", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $2fa6d9dae6dddfa0$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $2fa6d9dae6dddfa0$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $2fa6d9dae6dddfa0$var$replaceFn(match, name) {
    return $2fa6d9dae6dddfa0$var$SCOPED_ABBR[name.toLowerCase()];
}
function $2fa6d9dae6dddfa0$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE, $2fa6d9dae6dddfa0$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $2fa6d9dae6dddfa0$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($2fa6d9dae6dddfa0$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_scoped(state.tokens[blkIdx].children);
        if ($2fa6d9dae6dddfa0$var$RARE_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("6sbf2", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isWhiteSpace = $lKlAe.isWhiteSpace;

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isPunctChar = $lKlAe.isPunctChar;

var $lKlAe = parcelRequire("lKlAe");
var $4b2e13ec30356b37$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
var $4b2e13ec30356b37$var$QUOTE_TEST_RE = /['"]/;
var $4b2e13ec30356b37$var$QUOTE_RE = /['"]/g;
var $4b2e13ec30356b37$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $4b2e13ec30356b37$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $4b2e13ec30356b37$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $4b2e13ec30356b37$var$QUOTE_RE.lastIndex = pos;
            t = $4b2e13ec30356b37$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(lastChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(nextChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $4b2e13ec30356b37$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$4b2e13ec30356b37$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $4b2e13ec30356b37$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("jEa7S", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("dRBf6", function(module, exports) {
// Core state object
//
'use strict';

var $jwpQf = parcelRequire("jwpQf");
function $a17d1d317b1d68ad$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$a17d1d317b1d68ad$var$StateCore.prototype.Token = $jwpQf;
module.exports = $a17d1d317b1d68ad$var$StateCore;

});
parcelRegister("jwpQf", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $e3650d20fdc1ba98$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $e3650d20fdc1ba98$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $e3650d20fdc1ba98$var$Token;

});



parcelRegister("81Ci5", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");











var $5d7c1e72b0aff81a$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("gSwCe")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("dHrHm"))
    ],
    [
        'fence',
        (parcelRequire("1KHgS")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("79uLo")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("a0gIO")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("bFPxW")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("6Cm2K"))
    ],
    [
        'html_block',
        (parcelRequire("3IX6c")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("5VRwl")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("2v0Kv"))
    ],
    [
        'paragraph',
        (parcelRequire("d0isB"))
    ]
];
/**
 * new ParserBlock()
 **/ function $5d7c1e72b0aff81a$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $3sin6();
    for(var i = 0; i < $5d7c1e72b0aff81a$var$_rules.length; i++)this.ruler.push($5d7c1e72b0aff81a$var$_rules[i][0], $5d7c1e72b0aff81a$var$_rules[i][1], {
        alt: ($5d7c1e72b0aff81a$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$5d7c1e72b0aff81a$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $5d7c1e72b0aff81a$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$5d7c1e72b0aff81a$var$ParserBlock.prototype.State = (parcelRequire("l865e"));
module.exports = $5d7c1e72b0aff81a$var$ParserBlock;

});
parcelRegister("gSwCe", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $c49afd4af32a69df$require$isSpace = $lKlAe.isSpace;
function $c49afd4af32a69df$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $c49afd4af32a69df$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$c49afd4af32a69df$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $c49afd4af32a69df$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$c49afd4af32a69df$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $c49afd4af32a69df$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $c49afd4af32a69df$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $c49afd4af32a69df$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $c49afd4af32a69df$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $c49afd4af32a69df$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("dHrHm", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("1KHgS", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("79uLo", function(module, exports) {
// Block quotes
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $53513ca36aaad8c7$require$isSpace = $lKlAe.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($53513ca36aaad8c7$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("a0gIO", function(module, exports) {
// Horizontal rule
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $7486e013b11c48f5$require$isSpace = $lKlAe.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$7486e013b11c48f5$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("bFPxW", function(module, exports) {
// Lists
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $87fb82138ea80db7$require$isSpace = $lKlAe.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $87fb82138ea80db7$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$87fb82138ea80db7$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $87fb82138ea80db7$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$87fb82138ea80db7$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $87fb82138ea80db7$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $87fb82138ea80db7$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("6Cm2K", function(module, exports) {
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $4d1764068d639a24$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $4d1764068d639a24$require$isSpace = $lKlAe.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($4d1764068d639a24$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($4d1764068d639a24$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$4d1764068d639a24$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$4d1764068d639a24$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $4d1764068d639a24$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("3IX6c", function(module, exports) {
// HTML block
'use strict';

var $9Jgti = parcelRequire("9Jgti");

var $1RRsU = parcelRequire("1RRsU");
var $2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE = $1RRsU.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $2b6352f7d75b50f9$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $9Jgti.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $2b6352f7d75b50f9$var$HTML_SEQUENCES.length; i++){
        if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $2b6352f7d75b50f9$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $2b6352f7d75b50f9$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("9Jgti", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("1RRsU", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $15c436cb9ae50f13$export$6db61d2c3a16e419, (v) => $15c436cb9ae50f13$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $15c436cb9ae50f13$export$cd48660d06f74639, (v) => $15c436cb9ae50f13$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $15c436cb9ae50f13$export$6db61d2c3a16e419;
var $15c436cb9ae50f13$export$cd48660d06f74639;
'use strict';
var $15c436cb9ae50f13$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $15c436cb9ae50f13$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $15c436cb9ae50f13$var$single_quoted = "'[^']*'";
var $15c436cb9ae50f13$var$double_quoted = '"[^"]*"';
var $15c436cb9ae50f13$var$attr_value = '(?:' + $15c436cb9ae50f13$var$unquoted + '|' + $15c436cb9ae50f13$var$single_quoted + '|' + $15c436cb9ae50f13$var$double_quoted + ')';
var $15c436cb9ae50f13$var$attribute = '(?:\\s+' + $15c436cb9ae50f13$var$attr_name + '(?:\\s*=\\s*' + $15c436cb9ae50f13$var$attr_value + ')?)';
var $15c436cb9ae50f13$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $15c436cb9ae50f13$var$attribute + '*\\s*\\/?>';
var $15c436cb9ae50f13$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $15c436cb9ae50f13$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $15c436cb9ae50f13$var$processing = '<[?][\\s\\S]*?[?]>';
var $15c436cb9ae50f13$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $15c436cb9ae50f13$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $15c436cb9ae50f13$var$HTML_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + '|' + $15c436cb9ae50f13$var$comment + '|' + $15c436cb9ae50f13$var$processing + '|' + $15c436cb9ae50f13$var$declaration + '|' + $15c436cb9ae50f13$var$cdata + ')');
var $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + ')');
$15c436cb9ae50f13$export$6db61d2c3a16e419 = $15c436cb9ae50f13$var$HTML_TAG_RE;
$15c436cb9ae50f13$export$cd48660d06f74639 = $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("5VRwl", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $451bcab957a0998a$require$isSpace = $lKlAe.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$451bcab957a0998a$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $451bcab957a0998a$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("2v0Kv", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("d0isB", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("l865e", function(module, exports) {
// Parser state class
'use strict';

var $jwpQf = parcelRequire("jwpQf");

var $lKlAe = parcelRequire("lKlAe");
var $f61f10562433da3b$require$isSpace = $lKlAe.isSpace;
function $f61f10562433da3b$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($f61f10562433da3b$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$f61f10562433da3b$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $jwpQf(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$f61f10562433da3b$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$f61f10562433da3b$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$f61f10562433da3b$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$f61f10562433da3b$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$f61f10562433da3b$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$f61f10562433da3b$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$f61f10562433da3b$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$f61f10562433da3b$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$f61f10562433da3b$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($f61f10562433da3b$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$f61f10562433da3b$var$StateBlock.prototype.Token = $jwpQf;
module.exports = $f61f10562433da3b$var$StateBlock;

});


parcelRegister("58y21", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $3sin6 = parcelRequire("3sin6");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $3bd81911677b8252$var$_rules = [
    [
        'text',
        (parcelRequire("gc14M"))
    ],
    [
        'linkify',
        (parcelRequire("2aNBd"))
    ],
    [
        'newline',
        (parcelRequire("a490I"))
    ],
    [
        'escape',
        (parcelRequire("027TI"))
    ],
    [
        'backticks',
        (parcelRequire("27paT"))
    ],
    [
        'strikethrough',
        (parcelRequire("lBrF9")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("2MLmq")).tokenize
    ],
    [
        'link',
        (parcelRequire("frx2x"))
    ],
    [
        'image',
        (parcelRequire("iUeRh"))
    ],
    [
        'autolink',
        (parcelRequire("ktOwv"))
    ],
    [
        'html_inline',
        (parcelRequire("1jFGt"))
    ],
    [
        'entity',
        (parcelRequire("jd9ks"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $3bd81911677b8252$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("ey6sy"))
    ],
    [
        'strikethrough',
        (parcelRequire("lBrF9")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("2MLmq")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("hrHpd"))
    ]
];
/**
 * new ParserInline()
 **/ function $3bd81911677b8252$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $3sin6();
    for(i = 0; i < $3bd81911677b8252$var$_rules.length; i++)this.ruler.push($3bd81911677b8252$var$_rules[i][0], $3bd81911677b8252$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $3sin6();
    for(i = 0; i < $3bd81911677b8252$var$_rules2.length; i++)this.ruler2.push($3bd81911677b8252$var$_rules2[i][0], $3bd81911677b8252$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$3bd81911677b8252$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$3bd81911677b8252$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $3bd81911677b8252$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$3bd81911677b8252$var$ParserInline.prototype.State = (parcelRequire("82i7L"));
module.exports = $3bd81911677b8252$var$ParserInline;

});
parcelRegister("gc14M", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $bc9e9a00ea13b29d$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$bc9e9a00ea13b29d$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("2aNBd", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $1952fd4ef50e3f47$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($1952fd4ef50e3f47$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("a490I", function(module, exports) {
// Proceess '\n'
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $754144646e41a199$require$isSpace = $lKlAe.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $754144646e41a199$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("027TI", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $006650534e77ff18$require$isSpace = $lKlAe.isSpace;
var $006650534e77ff18$var$ESCAPED = [];
for(var $006650534e77ff18$var$i = 0; $006650534e77ff18$var$i < 256; $006650534e77ff18$var$i++)$006650534e77ff18$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $006650534e77ff18$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$006650534e77ff18$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $006650534e77ff18$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("27paT", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("lBrF9", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $fba282ec8c4eab24$export$660b2ee2d4fb4eff, (v) => $fba282ec8c4eab24$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $fba282ec8c4eab24$export$7b804a0e0ce836d9, (v) => $fba282ec8c4eab24$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $fba282ec8c4eab24$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $fba282ec8c4eab24$export$7b804a0e0ce836d9;
'use strict';
$fba282ec8c4eab24$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $fba282ec8c4eab24$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$fba282ec8c4eab24$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $fba282ec8c4eab24$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $fba282ec8c4eab24$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("2MLmq", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $2074cd535103ea35$export$660b2ee2d4fb4eff, (v) => $2074cd535103ea35$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $2074cd535103ea35$export$7b804a0e0ce836d9, (v) => $2074cd535103ea35$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $2074cd535103ea35$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $2074cd535103ea35$export$7b804a0e0ce836d9;
'use strict';
$2074cd535103ea35$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $2074cd535103ea35$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$2074cd535103ea35$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $2074cd535103ea35$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $2074cd535103ea35$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("frx2x", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $b3e301ae0b1788b5$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $b3e301ae0b1788b5$require$isSpace = $lKlAe.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$b3e301ae0b1788b5$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("iUeRh", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $lKlAe = parcelRequire("lKlAe");
var $dc38fb80f8b4f166$require$normalizeReference = $lKlAe.normalizeReference;

var $lKlAe = parcelRequire("lKlAe");
var $dc38fb80f8b4f166$require$isSpace = $lKlAe.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$dc38fb80f8b4f166$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("ktOwv", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $ee8db4fa9cfd6224$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $ee8db4fa9cfd6224$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($ee8db4fa9cfd6224$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($ee8db4fa9cfd6224$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("1jFGt", function(module, exports) {
// Process html tags
'use strict';

var $1RRsU = parcelRequire("1RRsU");
var $0f57e66455279f49$require$HTML_TAG_RE = $1RRsU.HTML_TAG_RE;
function $0f57e66455279f49$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $0f57e66455279f49$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $0f57e66455279f49$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$0f57e66455279f49$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($0f57e66455279f49$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($0f57e66455279f49$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($0f57e66455279f49$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("jd9ks", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $7MxGI = parcelRequire("7MxGI");

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$has = $lKlAe.has;

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$isValidEntityCode = $lKlAe.isValidEntityCode;

var $lKlAe = parcelRequire("lKlAe");
var $dfc677c78d4d441f$require$fromCodePoint = $lKlAe.fromCodePoint;
var $dfc677c78d4d441f$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $dfc677c78d4d441f$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($dfc677c78d4d441f$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $dfc677c78d4d441f$require$isValidEntityCode(code) ? $dfc677c78d4d441f$require$fromCodePoint(code) : $dfc677c78d4d441f$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($dfc677c78d4d441f$var$NAMED_RE);
        if (match) {
            if ($dfc677c78d4d441f$require$has($7MxGI, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $7MxGI[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("ey6sy", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $a979406325d16795$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a979406325d16795$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a979406325d16795$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("hrHpd", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("82i7L", function(module, exports) {
// Inline parser state
'use strict';

var $jwpQf = parcelRequire("jwpQf");

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isWhiteSpace = $lKlAe.isWhiteSpace;

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isPunctChar = $lKlAe.isPunctChar;

var $lKlAe = parcelRequire("lKlAe");
var $5d9c91befccde6a7$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
function $5d9c91befccde6a7$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$5d9c91befccde6a7$var$StateInline.prototype.pushPending = function() {
    var token = new $jwpQf('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$5d9c91befccde6a7$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $jwpQf(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$5d9c91befccde6a7$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(lastChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(nextChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$5d9c91befccde6a7$var$StateInline.prototype.Token = $jwpQf;
module.exports = $5d9c91befccde6a7$var$StateInline;

});


parcelRegister("43kHv", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $2f377ffd6e81380f$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $2f377ffd6e81380f$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $2f377ffd6e81380f$var$isString(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object String]';
}
function $2f377ffd6e81380f$var$isObject(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object Object]';
}
function $2f377ffd6e81380f$var$isRegExp(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object RegExp]';
}
function $2f377ffd6e81380f$var$isFunction(obj) {
    return $2f377ffd6e81380f$var$_class(obj) === '[object Function]';
}
function $2f377ffd6e81380f$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $2f377ffd6e81380f$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $2f377ffd6e81380f$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $2f377ffd6e81380f$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $2f377ffd6e81380f$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $2f377ffd6e81380f$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $2f377ffd6e81380f$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $2f377ffd6e81380f$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $2f377ffd6e81380f$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $2f377ffd6e81380f$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $2f377ffd6e81380f$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("5GUip"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($2f377ffd6e81380f$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($2f377ffd6e81380f$var$isObject(val)) {
            if ($2f377ffd6e81380f$var$isRegExp(val.validate)) compiled.validate = $2f377ffd6e81380f$var$createValidator(val.validate);
            else if ($2f377ffd6e81380f$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($2f377ffd6e81380f$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $2f377ffd6e81380f$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($2f377ffd6e81380f$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $2f377ffd6e81380f$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($2f377ffd6e81380f$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $2f377ffd6e81380f$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $2f377ffd6e81380f$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $2f377ffd6e81380f$var$createMatch(self, shift) {
    var match = new $2f377ffd6e81380f$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $2f377ffd6e81380f$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $2f377ffd6e81380f$var$LinkifyIt)) return new $2f377ffd6e81380f$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($2f377ffd6e81380f$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $2f377ffd6e81380f$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $2f377ffd6e81380f$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $2f377ffd6e81380f$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $2f377ffd6e81380f$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($2f377ffd6e81380f$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($2f377ffd6e81380f$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $2f377ffd6e81380f$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $2f377ffd6e81380f$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $2f377ffd6e81380f$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $2f377ffd6e81380f$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $2f377ffd6e81380f$var$LinkifyIt;

});
parcelRegister("5GUip", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("k7qPZ", function(module, exports) {
'use strict';
/** Highest positive signed 32-bit float value */ const $ea59477c15f361c2$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $ea59477c15f361c2$var$base = 36;
const $ea59477c15f361c2$var$tMin = 1;
const $ea59477c15f361c2$var$tMax = 26;
const $ea59477c15f361c2$var$skew = 38;
const $ea59477c15f361c2$var$damp = 700;
const $ea59477c15f361c2$var$initialBias = 72;
const $ea59477c15f361c2$var$initialN = 128; // 0x80
const $ea59477c15f361c2$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $ea59477c15f361c2$var$regexPunycode = /^xn--/;
const $ea59477c15f361c2$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $ea59477c15f361c2$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $ea59477c15f361c2$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $ea59477c15f361c2$var$baseMinusTMin = $ea59477c15f361c2$var$base - $ea59477c15f361c2$var$tMin;
const $ea59477c15f361c2$var$floor = Math.floor;
const $ea59477c15f361c2$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $ea59477c15f361c2$var$error(type) {
    throw new RangeError($ea59477c15f361c2$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $ea59477c15f361c2$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $ea59477c15f361c2$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($ea59477c15f361c2$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $ea59477c15f361c2$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $ea59477c15f361c2$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $ea59477c15f361c2$var$ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $ea59477c15f361c2$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $ea59477c15f361c2$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $ea59477c15f361c2$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $ea59477c15f361c2$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $ea59477c15f361c2$var$floor(delta / $ea59477c15f361c2$var$damp) : delta >> 1;
    delta += $ea59477c15f361c2$var$floor(delta / numPoints);
    for(; delta > $ea59477c15f361c2$var$baseMinusTMin * $ea59477c15f361c2$var$tMax >> 1; k += $ea59477c15f361c2$var$base)delta = $ea59477c15f361c2$var$floor(delta / $ea59477c15f361c2$var$baseMinusTMin);
    return $ea59477c15f361c2$var$floor(k + ($ea59477c15f361c2$var$baseMinusTMin + 1) * delta / (delta + $ea59477c15f361c2$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $ea59477c15f361c2$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $ea59477c15f361c2$var$initialN;
    let bias = $ea59477c15f361c2$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($ea59477c15f361c2$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $ea59477c15f361c2$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $ea59477c15f361c2$var$base;; k += $ea59477c15f361c2$var$base){
            if (index >= inputLength) $ea59477c15f361c2$var$error('invalid-input');
            const digit = $ea59477c15f361c2$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $ea59477c15f361c2$var$base) $ea59477c15f361c2$var$error('invalid-input');
            if (digit > $ea59477c15f361c2$var$floor(($ea59477c15f361c2$var$maxInt - i) / w)) $ea59477c15f361c2$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $ea59477c15f361c2$var$tMin : k >= bias + $ea59477c15f361c2$var$tMax ? $ea59477c15f361c2$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $ea59477c15f361c2$var$base - t;
            if (w > $ea59477c15f361c2$var$floor($ea59477c15f361c2$var$maxInt / baseMinusT)) $ea59477c15f361c2$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $ea59477c15f361c2$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($ea59477c15f361c2$var$floor(i / out) > $ea59477c15f361c2$var$maxInt - n) $ea59477c15f361c2$var$error('overflow');
        n += $ea59477c15f361c2$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $ea59477c15f361c2$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $ea59477c15f361c2$var$ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $ea59477c15f361c2$var$initialN;
    let delta = 0;
    let bias = $ea59477c15f361c2$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($ea59477c15f361c2$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($ea59477c15f361c2$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $ea59477c15f361c2$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $ea59477c15f361c2$var$floor(($ea59477c15f361c2$var$maxInt - delta) / handledCPCountPlusOne)) $ea59477c15f361c2$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $ea59477c15f361c2$var$maxInt) $ea59477c15f361c2$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $ea59477c15f361c2$var$base;; k += $ea59477c15f361c2$var$base){
                    const t = k <= bias ? $ea59477c15f361c2$var$tMin : k >= bias + $ea59477c15f361c2$var$tMax ? $ea59477c15f361c2$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $ea59477c15f361c2$var$base - t;
                    output.push($ea59477c15f361c2$var$stringFromCharCode($ea59477c15f361c2$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $ea59477c15f361c2$var$floor(qMinusT / baseMinusT);
                }
                output.push($ea59477c15f361c2$var$stringFromCharCode($ea59477c15f361c2$var$digitToBasic(q, 0)));
                bias = $ea59477c15f361c2$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $ea59477c15f361c2$var$toUnicode = function(input) {
    return $ea59477c15f361c2$var$mapDomain(input, function(string) {
        return $ea59477c15f361c2$var$regexPunycode.test(string) ? $ea59477c15f361c2$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $ea59477c15f361c2$var$toASCII = function(input) {
    return $ea59477c15f361c2$var$mapDomain(input, function(string) {
        return $ea59477c15f361c2$var$regexNonASCII.test(string) ? 'xn--' + $ea59477c15f361c2$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $ea59477c15f361c2$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $ea59477c15f361c2$var$ucs2decode,
        'encode': $ea59477c15f361c2$var$ucs2encode
    },
    'decode': $ea59477c15f361c2$var$decode,
    'encode': $ea59477c15f361c2$var$encode,
    'toASCII': $ea59477c15f361c2$var$toASCII,
    'toUnicode': $ea59477c15f361c2$var$toUnicode
};
module.exports = $ea59477c15f361c2$var$punycode;

});

parcelRegister("gcpUf", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("hbvGf", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("8Ubo6", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("4iMad", function(module, exports) {

$parcel$export(module.exports, "markdownItTable", () => $321e3433bbbbd43e$export$26a6b72a65821214);

var $ew5rH = parcelRequire("ew5rH");
var $321e3433bbbbd43e$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($ew5rH))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};

});
parcelRegister("ew5rH", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $a9184747dc810078$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $a9184747dc810078$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $a9184747dc810078$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$a9184747dc810078$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $a9184747dc810078$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $a9184747dc810078$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $a9184747dc810078$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("38KaN", function(module, exports) {

$parcel$export(module.exports, "MarkdownTransformer", () => $ca5b579471d13098$export$267fd7ead7cc4561);

var $kOFhM = parcelRequire("kOFhM");

var $ivSSX = parcelRequire("ivSSX");

var $4iMad = parcelRequire("4iMad");

var $6fRr3 = parcelRequire("6fRr3");

var $39HCX = parcelRequire("39HCX");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $ca5b579471d13098$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $ca5b579471d13098$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $ca5b579471d13098$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))('zero', {
    html: false
});
$ca5b579471d13098$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $ca5b579471d13098$export$267fd7ead7cc4561 {
    constructor(schema = (0, $kOFhM.defaultSchema), tokenizer = $ca5b579471d13098$var$md){
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $ca5b579471d13098$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($ca5b579471d13098$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $4iMad.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $39HCX.markdownItMedia));
        this.markdownParser = new (0, $6fRr3.MarkdownParser)(schema, tokenizer, $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, $ca5b579471d13098$var$mdToPmMapping));
    }
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
}

});
parcelRegister("6fRr3", function(module, exports) {

$parcel$export(module.exports, "MarkdownParser", () => $48dd97f13fd6d562$export$a64f782182dea128);
$parcel$export(module.exports, "MarkdownSerializer", () => $48dd97f13fd6d562$export$ae9f6f04acb6c60c);
$parcel$export(module.exports, "MarkdownSerializerState", () => $48dd97f13fd6d562$export$61055fa707e69319);

var $kCV8T = parcelRequire("kCV8T");

var $ivSSX = parcelRequire("ivSSX");
/**
Document schema for the data model used by CommonMark.
*/ const $48dd97f13fd6d562$export$4902baddc787debb = new (0, $kCV8T.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $48dd97f13fd6d562$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $kCV8T.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $48dd97f13fd6d562$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $kCV8T.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $48dd97f13fd6d562$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $kCV8T.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $48dd97f13fd6d562$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $48dd97f13fd6d562$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $48dd97f13fd6d562$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $48dd97f13fd6d562$var$noOp() {}
function $48dd97f13fd6d562$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = $48dd97f13fd6d562$var$noOp;
            else {
                handlers[type + "_open"] = $48dd97f13fd6d562$var$noOp;
                handlers[type + "_close"] = $48dd97f13fd6d562$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $48dd97f13fd6d562$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $48dd97f13fd6d562$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $48dd97f13fd6d562$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $48dd97f13fd6d562$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $48dd97f13fd6d562$export$7517583227ad0cb8 = new $48dd97f13fd6d562$export$a64f782182dea128($48dd97f13fd6d562$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($ivSSX)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $48dd97f13fd6d562$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $48dd97f13fd6d562$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $48dd97f13fd6d562$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $48dd97f13fd6d562$export$f996452ca6e9a0ae = new $48dd97f13fd6d562$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $48dd97f13fd6d562$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $48dd97f13fd6d562$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $48dd97f13fd6d562$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $48dd97f13fd6d562$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $48dd97f13fd6d562$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $48dd97f13fd6d562$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $48dd97f13fd6d562$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});

parcelRegister("39HCX", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", () => $288ff3bbed487814$export$c8dcbd316b71f8cf);
function $288ff3bbed487814$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match, j)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $288ff3bbed487814$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $288ff3bbed487814$var$createRule());
};

});


parcelRegister("kboGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9d26c02fbcba604$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");
const $d9d26c02fbcba604$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $d9d26c02fbcba604$var$citation = (state)=>{
    const tokens = [];
    // TODO: Remove the next two lines when rovo_chat_simplify_citation_logic enabled and cleaned up
    const citationIndexMap = {};
    let currentIndex = 1;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $d9d26c02fbcba604$var$CITATION_REGEX.test(childToken.content)) {
                /**
					 * Example content: `Hello [^1^][^1^].`
					 * `parts` will be ['Hello ', '1', '', '1', '.']
					 */ const parts = childToken.content.split($d9d26c02fbcba604$var$CITATION_REGEX);
                const newChildren = [];
                /**
					 * we want to remove consecutive citation
					 * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
					 * should be transformed to `Hello 1. How are you 1 2`
					 */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
							 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
							 * So it doesn't end up rendering empty space that will end up with multi empty spaces
							 * because previous valid citation already added 1 empty space
							 *
							 * Example: For `[^1^][^1^]`
							 * it will be split into parts: ['', '1', '', '1', ''],
							 * This code will skip any rendering for the last empty string (index=4)
							 * Because the empty string at index=2 already added 1 empty space from the code below
							 */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
								 * if the text part is not an empty string, we want to reset the last citation
								 * because the text part is a valid text, and not a space between citations
								 * so that we can render citation again, even if the next number is the same as the last number
								 *
								 * Example:
								 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
								 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        if (!(0, $VSDnB.fg)('rovo_chat_simplify_citation_logic')) {
                            citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                            if (!citationIndexMap[part]) {
                                citationIndexMap[part] = currentIndex;
                                currentIndex++;
                            }
                        }
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $d9d26c02fbcba604$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $d9d26c02fbcba604$var$citation);

});

parcelRegister("lKkRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e1f3f064434b868$export$2e2bcd8739ae039);
const $8e1f3f064434b868$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $8e1f3f064434b868$var$dataSculptor = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $8e1f3f064434b868$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                citationToken.attrs = [
                    [
                        'localId',
                        'data-sculptor'
                    ],
                    [
                        'text',
                        'data-sculptor'
                    ],
                    [
                        'color',
                        'blue'
                    ]
                ];
                const parts = childToken.content.split($8e1f3f064434b868$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else tokenChildren.push(citationToken);
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $8e1f3f064434b868$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $8e1f3f064434b868$var$dataSculptor);

});

parcelRegister("3p5rU", function(module, exports) {

$parcel$export(module.exports, "createLinkifyPlugin", () => $c1d7fcb3e69c8564$export$763ac077c9998026);

var $e2gHg = parcelRequire("e2gHg");

var $iZOJ9 = parcelRequire("iZOJ9");
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $c1d7fcb3e69c8564$var$arrayReplaceAt = (src, pos, newElements)=>{
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $c1d7fcb3e69c8564$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $c1d7fcb3e69c8564$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $c1d7fcb3e69c8564$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($e2gHg)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children;
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($c1d7fcb3e69c8564$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($c1d7fcb3e69c8564$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $iZOJ9.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $c1d7fcb3e69c8564$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
const $c1d7fcb3e69c8564$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', $c1d7fcb3e69c8564$export$8cd7d1ec2e6808da(params));

});

parcelRegister("htzpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ae4aa9255782dd$export$2e2bcd8739ae039);
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $b9ae4aa9255782dd$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = /(?<!`)!\[[^\]]*\]\([^\)]+\)(?!`)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $b9ae4aa9255782dd$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $b9ae4aa9255782dd$var$createRule());
};

});

parcelRegister("8ZEpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58bb75d4d8b9c5c$export$2e2bcd8739ae039);
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $b58bb75d4d8b9c5c$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $b58bb75d4d8b9c5c$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $b58bb75d4d8b9c5c$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $b58bb75d4d8b9c5c$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$b58bb75d4d8b9c5c$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $b58bb75d4d8b9c5c$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $b58bb75d4d8b9c5c$var$mentionLinks);

});

parcelRegister("muDJ0", function(module, exports) {

$parcel$export(module.exports, "createSmartLinksPlugin", () => $8d336fe6df406911$export$9625a798761643ac);

var $bq23d = parcelRequire("bq23d");
const $8d336fe6df406911$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $8d336fe6df406911$var$linkPatternEnd = '[^\\s\\]\\)]*';
// If we want to re-introduce canva support, please use the regex from this
// PR which was made redundant: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/135407/commits/0fcf626f035396cfcb87153a4d8d4721c844b07a#platform%2Fpackages%2Fai-mate%2Fconversation-assistant%2Fsrc%2Fcommon%2Futils%2Fcontent-transformer%2Fmd-tokenizer%2Fmd-plugin-smartlink%2Findex.ts
// Right now the support is dropped in favour of supporting what the Canva Agent needs.
// It's likely first-class Enhanced Smart links  (e.g `(my canva link "smartCard-embed")[http://some.canva.link]`
// will be how we support this in the future
const $8d336fe6df406911$var$linkRegex = {
    youtube: `${$8d336fe6df406911$var$linkPatternStart}youtube\\.com${$8d336fe6df406911$var$linkPatternEnd}`,
    youtubeShortUrl: `${$8d336fe6df406911$var$linkPatternStart}youtu\\.be${$8d336fe6df406911$var$linkPatternEnd}`,
    loomVideo: `${$8d336fe6df406911$var$linkPatternStart}loom\\.com\\/share\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    figmaFile: `${$8d336fe6df406911$var$linkPatternStart}figma\\.com\\/file\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$8d336fe6df406911$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$8d336fe6df406911$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    googleDoc: `${$8d336fe6df406911$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/edit${$8d336fe6df406911$var$linkPatternEnd}`,
    googleForm: `${$8d336fe6df406911$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$8d336fe6df406911$var$linkPatternEnd}`,
    microsoftForm: `${$8d336fe6df406911$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$8d336fe6df406911$var$linkPatternEnd}`,
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$8d336fe6df406911$var$linkPatternEnd}`
};
const $8d336fe6df406911$var$supportedEmbedProviders = Object.values($8d336fe6df406911$var$linkRegex).join('|');
const $8d336fe6df406911$var$embedRegex = new RegExp($8d336fe6df406911$var$supportedEmbedProviders, 'g');
const $8d336fe6df406911$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$8d336fe6df406911$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$8d336fe6df406911$var$linkPatternEnd}`
];
const $8d336fe6df406911$var$createSmartLinks = ({ regexStorage: regexStorage })=>(state)=>{
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        for (const token of state.tokens){
            let processedTokenChildren = [];
            embedMatches = [
                ...embedMatches,
                ...new Set(token.content?.trim().match($8d336fe6df406911$var$embedRegex))
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $bq23d.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        if (token.level <= 1 && $8d336fe6df406911$var$embedInlineRegex.some((r)=>url.match(r))) {
                            outputToken.children = processedTokenChildren;
                            tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                            processedTokenChildren = [];
                            let embedToken = new state.Token('embedCard', '', 0);
                            embedToken.content = '';
                            embedToken.block = true;
                            embedToken.attrSet('url', url);
                            embedToken.attrSet('layout', 'center');
                            tokensToAppend.push(embedToken);
                            tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                            outputToken = new state.Token('inline', '', 0);
                            tokensToAppend.push(outputToken);
                            return;
                        }
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', url);
                        processedTokenChildren.push(cardToken);
                        return;
                    }
                    processedTokenChildren.push(childToken);
                });
            }
            outputToken.children = processedTokenChildren;
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        if (embedMatches?.length) [
            ...new Set(embedMatches)
        ].forEach((match)=>{
            let embedToken = new state.Token('embedCard', '', 0);
            embedToken.content = '';
            embedToken.block = true;
            embedToken.attrSet('url', match);
            embedToken.attrSet('layout', 'center');
            embedTokens.push(embedToken);
        });
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $8d336fe6df406911$export$9625a798761643ac = (params)=>(md)=>md.core.ruler.push('inlineCard', $8d336fe6df406911$var$createSmartLinks(params));

});
parcelRegister("bq23d", function(module, exports) {

$parcel$export(module.exports, "isSupportedByLinkingPlatform", () => $e8d3bfaeca12d687$export$4b1056d02426889c);
$parcel$export(module.exports, "hydrateLinkingPlatformCache", () => $e8d3bfaeca12d687$export$d08c351b3b4e4934);

var $8QpSo = parcelRequire("8QpSo");

const $e8d3bfaeca12d687$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $e8d3bfaeca12d687$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    const regexPattern = new RegExp(cachedProviderRegex, 'g');
    return regexPattern.test(url);
};
const $e8d3bfaeca12d687$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $b1a9f1323a849c20$export$56bec2f197c16818))) return JSON.parse(`${regexStorage.getItem((0, $b1a9f1323a849c20$export$56bec2f197c16818))}`);
    return '';
};
const $e8d3bfaeca12d687$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $b1a9f1323a849c20$export$56bec2f197c16818), JSON.stringify(providerRegex));
};
const $e8d3bfaeca12d687$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerRegex = await $e8d3bfaeca12d687$export$ab8eaff0f2d596bd(baseUrl);
    $e8d3bfaeca12d687$export$5af966b3aa3b1d83(regexStorage, providerRegex);
};
const $e8d3bfaeca12d687$export$b7ac97ae80c7eb5a = (data)=>{
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns.map((pattern)=>pattern.source);
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $e8d3bfaeca12d687$export$ab8eaff0f2d596bd = (0, $8QpSo.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $b1a9f1323a849c20$export$57ad190cdc563df3), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return !data ? '' : $e8d3bfaeca12d687$export$b7ac97ae80c7eb5a(data);
    } catch (error) {
        return '';
    }
});

});
const $b1a9f1323a849c20$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $b1a9f1323a849c20$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';



parcelRegister("7zJFX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d2c4e4990535216$export$2e2bcd8739ae039);
const $2d2c4e4990535216$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $2d2c4e4990535216$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $2d2c4e4990535216$var$tableBreakTags);

});

parcelRegister("btItw", function(module, exports) {

$parcel$export(module.exports, "pmToMd", () => $360bd652c179d65a$export$cd54a56af01ba875);
$parcel$export(module.exports, "mdToPmSchema", () => $360bd652c179d65a$export$eb83d753215c78a2);
const $360bd652c179d65a$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $360bd652c179d65a$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('order') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};

});

parcelRegister("4bKco", function(module, exports) {

$parcel$export(module.exports, "filterSchemaMapping", () => $ba60debb72d7c40c$export$155749302793c60c);
$parcel$export(module.exports, "enableSchemaPlugins", () => $ba60debb72d7c40c$export$a1cf9d9b96e16789);

var $btItw = parcelRequire("btItw");
const $ba60debb72d7c40c$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $ba60debb72d7c40c$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $btItw.pmToMd){
        const key = k;
        for(const i in (0, $btItw.pmToMd)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $btItw.pmToMd)[key][idx]);
        }
    }
};

});



parcelRegister("3sxUu", function(module, exports) {

$parcel$export(module.exports, "GeneratingAnimation", () => $7000506399c53b5a$export$483f53d5a0354a30);

var $5uXOq = parcelRequire("5uXOq");
const $7000506399c53b5a$export$483f53d5a0354a30 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("hFECI", function(module, exports) {

$parcel$export(module.exports, "default", () => $12e3af689bf1eea0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12e3af689bf1eea0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    generating: {
        "id": "canned-comments.ui.ai-comments.ai-generated-comment.generating",
        "defaultMessage": "Generating"
    },
    insert: {
        "id": "canned-comments.ui.ai-comments.ai-generated-comment.insert",
        "defaultMessage": "Insert"
    },
    discard: {
        "id": "canned-comments.ui.ai-comments.ai-generated-comment.discard",
        "defaultMessage": "Discard"
    },
    cancel: {
        "id": "canned-comments.ui.ai-comments.ai-generated-comment.cancel",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("jApB6", function(module, exports) {

$parcel$export(module.exports, "LazyIssueEditor", () => $f1841af0eea56d42$export$43043c19621f0386);

var $5uXOq = parcelRequire("5uXOq");

var $kMSay = parcelRequire("kMSay");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $FV5rw = parcelRequire("FV5rw");

var $7XYc4 = parcelRequire("7XYc4");
var $e5wyW = parcelRequire("e5wyW");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $37FBE = parcelRequire("37FBE");

var $blotC = parcelRequire("blotC");

var $93Yeu = parcelRequire("93Yeu");

var $7wNl6 = parcelRequire("7wNl6");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $koVbs = parcelRequire("koVbs");

var $kLoIs = parcelRequire("kLoIs");

var $14nYi = parcelRequire("14nYi");

var $9rBFM = parcelRequire("9rBFM");

var $6xTZy = parcelRequire("6xTZy");

var $6ptvT = parcelRequire("6ptvT");
const $f1841af0eea56d42$var$entryPointParams = {};
// This hook is only required for feature gating purposes as we can't condtionally render hooks
const $f1841af0eea56d42$var$useIssueLinkSuggestionsTemp = ()=>{
    return [];
};
const $f1841af0eea56d42$var$useIssueLinkSuggestions = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('issue-link-suggestions-in-comments'), (0, $6ptvT.useIssueLinkSuggestions), $f1841af0eea56d42$var$useIssueLinkSuggestionsTemp);
const $f1841af0eea56d42$var$IssueEditor = (props)=>{
    const [editorMentionsAPI, setEditorMentionsAPI] = (0, $5uXOq.useState)(undefined);
    const issueLinkSuggestions = $f1841af0eea56d42$var$useIssueLinkSuggestions({
        existingIssueLinks: props.issueLinks
    });
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const [{ value: issueType }] = (0, $7wNl6.useIssueTypeField)({
        issueKey: issueKey
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isIssueOfIncidentPractice = (0, $kLoIs.useIsIssueOfIncidentsPractice)();
    const isAgentOrProjectAdmin = (0, $14nYi.useIsAgentOrProjectAdmin)();
    const isPromptLinkedIssuesExperimentEligible = (0, $5uXOq.useMemo)(()=>{
        return (projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT)) && (0, $4R6GH.fg)('issue-link-suggestions-in-comments');
    }, [
        projectType
    ]);
    const isMentionExperimentEligible = (0, $5uXOq.useMemo)(()=>{
        return projectType === (0, $2vSU6.SOFTWARE_PROJECT) && issueType?.name !== formatMessage((0, $9rBFM.messages).bugIssueTypeName);
    }, [
        projectType,
        issueType,
        formatMessage
    ]);
    // Draft Reply Pill is only for JSM product
    const isDraftReplyExperimentEligible = (0, $5uXOq.useMemo)(()=>{
        return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && isAiOptInEnabled && !isIssueOfIncidentPractice && (!(0, $4R6GH.fg)('draft_reply_agent_check') || isAgentOrProjectAdmin);
    }, [
        projectType,
        isAiOptInEnabled,
        isIssueOfIncidentPractice,
        isAgentOrProjectAdmin
    ]);
    const contentComponents = (0, $5uXOq.useMemo)(()=>{
        if (isPromptLinkedIssuesExperimentEligible && issueLinkSuggestions.length > 0 && (0, $6s1PB.expVal)('issue-link-suggestions-in-comments-exp', 'isPromptLinkedIssuesEnabled', false)) return {
            before: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            // TODO: Render component from HL-2784
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        };
        // Placing two separate if statements since we draft reply and mentions mutually exclusive
        if (isDraftReplyExperimentEligible && (0, $6s1PB.expVal)('draft_reply_pre-pill_quality_improve_before_ga', 'ExperimentVersion', 'Control') !== 'Control') return {
            before: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $blotC.DraftReplyPillContainer), null)
        };
        if (isMentionExperimentEligible && (0, $6s1PB.expVal)('recommend_user_mentions_in_comments', 'isMentionsPanelVisible', false)) return {
            before: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $37FBE.MentionsContainer), {
                api: editorMentionsAPI
            })
        };
    }, [
        editorMentionsAPI,
        isDraftReplyExperimentEligible,
        isMentionExperimentEligible,
        isPromptLinkedIssuesExperimentEligible,
        issueLinkSuggestions.length
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>{
        const shouldPassPromptLinkedIssuesComponent = isMentionExperimentEligible && (0, $6s1PB.expVal)('issue-link-suggestions-in-comments-exp', 'isPromptLinkedIssuesEnabled', false);
        const shouldPassMentionComponent = isMentionExperimentEligible && (0, $6s1PB.expVal)('recommend_user_mentions_in_comments', 'isMentionsPanelVisible', false);
        const shouldPassDraftReplyComponent = isDraftReplyExperimentEligible && (0, $6s1PB.expVal)('draft_reply_pre-pill_quality_improve_before_ga', 'ExperimentVersion', 'Control') !== 'Control';
        return {
            ...props,
            ...props.isAddComment && (shouldPassPromptLinkedIssuesComponent || shouldPassMentionComponent || shouldPassDraftReplyComponent) && {
                contentComponents: contentComponents
            },
            ...props.isAddComment && shouldPassMentionComponent && {
                editorMentionsAPI: editorMentionsAPI,
                setEditorMentionsAPI: setEditorMentionsAPI
            }
        };
    }, [
        props,
        isDraftReplyExperimentEligible,
        contentComponents,
        editorMentionsAPI,
        setEditorMentionsAPI,
        isMentionExperimentEligible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1841af0eea56d42$var$IssueEditorInternal, {
        runtimeProps: runtimeProps
    });
};
const $f1841af0eea56d42$var$IssueEditorWithLoomEmbedder = (props)=>{
    const { editorApiRef: editorApiRef } = (0, $FV5rw.useLoomVideoEditorInserter)({
        entryPointLocation: 'jsmIssueView_customerReply_crossflow'
    });
    const [editorMentionsAPI, setEditorMentionsAPI] = (0, $5uXOq.useState)(undefined);
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const [{ value: issueType }] = (0, $7wNl6.useIssueTypeField)({
        issueKey: issueKey
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isIssueOfIncidentPractice = (0, $kLoIs.useIsIssueOfIncidentsPractice)();
    const isAgentOrProjectAdmin = (0, $14nYi.useIsAgentOrProjectAdmin)();
    const isMentionExperimentEligible = (0, $5uXOq.useMemo)(()=>{
        return projectType === (0, $2vSU6.SOFTWARE_PROJECT) && issueType?.name !== formatMessage((0, $9rBFM.messages).bugIssueTypeName);
    }, [
        projectType,
        issueType,
        formatMessage
    ]);
    // Draft reply pill is only for JSM product
    const isDraftReplyExperimentEligible = (0, $5uXOq.useMemo)(()=>{
        return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && isAiOptInEnabled && !isIssueOfIncidentPractice && (!(0, $4R6GH.fg)('draft_reply_agent_check') || isAgentOrProjectAdmin);
    }, [
        projectType,
        isAiOptInEnabled,
        isIssueOfIncidentPractice,
        isAgentOrProjectAdmin
    ]);
    const contentComponents = (0, $5uXOq.useMemo)(()=>{
        // Placing two separate if statements since we draft reply and mentions mutually exclusive
        if (isDraftReplyExperimentEligible && (0, $6s1PB.expVal)('draft_reply_pre-pill_quality_improve_before_ga', 'ExperimentVersion', 'Control') !== 'Control') return {
            before: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $blotC.DraftReplyPillContainer), null)
        };
        if (isMentionExperimentEligible && (0, $6s1PB.expVal)('recommend_user_mentions_in_comments', 'isMentionsPanelVisible', false)) return {
            before: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $37FBE.MentionsContainer), {
                api: editorMentionsAPI
            })
        };
    }, [
        editorMentionsAPI,
        isDraftReplyExperimentEligible,
        isMentionExperimentEligible
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>{
        const shouldPassMentionComponent = isMentionExperimentEligible && (0, $6s1PB.expVal)('recommend_user_mentions_in_comments', 'isMentionsPanelVisible', false);
        const shouldPassDraftReplyComponent = isDraftReplyExperimentEligible && (0, $6s1PB.expVal)('draft_reply_pre-pill_quality_improve_before_ga', 'ExperimentVersion', 'Control') !== 'Control';
        return {
            ...props,
            editorApiRef: editorApiRef,
            ...props.isAddComment && (shouldPassMentionComponent || shouldPassDraftReplyComponent) && {
                contentComponents: contentComponents
            },
            ...props.isAddComment && shouldPassMentionComponent && {
                editorMentionsAPI: editorMentionsAPI,
                setEditorMentionsAPI: setEditorMentionsAPI
            }
        };
    }, [
        editorApiRef,
        props,
        contentComponents,
        editorMentionsAPI,
        setEditorMentionsAPI,
        isMentionExperimentEligible,
        isDraftReplyExperimentEligible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f1841af0eea56d42$var$IssueEditorInternal, {
        runtimeProps: runtimeProps
    });
};
const $f1841af0eea56d42$var$IssueEditorInternal = ({ runtimeProps: runtimeProps })=>{
    const pressTracing = (0, $kMSay.default)('issue-editor-load');
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $6xTZy.issueEditorEntrypoint), $f1841af0eea56d42$var$entryPointParams);
    // Tracking the editor loading should start at the point of user interaction, as should loading the entrypoint.
    // Everything in this useEffect should actually be moved out of this component and closer to whatever
    // user interaction triggers the editor to appear. (e.g., pressing 'm' to start a new issue comment)
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        (0, $4R6GH.fg)('jiv-20205-more-ufo-tracing') && pressTracing();
        entryPointActions.load();
    }, [
        pressTracing,
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "lazyIssueEditor",
        packageName: "issueViewCommon",
        errorFallback: "unmount",
        teamName: "team-bento",
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore -  error TS2322: Type are incompatible
        runtimeProps: runtimeProps
    });
};
const $f1841af0eea56d42$export$43043c19621f0386 = (0, $7XYc4.componentWithCondition)(()=>{
    const [experimentConfigJSM] = (0, $6s1PB.UNSAFE_noExposureExp)('loom_jsm_agent_response_touchpoint');
    return (0, $4R6GH.fg)('loom_jsm_experiment_controller') && experimentConfigJSM.get('cohort', 'not-enrolled') === 'variation';
}, $f1841af0eea56d42$var$IssueEditorWithLoomEmbedder, $f1841af0eea56d42$var$IssueEditor);

});
parcelRegister("FV5rw", function(module, exports) {

$parcel$export(module.exports, "useLoomVideoEditorInserter", () => $b69a99758113dafd$export$d2627567e5854c29);

var $5uXOq = parcelRequire("5uXOq");

var $fdGwF = parcelRequire("fdGwF");

var $9PU8D = parcelRequire("9PU8D");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $b69a99758113dafd$export$d2627567e5854c29 = ({ entryPointLocation: entryPointLocation })=>{
    const editorApiRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // when cross flow succeeds, open the recorder
    (0, $fdGwF.useLoomRecorderTriggerListener)((0, $9PU8D.LoomRecorderTriggerEvent).CROSS_FLOW_SUCCESS_FROM_JSM, {
        entryPointLocation: entryPointLocation,
        // intentionally not localized because Loom RecordSDK does not support i18n
        insertButtonText: 'Add video',
        onInsert: (sharedUrl)=>{
            const loomRefMetadata = {
                hasEditorApiRefBeenSet: editorApiRef.current != null,
                loomPluginSuccessfullyAdded: editorApiRef.current?.loom != null,
                loomInsertDefined: editorApiRef.current?.loom?.actions?.insertLoom != null
            };
            if (editorApiRef.current?.loom?.actions?.insertLoom) {
                const isSuccess = editorApiRef.current?.loom?.actions?.insertLoom({
                    sharedUrl: sharedUrl,
                    title: ''
                }, 'end');
                if (isSuccess) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomVideoIntoEditor inserted');
                else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraLoomUtils.insertLoomVideoIntoEditor fail', {
                    ...loomRefMetadata,
                    loomInsertAttempted: true
                });
            } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraLoomUtils.insertLoomVideoIntoEditor fail', {
                ...loomRefMetadata,
                loomInsertAttempted: false
            });
        }
    });
    return {
        editorApiRef: editorApiRef
    };
};

});
parcelRegister("fdGwF", function(module, exports) {

$parcel$export(module.exports, "useLoomRecorderTrigger", () => $ff5a2fc8dfa67bd9$export$3e559e51d1df0aaa);
$parcel$export(module.exports, "useLoomRecorderTriggerListener", () => $ff5a2fc8dfa67bd9$export$6121ceb7d7a8574b);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $fyQN8 = parcelRequire("fyQN8");
const $ff5a2fc8dfa67bd9$var$initialState = {
    triggers: new Set()
};
const $ff5a2fc8dfa67bd9$var$actions = {
    triggerLoomRecorder: (event)=>({ getState: getState, setState: setState })=>{
            const { triggers: triggers } = getState();
            triggers.add(event);
            setState({
                triggers: triggers
            });
        },
    markTriggered: (event)=>({ getState: getState, setState: setState })=>{
            const { triggers: triggers } = getState();
            triggers.delete(event);
            setState({
                triggers: triggers
            });
        }
};
const $ff5a2fc8dfa67bd9$var$store = (0, $iXqE5.createStore)({
    name: 'loom-utils.loom-recorder-trigger',
    initialState: $ff5a2fc8dfa67bd9$var$initialState,
    actions: $ff5a2fc8dfa67bd9$var$actions
});
const $ff5a2fc8dfa67bd9$var$useLoomRecorderTriggerStore = (0, $3sQ5x.createHook)($ff5a2fc8dfa67bd9$var$store);
const $ff5a2fc8dfa67bd9$export$3e559e51d1df0aaa = ()=>{
    const [, { triggerLoomRecorder: triggerLoomRecorder }] = $ff5a2fc8dfa67bd9$var$useLoomRecorderTriggerStore();
    return triggerLoomRecorder;
};
const $ff5a2fc8dfa67bd9$export$6121ceb7d7a8574b = (event, entrypointProps)=>{
    const [{ triggers: triggers }, { markTriggered: markTriggered }] = $ff5a2fc8dfa67bd9$var$useLoomRecorderTriggerStore();
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $fyQN8.useJiraLoomRecorderEntryPoint)({
        ...entrypointProps,
        skipInitialisation: entrypointProps.skipInitialisation || !triggers.has(event)
    });
    (0, $5uXOq.useEffect)(()=>{
        if (// we "open" the recorder even if the initialisation has failed, so that the user is notified of it via error flags
        (recorderState === 'ready' || recorderState === 'initialisation-failed') && openLoomRecorder !== null && triggers.has(event)) {
            openLoomRecorder();
            markTriggered(event);
        }
    }, [
        event,
        markTriggered,
        openLoomRecorder,
        recorderState,
        triggers
    ]);
};

});
parcelRegister("fyQN8", function(module, exports) {

$parcel$export(module.exports, "useJiraLoomRecorderEntryPoint", () => $a858ac987e29a9d4$export$c1f08abbdaae3af1);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $gBfrj = parcelRequire("gBfrj");

var $eMXvl = parcelRequire("eMXvl");

var $apCzy = parcelRequire("apCzy");

var $5BHhW = parcelRequire("5BHhW");

var $4BRXm = parcelRequire("4BRXm");

var $1ElzW = parcelRequire("1ElzW");
function $a858ac987e29a9d4$var$reloadPage() {
    if (typeof window !== 'undefined') window.location.reload();
}
const $a858ac987e29a9d4$export$c1f08abbdaae3af1 = ({ entryPointLocation: entryPointLocation, onInsert: onInsert, insertButtonText: insertButtonText, renderOnInsertFallbackWhen: renderOnInsertFallbackWhen, skipInitialisation: skipInitialisation })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $5BHhW.useLoomTouchpointVariant)();
    const productName = (0, $eMXvl.useJiraLoomSDKProductName)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { hideBlanket: hideBlanket }] = (0, $apCzy.useLoomRecorderLoadingBlanket)();
    const { loomInitError: loomInitError, openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $gBfrj.useLoomRecorderEntryPoint)({
        environment: environment,
        cloudId: cloudId,
        productName: productName ?? 'UNKNOWN',
        skipInitialisation: skipInitialisation || loomTouchpointVariant !== (0, $4BRXm.LoomTouchpointVariant).COUSE,
        entryPointLocation: entryPointLocation,
        onInsert: (loomVideoUrl, video)=>{
            onInsert(loomVideoUrl, video);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomVideoLink inserted');
        },
        insertButtonText: insertButtonText,
        renderOnInsertFallbackWhen: renderOnInsertFallbackWhen,
        eventHandler: {
            // DONT USE OUR PATTERN, if you want, reach to us(Growth: Crossflow)
            // Loom has its own analytics event records, so due to the project schedule, we adopted the simplest method
            // and made a temporary version first. We will do the refactor after Loom's analytics are ready
            // (or if we find out that there is no intention on their end to do the integration any time soon)
            onStart: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'loomRecordingStart'),
            onRecordingStarted: ()=>(0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording started'),
            onCancel: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'loomRecordingCancel'),
            onComplete: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'loomRecordingComplete'),
            onRecordingComplete: ()=>(0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording completed'),
            onUploadComplete: ()=>(0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording uploaded'),
            onInsertClicked: (isInsertFallbackRendered)=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insertVideoLink', {
                    isInsertFallbackRendered: isInsertFallbackRendered
                })
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        if (loomInitError) hideBlanket();
    }, [
        loomInitError,
        hideBlanket
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // when cross-flowing, we need to hide the loading blanket at this point.
        // No harm hiding it when it's already hidden in other cases, though.
        if (recorderState === 'pre-recording') hideBlanket();
    }, [
        hideBlanket,
        recorderState
    ]);
    const fireMergeAccountsClickAnalytic = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent ?? createAnalyticsEvent({}), 'button clicked', 'loomRecorderErrorFlagMergeAccountsAction');
    }, [
        createAnalyticsEvent
    ]);
    const wrappedOpenLoomRecorder = (0, $5uXOq.useCallback)(()=>{
        if (loomInitError) {
            switch(loomInitError.type){
                case 'unsupported-browser':
                    showFlag({
                        id: 'loomInitErrorUnsupportedBrowser',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleInitFailed,
                        description: formatMessage((0, $1ElzW.default).errorInitFailedBrowserUnsupported),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-unsupported-browser',
                        messageType: 'transactional',
                        actions: [
                            {
                                content: (0, $1ElzW.default).errorActionBrowserUnsupported,
                                target: '_blank',
                                href: 'https://support.loom.com/hc/en-us/articles/360002228418-Can-I-use-Loom-with-Firefox-Safari-etc'
                            }
                        ]
                    });
                    break;
                case 'unsupported-third-party-cookie':
                    showFlag({
                        id: 'loomInitErrorCookie',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleInitFailed,
                        description: formatMessage((0, $1ElzW.default).errorInitFailedThirdPartyCookiesDisabled),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-cookie',
                        messageType: 'transactional'
                    });
                    break;
                case 'unsupported-media-streaming':
                    showFlag({
                        id: 'loomInitErrorUnsupportedMediaStreaming',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleInitFailed,
                        description: formatMessage((0, $1ElzW.default).errorInitFailedStreamingUnsupported),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-unsupported-media-streaming',
                        messageType: 'transactional'
                    });
                    break;
                case 'token-unsuccessful-unmerged-user':
                    showFlag({
                        id: 'loomInitErrorUnmergedUser',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleUnmergedAccount,
                        description: formatMessage((0, $1ElzW.default).errorUnmergedAccount),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-unmerged-user',
                        messageType: 'transactional',
                        actions: [
                            {
                                content: (0, $1ElzW.default).errorActionMergeAccounts,
                                target: '_blank',
                                href: environment === 'staging' ? 'https://stage.loom.com/merge-atlassian-profile' : 'https://www.loom.com/merge-atlassian-profile',
                                onClick: fireMergeAccountsClickAnalytic
                            }
                        ]
                    });
                    break;
                case 'loom-internal-error':
                default:
                    showFlag({
                        id: 'loomInitErrorInternal',
                        type: 'error',
                        title: (0, $1ElzW.default).errorTitleInitFailed,
                        description: formatMessage((0, $1ElzW.default).errorInitFailedInternal),
                        messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-init-error-internal',
                        messageType: 'transactional',
                        actions: [
                            {
                                content: (0, $1ElzW.default).errorActionRefresh,
                                onClick: $a858ac987e29a9d4$var$reloadPage
                            }
                        ]
                    });
            }
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomRecording refused', {
                reason: loomInitError.type
            });
            return;
        }
        const { isSuccess: isSuccess, failureReason: failureReason } = openLoomRecorder();
        if (!isSuccess) {
            hideBlanket();
            if (failureReason === 'already-recording') showFlag({
                id: 'loomAlreadyRecording',
                type: 'error',
                title: (0, $1ElzW.default).errorTitleRecordingAlreadyInProgress,
                description: formatMessage((0, $1ElzW.default).errorRecordingAlreadyInProgress),
                messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.show-flagloom-already-recording',
                messageType: 'transactional'
            });
            else if (failureReason === 'still-initialising') showFlag({
                id: 'loomStillInitialising',
                type: 'info',
                title: (0, $1ElzW.default).errorTitleSdkNotInitialized,
                description: formatMessage((0, $1ElzW.default).errorSdkNotInitialized),
                messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.info.loom-still-initialising',
                messageType: 'transactional'
            });
            else showFlag({
                id: 'loomUnknownError',
                type: 'error',
                title: (0, $1ElzW.default).errorTitleUnknown,
                description: formatMessage((0, $1ElzW.default).errorUnknown),
                messageId: 'loom-utils.controllers.use-jira-loom-recorder-entrypoint.show-flag.error.loom-unknown-error',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $1ElzW.default).errorActionRefresh,
                        onClick: $a858ac987e29a9d4$var$reloadPage
                    }
                ]
            });
        }
        if (isSuccess) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'loomSdkRecorder opened', {
            entryPointLocation: entryPointLocation
        });
    }, [
        openLoomRecorder,
        showFlag,
        formatMessage,
        hideBlanket,
        loomInitError,
        createAnalyticsEvent,
        fireMergeAccountsClickAnalytic,
        environment,
        entryPointLocation
    ]);
    return {
        openLoomRecorder: wrappedOpenLoomRecorder,
        recorderState: recorderState
    };
};

});
parcelRegister("gBfrj", function(module, exports) {

$parcel$export(module.exports, "useLoomRecorderEntryPoint", () => $7879d9ef07c4028a$export$c8d9dc913e9e33ec);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $bSOOm = parcelRequire("bSOOm");

var $lw9xs = parcelRequire("lw9xs");

var $8kCPZ = parcelRequire("8kCPZ");

var $ftgXH = parcelRequire("ftgXH");
const $7879d9ef07c4028a$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, environment: environment, cloudId: cloudId, productName: productName, onInsert: onInsert, insertButtonText: insertButtonText, renderOnInsertFallbackWhen: renderOnInsertFallbackWhen, skipInitialisation: skipInitialisation, eventHandler: eventHandler })=>{
    const singletonLoomSDKRef = (0, $5uXOq.useRef)();
    const [loomInitError, setLoomInitError] = (0, $5uXOq.useState)();
    const [recorderState, setRecorderState] = (0, $5uXOq.useState)('initialising');
    const [userSegmentationData, setUserSegmentationData] = (0, $5uXOq.useState)({});
    const updateOnInsertIfUnmountedRef = (0, $5uXOq.useRef)();
    const experienceTracker = (0, $5uXOq.useContext)((0, $bSOOm.ExperienceTrackerContext));
    (0, $5uXOq.useEffect)(()=>{
        async function initLoom() {
            const initResult = await (0, $ftgXH.initLoomSDK)({
                environment: environment,
                cloudId: cloudId,
                productName: productName,
                experienceTracker: experienceTracker,
                entryPointLocation: entryPointLocation
            });
            if (initResult.kind === 'success') {
                singletonLoomSDKRef.current = initResult.loomSDKInstance;
                // TODO - we need to set this to the current state of the singleton (maybe it's already recording), but currently no way to subscibe to changes in the global state
                setRecorderState('ready');
            } else {
                setLoomInitError(initResult.initError);
                setRecorderState('initialisation-failed');
            }
        }
        if (!skipInitialisation) {
            initLoom();
            (0, $VSDnB.fg)('loom_examples_in_sdk_killswitch') && (0, $8kCPZ.getUserSegmentationData)().then((resp)=>{
                setUserSegmentationData({
                    jobTitle: resp.title,
                    teamType: resp.teamType
                });
            });
        }
    // Assumption - the dependencies cannot change without a full page regresh
    }, [
        environment,
        cloudId,
        productName,
        experienceTracker,
        skipInitialisation,
        entryPointLocation
    ]);
    // eslint-disable-next-line arrow-body-style
    (0, $5uXOq.useEffect)(()=>{
        // this will run on unmount
        return function changeOnInsertBehaviorOnUnmount() {
            if (!singletonLoomSDKRef.current || !updateOnInsertIfUnmountedRef.current) return;
            if (renderOnInsertFallbackWhen === 'unmount') updateOnInsertIfUnmountedRef.current();
        };
    }, [
        renderOnInsertFallbackWhen
    ]);
    const openLoomRecorder = (0, $5uXOq.useCallback)(()=>{
        try {
            (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
            experienceTracker.start({
                id: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            // TODO - another instance can try to open the recorder while it's doing something else, we should disallow that by subscribing to the singleton state
            if (singletonLoomSDKRef.current === undefined) {
                (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                const failureReason = 'still-initialising';
                experienceTracker.abort({
                    name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                    reason: failureReason,
                    attributes: {
                        entryPointLocation: entryPointLocation
                    }
                });
                return {
                    isSuccess: false,
                    failureReason: failureReason
                };
            }
            if (singletonLoomSDKRef.current.status().state === 'active-recording') {
                (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                const failureReason = 'already-recording';
                experienceTracker.abort({
                    name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                    reason: failureReason,
                    attributes: {
                        entryPointLocation: entryPointLocation
                    }
                });
                return {
                    isSuccess: false,
                    failureReason: failureReason
                };
            }
            const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current;
            const sdkButton = configureButton();
            updateConfig({
                config: {
                    insertButtonText: insertButtonText,
                    entryPointName: entryPointLocation,
                    ...(0, $VSDnB.fg)('loom_examples_in_sdk_killswitch') && {
                        experimentalFeatures: {
                            teamType: userSegmentationData.teamType
                        }
                    }
                }
            });
            sdkButton.on('start', ()=>{
                eventHandler?.onStart?.();
            });
            sdkButton.on('recording-start', ()=>{
                eventHandler?.onRecordingStarted?.();
                setRecorderState('recording');
            });
            sdkButton.on('cancel', ()=>{
                eventHandler?.onCancel?.();
            });
            sdkButton.on('complete', ()=>{
                eventHandler?.onComplete?.();
            });
            sdkButton.on('recording-complete', (video)=>{
                eventHandler?.onRecordingComplete?.(video);
            });
            sdkButton.on('upload-complete', (video)=>{
                eventHandler?.onUploadComplete?.(video);
            });
            sdkButton.on('insert-click', (video)=>{
                onInsert(video.sharedUrl, video);
                eventHandler?.onInsertClicked?.(false);
                experienceTracker.succeed({
                    name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        inserted: true,
                        entryPointLocation: entryPointLocation
                    }
                });
            });
            updateOnInsertIfUnmountedRef.current = ()=>{
                updateConfig({
                    config: {
                        // TODO - format message?
                        insertButtonText: 'Open on Loom'
                    }
                });
                sdkButton.off('insert-click');
                sdkButton.on('insert-click', (video)=>{
                    if (typeof window !== 'undefined') {
                        window.open(video.sharedUrl, '_blank');
                        experienceTracker.succeed({
                            name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                            attributes: {
                                inserted: true,
                                insertFunctionWasReset: true,
                                entryPointLocation: entryPointLocation
                            }
                        });
                    }
                    eventHandler?.onInsertClicked?.(true);
                });
            };
            sdkButton.on('lifecycle-update', (lifecycleState)=>{
                if (lifecycleState === 'pre-recording') {
                    setRecorderState('pre-recording');
                    (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                } else if (lifecycleState === 'post-recording') {
                    if (typeof renderOnInsertFallbackWhen === 'function' && renderOnInsertFallbackWhen() && !!updateOnInsertIfUnmountedRef.current) updateOnInsertIfUnmountedRef.current();
                    setRecorderState('post-recording');
                } else if (lifecycleState === 'closed') {
                    setRecorderState('ready');
                    experienceTracker.succeed({
                        name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            closed: true,
                            entryPointLocation: entryPointLocation
                        }
                    });
                    updateOnInsertIfUnmountedRef.current = undefined;
                } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                    name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        cascaded: true,
                        entryPointLocation: entryPointLocation
                    }
                });
            });
            sdkButton.openPreRecordPanel();
            return {
                isSuccess: true
            };
        } catch (error) {
            (0, $lw9xs.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            experienceTracker.fail({
                name: (0, $lw9xs.RECORD_LOOM_ENTRY_POINT),
                error: error instanceof Error ? error : new Error('unknown error in openLoomRecorder'),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            return {
                isSuccess: false,
                failureReason: 'unexpected-error'
            };
        }
    }, [
        onInsert,
        entryPointLocation,
        insertButtonText,
        renderOnInsertFallbackWhen,
        experienceTracker,
        eventHandler,
        userSegmentationData.teamType
    ]);
    return loomInitError ? {
        recorderState: 'initialisation-failed',
        loomInitError: loomInitError,
        openLoomRecorder: null
    } : {
        openLoomRecorder: openLoomRecorder,
        loomInitError: null,
        recorderState: recorderState
    };
};

});
parcelRegister("lw9xs", function(module, exports) {

$parcel$export(module.exports, "OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC", () => $64e9d717812fd2f7$export$873f91e3be81ab94);
$parcel$export(module.exports, "INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC", () => $64e9d717812fd2f7$export$bf1068aa9f020d8f);
$parcel$export(module.exports, "RECORD_LOOM_ENTRY_POINT", () => $64e9d717812fd2f7$export$5e1aeeb6f31be57a);
$parcel$export(module.exports, "INITIALIZE_LOOM_ENTRY_POINT", () => $64e9d717812fd2f7$export$fdda1c9b501679e3);

var $dGrdR = parcelRequire("dGrdR");
const $64e9d717812fd2f7$export$873f91e3be81ab94 = (0, $dGrdR.metrics).interaction({
    key: 'open-loom-recorder-sdk'
});
const $64e9d717812fd2f7$export$bf1068aa9f020d8f = (0, $dGrdR.metrics).interaction({
    key: 'initialize-loom-recorder-sdk'
});
const $64e9d717812fd2f7$export$5e1aeeb6f31be57a = 'record-loom-entry-point';
const $64e9d717812fd2f7$export$fdda1c9b501679e3 = 'initialize-loom-entry-point';

});

parcelRegister("8kCPZ", function(module, exports) {

$parcel$export(module.exports, "getUserSegmentationData", () => $56959dc8d63b2133$export$f0a14a7cbbb7397e);
const $56959dc8d63b2133$var$LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY = 'loom-recorder.user-segmentation';
const $56959dc8d63b2133$var$handleFetchResponse = (response)=>{
    if (response.ok) return response.json();
    const error = new Error(`API responded with failure HTTP code: ${response.status}`);
    throw error;
};
const $56959dc8d63b2133$export$318c25600a19e2ee = async ()=>fetch('/gateway/api/me').then($56959dc8d63b2133$var$handleFetchResponse);
const $56959dc8d63b2133$export$f0a14a7cbbb7397e = async ()=>{
    // Try to read from local storage
    try {
        const cachedUserSegmentation = localStorage.getItem($56959dc8d63b2133$var$LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY);
        if (cachedUserSegmentation) return JSON.parse(cachedUserSegmentation);
    } catch (e) {
    // Ignore localStorage errors
    }
    try {
        const { extended_profile: extendedProfile } = await $56959dc8d63b2133$export$318c25600a19e2ee();
        const userSegmentationData = {
            title: extendedProfile.job_title,
            teamType: extendedProfile.team_type
        };
        // Save to local storage
        try {
            localStorage.setItem($56959dc8d63b2133$var$LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY, JSON.stringify(userSegmentationData));
        } catch (e) {
        // Ignore localStorage errors
        }
        return userSegmentationData;
    } catch (err) {
    // TODO add error analytics
    }
    return {};
};

});

parcelRegister("ftgXH", function(module, exports) {

$parcel$export(module.exports, "initLoomSDK", () => $a222f6be621da98e$export$a6ae7697c0f5af9d);
/* eslint-disable @repo/internal/import/no-unresolved */ 
var $lw9xs = parcelRequire("lw9xs");

var $3i33c = parcelRequire("3i33c");
const $a222f6be621da98e$export$703005ecc9b7c87e = {
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    UNSUPPORTED_MEDIA_STREAMING: 'unsupported-media-streaming',
    UNSUPPORTED_3RD_PARTY_COOKIE: 'unsupported-third-party-cookie',
    UNSUPPORTED_UNKNOWN: 'unsupported-unknown',
    TOKEN_UNSUCCESSFUL: 'token-unsuccessful',
    UNMERGED_USER: 'token-unsuccessful-unmerged-user',
    TOKEN_EMPTY: 'token-empty',
    NETWORK: 'network',
    LOOM_INTERNAL_ERROR: 'loom-internal-error',
    UNKNOWN: 'unknown'
};
class $a222f6be621da98e$var$LoomInitError extends Error {
    constructor(type, message){
        super(message);
        this.type = type;
    }
}
function $a222f6be621da98e$var$mapLoomUnsupportedTypeToSubType(unsupportedReason) {
    switch(unsupportedReason){
        case 'incompatible-browser':
            return $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_BROWSER;
        case 'third-party-cookies-disabled':
            return $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_3RD_PARTY_COOKIE;
        case 'no-media-streams-support':
            return $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_MEDIA_STREAMING;
        default:
            return $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_UNKNOWN;
    }
}
async function $a222f6be621da98e$var$fetchJsonFromUrl(url, method = 'GET', expectedStatuses = []) {
    try {
        const response = await fetch(url, {
            method: method,
            headers: {
                Accept: 'application/json'
            }
        });
        if (!response.ok && !expectedStatuses.includes(response.status)) throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.NETWORK, response.statusText);
        const data = await response.json();
        return data;
    } catch (error) {
        throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.NETWORK, error instanceof Error ? error.message : '');
    }
}
async function $a222f6be621da98e$var$getAuthToken() {
    const { token: token, message: message } = await $a222f6be621da98e$var$fetchJsonFromUrl('/gateway/api/loom-auth/api/internal/auth/sdk_token', 'POST', [
        404
    ]);
    if (message === 'Loom user needs merge') throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.UNMERGED_USER);
    if (message !== 'Success') {
        let userStatus;
        try {
            // we don't want a failure to make the identity check to mask the original issue
            const { status: status } = await $a222f6be621da98e$var$fetchJsonFromUrl('/gateway/api/loom-auth/api/internal/identity/user-status', 'GET');
            userStatus = status;
        } catch (error) {
            userStatus = 'unknown user status';
        }
        throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.TOKEN_UNSUCCESSFUL, `${message} , ${userStatus}`);
    }
    if (!token) throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.TOKEN_EMPTY);
    return token;
}


async function $a222f6be621da98e$var$_init({ cloudId: cloudId, environment: environment, productName: productName, experienceTracker: experienceTracker, entryPointLocation: entryPointLocation }) {
    let loomSDKInstance;
    try {
        (0, $lw9xs.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        experienceTracker.start({
            id: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
            name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        const { isSupported: isSupported } = await (parcelRequire("dt3ca"));
        const { supported: supported, error: error } = isSupported();
        if (!supported) throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$var$mapLoomUnsupportedTypeToSubType(error));
        const recorderToken = await $a222f6be621da98e$var$getAuthToken();
        const { createInstance: createInstance } = await (parcelRequire("i0rvQ"));
        loomSDKInstance = await createInstance((0, $3i33c.getLoomInstanceDataByEnvironment)({
            environment: environment,
            jws: recorderToken,
            siteId: cloudId,
            productName: productName,
            entryPointName: entryPointLocation
        }));
        if (!loomSDKInstance.status().success) throw new $a222f6be621da98e$var$LoomInitError($a222f6be621da98e$export$703005ecc9b7c87e.LOOM_INTERNAL_ERROR, 'Loom SDK timeout or another internal issue');
        experienceTracker.succeed({
            name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        (0, $lw9xs.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
    } catch (error) {
        (0, $lw9xs.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        if (error instanceof $a222f6be621da98e$var$LoomInitError) {
            if (error.type === $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_BROWSER || error.type === $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_MEDIA_STREAMING || error.type === $a222f6be621da98e$export$703005ecc9b7c87e.UNSUPPORTED_3RD_PARTY_COOKIE || error.type === $a222f6be621da98e$export$703005ecc9b7c87e.UNMERGED_USER) experienceTracker.succeed({
                name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            else experienceTracker.fail({
                name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
                error: new Error(error.type),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            return {
                kind: 'failure',
                initError: {
                    type: error.type,
                    message: error.message
                }
            };
        }
        experienceTracker.fail({
            name: (0, $lw9xs.INITIALIZE_LOOM_ENTRY_POINT),
            error: new Error($a222f6be621da98e$export$703005ecc9b7c87e.UNKNOWN),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (error instanceof Error) return {
            kind: 'failure',
            initError: {
                type: $a222f6be621da98e$export$703005ecc9b7c87e.UNKNOWN,
                message: error.message
            }
        };
        return {
            kind: 'failure',
            initError: {
                type: $a222f6be621da98e$export$703005ecc9b7c87e.UNKNOWN
            }
        };
    }
    return {
        kind: 'success',
        loomSDKInstance: loomSDKInstance
    };
}
// this will hold our singleton result instance
let $a222f6be621da98e$var$initSDKResultPromise;
function $a222f6be621da98e$export$a6ae7697c0f5af9d(params) {
    // Singleton
    if ($a222f6be621da98e$var$initSDKResultPromise === undefined) $a222f6be621da98e$var$initSDKResultPromise = $a222f6be621da98e$var$_init(params);
    return $a222f6be621da98e$var$initSDKResultPromise;
}
function $a222f6be621da98e$export$1702a3de4c96a056() {
    $a222f6be621da98e$var$initSDKResultPromise = undefined;
}

});
parcelRegister("3i33c", function(module, exports) {

$parcel$export(module.exports, "getLoomInstanceDataByEnvironment", () => $ce96bc6823246afd$export$c150e4a8d8a3ab35);
const $ce96bc6823246afd$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $ce96bc6823246afd$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, productName: productName, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: productName,
            entryPointName: entryPointName
        }
    };
    if (environment === 'dev') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $ce96bc6823246afd$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production'
    };
    if (environment === 'staging') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $ce96bc6823246afd$var$PUBLIC_APP_IDS.staging,
        environment: 'staging'
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $ce96bc6823246afd$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production'
    };
};

});

parcelRegister("dt3ca", function(module, exports) {

let $9ce076484d3c551a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ce076484d3c551a$var$load("mtd6g").then(()=>parcelRequire('mesIh'));

});

parcelRegister("i0rvQ", function(module, exports) {

let $d1bd918a846611d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d1bd918a846611d5$var$load("ffQaD"),
    $d1bd918a846611d5$var$load("kvRbA"),
    $d1bd918a846611d5$var$load("2MUEn")
]).then(()=>parcelRequire('bpTSI'));

});



parcelRegister("1ElzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9df5f82f05fb80$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $cc9df5f82f05fb80$var$messages = (0, $7VHMR.defineMessages)({
    errorTitleRecordingAlreadyInProgress: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-recording-already-in-progress",
        "defaultMessage": "Loom recorder unavailable"
    },
    errorRecordingAlreadyInProgress: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-recording-already-in-progress",
        "defaultMessage": "End the recording in progress before recording another Loom video."
    },
    errorTitleSdkNotInitialized: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-sdk-not-initialized",
        "defaultMessage": "The Loom recorder wasn\u2019t ready"
    },
    errorSdkNotInitialized: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-sdk-not-initialized",
        "defaultMessage": "Try to start recording again now."
    },
    errorTitleUnknown: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-unknown",
        "defaultMessage": "Failed to start recording"
    },
    errorUnknown: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-unknown",
        "defaultMessage": "Sorry, we couldn\u2019t start your recording. Please refresh the page and try again."
    },
    errorTitleInitFailed: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-init-failed",
        "defaultMessage": "Loom recorder unavailable"
    },
    errorInitFailedBrowserUnsupported: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-init-failed-browser-unsupported",
        "defaultMessage": "Switch to a different browser or turn off private browsing to continue recording."
    },
    errorInitFailedThirdPartyCookiesDisabled: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-init-failed-third-party-cookies-disabled",
        "defaultMessage": "Enable third party cookies in your browser to continue recording."
    },
    errorInitFailedStreamingUnsupported: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-init-failed-streaming-unsupported",
        "defaultMessage": "Your browser isn\u2019t supported - switch to a different browser to continue recording."
    },
    errorInitFailedInternal: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-init-failed-internal",
        "defaultMessage": "Refresh your browser to try again."
    },
    errorActionRefresh: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-action-refresh",
        "defaultMessage": "Refresh"
    },
    errorTitleUnmergedAccount: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-title-unmerged-account",
        "defaultMessage": "User not found"
    },
    errorUnmergedAccount: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-unmerged-account",
        "defaultMessage": "Merge your Atlassian and Loom profiles to access your account and available features."
    },
    errorActionMergeAccounts: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-action-merge-accounts",
        "defaultMessage": "Merge profiles"
    },
    errorActionBrowserUnsupported: {
        "id": "loom-utils.controllers.use-jira-loom-recorder-entrypoint.error-action-browser-unsupported",
        "defaultMessage": "See supported browsers"
    }
});
var $cc9df5f82f05fb80$export$2e2bcd8739ae039 = $cc9df5f82f05fb80$var$messages;

});



parcelRegister("9PU8D", function(module, exports) {

$parcel$export(module.exports, "LoomRecorderTriggerEvent", () => $e839c52b56629c0b$export$8222a78bff6d77fd);
const $e839c52b56629c0b$export$8222a78bff6d77fd = {
    CROSS_FLOW_SUCCESS: 'cross-flow-success',
    // Created a separate JSM event trigger to avoid any accidental triggering from other touchpoints
    CROSS_FLOW_SUCCESS_FROM_JSM: 'cross-flow-success-from-jsm'
};

});


parcelRegister("37FBE", function(module, exports) {

$parcel$export(module.exports, "MentionsContainer", () => $1c650be294ce48e7$export$3c563eedbddd3162);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bpC55 = parcelRequire("bpC55");

var $dZbEw = parcelRequire("dZbEw");

var $ks8FD = parcelRequire("ks8FD");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $42CjB = parcelRequire("42CjB");

var $ujWmd = parcelRequire("ujWmd");

var $koVbs = parcelRequire("koVbs");

var $9RlWW = parcelRequire("9RlWW");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $70qvj = parcelRequire("70qvj");

var $gIfHm = parcelRequire("gIfHm");
const $1c650be294ce48e7$export$3c563eedbddd3162 = ({ api: api })=>{
    const { setRef: setRef, setCanScrollDebounced: setCanScrollDebounced, shouldHideScrollLeftButton: shouldHideScrollLeftButton, shouldHideScrollRightButton: shouldHideScrollRightButton, scrollToNext: scrollToNext, scrollToPrevious: scrollToPrevious } = (0, $9RlWW.useScrollCarousel)();
    const initialMentionUsersData = (0, $70qvj.useDataForRecommendationsInEditor)();
    const [mentionUsersData, setMentionUsersData] = (0, $5uXOq.useState)([]);
    const hasViewedEventFired = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (initialMentionUsersData) setMentionUsersData(initialMentionUsersData);
    }, [
        initialMentionUsersData
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const hasFired = (0, $5uXOq.useRef)(false);
    const sendAnalyticsEvent = (0, $5uXOq.useCallback)((action)=>{
        if (action === 'viewed') (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'panel viewed', 'recommendedUserMentionInsideEditorPanel', {});
        else if (action === 'clicked' && !hasFired.current) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'recommendedUserMentionInsideEditorButton', {});
            hasFired.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasViewedEventFired.current) {
            sendAnalyticsEvent('viewed');
            hasViewedEventFired.current = true;
        }
    }, [
        sendAnalyticsEvent
    ]);
    const handleMentionClick = (0, $5uXOq.useCallback)((name, userId)=>{
        setMentionUsersData((prevUsers)=>prevUsers.filter((user)=>user.userId !== userId));
        sendAnalyticsEvent('clicked');
        api?.core.actions.execute(({ tr: tr })=>{
            const { schema: schema } = tr.doc.type;
            const mentionName = `@${name}`;
            const mentionNode = schema.nodes.mention.createChecked({
                text: mentionName,
                id: userId
            }, null, undefined); // Insert a space before the mention node to prevent the mention from being merged with the previous node
            tr.insertText(' ', tr.selection.from);
            return tr.insert(tr.selection.from, mentionNode);
        });
        api?.core.actions.focus();
    }, [
        api,
        sendAnalyticsEvent
    ]);
    return mentionUsersData && mentionUsersData.length > 0 ? /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $1c650be294ce48e7$var$boxStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: [
            $1c650be294ce48e7$var$hoverButtonStyle,
            $1c650be294ce48e7$var$leftButtonStyle,
            shouldHideScrollLeftButton && $1c650be294ce48e7$var$hiddenButtonStyle
        ]
    }, /*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ks8FD))), {
                ...iconProps,
                size: "small"
            }),
        isTooltipDisabled: true,
        label: "Previous",
        onClick: scrollToPrevious,
        tabIndex: -1
    })), /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: setRef,
        onScroll: setCanScrollDebounced,
        role: "group",
        "aria-label": "Mention",
        tabIndex: -1,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1bsb1osq _1e0c1txw _1bah1y6m _4cvr1h6o _1reo15zi _1fjgglyw _4pckglyw _1cicglyw"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $cgL5K.default), null, formatMessage((0, $gIfHm.default).mentionRecommendationText)), mentionUsersData.map((user)=>/*#__PURE__*/ $5uXOq.createElement((0, $5ILhZ.default), {
            key: user.userId,
            onClick: ()=>handleMentionClick(user.name, user.userId),
            xcss: $1c650be294ce48e7$var$buttonStyles,
            tabIndex: -1
        }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
            LEGACY_size: "small",
            label: "",
            size: "small"
        }), /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
            size: "xsmall",
            src: user.avatarUrl
        }), user.name))), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: [
            $1c650be294ce48e7$var$hoverButtonStyle,
            $1c650be294ce48e7$var$rightButtonStyle,
            shouldHideScrollRightButton && $1c650be294ce48e7$var$hiddenButtonStyle
        ]
    }, /*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
                ...iconProps,
                size: "small"
            }),
        isTooltipDisabled: true,
        label: "Next",
        onClick: scrollToNext,
        tabIndex: -1
    }))) : undefined;
};
const $1c650be294ce48e7$var$boxStyles = (0, $8CUq3.xcss)({
    padding: 'space.100',
    paddingLeft: 'space.150',
    backgroundColor: 'color.background.accent.gray.subtlest',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    position: 'relative',
    marginTop: 'space.200',
    marginLeft: 'space.negative.200',
    marginRight: 'space.negative.200',
    marginBottom: 'space.negative.200',
    borderRadius: 'border.radius.100'
});
const $1c650be294ce48e7$var$buttonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    height: '24px',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingLeft: 'space.050',
    paddingRight: 'space.050',
    borderRadius: 'border.radius.100',
    borderColor: 'color.border',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 'space.050',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $1c650be294ce48e7$var$commentsContainerStyle = null;
const $1c650be294ce48e7$var$hoverButtonStyle = (0, $8CUq3.xcss)({
    zIndex: 'layer',
    alignItems: 'center',
    position: 'absolute',
    backgroundColor: 'color.background.accent.gray.subtlest',
    opacity: 1,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer'
});
const $1c650be294ce48e7$var$rightButtonStyle = (0, $8CUq3.xcss)({
    right: 'space.0'
});
const $1c650be294ce48e7$var$leftButtonStyle = (0, $8CUq3.xcss)({
    left: 'space.0'
});
const $1c650be294ce48e7$var$hiddenButtonStyle = (0, $8CUq3.xcss)({
    display: 'none'
});

});
parcelRegister("70qvj", function(module, exports) {

$parcel$export(module.exports, "useDataForRecommendationsInEditor", () => $c5c838111ea8b4cb$export$9b8c24cd19239059);

var $k5Jjs = parcelRequire("k5Jjs");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2gCtH = parcelRequire("2gCtH");

var $5yJb9 = parcelRequire("5yJb9");

var $koeKL = parcelRequire("koeKL");

var $2YZCu = parcelRequire("2YZCu");

var $90yGq = parcelRequire("90yGq");
const $c5c838111ea8b4cb$export$25a759e49d5049db = 'editor-wrapper.mention-recommendations.data-for-recommendations-in-editor';
const $c5c838111ea8b4cb$var$mentionsDataQuery = (0, $k5Jjs.default);
const $c5c838111ea8b4cb$var$transformMentionableResponse = (response, loggedInUserAccountId)=>{
    const mentions = response.jira?.searchUserTeamMention?.edges.reduce((acc, edge)=>{
        const { user: user } = edge?.node || {};
        if (user && user.__typename === 'AtlassianAccountUser' && user.accountId !== loggedInUserAccountId) acc.push({
            name: user.name,
            userId: user.accountId,
            avatarUrl: user.picture || ''
        });
        return acc;
    }, []);
    return mentions || [];
};
const $c5c838111ea8b4cb$export$9b8c24cd19239059 = ()=>{
    const [mentionsUserData, setMentionsUserData] = (0, $5uXOq.useState)([]);
    const issueKey = (0, $2gCtH.useIssueKey)();
    const cloudId = (0, $koeKL.useCloudId)();
    const loggedInUserAccountId = (0, $90yGq.useAccountId)();
    const variables = (0, $5uXOq.useMemo)(()=>({
            query: '',
            issueKey: issueKey,
            organizationId: '',
            maxResults: 8,
            sessionId: '',
            cloudId: cloudId,
            siteId: cloudId
        }), [
        issueKey,
        cloudId
    ]);
    const environment = (0, $5uXOq.useMemo)(()=>(0, $5yJb9.default)(), []);
    (0, $5uXOq.useEffect)(()=>{
        const fetchMentionsUserData = async ()=>{
            try {
                const response = await (0, $8Uumt.fetchQuery)(environment, $c5c838111ea8b4cb$var$mentionsDataQuery, variables).toPromise();
                const transformedMentionableResponse = response ? $c5c838111ea8b4cb$var$transformMentionableResponse(response, loggedInUserAccountId) : [];
                setMentionsUserData(transformedMentionableResponse);
            } catch (error) {
                setMentionsUserData([]);
                (0, $2YZCu.default).safeErrorWithoutCustomerData($c5c838111ea8b4cb$export$25a759e49d5049db, `Error occurred while fetching mentions user data: ${error}`);
            }
        };
        fetchMentionsUserData();
    }, [
        environment,
        variables,
        loggedInUserAccountId
    ]);
    return mentionsUserData;
};

});
parcelRegister("k5Jjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d4e21c585fc8df5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9a92093530951b240bc66c77f11417f9>>
 * @relayHash 2b71fc746331359b106fb95c3e29a341
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f0ea23ecb96f1ebbf832480f95d0e3e529c379b376fcf52770efc277df3892b3
const $3d4e21c585fc8df5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "maxResults"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "organizationId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueKey",
            "variableName": "issueKey"
        },
        {
            "kind": "Variable",
            "name": "maxResults",
            "variableName": "maxResults"
        },
        {
            "kind": "Variable",
            "name": "organizationId",
            "variableName": "organizationId"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sessionId",
            "variableName": "sessionId"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "dataForRecommendationsInEditorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraMentionableConnection",
                            "kind": "LinkedField",
                            "name": "searchUserTeamMention",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraMentionableEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraMentionable",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.searchUserTeamMention.edges.node"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.searchUserTeamMention.edges"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "dataForRecommendationsInEditorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraMentionableConnection",
                            "kind": "LinkedField",
                            "name": "searchUserTeamMention",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraMentionableEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraMentionable",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f0ea23ecb96f1ebbf832480f95d0e3e529c379b376fcf52770efc277df3892b3",
            "metadata": {},
            "name": "dataForRecommendationsInEditorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3d4e21c585fc8df5$var$node.hash = "96de78460558597c7895447069471dce";
var $3d4e21c585fc8df5$export$2e2bcd8739ae039 = $3d4e21c585fc8df5$var$node;

});


parcelRegister("gIfHm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a4589156ce9bd23$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1a4589156ce9bd23$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    mentionRecommendationText: {
        "id": "editor-wrapper.mention-recommendations.mention-recommendation-text",
        "defaultMessage": "Add mentions:"
    }
});

});


parcelRegister("9rBFM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $410a2dba9d7738b8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $410a2dba9d7738b8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    bugIssueTypeName: {
        "id": "issue-view-common.component.loom-videos.bug-issue-type-name",
        "defaultMessage": "Bug"
    },
    taskIssueTypeName: {
        "id": "issue-view-common.component.loom-videos.task-issue-type-name",
        "defaultMessage": "Task"
    }
});

});

parcelRegister("6xTZy", function(module, exports) {

$parcel$export(module.exports, "issueEditorEntrypoint", () => $5ad999a859407254$export$6ac1466cb193127c);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5ad999a859407254$export$6ac1466cb193127c = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("94BkX")), {
        moduleId: "276f4d23"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("94BkX", function(module, exports) {

let $69b1732163ef3fd7$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $69b1732163ef3fd7$var$load("ffQaD"),
    $69b1732163ef3fd7$var$load("kvRbA"),
    $69b1732163ef3fd7$var$load("76n7a"),
    $69b1732163ef3fd7$var$load("l253H"),
    $69b1732163ef3fd7$var$load("jbmdw")
]).then(()=>parcelRequire('kp1J3'));

});


parcelRegister("6ptvT", function(module, exports) {

$parcel$export(module.exports, "useIssueLinkSuggestions", () => $c5b4da72b943f7ce$export$fba93ea79c127bfd);
$parcel$export(module.exports, "useIssueLinkSuggestionsActions", () => $c5b4da72b943f7ce$export$35171dbf1b4aa26a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4B7H2 = parcelRequire("4B7H2");
const $c5b4da72b943f7ce$var$Store = (0, $iXqE5.createStore)({
    name: 'issue-link-suggestions-store',
    initialState: {
        issueLinkSuggestions: new Set()
    },
    actions: $4B7H2.actions
});
const $c5b4da72b943f7ce$export$37f3d2e24d90fe55 = (state, props)=>{
    if (!props.existingIssueLinks?.linkedIssueKeys?.length) return [
        ...state.issueLinkSuggestions
    ];
    const linkedIssueKeys = new Set(props.existingIssueLinks.linkedIssueKeys);
    return [
        ...state.issueLinkSuggestions
    ].filter((item)=>!linkedIssueKeys.has(item));
};
const $c5b4da72b943f7ce$export$fba93ea79c127bfd = (0, $3sQ5x.createStateHook)($c5b4da72b943f7ce$var$Store, {
    selector: $c5b4da72b943f7ce$export$37f3d2e24d90fe55
});
const $c5b4da72b943f7ce$export$35171dbf1b4aa26a = (0, $3sQ5x.createActionsHook)($c5b4da72b943f7ce$var$Store);
const $c5b4da72b943f7ce$export$604a40751793d9f2 = (0, $3sQ5x.createHook)($c5b4da72b943f7ce$var$Store);

});
parcelRegister("4B7H2", function(module, exports) {

$parcel$export(module.exports, "actions", () => $13cf07c6dc2fc4af$export$e324594224ef24da);
const $13cf07c6dc2fc4af$var$addIssueLinkSuggestion = (issueKey)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.issueLinkSuggestions.has(issueKey)) return;
        setState({
            ...state,
            issueLinkSuggestions: new Set([
                ...state.issueLinkSuggestions,
                issueKey
            ])
        });
    };
const $13cf07c6dc2fc4af$export$e324594224ef24da = {
    addIssueLinkSuggestion: $13cf07c6dc2fc4af$var$addIssueLinkSuggestion
};

});



parcelRegister("dsRaM", function(module, exports) {

$parcel$export(module.exports, "useHandleQuickReply", () => $8df25ecf2aa07375$export$95af15d7ef833965);

var $5uXOq = parcelRequire("5uXOq");

var $bPWvi = parcelRequire("bPWvi");
var $50sdg = parcelRequire("50sdg");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3hGWp = parcelRequire("3hGWp");


var $4vTdq = parcelRequire("4vTdq");

var $8MH38 = parcelRequire("8MH38");
const $8df25ecf2aa07375$export$95af15d7ef833965 = (onChange)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage, locale: locale } = (0, $koVbs.default)();
    const [{ quickReply: quickReply }, setQueryParams] = (0, $3hGWp.useQueryParams)('quickReply');
    const hasInvalidQuickReply = !quickReply || !onChange || !(0, $8MH38.isQuickReply)(quickReply);
    const fireAnalytics = (0, $5uXOq.useCallback)((valid)=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $dda79eff4ec4e3a6$export$d3adeadf66f71217)} ${valid ? (0, $dda79eff4ec4e3a6$export$e53819cb799e64aa) : (0, $dda79eff4ec4e3a6$export$b1ac282fd3999acc)}`, {
            quickReply: quickReply,
            locale: locale
        });
    }, [
        createAnalyticsEvent,
        locale,
        quickReply
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasInvalidQuickReply) {
            /**
       * To ensure nothing is going wrong with localisation etc, we want to fire an event if we
       * *have* a query parameter value that is not in the current list, but we don't want analytics
       * noise from when the query parameter is empty etc
       */ if (quickReply) fireAnalytics(false);
            return;
        }
        fireAnalytics(true);
        setQueryParams({
            quickReply: undefined
        }, {
            updateType: 'replace'
        });
        onChange((0, $bPWvi.doc)((0, $50sdg.paragraph)(formatMessage((0, $4vTdq.default)[quickReply]))));
    }, [
        quickReply,
        onChange,
        setQueryParams,
        hasInvalidQuickReply,
        formatMessage,
        fireAnalytics
    ]);
    return {
        hasQuickReply: !hasInvalidQuickReply
    };
};

});
parcelRegister("3hGWp", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $doZTA.useRouter)();
    const queryParamsRef = (0, $5uXOq.useRef)({});
    const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
            accumulator[currentValue] = query[currentValue] || undefined;
            return accumulator;
        }, {});
        // update cache only when one of requested params actually changed
        // otherwise return cached value to avoid changing return object reference
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
        return queryParamsRef.current;
    }, [
        query,
        queryParamsToWatch
    ]);
    const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            ...newQueryParams
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const { updateType: updateType, ...stringifyOptions } = options ?? {};
        // @ts-expect-error - TS2559 - Type '{ sort?: false | ((a: string, b: string) => number) | undefined; }' has no properties in common with type 'StringifyOptions'.
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
        const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
        updateType === 'replace' ? replace(url) : push(url);
    }, [
        pathname,
        push,
        replace,
        query
    ]);
    return [
        parsedQueryParams,
        setQueryParams
    ];
};

});

const $dda79eff4ec4e3a6$export$d3adeadf66f71217 = 'jiraQuickReply';
const $dda79eff4ec4e3a6$export$e53819cb799e64aa = 'validQueryParam';
const $dda79eff4ec4e3a6$export$b1ac282fd3999acc = 'invalidQueryParam';

parcelRegister("4vTdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cb7721dc683f7b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var /**
 * Note: any key you add to this will add a similar requirement to add an attached emoji in `constants.tsx`,
 * as well as provide it as an available value in the 'quickReply' query parameter on any issue view route.
 *
 * This value will populate the comment box on any issue when the query param is
 */ $f7cb7721dc683f7b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    looksGood: {
        "id": "quick-reply.common.looks-good",
        "defaultMessage": "Looks good!"
    },
    onTrack: {
        "id": "quick-reply.common.on-track",
        "defaultMessage": "This is on track"
    },
    canHelp: {
        "id": "quick-reply.common.can-help",
        "defaultMessage": "I can help with this one"
    }
});

});

parcelRegister("8MH38", function(module, exports) {

$parcel$export(module.exports, "isQuickReply", () => $fc63357627fcd321$export$46c9528be2a6ee69);

var $4vTdq = parcelRequire("4vTdq");
const $fc63357627fcd321$export$46c9528be2a6ee69 = (input)=>{
    return Object.keys((0, $4vTdq.default)).includes(input);
};

});


parcelRegister("cF333", function(module, exports) {

$parcel$export(module.exports, "CommentsPlaceholder", () => $fe12e84e0f2d1207$export$d6c3f14461dba950);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dmSsL = parcelRequire("dmSsL");
const $fe12e84e0f2d1207$export$d6c3f14461dba950 = ({ placeholder: placeholder, onFocus: onFocus, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $fe12e84e0f2d1207$var$containerStyles,
            $fe12e84e0f2d1207$var$hoveredStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dmSsL.CommentTextAreaPlaceholder), {
        placeholder: placeholder,
        onFocus: onFocus,
        onClick: onClick
    }));
const $fe12e84e0f2d1207$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
/**
 * Add css-var to adjust styling between parents and children.
 * hovering the div should make the background color of the textarea and button right and left the same
 * NOTE: if css-var name gets changed, please search for the usage of it within the children.
 *
 * Arguably, another solution is to use react state and event listener (mouseenter and mouseleave)
 * but we will need to wait extra render cycle for css to change.
 */ const $fe12e84e0f2d1207$var$hoveredStyle = (0, $8CUq3.xcss)({
    '--jira-issue-view-add-comment-placeholder-background-color': "var(--ds-background-input, #FFFFFF)",
    ':hover': {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        '--jira-issue-view-add-comment-placeholder-background-color': "var(--ds-background-input-hovered, #F7F8F9)"
    }
});

});
parcelRegister("dmSsL", function(module, exports) {

$parcel$export(module.exports, "CommentTextAreaPlaceholder", () => $adf3c7f8c33dd89f$export$664c0615c825fe36);
/* comment-text-area-placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $k0yGC = parcelRequire("k0yGC");
const $adf3c7f8c33dd89f$export$664c0615c825fe36 = ({ placeholder: placeholder, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        "data-testid": "issue-view-activity-comment.comment-add-editor.textarea",
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c82smr _189et94y _1dqonqa1 _1h6d1elr _14zgglyw _r06hglyw _bfhk145l _vchhusvi _4t3i1ylp _19bvv47k _ca0qutpp _n3tdutpp _vwz4kb7n _1bsb1osq _syaz131l _1e0c116y _4cvr1y6m _nt751r31 _49pcglyw _1hvw1o36 _1ygbugt7 _1ah3v77o _4cvx1elr _irr312p6 _d0al1kdv"
        ])
    }, placeholder || formatMessage((0, $k0yGC.default).defaultPlaceholderMessages));
};
// NOTE: Styling gets copied from platform/packages/editor/editor-core/src/ui/ChromeCollapsed/styles.ts and adjusted to the design
// Except the focus visible state which is new
const $adf3c7f8c33dd89f$var$textAreaStyles = null;

});
parcelRegister("k0yGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d5ecc7462514e83$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4d5ecc7462514e83$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultPlaceholderMessages: {
        "id": "issue-view-activity-comment.comment-add-editor.default-placeholder-messages",
        "defaultMessage": "Add Comment..."
    }
});

});



parcelRegister("75rkV", function(module, exports) {

$parcel$export(module.exports, "enhanceIssueCommentEditor", () => $8c2211ee7462330b$export$cfeb1c2112fded8d);
// This component deals exclusively with the creation of new comments.
// For editing, there is a separate version available from @atlassian/jira-issue-comment-base
// eslint-disable-next-line jira/restricted/react-component-props

var $dRLCn = parcelRequire("dRLCn");

var $hxqfC = parcelRequire("hxqfC");

var $epg8f = parcelRequire("epg8f");

var $5CbyA = parcelRequire("5CbyA");

var $8BBFj = parcelRequire("8BBFj");

var $hAf12 = parcelRequire("hAf12");

var $7aBQD = parcelRequire("7aBQD");

var $bcoYn = parcelRequire("bcoYn");

var $a1ky2 = parcelRequire("a1ky2");

var $gDpUM = parcelRequire("gDpUM");

var $zzDIW = parcelRequire("zzDIW");

var $4R6GH = parcelRequire("4R6GH");
const $8c2211ee7462330b$export$cfeb1c2112fded8d = (0, $dRLCn.flowWithSafeComponent)((0, $hxqfC.connect)((state, props)=>{
    const baseUrl = (0, $a1ky2.baseUrlSelector)(state);
    return {
        contextIdentifier: (0, $7aBQD.contextIdentifierSelector)(state, props),
        baseUrl: baseUrl,
        mentionProvider: (0, $epg8f.mentionProviderSelector)(state),
        activityProvider: (0, $hAf12.activityProviderSelector)(state),
        mediaContext: (0, $gDpUM.mediaContextSelector)(state),
        sharedAtTimestamp: (0, $zzDIW.getTimestampForSharingAsComment)(state),
        sharedValue: (0, $zzDIW.getValueForSharingAsComment)(state),
        issueLinks: (0, $4R6GH.fg)('issue-link-suggestions-in-comments') ? (0, $bcoYn.entitiesIssueLinksSelector)(state) : undefined,
        useStickyToolbar: true
    };
}, (dispatch)=>({
        onExpandedFailure: ()=>dispatch((0, $5CbyA.editorExpandedFailure)()),
        onSaveFailure: ()=>dispatch((0, $5CbyA.editorSaveFailure)()),
        clearSharedValues: ()=>{
            dispatch((0, $8BBFj.clearSharedAsCommentValues)());
        }
    })));

});


parcelRegister("dOZvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa7d02b05752451c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $2e4p8 = parcelRequire("2e4p8");

var $lOVyz = parcelRequire("lOVyz");
const $aa7d02b05752451c$var$CommentShortcutHint = ({ messageDescriptor: messageDescriptor, values: values })=>{
    const isEmbedMode = (0, $2e4p8.useIsEmbedMode)();
    if (isEmbedMode) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lOVyz.StyledCommentShortcutHint), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...messageDescriptor,
        values: values
    }));
};
var $aa7d02b05752451c$export$2e2bcd8739ae039 = $aa7d02b05752451c$var$CommentShortcutHint;

});
parcelRegister("lOVyz", function(module, exports) {

$parcel$export(module.exports, "StyledCommentShortcutHint", () => $d3c089b70fd0be0a$export$903538afaf45a25b);
$parcel$export(module.exports, "StickyWrapper", () => $d3c089b70fd0be0a$export$c1bdd37d1f2cfe01);
$parcel$export(module.exports, "Wrapper", () => $d3c089b70fd0be0a$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "AvatarContainer", () => $d3c089b70fd0be0a$export$6027454d331df3c4);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");


var $bGX9T = parcelRequire("bGX9T");
const $d3c089b70fd0be0a$var$CONTAINER_HEIGHT = 100;
const $d3c089b70fd0be0a$export$903538afaf45a25b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz131l _1e0c1ule _19pku2gc _o5721q9c",
            __cmplp.className
        ])
    });
});
const $d3c089b70fd0be0a$export$c1bdd37d1f2cfe01 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldApplySticky: shouldApplySticky, isCompact: isCompact, isKeylineVisible: isKeylineVisible, isHidden: isHidden, sortOrder: sortOrder, shouldApplyTopSticky: shouldApplyTopSticky, isModal: isModal, isActivityInVerticalSidePanel: isActivityInVerticalSidePanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_d564on": (0, $lD23V.default)(__cmplp.isCompact ? 'static' : 'sticky'),
            "--_17l2vjj": (0, $lD23V.default)(__cmplp.isKeylineVisible ? (0, $bGX9T.issueViewLayers).baseLayer : 0),
            "--_pcpduf": (0, $lD23V.default)(__cmplp.isHidden ? `translate(0, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            __cmplp.sortOrder === (0, $c97bf8752afb1bcb$export$e86669f498228fff) ? $d3c089b70fd0be0a$var$CONTAINER_HEIGHT : $d3c089b70fd0be0a$var$CONTAINER_HEIGHT * -1}px)` : 'translate(0, 0)'),
            "--_13x3tqy": (0, $lD23V.default)(__cmplp.shouldApplyTopSticky ? 0 : undefined),
            "--_1jopckr": (0, $lD23V.default)(__cmplp.isModal ? "var(--ds-surface-overlay, #FFFFFF)" : "var(--ds-surface, #FFFFFF)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.shouldApplySticky && "_v5641pm3 _11q71olo _kqswmczl _1pbympez _t9ec1tti _94n51i6y _154i186y _19bvu2gc _18u0x0bf",
            __cmplp.isActivityInVerticalSidePanel && "_18u0idpf _19bvu2gc _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $d3c089b70fd0be0a$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { sortOrder: sortOrder, isModal: isModal, isActivityInVerticalSidePanel: isActivityInVerticalSidePanel, shouldApplySticky: shouldApplySticky, isKeylineVisible: isKeylineVisible, shouldApplyTopSticky: shouldApplyTopSticky, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ls0j56": (0, $lD23V.default)(__cmplp.shouldApplySticky ? "var(--ds-space-100, 8px)" : "var(--ds-space-negative-075, -6px)"),
            "--_b93t9t": (0, $lD23V.default)(__cmplp.shouldApplyTopSticky ? `0 2px 0 0 ${"var(--ds-border, #091E4224)"}, 0 -2px 0 0 ${"var(--ds-border, #091E4224)"}` : `0 -2px 0 0 ${"var(--ds-border, #091E4224)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ca0qpxbi _n3tdpxbi _19pku2gc",
            __cmplp.sortOrder === (0, $c97bf8752afb1bcb$export$eda5fe8da1abb04c) ? "_otyrmgjw" : "_otyridpf",
            __cmplp.isModal ? "_11q71bhr" : "_11q7vuon",
            __cmplp.isActivityInVerticalSidePanel && "_n3tdidpf _otyr1ijh _ca0qu2gc",
            __cmplp.isKeylineVisible && __cmplp.shouldApplySticky && "_16qsygdp _19pku2gc",
            __cmplp.className
        ])
    });
});
const $d3c089b70fd0be0a$export$6027454d331df3c4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxutpp _19pkv77o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gCOpU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d1c9e0850ebe6e9f$export$defe85febe8b728c);
// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction

var $7VHMR = parcelRequire("7VHMR");
const $d1c9e0850ebe6e9f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    easyMentionsPlaceholder: {
        "id": "issue.easy-mentions-placeholder-for-empty-comment-editor",
        "defaultMessage": "Type @ to mention and notify someone."
    },
    cannedResponsesPlaceholder: {
        "id": "issue.canned-responses-placeholder-for-empty-comment-editor",
        "defaultMessage": "Type /canned to create or insert predefined responses."
    },
    aiUpsellPlaceholder: {
        "id": "issue.ai-upsell-placeholder-for-empty-comment-editor",
        "defaultMessage": "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone."
    },
    placeholder: {
        "id": "issue.placeholder-for-empty-comment-editor",
        "defaultMessage": "Add a comment\u2026"
    },
    draftPlaceholder: {
        "id": "issue.draft-placeholder-for-empty-comment-editor",
        "defaultMessage": "You have an unsaved comment"
    },
    commentShortcutHintHeading: {
        "id": "issue.comment.shortcut-hint-pro-tip-text",
        "defaultMessage": "Pro tip:"
    },
    commentShortcutHintMessage: {
        "id": "issue.comment.shortcut-hint-message-with-pro-tip-text",
        "defaultMessage": "{proTipText} press {shortcutKey} to comment"
    },
    userAvatarAriaLabel: {
        "id": "issue.comment.user-avatar-aria-label",
        "defaultMessage": "Profile image of {displayName}"
    },
    comment: {
        "id": "issue-view.comment.comment-add.comment",
        "defaultMessage": "Comment"
    }
});

});

parcelRegister("jprhX", function(module, exports) {

$parcel$export(module.exports, "useMobileSectionMessage", () => $efd7dc2d3fca3c70$export$5269203b5e7b8966);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $gNzjL = parcelRequire("gNzjL");
const $efd7dc2d3fca3c70$export$5269203b5e7b8966 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const checkAndDisplayMessage = (0, $5uXOq.useCallback)(()=>{
        if (cloudId) {
            const getMobileMessageKeyFromStorage = (0, $gNzjL.getMobileSectionMsgCache)(cloudId);
            if (getMobileMessageKeyFromStorage === null && new Date().getHours() >= 16) {
                (0, $gNzjL.setMobileSectionMsgCache)(cloudId, JSON.stringify(false));
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'mobileSectionMessage displayed');
            }
        }
    }, [
        cloudId,
        createAnalyticsEvent
    ]);
    return {
        checkAndDisplayMessage: checkAndDisplayMessage
    };
};

});
parcelRegister("gNzjL", function(module, exports) {

$parcel$export(module.exports, "getMobileSectionMsgCache", () => $f532c58f4964dd68$export$aecaa9204efea37a);
$parcel$export(module.exports, "setMobileSectionMsgCache", () => $f532c58f4964dd68$export$71f324309c2f3608);

var $bSSG7 = parcelRequire("bSSG7");
const $f532c58f4964dd68$var$mobileSectionMsgCache = (0, $bSSG7.createLocalStorageProvider)('issue-mobile-section-message');
const $f532c58f4964dd68$export$aecaa9204efea37a = (cloudId)=>$f532c58f4964dd68$var$mobileSectionMsgCache.get(`${cloudId}_mobile_section_message_is_dismissed`) || null;
const $f532c58f4964dd68$export$71f324309c2f3608 = (cloudId, value)=>$f532c58f4964dd68$var$mobileSectionMsgCache.set(`${cloudId}_mobile_section_message_is_dismissed`, value);

});




parcelRegister("2Mf7e", function(module, exports) {

$parcel$export(module.exports, "PinnedComments", () => $064b382128abd5ca$export$3a670d6fdab27a65);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $iy9RA = parcelRequire("iy9RA");

var $bpC55 = parcelRequire("bpC55");

var $koVbs = parcelRequire("koVbs");

var $18jBk = parcelRequire("18jBk");

var $2gCtH = parcelRequire("2gCtH");

var $lssfC = parcelRequire("lssfC");

var $kAatj = parcelRequire("kAatj");
const $064b382128abd5ca$export$3a670d6fdab27a65 = ({ pinnedCommentsIds: pinnedCommentsIds })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = ()=>{
        setIsOpen(!isOpen);
    };
    const issueKey = (0, $2gCtH.useIssueKey)();
    const fullIssueUrl = (0, $lssfC.createFullIssueUrl)('', issueKey);
    if (pinnedCommentsIds?.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $064b382128abd5ca$var$pinnedCommentsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $064b382128abd5ca$var$pinnedCommentHeaderStyles,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $064b382128abd5ca$var$pinnedCommentHeaderTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $kAatj.messages).pinnedCommentsHeader))), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iy9RA))), {
        spacing: "spacious",
        label: formatMessage((0, $kAatj.messages).expandPinnedComments),
        "aria-label": formatMessage((0, $kAatj.messages).expandPinnedComments),
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpC55))), {
        spacing: "spacious",
        label: formatMessage((0, $kAatj.messages).collapsePinnedComments),
        "aria-label": formatMessage((0, $kAatj.messages).collapsePinnedComments),
        size: "small"
    }))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $064b382128abd5ca$var$pinnedCommentsContentStyles
    }, pinnedCommentsIds.map((commentId)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $18jBk.default), {
            key: commentId,
            commentId: commentId,
            fullIssueUrl: fullIssueUrl,
            canEdit: false,
            canCreateWorkItemInComment: false,
            isEditing: false,
            isSaving: false,
            isError: false,
            isOptimistic: false,
            canScrollToOriginalCommentFromPinned: true
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $064b382128abd5ca$var$horizontalDividerStyles
    }));
};
const $064b382128abd5ca$var$pinnedCommentsWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.150'
});
const $064b382128abd5ca$var$pinnedCommentHeaderStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    fontWeight: 'font.weight.medium',
    backgroundColor: 'color.background.neutral.subtle'
});
const $064b382128abd5ca$var$pinnedCommentsContentStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'border.radius.100'
});
const $064b382128abd5ca$var$horizontalDividerStyles = (0, $8CUq3.xcss)({
    height: '1px',
    width: '100%',
    backgroundColor: 'color.background.accent.gray.subtler',
    marginTop: 'space.200'
});
const $064b382128abd5ca$var$pinnedCommentHeaderTextStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.025'
});

});
parcelRegister("kAatj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d07803a4f32e5d00$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d07803a4f32e5d00$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    pinnedCommentsHeader: {
        "id": "issue-view-activity-common.component.pinned-comments.pinned-comments-header",
        "defaultMessage": "Pinned comments"
    },
    expandPinnedComments: {
        "id": "issue-view-activity-common.component.pinned-comments.expand-pinned-comments",
        "defaultMessage": "Expand pinned comments"
    },
    collapsePinnedComments: {
        "id": "issue-view-activity-common.component.pinned-comments.collapse-pinned-comments",
        "defaultMessage": "Collapse pinned comments"
    }
});

});


parcelRegister("dzJSM", function(module, exports) {

$parcel$export(module.exports, "CommentEmptyState", () => $53d5e32c6737b86f$export$6afb8758bb5085d6);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $5qRwM = parcelRequire("5qRwM");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $b39fg = parcelRequire("b39fg");

var $9HJJZ = parcelRequire("9HJJZ");

var $jUjoR = parcelRequire("jUjoR");
const $53d5e32c6737b86f$export$6afb8758bb5085d6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $53d5e32c6737b86f$var$placeholderWrapperStyles,
        alignItems: "center",
        justifyContent: "center",
        direction: "column",
        gap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $53d5e32c6737b86f$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9HJJZ))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b39fg))),
        alt: formatMessage((0, $jUjoR.default).header)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        direction: "column",
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, formatMessage((0, $jUjoR.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $jUjoR.default).description))));
};
const $53d5e32c6737b86f$var$placeholderWrapperStyles = (0, $8CUq3.xcss)({
    textAlign: 'center',
    maxWidth: '300px',
    margin: '0 auto',
    paddingTop: 'space.1000',
    paddingBottom: 'space.1000',
    minHeight: '300px'
});
const $53d5e32c6737b86f$var$imageWrapperStyles = (0, $8CUq3.xcss)({
    width: '120px',
    height: '120px'
});

});
parcelRegister("b39fg", function(module, exports) {
module.exports = new URL("dark-comments-empty.21b1aead.svg", import.meta.url).toString();

});

parcelRegister("9HJJZ", function(module, exports) {
module.exports = new URL("light-comments-empty.213e59fa.svg", import.meta.url).toString();

});

parcelRegister("jUjoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e83582f6e6edfc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f8e83582f6e6edfc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        "id": "issue-view-activity-comment.comment-add.comment-empty-state.description",
        "defaultMessage": "Light up the comment section - add an update, ask a question, or @mention someone."
    },
    header: {
        "id": "issue-view-activity-comment.comment-add.comment-empty-state.header",
        "defaultMessage": "Spark a conversation"
    }
});

});



parcelRegister("2n3vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09d649a9d4c5245$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2rqOp = parcelRequire("2rqOp");
const $e09d649a9d4c5245$var$LoadMoreButton = ({ onClick: onClick, isDisabled: isDisabled, isLoading: isLoading, numberToLoad: numberToLoad, children: children, loadButton: loadButton })=>{
    if (numberToLoad <= 0 && !loadButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e09d649a9d4c5245$var$LoadMoreButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        onClick: onClick,
        isDisabled: isDisabled,
        isLoading: isLoading,
        shouldFitContainer: true,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "issue.activity.common.component.load-more-button.loading-button",
        interactionName: "auto-generated.issue.activity.common.component.load-more-button.loading-button.button"
    }, children));
};
var $e09d649a9d4c5245$export$2e2bcd8739ae039 = $e09d649a9d4c5245$var$LoadMoreButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e09d649a9d4c5245$var$LoadMoreButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf",
            __cmplp.className
        ])
    });
});
$e09d649a9d4c5245$var$LoadMoreButtonContainer.displayName = 'LoadMoreButtonContainer';

});

parcelRegister("lY0Md", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD", () => $7ea3327a339880dd$export$724fbfb10c203824);
$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS", () => $7ea3327a339880dd$export$a1162d3036fadf0e);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD", () => $7ea3327a339880dd$export$ed7e687bbd42b4a7);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD_OLD", () => $7ea3327a339880dd$export$9b2f842ae6d3541d);
$parcel$export(module.exports, "LOAD_NEWER_BUTTON", () => $7ea3327a339880dd$export$4f2e52b6b9be5088);
$parcel$export(module.exports, "LOAD_OLDER_BUTTON", () => $7ea3327a339880dd$export$ed33f944ab1a1bb0);

var $gwIPs = parcelRequire("gwIPs");
const $7ea3327a339880dd$export$724fbfb10c203824 = 5;
const $7ea3327a339880dd$export$a1162d3036fadf0e = 100;
const $7ea3327a339880dd$export$ed7e687bbd42b4a7 = 100;
const $7ea3327a339880dd$export$9b2f842ae6d3541d = 10;
const $7ea3327a339880dd$export$ef42ae71539e03a7 = `${3 * (0, $gwIPs.gridSize)}px`;
const $7ea3327a339880dd$export$4f2e52b6b9be5088 = 'LOAD_NEWER_BUTTON';
const $7ea3327a339880dd$export$ed33f944ab1a1bb0 = 'LOAD_OLDER_BUTTON';

});

parcelRegister("lPPO3", function(module, exports) {

$parcel$export(module.exports, "withRemovePermalinkQuery", () => $377e42019864d5f5$export$6264bc0635c6c3c5);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $9pF5v = parcelRequire("9pF5v");

var $fKtck = parcelRequire("fKtck");

var $lVJAU = parcelRequire("lVJAU");

var $iFZPY = parcelRequire("iFZPY");
const $377e42019864d5f5$export$6264bc0635c6c3c5 = (CommentsComponent)=>(props)=>{
        const { replace: replace } = (0, $lVJAU.useRouterActions)();
        const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
        (0, $5uXOq.useEffect)(()=>{
            if (!props.commentIds.length) {
                const { hasPermalink: hasPermalink } = (0, $fKtck.getPermalinkStatus)((0, $9pF5v.COMMENTS));
                if (hasPermalink) {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    const fullUrl = new URL(window.location.href);
                    fullUrl.searchParams.delete((0, $fKtck.PermalinkType).COMMENTS);
                    replace(fullUrl.toString());
                    showFlag({
                        messageId: 'platform-issue-permalinks.remove-permalink-query.show-flag.error',
                        messageType: 'transactional',
                        type: 'error',
                        title: (0, $iFZPY.default).noFocusedCommentFoundTitle,
                        description: (0, $iFZPY.default).noFocusedCommentFoundDescription,
                        actions: [
                            {
                                content: (0, $iFZPY.default).noFocusedCommentFoundAction,
                                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                                onClick: ()=>window.location.reload()
                            }
                        ]
                    });
                }
            }
        }, [
            replace,
            props.commentIds,
            showFlag
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CommentsComponent, props);
    };

});
parcelRegister("iFZPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfff6128603019de$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bfff6128603019de$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noFocusedCommentFoundTitle: {
        "id": "remove-permalink-query.no-focused-comment-found-title",
        "defaultMessage": "We\u2019re unable to load the comment"
    },
    noFocusedCommentFoundDescription: {
        "id": "remove-permalink-query.no-focused-comment-found-description",
        "defaultMessage": "Looks like that comments doesn\u2019t exist or it\u2019s been deleted."
    },
    noFocusedCommentFoundAction: {
        "id": "remove-permalink-query.no-focused-comment-found-action",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("6irpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7982b4e1d45d83e2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hYRTO = parcelRequire("hYRTO");

var $4R6GH = parcelRequire("4R6GH");

var $bXQsy = parcelRequire("bXQsy");


const $7982b4e1d45d83e2$var$LazyRepliesList = (parcelRequire("jkm3K")).default;
const $7982b4e1d45d83e2$var$RepliesContainer = ({ hasReplies: hasReplies, ...otherProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('jira_custom_comment_component_refactor') ? "_19pk1b66" : "_19pkukr8"
        ])
    }, hasReplies && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "reply-comments-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7982b4e1d45d83e2$var$LazyRepliesList, otherProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bXQsy.default), otherProps));
};
const $7982b4e1d45d83e2$var$sectionContainerStyle = null;
const $7982b4e1d45d83e2$var$sectionContainerWithCustomComponentStyle = null;
var $7982b4e1d45d83e2$export$2e2bcd8739ae039 = $7982b4e1d45d83e2$var$RepliesContainer;

});
parcelRegister("bXQsy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cfb398ba740d2be$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $hYRTO = parcelRequire("hYRTO");

var $hxqfC = parcelRequire("hxqfC");

var $kxZPA = parcelRequire("kxZPA");

var $8dFNe = parcelRequire("8dFNe");

var $bcoYn = parcelRequire("bcoYn");


var $d4MOh = parcelRequire("d4MOh");

var $fCo6Y = parcelRequire("fCo6Y");

var $4R6GH = parcelRequire("4R6GH");

var $hJyCc = parcelRequire("hJyCc");

var $iNUY0 = parcelRequire("iNUY0");

const $0cfb398ba740d2be$var$LazyReplyEditor = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ioqg")).then((module)=>module.CommentReplyEditor), {
    moduleId: "./src/packages/issue/issue-view-activity-comment/src/comment-reply-editor/index.tsx"
});
const $0cfb398ba740d2be$var$CommentReplies = (props)=>{
    const { commentId: commentId, loggedInUser: loggedInUser, replyContent: replyContent, replyVisibility: replyVisibility, isReplyingToComment: isReplyingToComment, replyingToAuthor: replyingToAuthor, onReplyUpdate: onReplyUpdate, onReplyCancel: onReplyCancel, onReplySave: onReplySave, commentSessionId: commentSessionId, isRealTimeCommentUpdated: isRealTimeCommentUpdated } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onReplySaveHandlerMemoised = (0, $5uXOq.useCallback)((value)=>{
        if (!onReplySave) return;
        const isValueEmpty = (0, $fCo6Y.isOnlyWhitespaceAdf)(value);
        if (!isValueEmpty) {
            const authorId = loggedInUser ? loggedInUser.id : null;
            const analyticsEvent = createAnalyticsEvent({
                action: 'created',
                isReply: true
            });
            if ((0, $4R6GH.fg)('thor_send_realtime_attribute')) analyticsEvent.update({
                isRealTimeCommentUpdated: isRealTimeCommentUpdated
            });
            if ((0, $4R6GH.fg)('comments_mentioned_users_analytics')) {
                if (value?.content) {
                    const mentions = (0, $hJyCc.findMentionsInAdfContent)(value.content);
                    analyticsEvent.update({
                        mentionedUserIds: mentions.map((mention)=>mention.attrs.id)
                    });
                }
            }
            onReplySave({
                authorId: authorId,
                bodyAdf: value,
                isNewComment: true,
                visibility: replyVisibility
            }, analyticsEvent, commentSessionId);
        }
    }, [
        commentSessionId,
        createAnalyticsEvent,
        isRealTimeCommentUpdated,
        loggedInUser,
        onReplySave,
        replyVisibility
    ]);
    if (!isReplyingToComment) return null;
    const onReplySaveHandler = (value)=>{
        if (!onReplySave) return;
        const isValueEmpty = (0, $fCo6Y.isOnlyWhitespaceAdf)(value);
        if (!isValueEmpty) {
            const authorId = loggedInUser ? loggedInUser.id : null;
            const analyticsEvent = createAnalyticsEvent({
                action: 'created',
                isReply: true
            });
            if ((0, $4R6GH.fg)('thor_send_realtime_attribute')) analyticsEvent.update({
                isRealTimeCommentUpdated: isRealTimeCommentUpdated
            });
            if ((0, $4R6GH.fg)('comments_mentioned_users_analytics')) {
                if (value?.content) {
                    const mentions = (0, $hJyCc.findMentionsInAdfContent)(value.content);
                    analyticsEvent.update({
                        mentionedUserIds: mentions.map((mention)=>mention.attrs.id)
                    });
                }
            }
            onReplySave({
                authorId: authorId,
                bodyAdf: value,
                isNewComment: true,
                visibility: replyVisibility
            }, analyticsEvent, commentSessionId);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isReplyingToComment && // reply editor always open at end so isLast is true
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNUY0.default), {
        hasReplyEditor: true,
        isLast: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hYRTO.default), {
        name: "reply-comment-editor-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cfb398ba740d2be$var$LazyReplyEditor, {
        parentCommentId: commentId,
        author: loggedInUser,
        replyToAuthorName: replyingToAuthor?.displayName,
        bodyAdf: replyContent,
        onChange: onReplyUpdate,
        onCancel: onReplyCancel,
        onSave: (0, $4R6GH.fg)('jira-editor-re-render-keystroke') ? onReplySaveHandlerMemoised : onReplySaveHandler,
        onBlur: onReplyCancel
    }))));
};
var $0cfb398ba740d2be$export$2e2bcd8739ae039 = (0, $hxqfC.connect)((_)=>(state, ownProps)=>({
            isReplyingToComment: (0, $d4MOh.isReplyingToCommentSelector)(ownProps.commentId)(state),
            loggedInUser: (0, $bcoYn.loggedInUserDetailsSelector)(state),
            replyContent: (0, $d4MOh.replyContentSelector)(ownProps.commentId)(state),
            replyVisibility: (0, $d4MOh.commentEditingOrViewVisibilitySelector)(`${(0, $7a0695d910e98a34$export$56251dcfec1ad08d)}-${ownProps.commentId}`)(state),
            replyingToAuthor: (0, $d4MOh.replyingToAuthorSelector)(state)
        }), (dispatch, ownProps)=>({
        onReplyUpdate: (editValue)=>dispatch((0, $8dFNe.replyCommentUpdate)(ownProps.commentId, editValue)),
        onReplyCancel: ()=>dispatch((0, $8dFNe.replyCommentCancel)(ownProps.commentId)),
        onReplySave: (eventData, analyticsEvent, commentSessionId)=>dispatch((0, $8dFNe.saveCommentRequest)({
                id: `${(0, $7a0695d910e98a34$export$56251dcfec1ad08d)}-${ownProps.commentId}-${new Date().getTime()}`,
                // needed to support multiple optimistic replies at the same time
                parentId: ownProps.commentId,
                createdDate: new Date().toISOString(),
                bodyHtml: undefined,
                ...eventData
            }, analyticsEvent, commentSessionId))
    }))($0cfb398ba740d2be$var$CommentReplies);

});
parcelRegister("iNUY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $59620ac2ef1c17eb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");
const $59620ac2ef1c17eb$var$ReplyCommentWrapper = ({ children: children, isFirst: isFirst = false, isLast: isLast = false, hasReplyEditor: hasReplyEditor = false, showNextButton: showNextButton = false })=>{
    return /*#__PURE__*/ $5uXOq.createElement("section", {
        "data-testid": "issue-view-activity-comment.comment-reply-wrapper.reply-container",
        className: (0, $bwpsq.default)([
            $59620ac2ef1c17eb$var$sectionStylesOverride.common,
            isFirst && !isLast && $59620ac2ef1c17eb$var$sectionStylesOverride.firstSection,
            !isFirst && !isLast && $59620ac2ef1c17eb$var$sectionStylesOverride.InBetweenSections,
            showNextButton && hasReplyEditor && $59620ac2ef1c17eb$var$sectionStylesOverride.InBetweenSections,
            (0, $4R6GH.fg)('jira_custom_comment_component_refactor') && $59620ac2ef1c17eb$var$sectionStylesOverride.customComment,
            hasReplyEditor && (0, $4R6GH.fg)('jira_custom_comment_component_refactor') && $59620ac2ef1c17eb$var$sectionStylesOverride.customCommentEditor
        ])
    }, children);
};
const $59620ac2ef1c17eb$var$sectionStylesOverride = {
    common: "_kqswh2mm _uglpt94y _1wgl1mmo _161e1v33 _lcsaa7px",
    firstSection: "_kqswh2mm _1kt9b3bt _1cs8stnw _kfgt1fc4 _1aukukzn _1mp41cut _z5wt1yie _1rus1qe4",
    InBetweenSections: "_kqswh2mm _1kt9b3bt _1cs8stnw _19woze3t _1mp41cut _z5wt1yie _1rus1qe4 _kfgt1fc4 _1aukukzn",
    customComment: "_kfgt1osq _z5wtd439",
    customCommentEditor: "_18u0y5yx"
};
var $59620ac2ef1c17eb$export$2e2bcd8739ae039 = $59620ac2ef1c17eb$var$ReplyCommentWrapper;

});

parcelRegister("6ioqg", function(module, exports) {

let $49575e591e2f20ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49575e591e2f20ac$var$load("900gP").then(()=>parcelRequire('4jQsz'));

});


parcelRegister("jkm3K", function(module, exports) {

module.exports = (parcelRequire("avM1e"))('issue_comment_reply_list_sync_import', function() {
    return parcelRequire('kBJIb');
}, function() {
    return parcelRequire('7eBvR');
});

});


parcelRegister("9vYHU", function(module, exports) {

$parcel$export(module.exports, "SectionMessage", () => $c744847768d5373b$export$a36903bd214cec06);

var $5uXOq = parcelRequire("5uXOq");

var $gNzjL = parcelRequire("gNzjL");

var $koeKL = parcelRequire("koeKL");

var $lVJAU = parcelRequire("lVJAU");

var $g1K2o = parcelRequire("g1K2o");
const $c744847768d5373b$export$a36903bd214cec06 = ()=>{
    const [showMessage, setShowMessage] = (0, $5uXOq.useState)(false);
    const cloudId = (0, $koeKL.useCloudId)();
    const getMobileMessageKeyFromStorage = (0, $gNzjL.getMobileSectionMsgCache)(cloudId);
    const { registerBlock: registerBlock } = (0, $lVJAU.useRouterActions)();
    (0, $5uXOq.useEffect)(()=>{
        setShowMessage(getMobileMessageKeyFromStorage === 'false');
    }, [
        getMobileMessageKeyFromStorage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const unregisterBlock = registerBlock(setToMobileSectionMsgCache);
        return unregisterBlock;
    });
    const setToMobileSectionMsgCache = (0, $5uXOq.useCallback)(()=>{
        if (showMessage) {
            (0, $gNzjL.setMobileSectionMsgCache)(cloudId, JSON.stringify(true));
            setShowMessage(false);
        }
    }, [
        cloudId,
        showMessage
    ]);
    return showMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1K2o.default), null) : null;
};

});
parcelRegister("g1K2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $de8942ae1febe674$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dS3PR = parcelRequire("dS3PR");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $7IflY = parcelRequire("7IflY");
const $de8942ae1febe674$export$19a4c2279a03166e = 'https://apps.apple.com/us/app/jira-cloud-by-atlassian/id1006972087';
const $de8942ae1febe674$export$9e6cf75fa48088e7 = 'https://play.google.com/store/apps/details?id=com.atlassian.android.jira.core';
const $de8942ae1febe674$var$SectionMessageComponent = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)((url, text)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), `${text} clicked`);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        testId: "issue-view-activity.section-message",
        title: formatMessage((0, $7IflY.default).title),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                key: "jira-ios-download-cta",
                testId: "issue-view-activity.section-message.jira-ios-download-cta",
                onClick: ()=>onClick($de8942ae1febe674$export$19a4c2279a03166e, 'jiraIosDownloadCTA')
            }, formatMessage((0, $7IflY.default).jiraIosDownloadCta)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                key: "jira-andriod-download-cta",
                testId: "issue-view-activity.section-message.jira-andriod-download-cta",
                onClick: ()=>onClick($de8942ae1febe674$export$9e6cf75fa48088e7, 'jiraAndroidDownloadCTA')
            }, formatMessage((0, $7IflY.default).jiraAndroidDownloadCta))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7IflY.default).bodyIssueTermRefresh : (0, $7IflY.default).body)));
};
var $de8942ae1febe674$export$2e2bcd8739ae039 = $de8942ae1febe674$var$SectionMessageComponent;

});
parcelRegister("7IflY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5216507c211b4d2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a5216507c211b4d2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jiraIosDownloadCta: {
        "id": "issue-view-activity.section-message.jira-ios-download-cta",
        "defaultMessage": "Download Jira iOS"
    },
    jiraAndroidDownloadCta: {
        "id": "issue-view-activity.section-message.jira-android-download-cta",
        "defaultMessage": "Download Jira Android"
    },
    body: {
        "id": "issue-view-activity.section-message.body",
        "defaultMessage": "Get issue updates in real-time and respond from anywhere, with the Jira Mobile app."
    },
    title: {
        "id": "issue-view-activity.section-message.title",
        "defaultMessage": "Stay in the loop"
    },
    bodyIssueTermRefresh: {
        "id": "issue-view-activity.section-message.body-issue-term-refresh",
        "defaultMessage": "Get updates on your work items in real-time and respond from anywhere, with the Jira Mobile app."
    }
});

});



parcelRegister("4nRwA", function(module, exports) {

$parcel$export(module.exports, "JsmSmartRequestSummaryEntryPointContainer", () => $35786dcfc11e4f4e$export$ca38248bf7b9638d);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $fv0L0 = parcelRequire("fv0L0");
const $35786dcfc11e4f4e$var$runtimeProps = {};
const $35786dcfc11e4f4e$export$ca38248bf7b9638d = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $5uXOq.useContext)((0, $fv0L0.JsmSmartRequestSummaryEntryPointContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jsmSmartRequestSummary",
        packageName: "issue",
        teamName: "itsm-grimlock",
        runtimeProps: $35786dcfc11e4f4e$var$runtimeProps,
        fallback: null,
        errorFallback: "flag"
    });
};

});

parcelRegister("3EXh5", function(module, exports) {

$parcel$export(module.exports, "IssueSmartRequestSummaryEntryPointContainerOld", () => $b34db1af708c32b1$export$bf5985aa0d211a6c);
$parcel$export(module.exports, "IssueSmartRequestSummaryEntryPointContainer", () => $b34db1af708c32b1$export$4437b78e7402ece1);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $fv0L0 = parcelRequire("fv0L0");

var $DVljb = parcelRequire("DVljb");

var $eNNkf = parcelRequire("eNNkf");

var $kVVL1 = parcelRequire("kVVL1");

var $d4MOh = parcelRequire("d4MOh");


var $cSD7y = parcelRequire("cSD7y");

var $lGvJS = parcelRequire("lGvJS");
const $b34db1af708c32b1$var$runtimeProps = {};
const $b34db1af708c32b1$export$bf5985aa0d211a6c = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $5uXOq.useContext)((0, $fv0L0.IssueSmartRequestSummaryEntryPointContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueSmartRequestSummary",
        packageName: "issue",
        teamName: "Bento",
        runtimeProps: $b34db1af708c32b1$var$runtimeProps,
        fallback: null,
        errorFallback: "flag"
    });
};
const $b34db1af708c32b1$export$ab7e6d14a61845e8 = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $fv0L0.IssueSmartRequestSummaryEntryPointContext));
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueSmartRequestSummary",
        packageName: "issue",
        teamName: "Bento",
        runtimeProps: $b34db1af708c32b1$var$runtimeProps,
        fallback: null,
        errorFallback: "flag"
    });
};
const $b34db1af708c32b1$var$PROACTIVE_COMMENT_THRESHOLD = 5;
const $b34db1af708c32b1$export$b21a65d79287f60c = ()=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $fv0L0.IssueSmartRequestSummaryEntryPointContext));
    const totalComments = (0, $kVVL1.useSelector)((0, $d4MOh.totalCommentsSelector));
    const locale = (0, $DVljb.useLocale)();
    const [hasProactiveFeatureEnabled] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$25f5ee1223725a65));
    const isEnglishLocale = locale && locale.startsWith('en');
    const [hasScrolled] = (0, $lGvJS.useHasScrolledLayoutContainer)();
    const smartRequestSummaryHasBeenLoaded = (0, $5uXOq.useRef)(false);
    const isProactiveExperimentConditionMet = (0, $5uXOq.useMemo)(()=>totalComments >= $b34db1af708c32b1$var$PROACTIVE_COMMENT_THRESHOLD && isEnglishLocale && hasProactiveFeatureEnabled === 'true', // We only need to check the initial values, as the entry point will be loaded only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (smartRequestSummaryHasBeenLoaded.current === false && hasScrolled && isProactiveExperimentConditionMet) {
            entryPointActions.load();
            smartRequestSummaryHasBeenLoaded.current = true;
        }
    }, [
        hasScrolled,
        smartRequestSummaryHasBeenLoaded,
        isProactiveExperimentConditionMet,
        entryPointActions
    ]);
    const localRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            isProactiveExperimentConditionMet: isProactiveExperimentConditionMet
        }), [
        isProactiveExperimentConditionMet
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueSmartRequestSummary",
        packageName: "issue",
        teamName: "Bento",
        runtimeProps: localRuntimeProps,
        fallback: null,
        errorFallback: "flag"
    });
};
const $b34db1af708c32b1$export$4437b78e7402ece1 = (0, $cSD7y.componentWithFG)('improve_issue_view_comment_ai', $b34db1af708c32b1$export$b21a65d79287f60c, $b34db1af708c32b1$export$ab7e6d14a61845e8);

});

parcelRegister("5BQ0h", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff68b9c9e551476b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff68b9c9e551476b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreComments: {
        "id": "issue-view-activity.show-more-comments",
        "defaultMessage": "Show more comments"
    }
});

});




$parcel$global.rlb("6yHb5")
//# sourceMappingURL=async-issue-view-comment.35589bd6.js.map
